/* tslint:disable */
/* eslint-disable */
/**
 * API_Xdent_external
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
 */
export interface APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'idChatMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'idSender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'idLabTicket'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'messageText'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'dateSend'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'hasAttachment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'isFromXdent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'idCompanyRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'senderName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'senderLocationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'idProfilePhoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'idLabTicketExternalState'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal
     */
    'dateRead'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
 */
export interface APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idLabLaboratoryRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idLabLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idLabCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idXCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idXLaboratory'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'issueDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'ico'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'dic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idInvoicePartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idPricelist'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'status'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'clicked'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'acceptDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'xdentWeb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idXdentLocation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'isUnpairedFromXdent'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'unpairedDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest
     */
    'idUnpairNoticeStatus'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedLabinoCoreEntityLayerLabTicket
 */
export interface APIContextGeneratedLabinoCoreEntityLayerLabTicket {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idLabTicket'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idInvoicePartner'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'dueDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'finishDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idTicketState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'ticketNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idXLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idInternalState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idExternalState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'isRead'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'isInternal'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'laboratoryNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'doctorNote'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'isImportant'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idInvoicePartnerStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'summaryInvoiceState'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'officeDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoiceDate'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'isHistoryBatchConfirmed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'locationStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'locationEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'locationPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'locationRegNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'locationVatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoicePartnerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoicePartnerStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoicePartnerRegNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoicePartnerVatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoicePartnerStaffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'clientPersonalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'mainLaborants'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoicePartnerEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoicePartnerPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'invoicePartnerStaffPhone'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'historyBatchConfirmDate'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'isHistoryBatchOutdated'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'historyBatchGeneratedDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'additionalNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'lockedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'idPricelistValidity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'complaintData'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'isComplaint'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicket
     */
    'externalPartners'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedLabinoCoreEntityLayerLabTicketInspections
 */
export interface APIContextGeneratedLabinoCoreEntityLayerLabTicketInspections {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicketInspections
     */
    'idLabTicketInspection'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicketInspections
     */
    'idLabTicket'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicketInspections
     */
    'dateInspection'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedLabinoCoreEntityLayerLabTicketInspections
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAddress
 */
export interface APIContextGeneratedXdentCoreEntityLayerAddress {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAddress
     */
    'idAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAddress
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAddress
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAddress
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAddress
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAddress
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAddress
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAddress
     */
    'companyName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetApplications
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetApplications {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetApplications
     */
    'applicationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetApplications
     */
    'loweredApplicationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetApplications
     */
    'applicationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetApplications
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetMembership>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetApplications
     */
    'aspnetMembershipList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetMembership> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetPaths>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetApplications
     */
    'aspnetPathsList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetPaths> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetRoles>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetApplications
     */
    'aspnetRolesList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetRoles> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetUsers>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetApplications
     */
    'aspnetUsersList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetUsers> | null;
}
/**
 * Foreign key AspnetApplicationsFk removed, Foreign key AspnetUsersFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetMembership
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetMembership {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'applicationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'password'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'passwordFormat'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'passwordSalt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'mobilePIN'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'loweredEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'passwordQuestion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'passwordAnswer'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'isApproved'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'isLockedOut'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'createDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'lastLoginDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'lastPasswordChangedDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'lastLockoutDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'failedPasswordAttemptCount'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'failedPasswordAttemptWindowStart'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'failedPasswordAnswerAttemptCount'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'failedPasswordAnswerAttemptWindowStart'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetMembership
     */
    'comment'?: string | null;
}
/**
 * Foreign key AspnetApplicationsFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetPaths
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetPaths {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPaths
     */
    'applicationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPaths
     */
    'pathId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPaths
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPaths
     */
    'loweredPath'?: string | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationallusers>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPaths
     */
    'aspnetPersonalizationallusersList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationallusers> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPaths
     */
    'aspnetPersonalizationperuserList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser> | null;
}
/**
 * Foreign key AspnetPathsFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationallusers
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationallusers {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationallusers
     */
    'pathId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationallusers
     */
    'pageSettings'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationallusers
     */
    'lastUpdatedDate'?: Date | null;
}
/**
 * Foreign key AspnetPathsFk removed, Foreign key AspnetUsersFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser
     */
    'pathId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser
     */
    'pageSettings'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser
     */
    'lastUpdatedDate'?: Date | null;
}
/**
 * Foreign key AspnetUsersFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetProfile
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetProfile {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetProfile
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetProfile
     */
    'propertyNames'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetProfile
     */
    'propertyValuesString'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetProfile
     */
    'propertyValuesBinary'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetProfile
     */
    'lastUpdatedDate'?: Date | null;
}
/**
 * Foreign key AspnetApplicationsFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetRoles
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetRoles {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetRoles
     */
    'applicationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetRoles
     */
    'roleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetRoles
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetRoles
     */
    'loweredRoleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetRoles
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetUsersinroles>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetRoles
     */
    'aspnetUsersinrolesList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetUsersinroles> | null;
}
/**
 * Foreign key AspnetApplicationsFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetUsers
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetUsers {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'applicationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'loweredUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'mobileAlias'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'isAnonymous'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'lastActivityDate'?: Date | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetMembership>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'aspnetMembershipList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetMembership> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'aspnetPersonalizationperuserList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetPersonalizationperuser> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetProfile>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'aspnetProfileList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetProfile> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerAspnetUsersinroles>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'aspnetUsersinrolesList'?: Array<APIContextGeneratedXdentCoreEntityLayerAspnetUsersinroles> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerUsers>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsers
     */
    'usersList'?: Array<APIContextGeneratedXdentCoreEntityLayerUsers> | null;
}
/**
 * Foreign key AspnetRolesFk removed, Foreign key AspnetUsersFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerAspnetUsersinroles
 */
export interface APIContextGeneratedXdentCoreEntityLayerAspnetUsersinroles {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsersinroles
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerAspnetUsersinroles
     */
    'roleId'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
 */
export interface APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'idRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'idStatus'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'created'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'dateLastChange'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'nempriBase64'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'signatureBase64'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'correlationID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest
     */
    'qualifier'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerClientAlerts
 */
export interface APIContextGeneratedXdentCoreEntityLayerClientAlerts {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientAlerts
     */
    'idClientAlert'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientAlerts
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientAlerts
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientAlerts
     */
    'groupName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
 */
export interface APIContextGeneratedXdentCoreEntityLayerClientDentalCategory {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idClientDentalCategory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idClientDentalCategoryPrev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idProsthetics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idEndodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idPeriodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idOrthodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idImplantology'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerClientDentalCategory
     */
    'created'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCompany
 */
export interface APIContextGeneratedXdentCoreEntityLayerCompany {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'businessName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'businessType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'logo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'timezone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'currency'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'displayAddress'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'registrationType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'paypalEmail'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'enablePayments'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'contactPersonTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'contactPersonFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'contactPersonLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'showWorkTimeOnly'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'emailNotify'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'smsNotify'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'prefixWebsite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'codeBooking'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'isSubscripted'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'expirationDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'subscriptionCancelReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'subscriptionCancelComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'externalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'miniWebsite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'showAddress'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'ntfRegistration'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'facebookSite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'twitterSite'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'cancelPending'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'cancelReqDatetime'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'cancelConfDatetime'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'vatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'regNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'supportContact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'idCRM'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'idUOL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'idBusinessMan'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'isNewLabinoEnabled'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'contractNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'contractAddendumDevicesNumber'?: string | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerInvoiceSettings>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'invoiceSettingsList'?: Array<APIContextGeneratedXdentCoreEntityLayerInvoiceSettings> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerLocations>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'locationsList'?: Array<APIContextGeneratedXdentCoreEntityLayerLocations> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCompany
     */
    'medicalReportPhraseList'?: Array<APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase> | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCsszBankCode
 */
export interface APIContextGeneratedXdentCoreEntityLayerCsszBankCode {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszBankCode
     */
    'idCsszBankCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszBankCode
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszBankCode
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCsszBankType
 */
export interface APIContextGeneratedXdentCoreEntityLayerCsszBankType {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszBankType
     */
    'idCsszBankType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszBankType
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszBankType
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCsszCisDruhCin
 */
export interface APIContextGeneratedXdentCoreEntityLayerCsszCisDruhCin {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszCisDruhCin
     */
    'idCsszCisDruhCin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszCisDruhCin
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszCisDruhCin
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCsszCountryCode
 */
export interface APIContextGeneratedXdentCoreEntityLayerCsszCountryCode {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszCountryCode
     */
    'idCsszCountryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszCountryCode
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszCountryCode
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCsszDuvodPrevzeti
 */
export interface APIContextGeneratedXdentCoreEntityLayerCsszDuvodPrevzeti {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszDuvodPrevzeti
     */
    'idCsszDuvodPrevzeti'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszDuvodPrevzeti
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszDuvodPrevzeti
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCsszFamilyRelations
 */
export interface APIContextGeneratedXdentCoreEntityLayerCsszFamilyRelations {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszFamilyRelations
     */
    'idCsszFamilyRelations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszFamilyRelations
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszFamilyRelations
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerCsszPensionType
 */
export interface APIContextGeneratedXdentCoreEntityLayerCsszPensionType {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszPensionType
     */
    'idCsszPensionType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszPensionType
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerCsszPensionType
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings
 */
export interface APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings
     */
    'idDocumentPrintFormSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
 */
export interface APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'idOUPZS'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'idPZS'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'kodPZS'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'odborneZameranieOU'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'druhUtvaru'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'druhUtvaruDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'municipality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'streetName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'buildingNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'propertyRegistrationNumber'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS
     */
    'postalCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
 */
export interface APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'idPZS'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'corporateBodyFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'municipality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'streetName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'buildingNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'propertyRegistrationNumber'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS
     */
    'ico'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerForms
 */
export interface APIContextGeneratedXdentCoreEntityLayerForms {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'idForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'idFormType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'form'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'formSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'model'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'published'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'expirationDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'isFavorite'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'idTemplate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'definitionV2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'modelV2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerForms
     */
    'autoConfirm'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerGeocache
 */
export interface APIContextGeneratedXdentCoreEntityLayerGeocache {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGeocache
     */
    'idAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGeocache
     */
    'idMap'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGeocache
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGeocache
     */
    'latitude'?: number | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerGlobal
 */
export interface APIContextGeneratedXdentCoreEntityLayerGlobal {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGlobal
     */
    'idGlobal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGlobal
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGlobal
     */
    'datetime'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGlobal
     */
    'valid'?: boolean | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerInvoiceSettings>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGlobal
     */
    'invoiceSettingsList'?: Array<APIContextGeneratedXdentCoreEntityLayerInvoiceSettings> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerLocations>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGlobal
     */
    'locationsList'?: Array<APIContextGeneratedXdentCoreEntityLayerLocations> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase>}
     * @memberof APIContextGeneratedXdentCoreEntityLayerGlobal
     */
    'medicalReportPhraseList'?: Array<APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase> | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
 */
export interface APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'idInsuranceItemOverride'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'idInsuranceItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'idInsuranceCompany'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'bod'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'pricePerPoint'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'priceInsurance'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'priceClient'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'priceTotal'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'keepCodelistInsurancePrices'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'showInsurancePrice'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'dateLastChanged'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride
     */
    'dateDeleted'?: Date | null;
}
/**
 * Foreign key CompanyFk removed, Foreign key GlobalFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
 */
export interface APIContextGeneratedXdentCoreEntityLayerInvoiceSettings {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'idInvoiceSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'fiscalYear'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'useStore'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'autoPayment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'invoiceItemAddEdit'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'printMacroDetail'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'idInvoiceTypeDefault'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'invoiceEetSumType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerInvoiceSettings
     */
    'invoiceEetForce'?: number | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
 */
export interface APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'idLabLaboratoryRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'idLabLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'idLabCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'idXCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'idXLaboratory'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'status'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'clicked'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'acceptDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'labLaboratoryName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'isUnpairedFromLabino'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'unpairedDate'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'clickedUnpaired'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest
     */
    'idUnpairedXLocation'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
 */
export interface APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
     */
    'idLabRequestFormTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
     */
    'tagName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
     */
    'position'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags
     */
    'deletedAt'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerLanguage
 */
export interface APIContextGeneratedXdentCoreEntityLayerLanguage {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLanguage
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLanguage
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLanguage
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLanguage
     */
    'idPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLanguage
     */
    'flag'?: string | null;
}
/**
 * Foreign key CompanyFk removed, Foreign key GlobalFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerLocations
 */
export interface APIContextGeneratedXdentCoreEntityLayerLocations {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idAddressOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idLogo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'regNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'vatNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'icz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'accountNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'bankCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'swift'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'iban'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'writtenBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'web'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'facebook'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'twitter'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'onlineAvalaible'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'vozp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'nameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'webOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'emailOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'phoneOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eetLocationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eetDeviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eetType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eetCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eetPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eetCertificateName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eetActive'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eetStartDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'invoicePayVAT'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eReceptCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eReceptPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eReceptID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eReceptCertificateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'ideReceptPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eReceptPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'uolDatabaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'uolLoginToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idLogoOriginal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idLogoBooking'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idLogoBox'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idExpertiseType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'invoiceSeriesActive'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'invoiceSeriesNumber'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'invoiceCustomDue'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'forcePaymentTypePick'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'eReceptAutoRenewDisable'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insuranceCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insurenceCertificatePassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insuranceCompanyNotUsed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insuranceCertificateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insuranceBankAccountNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insuranceBankCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insuranceForceAltBankAccount'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'customColors'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'ereceptPayment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insuranceVariableSymbol'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'b2BValidFrom'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'fixedCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'ezdravieJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'instagram'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'isInvoiceItemsMerged'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idSignatureImg'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idAddressHQ'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'insuranceIBAN'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'idDiscountType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerLocations
     */
    'nameInternal'?: string | null;
}
/**
 * Foreign key CompanyFk removed, Foreign key GlobalFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase
 */
export interface APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase
     */
    'idPhrase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMedicalReportPhrase
     */
    'isInsuranceCodesCombined'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerMutation
 */
export interface APIContextGeneratedXdentCoreEntityLayerMutation {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMutation
     */
    'idGlobal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMutation
     */
    'idMutation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMutation
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMutation
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMutation
     */
    'anotation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerMutation
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerRegion
 */
export interface APIContextGeneratedXdentCoreEntityLayerRegion {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerRegion
     */
    'idRegion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerRegion
     */
    'shortCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerRegion
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerRegion
     */
    'isDefault'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerSetOpeningHours
 */
export interface APIContextGeneratedXdentCoreEntityLayerSetOpeningHours {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerSetOpeningHours
     */
    'idOpenHour'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerSetOpeningHours
     */
    'idDayType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerSetOpeningHours
     */
    'enable'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerSetOpeningHours
     */
    'startDatetime'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerSetOpeningHours
     */
    'endDatetime'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerSetOpeningHours
     */
    'idEntity'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerSuklCokr
 */
export interface APIContextGeneratedXdentCoreEntityLayerSuklCokr {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerSuklCokr
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerSuklCokr
     */
    'nazev'?: string | null;
}
/**
 * 
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerUserLog
 */
export interface APIContextGeneratedXdentCoreEntityLayerUserLog {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUserLog
     */
    'idUserLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUserLog
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUserLog
     */
    'dateTime'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUserLog
     */
    'jsonLog'?: string | null;
}
/**
 * Foreign key AspnetUsersFk removed
 * @export
 * @interface APIContextGeneratedXdentCoreEntityLayerUsers
 */
export interface APIContextGeneratedXdentCoreEntityLayerUsers {
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'idExpertiseCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'insuranceAccess'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'nameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'idProfilePhoto'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'idUserExport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContextGeneratedXdentCoreEntityLayerUsers
     */
    'diagnoseCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
 */
export interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'idFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'mimeType'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'isIKlientShared'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'isXdentShared'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'serverIp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'fileType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'idMaster'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'systemFileTags'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'isFileEmailSent': number;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
 */
export interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'idLabLaboratoryRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'idLabLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'idXdentLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'idLabCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'idXCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'idXLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'labinoName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'idInvoicePartner'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
 */
export interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'idLogo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'idAddressOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'idLogoBooking'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'regNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'vatNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'isClientsOnly': number;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'focusAreas'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'isVisibleByAddress': number;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'visibilityCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult
     */
    'map'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORYLABELHISTORYGRIDResult
 */
export interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORYLABELHISTORYGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORYLABELHISTORYGRIDResult
     */
    'idLaboratoryLabel'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORYLABELHISTORYGRIDResult
     */
    'datetime'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORYLABELHISTORYGRIDResult
     */
    'changedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORYLABELHISTORYGRIDResult
     */
    'idLabLaboratoryLabelHistory': string;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
 */
export interface APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idLabTicket'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idInvoicePartner'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'dueDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoiceDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'finishDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idTicketState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'ticketNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idInternalState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idExternalState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idXLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'laboratoryNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'doctorNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'birthDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerRegNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerVatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idInvoicePartnerStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerStaffEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerStaffFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerStaffLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerStaffEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerStaffPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerStaffPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerStaffEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerPost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoicePartnerNameAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'mainEmployees'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'internalState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'externalState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoiceState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'isValid'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'officeDate'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'isOutdated': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoiceType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'invoiceNumber'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idLabLaboratoryRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'additionalNote'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'isLocked'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idLockedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'lockedByFullname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'lockedByRole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idPricelistValidity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'complaintData'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'isComplaint'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'idComplaintLabTicket'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'complaintTicketNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult
     */
    'externalPartners'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedALERTITEMSEARCHGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedALERTITEMSEARCHGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedALERTITEMSEARCHGRIDResult
     */
    'idClientAlert'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedALERTITEMSEARCHGRIDResult
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedALERTITEMSEARCHGRIDResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedALERTITEMSEARCHGRIDResult
     */
    'groupName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult
     */
    'idAnamnesis': string;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult
     */
    'dateCreated': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idAppointment': string;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'type'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'allDay'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'label'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'recurrenceInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'reminderInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idResource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'eventType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'confirmed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'onlineBooked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'noShow': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'newClient': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'createdDate': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'lastUpdateDate': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'clientRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idApplicationType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'isPayment'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'planIdService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'partitionColumn'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'duration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'cancelCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'cancelCodeText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'valid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'idWaitingClients'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'appColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult
     */
    'staff'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult
     */
    'personalId'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'type'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'allDay'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'label'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'recurrenceInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'reminderInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'idResource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'eventType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'confirmed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'onlineBooked'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'noShow'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'newClient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'clientRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'promoCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'findUs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'custom'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'clientAnswer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'personalId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'phone'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'phonePrefix'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'planIdService'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult
     */
    'tempType': number;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'type'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'allDay'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'label'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'recurrenceInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'reminderInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'idResource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'eventType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'confirmed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'onlineBooked'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'noShow'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'newClient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'clientRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'promoCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'findUs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'custom'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'clientAnswer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'personalId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'phone'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'phonePrefix'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'orderItem'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'active'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'activeOverride'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'weekType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult
     */
    'services'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult
     */
    'idPlan': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult
     */
    'idCompany': string;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult
     */
    'isDispensarization': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult
     */
    'dateCreated': Date;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult
     */
    'idCredit': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult
     */
    'price'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult
     */
    'transactionDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult
     */
    'idCurrency'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
     */
    'idClientDentalCategory': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
     */
    'idUser': string;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
     */
    'created': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
     */
    'idProsthetics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
     */
    'idEndodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
     */
    'idPeriodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
     */
    'idOrthodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult
     */
    'idImplantology'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'pendingInvoicesCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'overdueInvoicesCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'unconfirmedNewsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'unreadSmsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'storeNotifyCount'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'bonus'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'waitingCLientsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'totalFileSize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'totalFileSizeLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'invoiceCreditRequestCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'pendingFormRequestCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'pendingDocRequestCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult
     */
    'laboratoryNotificationsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult
     */
    'idCustomTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult
     */
    'idGlobal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult
     */
    'customTagName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult
     */
    'position'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'staff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'locationPosition'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'invoiceIncomePayment': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'invoiceIncomeDebit': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'insuranceIncome': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'appointmentsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'appointmentsDone': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'countAppointmentCreated': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'countAppointmentDeletedToday': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult
     */
    'countAppointmentDeleted': number;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'idMedicalReportOverview': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'idMedicalReport': string;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'datetime'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'pi'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'bop'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'api'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'bi'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'pbi'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'cpi'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult
     */
    'lastUpdate': Date;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'idDoctorPass': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'idMedicalReport': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'fullClientName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'clientDOB': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'leaveAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'privateVisit': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'returnAt': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'treatedAt': string;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'passDate': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'idStaff': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult
     */
    'staff'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'idDocumentRequest': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'idDocument': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'idDocumentType': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'documentName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'dateCreated': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'idFile': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'clientFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult
     */
    'clientLastname'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'idProfilePhoto'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'insuranceAccess'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'locationPosition'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'rolesDelimited'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'idUserPrivilegesProfile'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'lastActivityDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'lastLoginDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'createDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'expertiseCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'calendarName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'userName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'isValid'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'isDeleted'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'profileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult
     */
    'onlineAvalaible'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'idRequest': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'dateCreated': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'dateLastTry'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'tryCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'processed': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'priority': number;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'isPaused': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'isSuccess'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult
     */
    'retryStopRequested'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idFormRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idFormBatch'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idDocumentPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idFormType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'created'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'expiration'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'documentFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idDocumentFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'idForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'formSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'form'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'formName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'clientFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'clientLastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'formType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'isFavorite'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult
     */
    'isFormV2': boolean;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idFormRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idFormBatch'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idDocumentPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idFormType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'created'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'expiration'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'expirationDays'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'documentFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idDocumentFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'formSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'form'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'formName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'clientFullname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'formType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult
     */
    'staffFullname'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'idFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'mimeType'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'isIKlientShared'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'isLabinoShared'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'serverIp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'fileType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'idMaster'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'systemFileTags'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result
     */
    'isFileEmailSent': number;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'idInsuranceItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'idLaboratoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'insurancePaymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'insurancePaymentTypeTitle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'bod'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'pricePerPoint'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'priceInsurance'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'priceInsurance_calculated'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'priceLaboratory'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'priceClient'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'priceTotal'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'itemOverrideFound'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'keepCodelistInsurancePrices'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'regionShortCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult
     */
    'idItemOverride'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult {
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult
     */
    'startDatetime'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult
     */
    'endDatetime'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult
     */
    'idEntity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult
     */
    'dayType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult
     */
    'enable'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult
     */
    'enableBySettings'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult
     */
    'idCompanyPremiumService': string;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult
     */
    'dateBillingStart'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult
     */
    'dateBillingEnd'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult
     */
    'price'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult
     */
    'vatRate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult {
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'staffCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'staffCountNew'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'locationCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'eetLocationCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'gallerySize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'gallerySizeLimit'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'isAnalyticsActive'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'isAnalyticsShow'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'averageSMSQuantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'lastMonthSMSMarketing'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'lastMonthSMSReminder'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'cbSmsPaymentFix'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'cbLocationPaymentFix'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'cbSubscriptionSale'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'cbSubPaymentFix'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'eetPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'codeCurrentPricelist'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'idCurrentPricelist'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'yearlyPayment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'isSMSNotifyActive'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'lastPricelistChange'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult
     */
    'countStaffNoCalendar'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSEFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSEFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSEFORMResult
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSEFORMResult
     */
    'naz'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSESEARCHGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSESEARCHGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSESEARCHGRIDResult
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSESEARCHGRIDResult
     */
    'naz'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'icp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'insuranceAccess'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'odb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'locationPosition'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'icz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'idExpertiseCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'cert'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult
     */
    'pointPrice': number;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'customCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'naz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'idInsuranceCodeType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'bod'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'priceInsurance'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'priceLaboratory'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'priceClient'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'idInsurancePaymentType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'isLocalizationRequired'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'ageStart'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'ageFinish'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'codeTypeTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'paymentTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'nameLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'idLaboratoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'labColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult
     */
    'idInsuranceItem'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'idInvoiceEet': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'locationEetName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'onlineType': number;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'certificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'certificateName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'sum': number;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'vatNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'dateEet'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'type': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'firstSend': number;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'idOwner': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'idLocation': string;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'date': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'idInvoice': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'fik'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'bkp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'pkp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'storno'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'invoiceEetNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'urcenoCerpZuct': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'cerpZuct': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'invoiceEetSumType': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'invoicePayVAT': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'sumVAT': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'sumBaseForVAT': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'sumVATLow1': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'sumBaseForVATLow1': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'sumVATLow2': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'sumBaseForVATLow2': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult
     */
    'erorStatus'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'locationPosition'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult
     */
    'isStore'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'idLaboratoryLabel': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'clientFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'labelNumberLab'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'color'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'dateIssue'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'dateDelivery'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'priceTotal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'labColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'generatedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult
     */
    'labinoValid'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'idLaboratoryLabel': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'labelNumberLab'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'dateIssue'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'dateDelivery'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'priceTotal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'clientFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'clientLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'clientDegree'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'clientDegreeAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'locationPosition'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'labColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult
     */
    'generatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult
     */
    'idMagistralis': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult
     */
    'medicamentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult
     */
    'medicamentCreation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult
     */
    'administer'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult
     */
    'idMagistralisSubstance': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult
     */
    'idMagistralis': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult
     */
    'amout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult
     */
    'substanceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult
     */
    'substanceCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'idMedicalExaminationReport': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerAddressStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerAddressCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerAddressPost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerAddressCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult
     */
    'partnerAddressState'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'idDiagnosis': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'idMedicalReport': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'idInvoiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'unitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'pricePerMinute'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'priceLaboratory'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'codeTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'localizationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'lot'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'exp'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'idCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult
     */
    'currencyCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'idMedicalReportExtern': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'dateIssue'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'externPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult
     */
    'ownerName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idMedicalReport': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'datetime': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'lastUpdate': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idMedicalReportPrev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idStaffInsurance'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'isLockedReport': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idExternAuthor'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'created'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'valid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffLastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffInsuranceFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffInsuranceLastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffInsuranceEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffInsuranceEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffLocationRegNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffLocationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffLocationStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffLocationCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffLocationPost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idSupervisor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'staffInsuranceCodes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'toothLocalizations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'insuranceToothLocalizations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'reportType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idExpertiseType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'expertiseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult
     */
    'idReportInsuranceType'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'datetime'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'lastUpdate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idMedicalReportPrev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idStaffInsurance'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'isLocked'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'isLockedReport'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'isGallery'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'isDentalChart'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'isDigitalSign'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'medicalPrescriptionsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'laboratoryLabelsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'insuranceRegistrationListsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'medicalReportExternsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'medicalExaminationReportsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'transportOrderCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'doctorPassCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'intakeReportCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'dismissalReportCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idCovidTest'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'created'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'valid'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'staffInsuranceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'toothLocalizations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'insuranceReportedCodes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'insuranceDiagnoses'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'diagnosisCodes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idClientDentalCategory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idEndodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idImplantology'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idOrthodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idPeriodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idProsthetics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'reportColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'reportType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'idExpertiseType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'pregnancyExams'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult
     */
    'expertiseTypeCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
     */
    'idPhrase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
     */
    'isInsuranceCodesCombined'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
     */
    'insurancePredefinedCodesCommaSeparated'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
     */
    'invoicePredefinedItemsCommaSeparated'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult
     */
    'dentalchartPredefinedItemsCommaSeparated'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETHOLIDAYSResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETHOLIDAYSResult {
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETHOLIDAYSResult
     */
    'startDate'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETINFOFORSTAFFResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETINFOFORSTAFFResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETINFOFORSTAFFResult
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETINFOFORSTAFFResult
     */
    'includeHolidays'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETINFOFORSTAFFResult
     */
    'xdentServicesMandatory'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult
     */
    'caption'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult
     */
    'colorIndex'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult
     */
    'idStaff'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'idSetCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'codeLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'languageTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'dateFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'dateFormatTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'timeFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'timeFormatTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'currencySymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'currencyTile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'currencySymbolPosition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'currencySymbolPositionTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'currencyAnotation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'numberFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'numberFormatTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'idPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'phonePrefixTitle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'googleSync': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'isTacAgreed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'isMarketingAgreed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'isPaymentTerminal'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'isNewLabinoEnabled'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'isCentralStoreEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'miniWebsite'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'multicurrency'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'newFeatures': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'disabledClientDropdownOptions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'idRegion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'regionTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'regionShortCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'analyticsLastGenerated'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'businessType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'businessTypeCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult
     */
    'eLabRequestEnabled'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTATSUSERINVOICEResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTATSUSERINVOICEResult {
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTATSUSERINVOICEResult
     */
    'debit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTATSUSERINVOICEResult
     */
    'credit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTATSUSERINVOICEResult
     */
    'income'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTOREITEMLOTEXPSEARCHResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTOREITEMLOTEXPSEARCHResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTOREITEMLOTEXPSEARCHResult
     */
    'idItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTOREITEMLOTEXPSEARCHResult
     */
    'lot'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTOREITEMLOTEXPSEARCHResult
     */
    'exp'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTOREITEMLOTEXPSEARCHResult
     */
    'quantity'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult
     */
    'skupina'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult
     */
    'popis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult
     */
    'doporuceni'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult
     */
    'critical'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult
     */
    'hide'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult
     */
    'idTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult
     */
    'idTag': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult
     */
    'isSystemTag': number;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'idTaskMessage': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'idTaskBatch': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'idAuthor': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'body'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'sent': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'authorLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'authorFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'authorEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult
     */
    'authorEducationAfter'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'idTransportOrder': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'idOwner': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'idInsurance': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'idMedicalReport': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'clientPID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'clientFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'idStaff': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'staff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'mainDiagnose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'mainDiagnoseText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'diagnose1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'diagnose1Text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'diagnose2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'diagnose2Text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'transportReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'fromCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'fromStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'fromPost'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'fromPaidByInsurance': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'toCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'toStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'toPost'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'toPaidByInsurance': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'szzCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'szzStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'szzPost'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'szzPaidByInsurance': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'escortReason'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'dateOfTransport': Date;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult
     */
    'crewInstructions': string;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'formDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceAccess'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'nameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idProfilePhoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'deleteReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'hiddenDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'recallsCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'profilePhotoId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'valid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'roleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'blocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'emailNotify': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'smsNotify': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'marketing'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idInsuranceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'codeInsuranceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'alerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'medicaments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'formAlerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'formMedicaments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'salutation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'lastPrintPosition': number;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'codeGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'codeInsurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'codePhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idExternal'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceRegistrationDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceRegistrationDateGyn'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceICP'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceICPGyn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceIdStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceIdStaffGyn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'citizenship'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'badgeColor'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'isInsuranceRegistered'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'isInsuranceRegisteredGyn'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'citizenshipCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idPartnership'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'idPartner'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'partnershipCreated'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'lastCovidStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'insuranceExternalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult
     */
    'countryCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'insurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'citizenshipCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'rn'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult
     */
    'badgeColor'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'idUser': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'idGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'schortcut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'idProfilePhoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'locationPosition'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'groups'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult
     */
    'educationAfter'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERGROUPGRIDResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERGROUPGRIDResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERGROUPGRIDResult
     */
    'idUserGroup': string;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERGROUPGRIDResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERGROUPGRIDResult
     */
    'position'?: number | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idProfilePhoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idExpertiseCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'icp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'insuranceAccess'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'valid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'eReceptID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'eReceptPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'ezadankaKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'expertiseCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'pictureFileStream'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'pbxActive'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'pbxProfileList'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'paymentTerminalProfileList'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'equipmentList'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'filteredCodes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'schortcut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'calendarColorDays'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'calendarColorWeeks'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idUserPrivilegesProfile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'eNeschopenkaICPE'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'eNeschopenkaOSSZ'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'gender'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'birth'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'pid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'bankAccountPrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'bankAccountNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'bankCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'employmentCommencement'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'employmentTermination'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idNationality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idInsurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idEmploymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'personalPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'personalPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'country'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'invoiceLocationOnly'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'invoiceHistoryDays'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'directionName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'directionDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'isStore'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'diagnoseCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'diagnoseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'uzisEmployeeNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'idExpertiseCertificateList'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'additionalSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'dhid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult
     */
    'posDeviceProfileList'?: string | null;
}
/**
 * 
 * @export
 * @interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
 */
export interface APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult {
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'idGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'schortcut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'idProfilePhoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'locationPosition'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'color1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'color2'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'customName'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'groups'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult
     */
    'xdentServicesMandatory'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APISharedAddAppointmenDto
 */
export interface APISharedAddAppointmenDto {
    /**
     * 
     * @type {Array<APISharedCalendarAppointmentX2Dto>}
     * @memberof APISharedAddAppointmenDto
     */
    'items'?: Array<APISharedCalendarAppointmentX2Dto> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddAppointmenDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddAppointmenDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddAppointmenDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddAppointmenDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddAppointmenDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedAddAppointmenDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddAppointmenDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedAddClientDto
 */
export interface APISharedAddClientDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'gender'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedAddClientDto
     */
    'marketing'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'realibility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedAddClientDto
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedAddClientDto
     */
    'blocked'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedAddClientDto
     */
    'emailNotify'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedAddClientDto
     */
    'smsNotify'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'insurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'idInsuranceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'salutation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'alerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'medicaments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'citizenship'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'insuranceExternalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientDto
     */
    'hiddenDescription'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedAddClientDto
     */
    'insuranceRegistrationDate'?: Date | null;
}
/**
 * 
 * @export
 * @interface APISharedAddClientInternal
 */
export interface APISharedAddClientInternal {
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    '_idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'gender'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedAddClientInternal
     */
    'marketing'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'realibility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'country'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedAddClientInternal
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedAddClientInternal
     */
    'blocked'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedAddClientInternal
     */
    'emailNotify'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedAddClientInternal
     */
    'smsNotify'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'insurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'idInsuranceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'salutation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'alerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'medicaments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'citizenship'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'insuranceExternalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientInternal
     */
    'hiddenDescription'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedAddClientInternal
     */
    'insuranceRegistrationDate'?: Date | null;
}
/**
 * 
 * @export
 * @interface APISharedAddClientRelationCustomTagDto
 */
export interface APISharedAddClientRelationCustomTagDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientRelationCustomTagDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientRelationCustomTagDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddClientRelationCustomTagDto
     */
    'color'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedAddRelationCustomTagDto
 */
export interface APISharedAddRelationCustomTagDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedAddRelationCustomTagDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAddRelationCustomTagDto
     */
    'color'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedAppointmentClientDto
 */
export interface APISharedAppointmentClientDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentClientDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentClientDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentClientDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentClientDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentClientDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentClientDto
     */
    'educationBefore'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentClientDto
     */
    'educationAfter'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedAppointmentDto
 */
export interface APISharedAppointmentDto {
    /**
     * 
     * @type {APISharedCalendarAppointmentDto}
     * @memberof APISharedAppointmentDto
     */
    'appointment': APISharedCalendarAppointmentDto;
    /**
     * 
     * @type {APISharedAppointmentClientDto}
     * @memberof APISharedAppointmentDto
     */
    'client': APISharedAppointmentClientDto;
    /**
     * 
     * @type {APISharedAppointmentStaffDto}
     * @memberof APISharedAppointmentDto
     */
    'staff': APISharedAppointmentStaffDto;
    /**
     * 
     * @type {APISharedAppointmentOtherInfoDto}
     * @memberof APISharedAppointmentDto
     */
    'otherInfo': APISharedAppointmentOtherInfoDto;
}
/**
 * 
 * @export
 * @interface APISharedAppointmentOtherInfoCustomDto
 */
export interface APISharedAppointmentOtherInfoCustomDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoCustomDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoCustomDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedAppointmentOtherInfoDto
 */
export interface APISharedAppointmentOtherInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'idAppOtherInfo': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'idAppointment': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'custom'?: string | null;
    /**
     * 
     * @type {Array<APISharedAppointmentOtherInfoCustomDto>}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'customProcessed'?: Array<APISharedAppointmentOtherInfoCustomDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'findUs'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'promoCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentOtherInfoDto
     */
    'post'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedAppointmentStaffDto
 */
export interface APISharedAppointmentStaffDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentStaffDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentStaffDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentStaffDto
     */
    'idFoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentStaffDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedAppointmentStaffDto
     */
    'color2'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedAppointmentWrapperDto
 */
export interface APISharedAppointmentWrapperDto {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult>}
     * @memberof APISharedAppointmentWrapperDto
     */
    'openingHours'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETOPENINGHOURSSCHEDULERResult> | null;
    /**
     * 
     * @type {Array<APISharedAppointmentDto>}
     * @memberof APISharedAppointmentWrapperDto
     */
    'appointments'?: Array<APISharedAppointmentDto> | null;
}
/**
 * 
 * @export
 * @interface APISharedAppointmentsAndOpenHoursDurationWrapperX2Dto
 */
export interface APISharedAppointmentsAndOpenHoursDurationWrapperX2Dto {
    /**
     * 
     * @type {Array<APISharedStaffDayDuration>}
     * @memberof APISharedAppointmentsAndOpenHoursDurationWrapperX2Dto
     */
    'staffDay'?: Array<APISharedStaffDayDuration> | null;
}
/**
 * 
 * @export
 * @interface APISharedCacheDtoHolder
 */
export interface APISharedCacheDtoHolder {
    /**
     * 
     * @type {string}
     * @memberof APISharedCacheDtoHolder
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCacheDtoHolder
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCacheDtoHolder
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCacheDtoHolder
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCacheDtoHolder
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedCacheDtoHolder
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedCacheDtoHolder
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedCalendarAppointmentCDto
 */
export interface APISharedCalendarAppointmentCDto {
    /**
     * 
     * @type {Array<APISharedCalendarAppointmentX2Dto>}
     * @memberof APISharedCalendarAppointmentCDto
     */
    'items'?: Array<APISharedCalendarAppointmentX2Dto> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentCDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentCDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentCDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentCDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentCDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentCDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentCDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedCalendarAppointmentDto
 */
export interface APISharedCalendarAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idPattern'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentDto
     */
    'isRecurrent': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentDto
     */
    'recurrenceIndex'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentDto
     */
    'isHoliday'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'promoCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'findUs'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'custom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'clientAnswer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarAppointmentDto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarAppointmentDto
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentDto
     */
    'allDay'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentDto
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentDto
     */
    'label'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'recurrenceInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'reminderInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idResource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentDto
     */
    'eventType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentDto
     */
    'confirmed': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentDto
     */
    'onlineBooked': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentDto
     */
    'noShow': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentDto
     */
    'newClient': boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarAppointmentDto
     */
    'createdDate': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarAppointmentDto
     */
    'lastUpdateDate': Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'clientRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'idApplicationType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentDto
     */
    'isPayment': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentDto
     */
    'planIdService'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedCalendarAppointmentX2Dto
 */
export interface APISharedCalendarAppointmentX2Dto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'recurrenceInfoXML'?: string | null;
    /**
     * 
     * @type {APISharedRecurrenceInfoDto}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'recurrenceInfoParsed': APISharedRecurrenceInfoDto;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'recurrenceInfoRRULE'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'originalKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'updatedKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'updateTransactionId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'isHoliday'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'type'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'allDay'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'label'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'recurrenceInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'reminderInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'idResource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'eventType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'confirmed': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'onlineBooked': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'noShow': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'newClient': boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'createdDate': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'lastUpdateDate': Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'clientRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'idApplicationType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'isPayment': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarAppointmentX2Dto
     */
    'planIdService'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedCalendarClientsDto
 */
export interface APISharedCalendarClientsDto {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult>}
     * @memberof APISharedCalendarClientsDto
     */
    'items'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarClientsDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarClientsDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarClientsDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarClientsDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarClientsDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarClientsDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarClientsDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedCalendarFetch
 */
export interface APISharedCalendarFetch {
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarFetch
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarFetch
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedCalendarFetch
     */
    'idStaff'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarFetch
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarFetch
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarFetch
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarFetch
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarFetch
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarFetch
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarFetch
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedCalendarOpenHourX2Dto
 */
export interface APISharedCalendarOpenHourX2Dto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'recurrenceInfoXML'?: string | null;
    /**
     * 
     * @type {APISharedRecurrenceInfoDto}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'recurrenceInfoParsed': APISharedRecurrenceInfoDto;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'recurrenceInfoRRULE'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'active'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'activeOverride'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'weekType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'eventType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'orderItem'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'type'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'allDay'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'label'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'recurrenceInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'reminderInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'idResource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'confirmed': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'onlineBooked': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'noShow': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'newClient': boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'createdDate': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'lastUpdateDate': Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'clientRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'idApplicationType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'isPayment': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHourX2Dto
     */
    'planIdService'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedCalendarOpenHoursDto
 */
export interface APISharedCalendarOpenHoursDto {
    /**
     * 
     * @type {Array<APISharedCalendarOpenHourX2Dto>}
     * @memberof APISharedCalendarOpenHoursDto
     */
    'items'?: Array<APISharedCalendarOpenHourX2Dto> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHoursDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHoursDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHoursDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHoursDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHoursDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarOpenHoursDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarOpenHoursDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedCalendarServicesDto
 */
export interface APISharedCalendarServicesDto {
    /**
     * 
     * @type {Array<APISharedServiceWithRelation>}
     * @memberof APISharedCalendarServicesDto
     */
    'items'?: Array<APISharedServiceWithRelation> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarServicesDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarServicesDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarServicesDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarServicesDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarServicesDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarServicesDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarServicesDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedCalendarStaffsDto
 */
export interface APISharedCalendarStaffsDto {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult>}
     * @memberof APISharedCalendarStaffsDto
     */
    'items'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarStaffsDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarStaffsDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarStaffsDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarStaffsDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarStaffsDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedCalendarStaffsDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedCalendarStaffsDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedCallEventDTO
 */
export interface APISharedCallEventDTO {
    /**
     * 
     * @type {APISharedCallHeaderDTO}
     * @memberof APISharedCallEventDTO
     */
    'callHeader': APISharedCallHeaderDTO;
    /**
     * 
     * @type {Array<APISharedCallItemDTO>}
     * @memberof APISharedCallEventDTO
     */
    'callItemList'?: Array<APISharedCallItemDTO> | null;
    /**
     * 
     * @type {Array<APISharedCallUserDTO>}
     * @memberof APISharedCallEventDTO
     */
    'callStaffList'?: Array<APISharedCallUserDTO> | null;
    /**
     * 
     * @type {Array<APISharedCallUserDTO>}
     * @memberof APISharedCallEventDTO
     */
    'callClientList'?: Array<APISharedCallUserDTO> | null;
}
/**
 * 
 * @export
 * @interface APISharedCallHeaderDTO
 */
export interface APISharedCallHeaderDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedCallHeaderDTO
     */
    'uniqueId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallHeaderDTO
     */
    'phoneFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallHeaderDTO
     */
    'phoneTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallHeaderDTO
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallHeaderDTO
     */
    'login'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallHeaderDTO
     */
    'pbxTitle'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedCallItemDTO
 */
export interface APISharedCallItemDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedCallItemDTO
     */
    'idEventType': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallItemDTO
     */
    'eventCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCallItemDTO
     */
    'eventDate': Date;
}
/**
 * 
 * @export
 * @interface APISharedCallUserDTO
 */
export interface APISharedCallUserDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedCallUserDTO
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallUserDTO
     */
    'idUserPhoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallUserDTO
     */
    'userName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCallUserDTO
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallUserDTO
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCallUserDTO
     */
    'badgeColor'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedCancelOnlineBookingAppointmentDto
 */
export interface APISharedCancelOnlineBookingAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCancelOnlineBookingAppointmentDto
     */
    'idAppointment': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCancelOnlineBookingAppointmentDto
     */
    'idCompany': string;
}
/**
 * 
 * @export
 * @interface APISharedCartOrderDTO
 */
export interface APISharedCartOrderDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedCartOrderDTO
     */
    'idCart': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCartOrderDTO
     */
    'idOwner': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCartOrderDTO
     */
    'ownerFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCartOrderDTO
     */
    'ownerLastname'?: string | null;
    /**
     * 
     * @type {Array<APISharedCartOrderItemDTO>}
     * @memberof APISharedCartOrderDTO
     */
    'items'?: Array<APISharedCartOrderItemDTO> | null;
}
/**
 * 
 * @export
 * @interface APISharedCartOrderItemDTO
 */
export interface APISharedCartOrderItemDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedCartOrderItemDTO
     */
    'idShopCartItem': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCartOrderItemDTO
     */
    'idOwner': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedCartOrderItemDTO
     */
    'itemId': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedCartOrderItemDTO
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface APISharedChiroLoginDto
 */
export interface APISharedChiroLoginDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedChiroLoginDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedChiroLoginDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedChiroLoginDto
     */
    'fireBaseDeviceToken'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedClientGeneralDataDto
 */
export interface APISharedClientGeneralDataDto {
    /**
     * 
     * @type {number}
     * @memberof APISharedClientGeneralDataDto
     */
    'limit': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientGeneralDataDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientGeneralDataDto
     */
    'period'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedClientGeneralDataDto
     */
    'validOnly': boolean;
}
/**
 * 
 * @export
 * @interface APISharedClientV2Dto
 */
export interface APISharedClientV2Dto {
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'idInsurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'idPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'idGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedClientV2Dto
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedClientV2Dto
     */
    'email'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedClientV2Dto
     */
    'createdAt': Date;
}
/**
 * 
 * @export
 * @interface APISharedCodelistDto
 */
export interface APISharedCodelistDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCodelistDto
     */
    'idCodelist': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCodelistDto
     */
    'idCodelistType': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCodelistDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCodelistDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCodelistDto
     */
    'annotation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCodelistDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCodelistDto
     */
    'list'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCodelistDto
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedCommunityCommunityPlatformMetadataDto
 */
export interface APISharedCommunityCommunityPlatformMetadataDto {
    /**
     * 
     * @type {APISharedCommunityPlatformUserMetadataDto}
     * @memberof APISharedCommunityCommunityPlatformMetadataDto
     */
    'user': APISharedCommunityPlatformUserMetadataDto;
    /**
     * 
     * @type {APISharedCommunityPlatformCompanyMetadataDto}
     * @memberof APISharedCommunityCommunityPlatformMetadataDto
     */
    'company': APISharedCommunityPlatformCompanyMetadataDto;
    /**
     * 
     * @type {APISharedCommunityPlatformLocationMetadataDto}
     * @memberof APISharedCommunityCommunityPlatformMetadataDto
     */
    'location': APISharedCommunityPlatformLocationMetadataDto;
}
/**
 * 
 * @export
 * @interface APISharedCommunityPlatformAdressMetadataDto
 */
export interface APISharedCommunityPlatformAdressMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformAdressMetadataDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformAdressMetadataDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformAdressMetadataDto
     */
    'zip'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedCommunityPlatformCompanyMetadataDto
 */
export interface APISharedCommunityPlatformCompanyMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformCompanyMetadataDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformCompanyMetadataDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformCompanyMetadataDto
     */
    'ico'?: string | null;
    /**
     * 
     * @type {APISharedCommunityPlatformAdressMetadataDto}
     * @memberof APISharedCommunityPlatformCompanyMetadataDto
     */
    'adress': APISharedCommunityPlatformAdressMetadataDto;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCommunityPlatformCompanyMetadataDto
     */
    'dateCreated': Date;
}
/**
 * 
 * @export
 * @interface APISharedCommunityPlatformLocationMetadataDto
 */
export interface APISharedCommunityPlatformLocationMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformLocationMetadataDto
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformLocationMetadataDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformLocationMetadataDto
     */
    'icz'?: string | null;
    /**
     * 
     * @type {APISharedCommunityPlatformAdressMetadataDto}
     * @memberof APISharedCommunityPlatformLocationMetadataDto
     */
    'adress': APISharedCommunityPlatformAdressMetadataDto;
}
/**
 * 
 * @export
 * @interface APISharedCommunityPlatformUserMetadataDto
 */
export interface APISharedCommunityPlatformUserMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'idUser': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'idProfilePicture'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCommunityPlatformUserMetadataDto
     */
    'dateCreated'?: Date | null;
}
/**
 * 
 * @export
 * @interface APISharedCreateAppointmentDto
 */
export interface APISharedCreateAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCreateAppointmentDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedCreateAppointmentDto
     */
    'datetime': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreateAppointmentDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedCreateAppointmentDto
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreateAppointmentDto
     */
    'serviceId': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreateAppointmentDto
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreateAppointmentDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreateAppointmentDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreateAppointmentDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreateAppointmentDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedCreateOrderDTO
 */
export interface APISharedCreateOrderDTO {
    /**
     * 
     * @type {APISharedCartOrderDTO}
     * @memberof APISharedCreateOrderDTO
     */
    'cart': APISharedCartOrderDTO;
    /**
     * 
     * @type {APISharedLocationData}
     * @memberof APISharedCreateOrderDTO
     */
    'billingLocation': APISharedLocationData;
    /**
     * 
     * @type {APISharedLocationData}
     * @memberof APISharedCreateOrderDTO
     */
    'shippingLocation': APISharedLocationData;
    /**
     * 
     * @type {APISharedDeliveryInfo}
     * @memberof APISharedCreateOrderDTO
     */
    'deliveryInfo': APISharedDeliveryInfo;
}
/**
 * 
 * @export
 * @interface APISharedCreatePartnershipRequestDto
 */
export interface APISharedCreatePartnershipRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedCreatePartnershipRequestDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreatePartnershipRequestDto
     */
    'idForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreatePartnershipRequestDto
     */
    'idPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedCreatePartnershipRequestDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedCreatePartnershipRequestDto
     */
    'sendSms'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOCurrenciesFixedCurrency
 */
export interface APISharedDTOCurrenciesFixedCurrency {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOCurrenciesFixedCurrency
     */
    'idCurrency': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOCurrenciesFixedCurrency
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOCurrenciesFixedCurrency
     */
    'code'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
 */
export interface APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'idEneschopenka': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'eneschopenkaType': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'eneschopenkaStatus': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'idXdentUser': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'idLocation': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'dateCreated': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'cisloRozhodnuti': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaEpWrappersBaseSubmissionWrapperDto
     */
    'dateModified'?: Date | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto
 */
export interface APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto
     */
    'idClient': string;
    /**
     * Allowed values: \"RPOP1\", \"RPOP2\", \"PDP\"
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface APISharedDTOEneschopenkaEpWrappersSubmissionGridDto
 */
export interface APISharedDTOEneschopenkaEpWrappersSubmissionGridDto {
    /**
     * 
     * @type {Array<APISharedDTOEneschopenkaEpWrappersSubmissionItemDto>}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionGridDto
     */
    'submissions'?: Array<APISharedDTOEneschopenkaEpWrappersSubmissionItemDto> | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOEneschopenkaEpWrappersSubmissionItemDto
 */
export interface APISharedDTOEneschopenkaEpWrappersSubmissionItemDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionItemDto
     */
    'idEneschopenka': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionItemDto
     */
    'eneschopenkaType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionItemDto
     */
    'eneschopenkaStatus'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionItemDto
     */
    'dateCreated': Date;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionItemDto
     */
    'dateModified'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionItemDto
     */
    'idXdentUser'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
 */
export interface APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto {
    /**
     * 
     * @type {APISharedDTOEneschopenkaPdpSubmissionDto}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'pdp': APISharedDTOEneschopenkaPdpSubmissionDto;
    /**
     * 
     * @type {APISharedDTOEneschopenkaRpop1SubmissionDto | APISharedDTOEneschopenkaRpop2SubmissionDto}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'rpop1'?: APISharedDTOEneschopenkaRpop1SubmissionDto | APISharedDTOEneschopenkaRpop2SubmissionDto | null;
    /**
     * 
     * @type {APISharedDTOEneschopenkaRpop2SubmissionDto}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'rpop2': APISharedDTOEneschopenkaRpop2SubmissionDto;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'idEneschopenka': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'eneschopenkaType': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'eneschopenkaStatus': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'idXdentUser': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'idLocation': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'dateCreated': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'cisloRozhodnuti': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto
     */
    'dateModified'?: Date | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOEneschopenkaPdpSubmissionDto
 */
export interface APISharedDTOEneschopenkaPdpSubmissionDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'cisloRozhodnuti': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'datumVystaveni': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'kodOssz': string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'opravnePodani': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'pojistenkaJmeno': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'pojistenkaPrijmeni': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'pojistenkaRodneCislo'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'pojistenkaDatumNarozeni'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'pojistenkaTelefon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'pojistenkaEmail'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'datumOcekavanehoPorodu'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'datumPorodu'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'lekarNazevPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'lekarIcoPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'lekarIczPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'lekarIcpe': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaPdpSubmissionDto
     */
    'lekarJmeno': string;
}
/**
 * 
 * @export
 * @interface APISharedDTOEneschopenkaRpop1SubmissionDto
 */
export interface APISharedDTOEneschopenkaRpop1SubmissionDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'cisloRozhodnuti': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'datumVystaveni': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'kodOssz': string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'opravnePodani': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'osetrovanaOsobaJmeno': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'osetrovanaOsobaPrijmeni': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'osetrovanaOsobaRodneCislo'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'osetrovanaOsobaDatumNarozeni'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'osetrovanaOsobaTelefon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'osetrovanaOsobaEmail'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'datumOd': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'lekarNazevPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'lekarJmeno': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'lekarIcoPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'lekarIczPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'lekarIcpe': string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'narizenaKarantena': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'nemuzePecovatODite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaRpop1SubmissionDto
     */
    'onemocnela': boolean;
}
/**
 * 
 * @export
 * @interface APISharedDTOEneschopenkaRpop2SubmissionDto
 */
export interface APISharedDTOEneschopenkaRpop2SubmissionDto {
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'datumDo': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'cisloRozhodnuti': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'datumVystaveni': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'kodOssz': string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'opravnePodani': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'osetrovanaOsobaJmeno': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'osetrovanaOsobaPrijmeni': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'osetrovanaOsobaRodneCislo'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'osetrovanaOsobaDatumNarozeni'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'osetrovanaOsobaTelefon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'osetrovanaOsobaEmail'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'datumOd': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'lekarNazevPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'lekarJmeno': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'lekarIcoPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'lekarIczPzs': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'lekarIcpe': string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'narizenaKarantena': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'nemuzePecovatODite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOEneschopenkaRpop2SubmissionDto
     */
    'onemocnela': boolean;
}
/**
 * 
 * @export
 * @interface APISharedDTOGalleryGalleryFilesGrid2WithContentDto
 */
export interface APISharedDTOGalleryGalleryFilesGrid2WithContentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'idFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'mimeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'galleryName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'size'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'isIKlientShared'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'fileType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'idMaster'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'imageContent'?: string | null;
    /**
     * 
     * @type {Array<APISharedDTOGalleryTagDto>}
     * @memberof APISharedDTOGalleryGalleryFilesGrid2WithContentDto
     */
    'tags'?: Array<APISharedDTOGalleryTagDto> | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOGalleryGroupedGalleryDto
 */
export interface APISharedDTOGalleryGroupedGalleryDto {
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOGalleryGroupedGalleryDto
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {Array<APISharedDTOGalleryGalleryFilesGrid2WithContentDto>}
     * @memberof APISharedDTOGalleryGroupedGalleryDto
     */
    'items'?: Array<APISharedDTOGalleryGalleryFilesGrid2WithContentDto> | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOGalleryGroupedGalleryWrapperDto
 */
export interface APISharedDTOGalleryGroupedGalleryWrapperDto {
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOGalleryGroupedGalleryWrapperDto
     */
    'totalLength'?: number | null;
    /**
     * 
     * @type {Array<APISharedDTOGalleryGroupedGalleryDto>}
     * @memberof APISharedDTOGalleryGroupedGalleryWrapperDto
     */
    'folders'?: Array<APISharedDTOGalleryGroupedGalleryDto> | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOGalleryTagDto
 */
export interface APISharedDTOGalleryTagDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryTagDto
     */
    'idTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryTagDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOGalleryTagDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOGalleryTagDto
     */
    'isAdd': boolean;
}
/**
 * 
 * @export
 * @interface APISharedDTOLocationLocationCustomSettingsDto
 */
export interface APISharedDTOLocationLocationCustomSettingsDto {
    /**
     * 
     * @type {Array<APISharedDTOCurrenciesFixedCurrency>}
     * @memberof APISharedDTOLocationLocationCustomSettingsDto
     */
    'fixedCurrency'?: Array<APISharedDTOCurrenciesFixedCurrency> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOLocationLocationCustomSettingsDto
     */
    'idLocation': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOLocationLocationCustomSettingsDto
     */
    'customDue': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOLocationLocationCustomSettingsDto
     */
    'forcePaymentTypePick': boolean;
    /**
     * 
     * @type {Array<APISharedDTOLocationLocationPaymentTypeSettingDto>}
     * @memberof APISharedDTOLocationLocationCustomSettingsDto
     */
    'paymentTypes'?: Array<APISharedDTOLocationLocationPaymentTypeSettingDto> | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOLocationLocationPaymentTypeSettingDto
 */
export interface APISharedDTOLocationLocationPaymentTypeSettingDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOLocationLocationPaymentTypeSettingDto
     */
    'idLocationsPaymentTypes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOLocationLocationPaymentTypeSettingDto
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOLocationLocationPaymentTypeSettingDto
     */
    'idPaymentType': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOLocationLocationPaymentTypeSettingDto
     */
    'position': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOLocationLocationPaymentTypeSettingDto
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingBookingDetailSettingDto
 */
export interface APISharedDTOOnlineBookingBookingDetailSettingDto {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'isEmailRequired': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'isPhoneRequired': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'htmlMsgBeforeBook'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'htmlScript'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'htmlScriptPre'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'bookToFuture': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'idScheme'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'indexBookingPage': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'calendarSelectOption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'termsAndConditionsUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'showCookieBar': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'paymentGatewayEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'autoApprove': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'isNewBookingDetail': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingBookingDetailSettingDto
     */
    'gdprPersonalDataUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingConfigDto
 */
export interface APISharedDTOOnlineBookingConfigDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingConfigDto
     */
    'ietfLanguageTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingConfigDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingConfigDto
     */
    'currency'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingLanguageDto
 */
export interface APISharedDTOOnlineBookingLanguageDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLanguageDto
     */
    'lngTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLanguageDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingLanguageDto
     */
    'isGlobalLng': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLanguageDto
     */
    'phonePrefixTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLanguageDto
     */
    'flag'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingLocationItemHelpDto
 */
export interface APISharedDTOOnlineBookingLocationItemHelpDto {
    /**
     * 
     * @type {Array<APISharedDTOOnlineBookingOtherInfoItemDto>}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'otherInfo'?: Array<APISharedDTOOnlineBookingOtherInfoItemDto> | null;
    /**
     * 
     * @type {APISharedDTOOnlineBookingBookingDetailSettingDto}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'bookingDetailSetting': APISharedDTOOnlineBookingBookingDetailSettingDto;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'web'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'facebook'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'twitter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'instagram'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'logo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'position': number;
    /**
     * 
     * @type {Array<APISharedDTOOnlineBookingServiceItemDto>}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'services'?: Array<APISharedDTOOnlineBookingServiceItemDto> | null;
    /**
     * 
     * @type {Array<APISharedDTOOnlineBookingWorkingHourItemDto>}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'workHourList'?: Array<APISharedDTOOnlineBookingWorkingHourItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'logoSquare'?: string | null;
    /**
     * 
     * @type {APIContextGeneratedXdentCoreEntityLayerGeocache}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'geoCache': APIContextGeneratedXdentCoreEntityLayerGeocache;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'isBookingDashboard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'isBookingDashboardLastAppointment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'isBookingDashboardRequestAppointment'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingLocationItemHelpDto
     */
    'gtMid'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingOnlineBookingAppointmentDto
 */
export interface APISharedDTOOnlineBookingOnlineBookingAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'idAppointment': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'staff'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'cancelBeforeStartTime'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'onlineBooked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'canBeCancelled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingOnlineBookingAppointmentDto
     */
    'isAlreadyCancelled'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingOnlineBookingMetadataDto
 */
export interface APISharedDTOOnlineBookingOnlineBookingMetadataDto {
    /**
     * 
     * @type {Array<APISharedDTOOnlineBookingLocationItemHelpDto>}
     * @memberof APISharedDTOOnlineBookingOnlineBookingMetadataDto
     */
    'clinics'?: Array<APISharedDTOOnlineBookingLocationItemHelpDto> | null;
    /**
     * 
     * @type {APISharedDTOOnlineBookingConfigDto}
     * @memberof APISharedDTOOnlineBookingOnlineBookingMetadataDto
     */
    'config': APISharedDTOOnlineBookingConfigDto;
    /**
     * 
     * @type {Array<APISharedDTOOnlineBookingLanguageDto>}
     * @memberof APISharedDTOOnlineBookingOnlineBookingMetadataDto
     */
    'languages'?: Array<APISharedDTOOnlineBookingLanguageDto> | null;
    /**
     * 
     * @type {{ [key: string]: Array<APISharedCodelistDto>; }}
     * @memberof APISharedDTOOnlineBookingOnlineBookingMetadataDto
     */
    'codelists'?: { [key: string]: Array<APISharedCodelistDto>; } | null;
    /**
     * 
     * @type {APISharedDTOOnlineBookingOnlineBookingAppointmentDto}
     * @memberof APISharedDTOOnlineBookingOnlineBookingMetadataDto
     */
    'appointment': APISharedDTOOnlineBookingOnlineBookingAppointmentDto;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingOtherInfoItemDto
 */
export interface APISharedDTOOnlineBookingOtherInfoItemDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOtherInfoItemDto
     */
    'idInfoType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOtherInfoItemDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOtherInfoItemDto
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingOtherInfoItemDto
     */
    'instruction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingOtherInfoItemDto
     */
    'position': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingOtherInfoItemDto
     */
    'isRequired': boolean;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingServiceGroupDto
 */
export interface APISharedDTOOnlineBookingServiceGroupDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingServiceGroupDto
     */
    'idServiceGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingServiceGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingServiceGroupDto
     */
    'position'?: number | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingServiceItemDto
 */
export interface APISharedDTOOnlineBookingServiceItemDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'nameXdent'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'priceText'?: string | null;
    /**
     * 
     * @type {Array<APISharedDTOOnlineBookingStaffItemDto>}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'staffs'?: Array<APISharedDTOOnlineBookingStaffItemDto> | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'deposit'?: number | null;
    /**
     * 
     * @type {Array<APISharedDTOOnlineBookingServiceGroupDto>}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'serviceGroups'?: Array<APISharedDTOOnlineBookingServiceGroupDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'requiresAuth'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingServiceItemDto
     */
    'color'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingStaffItemDto
 */
export interface APISharedDTOOnlineBookingStaffItemDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingStaffItemDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingStaffItemDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingStaffItemDto
     */
    'foto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingStaffItemDto
     */
    'directionDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingStaffItemDto
     */
    'directionName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingStaffItemDto
     */
    'languages'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOOnlineBookingWorkingHourItemDto
 */
export interface APISharedDTOOnlineBookingWorkingHourItemDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingWorkingHourItemDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingWorkingHourItemDto
     */
    'start': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOOnlineBookingWorkingHourItemDto
     */
    'finish': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOOnlineBookingWorkingHourItemDto
     */
    'opened': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOOnlineBookingWorkingHourItemDto
     */
    'dayType'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOQuickSmsSendQuickSmsDto
 */
export interface APISharedDTOQuickSmsSendQuickSmsDto {
    /**
     * 0 - Iklient, 1 - Xdent, 2 - Labino, 3 - XdentSk
     * @type {string}
     * @memberof APISharedDTOQuickSmsSendQuickSmsDto
     */
    'smsApi': APISharedDTOQuickSmsSendQuickSmsDtoSmsApiEnum;
    /**
     * 0 - None, 1 - Iklient, 2 - Xdent, 3 - Labino
     * @type {string}
     * @memberof APISharedDTOQuickSmsSendQuickSmsDto
     */
    'smsTextId': APISharedDTOQuickSmsSendQuickSmsDtoSmsTextIdEnum;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOQuickSmsSendQuickSmsDto
     */
    'numberWithPrefix'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOQuickSmsSendQuickSmsDto
     */
    'dateToSendUtc': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOQuickSmsSendQuickSmsDto
     */
    'smsText'?: string | null;
}

export const APISharedDTOQuickSmsSendQuickSmsDtoSmsApiEnum = {
    Iklient: 'Iklient',
    Xdent: 'Xdent',
    Labino: 'Labino',
    XdentSk: 'XdentSk'
} as const;

export type APISharedDTOQuickSmsSendQuickSmsDtoSmsApiEnum = typeof APISharedDTOQuickSmsSendQuickSmsDtoSmsApiEnum[keyof typeof APISharedDTOQuickSmsSendQuickSmsDtoSmsApiEnum];
export const APISharedDTOQuickSmsSendQuickSmsDtoSmsTextIdEnum = {
    None: 'None',
    Iklient: 'Iklient',
    Xdent: 'Xdent',
    Labino: 'Labino'
} as const;

export type APISharedDTOQuickSmsSendQuickSmsDtoSmsTextIdEnum = typeof APISharedDTOQuickSmsSendQuickSmsDtoSmsTextIdEnum[keyof typeof APISharedDTOQuickSmsSendQuickSmsDtoSmsTextIdEnum];

/**
 * 
 * @export
 * @interface APISharedDTORatingRatingConfigurationDto
 */
export interface APISharedDTORatingRatingConfigurationDto {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTORatingRatingConfigurationDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTORatingRatingConfigurationDto
     */
    'minDaysAfterInstall': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTORatingRatingConfigurationDto
     */
    'minDaysBeforeRemind': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTORatingRatingConfigurationDto
     */
    'minLaunchTimes': number;
}
/**
 * 
 * @export
 * @interface APISharedDTOValidationPersonalNumberAnalyzeDto
 */
export interface APISharedDTOValidationPersonalNumberAnalyzeDto {
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOValidationPersonalNumberAnalyzeDto
     */
    'age'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDTOValidationPersonalNumberAnalyzeDto
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationPersonalNumberAnalyzeDto
     */
    'gender'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOValidationPersonalNumberAnalyzeDto
     */
    'validFormat': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOValidationPersonalNumberAnalyzeDto
     */
    'isAgeOutOfRange': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOValidationPersonalNumberAnalyzeDto
     */
    'isForeigner': boolean;
}
/**
 * 
 * @export
 * @interface APISharedDTOValidationPhoneValidationResultDto
 */
export interface APISharedDTOValidationPhoneValidationResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'parseSuccess': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'phonePrefixCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'phonePrefixCodePlus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'countryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'idPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'minPhoneWithPrefixLength': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOValidationPhoneValidationResultDto
     */
    'missingPrefix': boolean;
}
/**
 * 
 * @export
 * @interface APISharedDTOValidationZipCodeValidationResultDto
 */
export interface APISharedDTOValidationZipCodeValidationResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDTOValidationZipCodeValidationResultDto
     */
    'parseSuccess': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationZipCodeValidationResultDto
     */
    'errorCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationZipCodeValidationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationZipCodeValidationResultDto
     */
    'czechName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDTOValidationZipCodeValidationResultDto
     */
    'slovakName'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDTOZabbixZabbixSmsLimitsDto
 */
export interface APISharedDTOZabbixZabbixSmsLimitsDto {
    /**
     * 
     * @type {number}
     * @memberof APISharedDTOZabbixZabbixSmsLimitsDto
     */
    'allSmsAlreadySentToday': number;
    /**
     * 
     * @type {APISharedOptionsSmsApiMexOptions}
     * @memberof APISharedDTOZabbixZabbixSmsLimitsDto
     */
    'smsApiOptions': APISharedOptionsSmsApiMexOptions;
}
/**
 * 
 * @export
 * @interface APISharedDashboardNotesInsertUpdateDTO
 */
export interface APISharedDashboardNotesInsertUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedDashboardNotesInsertUpdateDTO
     */
    'noteContent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDashboardNotesInsertUpdateDTO
     */
    'idNote'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDashboardNotesInsertUpdateDTO
     */
    'isComplete'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APISharedDashboardNotesListDTO
 */
export interface APISharedDashboardNotesListDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedDashboardNotesListDTO
     */
    'idNote': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDashboardNotesListDTO
     */
    'idOwner': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDashboardNotesListDTO
     */
    'idCompany': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDashboardNotesListDTO
     */
    'dateCreated': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedDashboardNotesListDTO
     */
    'noteContent'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDashboardNotesListDTO
     */
    'isComplete': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APISharedDashboardNotesListDTO
     */
    'dateCompleted'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDashboardNotesListDTO
     */
    'position'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedDashboardNotesListDTO
     */
    'rowNumber'?: number | null;
}
/**
 * 
 * @export
 * @interface APISharedDashobardDto
 */
export interface APISharedDashobardDto {
    /**
     * 
     * @type {Array<APISharedHeaderBlockHelper>}
     * @memberof APISharedDashobardDto
     */
    'progressBars'?: Array<APISharedHeaderBlockHelper> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedDashobardDto
     */
    'hasNotifications': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedDashobardDto
     */
    'notificationsCount'?: number | null;
}
/**
 * 
 * @export
 * @interface APISharedDeleteAppointment
 */
export interface APISharedDeleteAppointment {
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointment
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointment
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointment
     */
    'idAppointmentCancel'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDeleteAppointmentDto
 */
export interface APISharedDeleteAppointmentDto {
    /**
     * 
     * @type {Array<APISharedDeleteAppointmentItem2Dto>}
     * @memberof APISharedDeleteAppointmentDto
     */
    'items'?: Array<APISharedDeleteAppointmentItem2Dto> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedDeleteAppointmentDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedDeleteAppointmentItem2Dto
 */
export interface APISharedDeleteAppointmentItem2Dto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentItem2Dto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentItem2Dto
     */
    'idAppointment': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeleteAppointmentItem2Dto
     */
    'idAppointmentCancel': string;
}
/**
 * 
 * @export
 * @interface APISharedDeliveryInfo
 */
export interface APISharedDeliveryInfo {
    /**
     * 
     * @type {string}
     * @memberof APISharedDeliveryInfo
     */
    'contactPersonFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeliveryInfo
     */
    'contactPersonLastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeliveryInfo
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeliveryInfo
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDeliveryInfo
     */
    'phone'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDentalCategoryColorsDto
 */
export interface APISharedDentalCategoryColorsDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedDentalCategoryColorsDto
     */
    'idColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDentalCategoryColorsDto
     */
    'color'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedDynamicFormsFieldsBaseIDynamicFormField
 */
export interface APISharedDynamicFormsFieldsBaseIDynamicFormField {
    /**
     * 
     * @type {string}
     * @memberof APISharedDynamicFormsFieldsBaseIDynamicFormField
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDynamicFormsFieldsBaseIDynamicFormField
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedDynamicFormsFieldsBaseIDynamicFormField
     */
    'description'?: string | null;
    /**
     * 0 - Text, 1 - Integer, 2 - Decimal, 3 - Date, 4 - Signature, 5 - Group, 6 - TextMultiline
     * @type {string}
     * @memberof APISharedDynamicFormsFieldsBaseIDynamicFormField
     */
    'fieldType': APISharedDynamicFormsFieldsBaseIDynamicFormFieldFieldTypeEnum;
}

export const APISharedDynamicFormsFieldsBaseIDynamicFormFieldFieldTypeEnum = {
    Text: 'Text',
    Integer: 'Integer',
    Decimal: 'Decimal',
    Date: 'Date',
    Signature: 'Signature',
    Group: 'Group',
    TextMultiline: 'TextMultiline'
} as const;

export type APISharedDynamicFormsFieldsBaseIDynamicFormFieldFieldTypeEnum = typeof APISharedDynamicFormsFieldsBaseIDynamicFormFieldFieldTypeEnum[keyof typeof APISharedDynamicFormsFieldsBaseIDynamicFormFieldFieldTypeEnum];

/**
 * 
 * @export
 * @interface APISharedEditAppointmentDto
 */
export interface APISharedEditAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedEditAppointmentDto
     */
    'datetime': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedEditAppointmentDto
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'serviceId': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedEditAppointmentValuesDto
 */
export interface APISharedEditAppointmentValuesDto {
    /**
     * 
     * @type {Array<APISharedEditAppointmentX2Dto>}
     * @memberof APISharedEditAppointmentValuesDto
     */
    'items'?: Array<APISharedEditAppointmentX2Dto> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentValuesDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentValuesDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentValuesDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentValuesDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentValuesDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedEditAppointmentValuesDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentValuesDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedEditAppointmentX2Dto
 */
export interface APISharedEditAppointmentX2Dto {
    /**
     * 
     * @type {string}
     * @memberof APISharedEditAppointmentX2Dto
     */
    'idAppointment': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APISharedEditAppointmentX2Dto
     */
    'values'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface APISharedEditClientDto
 */
export interface APISharedEditClientDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'gender'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedEditClientDto
     */
    'marketing'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'realibility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedEditClientDto
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedEditClientDto
     */
    'blocked'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedEditClientDto
     */
    'emailNotify'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedEditClientDto
     */
    'smsNotify'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'insurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'idInsuranceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'salutation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'alerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'medicaments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'citizenship'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'insuranceExternalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientDto
     */
    'hiddenDescription'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedEditClientDto
     */
    'insuranceRegistrationDate'?: Date | null;
}
/**
 * 
 * @export
 * @interface APISharedEditClientInternal
 */
export interface APISharedEditClientInternal {
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'idReturned'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'gender'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedEditClientInternal
     */
    'marketing'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'realibility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'country'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedEditClientInternal
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedEditClientInternal
     */
    'blocked'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedEditClientInternal
     */
    'emailNotify'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedEditClientInternal
     */
    'smsNotify'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'insurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'idInsuranceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'salutation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'alerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'medicaments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'citizenship'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'insuranceExternalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEditClientInternal
     */
    'hiddenDescription'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedEditClientInternal
     */
    'insuranceRegistrationDate'?: Date | null;
}
/**
 * DTO pro výsledek odeslání emailu.
 * @export
 * @interface APISharedEmailsSendResultDto
 */
export interface APISharedEmailsSendResultDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedEmailsSendResultDto
     */
    'responseId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEmailsSendResultDto
     */
    'response'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEmailsSendResultDto
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedEmailsSendResultDto
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedErrorDto
 */
export interface APISharedErrorDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedErrorDto
     */
    'codeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedErrorDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedErrorDto
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedErrorDto
     */
    'innerDetail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedErrorDto
     */
    'stack'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedErrorDto
     */
    'innerStack'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedErrorDto
     */
    'innerExceptions'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedExtendBearerDto
 */
export interface APISharedExtendBearerDto {
    /**
     * Auth token
     * @type {string}
     * @memberof APISharedExtendBearerDto
     */
    'bearerToken'?: string | null;
    /**
     * One time use refresh token. Bearer that has been generated with its refresh pair equivalent has to be provided
     * @type {string}
     * @memberof APISharedExtendBearerDto
     */
    'refreshToken'?: string | null;
    /**
     * Firebase token for apps that use it. Can be null
     * @type {string}
     * @memberof APISharedExtendBearerDto
     */
    'fireBaseDeviceToken'?: string | null;
    /**
     * Device os description (for firebase purposes) can be null
     * @type {string}
     * @memberof APISharedExtendBearerDto
     */
    'os'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedExtendedBaseModel
 */
export interface APISharedExtendedBaseModel {
    /**
     * 
     * @type {string}
     * @memberof APISharedExtendedBaseModel
     */
    'fileContent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedExtendedBaseModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedExtendedBaseModel
     */
    'extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedExtendedBaseModel
     */
    'mimeType'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedFormRequest
 */
export interface APISharedFormRequest {
    /**
     * 
     * @type {APIContextGeneratedXdentCoreEntityLayerForms}
     * @memberof APISharedFormRequest
     */
    'form': APIContextGeneratedXdentCoreEntityLayerForms;
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult}
     * @memberof APISharedFormRequest
     */
    'client': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult;
    /**
     * 
     * @type {APIContextGeneratedXdentCoreEntityLayerUsers}
     * @memberof APISharedFormRequest
     */
    'doctor': APIContextGeneratedXdentCoreEntityLayerUsers;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormRequest
     */
    'idOwner'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedFormTemplateDto
 */
export interface APISharedFormTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'formType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idPartnerFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'signatureLoginToken'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedFormTemplateDto
     */
    'hasSignedArea': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedFormTemplateDto
     */
    'isStaticForm': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedFormTemplateDto
     */
    'isFilled': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idFormType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'form'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'formSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedFormTemplateDto
     */
    'published'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedFormTemplateDto
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedFormTemplateDto
     */
    'expirationDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedFormTemplateDto
     */
    'isFavorite'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'idTemplate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'definitionV2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'modelV2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedFormTemplateDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedFormTemplateDto
     */
    'autoConfirm'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APISharedGetLaboratoryLabelListDTO
 */
export interface APISharedGetLaboratoryLabelListDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'idLaboratoryLabel': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'labelNumberLab'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'dateIssue'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'dateDelivery'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'priceTotal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'locationPosition'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'labColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetLaboratoryLabelListDTO
     */
    'generatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedGetReservationsPerDayDTO
 */
export interface APISharedGetReservationsPerDayDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'client'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'staff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'confirmed'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'onlineBooked'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'createdDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'duration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetReservationsPerDayDTO
     */
    'debt'?: number | null;
}
/**
 * 
 * @export
 * @interface APISharedGetStoreTransactionsPerDayDTO
 */
export interface APISharedGetStoreTransactionsPerDayDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'idStoreTransaction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'staff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'idTransactionType'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'date'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'quantityBefore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'quantityAfter'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'transactionTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'lot'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'expiration'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'quantityNotify'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'itemCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'itemName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'transactionInfo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'quantityMovement'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'storeDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'storeUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'storeLocationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedGetStoreTransactionsPerDayDTO
     */
    'priceInvoice'?: number | null;
}
/**
 * 
 * @export
 * @interface APISharedGlobalXdentConfigCmpanyDto
 */
export interface APISharedGlobalXdentConfigCmpanyDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedGlobalXdentConfigCmpanyDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGlobalXdentConfigCmpanyDto
     */
    'businessName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGlobalXdentConfigCmpanyDto
     */
    'idLgo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGlobalXdentConfigCmpanyDto
     */
    'idRegion'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedGlobalXdentConfigLocationDto
 */
export interface APISharedGlobalXdentConfigLocationDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedGlobalXdentConfigLocationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedGlobalXdentConfigLocationDto
     */
    'idLogo'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedGlobalXdentConfigurationDto
 */
export interface APISharedGlobalXdentConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: Array<APISharedCodelistDto>; }}
     * @memberof APISharedGlobalXdentConfigurationDto
     */
    'codeLists'?: { [key: string]: Array<APISharedCodelistDto>; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedGlobalXdentConfigurationDto
     */
    'roles'?: Array<string> | null;
    /**
     * 
     * @type {Array<APISharedDentalCategoryColorsDto>}
     * @memberof APISharedGlobalXdentConfigurationDto
     */
    'dentalCategoryColors'?: Array<APISharedDentalCategoryColorsDto> | null;
    /**
     * 
     * @type {APISharedGlobalXdentConfigCmpanyDto}
     * @memberof APISharedGlobalXdentConfigurationDto
     */
    'company': APISharedGlobalXdentConfigCmpanyDto;
    /**
     * 
     * @type {APISharedGlobalXdentConfigLocationDto}
     * @memberof APISharedGlobalXdentConfigurationDto
     */
    'location': APISharedGlobalXdentConfigLocationDto;
}
/**
 * 
 * @export
 * @interface APISharedGlobalXdentConfigurationWrapperDto
 */
export interface APISharedGlobalXdentConfigurationWrapperDto {
    /**
     * 
     * @type {APISharedGlobalXdentConfigurationDto}
     * @memberof APISharedGlobalXdentConfigurationWrapperDto
     */
    'configuration': APISharedGlobalXdentConfigurationDto;
    /**
     * 
     * @type {APISharedUserXdentDto}
     * @memberof APISharedGlobalXdentConfigurationWrapperDto
     */
    'user': APISharedUserXdentDto;
}
/**
 * 
 * @export
 * @interface APISharedHeaderBlockHelper
 */
export interface APISharedHeaderBlockHelper {
    /**
     * 
     * @type {string}
     * @memberof APISharedHeaderBlockHelper
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedHeaderBlockHelper
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedHeaderBlockHelper
     */
    'number'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedHeaderBlockHelper
     */
    'progress'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedHeaderBlockHelper
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedHeaderBlockHelper
     */
    'statusTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedHeaderBlockHelper
     */
    'statusText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedHeaderBlockHelper
     */
    'dashboardDisplayType'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedInsuranceCustomCodeDelModel
 */
export interface APISharedInsuranceCustomCodeDelModel {
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceCustomCodeDelModel
     */
    'idInsuranceCustomCode': string;
}
/**
 * 
 * @export
 * @interface APISharedInsuranceCustomCodeIUModel
 */
export interface APISharedInsuranceCustomCodeIUModel {
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceCustomCodeIUModel
     */
    'idInsuranceCustomCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceCustomCodeIUModel
     */
    'idInsuranceItemN': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceCustomCodeIUModel
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceCustomCodeIUModel
     */
    'insuranceCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceCustomCodeIUModel
     */
    'customCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceCustomCodeIUModel
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceCustomCodeIUModel
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedInsuranceCustomCodeIUModel
     */
    'totalPrice': number;
}
/**
 * Payload for getting locked MR
 * @export
 * @interface APISharedInsuranceInvoiceGetLockedReportsModel
 */
export interface APISharedInsuranceInvoiceGetLockedReportsModel {
    /**
     * 
     * @type {Date}
     * @memberof APISharedInsuranceInvoiceGetLockedReportsModel
     */
    'datePeriod': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceInvoiceGetLockedReportsModel
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceInvoiceGetLockedReportsModel
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceInvoiceGetLockedReportsModel
     */
    'insuranceExternalId'?: string | null;
}
/**
 * Payload sent to APICORE
 * @export
 * @interface APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
 */
export interface APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel {
    /**
     * 
     * @type {Date}
     * @memberof APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
     */
    'dateStart': Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
     */
    'locations'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
     */
    'icps'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
     */
    'insuranceCompanies'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
     */
    'insuranceTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
     */
    'cares'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
     */
    'insuranceInvoiceTypes'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedInsuranceRulesInsuranceCheckAddCode
 */
export interface APISharedInsuranceRulesInsuranceCheckAddCode {
    /**
     * 
     * @type {APISharedInsuranceRulesInsuranceCode}
     * @memberof APISharedInsuranceRulesInsuranceCheckAddCode
     */
    'code': APISharedInsuranceRulesInsuranceCode;
    /**
     * 
     * @type {Array<APISharedInsuranceRulesInsuranceCode>}
     * @memberof APISharedInsuranceRulesInsuranceCheckAddCode
     */
    'history'?: Array<APISharedInsuranceRulesInsuranceCode> | null;
}
/**
 * 
 * @export
 * @interface APISharedInsuranceRulesInsuranceCheckAdviseCode
 */
export interface APISharedInsuranceRulesInsuranceCheckAdviseCode {
    /**
     * 
     * @type {Array<APISharedInsuranceRulesInsuranceCode>}
     * @memberof APISharedInsuranceRulesInsuranceCheckAdviseCode
     */
    'code'?: Array<APISharedInsuranceRulesInsuranceCode> | null;
    /**
     * 
     * @type {Array<APISharedInsuranceRulesInsuranceCode>}
     * @memberof APISharedInsuranceRulesInsuranceCheckAdviseCode
     */
    'history'?: Array<APISharedInsuranceRulesInsuranceCode> | null;
}
/**
 * 
 * @export
 * @interface APISharedInsuranceRulesInsuranceClient
 */
export interface APISharedInsuranceRulesInsuranceClient {
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'personalNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'age'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'male': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'validPersonalNumber': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'registrationDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'registrationIcp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'registrationIcz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'idInsuranceCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceClient
     */
    'idClient'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedInsuranceRulesInsuranceCode
 */
export interface APISharedInsuranceRulesInsuranceCode {
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'idReport'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'issueDate': Date;
    /**
     * 
     * @type {APISharedInsuranceRulesInsuranceStaff}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'staff': APISharedInsuranceRulesInsuranceStaff;
    /**
     * 
     * @type {APISharedInsuranceRulesInsuranceClient}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'client': APISharedInsuranceRulesInsuranceClient;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'diagnose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'localization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'idLaboratoryCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'isBeforeCheck'?: boolean | null;
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'basePrices': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGETINSURANCEITEMPRICESDATAPROCResult;
    /**
     * 
     * @type {APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'actualOverride': APIContextGeneratedXdentCoreEntityLayerInsuranceItemsOverride;
    /**
     * 
     * @type {Array<APISharedInsuranceRulesInsuranceCodeOverrideN>}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'codeOverridesN'?: Array<APISharedInsuranceRulesInsuranceCodeOverrideN> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceCode
     */
    'pricePerPoint'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedInsuranceRulesInsuranceCodeOverrideN
 */
export interface APISharedInsuranceRulesInsuranceCodeOverrideN {
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceCodeOverrideN
     */
    'overrideCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedInsuranceRulesInsuranceCodeOverrideN
     */
    'insurancePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedInsuranceRulesInsuranceCodeOverrideN
     */
    'insurancePoints'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedInsuranceRulesInsuranceCodeOverrideN
     */
    'clientPrice'?: number | null;
}
/**
 * 
 * @export
 * @interface APISharedInsuranceRulesInsuranceStaff
 */
export interface APISharedInsuranceRulesInsuranceStaff {
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceStaff
     */
    'certificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceStaff
     */
    'expertise'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceStaff
     */
    'icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceStaff
     */
    'icz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceStaff
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceStaff
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedInsuranceRulesInsuranceStaff
     */
    'idCompany'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedJsonWebToken
 */
export interface APISharedJsonWebToken {
    /**
     * 
     * @type {string}
     * @memberof APISharedJsonWebToken
     */
    'bearerToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedJsonWebToken
     */
    'refreshToken'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedJsonWebToken
     */
    'refreshExpiration'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedJsonWebToken
     */
    'bearerExpiration': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedJsonWebToken
     */
    'active'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOAssigneeDto
 */
export interface APISharedLabRequestFormsDTOAssigneeDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'idLabRequestFormAssigment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'idAssignee'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'assigneeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOAssigneeDto
     */
    'idLocation'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLRDCDiag
 */
export interface APISharedLabRequestFormsDTOLRDCDiag {
    /**
     * Zadává se tak, jak je uváděno v tomto číselníku, tj. bez tečky (např. A00, A001, M8111 aj.).
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRDCDiag
     */
    'value'?: string | null;
}
/**
 * https://dastacr.cz/dasta/hypertext/DSACJ.htm
 * @export
 * @interface APISharedLabRequestFormsDTOLRDCLip
 */
export interface APISharedLabRequestFormsDTOLRDCLip {
    /**
     * klíč sdělované položky
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRDCLip
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRDCLip
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLRDCLop
 */
export interface APISharedLabRequestFormsDTOLRDCLop {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRDCLop
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLRDCTest
 */
export interface APISharedLabRequestFormsDTOLRDCTest {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRDCTest
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRDCTest
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLRDCLop>}
     * @memberof APISharedLabRequestFormsDTOLRDCTest
     */
    'lops'?: Array<APISharedLabRequestFormsDTOLRDCLop> | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLRFRHeader
 */
export interface APISharedLabRequestFormsDTOLRFRHeader {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'idLabRequestFormResultHeader': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'idLabRequestFormResult': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'idLabRequestForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'pm_ico'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'pm_icz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'pm_icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'pm_icl'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'pm_a'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'is_ico'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'is_icz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'is_icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'is_icl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'ip_id_pac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'ip_jmeno'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'ip_prijmeni'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'ip_dat_dn'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_typku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_fazespec'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_idku'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_dat_prov'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_dat_vydani'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_pracoviste_icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_pracoviste_odb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_pracoviste_nazev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'kuz_text'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'createdAt': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'hasAttachment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'emailSent': boolean;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLRFRItem>}
     * @memberof APISharedLabRequestFormsDTOLRFRHeader
     */
    'items'?: Array<APISharedLabRequestFormsDTOLRFRItem> | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLRFRItem
 */
export interface APISharedLabRequestFormsDTOLRFRItem {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'idLabRequestFormResultItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'klic_nclp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'syst_klic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'komp_klic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'typ_cispol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'typpol_fh'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'stav_vys'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'urg_zprac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'typ_sdel_vys'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'akreditace'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'id_lis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'id_lo_is'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'dat_du'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'dat_pl'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'dat_vv'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'autor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'nazev_lclp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'unit'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'vrJson'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLRFRItem
     */
    'vrType'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabCatalog
 */
export interface APISharedLabRequestFormsDTOLabCatalog {
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabCatalog
     */
    'version': number;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLabRequestType>}
     * @memberof APISharedLabRequestFormsDTOLabCatalog
     */
    'labRequestTypes'?: Array<APISharedLabRequestFormsDTOLabRequestType> | null;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLabRequestParam>}
     * @memberof APISharedLabRequestFormsDTOLabCatalog
     */
    'labRequestParams'?: Array<APISharedLabRequestFormsDTOLabRequestParam> | null;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLabRequestSample>}
     * @memberof APISharedLabRequestFormsDTOLabCatalog
     */
    'labRequestSamples'?: Array<APISharedLabRequestFormsDTOLabRequestSample> | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestDataContentDto
 */
export interface APISharedLabRequestFormsDTOLabRequestDataContentDto {
    /**
     * Samoplatce
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestDataContentDto
     */
    'selfPayer'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestDataContentDto
     */
    'sampleCollectionTimestamp'?: Date | null;
    /**
     * Diagnoza z ciselniku MKN10 https://dastacr.cz/dasta/hypertext/UZIScis_Mkn10_5.htm
     * @type {Array<APISharedLabRequestFormsDTOLRDCDiag>}
     * @memberof APISharedLabRequestFormsDTOLabRequestDataContentDto
     */
    'diag'?: Array<APISharedLabRequestFormsDTOLRDCDiag> | null;
    /**
     * Globalni poznamka
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestDataContentDto
     */
    'description'?: string | null;
    /**
     * Interní poznamka - pro laboratoř. Nebude vytištěná na zprávách, výsledcích a tak...
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestDataContentDto
     */
    'noteInternal'?: string | null;
    /**
     * Informace o pacientovi
     * @type {Array<APISharedLabRequestFormsDTOLRDCLip>}
     * @memberof APISharedLabRequestFormsDTOLabRequestDataContentDto
     */
    'lip'?: Array<APISharedLabRequestFormsDTOLRDCLip> | null;
    /**
     * Objednávky a požadavky
     * @type {Array<APISharedLabRequestFormsDTOLRDCTest>}
     * @memberof APISharedLabRequestFormsDTOLabRequestDataContentDto
     */
    'tests'?: Array<APISharedLabRequestFormsDTOLRDCTest> | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestDataContentDto
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormAssigmentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'idLabRequestFormAssigment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'idParrentItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'parentItemType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'idAssignee'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'assigneeType'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'idUserCreated'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'deletedAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'idUserDeleted'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormAssigmentDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idLabRequestForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idLabRequestFormParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idLabRequestFormLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idUserSender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'idStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {APISharedLabRequestFormsDTOLabRequestDataContentDto}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'dataContent': APISharedLabRequestFormsDTOLabRequestDataContentDto;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'catalogVersion'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'identification'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'updatedAt'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'deletedAt'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'isReadOnly': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'hasResultsPdf': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'resultsCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'hasResults'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'sampleCollected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'sentEmailResultFromLab'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormDto
     */
    'urgCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormErrorDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormErrorDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'idLabRequestForm': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'identification'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'shortId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'idUserCreated'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'userCreatorFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'userCreatorLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'userCreatorEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'userCreatorEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'idUserSender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'userSenderFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'userSenderLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'userSenderEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'userSenderEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'clientFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'clientLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'clientEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'clientEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'clientPersonalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormErrorDto
     */
    'externalStatusCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormGridDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormGridDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'idLabRequestForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'idStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'identification'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'catalogVersion'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'updatedAt'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'isReadOnly': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'hasResults'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'hasResultsPdf': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'resultsCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'sampleCollected': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'allResultEmailSent': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'anyResultEmailSent': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'urgCode'?: string | null;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLabTagDto>}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormGridDto
     */
    'tags'?: Array<APISharedLabRequestFormsDTOLabTagDto> | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormLogDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormLogDto {
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'eventTimestamp': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'idLabRequestForm': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'statusTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'subtitle'?: string | null;
    /**
     * 0 - Status, 1 - Result
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'eventType': APISharedLabRequestFormsDTOLabRequestFormLogDtoEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'clientFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'clientLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'resultsGroups'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormLogDto
     */
    'identification'?: string | null;
}

export const APISharedLabRequestFormsDTOLabRequestFormLogDtoEventTypeEnum = {
    Status: 'Status',
    Result: 'Result'
} as const;

export type APISharedLabRequestFormsDTOLabRequestFormLogDtoEventTypeEnum = typeof APISharedLabRequestFormsDTOLabRequestFormLogDtoEventTypeEnum[keyof typeof APISharedLabRequestFormsDTOLabRequestFormLogDtoEventTypeEnum];

/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormPairHintDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormPairHintDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormPairHintDto
     */
    'idLabRequestFormPairHint'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormPairHintDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormPairHintDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormPairHintDto
     */
    'idLabRequestForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormPairHintDto
     */
    'sourceIsVnitrni'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormPairHintDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormPairHintDto
     */
    'valueType'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormResultDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormResultDto {
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLRFRHeader>}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultDto
     */
    'results'?: Array<APISharedLabRequestFormsDTOLRFRHeader> | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultDto
     */
    'xmlReceivedAt'?: Date | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'idLabRequestFormResultHeader'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'idLabRequestFormResult'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'idLabRequestForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'pmIco'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'pmIcz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'pmIcp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'pmIcl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'pmA'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'isIco'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'isIcz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'isIcp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'isIcl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'ipIdPac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'ipJmeno'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'ipPrijmeni'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'ipDatDn'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzTypku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzFazespec'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzIdku'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzDatProv'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzDatVydani'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzPracovisteIcp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzPracovisteOdb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzPracovisteNazev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'kuzText'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto
     */
    'hasResultPdf': boolean;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'idLabRequestFormResultHeader'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'idLabRequestForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'idStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'statusTitle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'shortId': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'identification'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'requestCreatedAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'idRequestSender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'userSenderFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'userSenderLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'userSenderEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'userSenderEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'clientFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'clientLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'clientEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'clientEducationAfter'?: string | null;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOAssigneeDto>}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'assignees'?: Array<APISharedLabRequestFormsDTOAssigneeDto> | null;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLabTagDto>}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'tags'?: Array<APISharedLabRequestFormsDTOLabTagDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'hasPdfResult': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'emailSent': boolean;
    /**
     * Only set
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'assigmentCreatedAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'assigmentMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'pmIcp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'pmIcz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto
     */
    'urgCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'idLabRequestFormResult'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'idLabRequestFormResultZip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'errorMsg'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'apiUserTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'kuzIdku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'ipIdPac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'kuzFazespec'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'pmIco'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'pmIcp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'pmIcz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'kuzPracovisteIcp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'kuzPracovisteOdb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'kuzPracovisteNazev'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto
     */
    'xmlContentSet'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormStatusLogDto {
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'eventTimestamp': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'idLabRequestForm': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'statusTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'apiUserTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'userCreatedLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'userCreatedFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormStatusLogDto
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto
     */
    'idLabRequestFormTemplate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {APISharedLabRequestFormsDTOLabRequestTemplateContentDto}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto
     */
    'dataContent': APISharedLabRequestFormsDTOLabRequestTemplateContentDto;
    /**
     * 
     * @type {APISharedLabRequestFormsDTOLabRequestTemplateMetaDto}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto
     */
    'metadata': APISharedLabRequestFormsDTOLabRequestTemplateMetaDto;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'idLabRequestFormTemplate': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {APISharedLabRequestFormsDTOLabRequestTemplateContentDto}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'dataContent': APISharedLabRequestFormsDTOLabRequestTemplateContentDto;
    /**
     * 
     * @type {APISharedLabRequestFormsDTOLabRequestTemplateMetaDto}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'metadata': APISharedLabRequestFormsDTOLabRequestTemplateMetaDto;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'idUserUpdated'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto
     */
    'updatedAt'?: Date | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto
 */
export interface APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto
     */
    'idLabRequestFormTemplate': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {APISharedLabRequestFormsDTOLabRequestTemplateMetaDto}
     * @memberof APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto
     */
    'metadata': APISharedLabRequestFormsDTOLabRequestTemplateMetaDto;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestParam
 */
export interface APISharedLabRequestFormsDTOLabRequestParam {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestParam
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestParam
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestParam
     */
    'title'?: string | null;
    /**
     * 
     * @type {APISharedLabRequestFormsDTOTyp}
     * @memberof APISharedLabRequestFormsDTOLabRequestParam
     */
    'typ': APISharedLabRequestFormsDTOTyp;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestResultOverviewStats
 */
export interface APISharedLabRequestFormsDTOLabRequestResultOverviewStats {
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestResultOverviewStats
     */
    'erroredResults'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestResultOverviewStats
     */
    'unpairedResults'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestResultOverviewStats
     */
    'myAssignments'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestResultOverviewStats
     */
    'resultToReview'?: number | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestSample
 */
export interface APISharedLabRequestFormsDTOLabRequestSample {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestSample
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestSample
     */
    'material'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestSample
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestSample
     */
    'packageType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestSample
     */
    'packageColor'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestTemplateContentDto
 */
export interface APISharedLabRequestFormsDTOLabRequestTemplateContentDto {
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestTemplateContentDto
     */
    'version': number;
    /**
     * Objednávky a požadavky
     * @type {Array<APISharedLabRequestFormsDTOLRDCTest>}
     * @memberof APISharedLabRequestFormsDTOLabRequestTemplateContentDto
     */
    'tests'?: Array<APISharedLabRequestFormsDTOLRDCTest> | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestTemplateMetaDto
 */
export interface APISharedLabRequestFormsDTOLabRequestTemplateMetaDto {
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestTemplateMetaDto
     */
    'testCount': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLabRequestFormsDTOLabRequestTemplateMetaDto
     */
    'includedTypes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestType
 */
export interface APISharedLabRequestFormsDTOLabRequestType {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestType
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestType
     */
    'color'?: string | null;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLabRequestTypeTest>}
     * @memberof APISharedLabRequestFormsDTOLabRequestType
     */
    'tests'?: Array<APISharedLabRequestFormsDTOLabRequestTypeTest> | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabRequestType
     */
    'testCount': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestType
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabRequestTypeTest
 */
export interface APISharedLabRequestFormsDTOLabRequestTypeTest {
    /**
     * DefiniceZadanky - Název
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'typeTitle'?: string | null;
    /**
     * NazevSkupiny
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'groupTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'groupNote'?: string | null;
    /**
     * KodSablony
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'templateCode'?: string | null;
    /**
     * NazevSablony - odstranene {pozn_lop}
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'templateTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'templateNote'?: string | null;
    /**
     * Jestli NazevSablony obsahoval \"{pozn_lop}\"
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'requireDescription': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'lopKeys'?: Array<string> | null;
    /**
     * @deprecated
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'lopKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'icp'?: string | null;
    /**
     * 
     * @type {Array<APISharedLabRequestFormsDTOLabTestSampleRequirement>}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'samples'?: Array<APISharedLabRequestFormsDTOLabTestSampleRequirement> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLabRequestFormsDTOLabRequestTypeTest
     */
    'patientParameters'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabResultNotificationDto
 */
export interface APISharedLabRequestFormsDTOLabResultNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabResultNotificationDto
     */
    'idLabRequestForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabResultNotificationDto
     */
    'idLabRequestFormResultHeader'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabResultNotificationDto
     */
    'protectAttacmentByPersonalId': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOLabResultNotificationDto
     */
    'attachResultPdf': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabResultNotificationDto
     */
    'emailSubject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabResultNotificationDto
     */
    'emailBody'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabResultNotificationDto
     */
    'passwordOverride'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabTagDto
 */
export interface APISharedLabRequestFormsDTOLabTagDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabTagDto
     */
    'idLabRequestFormTag': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabTagDto
     */
    'tagName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabTagDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOLabTagDto
     */
    'position': number;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOLabTestSampleRequirement
 */
export interface APISharedLabRequestFormsDTOLabTestSampleRequirement {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabTestSampleRequirement
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOLabTestSampleRequirement
     */
    'subKey'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOPairResultDto
 */
export interface APISharedLabRequestFormsDTOPairResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOPairResultDto
     */
    'askForClientIdHintSet': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOPairResultDto
     */
    'additionalResultsPaired': number;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOResultEmailPreviewDTO
 */
export interface APISharedLabRequestFormsDTOResultEmailPreviewDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOResultEmailPreviewDTO
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOResultEmailPreviewDTO
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOResultEmailPreviewDTO
     */
    'idTemplate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOResultEmailPreviewDTO
     */
    'clientHasEmail': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOResultEmailPreviewDTO
     */
    'recipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOResultEmailPreviewDTO
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOResultEmailPreviewDTO
     */
    'idCliet'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOResultEmailPreviewDTO
     */
    'allowPdfAttachment': boolean;
}
/**
 * 
 * @export
 * @interface APISharedLabRequestFormsDTOTyp
 */
export interface APISharedLabRequestFormsDTOTyp {
    /**
     * 0 - text, 1 - number, 2 - integer, 3 - datetime, 4 - choice, 5 - link
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOTyp
     */
    'type': APISharedLabRequestFormsDTOTypTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOTyp
     */
    'min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLabRequestFormsDTOTyp
     */
    'max'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLabRequestFormsDTOTyp
     */
    'required': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOTyp
     */
    'format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsDTOTyp
     */
    'url'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLabRequestFormsDTOTyp
     */
    'options'?: Array<string> | null;
}

export const APISharedLabRequestFormsDTOTypTypeEnum = {
    Text: 'text',
    Number: 'number',
    Integer: 'integer',
    Datetime: 'datetime',
    Choice: 'choice',
    Link: 'link'
} as const;

export type APISharedLabRequestFormsDTOTypTypeEnum = typeof APISharedLabRequestFormsDTOTypTypeEnum[keyof typeof APISharedLabRequestFormsDTOTypTypeEnum];

/**
 * 
 * @export
 * @interface APISharedLabRequestFormsLabRequestResultParseLog
 */
export interface APISharedLabRequestFormsLabRequestResultParseLog {
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsLabRequestResultParseLog
     */
    'idLabRequestFormResult'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLabRequestFormsLabRequestResultParseLog
     */
    'error'?: string | null;
}
/**
 * Adresa - obecný předek
 * @export
 * @interface APISharedLibsAdresa
 */
export interface APISharedLibsAdresa {
    [key: string]: any;

    /**
     * Kód státu (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'kodStatu': string;
    /**
     * Název státu
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevStatu': string;
    /**
     * Kód kraje
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodKraje': number;
    /**
     * Název kraje
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevKraje': string;
    /**
     * Kód okresu
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodOkresu': number;
    /**
     * Název okresu
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevOkresu': string;
    /**
     * Kód obce
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodObce': number;
    /**
     * Název obce
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevObce': string;
    /**
     * Kód správního obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodSpravnihoObvodu': number;
    /**
     * Název správního obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevSpravnihoObvodu': string;
    /**
     * Kód městského obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodMestskehoObvodu': number;
    /**
     * Název městského obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevMestskehoObvodu': string;
    /**
     * Kód městské části statutárního města
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodMestskeCastiObvodu': number;
    /**
     * Kód ulice, veřejného prostranství ze zdroje
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodUlice': number;
    /**
     * Název městské části statutárního města
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevMestskeCastiObvodu': string;
    /**
     * Název ulice, veřejného prostranství
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevUlice': string;
    /**
     * Číslo domovní
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'cisloDomovni': number;
    /**
     * Doplňující informace adresního popisu
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'doplnekAdresy': string;
    /**
     * Kód časti obce
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodCastiObce': number;
    /**
     * Číslo orientační - číselná část
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'cisloOrientacni': number;
    /**
     * Číslo orientační - písmenná část
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'cisloOrientacniPismeno': string;
    /**
     * Název části obce
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'nazevCastiObce': string;
    /**
     * Kód adresního místa
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'kodAdresnihoMista': number;
    /**
     * Poštovní směrovací číslo adresní pošty
     * @type {number}
     * @memberof APISharedLibsAdresa
     */
    'psc': number;
    /**
     * Nestrukturovaná adresa (formátovaná adresa)
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'textovaAdresa': string;
    /**
     * Nestrukturované číslo/a použíté v adrese
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'cisloDoAdresy': string;
    /**
     * Typ čísla domu (ciselnikKod: TypCislaDomovniho)
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'typCisloDomovni': string;
    /**
     * Stav standardizace adresy dle RÚIAN
     * @type {boolean}
     * @memberof APISharedLibsAdresa
     */
    'standardizaceAdresy': boolean;
    /**
     * Psč zahraničních nebo nestandardně definovaných čísel
     * @type {string}
     * @memberof APISharedLibsAdresa
     */
    'pscTxt': string;
}
/**
 * Adresa s platností
 * @export
 * @interface APISharedLibsAdresaAres
 */
export interface APISharedLibsAdresaAres {
    [key: string]: any;

    /**
     * 
     * @type {APISharedLibsAdresaAresSidlo}
     * @memberof APISharedLibsAdresaAres
     */
    'sidlo': APISharedLibsAdresaAresSidlo;
    /**
     * Primární záznam
     * @type {boolean}
     * @memberof APISharedLibsAdresaAres
     */
    'primarniZaznam': boolean;
    /**
     * Platnost údaje od data
     * @type {Date}
     * @memberof APISharedLibsAdresaAres
     */
    'platnostOd': Date;
    /**
     * Platnost údaje od data
     * @type {Date}
     * @memberof APISharedLibsAdresaAres
     */
    'platnostDo': Date;
}
/**
 * @type APISharedLibsAdresaAresSidlo
 * Sídlo
 * @export
 */
export type APISharedLibsAdresaAresSidlo = APISharedLibsAdresa | APISharedLibsAdresaCeu | APISharedLibsAdresaRcns | APISharedLibsAngazovanySubjektAdresa | APISharedLibsEkonomickySubjektRzpAdresa;

/**
 * 
 * @export
 * @interface APISharedLibsAdresaCeu
 */
export interface APISharedLibsAdresaCeu {
    [key: string]: any;

    /**
     * Typ adresy
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'typAdresy': string;
    /**
     * Kód státu (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodStatu': string;
    /**
     * Název státu
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevStatu': string;
    /**
     * Kód kraje
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodKraje': number;
    /**
     * Název kraje
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevKraje': string;
    /**
     * Kód okresu
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodOkresu': number;
    /**
     * Název okresu
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevOkresu': string;
    /**
     * Kód obce
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodObce': number;
    /**
     * Název obce
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevObce': string;
    /**
     * Kód správního obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodSpravnihoObvodu': number;
    /**
     * Název správního obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevSpravnihoObvodu': string;
    /**
     * Kód městského obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodMestskehoObvodu': number;
    /**
     * Název městského obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevMestskehoObvodu': string;
    /**
     * Kód městské části statutárního města
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodMestskeCastiObvodu': number;
    /**
     * Kód ulice, veřejného prostranství ze zdroje
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodUlice': number;
    /**
     * Název městské části statutárního města
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevMestskeCastiObvodu': string;
    /**
     * Název ulice, veřejného prostranství
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevUlice': string;
    /**
     * Číslo domovní
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'cisloDomovni': number;
    /**
     * Doplňující informace adresního popisu
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'doplnekAdresy': string;
    /**
     * Kód časti obce
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodCastiObce': number;
    /**
     * Číslo orientační - číselná část
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'cisloOrientacni': number;
    /**
     * Číslo orientační - písmenná část
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'cisloOrientacniPismeno': string;
    /**
     * Název části obce
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'nazevCastiObce': string;
    /**
     * Kód adresního místa
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'kodAdresnihoMista': number;
    /**
     * Poštovní směrovací číslo adresní pošty
     * @type {number}
     * @memberof APISharedLibsAdresaCeu
     */
    'psc': number;
    /**
     * Nestrukturovaná adresa (formátovaná adresa)
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'textovaAdresa': string;
    /**
     * Nestrukturované číslo/a použíté v adrese
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'cisloDoAdresy': string;
    /**
     * Typ čísla domu (ciselnikKod: TypCislaDomovniho)
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'typCisloDomovni': string;
    /**
     * Stav standardizace adresy dle RÚIAN
     * @type {boolean}
     * @memberof APISharedLibsAdresaCeu
     */
    'standardizaceAdresy': boolean;
    /**
     * Psč zahraničních nebo nestandardně definovaných čísel
     * @type {string}
     * @memberof APISharedLibsAdresaCeu
     */
    'pscTxt': string;
}
/**
 * Adresa doručovací dle vyhlášky 359/2011 sb.
 * @export
 * @interface APISharedLibsAdresaDorucovaci
 */
export interface APISharedLibsAdresaDorucovaci {
    [key: string]: any;

    /**
     * 1. řádek doručovací adresy
     * @type {string}
     * @memberof APISharedLibsAdresaDorucovaci
     */
    'radekAdresy1': string;
    /**
     * 2. řádek doručovací adresy
     * @type {string}
     * @memberof APISharedLibsAdresaDorucovaci
     */
    'radekAdresy2': string;
    /**
     * 3. řádek doručovací adresy
     * @type {string}
     * @memberof APISharedLibsAdresaDorucovaci
     */
    'radekAdresy3': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsAdresaRcns
 */
export interface APISharedLibsAdresaRcns {
    [key: string]: any;

    /**
     * Platnost adresy od data
     * @type {Date}
     * @memberof APISharedLibsAdresaRcns
     */
    'platnostOd': Date;
    /**
     * Platnost adresy do data
     * @type {Date}
     * @memberof APISharedLibsAdresaRcns
     */
    'platnostDo': Date;
    /**
     * Typ adresy  - kód (ciselnikKod: TypAdresy, zdroj: rcns)
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'typAdresy': string;
    /**
     * Kód státu (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodStatu': string;
    /**
     * Název státu
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevStatu': string;
    /**
     * Kód kraje
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodKraje': number;
    /**
     * Název kraje
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevKraje': string;
    /**
     * Kód okresu
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodOkresu': number;
    /**
     * Název okresu
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevOkresu': string;
    /**
     * Kód obce
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodObce': number;
    /**
     * Název obce
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevObce': string;
    /**
     * Kód správního obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodSpravnihoObvodu': number;
    /**
     * Název správního obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevSpravnihoObvodu': string;
    /**
     * Kód městského obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodMestskehoObvodu': number;
    /**
     * Název městského obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevMestskehoObvodu': string;
    /**
     * Kód městské části statutárního města
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodMestskeCastiObvodu': number;
    /**
     * Kód ulice, veřejného prostranství ze zdroje
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodUlice': number;
    /**
     * Název městské části statutárního města
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevMestskeCastiObvodu': string;
    /**
     * Název ulice, veřejného prostranství
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevUlice': string;
    /**
     * Číslo domovní
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'cisloDomovni': number;
    /**
     * Doplňující informace adresního popisu
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'doplnekAdresy': string;
    /**
     * Kód časti obce
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodCastiObce': number;
    /**
     * Číslo orientační - číselná část
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'cisloOrientacni': number;
    /**
     * Číslo orientační - písmenná část
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'cisloOrientacniPismeno': string;
    /**
     * Název části obce
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'nazevCastiObce': string;
    /**
     * Kód adresního místa
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'kodAdresnihoMista': number;
    /**
     * Poštovní směrovací číslo adresní pošty
     * @type {number}
     * @memberof APISharedLibsAdresaRcns
     */
    'psc': number;
    /**
     * Nestrukturovaná adresa (formátovaná adresa)
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'textovaAdresa': string;
    /**
     * Nestrukturované číslo/a použíté v adrese
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'cisloDoAdresy': string;
    /**
     * Typ čísla domu (ciselnikKod: TypCislaDomovniho)
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'typCisloDomovni': string;
    /**
     * Stav standardizace adresy dle RÚIAN
     * @type {boolean}
     * @memberof APISharedLibsAdresaRcns
     */
    'standardizaceAdresy': boolean;
    /**
     * Psč zahraničních nebo nestandardně definovaných čísel
     * @type {string}
     * @memberof APISharedLibsAdresaRcns
     */
    'pscTxt': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsAngazmaRcns
 */
export interface APISharedLibsAngazmaRcns {
    [key: string]: any;

    /**
     * 
     * @type {APISharedLibsAngazovanySubjektRcns}
     * @memberof APISharedLibsAngazmaRcns
     */
    'osobaPravnicka': APISharedLibsAngazovanySubjektRcns;
    /**
     * 
     * @type {APISharedLibsAngazovanaOsobaRcns}
     * @memberof APISharedLibsAngazmaRcns
     */
    'osobaFyzicka': APISharedLibsAngazovanaOsobaRcns;
}
/**
 * Osoba v angažmá ekonomického subjektu
 * @export
 * @interface APISharedLibsAngazovanaOsoba
 */
export interface APISharedLibsAngazovanaOsoba {
    [key: string]: any;

    /**
     * Jméno fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsoba
     */
    'jmeno': string;
    /**
     * Příjmení fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsoba
     */
    'prijmeni': string;
    /**
     * Titul před jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsoba
     */
    'titulPredJmenem': string;
    /**
     * Titul za jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsoba
     */
    'titulZaJmenem': string;
    /**
     * Datum narození fyzické osoby
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsoba
     */
    'datumNarozeni': Date;
}
/**
 * Tabulka angažovaných osob
 * @export
 * @interface APISharedLibsAngazovanaOsobaCeu
 */
export interface APISharedLibsAngazovanaOsobaCeu {
    [key: string]: any;

    /**
     * Jméno, příjmení správce
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaCeu
     */
    'jmenoPrijmeni': string;
    /**
     * Typ angažmá
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaCeu
     */
    'typAngazma': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsAngazovanaOsobaNrpzs
 */
export interface APISharedLibsAngazovanaOsobaNrpzs {
    [key: string]: any;

    /**
     * Typ angažmá osoby  - kód (ciselnikKod: TypAngazma, zdroj: nrpzs)
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaNrpzs
     */
    'typAngazma': string;
    /**
     * Jméno fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaNrpzs
     */
    'jmeno': string;
    /**
     * Příjmení fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaNrpzs
     */
    'prijmeni': string;
    /**
     * Titul před jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaNrpzs
     */
    'titulPredJmenem': string;
    /**
     * Titul za jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaNrpzs
     */
    'titulZaJmenem': string;
    /**
     * Datum narození fyzické osoby
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaNrpzs
     */
    'datumNarozeni': Date;
}
/**
 * Název vykonávané statutární(církevní) funkce
 * @export
 * @interface APISharedLibsAngazovanaOsobaRcns
 */
export interface APISharedLibsAngazovanaOsobaRcns {
    [key: string]: any;

    /**
     * Platnost angažované osoby od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'platnostOd': Date;
    /**
     * Platnost angažované osoby od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'platnostDo': Date;
    /**
     * Název orgánu
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'nazevAngazma': string;
    /**
     * Dodatečná informace jako \'funkce neobsazena\'
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'poznamka': string;
    /**
     * Typ angažmá osoby  - kód (ciselnikKod: TypAngazma, zdroj: rcns)
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'typAngazma': string;
    /**
     * Název orgánu
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'nazevOrganu': string;
    /**
     * Kód státu  (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'kodStatu': string;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma)
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'pravniForma': string;
    /**
     * Jméno fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'jmeno': string;
    /**
     * Příjmení fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'prijmeni': string;
    /**
     * Titul před jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'titulPredJmenem': string;
    /**
     * Titul za jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'titulZaJmenem': string;
    /**
     * Datum narození fyzické osoby
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRcns
     */
    'datumNarozeni': Date;
}
/**
 * Identifikace fyzické osoby statutárního orgánu subjektu.
 * @export
 * @interface APISharedLibsAngazovanaOsobaRpsh
 */
export interface APISharedLibsAngazovanaOsobaRpsh {
    [key: string]: any;

    /**
     * Název fukce
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'funkce': string;
    /**
     * Platnost záznamu od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'platnostOd': Date;
    /**
     * Platnost záznamu do data
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'platnostDo': Date;
    /**
     * adresa angažované osoby
     * @type {APISharedLibsAdresa | APISharedLibsAngazovanySubjektAdresa | APISharedLibsEkonomickySubjektRzpAdresa | APISharedLibsAdresaRcns | APISharedLibsAdresaCeu}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'adresa': APISharedLibsAdresa | APISharedLibsAngazovanySubjektAdresa | APISharedLibsEkonomickySubjektRzpAdresa | APISharedLibsAdresaRcns | APISharedLibsAdresaCeu;
    /**
     * Kód fukce
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'kod': string;
    /**
     * Typ angažmá osoby  - kód (ciselnikKod: TypAngazma)
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'typAngazma': string;
    /**
     * Jméno fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'jmeno': string;
    /**
     * Příjmení fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'prijmeni': string;
    /**
     * Titul před jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'titulPredJmenem': string;
    /**
     * Titul za jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'titulZaJmenem': string;
    /**
     * Datum narození fyzické osoby
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRpsh
     */
    'datumNarozeni': Date;
}
/**
 * 
 * @export
 * @interface APISharedLibsAngazovanaOsobaRs
 */
export interface APISharedLibsAngazovanaOsobaRs {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRs
     */
    'typAngazma': string;
    /**
     * Jméno fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRs
     */
    'jmeno': string;
    /**
     * Příjmení fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRs
     */
    'prijmeni': string;
    /**
     * Titul před jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRs
     */
    'titulPredJmenem': string;
    /**
     * Titul za jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRs
     */
    'titulZaJmenem': string;
    /**
     * Datum narození fyzické osoby
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRs
     */
    'datumNarozeni': Date;
}
/**
 * Angažovaná osoba zdroje RŽP
 * @export
 * @interface APISharedLibsAngazovanaOsobaRzp
 */
export interface APISharedLibsAngazovanaOsobaRzp {
    [key: string]: any;

    /**
     * Platnost angažmá osoby od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'platnostOd': Date;
    /**
     * Platnost angažmá osoby do data
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'platnostDo': Date;
    /**
     * Státní občanství osoby - kód (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'statniObcanstvi': string;
    /**
     * Typ angažmá osoby  - kód (ciselnikKod: TypAngazma, zdroj: rzp)
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'typAngazma': string;
    /**
     * Jméno fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'jmeno': string;
    /**
     * Příjmení fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'prijmeni': string;
    /**
     * Titul před jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'titulPredJmenem': string;
    /**
     * Titul za jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'titulZaJmenem': string;
    /**
     * Datum narození fyzické osoby
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaRzp
     */
    'datumNarozeni': Date;
}
/**
 * 
 * @export
 * @interface APISharedLibsAngazovanaOsobaSzrZaklad
 */
export interface APISharedLibsAngazovanaOsobaSzrZaklad {
    [key: string]: any;

    /**
     * Typ angažmá osoby  - kód (ciselnikKod: TypAngazma)
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaSzrZaklad
     */
    'typAngazma': string;
    /**
     * Jméno fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaSzrZaklad
     */
    'jmeno': string;
    /**
     * Příjmení fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaSzrZaklad
     */
    'prijmeni': string;
    /**
     * Titul před jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaSzrZaklad
     */
    'titulPredJmenem': string;
    /**
     * Titul za jménem fyzické osoby
     * @type {string}
     * @memberof APISharedLibsAngazovanaOsobaSzrZaklad
     */
    'titulZaJmenem': string;
    /**
     * Datum narození fyzické osoby
     * @type {Date}
     * @memberof APISharedLibsAngazovanaOsobaSzrZaklad
     */
    'datumNarozeni': Date;
}
/**
 * 
 * @export
 * @interface APISharedLibsAngazovanySubjektAdresa
 */
export interface APISharedLibsAngazovanySubjektAdresa {
    [key: string]: any;

    /**
     * Platnost adresy od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'platnostOd': Date;
    /**
     * Platnost adresy do data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'platnostDo': Date;
    /**
     * Kód státu (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodStatu': string;
    /**
     * Název státu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevStatu': string;
    /**
     * Kód kraje
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodKraje': number;
    /**
     * Název kraje
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevKraje': string;
    /**
     * Kód okresu
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodOkresu': number;
    /**
     * Název okresu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevOkresu': string;
    /**
     * Kód obce
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodObce': number;
    /**
     * Název obce
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevObce': string;
    /**
     * Kód správního obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodSpravnihoObvodu': number;
    /**
     * Název správního obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevSpravnihoObvodu': string;
    /**
     * Kód městského obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodMestskehoObvodu': number;
    /**
     * Název městského obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevMestskehoObvodu': string;
    /**
     * Kód městské části statutárního města
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodMestskeCastiObvodu': number;
    /**
     * Kód ulice, veřejného prostranství ze zdroje
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodUlice': number;
    /**
     * Název městské části statutárního města
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevMestskeCastiObvodu': string;
    /**
     * Název ulice, veřejného prostranství
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevUlice': string;
    /**
     * Číslo domovní
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'cisloDomovni': number;
    /**
     * Doplňující informace adresního popisu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'doplnekAdresy': string;
    /**
     * Kód časti obce
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodCastiObce': number;
    /**
     * Číslo orientační - číselná část
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'cisloOrientacni': number;
    /**
     * Číslo orientační - písmenná část
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'cisloOrientacniPismeno': string;
    /**
     * Název části obce
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'nazevCastiObce': string;
    /**
     * Kód adresního místa
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'kodAdresnihoMista': number;
    /**
     * Poštovní směrovací číslo adresní pošty
     * @type {number}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'psc': number;
    /**
     * Nestrukturovaná adresa (formátovaná adresa)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'textovaAdresa': string;
    /**
     * Nestrukturované číslo/a použíté v adrese
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'cisloDoAdresy': string;
    /**
     * Typ čísla domu (ciselnikKod: TypCislaDomovniho)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'typCisloDomovni': string;
    /**
     * Stav standardizace adresy dle RÚIAN
     * @type {boolean}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'standardizaceAdresy': boolean;
    /**
     * Psč zahraničních nebo nestandardně definovaných čísel
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektAdresa
     */
    'pscTxt': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsAngazovanySubjektRcns
 */
export interface APISharedLibsAngazovanySubjektRcns {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsAngazovanaOsobaRcns>}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'statutarniOrgany': Array<APISharedLibsAngazovanaOsobaRcns>;
    /**
     * 
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'ico': string;
    /**
     * DIČ
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'dic': string;
    /**
     * Platnost záznamu od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'platnostOd': Date;
    /**
     * Platnost záznamu do data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'platnostDo': Date;
    /**
     * 
     * @type {APISharedLibsAdresaRcns}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'sidlo': APISharedLibsAdresaRcns;
    /**
     * Obchodní jméno subjektu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'obchodniJmeno': string;
    /**
     * Kód státu  (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'kodStatu': string;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcns
     */
    'pravniForma': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsAngazovanySubjektRcnsZaklad
 */
export interface APISharedLibsAngazovanySubjektRcnsZaklad {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcnsZaklad
     */
    'ico': string;
    /**
     * DIČ
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcnsZaklad
     */
    'dic': string;
    /**
     * Platnost záznamu od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRcnsZaklad
     */
    'platnostOd': Date;
    /**
     * Platnost záznamu do data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRcnsZaklad
     */
    'platnostDo': Date;
    /**
     * 
     * @type {APISharedLibsAdresaRcns}
     * @memberof APISharedLibsAngazovanySubjektRcnsZaklad
     */
    'sidlo': APISharedLibsAdresaRcns;
    /**
     * Obchodní jméno subjektu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcnsZaklad
     */
    'obchodniJmeno': string;
    /**
     * Kód státu  (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcnsZaklad
     */
    'kodStatu': string;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRcnsZaklad
     */
    'pravniForma': string;
}
/**
 * Detailní informace o ekonomickém subjektu ze zdroje RŠ
 * @export
 * @interface APISharedLibsAngazovanySubjektRs
 */
export interface APISharedLibsAngazovanySubjektRs {
    [key: string]: any;

    /**
     * IČO
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRs
     */
    'ico': string;
    /**
     * Jméno subjektu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRs
     */
    'obchodniJmeno': string;
    /**
     * Zkrácené jméno subjektu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRs
     */
    'obchodniJmenoZkracene': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRs
     */
    'typAngazma': string;
    /**
     * 
     * @type {APISharedLibsAngazovanySubjektRsAdresa}
     * @memberof APISharedLibsAngazovanySubjektRs
     */
    'adresa': APISharedLibsAngazovanySubjektRsAdresa;
    /**
     * Právní forma
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRs
     */
    'pravniForma': string;
    /**
     * Datum vzniku
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRs
     */
    'datumVzniku': Date;
    /**
     * Datum zániku
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRs
     */
    'datumZaniku': Date;
}
/**
 * @type APISharedLibsAngazovanySubjektRsAdresa
 * Adresa angažovaného subjektu
 * @export
 */
export type APISharedLibsAngazovanySubjektRsAdresa = APISharedLibsAdresa | APISharedLibsAdresaCeu | APISharedLibsAdresaRcns | APISharedLibsAngazovanySubjektAdresa | APISharedLibsEkonomickySubjektRzpAdresa;

/**
 * Právnické osoby v angažmá ekonomického subjektu.
 * @export
 * @interface APISharedLibsAngazovanySubjektRzp
 */
export interface APISharedLibsAngazovanySubjektRzp {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsAngazovanaOsobaRzp>}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'osobyZastupce': Array<APISharedLibsAngazovanaOsobaRzp>;
    /**
     * Typ angažmá osoby u subjektu ve zdroji RŽP (Registr živnostenského podnikání) - kód (ciselnikKod: TypAngazma, zdroj: rzp)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'typAngazma': string;
    /**
     * Platnost angažmá subjektu od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'platnostOd': Date;
    /**
     * Platnost angažmá subjektu do data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'platnostDo': Date;
    /**
     * Ičo angažovaného subjektu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'ico': string;
    /**
     * obchodní jméno angažovaného subjektu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsAngazovanySubjektAdresa}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'sidlo': APISharedLibsAngazovanySubjektAdresa;
    /**
     * Typ subjektu - kód (ciselnikKod: TypSubjektu, zdroj: rzp)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'typSubjektu': string;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj:com, res)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'pravniForma': string;
    /**
     * Kód státu (ciselnikKod: Stat, zdroj:com)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzp
     */
    'kodStatu': string;
}
/**
 * Právnické osoby v angažmá ekonomického subjektu.
 * @export
 * @interface APISharedLibsAngazovanySubjektRzpZaklad
 */
export interface APISharedLibsAngazovanySubjektRzpZaklad {
    [key: string]: any;

    /**
     * Typ angažmá osoby u subjektu ve zdroji RŽP (Registr živnostenského podnikání) - kód (ciselnikKod: TypAngazma, zdroj: rzp)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'typAngazma': string;
    /**
     * Platnost angažmá subjektu od data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'platnostOd': Date;
    /**
     * Platnost angažmá subjektu do data
     * @type {Date}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'platnostDo': Date;
    /**
     * Ičo angažovaného subjektu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'ico': string;
    /**
     * obchodní jméno angažovaného subjektu
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsAngazovanySubjektAdresa}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'sidlo': APISharedLibsAngazovanySubjektAdresa;
    /**
     * Typ subjektu - kód (ciselnikKod: TypSubjektu, zdroj: rzp)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'typSubjektu': string;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj:com, res)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'pravniForma': string;
    /**
     * Kód státu (ciselnikKod: Stat, zdroj:com)
     * @type {string}
     * @memberof APISharedLibsAngazovanySubjektRzpZaklad
     */
    'kodStatu': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsClenSvazu
 */
export interface APISharedLibsClenSvazu {
    [key: string]: any;

    /**
     * IČO člana svazu
     * @type {string}
     * @memberof APISharedLibsClenSvazu
     */
    'ico': string;
    /**
     * Platnost členství od data
     * @type {Date}
     * @memberof APISharedLibsClenSvazu
     */
    'platnostOd': Date;
    /**
     * Platnost členství do data
     * @type {Date}
     * @memberof APISharedLibsClenSvazu
     */
    'platnostDo': Date;
}
/**
 * Základní informace o ekonomickém subjektu
 * @export
 * @interface APISharedLibsEkonomickySubjekt
 */
export interface APISharedLibsEkonomickySubjekt {
    [key: string]: any;

    /**
     * Ičo ekonomického subjektu, pokud je ičo přidělené. Id ekonomického subjektu, pokud je ičo nepřidělené.
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'icoId': string;
    /**
     * 
     * @type {APISharedLibsAdresaDorucovaci}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'adresaDorucovaci': APISharedLibsAdresaDorucovaci;
    /**
     * 
     * @type {APISharedLibsSeznamRegistraci}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'seznamRegistraci': APISharedLibsSeznamRegistraci;
    /**
     * Identifikace primárního zdroje dat.
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'primarniZdroj': string;
    /**
     * 
     * @type {Array<APISharedLibsEkonomickySubjektDalsiUdaje>}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'dalsiUdaje': Array<APISharedLibsEkonomickySubjektDalsiUdaje>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'czNace': Array<string>;
    /**
     * Indeftifikátor sub-registru zdroje SZR - kód (ciselnikKod: SubRegistrSzr, zdroj:com)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'subRegistrSzr': string;
    /**
     * Daňové identifikační číslo skupiny plátce DPH ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'dicSkDph': string;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjekt
     */
    'dic': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsEkonomickySubjektCeuZaklad
 */
export interface APISharedLibsEkonomickySubjektCeuZaklad {
    [key: string]: any;

    /**
     * Typ subjektu  (ciselnikKod: TypSubjektu, zdroj: Ceu)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'typSubjektu': string;
    /**
     * 
     * @type {Array<APISharedLibsAdresaCeu>}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'adresy': Array<APISharedLibsAdresaCeu>;
    /**
     * Jméno, příjmení fyzické osoby
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'jmenoPrijmeni': string;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektCeuZaklad
     */
    'dic': string;
}
/**
 * Další údaje o ekonomickém subjektu
 * @export
 * @interface APISharedLibsEkonomickySubjektDalsiUdaje
 */
export interface APISharedLibsEkonomickySubjektDalsiUdaje {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsObchodniJmenoAres>}
     * @memberof APISharedLibsEkonomickySubjektDalsiUdaje
     */
    'obchodniJmeno': Array<APISharedLibsObchodniJmenoAres>;
    /**
     * 
     * @type {Array<APISharedLibsAdresaAres>}
     * @memberof APISharedLibsEkonomickySubjektDalsiUdaje
     */
    'sidlo': Array<APISharedLibsAdresaAres>;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektDalsiUdaje
     */
    'pravniForma': string;
    /**
     * Aktuální spisová značka ve tvaru ODDIL xx/SOUD (např. B 100/MSPH) - poskytováno pouze pro zdroj: Veřejné rejstříky
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektDalsiUdaje
     */
    'spisovaZnacka': string;
    /**
     * Identifikace primárního zdroje dat - kód (ciselnikKod: TypZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektDalsiUdaje
     */
    'datovyZdroj': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsEkonomickySubjektEzpZaklad
 */
export interface APISharedLibsEkonomickySubjektEzpZaklad {
    [key: string]: any;

    /**
     * URL odkaz na záznam zdrojového IS.
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'odkaz': string;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektEzpZaklad
     */
    'dic': string;
}
/**
 * Vazební tabulka adres
 * @export
 * @interface APISharedLibsEkonomickySubjektRzpAdresa
 */
export interface APISharedLibsEkonomickySubjektRzpAdresa {
    [key: string]: any;

    /**
     * Platnost adresy od data
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'platnostOd': Date;
    /**
     * Platnost adresy do data
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'platnostDo': Date;
    /**
     * Typ adresy  - kód (ciselnikKod: TypAdresy, zdroj: rzp)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'typAdresy': string;
    /**
     * Kód státu (ciselnikKod: Stat)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodStatu': string;
    /**
     * Název státu
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevStatu': string;
    /**
     * Kód kraje
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodKraje': number;
    /**
     * Název kraje
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevKraje': string;
    /**
     * Kód okresu
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodOkresu': number;
    /**
     * Název okresu
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevOkresu': string;
    /**
     * Kód obce
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodObce': number;
    /**
     * Název obce
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevObce': string;
    /**
     * Kód správního obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodSpravnihoObvodu': number;
    /**
     * Název správního obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevSpravnihoObvodu': string;
    /**
     * Kód městského obvodu Prahy
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodMestskehoObvodu': number;
    /**
     * Název městského obvodu Prahy
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevMestskehoObvodu': string;
    /**
     * Kód městské části statutárního města
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodMestskeCastiObvodu': number;
    /**
     * Kód ulice, veřejného prostranství ze zdroje
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodUlice': number;
    /**
     * Název městské části statutárního města
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevMestskeCastiObvodu': string;
    /**
     * Název ulice, veřejného prostranství
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevUlice': string;
    /**
     * Číslo domovní
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'cisloDomovni': number;
    /**
     * Doplňující informace adresního popisu
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'doplnekAdresy': string;
    /**
     * Kód časti obce
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodCastiObce': number;
    /**
     * Číslo orientační - číselná část
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'cisloOrientacni': number;
    /**
     * Číslo orientační - písmenná část
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'cisloOrientacniPismeno': string;
    /**
     * Název části obce
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'nazevCastiObce': string;
    /**
     * Kód adresního místa
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'kodAdresnihoMista': number;
    /**
     * Poštovní směrovací číslo adresní pošty
     * @type {number}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'psc': number;
    /**
     * Nestrukturovaná adresa (formátovaná adresa)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'textovaAdresa': string;
    /**
     * Nestrukturované číslo/a použíté v adrese
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'cisloDoAdresy': string;
    /**
     * Typ čísla domu (ciselnikKod: TypCislaDomovniho)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'typCisloDomovni': string;
    /**
     * Stav standardizace adresy dle RÚIAN
     * @type {boolean}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'standardizaceAdresy': boolean;
    /**
     * Psč zahraničních nebo nestandardně definovaných čísel
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektRzpAdresa
     */
    'pscTxt': string;
}
/**
 * Základní informace o ekonomickém subjektu - obecný předek
 * @export
 * @interface APISharedLibsEkonomickySubjektZaklad
 */
export interface APISharedLibsEkonomickySubjektZaklad {
    [key: string]: any;

    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsEkonomickySubjektZaklad
     */
    'dic': string;
}
/**
 * @type APISharedLibsEkonomickySubjektZakladSidlo
 * Sídlo ekonomického subjektu
 * @export
 */
export type APISharedLibsEkonomickySubjektZakladSidlo = APISharedLibsAdresa | APISharedLibsAdresaCeu | APISharedLibsAdresaRcns | APISharedLibsAngazovanySubjektAdresa | APISharedLibsEkonomickySubjektRzpAdresa;

/**
 * Události v rámci insolvenčního řízení
 * @export
 * @interface APISharedLibsInsolvencniRizeni
 */
export interface APISharedLibsInsolvencniRizeni {
    [key: string]: any;

    /**
     * Datum zápisu události
     * @type {Date}
     * @memberof APISharedLibsInsolvencniRizeni
     */
    'datumZapisu': Date;
    /**
     * Datum zplatnění události
     * @type {Date}
     * @memberof APISharedLibsInsolvencniRizeni
     */
    'platnostOd': Date;
}
/**
 * 
 * @export
 * @interface APISharedLibsKontakty
 */
export interface APISharedLibsKontakty {
    [key: string]: any;

    /**
     * Email zdravotnického zařízení
     * @type {string}
     * @memberof APISharedLibsKontakty
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLibsKontakty
     */
    'fax': string;
    /**
     * Telefoní kontakt
     * @type {string}
     * @memberof APISharedLibsKontakty
     */
    'telefon': string;
    /**
     * WWW zdravotnického zařízení
     * @type {string}
     * @memberof APISharedLibsKontakty
     */
    'www': string;
}
/**
 * Kontakty subjektu
 * @export
 * @interface APISharedLibsKontaktyRs
 */
export interface APISharedLibsKontaktyRs {
    [key: string]: any;

    /**
     * kontaktní telefon
     * @type {string}
     * @memberof APISharedLibsKontaktyRs
     */
    'telefon': string;
    /**
     * číslo faxu
     * @type {string}
     * @memberof APISharedLibsKontaktyRs
     */
    'fax': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLibsKontaktyRs
     */
    'email': Array<string>;
    /**
     * webová adresa ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsKontaktyRs
     */
    'www': string;
}
/**
 * Obchodní jméno s platností
 * @export
 * @interface APISharedLibsObchodniJmenoAres
 */
export interface APISharedLibsObchodniJmenoAres {
    [key: string]: any;

    /**
     * Platnost údaje od data
     * @type {Date}
     * @memberof APISharedLibsObchodniJmenoAres
     */
    'platnostOd': Date;
    /**
     * Platnost údaje do data
     * @type {Date}
     * @memberof APISharedLibsObchodniJmenoAres
     */
    'platnostDo': Date;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsObchodniJmenoAres
     */
    'obchodniJmeno': string;
    /**
     * Primární záznam
     * @type {boolean}
     * @memberof APISharedLibsObchodniJmenoAres
     */
    'primarniZaznam': boolean;
}
/**
 * Oprávnění k výkonu zvláštních práv církve
 * @export
 * @interface APISharedLibsPravoZvlastni
 */
export interface APISharedLibsPravoZvlastni {
    [key: string]: any;

    /**
     * Začátek platnosti zvláštního práva subjektu
     * @type {Date}
     * @memberof APISharedLibsPravoZvlastni
     */
    'platnostOd': Date;
    /**
     * Konec platnosti zvláštního práva subjektu
     * @type {Date}
     * @memberof APISharedLibsPravoZvlastni
     */
    'platnostDo': Date;
    /**
     * Oprávnění pro výkon církve - kód (ciselnikKod: Pravo, zdroj: rcns)
     * @type {number}
     * @memberof APISharedLibsPravoZvlastni
     */
    'kodPravo': number;
}
/**
 * 
 * @export
 * @interface APISharedLibsProvozovna
 */
export interface APISharedLibsProvozovna {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsZivnostOborCinnosti>}
     * @memberof APISharedLibsProvozovna
     */
    'oboryCinnosti': Array<APISharedLibsZivnostOborCinnosti>;
    /**
     * 
     * @type {APISharedLibsProvozovnaZakladSidloProvozovny}
     * @memberof APISharedLibsProvozovna
     */
    'sidloProvozovny': APISharedLibsProvozovnaZakladSidloProvozovny;
    /**
     * Umístění provozovny
     * @type {string}
     * @memberof APISharedLibsProvozovna
     */
    'umisteniProvozovny': string;
    /**
     * Platnost provozovny od data
     * @type {Date}
     * @memberof APISharedLibsProvozovna
     */
    'platnostOd': Date;
    /**
     * Platnost provozovny do data
     * @type {Date}
     * @memberof APISharedLibsProvozovna
     */
    'platnostDo': Date;
    /**
     * 
     * @type {Array<APISharedLibsZivnostProvozovnaPozastaveni>}
     * @memberof APISharedLibsProvozovna
     */
    'pozastaveniProvozovny': Array<APISharedLibsZivnostProvozovnaPozastaveni>;
    /**
     * Typ provozovny - kód (ciselnikKod: TypProvozovny)
     * @type {string}
     * @memberof APISharedLibsProvozovna
     */
    'typProvozovny': string;
    /**
     * Název provozovny
     * @type {string}
     * @memberof APISharedLibsProvozovna
     */
    'nazev': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsProvozovnaZaklad
 */
export interface APISharedLibsProvozovnaZaklad {
    [key: string]: any;

    /**
     * 
     * @type {APISharedLibsProvozovnaZakladSidloProvozovny}
     * @memberof APISharedLibsProvozovnaZaklad
     */
    'sidloProvozovny': APISharedLibsProvozovnaZakladSidloProvozovny;
    /**
     * Umístění provozovny
     * @type {string}
     * @memberof APISharedLibsProvozovnaZaklad
     */
    'umisteniProvozovny': string;
    /**
     * Platnost provozovny od data
     * @type {Date}
     * @memberof APISharedLibsProvozovnaZaklad
     */
    'platnostOd': Date;
    /**
     * Platnost provozovny do data
     * @type {Date}
     * @memberof APISharedLibsProvozovnaZaklad
     */
    'platnostDo': Date;
    /**
     * 
     * @type {Array<APISharedLibsZivnostProvozovnaPozastaveni>}
     * @memberof APISharedLibsProvozovnaZaklad
     */
    'pozastaveniProvozovny': Array<APISharedLibsZivnostProvozovnaPozastaveni>;
    /**
     * Typ provozovny - kód (ciselnikKod: TypProvozovny)
     * @type {string}
     * @memberof APISharedLibsProvozovnaZaklad
     */
    'typProvozovny': string;
    /**
     * Název provozovny
     * @type {string}
     * @memberof APISharedLibsProvozovnaZaklad
     */
    'nazev': string;
}
/**
 * @type APISharedLibsProvozovnaZakladSidloProvozovny
 * Adresa sídla provozovny
 * @export
 */
export type APISharedLibsProvozovnaZakladSidloProvozovny = APISharedLibsAdresa | APISharedLibsAdresaCeu | APISharedLibsAdresaRcns | APISharedLibsAngazovanySubjektAdresa | APISharedLibsEkonomickySubjektRzpAdresa;

/**
 * 
 * @export
 * @interface APISharedLibsProvozovnyRzpStav
 */
export interface APISharedLibsProvozovnyRzpStav {
    [key: string]: any;

    /**
     * Celkový počet provozoven
     * @type {number}
     * @memberof APISharedLibsProvozovnyRzpStav
     */
    'pocetCelkem': number;
    /**
     * Celkový počet zaniklých provozoven
     * @type {number}
     * @memberof APISharedLibsProvozovnyRzpStav
     */
    'pocetZaniklych': number;
    /**
     * Celkový počet aktivnich provozoven
     * @type {number}
     * @memberof APISharedLibsProvozovnyRzpStav
     */
    'pocetAktivnich': number;
    /**
     * Celkový počet zaniklých provozoven
     * @type {number}
     * @memberof APISharedLibsProvozovnyRzpStav
     */
    'pocetPozastavenych': number;
}
/**
 * 
 * @export
 * @interface APISharedLibsRegistraceRcns
 */
export interface APISharedLibsRegistraceRcns {
    [key: string]: any;

    /**
     * Pro subjekt typu církev a svaz církví je zde uvedeno registrační číslo pod kterým byl daný subjekt zaregistrován na MK. Pro subjekty typu právnická osoba je zde uvedeno evidenční číslo pod kterým byl daný subjekt zaevidován na MK.
     * @type {string}
     * @memberof APISharedLibsRegistraceRcns
     */
    'cisloRegistrace': string;
    /**
     * Datum zrušení registrace, evidence subjektu na MK
     * @type {string}
     * @memberof APISharedLibsRegistraceRcns
     */
    'cisloZruseniRegistrace': string;
    /**
     * Datum vyhlášení likvidace subjektu
     * @type {Date}
     * @memberof APISharedLibsRegistraceRcns
     */
    'datumLikvidace': Date;
    /**
     * Datum vyhlášení konkurzu subjektu
     * @type {Date}
     * @memberof APISharedLibsRegistraceRcns
     */
    'datumKonkurzu': Date;
    /**
     * Datum jmenování opatrovníka
     * @type {Date}
     * @memberof APISharedLibsRegistraceRcns
     */
    'datumOpatrovnik': Date;
    /**
     * Datum zrušení registrace, evidence subjektu na MK
     * @type {Date}
     * @memberof APISharedLibsRegistraceRcns
     */
    'datumZruseniRegistrace': Date;
}
/**
 * Seznam registrací ekonomického subjektu v jednotlivých zdrojích
 * @export
 * @interface APISharedLibsSeznamRegistraci
 */
export interface APISharedLibsSeznamRegistraci {
    [key: string]: any;

    /**
     * Stav ekonomického subjektu ve zdroji VR (Veřejné rejstříky) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeVr': string;
    /**
     * Stav ekonomického subjektu ve zdroji RES (Registr ekonomických subjektů) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeRes': string;
    /**
     * Stav ekonomického subjektu ve zdroji RŽP (Registr živnostenského podnikání) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeRzp': string;
    /**
     * Stav ekonomického subjektu ve zdroji NRPZS (Národní registr poskytovatelů zdrovotnických služeb) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeNrpzs': string;
    /**
     * Stav ekonomického subjektu ve zdroji RPSH (Registr politických stran a hnutí) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeRpsh': string;
    /**
     * Stav ekonomického subjektu ve zdroji RCNS(Registr církví a náboženských společenství) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeRcns': string;
    /**
     * Stav ekonomického subjektu ve zdroji  SZR(Společný zemědělský registr) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeSzr': string;
    /**
     * Stav ekonomického subjektu ve zdroji DPH(Registr plátců daně s přidané hodnoty) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeDph': string;
    /**
     * Stav ekonomického subjektu ve zdroji SD(Registr plátců spotřební daně) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeSd': string;
    /**
     * Stav ekonomického subjektu ve zdroji ISIR(Insolvenční rejstřík) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeIr': string;
    /**
     * Stav ekonomického subjektu ve zdroji CEÚ(Centrální evidence úpadců) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeCeu': string;
    /**
     * Stav ekonomického subjektu ve zdroji RŠ(Registr škol) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeRs': string;
    /**
     * Stav ekonomického subjektu ve zdroji RED(Registr evidence dotací) - kód (ciselnikKod: StavZdroje, zdroj: com)
     * @type {string}
     * @memberof APISharedLibsSeznamRegistraci
     */
    'stavZdrojeRed': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsSkolaZarizeni
 */
export interface APISharedLibsSkolaZarizeni {
    [key: string]: any;

    /**
     * 
     * @type {APISharedLibsKontaktyRs}
     * @memberof APISharedLibsSkolaZarizeni
     */
    'kontakty': APISharedLibsKontaktyRs;
    /**
     * IZO - resortní identifikátor
     * @type {string}
     * @memberof APISharedLibsSkolaZarizeni
     */
    'izo': string;
    /**
     * Jméno subjektu
     * @type {string}
     * @memberof APISharedLibsSkolaZarizeni
     */
    'obchodniJmeno': string;
    /**
     * Zkrácené jméno subjektu
     * @type {string}
     * @memberof APISharedLibsSkolaZarizeni
     */
    'obchodniJmenoZkracene': string;
    /**
     * Typ školy
     * @type {string}
     * @memberof APISharedLibsSkolaZarizeni
     */
    'typSkoly': string;
    /**
     * 
     * @type {APISharedLibsAngazovanySubjektRsAdresa}
     * @memberof APISharedLibsSkolaZarizeni
     */
    'adresa': APISharedLibsAngazovanySubjektRsAdresa;
    /**
     * Datum vzniku
     * @type {Date}
     * @memberof APISharedLibsSkolaZarizeni
     */
    'datumVzniku': Date;
    /**
     * Datum zániku
     * @type {Date}
     * @memberof APISharedLibsSkolaZarizeni
     */
    'datumZaniku': Date;
}
/**
 * Statistické informace o subjektu
 * @export
 * @interface APISharedLibsStatistickeUdaje
 */
export interface APISharedLibsStatistickeUdaje {
    [key: string]: any;

    /**
     * Institucinální sektor dle ESA2010 - kód (ciselnikKod: FceVladnichInstituci)
     * @type {string}
     * @memberof APISharedLibsStatistickeUdaje
     */
    'institucionalniSektor2010': string;
    /**
     * Kategorie dle počtu pracovníků - kód (ciselnikKod: KategoriePoctuPracovniku, zdroj: res)
     * @type {string}
     * @memberof APISharedLibsStatistickeUdaje
     */
    'kategoriePoctuPracovniku': string;
}
/**
 * Informace o způsobu jednání právnické osoby.
 * @export
 * @interface APISharedLibsStatutarniOrgan
 */
export interface APISharedLibsStatutarniOrgan {
    [key: string]: any;

    /**
     * Platnost záznamu od data
     * @type {Date}
     * @memberof APISharedLibsStatutarniOrgan
     */
    'platnostOd': Date;
    /**
     * Texty způsobu jednání právnické osoby.
     * @type {string}
     * @memberof APISharedLibsStatutarniOrgan
     */
    'popis': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsStatutatniOrganRcns
 */
export interface APISharedLibsStatutatniOrganRcns {
    [key: string]: any;

    /**
     * 
     * @type {APISharedLibsSubjektCirkev}
     * @memberof APISharedLibsStatutatniOrganRcns
     */
    'subjektCirkev': APISharedLibsSubjektCirkev;
    /**
     * 
     * @type {APISharedLibsSubjektSvazCirkvi}
     * @memberof APISharedLibsStatutatniOrganRcns
     */
    'subjektSvazCirkvi': APISharedLibsSubjektSvazCirkvi;
    /**
     * 
     * @type {APISharedLibsSubjektPravnickaOsoba}
     * @memberof APISharedLibsStatutatniOrganRcns
     */
    'subjektPravnickaOsoba': APISharedLibsSubjektPravnickaOsoba;
}
/**
 * Stav, ve kterém se subjekt nachází, s udáním počátku platnosti.
 * @export
 * @interface APISharedLibsStavSubjektu
 */
export interface APISharedLibsStavSubjektu {
    [key: string]: any;

    /**
     * Popis stavu subjektu
     * @type {string}
     * @memberof APISharedLibsStavSubjektu
     */
    'popis': string;
    /**
     * Platnost záznamu od data
     * @type {Date}
     * @memberof APISharedLibsStavSubjektu
     */
    'platnostOd': Date;
    /**
     * Stav ekonomického subjektu - kód (ciselnikKod: StavSubjektu(zdroj:rpsh)
     * @type {string}
     * @memberof APISharedLibsStavSubjektu
     */
    'stavSubjektu': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsSubjektCirkev
 */
export interface APISharedLibsSubjektCirkev {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsAngazovanySubjektRcns>}
     * @memberof APISharedLibsSubjektCirkev
     */
    'organy': Array<APISharedLibsAngazovanySubjektRcns>;
    /**
     * Datum registrace práv dané církvi.
     * @type {Date}
     * @memberof APISharedLibsSubjektCirkev
     */
    'datumRegistracePrav': Date;
    /**
     * Číslo registrace práv dané církvi.
     * @type {string}
     * @memberof APISharedLibsSubjektCirkev
     */
    'cisloRegistracePrav': string;
    /**
     * IČO nástupce zrušené právnické osoby.
     * @type {string}
     * @memberof APISharedLibsSubjektCirkev
     */
    'icoNastupce': string;
    /**
     * Datum zrušení registrace práv dané církvi.
     * @type {Date}
     * @memberof APISharedLibsSubjektCirkev
     */
    'datumZruseniRegistracePrav': Date;
    /**
     * 
     * @type {Array<APISharedLibsPravoZvlastni>}
     * @memberof APISharedLibsSubjektCirkev
     */
    'pravoZvlastni': Array<APISharedLibsPravoZvlastni>;
    /**
     * Číslo zrušení registrace práv dané církvi.
     * @type {string}
     * @memberof APISharedLibsSubjektCirkev
     */
    'cisloZruseniRegistracePrav': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsSubjektCirkevZaklad
 */
export interface APISharedLibsSubjektCirkevZaklad {
    [key: string]: any;

    /**
     * Datum registrace práv dané církvi.
     * @type {Date}
     * @memberof APISharedLibsSubjektCirkevZaklad
     */
    'datumRegistracePrav': Date;
    /**
     * Číslo registrace práv dané církvi.
     * @type {string}
     * @memberof APISharedLibsSubjektCirkevZaklad
     */
    'cisloRegistracePrav': string;
    /**
     * IČO nástupce zrušené právnické osoby.
     * @type {string}
     * @memberof APISharedLibsSubjektCirkevZaklad
     */
    'icoNastupce': string;
    /**
     * Datum zrušení registrace práv dané církvi.
     * @type {Date}
     * @memberof APISharedLibsSubjektCirkevZaklad
     */
    'datumZruseniRegistracePrav': Date;
    /**
     * 
     * @type {Array<APISharedLibsPravoZvlastni>}
     * @memberof APISharedLibsSubjektCirkevZaklad
     */
    'pravoZvlastni': Array<APISharedLibsPravoZvlastni>;
    /**
     * Číslo zrušení registrace práv dané církvi.
     * @type {string}
     * @memberof APISharedLibsSubjektCirkevZaklad
     */
    'cisloZruseniRegistracePrav': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsSubjektPravnickaOsoba
 */
export interface APISharedLibsSubjektPravnickaOsoba {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsAngazovanaOsobaRcns>}
     * @memberof APISharedLibsSubjektPravnickaOsoba
     */
    'organy': Array<APISharedLibsAngazovanaOsobaRcns>;
    /**
     * IČO zřizovatele právnické osoby.
     * @type {string}
     * @memberof APISharedLibsSubjektPravnickaOsoba
     */
    'icoZrizovatel': string;
    /**
     * IČO nástupce zrušené právnické osoby.
     * @type {string}
     * @memberof APISharedLibsSubjektPravnickaOsoba
     */
    'icoNastupce': string;
    /**
     * Způsob zruseni registrace - kód
     * @type {number}
     * @memberof APISharedLibsSubjektPravnickaOsoba
     */
    'zpusobZruseniRegistrace': number;
}
/**
 * 
 * @export
 * @interface APISharedLibsSubjektPravnickaOsobaZaklad
 */
export interface APISharedLibsSubjektPravnickaOsobaZaklad {
    [key: string]: any;

    /**
     * IČO zřizovatele právnické osoby.
     * @type {string}
     * @memberof APISharedLibsSubjektPravnickaOsobaZaklad
     */
    'icoZrizovatel': string;
    /**
     * IČO nástupce zrušené právnické osoby.
     * @type {string}
     * @memberof APISharedLibsSubjektPravnickaOsobaZaklad
     */
    'icoNastupce': string;
    /**
     * Způsob zruseni registrace - kód
     * @type {number}
     * @memberof APISharedLibsSubjektPravnickaOsobaZaklad
     */
    'zpusobZruseniRegistrace': number;
}
/**
 * 
 * @export
 * @interface APISharedLibsSubjektSvazCirkvi
 */
export interface APISharedLibsSubjektSvazCirkvi {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsAngazovanySubjektRcns>}
     * @memberof APISharedLibsSubjektSvazCirkvi
     */
    'organy': Array<APISharedLibsAngazovanySubjektRcns>;
    /**
     * 
     * @type {Array<APISharedLibsClenSvazu>}
     * @memberof APISharedLibsSubjektSvazCirkvi
     */
    'clenoveSvazu': Array<APISharedLibsClenSvazu>;
    /**
     * IČO nástupce zrušené právnické osoby.
     * @type {string}
     * @memberof APISharedLibsSubjektSvazCirkvi
     */
    'icoNastupce': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsSubjektSvazCirkviZaklad
 */
export interface APISharedLibsSubjektSvazCirkviZaklad {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsClenSvazu>}
     * @memberof APISharedLibsSubjektSvazCirkviZaklad
     */
    'clenoveSvazu': Array<APISharedLibsClenSvazu>;
    /**
     * IČO nástupce zrušené právnické osoby.
     * @type {string}
     * @memberof APISharedLibsSubjektSvazCirkviZaklad
     */
    'icoNastupce': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsUpadekCeu
 */
export interface APISharedLibsUpadekCeu {
    [key: string]: any;

    /**
     * Podnět
     * @type {string}
     * @memberof APISharedLibsUpadekCeu
     */
    'podnet': string;
    /**
     * Spisová značka
     * @type {string}
     * @memberof APISharedLibsUpadekCeu
     */
    'spisZn': string;
    /**
     * Datum
     * @type {Date}
     * @memberof APISharedLibsUpadekCeu
     */
    'datum': Date;
    /**
     * Odkaz na detail úpadku
     * @type {string}
     * @memberof APISharedLibsUpadekCeu
     */
    'detail': string;
    /**
     * Odkaz na usnesení
     * @type {string}
     * @memberof APISharedLibsUpadekCeu
     */
    'usneseni': string;
    /**
     * Akce úpadku
     * @type {string}
     * @memberof APISharedLibsUpadekCeu
     */
    'akceUpadek': string;
    /**
     * Typ úpadku
     * @type {string}
     * @memberof APISharedLibsUpadekCeu
     */
    'typUpadek': string;
    /**
     * Soud rozhodující o úpadku
     * @type {string}
     * @memberof APISharedLibsUpadekCeu
     */
    'soudUpadek': string;
}
/**
 * Tabulka úpadků
 * @export
 * @interface APISharedLibsUpadekCeuVerejny
 */
export interface APISharedLibsUpadekCeuVerejny {
    [key: string]: any;

    /**
     * 
     * @type {APISharedLibsAngazovanaOsobaCeu}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'spravceUpadku': APISharedLibsAngazovanaOsobaCeu;
    /**
     * Podnět
     * @type {string}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'podnet': string;
    /**
     * Spisová značka
     * @type {string}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'spisZn': string;
    /**
     * Datum
     * @type {Date}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'datum': Date;
    /**
     * Odkaz na detail úpadku
     * @type {string}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'detail': string;
    /**
     * Odkaz na usnesení
     * @type {string}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'usneseni': string;
    /**
     * Akce úpadku
     * @type {string}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'akceUpadek': string;
    /**
     * Typ úpadku
     * @type {string}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'typUpadek': string;
    /**
     * Soud rozhodující o úpadku
     * @type {string}
     * @memberof APISharedLibsUpadekCeuVerejny
     */
    'soudUpadek': string;
}
/**
 * Detailní informace o ekonomickém subjektu ze zdroje CEÚ
 * @export
 * @interface APISharedLibsZaznamCeu
 */
export interface APISharedLibsZaznamCeu {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsUpadekCeuVerejny>}
     * @memberof APISharedLibsZaznamCeu
     */
    'upadek': Array<APISharedLibsUpadekCeuVerejny>;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamCeu
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamCeu
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamCeu
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamCeu
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamCeu
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamCeu
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamCeu
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamCeu
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamCeu
     */
    'dic': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsZaznamNrpzs
 */
export interface APISharedLibsZaznamNrpzs {
    [key: string]: any;

    /**
     * Pořadové číslo zařízení
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'poradoveCisloZar': string;
    /**
     * Pořadové číslo pracovistě
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'poradoveCisloPrac': string;
    /**
     * Typ ekonomického subjektu - forma hospodaření - kód (ciselnikKod: TypSubjektu, zdroj: nrpzs)
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'typSubjektu': string;
    /**
     * Druh zdravotnického zařízení - kód (ciselnikKod: DruhZarizeni, zdroj: nrpzs)
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'druhZarizeni': string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'primarniZaznam': boolean;
    /**
     * Typ zřizovatele zdravotnického zařízení - kód (ciselnikKod: Zrizovatel, zdroj: nrpzs)
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'typZrizovatele': string;
    /**
     * 
     * @type {Array<APISharedLibsAngazovanaOsobaNrpzs>}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'angazovaneOsoby': Array<APISharedLibsAngazovanaOsobaNrpzs>;
    /**
     * 
     * @type {APISharedLibsKontakty}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'kontakty': APISharedLibsKontakty;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamNrpzs
     */
    'dic': string;
}
/**
 * Detailní informace o ekonomickém subjektu ze zdroje RCNS
 * @export
 * @interface APISharedLibsZaznamRcns
 */
export interface APISharedLibsZaznamRcns {
    [key: string]: any;

    /**
     * 
     * @type {APISharedLibsStatutatniOrganRcns}
     * @memberof APISharedLibsZaznamRcns
     */
    'statutarniOrgan': APISharedLibsStatutatniOrganRcns;
    /**
     * 
     * @type {Array<APISharedLibsAngazmaRcns>}
     * @memberof APISharedLibsZaznamRcns
     */
    'likvidatori': Array<APISharedLibsAngazmaRcns>;
    /**
     * 
     * @type {Array<APISharedLibsAngazmaRcns>}
     * @memberof APISharedLibsZaznamRcns
     */
    'konkurzniSpravci': Array<APISharedLibsAngazmaRcns>;
    /**
     * 
     * @type {Array<APISharedLibsAngazmaRcns>}
     * @memberof APISharedLibsZaznamRcns
     */
    'opatrovnici': Array<APISharedLibsAngazmaRcns>;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamRcns
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRcns
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamRcns
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamRcns
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamRcns
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRcns
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRcns
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamRcns
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamRcns
     */
    'dic': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsZaznamRcnsZaklad
 */
export interface APISharedLibsZaznamRcnsZaklad {
    [key: string]: any;

    /**
     * Typ subjektu - kód (ciselnikKod: TypSubjektuRcns)
     * @type {string}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'typSubjektu': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'stat': string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'primarniZaznam': boolean;
    /**
     * 
     * @type {APISharedLibsRegistraceRcns}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'registrace': APISharedLibsRegistraceRcns;
    /**
     * 
     * @type {Array<APISharedLibsZpusobJednani>}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'zpusobJednani': Array<APISharedLibsZpusobJednani>;
    /**
     * 
     * @type {Array<APISharedLibsAdresaRcns>}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'adresySubjektu': Array<APISharedLibsAdresaRcns>;
    /**
     * Identifikátor záznamu ve zdrojovém registru.
     * @type {string}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'zdrojId': string;
    /**
     * Platnost subjekt v registru od
     * @type {Date}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'platnostOd': Date;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamRcnsZaklad
     */
    'dic': string;
}
/**
 * Detailní informace o ekonomickém subjektu ze zdroje RES
 * @export
 * @interface APISharedLibsZaznamRes
 */
export interface APISharedLibsZaznamRes {
    [key: string]: any;

    /**
     * Právní forma ROS - kód (ciselnikKod: PravniFormaRos, zdroj:res)
     * @type {string}
     * @memberof APISharedLibsZaznamRes
     */
    'pravniFormaRos': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLibsZaznamRes
     */
    'czNace': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedLibsZaznamRes
     */
    'doplnkovePravniFormy': Array<string>;
    /**
     * 
     * @type {APISharedLibsStatistickeUdaje}
     * @memberof APISharedLibsZaznamRes
     */
    'statistickeUdaje': APISharedLibsStatistickeUdaje;
    /**
     * Základní územní jednotka sídla organizace - kód (ciselnikKod: ZakladniUzemniJednotka)
     * @type {string}
     * @memberof APISharedLibsZaznamRes
     */
    'zakladniUzemniJednotka': string;
    /**
     * Logická informace o primárním(hlavním) záznamu ekonomického subjektu.
     * @type {boolean}
     * @memberof APISharedLibsZaznamRes
     */
    'primarniZaznam': boolean;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamRes
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRes
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamRes
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamRes
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamRes
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRes
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRes
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamRes
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamRes
     */
    'dic': string;
}
/**
 * Detailní informace o ekonomickém subjektu ze zdroje RPSH
 * @export
 * @interface APISharedLibsZaznamRpsh
 */
export interface APISharedLibsZaznamRpsh {
    [key: string]: any;

    /**
     * Číslo registrace
     * @type {string}
     * @memberof APISharedLibsZaznamRpsh
     */
    'cisloRegistrace': string;
    /**
     * Typ subjektu - strana/hnutí - kód (ciselnikKod: TypSubjektuRpsh)
     * @type {string}
     * @memberof APISharedLibsZaznamRpsh
     */
    'typSubjektu': string;
    /**
     * Obchodní jméno zkrácené
     * @type {string}
     * @memberof APISharedLibsZaznamRpsh
     */
    'obchodniJmenoZkratka': string;
    /**
     * 
     * @type {Array<APISharedLibsAngazovanaOsobaRpsh>}
     * @memberof APISharedLibsZaznamRpsh
     */
    'angazovaneOsoby': Array<APISharedLibsAngazovanaOsobaRpsh>;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLibsZaznamRpsh
     */
    'primarniZaznam': boolean;
    /**
     * 
     * @type {Array<APISharedLibsZmenaStanov>}
     * @memberof APISharedLibsZaznamRpsh
     */
    'zmenaStanov': Array<APISharedLibsZmenaStanov>;
    /**
     * 
     * @type {Array<APISharedLibsStatutarniOrgan>}
     * @memberof APISharedLibsZaznamRpsh
     */
    'statutarniOrgan': Array<APISharedLibsStatutarniOrgan>;
    /**
     * 
     * @type {Array<APISharedLibsStavSubjektu>}
     * @memberof APISharedLibsZaznamRpsh
     */
    'stavSubjektu': Array<APISharedLibsStavSubjektu>;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamRpsh
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRpsh
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamRpsh
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamRpsh
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamRpsh
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRpsh
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRpsh
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamRpsh
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamRpsh
     */
    'dic': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsZaznamRs
 */
export interface APISharedLibsZaznamRs {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsAngazovanySubjektRs>}
     * @memberof APISharedLibsZaznamRs
     */
    'angazovanySubjekt': Array<APISharedLibsAngazovanySubjektRs>;
    /**
     * 
     * @type {Array<APISharedLibsAngazovanaOsobaRs>}
     * @memberof APISharedLibsZaznamRs
     */
    'angazovanaOsoba': Array<APISharedLibsAngazovanaOsobaRs>;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamRs
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRs
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamRs
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamRs
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamRs
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRs
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRs
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamRs
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamRs
     */
    'dic': string;
}
/**
 * Detailní informace o ekonomickém subjektu ze zdroje RŠ
 * @export
 * @interface APISharedLibsZaznamRsZaklad
 */
export interface APISharedLibsZaznamRsZaklad {
    [key: string]: any;

    /**
     * REDIZO - resortní identifikátor
     * @type {string}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'redizo': string;
    /**
     * Zkrácené obchodní jméno
     * @type {string}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'obchodniJmenoZkracene': string;
    /**
     * 
     * @type {APISharedLibsKontaktyRs}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'kontakty': APISharedLibsKontaktyRs;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'primarniZaznam': boolean;
    /**
     * 
     * @type {Array<APISharedLibsSkolaZarizeni>}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'skolyAZarizeni': Array<APISharedLibsSkolaZarizeni>;
    /**
     * Typ subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'typSubjektu': string;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamRsZaklad
     */
    'dic': string;
}
/**
 * Detailní informace o ekonomickém subjektu ze zdroje RŽP
 * @export
 * @interface APISharedLibsZaznamRzp
 */
export interface APISharedLibsZaznamRzp {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsAngazovanySubjektRzp>}
     * @memberof APISharedLibsZaznamRzp
     */
    'souvisejiciSubjekty': Array<APISharedLibsAngazovanySubjektRzp>;
    /**
     * 
     * @type {APISharedLibsAngazovanaOsobaRzp}
     * @memberof APISharedLibsZaznamRzp
     */
    'osobaPodnikatel': APISharedLibsAngazovanaOsobaRzp;
    /**
     * 
     * @type {Array<APISharedLibsAngazovanaOsobaRzp>}
     * @memberof APISharedLibsZaznamRzp
     */
    'angazovaneOsoby': Array<APISharedLibsAngazovanaOsobaRzp>;
    /**
     * 
     * @type {Array<APISharedLibsZivnost>}
     * @memberof APISharedLibsZaznamRzp
     */
    'zivnosti': Array<APISharedLibsZivnost>;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamRzp
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRzp
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamRzp
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamRzp
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamRzp
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRzp
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRzp
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamRzp
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamRzp
     */
    'dic': string;
}
/**
 * Detailní informace o ekonomickém subjektu ze zdroje RŽP
 * @export
 * @interface APISharedLibsZaznamRzpZaklad
 */
export interface APISharedLibsZaznamRzpZaklad {
    [key: string]: any;

    /**
     * 
     * @type {APISharedLibsInsolvencniRizeni}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'insolvencniRizeni': APISharedLibsInsolvencniRizeni;
    /**
     * Datum doručení prvního výpisu sloužícího jako průkaz živnostenského podnikání,
     * @type {Date}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'datumDoruceniVypisu': Date;
    /**
     * 
     * @type {Array<APISharedLibsEkonomickySubjektRzpAdresa>}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'adresySubjektu': Array<APISharedLibsEkonomickySubjektRzpAdresa>;
    /**
     * Typ subjektu - kód (ciselnikKod: TypSubjektu, zdroj: rzp)
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'typSubjektu': string;
    /**
     * Živnostenský úřadu - kód
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'zivnostenskyUrad': string;
    /**
     * Název organizační složky
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'organizacniSlozka': string;
    /**
     * 
     * @type {APISharedLibsZivnostiRzpStav}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'zivnostiStav': APISharedLibsZivnostiRzpStav;
    /**
     * Datum zápisu do Obchodního nebo podobného rejstříku
     * @type {Date}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'datumZapisuVr': Date;
    /**
     * 
     * @type {APISharedLibsProvozovnyRzpStav}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'provozovnyStav': APISharedLibsProvozovnyRzpStav;
    /**
     * Identifikace primárního záznamu  pozn.: U multiplicitních registrací je pouze jedna registrace primární
     * @type {boolean}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'primarniZaznam': boolean;
    /**
     * Kód státu  (ciselnikKod: Stat, zdroj:com)
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'kodStatu': string;
    /**
     * Identifikační číslo osoby - IČO
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'ico': string;
    /**
     * Obchodní jméno ekonomického subjektu
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'obchodniJmeno': string;
    /**
     * 
     * @type {APISharedLibsEkonomickySubjektZakladSidlo}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'sidlo': APISharedLibsEkonomickySubjektZakladSidlo;
    /**
     * Právní forma - kód (ciselnikKod: PravniForma, zdroj: res, com)
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'pravniForma': string;
    /**
     * Správně příslušný finanční úřad - kód (ciselnikKod: FinancniUrad, zdroj:ufo)
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'financniUrad': string;
    /**
     * Datum vzniku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'datumVzniku': Date;
    /**
     * Datum zániku ekonomického subjektu
     * @type {Date}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'datumZaniku': Date;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'datumAktualizace': Date;
    /**
     * Daňové identifikační číslo ve formátu CZNNNNNNNNNN
     * @type {string}
     * @memberof APISharedLibsZaznamRzpZaklad
     */
    'dic': string;
}
/**
 * Živnosti, které ekonomický subjekt provozuje nebo provozoval ve zdroji RŽP
 * @export
 * @interface APISharedLibsZivnost
 */
export interface APISharedLibsZivnost {
    [key: string]: any;

    /**
     * 
     * @type {Array<APISharedLibsZivnostOborCinnosti>}
     * @memberof APISharedLibsZivnost
     */
    'oboryCinnosti': Array<APISharedLibsZivnostOborCinnosti>;
    /**
     * 
     * @type {Array<APISharedLibsAngazovanaOsobaRzp>}
     * @memberof APISharedLibsZivnost
     */
    'odpovedniZastupci': Array<APISharedLibsAngazovanaOsobaRzp>;
    /**
     * 
     * @type {Array<APISharedLibsProvozovna>}
     * @memberof APISharedLibsZivnost
     */
    'provozovny': Array<APISharedLibsProvozovna>;
    /**
     * Datum vzniku živnosti
     * @type {Date}
     * @memberof APISharedLibsZivnost
     */
    'datumVzniku': Date;
    /**
     * Datum zániku živnosti
     * @type {Date}
     * @memberof APISharedLibsZivnost
     */
    'datumZaniku': Date;
    /**
     * Platnost živnosti do data
     * @type {Date}
     * @memberof APISharedLibsZivnost
     */
    'platnostDo': Date;
    /**
     * Předmět podnikáni živnosti
     * @type {string}
     * @memberof APISharedLibsZivnost
     */
    'predmetPodnikani': string;
    /**
     * 
     * @type {Array<APISharedLibsZivnostProvozovnaPozastaveni>}
     * @memberof APISharedLibsZivnost
     */
    'pozastaveniZivnosti': Array<APISharedLibsZivnostProvozovnaPozastaveni>;
    /**
     * 
     * @type {Array<APISharedLibsZivnostPodminky>}
     * @memberof APISharedLibsZivnost
     */
    'podminkyProvozovaniZivnosti': Array<APISharedLibsZivnostPodminky>;
    /**
     * 
     * @type {Array<APISharedLibsZivnostPreruseni>}
     * @memberof APISharedLibsZivnost
     */
    'preruseniZivnosti': Array<APISharedLibsZivnostPreruseni>;
    /**
     * 
     * @type {Array<APISharedLibsZivnostBezOZ>}
     * @memberof APISharedLibsZivnost
     */
    'zivnostBezOz': Array<APISharedLibsZivnostBezOZ>;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZivnost
     */
    'datumAktualizace': Date;
    /**
     * Druh živnosti - kód (ciselnikKod: DruhZivnosti)
     * @type {string}
     * @memberof APISharedLibsZivnost
     */
    'druhZivnosti': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsZivnostBezOZ
 */
export interface APISharedLibsZivnostBezOZ {
    [key: string]: any;

    /**
     * Zahájení vykonávání živnosti bez odpovědného zástupce od data
     * @type {Date}
     * @memberof APISharedLibsZivnostBezOZ
     */
    'platnostOd': Date;
    /**
     * Ukončení vykonávání živnosti bez odpovědného zástupce od data
     * @type {Date}
     * @memberof APISharedLibsZivnostBezOZ
     */
    'platnostDo': Date;
}
/**
 * 
 * @export
 * @interface APISharedLibsZivnostOborCinnosti
 */
export interface APISharedLibsZivnostOborCinnosti {
    [key: string]: any;

    /**
     * Platnost záznamu od data
     * @type {Date}
     * @memberof APISharedLibsZivnostOborCinnosti
     */
    'platnostOd': Date;
    /**
     * Platnost záznamu do data
     * @type {Date}
     * @memberof APISharedLibsZivnostOborCinnosti
     */
    'platnostDo': Date;
    /**
     * Název oboru
     * @type {string}
     * @memberof APISharedLibsZivnostOborCinnosti
     */
    'oborNazev': string;
}
/**
 * Podmínky pro vykonávání živnosti
 * @export
 * @interface APISharedLibsZivnostPodminky
 */
export interface APISharedLibsZivnostPodminky {
    [key: string]: any;

    /**
     * Platnost podmínky od data
     * @type {Date}
     * @memberof APISharedLibsZivnostPodminky
     */
    'platnostOd': Date;
    /**
     * Platnost podmínky do data
     * @type {Date}
     * @memberof APISharedLibsZivnostPodminky
     */
    'platnostDo': Date;
    /**
     * Text podmínky provozování živnosti
     * @type {string}
     * @memberof APISharedLibsZivnostPodminky
     */
    'podminka': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsZivnostPreruseni
 */
export interface APISharedLibsZivnostPreruseni {
    [key: string]: any;

    /**
     * Platnost přerušení živnosti od data
     * @type {Date}
     * @memberof APISharedLibsZivnostPreruseni
     */
    'platnostOd': Date;
    /**
     * Platnost přerušení živnosti do data
     * @type {Date}
     * @memberof APISharedLibsZivnostPreruseni
     */
    'platnostDo': Date;
}
/**
 * 
 * @export
 * @interface APISharedLibsZivnostProvozovnaPozastaveni
 */
export interface APISharedLibsZivnostProvozovnaPozastaveni {
    [key: string]: any;

    /**
     * Platnost pozastavení živnosti od data
     * @type {Date}
     * @memberof APISharedLibsZivnostProvozovnaPozastaveni
     */
    'platnostOd': Date;
    /**
     * Platnost pozastavení živnosti do data
     * @type {Date}
     * @memberof APISharedLibsZivnostProvozovnaPozastaveni
     */
    'platnostDo': Date;
    /**
     * Popis rozsahu pozastavení živnosti
     * @type {string}
     * @memberof APISharedLibsZivnostProvozovnaPozastaveni
     */
    'rozsahPozastaveni': string;
}
/**
 * Živnosti, které ekonomický subjekt provozuje nebo provozoval
 * @export
 * @interface APISharedLibsZivnostZaklad
 */
export interface APISharedLibsZivnostZaklad {
    [key: string]: any;

    /**
     * Datum vzniku živnosti
     * @type {Date}
     * @memberof APISharedLibsZivnostZaklad
     */
    'datumVzniku': Date;
    /**
     * Datum zániku živnosti
     * @type {Date}
     * @memberof APISharedLibsZivnostZaklad
     */
    'datumZaniku': Date;
    /**
     * Platnost živnosti do data
     * @type {Date}
     * @memberof APISharedLibsZivnostZaklad
     */
    'platnostDo': Date;
    /**
     * Předmět podnikáni živnosti
     * @type {string}
     * @memberof APISharedLibsZivnostZaklad
     */
    'predmetPodnikani': string;
    /**
     * 
     * @type {Array<APISharedLibsZivnostProvozovnaPozastaveni>}
     * @memberof APISharedLibsZivnostZaklad
     */
    'pozastaveniZivnosti': Array<APISharedLibsZivnostProvozovnaPozastaveni>;
    /**
     * 
     * @type {Array<APISharedLibsZivnostPodminky>}
     * @memberof APISharedLibsZivnostZaklad
     */
    'podminkyProvozovaniZivnosti': Array<APISharedLibsZivnostPodminky>;
    /**
     * 
     * @type {Array<APISharedLibsZivnostPreruseni>}
     * @memberof APISharedLibsZivnostZaklad
     */
    'preruseniZivnosti': Array<APISharedLibsZivnostPreruseni>;
    /**
     * 
     * @type {Array<APISharedLibsZivnostBezOZ>}
     * @memberof APISharedLibsZivnostZaklad
     */
    'zivnostBezOz': Array<APISharedLibsZivnostBezOZ>;
    /**
     * Datum aktualizace záznamu
     * @type {Date}
     * @memberof APISharedLibsZivnostZaklad
     */
    'datumAktualizace': Date;
    /**
     * Druh živnosti - kód (ciselnikKod: DruhZivnosti)
     * @type {string}
     * @memberof APISharedLibsZivnostZaklad
     */
    'druhZivnosti': string;
}
/**
 * 
 * @export
 * @interface APISharedLibsZivnostiRzpStav
 */
export interface APISharedLibsZivnostiRzpStav {
    [key: string]: any;

    /**
     * Celkový počet aktivních živností
     * @type {number}
     * @memberof APISharedLibsZivnostiRzpStav
     */
    'pocetAktivnich': number;
    /**
     * Celkový počet zaniklých živností
     * @type {number}
     * @memberof APISharedLibsZivnostiRzpStav
     */
    'pocetZaniklych': number;
    /**
     * Celkový počet zaniklých živností
     * @type {number}
     * @memberof APISharedLibsZivnostiRzpStav
     */
    'pocetPozastavenych': number;
    /**
     * Celkový počet zaniklých živností
     * @type {number}
     * @memberof APISharedLibsZivnostiRzpStav
     */
    'pocetPrerusenych': number;
    /**
     * Celkový počet živností
     * @type {number}
     * @memberof APISharedLibsZivnostiRzpStav
     */
    'pocetCelkem': number;
}
/**
 * Seznam datumů změn stanov.
 * @export
 * @interface APISharedLibsZmenaStanov
 */
export interface APISharedLibsZmenaStanov {
    [key: string]: any;

    /**
     * Datum změny stanov.
     * @type {Date}
     * @memberof APISharedLibsZmenaStanov
     */
    'datumZmeny': Date;
}
/**
 * tabulka způsobů jednání subjektu
 * @export
 * @interface APISharedLibsZpusobJednani
 */
export interface APISharedLibsZpusobJednani {
    [key: string]: any;

    /**
     * popis způsobu jednání
     * @type {string}
     * @memberof APISharedLibsZpusobJednani
     */
    'popis': string;
    /**
     * počátek platnosti způsobu jednání dle popisu
     * @type {Date}
     * @memberof APISharedLibsZpusobJednani
     */
    'platnostOd': Date;
    /**
     * konec platnosti způsobu jednání dle popisu
     * @type {Date}
     * @memberof APISharedLibsZpusobJednani
     */
    'platnostDo': Date;
}
/**
 * 
 * @export
 * @interface APISharedLocaleDto
 */
export interface APISharedLocaleDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLocaleDto
     */
    'defaultLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocaleDto
     */
    'currency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocaleDto
     */
    'currencyPosition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocaleDto
     */
    'dateFormat'?: string | null;
    /**
     * DatePicker uses proprietary culture/locale token map for dates -_-
     * @type {string}
     * @memberof APISharedLocaleDto
     */
    'datePickerDateFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocaleDto
     */
    'timeFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocaleDto
     */
    'numberFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocaleDto
     */
    'defaultPhonePrefix'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLocationData
 */
export interface APISharedLocationData {
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationData
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationData
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationData
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationData
     */
    'regNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationData
     */
    'vatNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationData
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationData
     */
    'post'?: string | null;
}
/**
 * Foreign key CompanyFk removed, Foreign key GlobalFk removed
 * @export
 * @interface APISharedLocationDto
 */
export interface APISharedLocationDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idAddressOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idLogo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'regNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'vatNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'icz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'accountNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'bankCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'swift'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'iban'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'writtenBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'web'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'facebook'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'twitter'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLocationDto
     */
    'onlineAvalaible'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLocationDto
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'vozp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'nameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'webOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'emailOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'phoneOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eetLocationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eetDeviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLocationDto
     */
    'eetType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eetCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eetPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eetCertificateName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLocationDto
     */
    'eetActive'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLocationDto
     */
    'eetStartDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLocationDto
     */
    'invoicePayVAT'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eReceptCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eReceptPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eReceptID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eReceptCertificateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'ideReceptPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'eReceptPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'uolDatabaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'uolLoginToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idLogoOriginal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idLogoBooking'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idLogoBox'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idExpertiseType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLocationDto
     */
    'invoiceSeriesActive'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLocationDto
     */
    'invoiceSeriesNumber'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedLocationDto
     */
    'invoiceCustomDue'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLocationDto
     */
    'forcePaymentTypePick'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLocationDto
     */
    'eReceptAutoRenewDisable'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'insuranceCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'insurenceCertificatePassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'insuranceCompanyNotUsed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'insuranceCertificateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'insuranceBankAccountNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'insuranceBankCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLocationDto
     */
    'insuranceForceAltBankAccount'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'customColors'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'ereceptPayment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'insuranceVariableSymbol'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedLocationDto
     */
    'b2BValidFrom'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'fixedCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'ezdravieJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'instagram'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedLocationDto
     */
    'isInvoiceItemsMerged'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idSignatureImg'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idAddressHQ'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'insuranceIBAN'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'idDiscountType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLocationDto
     */
    'nameInternal'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLoginBookingDto
 */
export interface APISharedLoginBookingDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginBookingDto
     */
    'idXdentCompanyRestriction': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginBookingDto
     */
    'idPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginBookingDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginBookingDto
     */
    'smsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginBookingDto
     */
    'emailOrUsername'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginBookingDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginBookingDto
     */
    'os'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginBookingDto
     */
    'fireBaseDeviceToken'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedLoginDto
 */
export interface APISharedLoginDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginDto
     */
    'idPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginDto
     */
    'smsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginDto
     */
    'emailOrUsername'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginDto
     */
    'os'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedLoginDto
     */
    'fireBaseDeviceToken'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedMedicalReportDetailDto
 */
export interface APISharedMedicalReportDetailDto {
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult}
     * @memberof APISharedMedicalReportDetailDto
     */
    'medicalReport': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult;
    /**
     * 
     * @type {Array<APISharedMedicalReportInsuranceDto>}
     * @memberof APISharedMedicalReportDetailDto
     */
    'insurance'?: Array<APISharedMedicalReportInsuranceDto> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult>}
     * @memberof APISharedMedicalReportDetailDto
     */
    'diagnose'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult> | null;
}
/**
 * 
 * @export
 * @interface APISharedMedicalReportInsuranceDto
 */
export interface APISharedMedicalReportInsuranceDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedMedicalReportInsuranceDto
     */
    'codeDiagnosis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedMedicalReportInsuranceDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedMedicalReportInsuranceDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {Array<APISharedMedicalReportInsuranceItemDto>}
     * @memberof APISharedMedicalReportInsuranceDto
     */
    'items'?: Array<APISharedMedicalReportInsuranceItemDto> | null;
}
/**
 * 
 * @export
 * @interface APISharedMedicalReportInsuranceItemDto
 */
export interface APISharedMedicalReportInsuranceItemDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedMedicalReportInsuranceItemDto
     */
    'performed'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedMedicalReportInsuranceItemDto
     */
    'localization'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedMedicalReportInsuranceItemDto
     */
    'diagnose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedMedicalReportInsuranceItemDto
     */
    'paymentTitle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedMedicalReportInsuranceItemDto
     */
    'amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedMedicalReportInsuranceItemDto
     */
    'patiencePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedMedicalReportInsuranceItemDto
     */
    'insurancePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedMedicalReportInsuranceItemDto
     */
    'laboratoryPrice'?: number | null;
}
/**
 * 
 * @export
 * @interface APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem
 */
export interface APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem {
    /**
     * 
     * @type {string}
     * @memberof APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem
     */
    'date'?: string | null;
    /**
     * 
     * @type {Array<APISharedModelsOnlineBookingOnlineBookingDtoOpenHourItem>}
     * @memberof APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem
     */
    'openHours'?: Array<APISharedModelsOnlineBookingOnlineBookingDtoOpenHourItem> | null;
}
/**
 * 
 * @export
 * @interface APISharedModelsOnlineBookingOnlineBookingDtoOpenHourItem
 */
export interface APISharedModelsOnlineBookingOnlineBookingDtoOpenHourItem {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedModelsOnlineBookingOnlineBookingDtoOpenHourItem
     */
    'afternoon': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedModelsOnlineBookingOnlineBookingDtoOpenHourItem
     */
    'dateTime'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedOnlineBookingPaymentDto
 */
export interface APISharedOnlineBookingPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingPaymentDto
     */
    'redirectUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingPaymentDto
     */
    'payId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingPaymentDto
     */
    'isVerified': boolean;
}
/**
 * 
 * @export
 * @interface APISharedOnlineBookingResultDto
 */
export interface APISharedOnlineBookingResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingResultDto
     */
    'isSuccess': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingResultDto
     */
    'idAppointment'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedOnlineBookingResultV3Dto
 */
export interface APISharedOnlineBookingResultV3Dto {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingResultV3Dto
     */
    'isSuccess': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingResultV3Dto
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {APISharedOnlineBookingPaymentDto}
     * @memberof APISharedOnlineBookingResultV3Dto
     */
    'payment': APISharedOnlineBookingPaymentDto;
}
/**
 * 
 * @export
 * @interface APISharedOnlineBookingSendByMiniWebsiteDto
 */
export interface APISharedOnlineBookingSendByMiniWebsiteDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'idResource': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'idService': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'selectedYear'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'selectedMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'selectedDay'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'selectedHour'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'selectedMinute'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'promo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'clientRequest'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'optIn': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'findUs'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'custom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'isPayment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'marketing'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'dateOfBirth'?: Date | null;
    /**
     * IdBudgetPlanService z iklientInfo EP pro OB
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'planIdService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteDto
     */
    'idPartnership'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedOnlineBookingSendByMiniWebsiteV3Dto
 */
export interface APISharedOnlineBookingSendByMiniWebsiteV3Dto {
    /**
     * Enum: [cs,en,de,fr,hu,it,ja,pl,pt,ro,ru,sk,es,tr,vi,hr,sl,sv], if null or not in enum --> en is selected.
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'lang'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'idResource': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'idService': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'selectedYear'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'selectedMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'selectedDay'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'selectedHour'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'selectedMinute'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'promo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'clientRequest'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'optIn': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'findUs'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'custom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'isPayment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'marketing'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'dateOfBirth'?: Date | null;
    /**
     * IdBudgetPlanService z iklientInfo EP pro OB
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'planIdService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOnlineBookingSendByMiniWebsiteV3Dto
     */
    'idPartnership'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedOptionsServiceAvailabilityOptions
 */
export interface APISharedOptionsServiceAvailabilityOptions {
    /**
     * 
     * @type {APISharedOptionsXdentOptions}
     * @memberof APISharedOptionsServiceAvailabilityOptions
     */
    'xdent': APISharedOptionsXdentOptions;
}
/**
 * 
 * @export
 * @interface APISharedOptionsSmsApiMexAuth
 */
export interface APISharedOptionsSmsApiMexAuth {
    /**
     * 
     * @type {APISharedOptionsSmsApiMexAuthProfile}
     * @memberof APISharedOptionsSmsApiMexAuth
     */
    'xdent': APISharedOptionsSmsApiMexAuthProfile;
    /**
     * 
     * @type {APISharedOptionsSmsApiMexAuthProfile}
     * @memberof APISharedOptionsSmsApiMexAuth
     */
    'labino': APISharedOptionsSmsApiMexAuthProfile;
    /**
     * 
     * @type {APISharedOptionsSmsApiMexAuthProfile}
     * @memberof APISharedOptionsSmsApiMexAuth
     */
    'iklient': APISharedOptionsSmsApiMexAuthProfile;
}
/**
 * 
 * @export
 * @interface APISharedOptionsSmsApiMexAuthProfile
 */
export interface APISharedOptionsSmsApiMexAuthProfile {
    /**
     * 
     * @type {string}
     * @memberof APISharedOptionsSmsApiMexAuthProfile
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOptionsSmsApiMexAuthProfile
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOptionsSmsApiMexAuthProfile
     */
    'textId'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedOptionsSmsApiMexOptions
 */
export interface APISharedOptionsSmsApiMexOptions {
    /**
     * 
     * @type {number}
     * @memberof APISharedOptionsSmsApiMexOptions
     */
    'dailyQuickGlobalLimit': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedOptionsSmsApiMexOptions
     */
    'dailyCompanyQuickLimit': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOptionsSmsApiMexOptions
     */
    'companyQuickLimitEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOptionsSmsApiMexOptions
     */
    'globalQuickLimitEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOptionsSmsApiMexOptions
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedOptionsSmsApiMexOptions
     */
    'allowedPrefixes'?: Array<string> | null;
    /**
     * 
     * @type {APISharedOptionsSmsApiMexUrl}
     * @memberof APISharedOptionsSmsApiMexOptions
     */
    'url': APISharedOptionsSmsApiMexUrl;
    /**
     * 
     * @type {APISharedOptionsSmsApiMexAuth}
     * @memberof APISharedOptionsSmsApiMexOptions
     */
    'auth': APISharedOptionsSmsApiMexAuth;
}
/**
 * 
 * @export
 * @interface APISharedOptionsSmsApiMexUrl
 */
export interface APISharedOptionsSmsApiMexUrl {
    /**
     * 
     * @type {string}
     * @memberof APISharedOptionsSmsApiMexUrl
     */
    'base'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOptionsSmsApiMexUrl
     */
    'sendSms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedOptionsSmsApiMexUrl
     */
    'login'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedOptionsXdentOptions
 */
export interface APISharedOptionsXdentOptions {
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOptionsXdentOptions
     */
    'formAnamnesisHistory': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedOptionsXdentOptions
     */
    'formV1Anamnesis': boolean;
}
/**
 * 
 * @export
 * @interface APISharedPartnershipRequestResult
 */
export interface APISharedPartnershipRequestResult {
    /**
     * 
     * @type {string}
     * @memberof APISharedPartnershipRequestResult
     */
    'code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedPartnershipRequestResult
     */
    'isNewIklient': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedPartnershipRequestResult
     */
    'errorCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedProductFiltersDTO
 */
export interface APISharedProductFiltersDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedProductFiltersDTO
     */
    'filter'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedProductFiltersDTO
     */
    'priceRangeFrom'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedProductFiltersDTO
     */
    'priceRangeTo'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof APISharedProductFiltersDTO
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof APISharedProductFiltersDTO
     */
    'categories'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof APISharedProductFiltersDTO
     */
    'attributeTerms'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedProductFiltersDTO
     */
    'orderType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedProductFiltersDTO
     */
    'startIndex': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedProductFiltersDTO
     */
    'endIndex': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedProductFiltersDTO
     */
    'nestedCategories': boolean;
}
/**
 * 
 * @export
 * @interface APISharedReadMessagesDto
 */
export interface APISharedReadMessagesDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedReadMessagesDto
     */
    'idChatMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedRecurrenceInfoDto
 */
export interface APISharedRecurrenceInfoDto {
    /**
     * 
     * @type {any}
     * @memberof APISharedRecurrenceInfoDto
     */
    'id'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedRecurrenceInfoDto
     */
    'timeZoneId'?: string | null;
    /**
     * 0 - Sunday, 1 - Monday, 2 - Tuesday, 3 - Wednesday, 4 - Thursday, 5 - Friday, 6 - Saturday
     * @type {string}
     * @memberof APISharedRecurrenceInfoDto
     */
    'firstDayOfWeek': APISharedRecurrenceInfoDtoFirstDayOfWeekEnum;
    /**
     * 
     * @type {Date}
     * @memberof APISharedRecurrenceInfoDto
     */
    'start': Date;
    /**
     * 
     * @type {Date}
     * @memberof APISharedRecurrenceInfoDto
     */
    'end': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedRecurrenceInfoDto
     */
    'duration': string;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedRecurrenceInfoDto
     */
    'allDay': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedRecurrenceInfoDto
     */
    'type': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedRecurrenceInfoDto
     */
    'range': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedRecurrenceInfoDto
     */
    'periodicity': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedRecurrenceInfoDto
     */
    'weekDays': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedRecurrenceInfoDto
     */
    'dayNumber': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedRecurrenceInfoDto
     */
    'weekOfMonth': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedRecurrenceInfoDto
     */
    'month': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedRecurrenceInfoDto
     */
    'occurrenceCount': number;
}

export const APISharedRecurrenceInfoDtoFirstDayOfWeekEnum = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday'
} as const;

export type APISharedRecurrenceInfoDtoFirstDayOfWeekEnum = typeof APISharedRecurrenceInfoDtoFirstDayOfWeekEnum[keyof typeof APISharedRecurrenceInfoDtoFirstDayOfWeekEnum];

/**
 * 
 * @export
 * @interface APISharedRegistrationRequestResponseDto
 */
export interface APISharedRegistrationRequestResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedRegistrationRequestResponseDto
     */
    'idRegistrationRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedRegistrationRequestResponseDto
     */
    'idRegistrationStatus'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedRegistrationRequestResponseDto
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedRegistrationRequestResponseDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedRegistrationRequestResponseDto
     */
    'idExternalSMS'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedRegistrationRequestResponseDto
     */
    'errorCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedSMSAnswersDTO
 */
export interface APISharedSMSAnswersDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedSMSAnswersDTO
     */
    'confirmed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'contentAnswer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'contentOriginal'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedSMSAnswersDTO
     */
    'dateReceived'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedSMSAnswersDTO
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedSMSAnswersDTO
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'idAnswer'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedSMSAnswersDTO
     */
    'idAnswerOriginal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'idResource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'idSMSOriginal'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedSMSAnswersDTO
     */
    'isNotify'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'phone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedSMSAnswersDTO
     */
    'rowNumber'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'subject'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedSMSAnswersDTO
     */
    'duration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSMSAnswersDTO
     */
    'staff'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedSendClientRegistrationRequestDto
 */
export interface APISharedSendClientRegistrationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedSendClientRegistrationRequestDto
     */
    'idXdentClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSendClientRegistrationRequestDto
     */
    'idCreateReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSendClientRegistrationRequestDto
     */
    'idCreateReasonEntity'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedSendClientRegistrationRequestDto
     */
    'isCron': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedSendClientRegistrationRequestDto
     */
    'clientPhoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedSendMessageDTO
 */
export interface APISharedSendMessageDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedSendMessageDTO
     */
    'idUser': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedSendMessageDTO
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedSendMessageDTO
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedSendMessageDTO
     */
    'customerMessage': boolean;
    /**
     * 0 - Message, 1 - Log, 2 - OrderAccept
     * @type {string}
     * @memberof APISharedSendMessageDTO
     */
    'messageType': APISharedSendMessageDTOMessageTypeEnum;
}

export const APISharedSendMessageDTOMessageTypeEnum = {
    Message: 'Message',
    Log: 'Log',
    OrderAccept: 'OrderAccept'
} as const;

export type APISharedSendMessageDTOMessageTypeEnum = typeof APISharedSendMessageDTOMessageTypeEnum[keyof typeof APISharedSendMessageDTOMessageTypeEnum];

/**
 * 
 * @export
 * @interface APISharedServiceWithRelation
 */
export interface APISharedServiceWithRelation {
    /**
     * 
     * @type {string}
     * @memberof APISharedServiceWithRelation
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedServiceWithRelation
     */
    'caption'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedServiceWithRelation
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedServiceWithRelation
     */
    'colorIndex'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedServiceWithRelation
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedServiceWithRelation
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedServiceWithRelation
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedServiceWithRelation
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedServiceWithRelation
     */
    'cost'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedServiceWithRelation
     */
    'visibility'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedServiceWithRelation
     */
    'nameOnline'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedServiceWithRelation
     */
    'reminderAfterPeriod'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedServiceWithRelation
     */
    'idResources'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APISharedServicesCurrencyRate
 */
export interface APISharedServicesCurrencyRate {
    /**
     * 
     * @type {number}
     * @memberof APISharedServicesCurrencyRate
     */
    'fixedRate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedServicesCurrencyRate
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedServicesCurrencyRate
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedServicesCurrencyRate
     */
    'rate': number;
}
/**
 * 
 * @export
 * @interface APISharedServicesCurrencyRateInternal
 */
export interface APISharedServicesCurrencyRateInternal {
    /**
     * 
     * @type {string}
     * @memberof APISharedServicesCurrencyRateInternal
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedServicesCurrencyRateInternal
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedServicesCurrencyRateInternal
     */
    'rate': number;
}
/**
 * 
 * @export
 * @interface APISharedStaffDayDuration
 */
export interface APISharedStaffDayDuration {
    /**
     * 
     * @type {string}
     * @memberof APISharedStaffDayDuration
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedStaffDayDuration
     */
    'date': Date;
    /**
     * 
     * @type {number}
     * @memberof APISharedStaffDayDuration
     */
    'openHoursDuration': number;
}
/**
 * 
 * @export
 * @interface APISharedSuklMedicamentsAndSubstancesDto
 */
export interface APISharedSuklMedicamentsAndSubstancesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedSuklMedicamentsAndSubstancesDto
     */
    'medicamentTitles'?: Array<string> | null;
    /**
     * 
     * @type {Array<APISharedSuklSubstanceDto>}
     * @memberof APISharedSuklMedicamentsAndSubstancesDto
     */
    'substances'?: Array<APISharedSuklSubstanceDto> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerClientAlerts>}
     * @memberof APISharedSuklMedicamentsAndSubstancesDto
     */
    'allergens'?: Array<APIContextGeneratedXdentCoreEntityLayerClientAlerts> | null;
}
/**
 * 
 * @export
 * @interface APISharedSuklSubstanceDto
 */
export interface APISharedSuklSubstanceDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedSuklSubstanceDto
     */
    'kodLatky'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSuklSubstanceDto
     */
    'nazev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedSuklSubstanceDto
     */
    'nazevInn'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedTreatmentPlanDto
 */
export interface APISharedTreatmentPlanDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'idPlan': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'idAuthor': string;
    /**
     * 
     * @type {Date}
     * @memberof APISharedTreatmentPlanDto
     */
    'created': Date;
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'idFile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedTreatmentPlanDto
     */
    'isFileSigned': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'authorFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'authorDegree'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedTreatmentPlanDto
     */
    'authorDegreeAfter'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedUnifiedNotification
 */
export interface APISharedUnifiedNotification {
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'titleMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'message'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedUnifiedNotification
     */
    'date'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedUnifiedNotification
     */
    'dateStart'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'duration': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'idGlobal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'type'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedUnifiedNotification
     */
    'confirmed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUnifiedNotification
     */
    'clientRequest'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedUpdateClientCategoriesDto
 */
export interface APISharedUpdateClientCategoriesDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesDto
     */
    'idProsthetics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesDto
     */
    'idEndodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesDto
     */
    'idPeriodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesDto
     */
    'idOrthodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesDto
     */
    'idImplantology'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedUpdateClientCategoriesInternal
 */
export interface APISharedUpdateClientCategoriesInternal {
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesInternal
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesInternal
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesInternal
     */
    'idProsthetics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesInternal
     */
    'idEndodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesInternal
     */
    'idPeriodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesInternal
     */
    'idOrthodontics'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdateClientCategoriesInternal
     */
    'idImplantology'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedUpdatedAppointmentValuesDto
 */
export interface APISharedUpdatedAppointmentValuesDto {
    /**
     * 
     * @type {Array<APISharedCalendarAppointmentX2Dto>}
     * @memberof APISharedUpdatedAppointmentValuesDto
     */
    'items'?: Array<APISharedCalendarAppointmentX2Dto> | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdatedAppointmentValuesDto
     */
    'controller'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdatedAppointmentValuesDto
     */
    'cacheContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdatedAppointmentValuesDto
     */
    'invoker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdatedAppointmentValuesDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdatedAppointmentValuesDto
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof APISharedUpdatedAppointmentValuesDto
     */
    'expiration': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedUpdatedAppointmentValuesDto
     */
    'idGlobal': string;
}
/**
 * 
 * @export
 * @interface APISharedUploadGalleryFileInternal
 */
export interface APISharedUploadGalleryFileInternal {
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'idMaster'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'idGallery'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'idFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'mimeType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'idServer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'path'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'isUpdate': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'fileContent'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedUploadGalleryFileInternal
     */
    'systemTags'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APISharedUserDto
 */
export interface APISharedUserDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedUserDto
     */
    'twoFactorEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'nameIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'profilePhotoId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'phonePrefixId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedUserDto
     */
    'created'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserDto
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedUserDto
     */
    'registrationDate'?: Date | null;
    /**
     * 
     * @type {APISharedLocaleDto}
     * @memberof APISharedUserDto
     */
    'localeSettings': APISharedLocaleDto;
    /**
     * Logic, is from new iklient inverted.
     * @type {boolean}
     * @memberof APISharedUserDto
     */
    'isFromOldIklient': boolean;
}
/**
 * 
 * @export
 * @interface APISharedUserSettingsDto
 */
export interface APISharedUserSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'idUserSetting'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'idChatSound'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'idUserPrivilegesProfile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'eReceptID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'eReceptPassword'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedUserSettingsDto
     */
    'chatMuteTill'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'schortcut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'calendarColorDays'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'calendarColorWeeks'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'eNeschopenkaICPE'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'eNeschopenkaOSSZ'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'ezadankaKey'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISharedUserSettingsDto
     */
    'sidebarState'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'additionalSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'dashboardLayout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'dhid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserSettingsDto
     */
    'groups'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedUserXdentDto
 */
export interface APISharedUserXdentDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APISharedUserXdentDto
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedUserXdentDto
     */
    'insuranceAccess'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'nameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedUserXdentDto
     */
    'idProfilePhoto'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedWidgetDTO
 */
export interface APISharedWidgetDTO {
    /**
     * 
     * @type {string}
     * @memberof APISharedWidgetDTO
     */
    'name'?: string | null;
    /**
     * 
     * @type {APISharedWidgetDetailDTO}
     * @memberof APISharedWidgetDTO
     */
    'detail': APISharedWidgetDetailDTO;
}
/**
 * 
 * @export
 * @interface APISharedWidgetDetailDTO
 */
export interface APISharedWidgetDetailDTO {
    /**
     * 
     * @type {number}
     * @memberof APISharedWidgetDetailDTO
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedWidgetDetailDTO
     */
    'y': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedWidgetDetailDTO
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedWidgetDetailDTO
     */
    'height': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedWidgetDetailDTO
     */
    'visible': boolean;
    /**
     * 
     * @type {number}
     * @memberof APISharedWidgetDetailDTO
     */
    'originalW': number;
    /**
     * 
     * @type {number}
     * @memberof APISharedWidgetDetailDTO
     */
    'originalH': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedWidgetDetailDTO
     */
    'filterToggled': boolean;
}
/**
 * 
 * @export
 * @interface APISharedWidgetLayoutMobileDto
 */
export interface APISharedWidgetLayoutMobileDto {
    /**
     * 
     * @type {number}
     * @memberof APISharedWidgetLayoutMobileDto
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof APISharedWidgetLayoutMobileDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedWidgetLayoutMobileDto
     */
    'visible': boolean;
}
/**
 * 
 * @export
 * @interface APISharedXdentFormDto
 */
export interface APISharedXdentFormDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'idForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'idFormType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'typeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'languageTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'languageCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'formTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedXdentFormDto
     */
    'published': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedXdentFormDto
     */
    'isFavourite': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APISharedXdentFormDto
     */
    'dateCreated': Date;
    /**
     * 
     * @type {number}
     * @memberof APISharedXdentFormDto
     */
    'expirationDays'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'idFormXdent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentFormDto
     */
    'idLocation'?: string | null;
}
/**
 * 
 * @export
 * @interface APISharedXdentFormsToggleAutoConfirmDto
 */
export interface APISharedXdentFormsToggleAutoConfirmDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharedXdentFormsToggleAutoConfirmDto
     */
    'idForms'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISharedXdentFormsToggleAutoConfirmDto
     */
    'isAutoConfirm': boolean;
}
/**
 * 
 * @export
 * @interface APISharedXdentLoginDto
 */
export interface APISharedXdentLoginDto {
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentLoginDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentLoginDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharedXdentLoginDto
     */
    'fireBaseDeviceToken'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentControllersCronCronControllerPhoneDto
 */
export interface APIXdentControllersCronCronControllerPhoneDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentControllersCronCronControllerPhoneDto
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentControllersSafeSignaturesInitDevice
 */
export interface APIXdentControllersSafeSignaturesInitDevice {
    /**
     * 
     * @type {string}
     * @memberof APIXdentControllersSafeSignaturesInitDevice
     */
    'json'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentControllersSafeSignaturesSafeSignaturesCurrentCertsDto
 */
export interface APIXdentControllersSafeSignaturesSafeSignaturesCurrentCertsDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentControllersSafeSignaturesSafeSignaturesCurrentCertsDto
     */
    'safeSignaturesPublicCertBase64'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentControllersSafeSignaturesSafeSignaturesCurrentCertsDto
     */
    'thirdPartySealCertificateBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentControllersXdentFormRequestActionDto
 */
export interface APIXdentControllersXdentFormRequestActionDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentControllersXdentFormRequestActionDto
     */
    'idRequest': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOAnalyticsANALYTICSAGECLIENTS
 */
export interface APIXdentDTOAnalyticsANALYTICSAGECLIENTS {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'idAnalyticsAgeClients': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'idStaff': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'dateCreated': Date;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'uSix': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'uFifteen': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'uEighteen': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'uThirty': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'uForty': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'uFifty': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'uSixty': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAGECLIENTS
     */
    'uMax': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
 */
export interface APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'idAnalyticsAppointments': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'idStaff': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'dateCreated': Date;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'appointmentsDone': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'appointmentsNotDone': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'appointmentsOnline': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS
     */
    'appointmentsXdent': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOAnalyticsANALYTICSDURATIONS
 */
export interface APIXdentDTOAnalyticsANALYTICSDURATIONS {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSDURATIONS
     */
    'idAnalyticsDurations': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSDURATIONS
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSDURATIONS
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSDURATIONS
     */
    'idStaff': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOAnalyticsANALYTICSDURATIONS
     */
    'dateCreated': Date;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSDURATIONS
     */
    'appointmentsDuration': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSDURATIONS
     */
    'openHoursDuration': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOAnalyticsANALYTICSNEWCLIENTS
 */
export interface APIXdentDTOAnalyticsANALYTICSNEWCLIENTS {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSNEWCLIENTS
     */
    'idAnalyticsNewClients': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSNEWCLIENTS
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSNEWCLIENTS
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSNEWCLIENTS
     */
    'idStaff': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOAnalyticsANALYTICSNEWCLIENTS
     */
    'dateCreated': Date;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSNEWCLIENTS
     */
    'newClients': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSNEWCLIENTS
     */
    'newActiveClients': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOAnalyticsANALYTICSPAYMENTS
 */
export interface APIXdentDTOAnalyticsANALYTICSPAYMENTS {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSPAYMENTS
     */
    'idAnalyticsPayment': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSPAYMENTS
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSPAYMENTS
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSPAYMENTS
     */
    'idStaff': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOAnalyticsANALYTICSPAYMENTS
     */
    'dateCreated': Date;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOAnalyticsANALYTICSPAYMENTS
     */
    'payment': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAnalyticsANALYTICSPAYMENTS
     */
    'paymentType'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOAresAresSearchResult
 */
export interface APIXdentDTOAresAresSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAresAresSearchResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAresAresSearchResult
     */
    'regNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAresAresSearchResult
     */
    'vatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAresAresSearchResult
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAresAresSearchResult
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAresAresSearchResult
     */
    'district'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAresAresSearchResult
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOAresAresSearchResult
     */
    'cityFull'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOBudgetPlanBudgetPlanDto
 */
export interface APIXdentDTOBudgetPlanBudgetPlanDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanBudgetPlanDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanBudgetPlanDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanBudgetPlanDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanBudgetPlanDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOBudgetPlanBudgetPlanDto
     */
    'isDispensarization': boolean;
    /**
     * 
     * @type {Array<APIXdentDTOBudgetPlanServiceDto>}
     * @memberof APIXdentDTOBudgetPlanBudgetPlanDto
     */
    'services'?: Array<APIXdentDTOBudgetPlanServiceDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOBudgetPlanDcRegionDto
 */
export interface APIXdentDTOBudgetPlanDcRegionDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanDcRegionDto
     */
    'idItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanDcRegionDto
     */
    'idRegion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanDcRegionDto
     */
    'shortCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanDcRegionDto
     */
    'codelistCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanDcRegionDto
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOBudgetPlanServiceDto
 */
export interface APIXdentDTOBudgetPlanServiceDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceDto
     */
    'idBudgetPlan'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOBudgetPlanServiceDto
     */
    'dateVisit': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOBudgetPlanServiceDto
     */
    'isDateVisitLocked': boolean;
    /**
     * 
     * @type {APIXdentDTOBudgetPlanSomeOtherServiceDto}
     * @memberof APIXdentDTOBudgetPlanServiceDto
     */
    'service': APIXdentDTOBudgetPlanSomeOtherServiceDto;
    /**
     * 
     * @type {Array<APIXdentDTOBudgetPlanServiceItemDto>}
     * @memberof APIXdentDTOBudgetPlanServiceDto
     */
    'items'?: Array<APIXdentDTOBudgetPlanServiceItemDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOBudgetPlanServiceItemDto
 */
export interface APIXdentDTOBudgetPlanServiceItemDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idBudgetPlanService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'typeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idLaboratoryLabel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'laboratoryName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'laboratoryPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'localizationCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'sorting': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'level'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {Array<APIXdentDTOBudgetPlanServiceItemDto>}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'items'?: Array<APIXdentDTOBudgetPlanServiceItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idPhrase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'phraseTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceDiagnoseCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceServiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceServiceCustomCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceIdLaboratoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceServiceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insurancePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceAgeStart'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceAgeFinish'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceIsLocalizationRequired'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceODB'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insurancePaymentTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceIdPaymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insurancePaymentTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insuranceLaboratoryCodeType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'insurancePriceClientAdd'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idInvoiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoiceCustomCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoiceCodeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoiceMaterialCodeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoiceTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoiceDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoiceUnitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoiceDuration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'invoicePricePerMinute'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idOperation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idConstruction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'idMaterial'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'dcOperationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'dcConstructionCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'dcMaterialCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'dcOperationTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'dcConstructionTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'dcMaterialTitle'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOBudgetPlanDcRegionDto>}
     * @memberof APIXdentDTOBudgetPlanServiceItemDto
     */
    'dcRegions'?: Array<APIXdentDTOBudgetPlanDcRegionDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOBudgetPlanSomeOtherServiceDto
 */
export interface APIXdentDTOBudgetPlanSomeOtherServiceDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanSomeOtherServiceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanSomeOtherServiceDto
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanSomeOtherServiceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOBudgetPlanSomeOtherServiceDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOBudgetPlanSomeOtherServiceDto
     */
    'duration'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOCallSetCallStatusDto
 */
export interface APIXdentDTOCallSetCallStatusDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOCallSetCallStatusDto
     */
    'uniqueId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOCallSetCallStatusDto
     */
    'phoneFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOCallSetCallStatusDto
     */
    'phoneTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOCallSetCallStatusDto
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientClientEmailArchiveDTO
 */
export interface APIXdentDTOClientClientEmailArchiveDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientClientEmailArchiveDTO
     */
    'idEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientClientEmailArchiveDTO
     */
    'emailSourceTable'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOClientClientEmailArchiveDTO
     */
    'dateSend'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientClientEmailArchiveDTO
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientClientEmailArchiveDTO
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientClientEmailArchiveDTO
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientClientEmailArchiveDTO
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientClientEmailArchiveDTO
     */
    'serviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientClientMagistralisDto
 */
export interface APIXdentDTOClientClientMagistralisDto {
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult}
     * @memberof APIXdentDTOClientClientMagistralisDto
     */
    'info': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult>}
     * @memberof APIXdentDTOClientClientMagistralisDto
     */
    'magistralisDetail'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientDetailGeneralDrugDto
 */
export interface APIXdentDTOClientDetailGeneralDrugDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'dosage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'packaging'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'ammount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'amount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'idDrug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'idMagistralis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'naz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'dop'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'dodavky'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralDrugDto
     */
    'iskupina'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientDetailGeneralInvoiceClientInfoDto
 */
export interface APIXdentDTOClientDetailGeneralInvoiceClientInfoDto {
    /**
     * 
     * @type {Array<APIXdentDTOClientDetailGeneralInvoiceGridInfoDto>}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceClientInfoDto
     */
    'clientInvoiceList'?: Array<APIXdentDTOClientDetailGeneralInvoiceGridInfoDto> | null;
    /**
     * 
     * @type {APIXdentDTOClientDetailGeneralUserCreditInfoDto}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceClientInfoDto
     */
    'creditInfo': APIXdentDTOClientDetailGeneralUserCreditInfoDto;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
 */
export interface APIXdentDTOClientDetailGeneralInvoiceGridInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'dateIssue': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'dateLastChange': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'supervisorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'nameSupervisorChange'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'locationSupervisorChange'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'locationPositionSupervisorChange'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'idBillingUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'billingName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'billingSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'billingAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'idInvoiceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'invoiceTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'invoiceTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'idBillingType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'billingTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'idDiscountType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'discountTypeCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'discount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'deposit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'credit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'total'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'priceService'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'priceMaterial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'priceDiscount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'currencySymbol'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'paid'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'toPay'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'pricePayments'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'pricePaymentsDate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'eetLock'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'eetInvoiceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'lockCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'summaryLock'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'idSupervisor'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'emailSent'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'iklientShared'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'emailDelivered'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'emailDeliveredDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralInvoiceGridInfoDto
     */
    'idPartner'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientDetailGeneralPrescriptionDto
 */
export interface APIXdentDTOClientDetailGeneralPrescriptionDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'idEreceptFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'idMedicalPrescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'ownerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'dateIssue'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'dateIss'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'insuranceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'diagnose'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOClientDetailGeneralDrugDto>}
     * @memberof APIXdentDTOClientDetailGeneralPrescriptionDto
     */
    'drugs'?: Array<APIXdentDTOClientDetailGeneralDrugDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientDetailGeneralReminderDto
 */
export interface APIXdentDTOClientDetailGeneralReminderDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'idReminder'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'service'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'status': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'statusText'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'dateSend'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralReminderDto
     */
    'idAppointment'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientDetailGeneralUserCreditInfoDto
 */
export interface APIXdentDTOClientDetailGeneralUserCreditInfoDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOClientDetailGeneralUserCreditInfoDto
     */
    'credit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientDetailGeneralUserCreditInfoDto
     */
    'currency'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientFilteredDrugsDto
 */
export interface APIXdentDTOClientFilteredDrugsDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientFilteredDrugsDto
     */
    'idMagistralis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientFilteredDrugsDto
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientFilteredDrugsDto
     */
    'naz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientFilteredDrugsDto
     */
    'dop'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientFilteredDrugsDto
     */
    'dodavky'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientFilteredDrugsDto
     */
    'iskupina'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOClientShareFileFromS3ToIklientDTO
 */
export interface APIXdentDTOClientShareFileFromS3ToIklientDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientShareFileFromS3ToIklientDTO
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientShareFileFromS3ToIklientDTO
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOClientShareFileFromS3ToIklientDTO
     */
    'urlDownload'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODashboardAppointmentNotification
 */
export interface APIXdentDTODashboardAppointmentNotification {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'subject'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'dateStart'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'duration': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'confirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardAppointmentNotification
     */
    'clientRequest'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODashboardDashboardNotificationWrapper
 */
export interface APIXdentDTODashboardDashboardNotificationWrapper {
    /**
     * 
     * @type {Array<APIXdentDTODashboardNewsNotification>}
     * @memberof APIXdentDTODashboardDashboardNotificationWrapper
     */
    'news'?: Array<APIXdentDTODashboardNewsNotification> | null;
    /**
     * 
     * @type {Array<APIXdentDTODashboardSmsAnswerNotification>}
     * @memberof APIXdentDTODashboardDashboardNotificationWrapper
     */
    'smsAnswers'?: Array<APIXdentDTODashboardSmsAnswerNotification> | null;
    /**
     * 
     * @type {Array<APIXdentDTODashboardStoreItemsNotification>}
     * @memberof APIXdentDTODashboardDashboardNotificationWrapper
     */
    'storeItems'?: Array<APIXdentDTODashboardStoreItemsNotification> | null;
    /**
     * 
     * @type {Array<APIXdentDTODashboardAppointmentNotification>}
     * @memberof APIXdentDTODashboardDashboardNotificationWrapper
     */
    'appointments'?: Array<APIXdentDTODashboardAppointmentNotification> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODashboardNewsNotification
 */
export interface APIXdentDTODashboardNewsNotification {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardNewsNotification
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardNewsNotification
     */
    'description'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardNewsNotification
     */
    'dateCreated': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardNewsNotification
     */
    'link'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODashboardNewsNotification
     */
    'confirmed': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTODashboardSmsAnswerNotification
 */
export interface APIXdentDTODashboardSmsAnswerNotification {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'contentAnswer'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'dateReceived'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'confirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'color'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'dateStart'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardSmsAnswerNotification
     */
    'dateEnd'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODashboardStoreItemsNotification
 */
export interface APIXdentDTODashboardStoreItemsNotification {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardStoreItemsNotification
     */
    'idInvoiceCode': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardStoreItemsNotification
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardStoreItemsNotification
     */
    'titleMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardStoreItemsNotification
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODashboardV2TaskDto
 */
export interface APIXdentDTODashboardV2TaskDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'idTask': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'idMaster': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'idSlave': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'taskMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'taskStatusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'taskTypeCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'dateCreated': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'dateFinish': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'idBatch': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'taskPriorityCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'taskStatusLocalized'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'taskPriorityLocalized'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'unreadcount'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'dateStart'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'masterUsername'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODashboardV2TaskDto
     */
    'slaveUsername'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODentalDentalChartItemData
 */
export interface APIXdentDTODentalDentalChartItemData {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idDentalChartItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idDentalChart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idLocalizationList'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'localizationCodeList'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'localizationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idOperation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'operationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idConstruction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'constructionCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idMaterial'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'materialCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idTeethSet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'teethSetCode'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idRegion'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'regionCode'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'lastUpdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'medicalReportDateTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODentalDentalChartItemData
     */
    'postData': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTODentalDhHistory
 */
export interface APIXdentDTODentalDhHistory {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult>}
     * @memberof APIXdentDTODentalDhHistory
     */
    'history'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDHHISTORYGRIDResult> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTODentalDhHistory
     */
    'indexes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODentalGetPeridontalChartIndicesValueDataDto
 */
export interface APIXdentDTODentalGetPeridontalChartIndicesValueDataDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalGetPeridontalChartIndicesValueDataDto
     */
    'idOwner': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalGetPeridontalChartIndicesValueDataDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalGetPeridontalChartIndicesValueDataDto
     */
    'idMedicalReport': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalGetPeridontalChartIndicesValueDataDto
     */
    'dateTime'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODentalGetPeridontalChartIndicesValueResponseDto
 */
export interface APIXdentDTODentalGetPeridontalChartIndicesValueResponseDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof APIXdentDTODentalGetPeridontalChartIndicesValueResponseDto
     */
    'pC_CPI'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof APIXdentDTODentalGetPeridontalChartIndicesValueResponseDto
     */
    'pC_PBI'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODentalPeriodontalChartItemData
 */
export interface APIXdentDTODentalPeriodontalChartItemData {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'idPeriodontalChart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'idPeriodontalChartItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'localizationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'idTeethSet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'teethSetCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'lastUpdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'medicalReportDateTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'postData': boolean;
    /**
     * 
     * @type {Array<APIXdentDTODentalPeriodontalChartItemDataIndices>}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'indices'?: Array<APIXdentDTODentalPeriodontalChartItemDataIndices> | null;
    /**
     * 
     * @type {Array<APIXdentDTODentalPeriodontalChartItemDataRegions>}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'regions'?: Array<APIXdentDTODentalPeriodontalChartItemDataRegions> | null;
    /**
     * 
     * @type {APIXdentDTODentalPeriodontalIndexes}
     * @memberof APIXdentDTODentalPeriodontalChartItemData
     */
    'periodontalComputedIndexes': APIXdentDTODentalPeriodontalIndexes;
}
/**
 * 
 * @export
 * @interface APIXdentDTODentalPeriodontalChartItemDataIndices
 */
export interface APIXdentDTODentalPeriodontalChartItemDataIndices {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataIndices
     */
    'idPeriodontalChartItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataIndices
     */
    'idOperation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataIndices
     */
    'idOperationValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataIndices
     */
    'operationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataIndices
     */
    'operationValue'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODentalPeriodontalChartItemDataRegions
 */
export interface APIXdentDTODentalPeriodontalChartItemDataRegions {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataRegions
     */
    'idPeriodontalChartItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataRegions
     */
    'idOperation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataRegions
     */
    'idRegion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataRegions
     */
    'idRegionValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataRegions
     */
    'regionValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataRegions
     */
    'regionCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalChartItemDataRegions
     */
    'operationCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODentalPeriodontalIndexes
 */
export interface APIXdentDTODentalPeriodontalIndexes {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTODentalPeriodontalIndexes
     */
    'cpitn'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODentalPeriodontalIndexes
     */
    'pbi'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTODentalPeriodontalIndexes
     */
    'avg'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentAssociatedUsersToDocumentDTO
 */
export interface APIXdentDTODocumentAssociatedUsersToDocumentDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentAssociatedUsersToDocumentDTO
     */
    'idDocument'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentAssociatedUsersToDocumentDTO
     */
    'idDocumentTemplate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentAssociatedUsersToDocumentDTO
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentAssociatedUsersToDocumentDTO
     */
    'userShortName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentAssociatedUsersToDocumentDTO
     */
    'userFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentAssociatedUsersToDocumentDTO
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentAssociatedUsersToDocumentDTO
     */
    'locationName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentCreateDocumentDTO
 */
export interface APIXdentDTODocumentCreateDocumentDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateDocumentDTO
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateDocumentDTO
     */
    'idTemplate': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateDocumentDTO
     */
    'idLanguage': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateDocumentDTO
     */
    'context'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentCreateDocumentDTO
     */
    'published': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentCreateDocumentFromTemplateDTO
 */
export interface APIXdentDTODocumentCreateDocumentFromTemplateDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateDocumentFromTemplateDTO
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateDocumentFromTemplateDTO
     */
    'idDocumentTemplateLocalization': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateDocumentFromTemplateDTO
     */
    'context'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentCreateDocumentFromTemplateDTO
     */
    'published': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO
 */
export interface APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO
     */
    'idDocumentPrintFormSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO
     */
    'idLocation': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO
 */
export interface APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO
     */
    'idDocumentTemplate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO
     */
    'localizationTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO
     */
    'idType': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO
     */
    'associatedUsers'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO
     */
    'published': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO
 */
export interface APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO
     */
    'idDocumentTemplate': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO
     */
    'idDocumentTemplateLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO
     */
    'idLanguage': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO
     */
    'documentTitle': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO
     */
    'documentAnotation'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentCreateOrUpdateDocumentTemplateResponseDTO
 */
export interface APIXdentDTODocumentCreateOrUpdateDocumentTemplateResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateResponseDTO
     */
    'idDocumentTemplate': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentCreateOrUpdateDocumentTemplateResponseDTO
     */
    'idDocumentTemplateLocalization'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentDocumentBaseDTO
 */
export interface APIXdentDTODocumentDocumentBaseDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentBaseDTO
     */
    'idType': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTODocumentDocumentBaseDTO
     */
    'associatedUsers'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentDocumentBaseDTO
     */
    'published': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentDocumentDTO
 */
export interface APIXdentDTODocumentDocumentDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'idDocument': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'idTemplate': string;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'published': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'locked'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'lockedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'lockedByName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'clientFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'content'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'created': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'templateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'templateTitleCompanyLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'templateAnotationCompanyLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'templateTitleDocumentLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'templateAnotationDocumentLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'documentLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'documentTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'documentAnotation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'idAuthor': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'authorFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'idLanguage': string;
    /**
     * 
     * @type {Array<APIXdentDTODocumentAssociatedUsersToDocumentDTO>}
     * @memberof APIXdentDTODocumentDocumentDTO
     */
    'associatedUsers'?: Array<APIXdentDTODocumentAssociatedUsersToDocumentDTO> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentDocumentTemplateDTO
 */
export interface APIXdentDTODocumentDocumentTemplateDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'idDocumentTemplate': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'idType': string;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'published': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'created': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'typeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'typeTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'typeAnotation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTODocumentDocumentTemplateLocalizationDTO>}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'localizations'?: Array<APIXdentDTODocumentDocumentTemplateLocalizationDTO> | null;
    /**
     * 
     * @type {Array<APIXdentDTODocumentAssociatedUsersToDocumentDTO>}
     * @memberof APIXdentDTODocumentDocumentTemplateDTO
     */
    'associatedUsers'?: Array<APIXdentDTODocumentAssociatedUsersToDocumentDTO> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentDocumentTemplateLocalizationDTO
 */
export interface APIXdentDTODocumentDocumentTemplateLocalizationDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'idDocumentTemplateLocalization': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'idDocumentTemplate': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'idLanguage': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'content'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'version': number;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'created': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'anotation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'langCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentDocumentTemplateLocalizationDTO
     */
    'langFlagBase'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTODocumentUpdateDocumentDTO
 */
export interface APIXdentDTODocumentUpdateDocumentDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentUpdateDocumentDTO
     */
    'idDocument': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentUpdateDocumentDTO
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentUpdateDocumentDTO
     */
    'documentTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTODocumentUpdateDocumentDTO
     */
    'documentAnotation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentUpdateDocumentDTO
     */
    'published': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTODocumentUpdateDocumentDTO
     */
    'locked'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTODocumentUpdateDocumentDTO
     */
    'associatedUsers'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieClientSkDto
 */
export interface APIXdentDTOEZdravieClientSkDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieClientSkDto
     */
    'idZp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieClientSkDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieClientSkDto
     */
    'jeNeplatic': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieClientSkDto
     */
    'jruzId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieClientSkDto
     */
    'idClient': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieDiagnosisDto
 */
export interface APIXdentDTOEZdravieDiagnosisDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'codeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'shortcut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'complementarySign'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'fullCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'additionalInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'lifeThreateningDiagnosis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'diagnosisFiveDigitCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'diagnosisFiveDigitCodeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'diagnosisFourDigitCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'diagnosisFourDigitCodeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'diagnosisThreeDigitCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'diagnosisThreeDigitCodeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'subcategoryCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'subcategoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'categoryCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'categoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'chapterCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'chapterName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'subcategory2CodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieDiagnosisDto
     */
    'subcategory2Name'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieEZdravieInsuranceContextDto
 */
export interface APIXdentDTOEZdravieEZdravieInsuranceContextDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieInsuranceContextDto
     */
    'idZP'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieInsuranceContextDto
     */
    'poistovneShortName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieInsuranceContextDto
     */
    'eReceptPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieInsuranceContextDto
     */
    'eReceptLogin'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieEZdravieInsuranceContextDto
     */
    'eReceptPasswordSet': boolean;
    /**
     * 0 - None, 24 - DOVERA, 25 - VSZP, 27 - UNION
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieInsuranceContextDto
     */
    'poistovne': APIXdentDTOEZdravieEZdravieInsuranceContextDtoPoistovneEnum;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieEZdravieInsuranceContextDto
     */
    'credentialsSet': boolean;
}

export const APIXdentDTOEZdravieEZdravieInsuranceContextDtoPoistovneEnum = {
    None: 'None',
    Dovera: 'DOVERA',
    Vszp: 'VSZP',
    Union: 'UNION'
} as const;

export type APIXdentDTOEZdravieEZdravieInsuranceContextDtoPoistovneEnum = typeof APIXdentDTOEZdravieEZdravieInsuranceContextDtoPoistovneEnum[keyof typeof APIXdentDTOEZdravieEZdravieInsuranceContextDtoPoistovneEnum];

/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieEZdravieUserDto
 */
export interface APIXdentDTOEZdravieEZdravieUserDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'idUser': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'zPr_Id'?: string | null;
    /**
     * KodPredpisujuciLekar
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'zPr_Kod'?: string | null;
    /**
     * KodNZ
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'pzS_Kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'pzS_OU_ID'?: string | null;
    /**
     * ICOHlavnaZlozka
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'pzS_ICO'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'zPr_SpecExtension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'zPr_SpecDisplayName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieEZdravieUserDto
     */
    'zPr_SpecVersion': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieExtEnquequeRequestQueueDto
 */
export interface APIXdentDTOEZdravieExtEnquequeRequestQueueDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'endpoint'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'request'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'requestType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'resultType'?: string | null;
    /**
     * 0 - Sync, 1 - Async
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'callType': APIXdentDTOEZdravieExtEnquequeRequestQueueDtoCallTypeEnum;
    /**
     * 0 - Nczi, 1 - Poistovna, 2 - eObjednanieGW
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'router': APIXdentDTOEZdravieExtEnquequeRequestQueueDtoRouterEnum;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'insuranceCompany'?: APIXdentDTOEZdravieExtEnquequeRequestQueueDtoInsuranceCompanyEnum;
    /**
     * 0 - None, 1 - BOK, 2 - NOBOK, 3 - VYZVA, 4 - OWN
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'ppcType': APIXdentDTOEZdravieExtEnquequeRequestQueueDtoPpcTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'priority'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'shouldRetry'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOEZdravieExtEnquequeRequestQueueDto
     */
    'retryUntil'?: Date | null;
}

export const APIXdentDTOEZdravieExtEnquequeRequestQueueDtoCallTypeEnum = {
    Sync: 'Sync',
    Async: 'Async'
} as const;

export type APIXdentDTOEZdravieExtEnquequeRequestQueueDtoCallTypeEnum = typeof APIXdentDTOEZdravieExtEnquequeRequestQueueDtoCallTypeEnum[keyof typeof APIXdentDTOEZdravieExtEnquequeRequestQueueDtoCallTypeEnum];
export const APIXdentDTOEZdravieExtEnquequeRequestQueueDtoRouterEnum = {
    Nczi: 'Nczi',
    Poistovna: 'Poistovna',
    EObjednanieGw: 'eObjednanieGW'
} as const;

export type APIXdentDTOEZdravieExtEnquequeRequestQueueDtoRouterEnum = typeof APIXdentDTOEZdravieExtEnquequeRequestQueueDtoRouterEnum[keyof typeof APIXdentDTOEZdravieExtEnquequeRequestQueueDtoRouterEnum];
export const APIXdentDTOEZdravieExtEnquequeRequestQueueDtoInsuranceCompanyEnum = {
    None: 'None',
    Dovera: 'DOVERA',
    Vszp: 'VSZP',
    Union: 'UNION'
} as const;

export type APIXdentDTOEZdravieExtEnquequeRequestQueueDtoInsuranceCompanyEnum = typeof APIXdentDTOEZdravieExtEnquequeRequestQueueDtoInsuranceCompanyEnum[keyof typeof APIXdentDTOEZdravieExtEnquequeRequestQueueDtoInsuranceCompanyEnum];
export const APIXdentDTOEZdravieExtEnquequeRequestQueueDtoPpcTypeEnum = {
    None: 'None',
    Bok: 'BOK',
    Nobok: 'NOBOK',
    Vyzva: 'VYZVA',
    Own: 'OWN'
} as const;

export type APIXdentDTOEZdravieExtEnquequeRequestQueueDtoPpcTypeEnum = typeof APIXdentDTOEZdravieExtEnquequeRequestQueueDtoPpcTypeEnum[keyof typeof APIXdentDTOEZdravieExtEnquequeRequestQueueDtoPpcTypeEnum];

/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieExtLogRequestDto
 */
export interface APIXdentDTOEZdravieExtLogRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'healthProfessionalIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'jruzIdClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'endpoint'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'request'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'requestRaw'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'resultRaw'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'requestType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'resultType'?: string | null;
    /**
     * 0 - Sync, 1 - Async
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'callType': APIXdentDTOEZdravieExtLogRequestDtoCallTypeEnum;
    /**
     * 0 - Nczi, 1 - Poistovna, 2 - eObjednanieGW
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'router': APIXdentDTOEZdravieExtLogRequestDtoRouterEnum;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'insuranceCompany'?: APIXdentDTOEZdravieExtLogRequestDtoInsuranceCompanyEnum;
    /**
     * 0 - None, 1 - BOK, 2 - NOBOK, 3 - VYZVA, 4 - OWN
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'ppcType': APIXdentDTOEZdravieExtLogRequestDtoPpcTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'shouldRetry'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLogRequestDto
     */
    'errorMessage'?: string | null;
}

export const APIXdentDTOEZdravieExtLogRequestDtoCallTypeEnum = {
    Sync: 'Sync',
    Async: 'Async'
} as const;

export type APIXdentDTOEZdravieExtLogRequestDtoCallTypeEnum = typeof APIXdentDTOEZdravieExtLogRequestDtoCallTypeEnum[keyof typeof APIXdentDTOEZdravieExtLogRequestDtoCallTypeEnum];
export const APIXdentDTOEZdravieExtLogRequestDtoRouterEnum = {
    Nczi: 'Nczi',
    Poistovna: 'Poistovna',
    EObjednanieGw: 'eObjednanieGW'
} as const;

export type APIXdentDTOEZdravieExtLogRequestDtoRouterEnum = typeof APIXdentDTOEZdravieExtLogRequestDtoRouterEnum[keyof typeof APIXdentDTOEZdravieExtLogRequestDtoRouterEnum];
export const APIXdentDTOEZdravieExtLogRequestDtoInsuranceCompanyEnum = {
    None: 'None',
    Dovera: 'DOVERA',
    Vszp: 'VSZP',
    Union: 'UNION'
} as const;

export type APIXdentDTOEZdravieExtLogRequestDtoInsuranceCompanyEnum = typeof APIXdentDTOEZdravieExtLogRequestDtoInsuranceCompanyEnum[keyof typeof APIXdentDTOEZdravieExtLogRequestDtoInsuranceCompanyEnum];
export const APIXdentDTOEZdravieExtLogRequestDtoPpcTypeEnum = {
    None: 'None',
    Bok: 'BOK',
    Nobok: 'NOBOK',
    Vyzva: 'VYZVA',
    Own: 'OWN'
} as const;

export type APIXdentDTOEZdravieExtLogRequestDtoPpcTypeEnum = typeof APIXdentDTOEZdravieExtLogRequestDtoPpcTypeEnum[keyof typeof APIXdentDTOEZdravieExtLogRequestDtoPpcTypeEnum];

/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieExtLoginDto
 */
export interface APIXdentDTOEZdravieExtLoginDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLoginDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtLoginDto
     */
    'certHash'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieExtRequestDto
 */
export interface APIXdentDTOEZdravieExtRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'idRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'healthProfessionalIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'jruzIdClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'endpoint'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'request'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'requestType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'result'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'resultType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'callType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'router'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'insuranceCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'ppcType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'priority'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'processed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'shouldRetry'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'tryCount'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'dateLastTry'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieExtRequestDto
     */
    'isPaused'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieExtRequestResultDto
 */
export interface APIXdentDTOEZdravieExtRequestResultDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'idRequest': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'rawRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'rawResponse'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'jsonResult'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'isSuccess': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'retryStopRequested': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'endpoint'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieExtRequestResultDto
     */
    'shouldPause'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieGenerateEZdravieIdDto
 */
export interface APIXdentDTOEZdravieGenerateEZdravieIdDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGenerateEZdravieIdDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGenerateEZdravieIdDto
     */
    'oid'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieGetDataByIdOUPZSDto
 */
export interface APIXdentDTOEZdravieGetDataByIdOUPZSDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdOUPZSDto
     */
    'idOUPZS'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdOUPZSDto
     */
    'idZPr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdOUPZSDto
     */
    'kodZPr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdOUPZSDto
     */
    'zdravotnickaOdbornost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdOUPZSDto
     */
    'givenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdOUPZSDto
     */
    'familyName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieGetDataByIdZPrDto
 */
export interface APIXdentDTOEZdravieGetDataByIdZPrDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdZPrDto
     */
    'idZPr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdZPrDto
     */
    'givenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdZPrDto
     */
    'familyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdZPrDto
     */
    'kodZPr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdZPrDto
     */
    'zdravotnickaOdbornost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdZPrDto
     */
    'idOUPZS'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdZPrDto
     */
    'kodPZS'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieGetDataByIdZPrDto
     */
    'idPZS'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieIndicationLimitationDto
 */
export interface APIXdentDTOEZdravieIndicationLimitationDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieIndicationLimitationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieIndicationLimitationDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieIndicationLimitationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieIndicationLimitationDto
     */
    'atc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieIndicationLimitationDto
     */
    'po'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieIndicationLimitationDto
     */
    'po2'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieInsuranceSettingsDto
 */
export interface APIXdentDTOEZdravieInsuranceSettingsDto {
    /**
     * 
     * @type {Array<APIXdentDTOEZdravieEZdravieInsuranceContextDto>}
     * @memberof APIXdentDTOEZdravieInsuranceSettingsDto
     */
    'insurances'?: Array<APIXdentDTOEZdravieEZdravieInsuranceContextDto> | null;
    /**
     * 
     * @type {APIXdentDTOEZdravieEZdravieUserDto}
     * @memberof APIXdentDTOEZdravieInsuranceSettingsDto
     */
    'user': APIXdentDTOEZdravieEZdravieUserDto;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieMedicalAidToolDto
 */
export interface APIXdentDTOEZdravieMedicalAidToolDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'toolId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'sizeAndType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'purpose'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'amountInPackageSpecified'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'amountInPackage'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'isBaseFunctionalType'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'isBaseFunctionalTypeSpecified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'usageGuide'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'isTailored'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'medicalClass'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'isSpecializedMaterial'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'manufacturer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'recipeValidityUnit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'recipeValidityValue'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'isCategoryInfoSpecified'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'maxPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'maxPriceUnit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'insurancePayPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicalAidToolDto
     */
    'insurancePayUnit'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieMedicamentDto
 */
export interface APIXdentDTOEZdravieMedicamentDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'medicamentId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'isAntibioticChemotherapy'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'additionalName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'isGenericPrescription'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'isVaccine'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'suklCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'isRegistrationInfoSpecified'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'packagingSize'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'packagingUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'atcCodelistCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'atcCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'atcName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'isCategoryInfoSpecified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'intake'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'opl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'lpDependency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'medicamentForm'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'medicamentAmountSize'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'medicamentAmountUnit'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'medicamentSpecified'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'recipeExpirationSize'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'recipeExpirationUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'vsrAvailability'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'pharmacyPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'pharmacyUnit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'surchargePrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'surchargeUnit'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'isMultiplePrescriptionAllowed'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'insurancePayPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'insurancePayUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'lpDependencyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'medicamentNames'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'indicationLimitations'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOEZdravieIndicationLimitationDto>}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'indicationLimitationList'?: Array<APIXdentDTOEZdravieIndicationLimitationDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'po'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'po2'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'poList'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'po2List'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieMedicamentDto
     */
    'atcDoplnok'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEZdravieUlozPreskripcnyZaznamDto
 */
export interface APIXdentDTOEZdravieUlozPreskripcnyZaznamDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieUlozPreskripcnyZaznamDto
     */
    'idPreskripcnyZaznam'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieUlozPreskripcnyZaznamDto
     */
    'idOwner': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieUlozPreskripcnyZaznamDto
     */
    'idClient': string;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam}
     * @memberof APIXdentDTOEZdravieUlozPreskripcnyZaznamDto
     */
    'preskripcnyZaznam': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup}
     * @memberof APIXdentDTOEZdravieUlozPreskripcnyZaznamDto
     */
    'preskripcnyZaznamVystup': XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieUlozPreskripcnyZaznamDto
     */
    'medicamentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEZdravieUlozPreskripcnyZaznamDto
     */
    'pzSection'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEpodaniCreateCsszEpodaniRequestDto
 */
export interface APIXdentDTOEpodaniCreateCsszEpodaniRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEpodaniCreateCsszEpodaniRequestDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEpodaniCreateCsszEpodaniRequestDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRINEMPRI}
     * @memberof APIXdentDTOEpodaniCreateCsszEpodaniRequestDto
     */
    'nempri': APIXdentHelpersESubmissionNEMPRINEMPRI;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEpodaniCreateEpodaniRequestDto
 */
export interface APIXdentDTOEpodaniCreateEpodaniRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEpodaniCreateEpodaniRequestDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEpodaniCreateEpodaniRequestDto
     */
    'jsonData'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEpodaniGetExternalSignDataResponse
 */
export interface APIXdentDTOEpodaniGetExternalSignDataResponse {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEpodaniGetExternalSignDataResponse
     */
    'idRequest': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEpodaniGetExternalSignDataResponse
     */
    'externalBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEpodaniValidateRequestDto
 */
export interface APIXdentDTOEpodaniValidateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEpodaniValidateRequestDto
     */
    'jsonData'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptCopyPrescriptionDto
 */
export interface APIXdentDTOEreceptCopyPrescriptionDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'idMedicalPrescription': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'idMedicalPrescriptionPrev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'dateIssue': Date;
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSEFORMResult}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'diagnoseData': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSEFORMResult;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'diagnose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'idInsurance': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'insuranceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'akutni': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'family': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'uhrada'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOEreceptPrescriptionDrugDto>}
     * @memberof APIXdentDTOEreceptCopyPrescriptionDto
     */
    'drugs'?: Array<APIXdentDTOEreceptPrescriptionDrugDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptDrugDto
 */
export interface APIXdentDTOEreceptDrugDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'dosage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'packaging'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'ammount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'amount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'idDrug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'idMagistralis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'naz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'dop'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'dodavky'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptDrugDto
     */
    'iskupina'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptEreceptError
 */
export interface APIXdentDTOEreceptEreceptError {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptEreceptError
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptEreceptError
     */
    'skupina'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptEreceptError
     */
    'popis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptEreceptError
     */
    'doporuceni'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptMagistralisData
 */
export interface APIXdentDTOEreceptMagistralisData {
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult}
     * @memberof APIXdentDTOEreceptMagistralisData
     */
    'info': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult>}
     * @memberof APIXdentDTOEreceptMagistralisData
     */
    'magistralisDetail'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISSUBSTANCEGRIDResult> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptMagistralisSaveDataDto
 */
export interface APIXdentDTOEreceptMagistralisSaveDataDto {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEreceptMagistralisSaveDataDto
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptMagistralisSaveDataDto
     */
    'idMagistralisSubstance': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptMagistralisSaveDataDto
     */
    'idMagistralis': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptMagistralisSaveDataDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptMagistralisSaveDataDto
     */
    'amout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptMagistralisSaveDataDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptMagistralisSaveDataDto
     */
    'substanceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptMagistralisSaveDataDto
     */
    'substanceCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptMagistralisSaveDto
 */
export interface APIXdentDTOEreceptMagistralisSaveDto {
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult}
     * @memberof APIXdentDTOEreceptMagistralisSaveDto
     */
    'magistralisData': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult;
    /**
     * 
     * @type {Array<APIXdentDTOEreceptMagistralisSaveDataDto>}
     * @memberof APIXdentDTOEreceptMagistralisSaveDto
     */
    'magistralisDetailData'?: Array<APIXdentDTOEreceptMagistralisSaveDataDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptMagistralisSaveResponseDto
 */
export interface APIXdentDTOEreceptMagistralisSaveResponseDto {
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult}
     * @memberof APIXdentDTOEreceptMagistralisSaveResponseDto
     */
    'info': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMAGISTRALISFORMResult;
    /**
     * 
     * @type {Array<APIXdentDTOEreceptMagistralisSaveDataDto>}
     * @memberof APIXdentDTOEreceptMagistralisSaveResponseDto
     */
    'magistralisDetail'?: Array<APIXdentDTOEreceptMagistralisSaveDataDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptPrescriptionDetailDto
 */
export interface APIXdentDTOEreceptPrescriptionDetailDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDetailDto
     */
    'idDrug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDetailDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDetailDto
     */
    'dosage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEreceptPrescriptionDetailDto
     */
    'amount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDetailDto
     */
    'idMagistralis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDetailDto
     */
    'iskupina'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDetailDto
     */
    'packaging'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDetailDto
     */
    'amountText'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptPrescriptionDrugDto
 */
export interface APIXdentDTOEreceptPrescriptionDrugDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'amount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'dosage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'idDrug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'idMagistralis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'naz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'dop'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'dodavky'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'iskupina'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'packaging'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOEreceptPrescriptionDrugDto
     */
    'position': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptPrescriptionDto
 */
export interface APIXdentDTOEreceptPrescriptionDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'idEreceptFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'idMedicalPrescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'ownerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'dateIssue'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'dateIss'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'insuranceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'diagnose'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOEreceptDrugDto>}
     * @memberof APIXdentDTOEreceptPrescriptionDto
     */
    'drugs'?: Array<APIXdentDTOEreceptDrugDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptSavePrescriptionDto
 */
export interface APIXdentDTOEreceptSavePrescriptionDto {
    /**
     * 
     * @type {APIXdentDTOEreceptPrescriptionDto}
     * @memberof APIXdentDTOEreceptSavePrescriptionDto
     */
    'prescriptionData': APIXdentDTOEreceptPrescriptionDto;
    /**
     * 
     * @type {Array<APIXdentDTOEreceptPrescriptionDetailDto>}
     * @memberof APIXdentDTOEreceptSavePrescriptionDto
     */
    'prescriptionDetailData'?: Array<APIXdentDTOEreceptPrescriptionDetailDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEreceptSavePrescriptionDto
     */
    'eRecept': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionDto
     */
    'notifyTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionDto
     */
    'uhradaIn'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEreceptSavePrescriptionDto
     */
    'family': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEreceptSavePrescriptionDto
     */
    'akutni': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptSavePrescriptionResponseDto
 */
export interface APIXdentDTOEreceptSavePrescriptionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionResponseDto
     */
    'idPrescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionResponseDto
     */
    'idPrescriptionRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionResponseDto
     */
    'prescriptionCmdLine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEreceptSavePrescriptionResponseDto
     */
    'xmlStatus': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionResponseDto
     */
    'iSkupina1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionResponseDto
     */
    'iSkupina2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionResponseDto
     */
    'hash'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSavePrescriptionResponseDto
     */
    'digestValue'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptSendSignedElectronicPrescriptionDto
 */
export interface APIXdentDTOEreceptSendSignedElectronicPrescriptionDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSendSignedElectronicPrescriptionDto
     */
    'idRequest': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSendSignedElectronicPrescriptionDto
     */
    'digestValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSendSignedElectronicPrescriptionDto
     */
    'signatureValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSendSignedElectronicPrescriptionDto
     */
    'x509SubjectName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSendSignedElectronicPrescriptionDto
     */
    'x509Certificate'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
 */
export interface APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'status': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'resultMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'idFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'file'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'iD_Dokladu'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOEreceptEreceptError>}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'errors'?: Array<APIXdentDTOEreceptEreceptError> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'errorsCompleteMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {APIXdentDTOEreceptTempValidSignature}
     * @memberof APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto
     */
    'tempTest': APIXdentDTOEreceptTempValidSignature;
}
/**
 * 
 * @export
 * @interface APIXdentDTOEreceptTempValidSignature
 */
export interface APIXdentDTOEreceptTempValidSignature {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptTempValidSignature
     */
    'signatureValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptTempValidSignature
     */
    'x509SubjectName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOEreceptTempValidSignature
     */
    'x509Certificate'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOGalleryEditGalleryFileMetadataDto
 */
export interface APIXdentDTOGalleryEditGalleryFileMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGalleryEditGalleryFileMetadataDto
     */
    'idExistingFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGalleryEditGalleryFileMetadataDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGalleryEditGalleryFileMetadataDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<APISharedDTOGalleryTagDto>}
     * @memberof APIXdentDTOGalleryEditGalleryFileMetadataDto
     */
    'tagList'?: Array<APISharedDTOGalleryTagDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOGalleryGetFilesGridDto
 */
export interface APIXdentDTOGalleryGetFilesGridDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOGalleryGetFilesGridDto
     */
    'masterList'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOGalleryGetFilesGridDto
     */
    'tagList'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOGalleryGetFilesGridDto
     */
    'systemTagList'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGalleryGetFilesGridDto
     */
    'mimeType'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOGallerySaveProfilePhotoRequestDto
 */
export interface APIXdentDTOGallerySaveProfilePhotoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGallerySaveProfilePhotoRequestDto
     */
    'idFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGallerySaveProfilePhotoRequestDto
     */
    'idClient': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOGalleryUpdateClientBadgeColorRequestDto
 */
export interface APIXdentDTOGalleryUpdateClientBadgeColorRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGalleryUpdateClientBadgeColorRequestDto
     */
    'hex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGalleryUpdateClientBadgeColorRequestDto
     */
    'idClient': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOGovEreceptZalozitPredpisRequestDto
 */
export interface APIXdentDTOGovEreceptZalozitPredpisRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGovEreceptZalozitPredpisRequestDto
     */
    'idRequest': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOGovVzpRegistracePojistenceRequestDto
 */
export interface APIXdentDTOGovVzpRegistracePojistenceRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOGovVzpRegistracePojistenceRequestDto
     */
    'idClient': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceClientPartnerFilterHelpDto
 */
export interface APIXdentDTOInvoiceClientPartnerFilterHelpDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'idPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'regNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'vatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'insuranceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'itemClass'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceClientPartnerFilterHelpDto
     */
    'badgeColor'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceCodeLocalizationDto
 */
export interface APIXdentDTOInvoiceInvoiceCodeLocalizationDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodeLocalizationDto
     */
    'idInvoiceCode': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodeLocalizationDto
     */
    'idLanguage': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodeLocalizationDto
     */
    'languageCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodeLocalizationDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodeLocalizationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodeLocalizationDto
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceCodesItemDto
 */
export interface APIXdentDTOInvoiceInvoiceCodesItemDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idCodeParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idCodeMacro'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idCodeStoreRecipe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idPriceLevel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'priceLevelName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'codeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'pricePerMin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'priceLaboratory'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'priceAverage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'laboratoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'finalPriceStr'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'finalPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'localizationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idMaterialType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'materialCodeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'materialTypeName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'quantityStore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'quantityNotify'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'externalID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idInvoiceCodeStoreExternalLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'idVATRate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'vatRate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'laboratoryColor'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'searchActive'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'show': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'maxBuyPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'expirationNotifyBefore'?: number | null;
    /**
     * 
     * @type {Array<APIXdentDTOInvoiceInvoiceCodeLocalizationDto>}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemDto
     */
    'localizations'?: Array<APIXdentDTOInvoiceInvoiceCodeLocalizationDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceCodesItemHelpDto
 */
export interface APIXdentDTOInvoiceInvoiceCodesItemHelpDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idCodeParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idCodeMacro'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idCodeStoreRecipe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idPriceLevel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'priceLevelName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'codeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'pricePerMin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'priceLaboratory'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'priceAverage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'laboratoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'finalPriceStr'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'finalPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'localizationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idMaterialType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'materialCodeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'materialTypeName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'quantityStore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'quantityNotify'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'externalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idInvoiceCodeStoreExternalLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'idVatRate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'vatRate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'laboratoryColor'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'searchActive'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'show': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'maxBuyPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'expirationNotifyBefore'?: number | null;
    /**
     * 
     * @type {Array<APIXdentDTOInvoiceInvoiceCodeLocalizationDto>}
     * @memberof APIXdentDTOInvoiceInvoiceCodesItemHelpDto
     */
    'localizations'?: Array<APIXdentDTOInvoiceInvoiceCodeLocalizationDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceDataDto
 */
export interface APIXdentDTOInvoiceInvoiceDataDto {
    /**
     * 
     * @type {APIXdentDTOInvoiceInvoiceInfoDto}
     * @memberof APIXdentDTOInvoiceInvoiceDataDto
     */
    'info': APIXdentDTOInvoiceInvoiceInfoDto;
    /**
     * 
     * @type {APIXdentDTOInvoiceInvoicePrintInfoDto}
     * @memberof APIXdentDTOInvoiceInvoiceDataDto
     */
    'printinfo': APIXdentDTOInvoiceInvoicePrintInfoDto;
    /**
     * 
     * @type {Array<APIXdentDTOInvoiceInvoiceItemDto>}
     * @memberof APIXdentDTOInvoiceInvoiceDataDto
     */
    'items'?: Array<APIXdentDTOInvoiceInvoiceItemDto> | null;
    /**
     * 
     * @type {Array<APIXdentDTOInvoiceInvoicePaymentItemDto>}
     * @memberof APIXdentDTOInvoiceInvoiceDataDto
     */
    'payments'?: Array<APIXdentDTOInvoiceInvoicePaymentItemDto> | null;
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult}
     * @memberof APIXdentDTOInvoiceInvoiceDataDto
     */
    'eet': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICEEETFORMResult;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceExportConfigDto
 */
export interface APIXdentDTOInvoiceInvoiceExportConfigDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOInvoiceInvoiceExportConfigDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceExportConfigDto
     */
    'format'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceExportRangeConfigDto
 */
export interface APIXdentDTOInvoiceInvoiceExportRangeConfigDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceExportRangeConfigDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceExportRangeConfigDto
     */
    'start': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceExportRangeConfigDto
     */
    'end': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceExportRangeConfigDto
     */
    'format'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceGridInfoDto
 */
export interface APIXdentDTOInvoiceInvoiceGridInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'dateIssue': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'dateLastChange': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'supervisorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'nameSupervisorChange'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'locationSupervisorChange'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'locationPositionSupervisorChange'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'idBillingUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'billingName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'billingSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'billingAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'idInvoiceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'invoiceTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'invoiceTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'idBillingType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'billingTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'idDiscountType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'discountTypeCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'discount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'deposit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'credit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'total'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'priceService'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'priceMaterial'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'priceDiscount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'currencySymbol'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'paid'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'toPay'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'pricePayments'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'pricePaymentsDate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'eetLock'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'eetInvoiceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'lockCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'summaryLock'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'idSupervisor'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'emailSent'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'iklientShared'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'emailDelivered'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'emailDeliveredDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceGridInfoDto
     */
    'idPartner'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceInfoDto
 */
export interface APIXdentDTOInvoiceInvoiceInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idSupervisor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idBillingType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idInvoiceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idDiscountType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idCurrencyTotal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'currencyTotalCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'currencyRate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'dateIssue': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'dateDue': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'dateTax'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'deposit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'discount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'total'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'credit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingPost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingRegNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'billingVatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'paid'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'toPay'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'currency'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'clientCredit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'pricePayments'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'report'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'storeStatus': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'lockCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'invoicePayVAT': number;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'emailSent'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceInfoDto
     */
    'iklientShared'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceItemDto
 */
export interface APIXdentDTOInvoiceInvoiceItemDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'idDiagnosis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'idInvoiceDetail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'idInvoiceDetailGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'idParentGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'idInvoiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'codeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'materialCodeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'idCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'unitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'pricePerMinute'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'priceLaboratory'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'codeTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'localizationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'lot'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceItemDto
     */
    'exp'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoicePaymentItemDto
 */
export interface APIXdentDTOInvoiceInvoicePaymentItemDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'idInvoicePayment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'supervisorFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'idBillingType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'billingTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'billingTypeCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'datePayment': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'datePaymentStr'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'pricePayment'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'currencySymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'eetLock'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'lockCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'idPaymentRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'idPaymentTerminal'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'paymentTerminalDeviceID'?: any | null;
    /**
     * 
     * @type {any}
     * @memberof APIXdentDTOInvoiceInvoicePaymentItemDto
     */
    'paymentTerminalDeviceName'?: any | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoicePrintInfoDto
 */
export interface APIXdentDTOInvoiceInvoicePrintInfoDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'invoiceNumber': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'invoiceTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'officeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'officeStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'officeCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'officePost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'officeCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'officeWeb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'officeEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'officePhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'regNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'vatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'accountNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'bankCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'providerSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'providerDegree'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'providerDegreeAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'issuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'issuerSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'issuerEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'issuerEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'billingTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'invoiceTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'discountTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'currencySymbol'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoicePrintInfoDto
     */
    'printMacroDetail'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceReturnInfoDto
 */
export interface APIXdentDTOInvoiceInvoiceReturnInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceReturnInfoDto
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceReturnInfoDto
     */
    'invoiceNumber': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceSettingsDto
 */
export interface APIXdentDTOInvoiceInvoiceSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'fiscalYear': number;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'useStore': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'autoPayment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'invoiceItemAddEdit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'printMacroDetail': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'idInvoiceTypeDefault': string;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'invoiceEetSumType': number;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'invoiceEetForce': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'isCentralStoreEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceSettingsDto
     */
    'idStoreLocation'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceInvoiceTransactionInfoDto
 */
export interface APIXdentDTOInvoiceInvoiceTransactionInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idInvoicePayment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'datePayment': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'dateIssue': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'staffFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'staffEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'staffEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idSupervisor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'supervisorFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'supervisorEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'supervisorEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'supervisorLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'supervisorLocationPosition'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'clientFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'clientEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'clientEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'partnerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idBillingType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'billingTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'pricePayment'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'currencySymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'invoiceCodeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idInvoiceLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'idStaffLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'invoiceLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'staffLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'eetLock'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceInvoiceTransactionInfoDto
     */
    'lockCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceNoteInvoiceNoteDto
 */
export interface APIXdentDTOInvoiceNoteInvoiceNoteDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceNoteInvoiceNoteDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceNoteInvoiceNoteDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceNoteInvoiceNoteDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceSaveInvoiceDto
 */
export interface APIXdentDTOInvoiceSaveInvoiceDto {
    /**
     * 
     * @type {APIXdentDTOInvoiceInvoiceInfoDto}
     * @memberof APIXdentDTOInvoiceSaveInvoiceDto
     */
    'info': APIXdentDTOInvoiceInvoiceInfoDto;
    /**
     * 
     * @type {Array<APIXdentDTOInvoiceInvoiceItemDto>}
     * @memberof APIXdentDTOInvoiceSaveInvoiceDto
     */
    'items'?: Array<APIXdentDTOInvoiceInvoiceItemDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceSaveInvoiceDto
     */
    'payment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceSaveInvoiceDto
     */
    'delTransaction': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOInvoiceSaveInvoiceDto
     */
    'updateStore': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSaveInvoiceDto
     */
    'idReport'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOInvoiceSummaryInvoiceDto
 */
export interface APIXdentDTOInvoiceSummaryInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'idSummaryInvoice': string;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'summaryInvoiceNumber': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'idLocation': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'idInvoicePartner'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'dateCreated': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'issuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'partnerName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'dateFrom': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'dateTo': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'idIssuer': string;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'invoicesCount': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOInvoiceSummaryInvoiceDto
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOLabinoReadLabRequestsNotificationDto
 */
export interface APIXdentDTOLabinoReadLabRequestsNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLabinoReadLabRequestsNotificationDto
     */
    'idLabLaboratoryRequest'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOLegacySearchAvailableTimeDto
 */
export interface APIXdentDTOLegacySearchAvailableTimeDto {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOLegacySearchAvailableTimeDto
     */
    'start': Date;
}
/**
 * Foreign key CompanyFk removed, Foreign key GlobalFk removed
 * @export
 * @interface APIXdentDTOLocationLocationDto
 */
export interface APIXdentDTOLocationLocationDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idAddressOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idLogo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'regNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'vatNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'icz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'accountNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'bankCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'swift'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'iban'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'writtenBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'web'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'facebook'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'twitter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'instagram'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'onlineAvalaible'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'vozp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'nameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'webOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'emailOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'phoneOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eetLocationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eetDeviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eetType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eetCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eetPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eetCertificateName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eetActive'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eetStartDate'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'invoicePayVAT'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eReceptCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eReceptPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eReceptID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eReceptCertificateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'ideReceptPhonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eReceptPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'uolDatabaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'uolLoginToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idLogoOriginal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idLogoBooking'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idLogoBox'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idExpertiseType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'invoiceSeriesActive'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'invoiceSeriesNumber'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'invoiceCustomDue'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'forcePaymentTypePick'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'eReceptAutoRenewDisable'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'insuranceCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'insurenceCertificatePassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'insuranceCompanyNotUsed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'insuranceCertificateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'insuranceBankAccountNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'insuranceBankCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'insuranceForceAltBankAccount'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'customColors'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'ereceptPayment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'insuranceVariableSymbol'?: string | null;
    /**
     * 
     * @type {APIContextGeneratedXdentCoreEntityLayerAddress}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'address': APIContextGeneratedXdentCoreEntityLayerAddress;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'logoImageContent'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOLocationLocationWorkingHourItemDto>}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'openingHours'?: Array<APIXdentDTOLocationLocationWorkingHourItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'idHcfLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'miniWebsite'?: string | null;
    /**
     * 
     * @type {APIXdentDTOLocationLocationGeocacheDto}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'geocache': APIXdentDTOLocationLocationGeocacheDto;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationDto
     */
    'post'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOLocationLocationGeocacheDto
 */
export interface APIXdentDTOLocationLocationGeocacheDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationGeocacheDto
     */
    'idEntity'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationGeocacheDto
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationGeocacheDto
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationGeocacheDto
     */
    'map'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOLocationLocationWorkingHourItemDto
 */
export interface APIXdentDTOLocationLocationWorkingHourItemDto {
    /**
     * 
     * @type {APIContextGeneratedXdentCoreEntityLayerSetOpeningHours}
     * @memberof APIXdentDTOLocationLocationWorkingHourItemDto
     */
    'openingHours': APIContextGeneratedXdentCoreEntityLayerSetOpeningHours;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOLocationLocationWorkingHourItemDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOLocationLocationWorkingHourItemDto
     */
    'list'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordDiagnosisSaveDto
 */
export interface APIXdentDTOMedicalRecordDiagnosisSaveDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'idDiagnosis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'idDiagnosisGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'idParentGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'idInvoiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'codeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'localization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'material'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'area'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'unitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'priceLaboratory'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'pricePerMinute'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'lot'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordDiagnosisSaveDto
     */
    'exp'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordInsuranceClientHistoryDto
 */
export interface APIXdentDTOMedicalRecordInsuranceClientHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'codeDiagnose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'lokalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'paymentTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'amount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'patientPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'insurancePrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'laboratoryPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'doctor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'laboratoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'diagnoseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'itemsName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryDto
     */
    'date'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
 */
export interface APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'idMedicalReport': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'codeDiagnose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'lokalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'paymentTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'amount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'patientPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'insurancePrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'laboratoryPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'doctor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'laboratoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'diagnoseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'itemsName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto
     */
    'date'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordInsuranceItemSaveDto
 */
export interface APIXdentDTOMedicalRecordInsuranceItemSaveDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'idInsuranceReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'naz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'localization': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'patiencePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'insurancePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'insurancePoints'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'codeDiagnose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'codeDiagnoseItem'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'laboratoryPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'idPaymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'customCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordInsuranceItemSaveDto
     */
    'idLaboratoryCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportExamDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportExamDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'idMedicalReportExam'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'idMedicalReportExamSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'idMedicalReportExamOptionSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'dateUpdated'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'resultDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'resultTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamDto
     */
    'examTitle'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto
     */
    'idMedicalReportExamOptionSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto
     */
    'idMedicalReportExamSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto
     */
    'resultTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto
     */
    'resultDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportExamSettingsDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportExamSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamSettingsDto
     */
    'idMedicalReportExamSettings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamSettingsDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamSettingsDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamSettingsDto
     */
    'examTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportExamSettingsDto
     */
    'resultTitles'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto
     */
    'externGrid'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult> | null;
    /**
     * 
     * @type {Array<APIXdentDTOClientDetailGeneralPrescriptionDto>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto
     */
    'prescriptionGrid'?: Array<APIXdentDTOClientDetailGeneralPrescriptionDto> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto
     */
    'medicalExaminationGrid'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto
     */
    'doctorPasses'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto
     */
    'transportOrders'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto
     */
    'laboratoryLabels'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportInsuranceDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportInsuranceDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'codeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'kod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'naz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'localization'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'patiencePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'insurancePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'laboratoryPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'codeDiagnose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'codeDiagnoseItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'created'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'idStaffInsurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'idPaymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'paymentTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'idLaboratoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'customCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'maxCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportInsuranceDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportPregnancyDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportPregnancyDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idMedicalReportPregnancy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idMedicalReportPregnancyPrev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'evidenceFrom'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idPara'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idGRHType'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'pregnancyByUltrasound'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'pregnancyByLastMenstruation'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'lastMenstruationDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'firstMovementsDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'birthByUltrasound'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'birthByLastMenstruation'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'prePregnancyWeight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idFrequency'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'pelvisSize'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'pregnantUntil'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idTerminationMethod'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'evidenceTo'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'dateUpdated'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'staffFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'staffLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'staffEducationBefore'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyDto
     */
    'staffEducationAfter'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'idMedicalReportPregnancyExam'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'idMedicalReportPregnancy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'bloodPressureSystolic'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'bloodPressureDiastolic'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'weight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'sugarLevel'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'protein'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'ketones'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'edem'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'dateCreated'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'dateUpdated'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'grhTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'grhTypeId'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'pregnancyByLastMenstruation'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto
     */
    'pregnancyByUltrasound'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportSaveDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportSaveDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'idReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'idStaff': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'staffEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'staffEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'staffFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'staffLastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'idStaffInsurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'staffInsuranceEducation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'staffInsuranceEducationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'staffInsuranceFirstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'staffInsuranceLastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'insuranceReportedCodes'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'toothLocalizations'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'isLockedReport': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'isGallery': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'isDentalChart': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'medicalPrescriptionsCount': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'insuranceRegistrationsCount': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'medicalReportExternsCount': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'laboratoryLabelsCount': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'locationStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'locationCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'locationPost'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'locationRegNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveDto
     */
    'idSupervisor'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto
 */
export interface APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto {
    /**
     * 
     * @type {APIXdentDTOMedicalRecordMedicalReportSaveDto}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto
     */
    'report': APIXdentDTOMedicalRecordMedicalReportSaveDto;
    /**
     * 
     * @type {Array<APIXdentDTOMedicalRecordDiagnosisSaveDto>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto
     */
    'diagnosis'?: Array<APIXdentDTOMedicalRecordDiagnosisSaveDto> | null;
    /**
     * 
     * @type {Array<APIXdentDTOMedicalRecordInsuranceItemSaveDto>}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto
     */
    'insurance'?: Array<APIXdentDTOMedicalRecordInsuranceItemSaveDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto
     */
    'reportType'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTONCZIReportSendReportApiDto
 */
export interface APIXdentDTONCZIReportSendReportApiDto {
    /**
     * base64bytes
     * @type {string}
     * @memberof APIXdentDTONCZIReportSendReportApiDto
     */
    'statement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTONCZIReportSendReportApiDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTONCZIReportSendReportApiDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTONCZIReportSendReportApiDto
     */
    'idNcziReport'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTONCZIReportSendReportApiResponseDto
 */
export interface APIXdentDTONCZIReportSendReportApiResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTONCZIReportSendReportApiResponseDto
     */
    'idNcziReportSendRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTONCZIReportSendReportApiResponseDto
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOOnlineBookingAppointmentDto
 */
export interface APIXdentDTOOnlineBookingAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'idAppointment': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'idLocation': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'startDate': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'endDate': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'idAppointmentCancel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'status'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'isOnlineBooked': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'idStaffProfilePhoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentDto
     */
    'idStaff'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOOnlineBookingAppointmentRequestBookingDto
 */
export interface APIXdentDTOOnlineBookingAppointmentRequestBookingDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'idAppointmentRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'idBudgetPlanService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'idProfilePhoto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'staffFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOOnlineBookingAppointmentRequestBookingDto
     */
    'isFinished': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTOOnlineBookingBookingPartnershipRequestDto
 */
export interface APIXdentDTOOnlineBookingBookingPartnershipRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingBookingPartnershipRequestDto
     */
    'idForm': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOOnlineBookingClientExtraInfoDto
 */
export interface APIXdentDTOOnlineBookingClientExtraInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingClientExtraInfoDto
     */
    'educationAfter'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto
 */
export interface APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto {
    /**
     * 
     * @type {Array<APIXdentDTOOnlineBookingAppointmentDto>}
     * @memberof APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto
     */
    'appointments'?: Array<APIXdentDTOOnlineBookingAppointmentDto> | null;
    /**
     * 
     * @type {Array<APISharedFormTemplateDto>}
     * @memberof APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto
     */
    'forms'?: Array<APISharedFormTemplateDto> | null;
    /**
     * 
     * @type {Array<APIXdentDTOOnlineBookingAppointmentRequestBookingDto>}
     * @memberof APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto
     */
    'appointmentRequests'?: Array<APIXdentDTOOnlineBookingAppointmentRequestBookingDto> | null;
    /**
     * 
     * @type {APISharedUserDto}
     * @memberof APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto
     */
    'user': APISharedUserDto;
    /**
     * 
     * @type {APIXdentDTOOnlineBookingUserExtraInfoDto}
     * @memberof APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto
     */
    'userExtraInfo': APIXdentDTOOnlineBookingUserExtraInfoDto;
    /**
     * 
     * @type {APIXdentDTOOnlineBookingClientExtraInfoDto}
     * @memberof APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto
     */
    'clientExtraInfo': APIXdentDTOOnlineBookingClientExtraInfoDto;
}
/**
 * 
 * @export
 * @interface APIXdentDTOOnlineBookingUserExtraInfoDto
 */
export interface APIXdentDTOOnlineBookingUserExtraInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingUserExtraInfoDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingUserExtraInfoDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingUserExtraInfoDto
     */
    'idPartnership'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingUserExtraInfoDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOOnlineBookingUserExtraInfoDto
     */
    'idRegistration': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPayment4UPayInvoiceApiResponseDto
 */
export interface APIXdentDTOPayment4UPayInvoiceApiResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPayment4UPayInvoiceApiResponseDto
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentGatewayEchoApiDto
 */
export interface APIXdentDTOPaymentGatewayEchoApiDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayEchoApiDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayEchoApiDto
     */
    'idLocation': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentGatewayEchoApiResponseDto
 */
export interface APIXdentDTOPaymentGatewayEchoApiResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOPaymentGatewayEchoApiResponseDto
     */
    'dttm': Date;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPaymentGatewayEchoApiResponseDto
     */
    'resultCode': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayEchoApiResponseDto
     */
    'resultMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayEchoApiResponseDto
     */
    'signature'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPaymentGatewayEchoApiResponseDto
     */
    'isVerified': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentGatewayPaymentInitApiDto
 */
export interface APIXdentDTOPaymentGatewayPaymentInitApiDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayPaymentInitApiDto
     */
    'idAppointment': string;
    /**
     * Enum: [cs,en,de,fr,hu,it,ja,pl,pt,ro,ru,sk,es,tr,vi,hr,sl,sv], if null or not in enum --> en is selected.
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayPaymentInitApiDto
     */
    'lang'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentGatewayPaymentInitApiResponseDto
 */
export interface APIXdentDTOPaymentGatewayPaymentInitApiResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayPaymentInitApiResponseDto
     */
    'redirectUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayPaymentInitApiResponseDto
     */
    'payId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPaymentGatewayPaymentInitApiResponseDto
     */
    'isVerified': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto
 */
export interface APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto
     */
    'idAppointment': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto
     */
    'payId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto
     */
    'paymentStatus'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto
     */
    'paymentStatusCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto
     */
    'statusIsFinalForClient'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto
     */
    'dateCreated'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentGatewaySendConfirmationEmailDto
 */
export interface APIXdentDTOPaymentGatewaySendConfirmationEmailDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOPaymentGatewaySendConfirmationEmailDto
     */
    'requestIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentImportPaymentImportMatch
 */
export interface APIXdentDTOPaymentImportPaymentImportMatch {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportMatch
     */
    'idInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportMatch
     */
    'variableSymbol'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPaymentImportPaymentImportMatch
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPaymentImportPaymentImportMatch
     */
    'paid': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPaymentImportPaymentImportMatch
     */
    'debt': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOPaymentImportPaymentImportMatch
     */
    'paymentTransactionIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentImportPaymentImportRow
 */
export interface APIXdentDTOPaymentImportPaymentImportRow {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'transactionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'foreignAccount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'foreignBankCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'variableSymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'constantSymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'specificSymbol'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'date': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'message'?: string | null;
    /**
     * 
     * @type {APIXdentDTOPaymentImportPaymentImportStatus}
     * @memberof APIXdentDTOPaymentImportPaymentImportRow
     */
    'status': APIXdentDTOPaymentImportPaymentImportStatus;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPaymentImportPaymentImportStatus
 */
export interface APIXdentDTOPaymentImportPaymentImportStatus {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPaymentImportPaymentImportStatus
     */
    'isFound': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPaymentImportPaymentImportStatus
     */
    'isImported': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPaymentImportPaymentImportStatus
     */
    'paymentAmount': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPaymentImportPaymentImportStatus
     */
    'combinedAmount': number;
    /**
     * 
     * @type {APIXdentDTOPaymentImportPaymentImportMatch}
     * @memberof APIXdentDTOPaymentImportPaymentImportStatus
     */
    'match': APIXdentDTOPaymentImportPaymentImportMatch;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPostmarkMailEmailDataFromS3Dto
 */
export interface APIXdentDTOPostmarkMailEmailDataFromS3Dto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailEmailDataFromS3Dto
     */
    'idClient': string;
    /**
     * 
     * @type {Array<APIXdentDTOPostmarkMailS3File>}
     * @memberof APIXdentDTOPostmarkMailEmailDataFromS3Dto
     */
    'files'?: Array<APIXdentDTOPostmarkMailS3File> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailEmailDataFromS3Dto
     */
    'emailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailEmailDataFromS3Dto
     */
    'emailBody'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailEmailDataFromS3Dto
     */
    'emailSubject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailEmailDataFromS3Dto
     */
    'filePassword'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPostmarkMailPostmarkClientPairDto
 */
export interface APIXdentDTOPostmarkMailPostmarkClientPairDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkClientPairDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkClientPairDto
     */
    'idClient': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPostmarkMailPostmarkSendEmailDto
 */
export interface APIXdentDTOPostmarkMailPostmarkSendEmailDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'to'?: Array<string> | null;
    /**
     * 
     * @type {Array<APIXdentDTOPostmarkMailPostmarkClientPairDto>}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'recipients'?: Array<APIXdentDTOPostmarkMailPostmarkClientPairDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'from'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'replyTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'attachments'?: Array<string> | null;
    /**
     * 
     * @type {Array<APIXdentDTOPostmarkMailPostmarkSendEmailEntityDto>}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'entities'?: Array<APIXdentDTOPostmarkMailPostmarkSendEmailEntityDto> | null;
    /**
     * 0 - INVOICE, 1 - FILE, 2 - APPOINTMENT_REMINDER, 3 - EQUIPMENT_REMINDER, 4 - OWNER_REGISTER, 5 - ACTIVATION_REQUEST, 6 - ACCOUNT_ACTIVATE, 7 - TEST, 8 - BOOKING_CONFIRM_PAYMENT, 9 - FORM_FILL_REQUEST, 10 - CLIENT_APPOINTMENTS_UPCOMING, 11 - DH_CHART, 12 - APPOINTMENT_REMINDER_AFTER, 13 - PASSWORD_CHANGE, 14 - LAB_RESULTS, 998 - UNKNOWN, 999 - ALL
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'emailType': APIXdentDTOPostmarkMailPostmarkSendEmailDtoEmailTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'ccRecipients'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'mergeItems': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailDto
     */
    'alias'?: string | null;
}

export const APIXdentDTOPostmarkMailPostmarkSendEmailDtoEmailTypeEnum = {
    Invoice: 'INVOICE',
    File: 'FILE',
    AppointmentReminder: 'APPOINTMENT_REMINDER',
    EquipmentReminder: 'EQUIPMENT_REMINDER',
    OwnerRegister: 'OWNER_REGISTER',
    ActivationRequest: 'ACTIVATION_REQUEST',
    AccountActivate: 'ACCOUNT_ACTIVATE',
    Test: 'TEST',
    BookingConfirmPayment: 'BOOKING_CONFIRM_PAYMENT',
    FormFillRequest: 'FORM_FILL_REQUEST',
    ClientAppointmentsUpcoming: 'CLIENT_APPOINTMENTS_UPCOMING',
    DhChart: 'DH_CHART',
    AppointmentReminderAfter: 'APPOINTMENT_REMINDER_AFTER',
    PasswordChange: 'PASSWORD_CHANGE',
    LabResults: 'LAB_RESULTS',
    Unknown: 'UNKNOWN',
    All: 'ALL'
} as const;

export type APIXdentDTOPostmarkMailPostmarkSendEmailDtoEmailTypeEnum = typeof APIXdentDTOPostmarkMailPostmarkSendEmailDtoEmailTypeEnum[keyof typeof APIXdentDTOPostmarkMailPostmarkSendEmailDtoEmailTypeEnum];

/**
 * 
 * @export
 * @interface APIXdentDTOPostmarkMailPostmarkSendEmailEntityDto
 */
export interface APIXdentDTOPostmarkMailPostmarkSendEmailEntityDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailEntityDto
     */
    'idEntity': string;
    /**
     * 0 - OldRecipe, 1 - Invoice, 2 - LaboratoryLabel, 3 - DoctorPass, 4 - TransportOrder, 5 - MedicalExamination, 6 - MedicalReport, 7 - MedicalReportExternal, 8 - Client_Appointments_Upcoming, 9 - LabRequestResultHeader, 10 - UNKNOWN
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailPostmarkSendEmailEntityDto
     */
    'entityType': APIXdentDTOPostmarkMailPostmarkSendEmailEntityDtoEntityTypeEnum;
}

export const APIXdentDTOPostmarkMailPostmarkSendEmailEntityDtoEntityTypeEnum = {
    OldRecipe: 'OldRecipe',
    Invoice: 'Invoice',
    LaboratoryLabel: 'LaboratoryLabel',
    DoctorPass: 'DoctorPass',
    TransportOrder: 'TransportOrder',
    MedicalExamination: 'MedicalExamination',
    MedicalReport: 'MedicalReport',
    MedicalReportExternal: 'MedicalReportExternal',
    ClientAppointmentsUpcoming: 'Client_Appointments_Upcoming',
    LabRequestResultHeader: 'LabRequestResultHeader',
    Unknown: 'UNKNOWN'
} as const;

export type APIXdentDTOPostmarkMailPostmarkSendEmailEntityDtoEntityTypeEnum = typeof APIXdentDTOPostmarkMailPostmarkSendEmailEntityDtoEntityTypeEnum[keyof typeof APIXdentDTOPostmarkMailPostmarkSendEmailEntityDtoEntityTypeEnum];

/**
 * 
 * @export
 * @interface APIXdentDTOPostmarkMailS3File
 */
export interface APIXdentDTOPostmarkMailS3File {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailS3File
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPostmarkMailS3File
     */
    'urlDownload'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPremiumPremiumServicesSettings
 */
export interface APIXdentDTOPremiumPremiumServicesSettings {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPremiumPremiumServicesSettings
     */
    'analytics'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPremiumPremiumServicesSettings
     */
    'isBiometricSignActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPremiumPremiumServicesSettings
     */
    'isFinancingActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPremiumPremiumServicesSettings
     */
    'isLegalProtectionActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOPremiumPremiumServicesSettings
     */
    'isLaboratoryLink': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPriceListPriceListDto
 */
export interface APIXdentDTOPriceListPriceListDto {
    /**
     * 
     * @type {Array<APIXdentDTOPriceListPriceListInvoiceDto>}
     * @memberof APIXdentDTOPriceListPriceListDto
     */
    'invoices'?: Array<APIXdentDTOPriceListPriceListInvoiceDto> | null;
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult}
     * @memberof APIXdentDTOPriceListPriceListDto
     */
    'stats': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYSTATSFORMResult;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult>}
     * @memberof APIXdentDTOPriceListPriceListDto
     */
    'premium'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedHELPCOMPANYPREMIUMSERVICESGRIDResult> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPriceListPriceListInvoiceDto
 */
export interface APIXdentDTOPriceListPriceListInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'idCompanyInvoice': string;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'priceSubscription'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'quantitySubscription'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'priceSMS'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'quantitySMS'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'quantityStorage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'priceStorage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'priceLocation'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'quantityLocation'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'dateIssue'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'variableSymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'fixSale'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'credit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'eetPrice': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'quantityEetLocation': number;
    /**
     * 
     * @type {Array<APIXdentDTOPriceListPriceListInvoiceItemDto>}
     * @memberof APIXdentDTOPriceListPriceListInvoiceDto
     */
    'invoiceItems'?: Array<APIXdentDTOPriceListPriceListInvoiceItemDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPriceListPriceListInvoiceItemDto
 */
export interface APIXdentDTOPriceListPriceListInvoiceItemDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPriceListPriceListInvoiceItemDto
     */
    'idCompanyInvoiceItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPriceListPriceListInvoiceItemDto
     */
    'itemCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPriceListPriceListInvoiceItemDto
     */
    'itemName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPriceListPriceListInvoiceItemDto
     */
    'itemDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceItemDto
     */
    'itemUnitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOPriceListPriceListInvoiceItemDto
     */
    'itemQuantity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOPriceListPriceListInvoiceItemDto
     */
    'itemVATRateCode'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOPrintformsPrintFormOverviewDto
 */
export interface APIXdentDTOPrintformsPrintFormOverviewDto {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult>}
     * @memberof APIXdentDTOPrintformsPrintFormOverviewDto
     */
    'labelList'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult> | null;
    /**
     * 
     * @type {Array<APIXdentDTOClientDetailGeneralPrescriptionDto>}
     * @memberof APIXdentDTOPrintformsPrintFormOverviewDto
     */
    'prescriptionList'?: Array<APIXdentDTOClientDetailGeneralPrescriptionDto> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult>}
     * @memberof APIXdentDTOPrintformsPrintFormOverviewDto
     */
    'medicalReportExternGrid'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult>}
     * @memberof APIXdentDTOPrintformsPrintFormOverviewDto
     */
    'medicalExaminationGrid'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult>}
     * @memberof APIXdentDTOPrintformsPrintFormOverviewDto
     */
    'transportOrders'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult>}
     * @memberof APIXdentDTOPrintformsPrintFormOverviewDto
     */
    'doctorPasses'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTORvgCoordinate
 */
export interface APIXdentDTORvgCoordinate {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTORvgCoordinate
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTORvgCoordinate
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTORvgSegmentationResponseDto
 */
export interface APIXdentDTORvgSegmentationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTORvgSegmentationResponseDto
     */
    'toothLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTORvgSegmentationResponseDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTORvgCoordinate>}
     * @memberof APIXdentDTORvgSegmentationResponseDto
     */
    'bbox'?: Array<APIXdentDTORvgCoordinate> | null;
    /**
     * 
     * @type {Array<APIXdentDTORvgCoordinate>}
     * @memberof APIXdentDTORvgSegmentationResponseDto
     */
    'polygonData'?: Array<APIXdentDTORvgCoordinate> | null;
    /**
     * 
     * @type {APIXdentDTORvgCoordinate}
     * @memberof APIXdentDTORvgSegmentationResponseDto
     */
    'polygonCenter': APIXdentDTORvgCoordinate;
    /**
     * 
     * @type {APIXdentDTORvgCoordinate}
     * @memberof APIXdentDTORvgSegmentationResponseDto
     */
    'lineData': APIXdentDTORvgCoordinate;
    /**
     * 
     * @type {APIXdentDTORvgCoordinate}
     * @memberof APIXdentDTORvgSegmentationResponseDto
     */
    'pointData': APIXdentDTORvgCoordinate;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesClientDataModel
 */
export interface APIXdentDTOSafeSignaturesClientDataModel {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'phone'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'educationBefore'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'insurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesClientDataModel
     */
    'gender'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesCreateDeviceRequestDto
 */
export interface APIXdentDTOSafeSignaturesCreateDeviceRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreateDeviceRequestDto
     */
    'idCompanyPremiumService': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreateDeviceRequestDto
     */
    'idDeviceExternalType': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreateDeviceRequestDto
     */
    'idDeviceExternalRental': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto
 */
export interface APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto
     */
    'idPlan': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesCreateSSRequestForClientDto
 */
export interface APIXdentDTOSafeSignaturesCreateSSRequestForClientDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreateSSRequestForClientDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreateSSRequestForClientDto
     */
    'idForm': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto
 */
export interface APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto
     */
    'idIklientForm': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesPairDeviceRequestDto
 */
export interface APIXdentDTOSafeSignaturesPairDeviceRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPairDeviceRequestDto
     */
    'pairingCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSafeSignaturesPairDeviceRequestDto
     */
    'beta'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesPdfFileData
 */
export interface APIXdentDTOSafeSignaturesPdfFileData {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPdfFileData
     */
    'idFile': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPdfFileData
     */
    'fileContentBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesPrintForm
 */
export interface APIXdentDTOSafeSignaturesPrintForm {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'idSSPrintform': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'printFormType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'pdfBase64'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'definition'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesSignBounds>}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'signBounds'?: Array<APIXdentDTOSafeSignaturesSignBounds> | null;
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesSubjectClient}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'subjectClient': APIXdentDTOSafeSignaturesSubjectClient;
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesSigningPerson>}
     * @memberof APIXdentDTOSafeSignaturesPrintForm
     */
    'signingPersons'?: Array<APIXdentDTOSafeSignaturesSigningPerson> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSSPrintFormCreateDto
 */
export interface APIXdentDTOSafeSignaturesSSPrintFormCreateDto {
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesSSSignatureCreateDto>}
     * @memberof APIXdentDTOSafeSignaturesSSPrintFormCreateDto
     */
    'signatures': Array<APIXdentDTOSafeSignaturesSSSignatureCreateDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSPrintFormCreateDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSPrintFormCreateDto
     */
    'idClientPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSPrintFormCreateDto
     */
    'idGlobal': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSPrintFormCreateDto
     */
    'idFilledGlobal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSPrintFormCreateDto
     */
    'idSignedFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSPrintFormCreateDto
     */
    'idPrintFormType': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSSRequestCreateDto
 */
export interface APIXdentDTOSafeSignaturesSSRequestCreateDto {
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesSSPrintFormCreateDto>}
     * @memberof APIXdentDTOSafeSignaturesSSRequestCreateDto
     */
    'printForms': Array<APIXdentDTOSafeSignaturesSSPrintFormCreateDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSSSignatureCreateDto
 */
export interface APIXdentDTOSafeSignaturesSSSignatureCreateDto {
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesSSSigningPersonCreateDto}
     * @memberof APIXdentDTOSafeSignaturesSSSignatureCreateDto
     */
    'signingPerson': APIXdentDTOSafeSignaturesSSSigningPersonCreateDto;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSSSignatureCreateDto
     */
    'signatureOrder': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
 */
export interface APIXdentDTOSafeSignaturesSSSigningPersonCreateDto {
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesSSVerificationCreateDto}
     * @memberof APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
     */
    'verification': APIXdentDTOSafeSignaturesSSVerificationCreateDto;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
     */
    'idUser': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
     */
    'idUserType': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
     */
    'idClientPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
     */
    'lastName': string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSSigningPersonCreateDto
     */
    'identification': string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSSVerificationCreateDto
 */
export interface APIXdentDTOSafeSignaturesSSVerificationCreateDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSVerificationCreateDto
     */
    'idAuthType': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSSVerificationCreateDto
     */
    'idUser': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSafeSignaturesSSVerificationCreateDto
     */
    'verifiedAt': Date;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld
 */
export interface APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld
     */
    'signSizeY': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld
     */
    'signSizeX': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld
     */
    'signPosX': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld
     */
    'signPosY': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld
     */
    'signPage': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSafeSignaturesPrivateSignCertDto
 */
export interface APIXdentDTOSafeSignaturesSafeSignaturesPrivateSignCertDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSafeSignaturesPrivateSignCertDto
     */
    'safeSignaturesPrivateSignCertBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto
 */
export interface APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto
     */
    'idSSPrintForm': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto
     */
    'definition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto
     */
    'model'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSaveAndRegenerateFormResponseDto
 */
export interface APIXdentDTOSafeSignaturesSaveAndRegenerateFormResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSaveAndRegenerateFormResponseDto
     */
    'idSSPrintForm': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSaveAndRegenerateFormResponseDto
     */
    'newPDFbase64'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesSignBounds>}
     * @memberof APIXdentDTOSafeSignaturesSaveAndRegenerateFormResponseDto
     */
    'signBounds'?: Array<APIXdentDTOSafeSignaturesSignBounds> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSendSignedMetadataDto
 */
export interface APIXdentDTOSafeSignaturesSendSignedMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSendSignedMetadataDto
     */
    'idSSPrintForm': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSendSignedMetadataDto
     */
    'pdfBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSignBounds
 */
export interface APIXdentDTOSafeSignaturesSignBounds {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignBounds
     */
    'idSSSigningPerson': string;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSignBounds
     */
    'signPosX': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSignBounds
     */
    'signPosY': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSignBounds
     */
    'signSizeX': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSignBounds
     */
    'signSizeY': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSignBounds
     */
    'signPage': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSignItemMetadataDtoOld
 */
export interface APIXdentDTOSafeSignaturesSignItemMetadataDtoOld {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignItemMetadataDtoOld
     */
    'idFile': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignItemMetadataDtoOld
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignItemMetadataDtoOld
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignItemMetadataDtoOld
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSignItemMetadataDtoOld
     */
    'order': number;
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld}
     * @memberof APIXdentDTOSafeSignaturesSignItemMetadataDtoOld
     */
    'safeSignatureSignBound': APIXdentDTOSafeSignaturesSafeSignatureSignBoundOld;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSignMetadataDto
 */
export interface APIXdentDTOSafeSignaturesSignMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignMetadataDto
     */
    'idSSRequest': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignMetadataDto
     */
    'idCompany': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSafeSignaturesSignMetadataDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesPrintForm>}
     * @memberof APIXdentDTOSafeSignaturesSignMetadataDto
     */
    'printForms'?: Array<APIXdentDTOSafeSignaturesPrintForm> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSignMetadataDtoOld
 */
export interface APIXdentDTOSafeSignaturesSignMetadataDtoOld {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignMetadataDtoOld
     */
    'idBatch': string;
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesSignerMetadataDtoOld>}
     * @memberof APIXdentDTOSafeSignaturesSignMetadataDtoOld
     */
    'signers'?: Array<APIXdentDTOSafeSignaturesSignerMetadataDtoOld> | null;
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesPdfFileData>}
     * @memberof APIXdentDTOSafeSignaturesSignMetadataDtoOld
     */
    'pdfFiles'?: Array<APIXdentDTOSafeSignaturesPdfFileData> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSignerIdentityConfirmOld
 */
export interface APIXdentDTOSafeSignaturesSignerIdentityConfirmOld {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerIdentityConfirmOld
     */
    'idIdentityConfirm': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerIdentityConfirmOld
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerIdentityConfirmOld
     */
    'result'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSafeSignaturesSignerIdentityConfirmOld
     */
    'validToDate'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSafeSignaturesSignerIdentityConfirmOld
     */
    'required': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSignerMetadataDtoOld
 */
export interface APIXdentDTOSafeSignaturesSignerMetadataDtoOld {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'idPrivateSignCertRequest': string;
    /**
     * 
     * @type {Array<APIXdentDTOSafeSignaturesSignItemMetadataDtoOld>}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'itemsToSign'?: Array<APIXdentDTOSafeSignaturesSignItemMetadataDtoOld> | null;
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesSafeSignaturesPrivateSignCertDto}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'privateSignCert': APIXdentDTOSafeSignaturesSafeSignaturesPrivateSignCertDto;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'order'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'personalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'type'?: string | null;
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesSignerIdentityConfirmOld}
     * @memberof APIXdentDTOSafeSignaturesSignerMetadataDtoOld
     */
    'identityConfirm': APIXdentDTOSafeSignaturesSignerIdentityConfirmOld;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSigningPerson
 */
export interface APIXdentDTOSafeSignaturesSigningPerson {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSigningPerson
     */
    'idSSSigningPerson': string;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSafeSignaturesSigningPerson
     */
    'signOrder': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSigningPerson
     */
    'clientCertBase64'?: string | null;
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesSigningUser}
     * @memberof APIXdentDTOSafeSignaturesSigningPerson
     */
    'signingUser': APIXdentDTOSafeSignaturesSigningUser;
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesVerification}
     * @memberof APIXdentDTOSafeSignaturesSigningPerson
     */
    'verification': APIXdentDTOSafeSignaturesVerification;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSigningUser
 */
export interface APIXdentDTOSafeSignaturesSigningUser {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSigningUser
     */
    'idUser': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSigningUser
     */
    'userType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSigningUser
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSafeSignaturesSigningUser
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSigningUser
     */
    'personalNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesSubjectClient
 */
export interface APIXdentDTOSafeSignaturesSubjectClient {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSubjectClient
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSubjectClient
     */
    'idClientPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSubjectClient
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSafeSignaturesSubjectClient
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesSubjectClient
     */
    'personalNumber'?: string | null;
    /**
     * 
     * @type {APIXdentDTOSafeSignaturesClientDataModel}
     * @memberof APIXdentDTOSafeSignaturesSubjectClient
     */
    'clientDataModel': APIXdentDTOSafeSignaturesClientDataModel;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesUnpairDeviceRequestDto
 */
export interface APIXdentDTOSafeSignaturesUnpairDeviceRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesUnpairDeviceRequestDto
     */
    'idDeviceExternalRental': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesUnpairDeviceRequestDto
     */
    'idCompanyPremiumService': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSafeSignaturesVerification
 */
export interface APIXdentDTOSafeSignaturesVerification {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesVerification
     */
    'idSSVerification': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesVerification
     */
    'authType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSafeSignaturesVerification
     */
    'idUser': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSafeSignaturesVerification
     */
    'createdAt': Date;
}
/**
 * 
 * @export
 * @interface APIXdentDTOServiceFormSendDeltaSettingJSON
 */
export interface APIXdentDTOServiceFormSendDeltaSettingJSON {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOServiceFormSendDeltaSettingJSON
     */
    'days': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOServiceServiceLocationFormSettingJSON
 */
export interface APIXdentDTOServiceServiceLocationFormSettingJSON {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOServiceServiceLocationFormSettingJSON
     */
    'idForm': string;
    /**
     * 
     * @type {Array<APIXdentDTOServiceFormSendDeltaSettingJSON>}
     * @memberof APIXdentDTOServiceServiceLocationFormSettingJSON
     */
    'daysDelta'?: Array<APIXdentDTOServiceFormSendDeltaSettingJSON> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOServiceServiceLocationSettingDTO
 */
export interface APIXdentDTOServiceServiceLocationSettingDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOServiceServiceLocationSettingDTO
     */
    'idServiceLocationSetting'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOServiceServiceLocationSettingDTO
     */
    'idService': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOServiceServiceLocationSettingDTO
     */
    'idLocation': string;
    /**
     * 
     * @type {APIXdentDTOServiceServiceLocationSettingJSON}
     * @memberof APIXdentDTOServiceServiceLocationSettingDTO
     */
    'settings': APIXdentDTOServiceServiceLocationSettingJSON;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOServiceServiceLocationSettingDTO
     */
    'createdAt'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOServiceServiceLocationSettingDTO
     */
    'updatedAt'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOServiceServiceLocationSettingJSON
 */
export interface APIXdentDTOServiceServiceLocationSettingJSON {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOServiceServiceLocationSettingJSON
     */
    'shouldSendExpiringBefore': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOServiceServiceLocationSettingJSON
     */
    'shouldSendExpiringAfter': boolean;
    /**
     * 
     * @type {Array<APIXdentDTOServiceFormSendDeltaSettingJSON>}
     * @memberof APIXdentDTOServiceServiceLocationSettingJSON
     */
    'beforeEventFormsDaysDelta'?: Array<APIXdentDTOServiceFormSendDeltaSettingJSON> | null;
    /**
     * 
     * @type {Array<APIXdentDTOServiceFormSendDeltaSettingJSON>}
     * @memberof APIXdentDTOServiceServiceLocationSettingJSON
     */
    'afterEventFormsDaysDelta'?: Array<APIXdentDTOServiceFormSendDeltaSettingJSON> | null;
    /**
     * 
     * @type {Array<APIXdentDTOServiceServiceLocationFormSettingJSON>}
     * @memberof APIXdentDTOServiceServiceLocationSettingJSON
     */
    'beforeEventForms'?: Array<APIXdentDTOServiceServiceLocationFormSettingJSON> | null;
    /**
     * 
     * @type {Array<APIXdentDTOServiceServiceLocationFormSettingJSON>}
     * @memberof APIXdentDTOServiceServiceLocationSettingJSON
     */
    'afterEventForms'?: Array<APIXdentDTOServiceServiceLocationFormSettingJSON> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarAppointmentWaitingRoomDto
 */
export interface APIXdentDTOSideBarAppointmentWaitingRoomDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarAppointmentWaitingRoomDto
     */
    'idAppointment': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarAppointmentWaitingRoomDto
     */
    'idService': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarAppointmentWaitingRoomDto
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarAppointmentWaitingRoomDto
     */
    'serviceColor'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarAppointmentWaitingRoomDto
     */
    'startDate': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarAppointmentWaitingRoomDto
     */
    'endDate': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarAppointmentWaitingRoomDto
     */
    'idStaff': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarAppointmentWaitingRoomDto
     */
    'staffFullname'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarClientInfoAppointmentDto
 */
export interface APIXdentDTOSideBarClientInfoAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'idResource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'finish'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'resourceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'isWaitingClients': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'appColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'dob'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'plan'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'isAptFuture': number;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentDto
     */
    'personalId'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarClientInfoAppointmentUserRatingDto
 */
export interface APIXdentDTOSideBarClientInfoAppointmentUserRatingDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentUserRatingDto
     */
    'appointmentTotal': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarClientInfoAppointmentUserRatingDto
     */
    'appointmentNotCome': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarClientInfoDto
 */
export interface APIXdentDTOSideBarClientInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'alerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'insurance'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'credit': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'debit': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'income': number;
    /**
     * 
     * @type {Array<APIXdentDTOSideBarClientInfoAppointmentDto>}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'appointments'?: Array<APIXdentDTOSideBarClientInfoAppointmentDto> | null;
    /**
     * 
     * @type {Array<APIXdentDTOSideBarClientInfoMedicalReportDto>}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'medicalReportList'?: Array<APIXdentDTOSideBarClientInfoMedicalReportDto> | null;
    /**
     * 
     * @type {APIXdentDTOSideBarClientInfoAppointmentUserRatingDto}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'userRating': APIXdentDTOSideBarClientInfoAppointmentUserRatingDto;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'profilePhotoId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'formAlerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'badgeColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'educationBefore'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'citizenshipCode'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarClientInfoDto
     */
    'dateOfBirth'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarClientInfoMedicalReportDto
 */
export interface APIXdentDTOSideBarClientInfoMedicalReportDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoMedicalReportDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoMedicalReportDto
     */
    'dateTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarClientInfoMedicalReportDto
     */
    'isLocked': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientInfoMedicalReportDto
     */
    'staffName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarClientWaitingRoomDto
 */
export interface APIXdentDTOSideBarClientWaitingRoomDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'fullname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'idFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'badgeColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'idStaffClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'idPartner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'idPartnership'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'idPhonePrefix'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'isVisible': boolean;
    /**
     * 
     * @type {APIXdentDTOSideBarAppointmentWaitingRoomDto}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'appointment': APIXdentDTOSideBarAppointmentWaitingRoomDto;
    /**
     * 
     * @type {APIXdentDTOSideBarInsuranceStateWaitingRoomDto}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'insuranceState': APIXdentDTOSideBarInsuranceStateWaitingRoomDto;
    /**
     * 
     * @type {Array<APIXdentDTOSideBarFormWaitingRoomDto>}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'expiringForms'?: Array<APIXdentDTOSideBarFormWaitingRoomDto> | null;
    /**
     * 
     * @type {Array<APIXdentDTOSideBarFormWaitingRoomDto>}
     * @memberof APIXdentDTOSideBarClientWaitingRoomDto
     */
    'serviceForms'?: Array<APIXdentDTOSideBarFormWaitingRoomDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarCustomTagDto
 */
export interface APIXdentDTOSideBarCustomTagDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarCustomTagDto
     */
    'idCustomTag': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarCustomTagDto
     */
    'idGlobal': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarCustomTagDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarCustomTagDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarCustomTagDto
     */
    'position': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarDeleteRelationCustomTagRequestDto
 */
export interface APIXdentDTOSideBarDeleteRelationCustomTagRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDeleteRelationCustomTagRequestDto
     */
    'idGlobal': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDeleteRelationCustomTagRequestDto
     */
    'idCustomTag': string;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarDispensarizationPlanDto
 */
export interface APIXdentDTOSideBarDispensarizationPlanDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarDispensarizationPlanDto
     */
    'isDispensarization': boolean;
    /**
     * 
     * @type {Array<APIXdentDTOSideBarDispensarizationPlanServiceDto>}
     * @memberof APIXdentDTOSideBarDispensarizationPlanDto
     */
    'services'?: Array<APIXdentDTOSideBarDispensarizationPlanServiceDto> | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarDispensarizationPlanDto
     */
    'dateCreated'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarDispensarizationPlanServiceDto
 */
export interface APIXdentDTOSideBarDispensarizationPlanServiceDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'idBudgetPlan'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'idAppointmentRequest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'idAppointmentRequestType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'appointmentRequestTypeTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'dateVisit': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'isDateVisitLocked': boolean;
    /**
     * 
     * @type {APIXdentDTOSideBarDispensarizationPlanServiceServiceDto}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'service': APIXdentDTOSideBarDispensarizationPlanServiceServiceDto;
    /**
     * 
     * @type {Array<APIXdentDTOSideBarDispensarizationPlanServiceItemDto>}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceDto
     */
    'items'?: Array<APIXdentDTOSideBarDispensarizationPlanServiceItemDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto
 */
export interface APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto
     */
    'idItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto
     */
    'idRegion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto
     */
    'shortCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto
     */
    'codelistCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarDispensarizationPlanServiceItemDto
 */
export interface APIXdentDTOSideBarDispensarizationPlanServiceItemDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idBudgetPlanService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idParent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'typeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idMedicalReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idLaboratoryLabel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'laboratoryName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'laboratoryPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'localizationCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'sorting': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'level'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {Array<APIXdentDTOSideBarDispensarizationPlanServiceItemDto>}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'items'?: Array<APIXdentDTOSideBarDispensarizationPlanServiceItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idPhrase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'phraseTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceDiagnoseCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceServiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceServiceCustomCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceIdLaboratoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceServiceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insurancePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceAgeStart'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceAgeFinish'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceIsLocalizationRequired'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceODB'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insurancePaymentTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceIdPaymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insurancePaymentTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insuranceLaboratoryCodeType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'insurancePriceClientAdd'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idInvoiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoiceCustomCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoiceCodeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoiceMaterialCodeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoiceTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoiceDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoiceUnitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoiceDuration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'invoicePricePerMinute'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idOperation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idConstruction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'idMaterial'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'dcOperationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'dcConstructionCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'dcMaterialCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'dcOperationTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'dcConstructionTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'dcMaterialTitle'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto>}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceItemDto
     */
    'dcRegions'?: Array<APIXdentDTOSideBarDispensarizationPlanServiceItemDcRegionDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarDispensarizationPlanServiceServiceDto
 */
export interface APIXdentDTOSideBarDispensarizationPlanServiceServiceDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceServiceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceServiceDto
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceServiceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceServiceDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceServiceDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarDispensarizationPlanServiceServiceDto
     */
    'isOnline'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarFormWaitingRoomDto
 */
export interface APIXdentDTOSideBarFormWaitingRoomDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarFormWaitingRoomDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarFormWaitingRoomDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarFormWaitingRoomDto
     */
    'isFilled': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarGetCustomTagsRequestDto
 */
export interface APIXdentDTOSideBarGetCustomTagsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOSideBarGetCustomTagsRequestDto
     */
    'idGlobals'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarGetCustomTagsRequestDto
     */
    'table'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarGetWaitingListClientInfoDto
 */
export interface APIXdentDTOSideBarGetWaitingListClientInfoDto {
    /**
     * 
     * @type {Array<APIXdentDTOSideBarWaitingListServiceDto>}
     * @memberof APIXdentDTOSideBarGetWaitingListClientInfoDto
     */
    'services'?: Array<APIXdentDTOSideBarWaitingListServiceDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarGetWaitingListClientInfoDto
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarGetWaitingListClientInfoDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarGetWaitingListClientInfoDto
     */
    'clientNameSimple'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarGetWaitingListClientInfoDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarGetWaitingListClientInfoDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarGetWaitingListClientInfoDto
     */
    'birthNum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarGetWaitingListClientInfoDto
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarGetWaitingListResponseDto
 */
export interface APIXdentDTOSideBarGetWaitingListResponseDto {
    /**
     * 
     * @type {{ [key: string]: APIXdentDTOSideBarGetWaitingListClientInfoDto; }}
     * @memberof APIXdentDTOSideBarGetWaitingListResponseDto
     */
    'clientInfoDictionary'?: { [key: string]: APIXdentDTOSideBarGetWaitingListClientInfoDto; } | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarInsuranceStateWaitingRoomDto
 */
export interface APIXdentDTOSideBarInsuranceStateWaitingRoomDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarInsuranceStateWaitingRoomDto
     */
    'idStaffInsurance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarInsuranceStateWaitingRoomDto
     */
    'insuranceCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarInsuranceStateWaitingRoomDto
     */
    'insuranceType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarInsuranceStateWaitingRoomDto
     */
    'isRegistered': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOSideBarInsuranceStateWaitingRoomDto
     */
    'dateRegistered'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarInsuranceStateWaitingRoomDto
     */
    'icpRegistered'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSideBarInsuranceStateWaitingRoomDto
     */
    'isOwned': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarSetCustomTagMethodRequestDto
 */
export interface APIXdentDTOSideBarSetCustomTagMethodRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSetCustomTagMethodRequestDto
     */
    'idGlobal': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSetCustomTagMethodRequestDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSetCustomTagMethodRequestDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSetCustomTagMethodRequestDto
     */
    'table'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarSideBarClientFilterDto
 */
export interface APIXdentDTOSideBarSideBarClientFilterDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'insuranceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarSideBarClientFilterDto
     */
    'badgeColor'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarUpdateAppointmentStatusRequestDto
 */
export interface APIXdentDTOSideBarUpdateAppointmentStatusRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarUpdateAppointmentStatusRequestDto
     */
    'idAppointment': string;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSideBarUpdateAppointmentStatusRequestDto
     */
    'status': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto
 */
export interface APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto
     */
    'idClient': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSideBarWaitingListServiceDto
 */
export interface APIXdentDTOSideBarWaitingListServiceDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'service'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'duration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'staffLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'idWC'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'iddApp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'appColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'serviceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSideBarWaitingListServiceDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSignSafeSigSealSignedDocumentDto
 */
export interface APIXdentDTOSignSafeSigSealSignedDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSignSafeSigSealSignedDocumentDto
     */
    'idBatch': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSignSafeSigSealSignedDocumentDto
     */
    'signedDocumentBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSmartformAddressDto
 */
export interface APIXdentDTOSmartformAddressDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressDto
     */
    'NUMBER'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressDto
     */
    'STREET_AND_NUMBER'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressDto
     */
    'STREET'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressDto
     */
    'CITY'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressDto
     */
    'CITY_EXTENDED'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressDto
     */
    'CITY_AND_DISTRICT'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressDto
     */
    'ZIP'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressDto
     */
    'WHOLE_ADDRESS'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSmartformAddressReponseDto
 */
export interface APIXdentDTOSmartformAddressReponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'district'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'NUMBER'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'STREET_AND_NUMBER'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'STREET'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'CITY'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'CITY_EXTENDED'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'CITY_AND_DISTRICT'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'ZIP'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressReponseDto
     */
    'WHOLE_ADDRESS'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSmartformAddressSuggestionDto
 */
export interface APIXdentDTOSmartformAddressSuggestionDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSmartformAddressSuggestionDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSmartformAddressSuggestionDto
     */
    'limit': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressSuggestionDto
     */
    'fieldType': string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressSuggestionDto
     */
    'country': string | null;
    /**
     * 
     * @type {APIXdentDTOSmartformAddressSuggestionDtoValues}
     * @memberof APIXdentDTOSmartformAddressSuggestionDto
     */
    'values'?: APIXdentDTOSmartformAddressSuggestionDtoValues | null;
}
/**
 * @type APIXdentDTOSmartformAddressSuggestionDtoValues
 * @export
 */
export type APIXdentDTOSmartformAddressSuggestionDtoValues = APIXdentDTOSmartformAddressDto | APIXdentDTOSmartformAddressReponseDto;

/**
 * 
 * @export
 * @interface APIXdentDTOSmartformAddressSuggestionResponseDto
 */
export interface APIXdentDTOSmartformAddressSuggestionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOSmartformAddressSuggestionResponseDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressSuggestionResponseDto
     */
    'resultCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformAddressSuggestionResponseDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOSmartformSuggestionDto>}
     * @memberof APIXdentDTOSmartformAddressSuggestionResponseDto
     */
    'suggestions'?: Array<APIXdentDTOSmartformSuggestionDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSmartformFlagDto
 */
export interface APIXdentDTOSmartformFlagDto {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSmartformFlagDto
     */
    'wholE_ADDRESS'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOSmartformFlagDto
     */
    'uniquE_CITY'?: boolean | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOSmartformSuggestionDto
 */
export interface APIXdentDTOSmartformSuggestionDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOSmartformSuggestionDto
     */
    'fieldType': string | null;
    /**
     * 
     * @type {APIXdentDTOSmartformAddressReponseDto}
     * @memberof APIXdentDTOSmartformSuggestionDto
     */
    'values': APIXdentDTOSmartformAddressReponseDto;
    /**
     * 
     * @type {APIXdentDTOSmartformFlagDto}
     * @memberof APIXdentDTOSmartformSuggestionDto
     */
    'flags': APIXdentDTOSmartformFlagDto;
}
/**
 * 
 * @export
 * @interface APIXdentDTOTaskChangeStatusDto
 */
export interface APIXdentDTOTaskChangeStatusDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskChangeStatusDto
     */
    'idTask'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskChangeStatusDto
     */
    'idBatch'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskChangeStatusDto
     */
    'taskStatus'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOTaskCommentDto
 */
export interface APIXdentDTOTaskCommentDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskCommentDto
     */
    'idBatch'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskCommentDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskCommentDto
     */
    'body'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOTaskCreateTaskDto
 */
export interface APIXdentDTOTaskCreateTaskDto {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOTaskCreateTaskDto
     */
    'finishDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOTaskCreateTaskDto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOTaskCreateTaskDto
     */
    'slaves'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskCreateTaskDto
     */
    'taskMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskCreateTaskDto
     */
    'taskPriority'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskCreateTaskDto
     */
    'taskType'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOTaskEditTaskDto
 */
export interface APIXdentDTOTaskEditTaskDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskEditTaskDto
     */
    'idBatch'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOTaskEditTaskDto
     */
    'finishDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOTaskEditTaskDto
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskEditTaskDto
     */
    'taskMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskEditTaskDto
     */
    'taskPriority'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOTaskEditTaskDto
     */
    'taskType'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOUserGlobalXdentConfigurationDto
 */
export interface APIXdentDTOUserGlobalXdentConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: Array<APISharedCodelistDto>; }}
     * @memberof APIXdentDTOUserGlobalXdentConfigurationDto
     */
    'codeLists'?: { [key: string]: Array<APISharedCodelistDto>; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOUserGlobalXdentConfigurationDto
     */
    'roles'?: Array<string> | null;
    /**
     * 
     * @type {Array<APISharedDentalCategoryColorsDto>}
     * @memberof APIXdentDTOUserGlobalXdentConfigurationDto
     */
    'dentalCategoryColors'?: Array<APISharedDentalCategoryColorsDto> | null;
    /**
     * 
     * @type {APISharedGlobalXdentConfigCmpanyDto}
     * @memberof APIXdentDTOUserGlobalXdentConfigurationDto
     */
    'company': APISharedGlobalXdentConfigCmpanyDto;
    /**
     * 
     * @type {APISharedGlobalXdentConfigLocationDto}
     * @memberof APIXdentDTOUserGlobalXdentConfigurationDto
     */
    'location': APISharedGlobalXdentConfigLocationDto;
    /**
     * 
     * @type {Array<APIContextGeneratedXdentCoreEntityLayerRegion>}
     * @memberof APIXdentDTOUserGlobalXdentConfigurationDto
     */
    'regions'?: Array<APIContextGeneratedXdentCoreEntityLayerRegion> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOUserGlobalXdentConfigurationWrapperDto
 */
export interface APIXdentDTOUserGlobalXdentConfigurationWrapperDto {
    /**
     * 
     * @type {APIXdentDTOUserGlobalXdentConfigurationDto}
     * @memberof APIXdentDTOUserGlobalXdentConfigurationWrapperDto
     */
    'configuration': APIXdentDTOUserGlobalXdentConfigurationDto;
    /**
     * 
     * @type {APIXdentDTOUserUserXdentDto}
     * @memberof APIXdentDTOUserGlobalXdentConfigurationWrapperDto
     */
    'user': APIXdentDTOUserUserXdentDto;
}
/**
 * 
 * @export
 * @interface APIXdentDTOUserLogTestLogPostDto
 */
export interface APIXdentDTOUserLogTestLogPostDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserLogTestLogPostDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOUserLogTestLogPostDto
     */
    'age': number;
}
/**
 * 
 * @export
 * @interface APIXdentDTOUserLogUserLogDto
 */
export interface APIXdentDTOUserLogUserLogDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserLogUserLogDto
     */
    'logJson'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOUserUserXdentDto
 */
export interface APIXdentDTOUserUserXdentDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'dob'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'education'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'phonePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'icp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'idExpertise'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'insuranceAccess'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'educationAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'nameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOUserUserXdentDto
     */
    'idProfilePhoto'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOVzpAsyncResponseDto
 */
export interface APIXdentDTOVzpAsyncResponseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'idState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'idXdentCorrelation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'dateRecieved'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'fileType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'xPathToFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpAsyncResponseDto
     */
    'idVzpAsyncResponse'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOVzpAsyncResponsesGridDto
 */
export interface APIXdentDTOVzpAsyncResponsesGridDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentDTOVzpAsyncResponsesGridDto
     */
    'xdentCorrelations'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOVzpInsuranceItemDto
 */
export interface APIXdentDTOVzpInsuranceItemDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'idShort'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'naz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'kod'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'insurancePrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'typeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'laboratoryPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'idPaymentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'paymentTitle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'isLocalizationRequire'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'ageStart'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'ageFinish'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'clientPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'customCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'nameLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'laboratoryColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'idLaboratoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'odb'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'maxCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'upo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceItemDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOVzpInsuranceSearchDiagnoseDto
 */
export interface APIXdentDTOVzpInsuranceSearchDiagnoseDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceSearchDiagnoseDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOVzpInsuranceSearchDiagnoseDto
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOXdentPointPointNavSettingImageUpdateDto
 */
export interface APIXdentDTOXdentPointPointNavSettingImageUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingImageUpdateDto
     */
    'idEntity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingImageUpdateDto
     */
    'idImage'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOXdentPointPointNavSettingMutationDto
 */
export interface APIXdentDTOXdentPointPointNavSettingMutationDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingMutationDto
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingMutationDto
     */
    'langCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingMutationDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingMutationDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOXdentPointPointNavSettingMutationUpdateDto
 */
export interface APIXdentDTOXdentPointPointNavSettingMutationUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingMutationUpdateDto
     */
    'idPointNavigationSetting'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingMutationUpdateDto
     */
    'idLanguage': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingMutationUpdateDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavSettingMutationUpdateDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOXdentPointPointNavigationSettingDto
 */
export interface APIXdentDTOXdentPointPointNavigationSettingDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingDto
     */
    'idPointNavigationSetting'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingDto
     */
    'idStaff': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingDto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingDto
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingDto
     */
    'serviceNameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingDto
     */
    'serviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOXdentPointPointNavigationSettingFullDto
 */
export interface APIXdentDTOXdentPointPointNavigationSettingFullDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'idPointNavigationSetting'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'idStaff': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'idImageFile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'serviceNameOnline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOXdentPointPointNavSettingMutationDto>}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingFullDto
     */
    'descMutations'?: Array<APIXdentDTOXdentPointPointNavSettingMutationDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOXdentPointPointNavigationSettingUpdateDto
 */
export interface APIXdentDTOXdentPointPointNavigationSettingUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingUpdateDto
     */
    'idPointNavigationSetting'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingUpdateDto
     */
    'idCompany': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingUpdateDto
     */
    'idStaff': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingUpdateDto
     */
    'idService'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<APIXdentDTOXdentPointPointNavSettingMutationUpdateDto>}
     * @memberof APIXdentDTOXdentPointPointNavigationSettingUpdateDto
     */
    'descMutations'?: Array<APIXdentDTOXdentPointPointNavSettingMutationUpdateDto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentDTOXdentShareShareLabTicketFileDto
 */
export interface APIXdentDTOXdentShareShareLabTicketFileDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentDTOXdentShareShareLabTicketFileDto
     */
    'idFile': string;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI {
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'dokument': APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIPojistenecNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'pojistenec': APIXdentHelpersESubmissionNEMPRIPojistenecNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'zamestnani': APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'rozhodneObdobi': APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'davka': APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'dalsiSdeleni'?: string | null;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIKontaktPracovnikNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'kontaktPracovnik': APIXdentHelpersESubmissionNEMPRIKontaktPracovnikNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'platebniSpojeni': APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIPrilohyNEMPRI>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'prilohy'?: Array<APIXdentHelpersESubmissionNEMPRIPrilohyNEMPRI> | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI
     */
    'poradoveCislo': number;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI {
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyNEMDavka}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI
     */
    'nem': APIXdentHelpersESubmissionNEMPRIDavkyNEMDavka;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI
     */
    'ose': APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPPMDavka}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI
     */
    'ppm': APIXdentHelpersESubmissionNEMPRIDavkyPPMDavka;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyDLODavka}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI
     */
    'dlo': APIXdentHelpersESubmissionNEMPRIDavkyDLODavka;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyOPPDavka}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI
     */
    'opp': APIXdentHelpersESubmissionNEMPRIDavkyOPPDavka;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyVPMDavka}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkaNEMPRI
     */
    'vpm': APIXdentHelpersESubmissionNEMPRIDavkyVPMDavka;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase
     */
    'od': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase
     */
    'do': Date;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyBaseOsobaBase
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyBaseOsobaBase {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBaseOsobaBase
     */
    'jmeno'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBaseOsobaBase
     */
    'prijmeni'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBaseOsobaBase
     */
    'rodneCislo'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBaseOsobaBase
     */
    'datumNarozeni'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyBasePotvrzeniZamestnavateleBase
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyBasePotvrzeniZamestnavateleBase {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBasePotvrzeniZamestnavateleBase
     */
    'pracoval': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBasePotvrzeniZamestnavateleBase
     */
    'pocetOdpracovanychHodin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBasePotvrzeniZamestnavateleBase
     */
    'pracovniDoba'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyBasePotvrzeniZamestnavateleBase
     */
    'prijemMalyRozsah'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyDLODavka
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyDLODavka {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDLODavka
     */
    'dloVznik': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDLODavka
     */
    'dloTrvani': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDLODavka
     */
    'dloUkonceni': boolean;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDLODavka
     */
    'potvrzeniZamestnavatele': APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDLODavka
     */
    'zadostODavku': APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDLODavka
     */
    'podkladyProVyplatDavky': APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyDitePPM
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyDitePPM {
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDitePPM
     */
    'poradoveCisloDitete': number;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDitePPM
     */
    'jmeno'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDitePPM
     */
    'prijmeni'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDitePPM
     */
    'rodneCislo'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyDitePPM
     */
    'datumNarozeni'?: Date | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyNEMDavka
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyNEMDavka {
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyNEMDavka
     */
    'potvrzeniZamestnavatele': APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyOPPDavka
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyOPPDavka {
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyOPPDavkaPotvrzeniZamestnavatele}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOPPDavka
     */
    'potvrzeniZamestnavatele'?: APIXdentHelpersESubmissionNEMPRIDavkyOPPDavkaPotvrzeniZamestnavatele | null;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOP}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOPPDavka
     */
    'zadostODavku': APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOP;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOPPDavka
     */
    'podkladyProVyplatDavky': APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP;
}
/**
 * @type APIXdentHelpersESubmissionNEMPRIDavkyOPPDavkaPotvrzeniZamestnavatele
 * @export
 */
export type APIXdentHelpersESubmissionNEMPRIDavkyOPPDavkaPotvrzeniZamestnavatele = APIXdentHelpersESubmissionNEMPRIDavkyBasePotvrzeniZamestnavateleBase | APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO | APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM | APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE | APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM | APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM;

/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka
     */
    'oseVznik': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka
     */
    'oseTrvani': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka
     */
    'oseUkonceni': boolean;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka
     */
    'potvrzeniZamestnavatele': APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka
     */
    'zadostODavku': APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyOSEDavka
     */
    'podkladyProVyplatDavky': APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPPMDavka
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPPMDavka {
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPPMDavka
     */
    'potvrzeniZamestnavatele': APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuPPM}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPPMDavka
     */
    'zadostODavku': APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuPPM;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO {
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
     */
    'pracovalPoslDenPD'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
     */
    'pracovniDobaPoslDenPD'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
     */
    'datumNavratDoPrace'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
     */
    'planovaneSmeny'?: boolean | null;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
     */
    'seznamRozvrhuSmen'?: Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase> | null;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
     */
    'seznamPraceVeDnech'?: Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
     */
    'maVolno'?: boolean | null;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyDLO
     */
    'pracovniVolno'?: Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase> | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP {
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP
     */
    'pracovniDobaPoslDenPD'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP
     */
    'pocetOdpracHodinPoslDenPD'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP
     */
    'planovaneSmeny': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP
     */
    'planovaneSmenyOdpracoval'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP
     */
    'datumNavratDoPrace'?: Date | null;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOOP
     */
    'seznamPraceVeDnech'?: Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase> | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE
     */
    'pracovalPoslDenPD'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE
     */
    'pracovniDobaPoslDenPD'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE
     */
    'pocetOdpracHodinPoslDenPD'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE
     */
    'planovaneSmeny'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE
     */
    'planovaneSmenyOdpracoval'?: boolean | null;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPodkladyProVyplatDavkyOSE
     */
    'seznamPraceVeDnech'?: Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase> | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'jeStudentem': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'spadaDoPrazdnin'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'prevedenaNaJinouPraci': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'datumNaJinouPraci'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'volnoBezNahrady': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'volnoBezNahradyOd'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'volnoBezNahradyDo'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'pracoval': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'pocetOdpracovanychHodin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'pracovniDoba'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleDLO
     */
    'prijemMalyRozsah'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'pobiraDuchod': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'druhDuchodu'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'jeStudentem': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'spadaDoPrazdnin'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'dobaVolnaPrvniZamestnani': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'volnoBezNahrady': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'volnoBezNahradyOd'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'volnoBezNahradyDo'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'nastupujePPM'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'narozeniDitete'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'prevedenaNaJinouPraci': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'datumNaJinouPraci'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'exekuce': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'insolvence': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'pracoval': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'pocetOdpracovanychHodin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'pracovniDoba'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleNEM
     */
    'prijemMalyRozsah'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'jeStudentem': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'spadaDoPrazdnin'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'prevedenaNaJinouPraci': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'datumNaJinouPraci'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'volnoBezNahrady'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'volnoBezNahradyOd'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'volnoBezNahradyDo'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'pracoval': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'pocetOdpracovanychHodin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'pracovniDoba'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleOSE
     */
    'prijemMalyRozsah'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'pobiraDuchod': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'druhDuchodu'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'nastupujePPM'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'narozeniDitete'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'prevedenaNaJinouPraci': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'datumNaJinouPraci'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'exekuce': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'insolvence': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'pracoval': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'pocetOdpracovanychHodin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'pracovniDoba'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavatelePPM
     */
    'prijemMalyRozsah'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'pobiraDuchod': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'druhDuchodu'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'jeStudentem': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'spadaDoPrazdnin'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'dobaVolnaPrvniZamestnani': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'nastupujePPM'?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'narozeniDitete'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'prevedenaNaJinouPraci': boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'datumNaJinouPraci'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'exekuce': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'insolvence': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'pracoval': boolean;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'pocetOdpracovanychHodin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'pracovniDoba'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM
     */
    'prijemMalyRozsah'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyUzavrenaSkolaOSE
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyUzavrenaSkolaOSE {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyUzavrenaSkolaOSE
     */
    'nazevZarizeniSkoly'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyUzavrenaSkolaOSE
     */
    'icZarizeniSkoly'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyVPMDavka
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyVPMDavka {
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyVPMDavka
     */
    'potvrzeniZamestnavatele': APIXdentHelpersESubmissionNEMPRIDavkyPotvrzeniZamestnavateleVPM;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'odeDne'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'doDne'?: Date | null;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLOOsetrovanaOsoba}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'osetrovanaOsoba'?: APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLOOsetrovanaOsoba | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'kodVztah'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'jeStridani'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'narokNaPPMjinouOsobou'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'jinaFOParagraf57'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'spolecnaDomacnost'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'pecovalOsobne'?: boolean | null;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLO
     */
    'pecovalVeDnech'?: Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase> | null;
}
/**
 * @type APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLOOsetrovanaOsoba
 * @export
 */
export type APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLOOsetrovanaOsoba = APIXdentHelpersESubmissionNEMPRIDavkyBaseOsobaBase | APIXdentHelpersESubmissionNEMPRIDavkyDitePPM;

/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOP
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOP {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOP
     */
    'odeDne': Date;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLOOsetrovanaOsoba}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOP
     */
    'dite'?: APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLOOsetrovanaOsoba | null;
    /**
     * 0 - OTC, 1 - ZEM, 2 - PEC
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOP
     */
    'duvodOtcovske': APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOPDuvodOtcovskeEnum;
}

export const APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOPDuvodOtcovskeEnum = {
    Otc: 'OTC',
    Zem: 'ZEM',
    Pec: 'PEC'
} as const;

export type APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOPDuvodOtcovskeEnum = typeof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOPDuvodOtcovskeEnum[keyof typeof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOOPDuvodOtcovskeEnum];

/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'odeDne'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'doDne'?: Date | null;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLOOsetrovanaOsoba}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'osetrovanaOsoba'?: APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuDLOOsetrovanaOsoba | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'onemocnela'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'narizenaKarantena'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'nemuzePecovatODite'?: boolean | null;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDavkyUzavrenaSkolaOSE}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'uzavrenaSkola': APIXdentHelpersESubmissionNEMPRIDavkyUzavrenaSkolaOSE;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'spolecnaDomacnost'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'jeOsamely'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'vPeciDiteDo16Let'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'narokNaPPMjinouOsobou'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'narokNaRPjinaOsobaNecerpaVolnoNeboOSVC'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'jinaFOParagraf57'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'pecovalOsobne'?: boolean | null;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'pecovalVeDnech'?: Array<APIXdentHelpersESubmissionNEMPRIDavkyBaseObdobiBase> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuOSE
     */
    'kodRodVztah'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuPPM
 */
export interface APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuPPM {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuPPM
     */
    'odeDne': Date;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuPPM
     */
    'duvodPece'?: string | null;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIDavkyDitePPM>}
     * @memberof APIXdentHelpersESubmissionNEMPRIDavkyZadostODavkuPPM
     */
    'deti'?: Array<APIXdentHelpersESubmissionNEMPRIDavkyDitePPM> | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI
     */
    'kodOSSZ'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI
     */
    'cisloRozhodnuti'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI
     */
    'zahranicni'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI
     */
    'opravnePodani'?: boolean | null;
    /**
     * 0 - DLO, 1 - NEM, 2 - OSE, 3 - OPP, 4 - PPM, 5 - VPM
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIDokumentNEMPRI
     */
    'druhDavkyEnum': APIXdentHelpersESubmissionNEMPRIDokumentNEMPRIDruhDavkyEnumEnum;
}

export const APIXdentHelpersESubmissionNEMPRIDokumentNEMPRIDruhDavkyEnumEnum = {
    Dlo: 'DLO',
    Nem: 'NEM',
    Ose: 'OSE',
    Opp: 'OPP',
    Ppm: 'PPM',
    Vpm: 'VPM'
} as const;

export type APIXdentHelpersESubmissionNEMPRIDokumentNEMPRIDruhDavkyEnumEnum = typeof APIXdentHelpersESubmissionNEMPRIDokumentNEMPRIDruhDavkyEnumEnum[keyof typeof APIXdentHelpersESubmissionNEMPRIDokumentNEMPRIDruhDavkyEnumEnum];

/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIKontaktNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIKontaktNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIKontaktNEMPRI
     */
    'telefon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIKontaktNEMPRI
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIKontaktPracovnikNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIKontaktPracovnikNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIKontaktPracovnikNEMPRI
     */
    'telefon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIKontaktPracovnikNEMPRI
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIKontaktPracovnikNEMPRI
     */
    'kontaktniPracovnik'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRINEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRINEMPRI {
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIVENDORNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRI
     */
    'vendor': APIXdentHelpersESubmissionNEMPRIVENDORNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRISENDERNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRI
     */
    'sender': APIXdentHelpersESubmissionNEMPRISENDERNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRI
     */
    'datovaVeta': APIXdentHelpersESubmissionNEMPRIDatovaVetaNEMPRI;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRI
     */
    'partialAccept'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRI
     */
    'version'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRINEMPRIObdobi
 */
export interface APIXdentHelpersESubmissionNEMPRINEMPRIObdobi {
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRIObdobi
     */
    'kalendarniMesic': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRIObdobi
     */
    'kalendarniRok': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRIObdobi
     */
    'zapocitatelnyPrijem': number;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRINEMPRIObdobi
     */
    'vylouceneDny': number;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI
     */
    'obec'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI
     */
    'ulice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI
     */
    'cisloPopis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI
     */
    'cisloOrient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI
     */
    'psc'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI
     */
    'vyplatitUcetCR'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI
     */
    'vyplatitUcetCizina'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI
     */
    'vyplatitAdresa'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI
     */
    'vyplatitHotovost'?: boolean | null;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI
     */
    'adresa': APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniAdresaNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetCZNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI
     */
    'ucetCZ': APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetCZNEMPRI;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniNEMPRI
     */
    'ucetZahranicni': APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetCZNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetCZNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetCZNEMPRI
     */
    'predcisli'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetCZNEMPRI
     */
    'ucetCislo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetCZNEMPRI
     */
    'specSymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetCZNEMPRI
     */
    'bankaKod'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'stat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'iban'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'ucetCislo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'ucetNazev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'bankaNazev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'bankaTypId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'bankaKod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'obec'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'ulice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'cisloPopis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'cisloOrient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPlatebniSpojeniUcetZahranicniNEMPRI
     */
    'psc'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIPojistenecNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIPojistenecNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPojistenecNEMPRI
     */
    'jmeno'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPojistenecNEMPRI
     */
    'prijmeni'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPojistenecNEMPRI
     */
    'rodneCislo'?: string | null;
    /**
     * 
     * @type {APIXdentHelpersESubmissionNEMPRIKontaktNEMPRI}
     * @memberof APIXdentHelpersESubmissionNEMPRIPojistenecNEMPRI
     */
    'kontakt': APIXdentHelpersESubmissionNEMPRIKontaktNEMPRI;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIPrilohaNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIPrilohaNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPrilohaNEMPRI
     */
    'nazev'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPrilohaNEMPRI
     */
    'typ'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPrilohaNEMPRI
     */
    'komentar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIPrilohaNEMPRI
     */
    'base64data'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIPrilohyNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIPrilohyNEMPRI {
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIPrilohyNEMPRI
     */
    'count': number;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRIPrilohaNEMPRI>}
     * @memberof APIXdentHelpersESubmissionNEMPRIPrilohyNEMPRI
     */
    'priloha'?: Array<APIXdentHelpersESubmissionNEMPRIPrilohaNEMPRI> | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI
     */
    'rozhodneObdobiOd': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI
     */
    'rozhodneObdobiDo': Date;
    /**
     * 
     * @type {Array<APIXdentHelpersESubmissionNEMPRINEMPRIObdobi>}
     * @memberof APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI
     */
    'seznamObdobi'?: Array<APIXdentHelpersESubmissionNEMPRINEMPRIObdobi> | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI
     */
    'zapocitatelnyPrijemCelkem'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI
     */
    'vylouceneDnyCelkem'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentHelpersESubmissionNEMPRIRozhodneObdobiNEMPRI
     */
    'pravdepodobnaVysePrijmu'?: number | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRISENDERNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRISENDERNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRISENDERNEMPRI
     */
    'emailNotifikace'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRISENDERNEMPRI
     */
    'isdSreportEnum'?: APIXdentHelpersESubmissionNEMPRISENDERNEMPRIIsdSreportEnumEnum;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRISENDERNEMPRI
     */
    'isdSreportValue'?: string | null;
}

export const APIXdentHelpersESubmissionNEMPRISENDERNEMPRIIsdSreportEnumEnum = {
    None: 'NONE',
    Xml: 'XML',
    Html: 'HTML',
    XmlHtml: 'XML_HTML'
} as const;

export type APIXdentHelpersESubmissionNEMPRISENDERNEMPRIIsdSreportEnumEnum = typeof APIXdentHelpersESubmissionNEMPRISENDERNEMPRIIsdSreportEnumEnum[keyof typeof APIXdentHelpersESubmissionNEMPRISENDERNEMPRIIsdSreportEnumEnum];

/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIVENDORNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIVENDORNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIVENDORNEMPRI
     */
    'productName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIVENDORNEMPRI
     */
    'productVersion'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI
 */
export interface APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI {
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI
     */
    'vsZamestnavatel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI
     */
    'icZamestnavatel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI
     */
    'nazevZamestnavatel'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI
     */
    'zamestnanOd': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI
     */
    'zamestnanDo'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRI
     */
    'druhCinnostiEnum'?: APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRIDruhCinnostiEnumEnum;
}

export const APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRIDruhCinnostiEnumEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
    H: 'H',
    I: 'I',
    J: 'J',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    O: 'O',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
    T: 'T',
    U: 'U',
    V: 'V',
    W: 'W',
    X: 'X',
    Y: 'Y',
    Z: 'Z',
    One: 'One',
    Two: 'Two',
    Three: 'Three',
    Four: 'Four',
    Five: 'Five',
    Six: 'Six',
    Seven: 'Seven',
    Eight: 'Eight',
    Nine: 'Nine'
} as const;

export type APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRIDruhCinnostiEnumEnum = typeof APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRIDruhCinnostiEnumEnum[keyof typeof APIXdentHelpersESubmissionNEMPRIZamestnaniNEMPRIDruhCinnostiEnumEnum];

/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto
 */
export interface APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto
     */
    'alerts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto
     */
    'medicaments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto
     */
    'formMedicaments'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto
     */
    'formAlerts'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto
     */
    'anamnesisDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryDto
 */
export interface APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryDto {
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryItemDto>}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryDto
     */
    'items'?: Array<APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryDto
     */
    'anamnesisDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryItemDto
 */
export interface APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryItemDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryItemDto
     */
    'idForm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryItemDto
     */
    'formName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryItemDto
     */
    'formMedicaments'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryItemDto
     */
    'formAlerts'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2FETCHSIMPLEResultExtened
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2FETCHSIMPLEResultExtened {
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2FETCHSIMPLEResultExtened
     */
    'appointment': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2FETCHSIMPLEResult;
    /**
     * 
     * @type {APISharedRecurrenceInfoDto}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2FETCHSIMPLEResultExtened
     */
    'recurrenceInfoParsed': APISharedRecurrenceInfoDto;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2FETCHSIMPLEResultExtened
     */
    'recurrenceInfoRRULE'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2OHFETCHResultExtened
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2OHFETCHResultExtened {
    /**
     * 
     * @type {APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2OHFETCHResultExtened
     */
    'appointment': APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2OHFETCHResult;
    /**
     * 
     * @type {APISharedRecurrenceInfoDto}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2OHFETCHResultExtened
     */
    'recurrenceInfoParsed': APISharedRecurrenceInfoDto;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2OHFETCHResultExtened
     */
    'recurrenceInfoRRULE'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto {
    /**
     * 
     * @type {Array<APISharedCalendarAppointmentX2Dto>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto
     */
    'items'?: Array<APISharedCalendarAppointmentX2Dto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2AvailableInterval
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2AvailableInterval {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2AvailableInterval
     */
    'idStaff': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2AvailableInterval
     */
    'day': Date;
    /**
     * 
     * @type {APIXdentServicesXdentScopedAppointmentServiceX2SelectedServicesHelper}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2AvailableInterval
     */
    'services': APIXdentServicesXdentScopedAppointmentServiceX2SelectedServicesHelper;
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedAppointmentServiceX2CustomInterval>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2AvailableInterval
     */
    'intervals'?: Array<APIXdentServicesXdentScopedAppointmentServiceX2CustomInterval> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarAppointmentNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarAppointmentNCDto {
    /**
     * 
     * @type {Array<APISharedCalendarAppointmentX2Dto>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CalendarAppointmentNCDto
     */
    'items'?: Array<APISharedCalendarAppointmentX2Dto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarClientsNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarClientsNCDto {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CalendarClientsNCDto
     */
    'items'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTX2CLIENTGRIDResult> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC
     */
    'idStaff'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarOpenHoursNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarOpenHoursNCDto {
    /**
     * 
     * @type {Array<APISharedCalendarOpenHourX2Dto>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CalendarOpenHoursNCDto
     */
    'items'?: Array<APISharedCalendarOpenHourX2Dto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarServicesNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarServicesNCDto {
    /**
     * 
     * @type {Array<APISharedServiceWithRelation>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CalendarServicesNCDto
     */
    'items'?: Array<APISharedServiceWithRelation> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarStaffsNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2CalendarStaffsNCDto {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CalendarStaffsNCDto
     */
    'items'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2CustomInterval
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2CustomInterval {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CustomInterval
     */
    'start': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2CustomInterval
     */
    'end': Date;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto {
    /**
     * 
     * @type {Array<APISharedDeleteAppointmentItem2Dto>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto
     */
    'items'?: Array<APISharedDeleteAppointmentItem2Dto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto {
    /**
     * 
     * @type {Array<APISharedEditAppointmentX2Dto>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto
     */
    'items'?: Array<APISharedEditAppointmentX2Dto> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO
     */
    'idOwner'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO
     */
    'idStaffs'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto
     */
    'idOwner': string;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto
     */
    'start': Date;
    /**
     * 
     * @type {number}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto
     */
    'searchDays': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto
     */
    'staffs'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto
     */
    'showDebugData': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC {
    /**
     * 
     * @type {APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC
     */
    'debugData': APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETHOLIDAYSResult>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC
     */
    'holidays'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETHOLIDAYSResult> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC
     */
    'servicesStaffs'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSERVICEGRIDJSONBYSTAFFResult> | null;
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETINFOFORSTAFFResult>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC
     */
    'schedulingStaffs'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSCHEDULINGGETINFOFORSTAFFResult> | null;
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedAppointmentServiceX2OpenDay>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC
     */
    'globalSearchResultSet'?: Array<APIXdentServicesXdentScopedAppointmentServiceX2OpenDay> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2OpenDay
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2OpenDay {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenDay
     */
    'day': Date;
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedAppointmentServiceX2AvailableInterval>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenDay
     */
    'availableIntervals'?: Array<APIXdentServicesXdentScopedAppointmentServiceX2AvailableInterval> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2OpenHourBulkInsert
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2OpenHourBulkInsert {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenHourBulkInsert
     */
    'date'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenHourBulkInsert
     */
    'from'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenHourBulkInsert
     */
    'to'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenHourBulkInsert
     */
    'idStaff'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto {
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedAppointmentServiceX2OpenHourBulkInsert>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto
     */
    'openHours'?: Array<APIXdentServicesXdentScopedAppointmentServiceX2OpenHourBulkInsert> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertResultDto
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertResultDto
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursWithOccurrences
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursWithOccurrences {
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedAppointmentServiceX2OpenDay>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursWithOccurrences
     */
    'openDays'?: Array<APIXdentServicesXdentScopedAppointmentServiceX2OpenDay> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData {
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData
     */
    'startDateL': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData
     */
    'endDateL': Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData
     */
    'filteredStaff'?: Array<string> | null;
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2FETCHSIMPLEResultExtened>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData
     */
    'appointments'?: Array<APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2FETCHSIMPLEResultExtened> | null;
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2OHFETCHResultExtened>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2SearchDebugData
     */
    'openHours'?: Array<APIXdentServicesXdentScopedAppointmentServiceX2APPOINTMENTX2OHFETCHResultExtened> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedAppointmentServiceX2SelectedServicesHelper
 */
export interface APIXdentServicesXdentScopedAppointmentServiceX2SelectedServicesHelper {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2SelectedServicesHelper
     */
    'xdentServices'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIXdentServicesXdentScopedAppointmentServiceX2SelectedServicesHelper
     */
    'onlineServices'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedClientServiceXdentPointAppointmentAddInfoDto
 */
export interface APIXdentServicesXdentScopedClientServiceXdentPointAppointmentAddInfoDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointAppointmentAddInfoDto
     */
    'idImageFile'?: string | null;
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedClientServiceXdentPointNavSettingMutation>}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointAppointmentAddInfoDto
     */
    'navigationMutations'?: Array<APIXdentServicesXdentScopedClientServiceXdentPointNavSettingMutation> | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedClientServiceXdentPointGenderDto
 */
export interface APIXdentServicesXdentScopedClientServiceXdentPointGenderDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGenderDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGenderDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGenderDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGenderDto
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
 */
export interface APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'staffDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'onlineBooked': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'directions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {APIXdentServicesXdentScopedClientServiceXdentPointGridClient}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'client': APIXdentServicesXdentScopedClientServiceXdentPointGridClient;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'idStaffProfilePhoto'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'directionName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'directionDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
 */
export interface APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2 {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'idAppointment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'idStaff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'idService'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'endDate'?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'startDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'staffName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'staffDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'serviceCaption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'onlineBooked': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {APIXdentServicesXdentScopedClientServiceXdentPointGridClient}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'client': APIXdentServicesXdentScopedClientServiceXdentPointGridClient;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'idStaffProfilePhoto'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperDto
 */
export interface APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperDto {
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment>}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperDto
     */
    'appointments'?: Array<APIXdentServicesXdentScopedClientServiceXdentPointGridAppointment> | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperDto
     */
    'searchStart': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperDto
     */
    'searchEnd': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperDto
     */
    'filteredByLocation': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperV2Dto
 */
export interface APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperV2Dto {
    /**
     * 
     * @type {Array<APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2>}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperV2Dto
     */
    'appointments'?: Array<APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentV2> | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperV2Dto
     */
    'searchStart': Date;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperV2Dto
     */
    'searchEnd': Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperV2Dto
     */
    'filteredByLocation': boolean;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedClientServiceXdentPointGridClient
 */
export interface APIXdentServicesXdentScopedClientServiceXdentPointGridClient {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'idClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'firstname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'lastname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'personalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'phone'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'dateOfBirth'?: Date | null;
    /**
     * 
     * @type {APIXdentServicesXdentScopedClientServiceXdentPointGenderDto}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'gender': APIXdentServicesXdentScopedClientServiceXdentPointGenderDto;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointGridClient
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedClientServiceXdentPointNavSettingMutation
 */
export interface APIXdentServicesXdentScopedClientServiceXdentPointNavSettingMutation {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointNavSettingMutation
     */
    'idLanguage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointNavSettingMutation
     */
    'languageCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointNavSettingMutation
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedClientServiceXdentPointNavSettingMutation
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedGetPresignedUrl
 */
export interface APIXdentServicesXdentScopedGetPresignedUrl {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedGetPresignedUrl
     */
    'urlPreview': string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedGetPresignedUrl
     */
    'urlDownload': string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentServicesXdentScopedGetPresignedUrl
     */
    'expiresInSeconds': number;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedInterfacesGetCompanyIdByUserIdDTO
 */
export interface APIXdentServicesXdentScopedInterfacesGetCompanyIdByUserIdDTO {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedInterfacesGetCompanyIdByUserIdDTO
     */
    'idUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedInterfacesGetCompanyIdByUserIdDTO
     */
    'idCompany'?: string | null;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedLabRequestFormTagDto
 */
export interface APIXdentServicesXdentScopedLabRequestFormTagDto {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedLabRequestFormTagDto
     */
    'idLabRequestFormTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedLabRequestFormTagDto
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedLabRequestFormTagDto
     */
    'tagName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedLabRequestFormTagDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIXdentServicesXdentScopedLabRequestFormTagDto
     */
    'position': number;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedLanguagesServiceLanguageDTO
 */
export interface APIXdentServicesXdentScopedLanguagesServiceLanguageDTO {
    /**
     * 
     * @type {APIContextGeneratedXdentCoreEntityLayerLanguage}
     * @memberof APIXdentServicesXdentScopedLanguagesServiceLanguageDTO
     */
    'language': APIContextGeneratedXdentCoreEntityLayerLanguage;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedLanguagesServiceLanguageDTO
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedLanguagesServiceLanguageDTO
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedLanguagesServiceLanguageDTO
     */
    'anotation'?: string | null;
    /**
     * 
     * @type {APIContextGeneratedXdentCoreEntityLayerMutation}
     * @memberof APIXdentServicesXdentScopedLanguagesServiceLanguageDTO
     */
    'mutation': APIContextGeneratedXdentCoreEntityLayerMutation;
}
/**
 * 
 * @export
 * @interface APIXdentServicesXdentScopedS3FileItem
 */
export interface APIXdentServicesXdentScopedS3FileItem {
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedS3FileItem
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedS3FileItem
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedS3FileItem
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedS3FileItem
     */
    'mime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIXdentServicesXdentScopedS3FileItem
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof APIXdentServicesXdentScopedS3FileItem
     */
    'createdAtDate': Date;
}
/**
 * @type ApiAppointmentAddAppointmentPostRequest
 * @export
 */
export type ApiAppointmentAddAppointmentPostRequest = APISharedCreateAppointmentDto | APISharedEditAppointmentDto;

/**
 * @type ApiClientAddClientPostRequest
 * @export
 */
export type ApiClientAddClientPostRequest = APISharedAddClientDto | APISharedAddClientInternal | APISharedEditClientDto | APISharedEditClientInternal;

/**
 * @type ApiClientEditClientPutRequest
 * @export
 */
export type ApiClientEditClientPutRequest = APISharedEditClientDto | APISharedEditClientInternal;

/**
 * @type ApiDentalCategoryUpdateClientDentalCategoriesPutRequest
 * @export
 */
export type ApiDentalCategoryUpdateClientDentalCategoriesPutRequest = APISharedUpdateClientCategoriesDto | APISharedUpdateClientCategoriesInternal;

/**
 * @type ApiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost404Response
 * @export
 */
export type ApiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost404Response = MicrosoftAspNetCoreHttpHttpValidationProblemDetails | MicrosoftAspNetCoreMvcProblemDetails;

/**
 * @type ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest
 * @export
 */
export type ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest = LabinoDtoShareTicketXdentRequest | LabinoDtoShareTicketXdentRequestFromXdent | LabinoDtoShareTicketXdentRequestToLabino;

/**
 * @type ApiOnlineBookingAuthOnlineBookingIklientPostRequest
 * @export
 */
export type ApiOnlineBookingAuthOnlineBookingIklientPostRequest = APISharedLoginBookingDto | APISharedLoginDto;

/**
 * @type ApiOnlineBookingSendUnknownClientPostRequest
 * @export
 */
export type ApiOnlineBookingSendUnknownClientPostRequest = APISharedOnlineBookingSendByMiniWebsiteDto | APISharedOnlineBookingSendByMiniWebsiteV3Dto;

/**
 * @type ApiSafesignaturesAuthPostRequest
 * @export
 */
export type ApiSafesignaturesAuthPostRequest = APISharedChiroLoginDto | APISharedXdentLoginDto;

/**
 * @type ApiTagAddCustomTagPostRequest
 * @export
 */
export type ApiTagAddCustomTagPostRequest = APISharedAddClientRelationCustomTagDto | APISharedAddRelationCustomTagDto;

/**
 * 
 * @export
 * @interface LabinoDtoChatMessageFileDto
 */
export interface LabinoDtoChatMessageFileDto {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoChatMessageFileDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoChatMessageFileDto
     */
    'extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoChatMessageFileDto
     */
    'mimeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoChatMessageFileDto
     */
    'imageDataBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoInvalidateLaboratoryRequest
 */
export interface LabinoDtoInvalidateLaboratoryRequest {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvalidateLaboratoryRequest
     */
    'idOwner': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvalidateLaboratoryRequest
     */
    'idXLaboratory': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvalidateLaboratoryRequest
     */
    'idXLocation': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvalidateLaboratoryRequest
     */
    'idLabLocation': string;
}
/**
 * 
 * @export
 * @interface LabinoDtoInvoicePartnerInvitationDTO
 */
export interface LabinoDtoInvoicePartnerInvitationDTO {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvoicePartnerInvitationDTO
     */
    'idInvoicePartner': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvoicePartnerInvitationDTO
     */
    'regNr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvoicePartnerInvitationDTO
     */
    'idLabCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvoicePartnerInvitationDTO
     */
    'idLabLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoInvoicePartnerInvitationDTO
     */
    'labLaboratoryName'?: string | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoLabMacro
 */
export interface LabinoDtoLabMacro {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'idMacro'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'idTicket'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'idCategory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'categoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'categoryTitle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacro
     */
    'sumQuantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacro
     */
    'sumPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacro
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'localization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacro
     */
    'text'?: string | null;
    /**
     * 
     * @type {Array<LabinoDtoLabMacroItem>}
     * @memberof LabinoDtoLabMacro
     */
    'macroItems'?: Array<LabinoDtoLabMacroItem> | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoLabMacroItem
 */
export interface LabinoDtoLabMacroItem {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'idMacroItem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'idInvoiceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'idParentMacro'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'idType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LabinoDtoLabMacroItem
     */
    'isDone'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'localization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'idLocalization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'idColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'laborant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabMacroItem
     */
    'idLaborant'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacroItem
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacroItem
     */
    'unitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacroItem
     */
    'laborantBonusFix'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacroItem
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacroItem
     */
    'position'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacroItem
     */
    'insertedUnitPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLabMacroItem
     */
    'materialLoss'?: number | null;
}
/**
 * This is used by labino frontend (legacy stuff, but dont refactor it)
 * @export
 * @interface LabinoDtoLabPairHelp
 */
export interface LabinoDtoLabPairHelp {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'idLabLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'idLabCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'idCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'idLaboratory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'idLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LabinoDtoLabPairHelp
     */
    'pairSucceded'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabPairHelp
     */
    'idCreatedLab'?: string | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoLabTicketHistoryDto
 */
export interface LabinoDtoLabTicketHistoryDto {
    /**
     * 
     * @type {APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult}
     * @memberof LabinoDtoLabTicketHistoryDto
     */
    'labTicketDetail': APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABTICKETDETAILResult;
    /**
     * 
     * @type {APIContextGeneratedLabinoCoreEntityLayerLabTicket}
     * @memberof LabinoDtoLabTicketHistoryDto
     */
    'labTicket': APIContextGeneratedLabinoCoreEntityLayerLabTicket;
    /**
     * 
     * @type {Array<LabinoDtoLabMacro>}
     * @memberof LabinoDtoLabTicketHistoryDto
     */
    'labMacros'?: Array<LabinoDtoLabMacro> | null;
    /**
     * 
     * @type {Array<APIContextGeneratedLabinoCoreEntityLayerLabTicketInspections>}
     * @memberof LabinoDtoLabTicketHistoryDto
     */
    'inspections'?: Array<APIContextGeneratedLabinoCoreEntityLayerLabTicketInspections> | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabTicketHistoryDto
     */
    'idLabinoUser': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLabTicketHistoryDto
     */
    'historyBatchGeneratedName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LabinoDtoLabTicketHistoryDto
     */
    'isTicketExternalStatusUpdate'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof LabinoDtoLabTicketHistoryDto
     */
    'isSilentUpdate'?: boolean | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoLaboratoryGridMarketplaceDto
 */
export interface LabinoDtoLaboratoryGridMarketplaceDto {
    /**
     * 
     * @type {APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult}
     * @memberof LabinoDtoLaboratoryGridMarketplaceDto
     */
    'laboratory': APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult;
    /**
     * 
     * @type {LabinoDtoLocationGeocache}
     * @memberof LabinoDtoLaboratoryGridMarketplaceDto
     */
    'geocache': LabinoDtoLocationGeocache;
}
/**
 * 
 * @export
 * @interface LabinoDtoLocationGeocache
 */
export interface LabinoDtoLocationGeocache {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLocationGeocache
     */
    'idEntity'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLocationGeocache
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LabinoDtoLocationGeocache
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoLocationGeocache
     */
    'map'?: string | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoMasterListMap
 */
export interface LabinoDtoMasterListMap {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoMasterListMap
     */
    'idMaster': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoMasterListMap
     */
    'idFile': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoMasterListMap
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoMasterListMap
     */
    'idPartnerFile'?: string | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoShareLabLaboratoryRequest
 */
export interface LabinoDtoShareLabLaboratoryRequest {
    /**
     * 
     * @type {APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest}
     * @memberof LabinoDtoShareLabLaboratoryRequest
     */
    'laboratoryRequest': APIContextGeneratedLabinoCoreEntityLayerLabLaboratoryRequest;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareLabLaboratoryRequest
     */
    'labinoUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareLabLaboratoryRequest
     */
    'labLaboratoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareLabLaboratoryRequest
     */
    'idPricelistValidity'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof LabinoDtoShareLabLaboratoryRequest
     */
    'dateFrom'?: Date | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoSharePricelistValidityInternalDto
 */
export interface LabinoDtoSharePricelistValidityInternalDto {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoSharePricelistValidityInternalDto
     */
    'idPricelistValidity': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoSharePricelistValidityInternalDto
     */
    'idLabCompany': string;
    /**
     * 
     * @type {Date}
     * @memberof LabinoDtoSharePricelistValidityInternalDto
     */
    'dateFrom': Date;
}
/**
 * 
 * @export
 * @interface LabinoDtoShareTicketChatMessage
 */
export interface LabinoDtoShareTicketChatMessage {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketChatMessage
     */
    'idLabLabel': string;
    /**
     * 
     * @type {Array<LabinoDtoChatMessageFileDto>}
     * @memberof LabinoDtoShareTicketChatMessage
     */
    'files'?: Array<LabinoDtoChatMessageFileDto> | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketChatMessage
     */
    'messageText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketChatMessage
     */
    'existingIdFile'?: string | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoShareTicketXdentRequest
 */
export interface LabinoDtoShareTicketXdentRequest {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequest
     */
    'idLabTicket'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequest
     */
    'labLabelNumber'?: string | null;
    /**
     * 
     * @type {APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal}
     * @memberof LabinoDtoShareTicketXdentRequest
     */
    'externalMessage': APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal;
    /**
     * 
     * @type {LabinoDtoShareTicketXdentRequestSharedFilesWrapper}
     * @memberof LabinoDtoShareTicketXdentRequest
     */
    'sharedFilesWrapper'?: LabinoDtoShareTicketXdentRequestSharedFilesWrapper | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequest
     */
    'idXdentLaboratory': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequest
     */
    'idXdentCompany': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequest
     */
    'labelNumberLab'?: string | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoShareTicketXdentRequestFromXdent
 */
export interface LabinoDtoShareTicketXdentRequestFromXdent {
    /**
     * 
     * @type {LabinoDtoSharedFilesWrapperFromXdent}
     * @memberof LabinoDtoShareTicketXdentRequestFromXdent
     */
    'sharedFilesWrapper': LabinoDtoSharedFilesWrapperFromXdent;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestFromXdent
     */
    'idLabTicket'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestFromXdent
     */
    'labLabelNumber'?: string | null;
    /**
     * 
     * @type {APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal}
     * @memberof LabinoDtoShareTicketXdentRequestFromXdent
     */
    'externalMessage': APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestFromXdent
     */
    'idXdentLaboratory': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestFromXdent
     */
    'idXdentCompany': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestFromXdent
     */
    'labelNumberLab'?: string | null;
}
/**
 * @type LabinoDtoShareTicketXdentRequestSharedFilesWrapper
 * @export
 */
export type LabinoDtoShareTicketXdentRequestSharedFilesWrapper = LabinoDtoSharedFilesWrapper | LabinoDtoSharedFilesWrapperFromXdent | LabinoDtoSharedFilesWrapperToLabino;

/**
 * 
 * @export
 * @interface LabinoDtoShareTicketXdentRequestToLabino
 */
export interface LabinoDtoShareTicketXdentRequestToLabino {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestToLabino
     */
    'idLabTicket'?: string | null;
    /**
     * 
     * @type {APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal}
     * @memberof LabinoDtoShareTicketXdentRequestToLabino
     */
    'externalMessage': APIContextGeneratedLabinoCoreEntityLayerChatMessageExternal;
    /**
     * 
     * @type {LabinoDtoSharedFilesWrapperToLabino}
     * @memberof LabinoDtoShareTicketXdentRequestToLabino
     */
    'sharedFilesWrapper': LabinoDtoSharedFilesWrapperToLabino;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestToLabino
     */
    'idXdentCompany': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestToLabino
     */
    'labLabelNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestToLabino
     */
    'idXdentLaboratory': string;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoShareTicketXdentRequestToLabino
     */
    'labelNumberLab'?: string | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoSharedFilesWrapper
 */
export interface LabinoDtoSharedFilesWrapper {
    /**
     * 
     * @type {Array<APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result>}
     * @memberof LabinoDtoSharedFilesWrapper
     */
    'galleryFiles'?: Array<APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedGALLERYFILESGRID2Result> | null;
    /**
     * 
     * @type {Array<LabinoDtoMasterListMap>}
     * @memberof LabinoDtoSharedFilesWrapper
     */
    'sharedFiles'?: Array<LabinoDtoMasterListMap> | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoSharedFilesWrapperFromXdent
 */
export interface LabinoDtoSharedFilesWrapperFromXdent {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result>}
     * @memberof LabinoDtoSharedFilesWrapperFromXdent
     */
    'galleryFiles'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result> | null;
    /**
     * 
     * @type {Array<LabinoDtoMasterListMap>}
     * @memberof LabinoDtoSharedFilesWrapperFromXdent
     */
    'sharedFiles'?: Array<LabinoDtoMasterListMap> | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoSharedFilesWrapperToLabino
 */
export interface LabinoDtoSharedFilesWrapperToLabino {
    /**
     * 
     * @type {Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result>}
     * @memberof LabinoDtoSharedFilesWrapperToLabino
     */
    'galleryFiles'?: Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result> | null;
    /**
     * 
     * @type {Array<LabinoDtoMasterListMap>}
     * @memberof LabinoDtoSharedFilesWrapperToLabino
     */
    'sharedFiles'?: Array<LabinoDtoMasterListMap> | null;
}
/**
 * 
 * @export
 * @interface LabinoDtoXdentLocationBillingInfoDto
 */
export interface LabinoDtoXdentLocationBillingInfoDto {
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoXdentLocationBillingInfoDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoXdentLocationBillingInfoDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoXdentLocationBillingInfoDto
     */
    'post'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoXdentLocationBillingInfoDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoXdentLocationBillingInfoDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoXdentLocationBillingInfoDto
     */
    'regNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoXdentLocationBillingInfoDto
     */
    'vatNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabinoDtoXdentLocationBillingInfoDto
     */
    'web'?: string | null;
}
/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreHttpHttpValidationProblemDetails
 */
export interface MicrosoftAspNetCoreHttpHttpValidationProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof MicrosoftAspNetCoreHttpHttpValidationProblemDetails
     */
    'errors'?: { [key: string]: Array<string>; } | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreHttpHttpValidationProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreHttpHttpValidationProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MicrosoftAspNetCoreHttpHttpValidationProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreHttpHttpValidationProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreHttpHttpValidationProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreMvcProblemDetails
 */
export interface MicrosoftAspNetCoreMvcProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'typDavkovania': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'denneDavkovanie1'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'denneDavkovanie1Specified': boolean;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDenneDavkovanie}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'denneDavkovanie2': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDenneDavkovanie;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'jednotkaDavkovania'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'sposobPodania'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'periodicita'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'dobaLiecbyValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'dobaLiecbyValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'dobaLiecby'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'poznamka'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie
     */
    'prepisDavkovania': string;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDenneDavkovanie
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDenneDavkovanie {
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDenneDavkovanie
     */
    'pocetJednotiek': number;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDenneDavkovanie
     */
    'opakovanieVHodinach': number;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDychaciPristroj
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDychaciPristroj {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDychaciPristroj
     */
    'ico': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDychaciPristroj
     */
    'kodNZ': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDychaciPristroj
     */
    'nastavenia'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'kodOdporucajucaNZ': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'idOdporucajucaNZValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'idOdporucajucaNZValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'idOdporucajucaNZ'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'kodOdporucajuciLekar': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'idOdporucajuciLekarValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'idOdporucajuciLekarValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'idOdporucajuciLekar'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'menoOdporucajucehoLekara'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar
     */
    'datumOdporucania': Date;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'icoHlavnaZlozka': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idHlavnaZlozkaValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idHlavnaZlozkaValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idHlavnaZlozka'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'kodNizsiaZlozkaPredpisujucehoLekara': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idNizsiaZlozkaPredpisujucehoLekaraValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idNizsiaZlozkaPredpisujucehoLekaraValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idNizsiaZlozkaPredpisujucehoLekara'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'kodPredpisujuciLekar': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idPredpisujuciLekarValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idPredpisujuciLekarValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'idPredpisujuciLekar'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar
     */
    'menoPredpisujucehoLekara'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam {
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idPreskripcnehoZaznamuValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idPreskripcnehoZaznamuValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idPreskripcnehoZaznamu'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'externyIdentifikatorRiadku': number;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'predpisujuciLekar': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPredpisujuciLekar;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumPrepusteniaZHospitalizacieValue': Date;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumPrepusteniaZHospitalizacieValueSpecified': boolean;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumPrepusteniaZHospitalizacie'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idObdobieDavkyValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idObdobieDavkyValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idObdobieDavky'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'rodneCisloVykazane': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'rodneCisloAkceptovane'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idPoistenecValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idPoistenecValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'idPoistenec'?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datum2Vykazany': Date;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'udajeProdukt': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'davkovanie': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDavkovanie;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'kodDiagnozaVykazana': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'kodDiagnozaAkcept'?: string | null;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'odporucajuciLekar': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIOdporucajuciLekar;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'zastupovanyLekar': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'statPoistenca': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'identifikacneCisloPoistenca'?: string | null;
    /**
     * 0 - M, 1 - Z, 2 - X, 3 - N
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'pohlaviePoistencaValue': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaValueEnum;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'pohlaviePoistencaValueSpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'pohlaviePoistenca'?: XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaEnum;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'neodkladnaZS': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'neplatic': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'evident'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumCasEvidencieValue': Date;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumCasEvidencieValueSpecified': boolean;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumCasEvidencie'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'modifikator'?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumPoslednejModifikacieValue': Date;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumPoslednejModifikacieValueSpecified': boolean;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'datumPoslednejModifikacie'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'ciarovyKod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'poznamkaZP'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'zakazVydaniaNahrady': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'zakazaneLieky'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'zakazaneLiekySpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'periodaOpakovanehoReceptuValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'periodaOpakovanehoReceptuValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'periodaOpakovanehoReceptu'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'pocetOpakovaniOpakovanehoReceptuValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'pocetOpakovaniOpakovanehoReceptuValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'pocetOpakovaniOpakovanehoReceptu'?: number | null;
    /**
     * Pevný dátum a čas konečnej platnosti lekárskeho predpisu alebo poukazu, vrátane opakovaného receptu. Po uplynutí tohto dátumu nebude možné realizovať výber zostávajúceho množstva. Recept sa neobjaví ako nevydaný v zozname liekov, ktoré sa zobrazia lekárni, ktoré má liek vydať. Maximálnu platnosť podľa predmetu preskripcie určuje legislatíva.
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'platnostReceptuValue': Date;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'platnostReceptuValueSpecified': boolean;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'platnostReceptu'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'vynutenyZapis': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'vynutenyZapisDovod'?: string | null;
    /**
     * 0 - NEZML, 1 - JASAM
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'dovodUhradyPacientaValue': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaValueEnum;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'dovodUhradyPacientaValueSpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'dovodUhradyPacienta'?: XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaEnum;
    /**
     * Príznak identifikujúci, či pre predpisovaný produkt má poistenec schválenú výnimku/návrh na ZS v zdravotnej poisťovni a pre daný produkt sa vyžaduje predchádzajúce schválenie zdravotnou poisťovňou. Príznak vyznačuje predpisujúci lekár.
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'produktNaVynimku': boolean;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'udajeVynimky': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'udajeIPL': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'zdovodnenie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'opisPomockyNaMieru'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'novorodenecNaRCRodica': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'poznamka'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'trvalePostihnutie': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'kodIndikacneObmedzenie'?: string | null;
    /**
     * 0 - L, 1 - P
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'aplikacnaZonaParovehoOrganuValue': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuValueEnum;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'aplikacnaZonaParovehoOrganuValueSpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'aplikacnaZonaParovehoOrganu'?: XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuEnum;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'mnozstvovyLimitPreDP'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'nadLimitneMnozstvoZP': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'cisloSchvalenejVynimky'?: string | null;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDychaciPristroj}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'dychaciPristroj': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIDychaciPristroj;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'zaloznyAtribut1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'zaloznyAtribut2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'zaloznyAtribut3'?: string | null;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'signature': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType;
    /**
     * 0 - JePodpisanyPlatny, 1 - JePodpisanyNeplatny, 2 - JePodpisanyNeovereny, 3 - NieJePodpisany
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'signatureValidationStatusValue': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusValueEnum;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'signatureValidationStatusValueSpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznam
     */
    'signatureValidationStatus'?: XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusEnum;
}

export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaValueEnum = {
    M: 'M',
    Z: 'Z',
    X: 'X',
    N: 'N'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaValueEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaValueEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaValueEnum];
export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaEnum = {
    M: 'M',
    Z: 'Z',
    X: 'X',
    N: 'N'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamPohlaviePoistencaEnum];
export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaValueEnum = {
    Nezml: 'NEZML',
    Jasam: 'JASAM'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaValueEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaValueEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaValueEnum];
export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaEnum = {
    Nezml: 'NEZML',
    Jasam: 'JASAM'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamDovodUhradyPacientaEnum];
export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuValueEnum = {
    L: 'L',
    P: 'P'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuValueEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuValueEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuValueEnum];
export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuEnum = {
    L: 'L',
    P: 'P'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamAplikacnaZonaParovehoOrganuEnum];
export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusValueEnum = {
    JePodpisanyPlatny: 'JePodpisanyPlatny',
    JePodpisanyNeplatny: 'JePodpisanyNeplatny',
    JePodpisanyNeovereny: 'JePodpisanyNeovereny',
    NieJePodpisany: 'NieJePodpisany'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusValueEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusValueEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusValueEnum];
export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusEnum = {
    JePodpisanyPlatny: 'JePodpisanyPlatny',
    JePodpisanyNeplatny: 'JePodpisanyNeplatny',
    JePodpisanyNeovereny: 'JePodpisanyNeovereny',
    NieJePodpisany: 'NieJePodpisany'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIPreskripcnyZaznamSignatureValidationStatusEnum];

/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISprava
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISprava {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISprava
     */
    'zavaznostText'?: string | null;
    /**
     * 0 - INFO, 1 - VAROVANIE, 2 - CHYBA, 3 - ODMIETNUTIE
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISprava
     */
    'zavaznost': XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISpravaZavaznostEnum;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISprava
     */
    'kod': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISprava
     */
    'text': string;
}

export const XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISpravaZavaznostEnum = {
    Info: 'INFO',
    Varovanie: 'VAROVANIE',
    Chyba: 'CHYBA',
    Odmietnutie: 'ODMIETNUTIE'
} as const;

export type XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISpravaZavaznostEnum = typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISpravaZavaznostEnum[keyof typeof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISpravaZavaznostEnum];

/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL
     */
    'zlozenieIPL': string;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL
     */
    'zlozkyIPL'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL
     */
    'zlozkyIPLSpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL
     */
    'pokynyPriVyrobeIPL': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeIPL
     */
    'pokynKUzivaniuIPL': string;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'kodProduktPZSVykaz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'kodProduktPZSAkcept'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'podskupinaPomockyVykaz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'nazovProduktVykaz'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'mernaJednotka'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'kodATCVykazany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'atcDoplnok'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'kodATCAkceptovany'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIUdajeProdukt
     */
    'mnozstvoVykazane': number;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka {
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'idVynimky': number;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'cisloVynimky': string;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'platnostOd': Date;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'platnostDoValue': Date;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'platnostDoValueSpecified': boolean;
    /**
     * 
     * @type {Date}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'platnostDo'?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'schvaleneMnozstvo': number;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'nevycerpaneMnozstvo': number;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIVynimka
     */
    'dohodnutaCena': number;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'kodZastupovanaNZ': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'idZastupovanaNZValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'idZastupovanaNZValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'idZastupovanaNZ'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'kodZastupovanyLekar': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'idZastupovanyLekarValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'idZastupovanyLekarValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'idZastupovanyLekar'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZastupovanyLekar
     */
    'menoZastupovanehoLekara'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'kod': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'nazov': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'mnozstvo': number;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'mernaJednotka': string;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'jednotkovaCenaBezDPHValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'jednotkovaCenaBezDPHValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'jednotkovaCenaBezDPH'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'jednotkovaCenaSDPHValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'jednotkovaCenaSDPHValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'jednotkovaCenaSDPH'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'uhradaZPValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'uhradaZPValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'uhradaZP'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'uhradaPacientaValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'uhradaPacientaValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPIZlozkaIPL
     */
    'uhradaPacienta'?: number | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup {
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup
     */
    'idPreskripcnehoZaznamuValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup
     */
    'idPreskripcnehoZaznamuValueSpecified': boolean;
    /**
     * 
     * @type {number}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup
     */
    'idPreskripcnehoZaznamu'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup
     */
    'ciarovyKod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup
     */
    'poznamkaZP'?: string | null;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISprava>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup
     */
    'spravy'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIEreceptTypesAPISprava> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIEreceptUlozPreskripcnyZaznamVystup
     */
    'spravySpecified': boolean;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigCanonicalizationMethodType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigCanonicalizationMethodType {
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigCanonicalizationMethodType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigCanonicalizationMethodType
     */
    'anySpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigCanonicalizationMethodType
     */
    'algorithm': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigCanonicalizationMethodType
     */
    'text'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType
     */
    'p'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType
     */
    'q'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType
     */
    'g'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType
     */
    'y': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType
     */
    'j'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType
     */
    'seed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType
     */
    'pgenCounter'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDigestMethodType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDigestMethodType {
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDigestMethodType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDigestMethodType
     */
    'anySpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDigestMethodType
     */
    'algorithm': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDigestMethodType
     */
    'text'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType {
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'keyName'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'keyNameSpecified': boolean;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyValueType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'keyValue'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyValueType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'keyValueSpecified': boolean;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRetrievalMethodType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'retrievalMethod'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRetrievalMethodType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'retrievalMethodSpecified': boolean;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'x509Data'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'x509DataSpecified': boolean;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'pgpData'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'pgpDataSpecified': boolean;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSPKIDataType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'spkiData'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSPKIDataType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'spkiDataSpecified': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'mgmtData'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'mgmtDataSpecified': boolean;
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'anySpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType
     */
    'text'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyValueType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyValueType {
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyValueType
     */
    'dsaKeyValue': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDSAKeyValueType;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRSAKeyValueType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyValueType
     */
    'rsaKeyValue': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRSAKeyValueType;
    /**
     * 
     * @type {Array<any>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyValueType
     */
    'any'?: Array<any> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyValueType
     */
    'text'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType {
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType
     */
    'anySpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType
     */
    'mimeType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType
     */
    'encoding'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType
     */
    'text'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType
     */
    'pgpKeyID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType
     */
    'pgpKeyPacket'?: string | null;
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType
     */
    'anySpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigPGPDataType
     */
    'pgpKeyPacket1'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRSAKeyValueType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRSAKeyValueType {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRSAKeyValueType
     */
    'modulus': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRSAKeyValueType
     */
    'exponent': string;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType {
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType
     */
    'transforms'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType
     */
    'transformsSpecified': boolean;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDigestMethodType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType
     */
    'digestMethod': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigDigestMethodType;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType
     */
    'digestValue': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType
     */
    'uri'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRetrievalMethodType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRetrievalMethodType {
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRetrievalMethodType
     */
    'transforms'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRetrievalMethodType
     */
    'transformsSpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRetrievalMethodType
     */
    'uri'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigRetrievalMethodType
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSPKIDataType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSPKIDataType {
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSPKIDataType
     */
    'spkiSexp': Array<string>;
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSPKIDataType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSPKIDataType
     */
    'anySpecified': boolean;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType
     */
    'hmacOutputLength'?: string | null;
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType
     */
    'anySpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType
     */
    'algorithm': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType
     */
    'text'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType {
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignedInfoType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType
     */
    'signedInfo': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignedInfoType;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureValueType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType
     */
    'signatureValue': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureValueType;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType
     */
    'keyInfo': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigKeyInfoType;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType
     */
    'object'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigObjectType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType
     */
    'objectSpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureType
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureValueType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureValueType {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureValueType
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureValueType
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignedInfoType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignedInfoType {
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigCanonicalizationMethodType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignedInfoType
     */
    'canonicalizationMethod': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigCanonicalizationMethodType;
    /**
     * 
     * @type {XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignedInfoType
     */
    'signatureMethod': XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignatureMethodType;
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignedInfoType
     */
    'reference': Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigReferenceType>;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigSignedInfoType
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType {
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType
     */
    'anySpecified': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType
     */
    'xPath'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType
     */
    'xPathSpecified': boolean;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType
     */
    'algorithm': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigTransformType
     */
    'text'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType {
    /**
     * 
     * @type {Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509IssuerSerialType>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509IssuerSerial'?: Array<XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509IssuerSerialType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509IssuerSerialSpecified': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509SKI'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509SKISpecified': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509SubjectName'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509SubjectNameSpecified': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509Certificate'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509CertificateSpecified': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509CRL'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'x509CRLSpecified': boolean;
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'any'?: Array<Array<any>> | null;
    /**
     * 
     * @type {boolean}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509DataType
     */
    'anySpecified': boolean;
}
/**
 * 
 * @export
 * @interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509IssuerSerialType
 */
export interface XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509IssuerSerialType {
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509IssuerSerialType
     */
    'x509IssuerName': string;
    /**
     * 
     * @type {string}
     * @memberof XDTEZdravieModelEReceptV6SchemaNCZIXmldsigX509IssuerSerialType
     */
    'x509SerialNumber': string;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLocalizationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/Localization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountLocalizationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountLocalizationGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AccountApi.apiAccountLocalizationGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLocalizationGet(options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSETCOMPANYFORMResult> {
            return localVarFp.apiAccountLocalizationGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountLocalizationGet(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountLocalizationGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates Device Request and returns pairing code
         * @param {APIXdentDTOSafeSignaturesCreateDeviceRequestDto} [aPIXdentDTOSafeSignaturesCreateDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesCreateDeviceRequestPost: async (aPIXdentDTOSafeSignaturesCreateDeviceRequestDto?: APIXdentDTOSafeSignaturesCreateDeviceRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/safesignatures/CreateDeviceRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesCreateDeviceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accepts vendor id and returns whether the tablet has valid new SS pair or not. The deviceId can be either supplied in request body or is drawn from headers.
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesDeviceHasNewSSPairPost: async (deviceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/safesignatures/DeviceHasNewSSPair`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accepts vendor id, checks the state of the device pair and beta tag and returns desired target for invocation.   The deviceId can be either supplied in request body or is drawn from headers.  Returns one of: WEB_IKLIENT, SAFE_SIGNATURES or SAFE_SIGNATURES_BETA
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesGetSSDeepLinkGet: async (deviceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/safesignatures/GetSSDeepLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesProcessMigrationCsvPost: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/safesignatures/ProcessMigrationCsv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unpairs device
         * @param {APIXdentDTOSafeSignaturesUnpairDeviceRequestDto} [aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesUnpairDeviceRequestPost: async (aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto?: APIXdentDTOSafeSignaturesUnpairDeviceRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/safesignatures/UnpairDeviceRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates Device Request and returns pairing code
         * @param {APIXdentDTOSafeSignaturesCreateDeviceRequestDto} [aPIXdentDTOSafeSignaturesCreateDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminSafesignaturesCreateDeviceRequestPost(aPIXdentDTOSafeSignaturesCreateDeviceRequestDto?: APIXdentDTOSafeSignaturesCreateDeviceRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminSafesignaturesCreateDeviceRequestPost(aPIXdentDTOSafeSignaturesCreateDeviceRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AdminApi.apiAdminSafesignaturesCreateDeviceRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Accepts vendor id and returns whether the tablet has valid new SS pair or not. The deviceId can be either supplied in request body or is drawn from headers.
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminSafesignaturesDeviceHasNewSSPairPost(deviceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminSafesignaturesDeviceHasNewSSPairPost(deviceId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AdminApi.apiAdminSafesignaturesDeviceHasNewSSPairPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Accepts vendor id, checks the state of the device pair and beta tag and returns desired target for invocation.   The deviceId can be either supplied in request body or is drawn from headers.  Returns one of: WEB_IKLIENT, SAFE_SIGNATURES or SAFE_SIGNATURES_BETA
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminSafesignaturesGetSSDeepLinkGet(deviceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminSafesignaturesGetSSDeepLinkGet(deviceId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AdminApi.apiAdminSafesignaturesGetSSDeepLinkGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminSafesignaturesProcessMigrationCsvPost(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminSafesignaturesProcessMigrationCsvPost(file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AdminApi.apiAdminSafesignaturesProcessMigrationCsvPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Unpairs device
         * @param {APIXdentDTOSafeSignaturesUnpairDeviceRequestDto} [aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminSafesignaturesUnpairDeviceRequestPost(aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto?: APIXdentDTOSafeSignaturesUnpairDeviceRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminSafesignaturesUnpairDeviceRequestPost(aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AdminApi.apiAdminSafesignaturesUnpairDeviceRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates Device Request and returns pairing code
         * @param {APIXdentDTOSafeSignaturesCreateDeviceRequestDto} [aPIXdentDTOSafeSignaturesCreateDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesCreateDeviceRequestPost(aPIXdentDTOSafeSignaturesCreateDeviceRequestDto?: APIXdentDTOSafeSignaturesCreateDeviceRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiAdminSafesignaturesCreateDeviceRequestPost(aPIXdentDTOSafeSignaturesCreateDeviceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accepts vendor id and returns whether the tablet has valid new SS pair or not. The deviceId can be either supplied in request body or is drawn from headers.
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesDeviceHasNewSSPairPost(deviceId?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiAdminSafesignaturesDeviceHasNewSSPairPost(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accepts vendor id, checks the state of the device pair and beta tag and returns desired target for invocation.   The deviceId can be either supplied in request body or is drawn from headers.  Returns one of: WEB_IKLIENT, SAFE_SIGNATURES or SAFE_SIGNATURES_BETA
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesGetSSDeepLinkGet(deviceId?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiAdminSafesignaturesGetSSDeepLinkGet(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesProcessMigrationCsvPost(file?: File, options?: any): AxiosPromise<void> {
            return localVarFp.apiAdminSafesignaturesProcessMigrationCsvPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unpairs device
         * @param {APIXdentDTOSafeSignaturesUnpairDeviceRequestDto} [aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminSafesignaturesUnpairDeviceRequestPost(aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto?: APIXdentDTOSafeSignaturesUnpairDeviceRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiAdminSafesignaturesUnpairDeviceRequestPost(aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @summary Creates Device Request and returns pairing code
     * @param {APIXdentDTOSafeSignaturesCreateDeviceRequestDto} [aPIXdentDTOSafeSignaturesCreateDeviceRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiAdminSafesignaturesCreateDeviceRequestPost(aPIXdentDTOSafeSignaturesCreateDeviceRequestDto?: APIXdentDTOSafeSignaturesCreateDeviceRequestDto, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminSafesignaturesCreateDeviceRequestPost(aPIXdentDTOSafeSignaturesCreateDeviceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accepts vendor id and returns whether the tablet has valid new SS pair or not. The deviceId can be either supplied in request body or is drawn from headers.
     * @param {string} [deviceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiAdminSafesignaturesDeviceHasNewSSPairPost(deviceId?: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminSafesignaturesDeviceHasNewSSPairPost(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accepts vendor id, checks the state of the device pair and beta tag and returns desired target for invocation.   The deviceId can be either supplied in request body or is drawn from headers.  Returns one of: WEB_IKLIENT, SAFE_SIGNATURES or SAFE_SIGNATURES_BETA
     * @param {string} [deviceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiAdminSafesignaturesGetSSDeepLinkGet(deviceId?: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminSafesignaturesGetSSDeepLinkGet(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiAdminSafesignaturesProcessMigrationCsvPost(file?: File, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminSafesignaturesProcessMigrationCsvPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unpairs device
     * @param {APIXdentDTOSafeSignaturesUnpairDeviceRequestDto} [aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiAdminSafesignaturesUnpairDeviceRequestPost(aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto?: APIXdentDTOSafeSignaturesUnpairDeviceRequestDto, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminSafesignaturesUnpairDeviceRequestPost(aPIXdentDTOSafeSignaturesUnpairDeviceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetAgeClientsGet: async (freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Analytic/GetAgeClients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (freshDataDays !== undefined) {
                localVarQueryParameter['freshDataDays'] = freshDataDays;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetAppointmentsGet: async (freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Analytic/GetAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (freshDataDays !== undefined) {
                localVarQueryParameter['freshDataDays'] = freshDataDays;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetDurationsGet: async (freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Analytic/GetDurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (freshDataDays !== undefined) {
                localVarQueryParameter['freshDataDays'] = freshDataDays;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetNewClientsGet: async (freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Analytic/GetNewClients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (freshDataDays !== undefined) {
                localVarQueryParameter['freshDataDays'] = freshDataDays;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetPaymentsGet: async (freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Analytic/GetPayments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (freshDataDays !== undefined) {
                localVarQueryParameter['freshDataDays'] = freshDataDays;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticGetAgeClientsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSAGECLIENTS>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticGetAgeClientsGet(freshDataDays, dateFrom, dateTo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnalyticsApi.apiAnalyticGetAgeClientsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticGetAppointmentsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticGetAppointmentsGet(freshDataDays, dateFrom, dateTo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnalyticsApi.apiAnalyticGetAppointmentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticGetDurationsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSDURATIONS>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticGetDurationsGet(freshDataDays, dateFrom, dateTo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnalyticsApi.apiAnalyticGetDurationsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticGetNewClientsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSNEWCLIENTS>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticGetNewClientsGet(freshDataDays, dateFrom, dateTo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnalyticsApi.apiAnalyticGetNewClientsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticGetPaymentsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSPAYMENTS>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticGetPaymentsGet(freshDataDays, dateFrom, dateTo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnalyticsApi.apiAnalyticGetPaymentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetAgeClientsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: any): AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSAGECLIENTS>> {
            return localVarFp.apiAnalyticGetAgeClientsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetAppointmentsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: any): AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSAPPOINTMENTS>> {
            return localVarFp.apiAnalyticGetAppointmentsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetDurationsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: any): AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSDURATIONS>> {
            return localVarFp.apiAnalyticGetDurationsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetNewClientsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: any): AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSNEWCLIENTS>> {
            return localVarFp.apiAnalyticGetNewClientsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [freshDataDays] 
         * @param {Date} [dateFrom] 
         * @param {Date} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticGetPaymentsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: any): AxiosPromise<Array<APIXdentDTOAnalyticsANALYTICSPAYMENTS>> {
            return localVarFp.apiAnalyticGetPaymentsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {number} [freshDataDays] 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public apiAnalyticGetAgeClientsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).apiAnalyticGetAgeClientsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {number} [freshDataDays] 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public apiAnalyticGetAppointmentsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).apiAnalyticGetAppointmentsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {number} [freshDataDays] 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public apiAnalyticGetDurationsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).apiAnalyticGetDurationsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {number} [freshDataDays] 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public apiAnalyticGetNewClientsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).apiAnalyticGetNewClientsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {number} [freshDataDays] 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public apiAnalyticGetPaymentsGet(freshDataDays?: number, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).apiAnalyticGetPaymentsGet(freshDataDays, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnamnesisApi - axios parameter creator
 * @export
 */
export const AnamnesisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnamnesisGetAnamnesisGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Anamnesis/GetAnamnesis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnamnesisGetFormAnamnesisGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Anamnesis/GetFormAnamnesis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnamnesisGetFormAnamnesisHistoryGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Anamnesis/GetFormAnamnesisHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnamnesisApi - functional programming interface
 * @export
 */
export const AnamnesisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnamnesisApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnamnesisGetAnamnesisGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnamnesisGetAnamnesisGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnamnesisApi.apiAnamnesisGetAnamnesisGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnamnesisGetFormAnamnesisGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnamnesisGetFormAnamnesisGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnamnesisApi.apiAnamnesisGetFormAnamnesisGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnamnesisGetFormAnamnesisHistoryGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnamnesisGetFormAnamnesisHistoryGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnamnesisApi.apiAnamnesisGetFormAnamnesisHistoryGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AnamnesisApi - factory interface
 * @export
 */
export const AnamnesisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnamnesisApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnamnesisGetAnamnesisGet(idClient?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult> {
            return localVarFp.apiAnamnesisGetAnamnesisGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnamnesisGetFormAnamnesisGet(idClient?: string, options?: any): AxiosPromise<APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisDto> {
            return localVarFp.apiAnamnesisGetFormAnamnesisGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnamnesisGetFormAnamnesisHistoryGet(idClient?: string, options?: any): AxiosPromise<APIXdentServicesXdentScopedAnamnesisServiceClientFormAnamnesisHistoryDto> {
            return localVarFp.apiAnamnesisGetFormAnamnesisHistoryGet(idClient, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnamnesisApi - object-oriented interface
 * @export
 * @class AnamnesisApi
 * @extends {BaseAPI}
 */
export class AnamnesisApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnamnesisApi
     */
    public apiAnamnesisGetAnamnesisGet(idClient?: string, options?: AxiosRequestConfig) {
        return AnamnesisApiFp(this.configuration).apiAnamnesisGetAnamnesisGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnamnesisApi
     */
    public apiAnamnesisGetFormAnamnesisGet(idClient?: string, options?: AxiosRequestConfig) {
        return AnamnesisApiFp(this.configuration).apiAnamnesisGetFormAnamnesisGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnamnesisApi
     */
    public apiAnamnesisGetFormAnamnesisHistoryGet(idClient?: string, options?: AxiosRequestConfig) {
        return AnamnesisApiFp(this.configuration).apiAnamnesisGetFormAnamnesisHistoryGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppointmentApi - axios parameter creator
 * @export
 */
export const AppointmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentAddAppointmentNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/AddAppointmentNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds appointment by model for owner user.
         * @param {ApiAppointmentAddAppointmentPostRequest} [apiAppointmentAddAppointmentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentAddAppointmentPost: async (apiAppointmentAddAppointmentPostRequest?: ApiAppointmentAddAppointmentPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/AddAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppointmentAddAppointmentPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedAddAppointmenDto} [aPISharedAddAppointmenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentAddAppointmentX2Post: async (aPISharedAddAppointmenDto?: APISharedAddAppointmenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/AddAppointmentX2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedAddAppointmenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto} [aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentAddOpenHoursImportNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto?: APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/AddOpenHoursImportNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set appointment confirmation status from onlineBooking
         * @param {string} [idAppointment] 
         * @param {boolean} [isConfirm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentConfirmAppointmentGet: async (idAppointment?: string, isConfirm?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/ConfirmAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idAppointment !== undefined) {
                localVarQueryParameter['idAppointment'] = idAppointment;
            }

            if (isConfirm !== undefined) {
                localVarQueryParameter['isConfirm'] = isConfirm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {APISharedDeleteAppointment} [aPISharedDeleteAppointment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentDeleteAppointmentByIdDelete: async (aPISharedDeleteAppointment?: APISharedDeleteAppointment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/DeleteAppointmentById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedDeleteAppointment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentDeleteAppointmentNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/DeleteAppointmentNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDeleteAppointmentDto} [aPISharedDeleteAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentDeleteAppointmentX2Post: async (aPISharedDeleteAppointmentDto?: APISharedDeleteAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/DeleteAppointmentX2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedDeleteAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentEditAppointmentNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/EditAppointmentNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits appointment by id for owner user.
         * @param {APISharedEditAppointmentDto} [aPISharedEditAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentEditAppointmentPut: async (aPISharedEditAppointmentDto?: APISharedEditAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/EditAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedEditAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedEditAppointmentValuesDto} [aPISharedEditAppointmentValuesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentEditAppointmentX2Post: async (aPISharedEditAppointmentValuesDto?: APISharedEditAppointmentValuesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/EditAppointmentX2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedEditAppointmentValuesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits appointment status by status id for owner user.
         * @param {string} [idAppointment] 
         * @param {string} [idStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentEditStatusPut: async (idAppointment?: string, idStatus?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/EditStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idAppointment !== undefined) {
                localVarQueryParameter['idAppointment'] = idAppointment;
            }

            if (idStatus !== undefined) {
                localVarQueryParameter['idStatus'] = idStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {string} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentByIdGet: async (appointmentId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetAppointmentById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO} [aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentsAndOpenHoursDurationNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO?: APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetAppointmentsAndOpenHoursDurationNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all appointments for user per all valid clients
         * @param {number} [startDate] Difference between dates should not be bigger than 52 days
         * @param {number} [endDate] Else start date + 52 days will be used
         * @param {Array<string>} [idStaff] Filter by staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentsGet: async (startDate?: number, endDate?: number, idStaff?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (idStaff) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentsNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetAppointmentsNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Date} [startDate] 
         * @param {Date} [endDate] 
         * @param {Array<string>} [idStaff] 
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentsX2Get: async (startDate?: Date, endDate?: Date, idStaff?: Array<string>, controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetAppointmentsX2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (idStaff) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (controller !== undefined) {
                localVarQueryParameter['controller'] = controller;
            }

            if (cacheContext !== undefined) {
                localVarQueryParameter['cacheContext'] = cacheContext;
            }

            if (invoker !== undefined) {
                localVarQueryParameter['invoker'] = invoker;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }

            if (idGlobal !== undefined) {
                localVarQueryParameter['idGlobal'] = idGlobal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetClientsByUserNCGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetClientsByUserNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetClientsByUserX2Get: async (controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetClientsByUserX2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (controller !== undefined) {
                localVarQueryParameter['controller'] = controller;
            }

            if (cacheContext !== undefined) {
                localVarQueryParameter['cacheContext'] = cacheContext;
            }

            if (invoker !== undefined) {
                localVarQueryParameter['invoker'] = invoker;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }

            if (idGlobal !== undefined) {
                localVarQueryParameter['idGlobal'] = idGlobal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetOpenHourNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetOpenHourNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Date} [startDate] 
         * @param {Date} [endDate] 
         * @param {Array<string>} [idStaff] 
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetOpenHourX2Get: async (startDate?: Date, endDate?: Date, idStaff?: Array<string>, controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetOpenHourX2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (idStaff) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (controller !== undefined) {
                localVarQueryParameter['controller'] = controller;
            }

            if (cacheContext !== undefined) {
                localVarQueryParameter['cacheContext'] = cacheContext;
            }

            if (invoker !== undefined) {
                localVarQueryParameter['invoker'] = invoker;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }

            if (idGlobal !== undefined) {
                localVarQueryParameter['idGlobal'] = idGlobal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets open hours for provided staff
         * @param {number} [startDate] Difference between dates should not be bigger than 52 days
         * @param {number} [endDate] Else start date + 52 days will be used
         * @param {string} [idStaff] Desired staff opening hours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetOpenHoursGet: async (startDate?: number, endDate?: number, idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetOpenHours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetOpenHoursWithOccurencesNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetOpenHoursWithOccurencesNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetServicesByUserNCGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetServicesByUserNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetServicesByUserX2Get: async (controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetServicesByUserX2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (controller !== undefined) {
                localVarQueryParameter['controller'] = controller;
            }

            if (cacheContext !== undefined) {
                localVarQueryParameter['cacheContext'] = cacheContext;
            }

            if (invoker !== undefined) {
                localVarQueryParameter['invoker'] = invoker;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }

            if (idGlobal !== undefined) {
                localVarQueryParameter['idGlobal'] = idGlobal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetStaffByUserNCGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetStaffByUserNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetStaffByUserX2Get: async (controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetStaffByUserX2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (controller !== undefined) {
                localVarQueryParameter['controller'] = controller;
            }

            if (cacheContext !== undefined) {
                localVarQueryParameter['cacheContext'] = cacheContext;
            }

            if (invoker !== undefined) {
                localVarQueryParameter['invoker'] = invoker;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }

            if (idGlobal !== undefined) {
                localVarQueryParameter['idGlobal'] = idGlobal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetUserSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GetUserSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGlobalSearchFreeTermsNCPost: async (aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Appointment/GlobalSearchFreeTermsNC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppointmentApi - functional programming interface
 * @export
 */
export const AppointmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppointmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentAddAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentAddAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentAddAppointmentNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adds appointment by model for owner user.
         * @param {ApiAppointmentAddAppointmentPostRequest} [apiAppointmentAddAppointmentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentAddAppointmentPost(apiAppointmentAddAppointmentPostRequest?: ApiAppointmentAddAppointmentPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentAddAppointmentPost(apiAppointmentAddAppointmentPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentAddAppointmentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedAddAppointmenDto} [aPISharedAddAppointmenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentAddAppointmentX2Post(aPISharedAddAppointmenDto?: APISharedAddAppointmenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedAddAppointmenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentAddAppointmentX2Post(aPISharedAddAppointmenDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentAddAppointmentX2Post']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto} [aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentAddOpenHoursImportNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto?: APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentAddOpenHoursImportNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentAddOpenHoursImportNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Set appointment confirmation status from onlineBooking
         * @param {string} [idAppointment] 
         * @param {boolean} [isConfirm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentConfirmAppointmentGet(idAppointment?: string, isConfirm?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentConfirmAppointmentGet(idAppointment, isConfirm, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentConfirmAppointmentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {APISharedDeleteAppointment} [aPISharedDeleteAppointment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentDeleteAppointmentByIdDelete(aPISharedDeleteAppointment?: APISharedDeleteAppointment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentDeleteAppointmentByIdDelete(aPISharedDeleteAppointment, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentDeleteAppointmentByIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentDeleteAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentDeleteAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentDeleteAppointmentNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDeleteAppointmentDto} [aPISharedDeleteAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentDeleteAppointmentX2Post(aPISharedDeleteAppointmentDto?: APISharedDeleteAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDeleteAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentDeleteAppointmentX2Post(aPISharedDeleteAppointmentDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentDeleteAppointmentX2Post']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentEditAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentEditAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentEditAppointmentNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edits appointment by id for owner user.
         * @param {APISharedEditAppointmentDto} [aPISharedEditAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentEditAppointmentPut(aPISharedEditAppointmentDto?: APISharedEditAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentEditAppointmentPut(aPISharedEditAppointmentDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentEditAppointmentPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedEditAppointmentValuesDto} [aPISharedEditAppointmentValuesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentEditAppointmentX2Post(aPISharedEditAppointmentValuesDto?: APISharedEditAppointmentValuesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedEditAppointmentValuesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentEditAppointmentX2Post(aPISharedEditAppointmentValuesDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentEditAppointmentX2Post']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edits appointment status by status id for owner user.
         * @param {string} [idAppointment] 
         * @param {string} [idStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentEditStatusPut(idAppointment?: string, idStatus?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentEditStatusPut(idAppointment, idStatus, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentEditStatusPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {string} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetAppointmentByIdGet(appointmentId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetAppointmentByIdGet(appointmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetAppointmentByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO} [aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetAppointmentsAndOpenHoursDurationNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO?: APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedAppointmentsAndOpenHoursDurationWrapperX2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetAppointmentsAndOpenHoursDurationNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetAppointmentsAndOpenHoursDurationNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all appointments for user per all valid clients
         * @param {number} [startDate] Difference between dates should not be bigger than 52 days
         * @param {number} [endDate] Else start date + 52 days will be used
         * @param {Array<string>} [idStaff] Filter by staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetAppointmentsGet(startDate?: number, endDate?: number, idStaff?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedAppointmentWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetAppointmentsGet(startDate, endDate, idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetAppointmentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetAppointmentsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentServicesXdentScopedAppointmentServiceX2CalendarAppointmentNCDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetAppointmentsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetAppointmentsNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Date} [startDate] 
         * @param {Date} [endDate] 
         * @param {Array<string>} [idStaff] 
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetAppointmentsX2Get(startDate?: Date, endDate?: Date, idStaff?: Array<string>, controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedCalendarAppointmentCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetAppointmentsX2Get(startDate, endDate, idStaff, controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetAppointmentsX2Get']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetClientsByUserNCGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2CalendarClientsNCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetClientsByUserNCGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetClientsByUserNCGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetClientsByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedCalendarClientsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetClientsByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetClientsByUserX2Get']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetOpenHourNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentServicesXdentScopedAppointmentServiceX2CalendarOpenHoursNCDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetOpenHourNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetOpenHourNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Date} [startDate] 
         * @param {Date} [endDate] 
         * @param {Array<string>} [idStaff] 
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetOpenHourX2Get(startDate?: Date, endDate?: Date, idStaff?: Array<string>, controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedCalendarOpenHoursDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetOpenHourX2Get(startDate, endDate, idStaff, controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetOpenHourX2Get']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets open hours for provided staff
         * @param {number} [startDate] Difference between dates should not be bigger than 52 days
         * @param {number} [endDate] Else start date + 52 days will be used
         * @param {string} [idStaff] Desired staff opening hours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetOpenHoursGet(startDate?: number, endDate?: number, idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedAppointmentWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetOpenHoursGet(startDate, endDate, idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetOpenHoursGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetOpenHoursWithOccurencesNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursWithOccurrences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetOpenHoursWithOccurencesNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetOpenHoursWithOccurencesNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetServicesByUserNCGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2CalendarServicesNCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetServicesByUserNCGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetServicesByUserNCGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetServicesByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedCalendarServicesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetServicesByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetServicesByUserX2Get']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetStaffByUserNCGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2CalendarStaffsNCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetStaffByUserNCGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetStaffByUserNCGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetStaffByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedCalendarStaffsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetStaffByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetStaffByUserX2Get']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGetUserSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedUserSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGetUserSettingsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGetUserSettingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppointmentGlobalSearchFreeTermsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppointmentGlobalSearchFreeTermsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AppointmentApi.apiAppointmentGlobalSearchFreeTermsNCPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AppointmentApi - factory interface
 * @export
 */
export const AppointmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppointmentApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentAddAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto, options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto> {
            return localVarFp.apiAppointmentAddAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds appointment by model for owner user.
         * @param {ApiAppointmentAddAppointmentPostRequest} [apiAppointmentAddAppointmentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentAddAppointmentPost(apiAppointmentAddAppointmentPostRequest?: ApiAppointmentAddAppointmentPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppointmentAddAppointmentPost(apiAppointmentAddAppointmentPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedAddAppointmenDto} [aPISharedAddAppointmenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentAddAppointmentX2Post(aPISharedAddAppointmenDto?: APISharedAddAppointmenDto, options?: any): AxiosPromise<APISharedAddAppointmenDto> {
            return localVarFp.apiAppointmentAddAppointmentX2Post(aPISharedAddAppointmenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto} [aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentAddOpenHoursImportNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto?: APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto, options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertResultDto> {
            return localVarFp.apiAppointmentAddOpenHoursImportNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set appointment confirmation status from onlineBooking
         * @param {string} [idAppointment] 
         * @param {boolean} [isConfirm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentConfirmAppointmentGet(idAppointment?: string, isConfirm?: boolean, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiAppointmentConfirmAppointmentGet(idAppointment, isConfirm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {APISharedDeleteAppointment} [aPISharedDeleteAppointment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentDeleteAppointmentByIdDelete(aPISharedDeleteAppointment?: APISharedDeleteAppointment, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppointmentDeleteAppointmentByIdDelete(aPISharedDeleteAppointment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentDeleteAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto, options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto> {
            return localVarFp.apiAppointmentDeleteAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDeleteAppointmentDto} [aPISharedDeleteAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentDeleteAppointmentX2Post(aPISharedDeleteAppointmentDto?: APISharedDeleteAppointmentDto, options?: any): AxiosPromise<APISharedDeleteAppointmentDto> {
            return localVarFp.apiAppointmentDeleteAppointmentX2Post(aPISharedDeleteAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentEditAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto, options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto> {
            return localVarFp.apiAppointmentEditAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edits appointment by id for owner user.
         * @param {APISharedEditAppointmentDto} [aPISharedEditAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentEditAppointmentPut(aPISharedEditAppointmentDto?: APISharedEditAppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppointmentEditAppointmentPut(aPISharedEditAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedEditAppointmentValuesDto} [aPISharedEditAppointmentValuesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentEditAppointmentX2Post(aPISharedEditAppointmentValuesDto?: APISharedEditAppointmentValuesDto, options?: any): AxiosPromise<APISharedEditAppointmentValuesDto> {
            return localVarFp.apiAppointmentEditAppointmentX2Post(aPISharedEditAppointmentValuesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edits appointment status by status id for owner user.
         * @param {string} [idAppointment] 
         * @param {string} [idStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentEditStatusPut(idAppointment?: string, idStatus?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppointmentEditStatusPut(idAppointment, idStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {string} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentByIdGet(appointmentId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppointmentGetAppointmentByIdGet(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO} [aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentsAndOpenHoursDurationNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO?: APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO, options?: any): AxiosPromise<APISharedAppointmentsAndOpenHoursDurationWrapperX2Dto> {
            return localVarFp.apiAppointmentGetAppointmentsAndOpenHoursDurationNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all appointments for user per all valid clients
         * @param {number} [startDate] Difference between dates should not be bigger than 52 days
         * @param {number} [endDate] Else start date + 52 days will be used
         * @param {Array<string>} [idStaff] Filter by staff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentsGet(startDate?: number, endDate?: number, idStaff?: Array<string>, options?: any): AxiosPromise<APISharedAppointmentWrapperDto> {
            return localVarFp.apiAppointmentGetAppointmentsGet(startDate, endDate, idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: any): AxiosPromise<Array<APIXdentServicesXdentScopedAppointmentServiceX2CalendarAppointmentNCDto>> {
            return localVarFp.apiAppointmentGetAppointmentsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Date} [startDate] 
         * @param {Date} [endDate] 
         * @param {Array<string>} [idStaff] 
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetAppointmentsX2Get(startDate?: Date, endDate?: Date, idStaff?: Array<string>, controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: any): AxiosPromise<APISharedCalendarAppointmentCDto> {
            return localVarFp.apiAppointmentGetAppointmentsX2Get(startDate, endDate, idStaff, controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetClientsByUserNCGet(options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2CalendarClientsNCDto> {
            return localVarFp.apiAppointmentGetClientsByUserNCGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetClientsByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: any): AxiosPromise<APISharedCalendarClientsDto> {
            return localVarFp.apiAppointmentGetClientsByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetOpenHourNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: any): AxiosPromise<Array<APIXdentServicesXdentScopedAppointmentServiceX2CalendarOpenHoursNCDto>> {
            return localVarFp.apiAppointmentGetOpenHourNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Date} [startDate] 
         * @param {Date} [endDate] 
         * @param {Array<string>} [idStaff] 
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetOpenHourX2Get(startDate?: Date, endDate?: Date, idStaff?: Array<string>, controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: any): AxiosPromise<Array<APISharedCalendarOpenHoursDto>> {
            return localVarFp.apiAppointmentGetOpenHourX2Get(startDate, endDate, idStaff, controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets open hours for provided staff
         * @param {number} [startDate] Difference between dates should not be bigger than 52 days
         * @param {number} [endDate] Else start date + 52 days will be used
         * @param {string} [idStaff] Desired staff opening hours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetOpenHoursGet(startDate?: number, endDate?: number, idStaff?: string, options?: any): AxiosPromise<APISharedAppointmentWrapperDto> {
            return localVarFp.apiAppointmentGetOpenHoursGet(startDate, endDate, idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetOpenHoursWithOccurencesNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursWithOccurrences> {
            return localVarFp.apiAppointmentGetOpenHoursWithOccurencesNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetServicesByUserNCGet(options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2CalendarServicesNCDto> {
            return localVarFp.apiAppointmentGetServicesByUserNCGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetServicesByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: any): AxiosPromise<APISharedCalendarServicesDto> {
            return localVarFp.apiAppointmentGetServicesByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetStaffByUserNCGet(options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2CalendarStaffsNCDto> {
            return localVarFp.apiAppointmentGetStaffByUserNCGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetStaffByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: any): AxiosPromise<APISharedCalendarStaffsDto> {
            return localVarFp.apiAppointmentGetStaffByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGetUserSettingsGet(options?: any): AxiosPromise<APISharedUserSettingsDto> {
            return localVarFp.apiAppointmentGetUserSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppointmentGlobalSearchFreeTermsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto, options?: any): AxiosPromise<APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachResultNC> {
            return localVarFp.apiAppointmentGlobalSearchFreeTermsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppointmentApi - object-oriented interface
 * @export
 * @class AppointmentApi
 * @extends {BaseAPI}
 */
export class AppointmentApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentAddAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentAddAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2AddAppointmenNCDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds appointment by model for owner user.
     * @param {ApiAppointmentAddAppointmentPostRequest} [apiAppointmentAddAppointmentPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentAddAppointmentPost(apiAppointmentAddAppointmentPostRequest?: ApiAppointmentAddAppointmentPostRequest, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentAddAppointmentPost(apiAppointmentAddAppointmentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APISharedAddAppointmenDto} [aPISharedAddAppointmenDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentAddAppointmentX2Post(aPISharedAddAppointmenDto?: APISharedAddAppointmenDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentAddAppointmentX2Post(aPISharedAddAppointmenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto} [aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentAddOpenHoursImportNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto?: APIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentAddOpenHoursImportNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2OpenHoursBulkInsertDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set appointment confirmation status from onlineBooking
     * @param {string} [idAppointment] 
     * @param {boolean} [isConfirm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentConfirmAppointmentGet(idAppointment?: string, isConfirm?: boolean, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentConfirmAppointmentGet(idAppointment, isConfirm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets appointment by id for owner user.
     * @param {APISharedDeleteAppointment} [aPISharedDeleteAppointment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentDeleteAppointmentByIdDelete(aPISharedDeleteAppointment?: APISharedDeleteAppointment, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentDeleteAppointmentByIdDelete(aPISharedDeleteAppointment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentDeleteAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentDeleteAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2DeleteAppointmentNCDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APISharedDeleteAppointmentDto} [aPISharedDeleteAppointmentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentDeleteAppointmentX2Post(aPISharedDeleteAppointmentDto?: APISharedDeleteAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentDeleteAppointmentX2Post(aPISharedDeleteAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentEditAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentEditAppointmentNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2EditAppointmentValuesNCDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edits appointment by id for owner user.
     * @param {APISharedEditAppointmentDto} [aPISharedEditAppointmentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentEditAppointmentPut(aPISharedEditAppointmentDto?: APISharedEditAppointmentDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentEditAppointmentPut(aPISharedEditAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APISharedEditAppointmentValuesDto} [aPISharedEditAppointmentValuesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentEditAppointmentX2Post(aPISharedEditAppointmentValuesDto?: APISharedEditAppointmentValuesDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentEditAppointmentX2Post(aPISharedEditAppointmentValuesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edits appointment status by status id for owner user.
     * @param {string} [idAppointment] 
     * @param {string} [idStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentEditStatusPut(idAppointment?: string, idStatus?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentEditStatusPut(idAppointment, idStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets appointment by id for owner user.
     * @param {string} [appointmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetAppointmentByIdGet(appointmentId?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetAppointmentByIdGet(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO} [aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetAppointmentsAndOpenHoursDurationNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO?: APIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetAppointmentsAndOpenHoursDurationNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GetAppointmentsAndOpenHoursDurationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all appointments for user per all valid clients
     * @param {number} [startDate] Difference between dates should not be bigger than 52 days
     * @param {number} [endDate] Else start date + 52 days will be used
     * @param {Array<string>} [idStaff] Filter by staff
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetAppointmentsGet(startDate?: number, endDate?: number, idStaff?: Array<string>, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetAppointmentsGet(startDate, endDate, idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetAppointmentsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetAppointmentsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {Array<string>} [idStaff] 
     * @param {string} [controller] 
     * @param {string} [cacheContext] 
     * @param {string} [invoker] 
     * @param {string} [key] 
     * @param {string} [transactionId] 
     * @param {number} [expiration] 
     * @param {string} [idGlobal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetAppointmentsX2Get(startDate?: Date, endDate?: Date, idStaff?: Array<string>, controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetAppointmentsX2Get(startDate, endDate, idStaff, controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetClientsByUserNCGet(options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetClientsByUserNCGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [controller] 
     * @param {string} [cacheContext] 
     * @param {string} [invoker] 
     * @param {string} [key] 
     * @param {string} [transactionId] 
     * @param {number} [expiration] 
     * @param {string} [idGlobal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetClientsByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetClientsByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetOpenHourNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetOpenHourNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {Array<string>} [idStaff] 
     * @param {string} [controller] 
     * @param {string} [cacheContext] 
     * @param {string} [invoker] 
     * @param {string} [key] 
     * @param {string} [transactionId] 
     * @param {number} [expiration] 
     * @param {string} [idGlobal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetOpenHourX2Get(startDate?: Date, endDate?: Date, idStaff?: Array<string>, controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetOpenHourX2Get(startDate, endDate, idStaff, controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets open hours for provided staff
     * @param {number} [startDate] Difference between dates should not be bigger than 52 days
     * @param {number} [endDate] Else start date + 52 days will be used
     * @param {string} [idStaff] Desired staff opening hours.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetOpenHoursGet(startDate?: number, endDate?: number, idStaff?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetOpenHoursGet(startDate, endDate, idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC} [aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetOpenHoursWithOccurencesNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC?: APIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetOpenHoursWithOccurencesNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2CalendarFetchNC, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetServicesByUserNCGet(options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetServicesByUserNCGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [controller] 
     * @param {string} [cacheContext] 
     * @param {string} [invoker] 
     * @param {string} [key] 
     * @param {string} [transactionId] 
     * @param {number} [expiration] 
     * @param {string} [idGlobal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetServicesByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetServicesByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetStaffByUserNCGet(options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetStaffByUserNCGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [controller] 
     * @param {string} [cacheContext] 
     * @param {string} [invoker] 
     * @param {string} [key] 
     * @param {string} [transactionId] 
     * @param {number} [expiration] 
     * @param {string} [idGlobal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetStaffByUserX2Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetStaffByUserX2Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGetUserSettingsGet(options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGetUserSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto} [aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    public apiAppointmentGlobalSearchFreeTermsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto?: APIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto, options?: AxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).apiAppointmentGlobalSearchFreeTermsNCPost(aPIXdentServicesXdentScopedAppointmentServiceX2GlobalSeachNCDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AresApi - axios parameter creator
 * @export
 */
export const AresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [ico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAresGetSubjectGet: async (ico?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Ares/GetSubject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ico !== undefined) {
                localVarQueryParameter['ico'] = ico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [ico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAresSearchGet: async (ico?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Ares/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ico !== undefined) {
                localVarQueryParameter['ico'] = ico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AresApi - functional programming interface
 * @export
 */
export const AresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [ico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAresGetSubjectGet(ico?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLibsEkonomickySubjekt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAresGetSubjectGet(ico, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AresApi.apiAresGetSubjectGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [ico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAresSearchGet(ico?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOAresAresSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAresSearchGet(ico, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AresApi.apiAresSearchGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AresApi - factory interface
 * @export
 */
export const AresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AresApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [ico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAresGetSubjectGet(ico?: string, options?: any): AxiosPromise<APISharedLibsEkonomickySubjekt> {
            return localVarFp.apiAresGetSubjectGet(ico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [ico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAresSearchGet(ico?: string, options?: any): AxiosPromise<APIXdentDTOAresAresSearchResult> {
            return localVarFp.apiAresSearchGet(ico, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AresApi - object-oriented interface
 * @export
 * @class AresApi
 * @extends {BaseAPI}
 */
export class AresApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [ico] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AresApi
     */
    public apiAresGetSubjectGet(ico?: string, options?: AxiosRequestConfig) {
        return AresApiFp(this.configuration).apiAresGetSubjectGet(ico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [ico] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AresApi
     */
    public apiAresSearchGet(ico?: string, options?: AxiosRequestConfig) {
        return AresApiFp(this.configuration).apiAresSearchGet(ico, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditApi - axios parameter creator
 * @export
 */
export const AuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Debug method for getting last N audits. Will be removed, just for the sake of testing (for FE devs)
         * @param {number} [takeLast] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditGet: async (takeLast?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (takeLast !== undefined) {
                localVarQueryParameter['takeLast'] = takeLast;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditPost: async (body?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditApi - functional programming interface
 * @export
 */
export const AuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Debug method for getting last N audits. Will be removed, just for the sake of testing (for FE devs)
         * @param {number} [takeLast] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditGet(takeLast?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditGet(takeLast, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuditApi.apiAuditGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditPost(body?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditPost(body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuditApi.apiAuditPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AuditApi - factory interface
 * @export
 */
export const AuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditApiFp(configuration)
    return {
        /**
         * 
         * @summary Debug method for getting last N audits. Will be removed, just for the sake of testing (for FE devs)
         * @param {number} [takeLast] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditGet(takeLast?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAuditGet(takeLast, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditPost(body?: any, options?: any): AxiosPromise<void> {
            return localVarFp.apiAuditPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditApi - object-oriented interface
 * @export
 * @class AuditApi
 * @extends {BaseAPI}
 */
export class AuditApi extends BaseAPI {
    /**
     * 
     * @summary Debug method for getting last N audits. Will be removed, just for the sake of testing (for FE devs)
     * @param {number} [takeLast] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApi
     */
    public apiAuditGet(takeLast?: number, options?: AxiosRequestConfig) {
        return AuditApiFp(this.configuration).apiAuditGet(takeLast, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {any} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApi
     */
    public apiAuditPost(body?: any, options?: AxiosRequestConfig) {
        return AuditApiFp(this.configuration).apiAuditPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if provided credentials are valid. Whatever scheme is used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthIsAuthValidGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/IsAuthValid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalPay4uAuthLoginPost: async (apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/external/pay4u/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiSafesignaturesAuthPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalPay4uAuthRefreshPost: async (aPISharedExtendBearerDto?: APISharedExtendBearerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/external/pay4u/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedExtendBearerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login endpoint for safe signatures app. Checks if tablet is paired and logins ss account. (For limitted time also migrates old pairing to new pairing)
         * @param {string} deviceToken 
         * @param {boolean} [beta] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthAuthByVendorIdPost: async (deviceToken: string, beta?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesAuthAuthByVendorIdPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/auth/AuthByVendorId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (beta !== undefined) {
                localVarQueryParameter['beta'] = beta;
            }

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {string} deviceToken 
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthExtendPost: async (deviceToken: string, aPISharedExtendBearerDto?: APISharedExtendBearerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesAuthExtendPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/auth/Extend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedExtendBearerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accepts pairing code and creates a pair
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesPairDeviceRequestDto} [aPIXdentDTOSafeSignaturesPairDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthPairDeviceRequestPost: async (deviceToken: string, aPIXdentDTOSafeSignaturesPairDeviceRequestDto?: APIXdentDTOSafeSignaturesPairDeviceRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesAuthPairDeviceRequestPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/auth/PairDeviceRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesPairDeviceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {string} deviceToken 
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthPost: async (deviceToken: string, apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesAuthPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiSafesignaturesAuthPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Debug method, unpairs device from platform.
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthUnpairPost: async (deviceToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesAuthUnpairPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/auth/Unpair`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check if provided credentials are valid. Whatever scheme is used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthIsAuthValidGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthIsAuthValidGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiAuthIsAuthValidGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalPay4uAuthLoginPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalPay4uAuthLoginPost(apiSafesignaturesAuthPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiExternalPay4uAuthLoginPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalPay4uAuthRefreshPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalPay4uAuthRefreshPost(aPISharedExtendBearerDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiExternalPay4uAuthRefreshPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Login endpoint for safe signatures app. Checks if tablet is paired and logins ss account. (For limitted time also migrates old pairing to new pairing)
         * @param {string} deviceToken 
         * @param {boolean} [beta] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesAuthAuthByVendorIdPost(deviceToken: string, beta?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesAuthAuthByVendorIdPost(deviceToken, beta, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiSafesignaturesAuthAuthByVendorIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {string} deviceToken 
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesAuthExtendPost(deviceToken: string, aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesAuthExtendPost(deviceToken, aPISharedExtendBearerDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiSafesignaturesAuthExtendPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Accepts pairing code and creates a pair
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesPairDeviceRequestDto} [aPIXdentDTOSafeSignaturesPairDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesAuthPairDeviceRequestPost(deviceToken: string, aPIXdentDTOSafeSignaturesPairDeviceRequestDto?: APIXdentDTOSafeSignaturesPairDeviceRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesAuthPairDeviceRequestPost(deviceToken, aPIXdentDTOSafeSignaturesPairDeviceRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiSafesignaturesAuthPairDeviceRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {string} deviceToken 
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesAuthPost(deviceToken: string, apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesAuthPost(deviceToken, apiSafesignaturesAuthPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiSafesignaturesAuthPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Debug method, unpairs device from platform.
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesAuthUnpairPost(deviceToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesAuthUnpairPost(deviceToken, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiSafesignaturesAuthUnpairPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Check if provided credentials are valid. Whatever scheme is used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthIsAuthValidGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiAuthIsAuthValidGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalPay4uAuthLoginPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiExternalPay4uAuthLoginPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalPay4uAuthRefreshPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiExternalPay4uAuthRefreshPost(aPISharedExtendBearerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login endpoint for safe signatures app. Checks if tablet is paired and logins ss account. (For limitted time also migrates old pairing to new pairing)
         * @param {string} deviceToken 
         * @param {boolean} [beta] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthAuthByVendorIdPost(deviceToken: string, beta?: boolean, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiSafesignaturesAuthAuthByVendorIdPost(deviceToken, beta, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {string} deviceToken 
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthExtendPost(deviceToken: string, aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiSafesignaturesAuthExtendPost(deviceToken, aPISharedExtendBearerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accepts pairing code and creates a pair
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesPairDeviceRequestDto} [aPIXdentDTOSafeSignaturesPairDeviceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthPairDeviceRequestPost(deviceToken: string, aPIXdentDTOSafeSignaturesPairDeviceRequestDto?: APIXdentDTOSafeSignaturesPairDeviceRequestDto, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiSafesignaturesAuthPairDeviceRequestPost(deviceToken, aPIXdentDTOSafeSignaturesPairDeviceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {string} deviceToken 
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthPost(deviceToken: string, apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiSafesignaturesAuthPost(deviceToken, apiSafesignaturesAuthPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Debug method, unpairs device from platform.
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesAuthUnpairPost(deviceToken: string, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiSafesignaturesAuthUnpairPost(deviceToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Check if provided credentials are valid. Whatever scheme is used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiAuthIsAuthValidGet(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthIsAuthValidGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticates user by login credentials via post model
     * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiExternalPay4uAuthLoginPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiExternalPay4uAuthLoginPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extends bearer token with provided refresh and old bearer
     * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiExternalPay4uAuthRefreshPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiExternalPay4uAuthRefreshPost(aPISharedExtendBearerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login endpoint for safe signatures app. Checks if tablet is paired and logins ss account. (For limitted time also migrates old pairing to new pairing)
     * @param {string} deviceToken 
     * @param {boolean} [beta] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiSafesignaturesAuthAuthByVendorIdPost(deviceToken: string, beta?: boolean, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiSafesignaturesAuthAuthByVendorIdPost(deviceToken, beta, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extends bearer token with provided refresh and old bearer
     * @param {string} deviceToken 
     * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiSafesignaturesAuthExtendPost(deviceToken: string, aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiSafesignaturesAuthExtendPost(deviceToken, aPISharedExtendBearerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accepts pairing code and creates a pair
     * @param {string} deviceToken 
     * @param {APIXdentDTOSafeSignaturesPairDeviceRequestDto} [aPIXdentDTOSafeSignaturesPairDeviceRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiSafesignaturesAuthPairDeviceRequestPost(deviceToken: string, aPIXdentDTOSafeSignaturesPairDeviceRequestDto?: APIXdentDTOSafeSignaturesPairDeviceRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiSafesignaturesAuthPairDeviceRequestPost(deviceToken, aPIXdentDTOSafeSignaturesPairDeviceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticates user by login credentials via post model
     * @param {string} deviceToken 
     * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiSafesignaturesAuthPost(deviceToken: string, apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiSafesignaturesAuthPost(deviceToken, apiSafesignaturesAuthPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Debug method, unpairs device from platform.
     * @param {string} deviceToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiSafesignaturesAuthUnpairPost(deviceToken: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiSafesignaturesAuthUnpairPost(deviceToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BudgetPlanApi - axios parameter creator
 * @export
 */
export const BudgetPlanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBudgetPlanGetBasePlanGridGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/BudgetPlan/GetBasePlanGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBudgetPlanGetDispensarizationGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/BudgetPlan/GetDispensarization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBudgetPlanGetPlanGet: async (idPlan?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/BudgetPlan/GetPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idPlan !== undefined) {
                localVarQueryParameter['idPlan'] = idPlan;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBudgetPlanGetRandomGuidsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/BudgetPlan/GetRandomGuids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BudgetPlanApi - functional programming interface
 * @export
 */
export const BudgetPlanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BudgetPlanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBudgetPlanGetBasePlanGridGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBudgetPlanGetBasePlanGridGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BudgetPlanApi.apiBudgetPlanGetBasePlanGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBudgetPlanGetDispensarizationGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOBudgetPlanBudgetPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBudgetPlanGetDispensarizationGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BudgetPlanApi.apiBudgetPlanGetDispensarizationGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBudgetPlanGetPlanGet(idPlan?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOBudgetPlanBudgetPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBudgetPlanGetPlanGet(idPlan, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BudgetPlanApi.apiBudgetPlanGetPlanGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBudgetPlanGetRandomGuidsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBudgetPlanGetRandomGuidsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BudgetPlanApi.apiBudgetPlanGetRandomGuidsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * BudgetPlanApi - factory interface
 * @export
 */
export const BudgetPlanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BudgetPlanApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBudgetPlanGetBasePlanGridGet(idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedBUDGETPLANGRIDResult>> {
            return localVarFp.apiBudgetPlanGetBasePlanGridGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBudgetPlanGetDispensarizationGet(idClient?: string, options?: any): AxiosPromise<APIXdentDTOBudgetPlanBudgetPlanDto> {
            return localVarFp.apiBudgetPlanGetDispensarizationGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBudgetPlanGetPlanGet(idPlan?: string, options?: any): AxiosPromise<APIXdentDTOBudgetPlanBudgetPlanDto> {
            return localVarFp.apiBudgetPlanGetPlanGet(idPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBudgetPlanGetRandomGuidsGet(options?: any): AxiosPromise<Set<string>> {
            return localVarFp.apiBudgetPlanGetRandomGuidsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BudgetPlanApi - object-oriented interface
 * @export
 * @class BudgetPlanApi
 * @extends {BaseAPI}
 */
export class BudgetPlanApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPlanApi
     */
    public apiBudgetPlanGetBasePlanGridGet(idClient?: string, options?: AxiosRequestConfig) {
        return BudgetPlanApiFp(this.configuration).apiBudgetPlanGetBasePlanGridGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPlanApi
     */
    public apiBudgetPlanGetDispensarizationGet(idClient?: string, options?: AxiosRequestConfig) {
        return BudgetPlanApiFp(this.configuration).apiBudgetPlanGetDispensarizationGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idPlan] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPlanApi
     */
    public apiBudgetPlanGetPlanGet(idPlan?: string, options?: AxiosRequestConfig) {
        return BudgetPlanApiFp(this.configuration).apiBudgetPlanGetPlanGet(idPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPlanApi
     */
    public apiBudgetPlanGetRandomGuidsGet(options?: AxiosRequestConfig) {
        return BudgetPlanApiFp(this.configuration).apiBudgetPlanGetRandomGuidsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallApi - axios parameter creator
 * @export
 */
export const CallApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sets call status
         * @param {APIXdentDTOCallSetCallStatusDto} [aPIXdentDTOCallSetCallStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallSetStatusPost: async (aPIXdentDTOCallSetCallStatusDto?: APIXdentDTOCallSetCallStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Call/SetStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOCallSetCallStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallApi - functional programming interface
 * @export
 */
export const CallApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sets call status
         * @param {APIXdentDTOCallSetCallStatusDto} [aPIXdentDTOCallSetCallStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallSetStatusPost(aPIXdentDTOCallSetCallStatusDto?: APIXdentDTOCallSetCallStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallSetStatusPost(aPIXdentDTOCallSetCallStatusDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CallApi.apiCallSetStatusPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CallApi - factory interface
 * @export
 */
export const CallApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallApiFp(configuration)
    return {
        /**
         * 
         * @summary Sets call status
         * @param {APIXdentDTOCallSetCallStatusDto} [aPIXdentDTOCallSetCallStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallSetStatusPost(aPIXdentDTOCallSetCallStatusDto?: APIXdentDTOCallSetCallStatusDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiCallSetStatusPost(aPIXdentDTOCallSetCallStatusDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallApi - object-oriented interface
 * @export
 * @class CallApi
 * @extends {BaseAPI}
 */
export class CallApi extends BaseAPI {
    /**
     * 
     * @summary Sets call status
     * @param {APIXdentDTOCallSetCallStatusDto} [aPIXdentDTOCallSetCallStatusDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallSetStatusPost(aPIXdentDTOCallSetCallStatusDto?: APIXdentDTOCallSetCallStatusDto, options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallSetStatusPost(aPIXdentDTOCallSetCallStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CertsApi - axios parameter creator
 * @export
 */
export const CertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets sign certs info. Returns empty 200 if fingerprints match. As there is no need to fetch the same data.
         * @param {string} deviceToken 
         * @param {string} [pubSafeSigThumb] 
         * @param {string} [thirdPartySealThumb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesCertsCurrentGet: async (deviceToken: string, pubSafeSigThumb?: string, thirdPartySealThumb?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesCertsCurrentGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/certs/Current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pubSafeSigThumb !== undefined) {
                localVarQueryParameter['pubSafeSigThumb'] = pubSafeSigThumb;
            }

            if (thirdPartySealThumb !== undefined) {
                localVarQueryParameter['thirdPartySealThumb'] = thirdPartySealThumb;
            }

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CertsApi - functional programming interface
 * @export
 */
export const CertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CertsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets sign certs info. Returns empty 200 if fingerprints match. As there is no need to fetch the same data.
         * @param {string} deviceToken 
         * @param {string} [pubSafeSigThumb] 
         * @param {string} [thirdPartySealThumb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesCertsCurrentGet(deviceToken: string, pubSafeSigThumb?: string, thirdPartySealThumb?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentControllersSafeSignaturesSafeSignaturesCurrentCertsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesCertsCurrentGet(deviceToken, pubSafeSigThumb, thirdPartySealThumb, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CertsApi.apiSafesignaturesCertsCurrentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CertsApi - factory interface
 * @export
 */
export const CertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CertsApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets sign certs info. Returns empty 200 if fingerprints match. As there is no need to fetch the same data.
         * @param {string} deviceToken 
         * @param {string} [pubSafeSigThumb] 
         * @param {string} [thirdPartySealThumb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesCertsCurrentGet(deviceToken: string, pubSafeSigThumb?: string, thirdPartySealThumb?: string, options?: any): AxiosPromise<APIXdentControllersSafeSignaturesSafeSignaturesCurrentCertsDto> {
            return localVarFp.apiSafesignaturesCertsCurrentGet(deviceToken, pubSafeSigThumb, thirdPartySealThumb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertsApi - object-oriented interface
 * @export
 * @class CertsApi
 * @extends {BaseAPI}
 */
export class CertsApi extends BaseAPI {
    /**
     * 
     * @summary Gets sign certs info. Returns empty 200 if fingerprints match. As there is no need to fetch the same data.
     * @param {string} deviceToken 
     * @param {string} [pubSafeSigThumb] 
     * @param {string} [thirdPartySealThumb] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertsApi
     */
    public apiSafesignaturesCertsCurrentGet(deviceToken: string, pubSafeSigThumb?: string, thirdPartySealThumb?: string, options?: AxiosRequestConfig) {
        return CertsApiFp(this.configuration).apiSafesignaturesCertsCurrentGet(deviceToken, pubSafeSigThumb, thirdPartySealThumb, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds client to location by logged user.
         * @param {ApiClientAddClientPostRequest} [apiClientAddClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientAddClientPost: async (apiClientAddClientPostRequest?: ApiClientAddClientPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/AddClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiClientAddClientPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits client in location by logged user.
         * @param {ApiClientEditClientPutRequest} [apiClientEditClientPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientEditClientPut: async (apiClientEditClientPutRequest?: ApiClientEditClientPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/EditClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiClientEditClientPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets filtered alerts
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientFilterAlertsGet: async (data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/FilterAlerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets filtered drugs
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientFilterDrugGet: async (data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/FilterDrug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get upcoming clients for user (By appointments). Default is 3
         * @param {string} [idClient] 
         * @param {string} [period] 
         * @param {number} [limit] 
         * @param {boolean} [onlyValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientAppointmentsGet: async (idClient?: string, period?: string, limit?: number, onlyValid?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetClientAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (onlyValid !== undefined) {
                localVarQueryParameter['onlyValid'] = onlyValid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get client detail by clientId, restricted by user ownership
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientDetailGet: async (clientId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetClientDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all client emails
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientEmailArchiveGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetClientEmailArchive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get client general data by provided model. (restricted by user ownership)
         * @param {APISharedClientGeneralDataDto} [aPISharedClientGeneralDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientGeneralDataPost: async (aPISharedClientGeneralDataDto?: APISharedClientGeneralDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetClientGeneralData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedClientGeneralDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get clients for signed user (Paginated by default)
         * @param {boolean} [pagination] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientsByUserGet: async (pagination?: boolean, page?: number, perPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetClientsByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get clients for signed user V2 (Paginated)
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientsByUserV2Get: async (page?: number, perPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetClientsByUserV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get clients detail by clientId, restricted by user ownership
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientsDetailPost: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetClientsDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets magistralis
         * @param {string} [idMagistralis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetMagistralisGet: async (idMagistralis?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetMagistralis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMagistralis !== undefined) {
                localVarQueryParameter['idMagistralis'] = idMagistralis;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get upcoming clients for logged user
         * @param {number} [numberOfClients] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetUpcomingClientsForUserGet: async (numberOfClients?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/GetUpcomingClientsForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (numberOfClients !== undefined) {
                localVarQueryParameter['numberOfClients'] = numberOfClients;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get clients for signed user (Paginated by default)
         * @param {string} [filter] 
         * @param {number} [startIndex] 
         * @param {number} [length] 
         * @param {string} [idStaff] 
         * @param {string} [idLocation] 
         * @param {boolean} [onlyValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientSearchClientsGet: async (filter?: string, startIndex?: number, length?: number, idStaff?: string, idLocation?: string, onlyValid?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/SearchClients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (startIndex !== undefined) {
                localVarQueryParameter['startIndex'] = startIndex;
            }

            if (length !== undefined) {
                localVarQueryParameter['length'] = length;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (onlyValid !== undefined) {
                localVarQueryParameter['onlyValid'] = onlyValid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send S3 file in to iklient
         * @param {APIXdentDTOClientShareFileFromS3ToIklientDTO} [aPIXdentDTOClientShareFileFromS3ToIklientDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientShareFileFromS3ToIklientPost: async (aPIXdentDTOClientShareFileFromS3ToIklientDTO?: APIXdentDTOClientShareFileFromS3ToIklientDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Client/ShareFileFromS3ToIklient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOClientShareFileFromS3ToIklientDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Adds client to location by logged user.
         * @param {ApiClientAddClientPostRequest} [apiClientAddClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientAddClientPost(apiClientAddClientPostRequest?: ApiClientAddClientPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientAddClientPost(apiClientAddClientPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientAddClientPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edits client in location by logged user.
         * @param {ApiClientEditClientPutRequest} [apiClientEditClientPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientEditClientPut(apiClientEditClientPutRequest?: ApiClientEditClientPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientEditClientPut(apiClientEditClientPutRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientEditClientPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets filtered alerts
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientFilterAlertsGet(data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedALERTITEMSEARCHGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientFilterAlertsGet(data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientFilterAlertsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets filtered drugs
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientFilterDrugGet(data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOClientFilteredDrugsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientFilterDrugGet(data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientFilterDrugGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get upcoming clients for user (By appointments). Default is 3
         * @param {string} [idClient] 
         * @param {string} [period] 
         * @param {number} [limit] 
         * @param {boolean} [onlyValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetClientAppointmentsGet(idClient?: string, period?: string, limit?: number, onlyValid?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetClientAppointmentsGet(idClient, period, limit, onlyValid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetClientAppointmentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get client detail by clientId, restricted by user ownership
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetClientDetailGet(clientId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetClientDetailGet(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetClientDetailGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all client emails
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetClientEmailArchiveGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOClientClientEmailArchiveDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetClientEmailArchiveGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetClientEmailArchiveGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get client general data by provided model. (restricted by user ownership)
         * @param {APISharedClientGeneralDataDto} [aPISharedClientGeneralDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetClientGeneralDataPost(aPISharedClientGeneralDataDto?: APISharedClientGeneralDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetClientGeneralDataPost(aPISharedClientGeneralDataDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetClientGeneralDataPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get clients for signed user (Paginated by default)
         * @param {boolean} [pagination] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetClientsByUserGet(pagination?: boolean, page?: number, perPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetClientsByUserGet(pagination, page, perPage, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetClientsByUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get clients for signed user V2 (Paginated)
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetClientsByUserV2Get(page?: number, perPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedClientV2Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetClientsByUserV2Get(page, perPage, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetClientsByUserV2Get']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get clients detail by clientId, restricted by user ownership
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetClientsDetailPost(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetClientsDetailPost(requestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetClientsDetailPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets magistralis
         * @param {string} [idMagistralis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetMagistralisGet(idMagistralis?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOClientClientMagistralisDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetMagistralisGet(idMagistralis, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetMagistralisGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get upcoming clients for logged user
         * @param {number} [numberOfClients] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientGetUpcomingClientsForUserGet(numberOfClients?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientGetUpcomingClientsForUserGet(numberOfClients, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientGetUpcomingClientsForUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get clients for signed user (Paginated by default)
         * @param {string} [filter] 
         * @param {number} [startIndex] 
         * @param {number} [length] 
         * @param {string} [idStaff] 
         * @param {string} [idLocation] 
         * @param {boolean} [onlyValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientSearchClientsGet(filter?: string, startIndex?: number, length?: number, idStaff?: string, idLocation?: string, onlyValid?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientSearchClientsGet(filter, startIndex, length, idStaff, idLocation, onlyValid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientSearchClientsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Send S3 file in to iklient
         * @param {APIXdentDTOClientShareFileFromS3ToIklientDTO} [aPIXdentDTOClientShareFileFromS3ToIklientDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientShareFileFromS3ToIklientPost(aPIXdentDTOClientShareFileFromS3ToIklientDTO?: APIXdentDTOClientShareFileFromS3ToIklientDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientShareFileFromS3ToIklientPost(aPIXdentDTOClientShareFileFromS3ToIklientDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.apiClientShareFileFromS3ToIklientPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * 
         * @summary Adds client to location by logged user.
         * @param {ApiClientAddClientPostRequest} [apiClientAddClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientAddClientPost(apiClientAddClientPostRequest?: ApiClientAddClientPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiClientAddClientPost(apiClientAddClientPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edits client in location by logged user.
         * @param {ApiClientEditClientPutRequest} [apiClientEditClientPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientEditClientPut(apiClientEditClientPutRequest?: ApiClientEditClientPutRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiClientEditClientPut(apiClientEditClientPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets filtered alerts
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientFilterAlertsGet(data?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedALERTITEMSEARCHGRIDResult>> {
            return localVarFp.apiClientFilterAlertsGet(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets filtered drugs
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientFilterDrugGet(data?: string, options?: any): AxiosPromise<Array<APIXdentDTOClientFilteredDrugsDto>> {
            return localVarFp.apiClientFilterDrugGet(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get upcoming clients for user (By appointments). Default is 3
         * @param {string} [idClient] 
         * @param {string} [period] 
         * @param {number} [limit] 
         * @param {boolean} [onlyValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientAppointmentsGet(idClient?: string, period?: string, limit?: number, onlyValid?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientGetClientAppointmentsGet(idClient, period, limit, onlyValid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get client detail by clientId, restricted by user ownership
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientDetailGet(clientId?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTFORMResult> {
            return localVarFp.apiClientGetClientDetailGet(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all client emails
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientEmailArchiveGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOClientClientEmailArchiveDTO>> {
            return localVarFp.apiClientGetClientEmailArchiveGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get client general data by provided model. (restricted by user ownership)
         * @param {APISharedClientGeneralDataDto} [aPISharedClientGeneralDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientGeneralDataPost(aPISharedClientGeneralDataDto?: APISharedClientGeneralDataDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientGetClientGeneralDataPost(aPISharedClientGeneralDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get clients for signed user (Paginated by default)
         * @param {boolean} [pagination] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientsByUserGet(pagination?: boolean, page?: number, perPage?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientGetClientsByUserGet(pagination, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get clients for signed user V2 (Paginated)
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientsByUserV2Get(page?: number, perPage?: number, options?: any): AxiosPromise<Array<APISharedClientV2Dto>> {
            return localVarFp.apiClientGetClientsByUserV2Get(page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get clients detail by clientId, restricted by user ownership
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetClientsDetailPost(requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientGetClientsDetailPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets magistralis
         * @param {string} [idMagistralis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetMagistralisGet(idMagistralis?: string, options?: any): AxiosPromise<APIXdentDTOClientClientMagistralisDto> {
            return localVarFp.apiClientGetMagistralisGet(idMagistralis, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get upcoming clients for logged user
         * @param {number} [numberOfClients] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientGetUpcomingClientsForUserGet(numberOfClients?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientGetUpcomingClientsForUserGet(numberOfClients, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get clients for signed user (Paginated by default)
         * @param {string} [filter] 
         * @param {number} [startIndex] 
         * @param {number} [length] 
         * @param {string} [idStaff] 
         * @param {string} [idLocation] 
         * @param {boolean} [onlyValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientSearchClientsGet(filter?: string, startIndex?: number, length?: number, idStaff?: string, idLocation?: string, onlyValid?: boolean, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERCLIENTGRIDPERFORMEDResult>> {
            return localVarFp.apiClientSearchClientsGet(filter, startIndex, length, idStaff, idLocation, onlyValid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send S3 file in to iklient
         * @param {APIXdentDTOClientShareFileFromS3ToIklientDTO} [aPIXdentDTOClientShareFileFromS3ToIklientDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientShareFileFromS3ToIklientPost(aPIXdentDTOClientShareFileFromS3ToIklientDTO?: APIXdentDTOClientShareFileFromS3ToIklientDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiClientShareFileFromS3ToIklientPost(aPIXdentDTOClientShareFileFromS3ToIklientDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * 
     * @summary Adds client to location by logged user.
     * @param {ApiClientAddClientPostRequest} [apiClientAddClientPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientAddClientPost(apiClientAddClientPostRequest?: ApiClientAddClientPostRequest, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientAddClientPost(apiClientAddClientPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edits client in location by logged user.
     * @param {ApiClientEditClientPutRequest} [apiClientEditClientPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientEditClientPut(apiClientEditClientPutRequest?: ApiClientEditClientPutRequest, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientEditClientPut(apiClientEditClientPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets filtered alerts
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientFilterAlertsGet(data?: string, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientFilterAlertsGet(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets filtered drugs
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientFilterDrugGet(data?: string, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientFilterDrugGet(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get upcoming clients for user (By appointments). Default is 3
     * @param {string} [idClient] 
     * @param {string} [period] 
     * @param {number} [limit] 
     * @param {boolean} [onlyValid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetClientAppointmentsGet(idClient?: string, period?: string, limit?: number, onlyValid?: boolean, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetClientAppointmentsGet(idClient, period, limit, onlyValid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get client detail by clientId, restricted by user ownership
     * @param {string} [clientId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetClientDetailGet(clientId?: string, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetClientDetailGet(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all client emails
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetClientEmailArchiveGet(idClient?: string, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetClientEmailArchiveGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get client general data by provided model. (restricted by user ownership)
     * @param {APISharedClientGeneralDataDto} [aPISharedClientGeneralDataDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetClientGeneralDataPost(aPISharedClientGeneralDataDto?: APISharedClientGeneralDataDto, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetClientGeneralDataPost(aPISharedClientGeneralDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get clients for signed user (Paginated by default)
     * @param {boolean} [pagination] 
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetClientsByUserGet(pagination?: boolean, page?: number, perPage?: number, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetClientsByUserGet(pagination, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get clients for signed user V2 (Paginated)
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetClientsByUserV2Get(page?: number, perPage?: number, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetClientsByUserV2Get(page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get clients detail by clientId, restricted by user ownership
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetClientsDetailPost(requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetClientsDetailPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets magistralis
     * @param {string} [idMagistralis] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetMagistralisGet(idMagistralis?: string, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetMagistralisGet(idMagistralis, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get upcoming clients for logged user
     * @param {number} [numberOfClients] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientGetUpcomingClientsForUserGet(numberOfClients?: number, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientGetUpcomingClientsForUserGet(numberOfClients, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get clients for signed user (Paginated by default)
     * @param {string} [filter] 
     * @param {number} [startIndex] 
     * @param {number} [length] 
     * @param {string} [idStaff] 
     * @param {string} [idLocation] 
     * @param {boolean} [onlyValid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientSearchClientsGet(filter?: string, startIndex?: number, length?: number, idStaff?: string, idLocation?: string, onlyValid?: boolean, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientSearchClientsGet(filter, startIndex, length, idStaff, idLocation, onlyValid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send S3 file in to iklient
     * @param {APIXdentDTOClientShareFileFromS3ToIklientDTO} [aPIXdentDTOClientShareFileFromS3ToIklientDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientShareFileFromS3ToIklientPost(aPIXdentDTOClientShareFileFromS3ToIklientDTO?: APIXdentDTOClientShareFileFromS3ToIklientDTO, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientShareFileFromS3ToIklientPost(aPIXdentDTOClientShareFileFromS3ToIklientDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientDetailAnamnesisApi - axios parameter creator
 * @export
 */
export const ClientDetailAnamnesisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailAnamnesisGetAnamnesisGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailAnamnesis/GetAnamnesis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailAnamnesisGetFormRequestsGet: async (idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailAnamnesis/GetFormRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idRequest !== undefined) {
                localVarQueryParameter['idRequest'] = idRequest;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (statusCode !== undefined) {
                localVarQueryParameter['statusCode'] = statusCode;
            }

            if (includeDocumentFile !== undefined) {
                localVarQueryParameter['includeDocumentFile'] = includeDocumentFile;
            }

            if (stDate !== undefined) {
                localVarQueryParameter['stDate'] = stDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (stExpDate !== undefined) {
                localVarQueryParameter['stExpDate'] = stExpDate;
            }

            if (endExpDate !== undefined) {
                localVarQueryParameter['endExpDate'] = endExpDate;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientDetailAnamnesisApi - functional programming interface
 * @export
 */
export const ClientDetailAnamnesisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientDetailAnamnesisApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailAnamnesisGetAnamnesisGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailAnamnesisGetAnamnesisGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailAnamnesisApi.apiClientDetailAnamnesisGetAnamnesisGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailAnamnesisGetFormRequestsGet(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailAnamnesisGetFormRequestsGet(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailAnamnesisApi.apiClientDetailAnamnesisGetFormRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ClientDetailAnamnesisApi - factory interface
 * @export
 */
export const ClientDetailAnamnesisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientDetailAnamnesisApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailAnamnesisGetAnamnesisGet(idClient?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedANAMNESISFORMResult> {
            return localVarFp.apiClientDetailAnamnesisGetAnamnesisGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailAnamnesisGetFormRequestsGet(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult>> {
            return localVarFp.apiClientDetailAnamnesisGetFormRequestsGet(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientDetailAnamnesisApi - object-oriented interface
 * @export
 * @class ClientDetailAnamnesisApi
 * @extends {BaseAPI}
 */
export class ClientDetailAnamnesisApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailAnamnesisApi
     */
    public apiClientDetailAnamnesisGetAnamnesisGet(idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailAnamnesisApiFp(this.configuration).apiClientDetailAnamnesisGetAnamnesisGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idRequest] 
     * @param {string} [idStaff] 
     * @param {string} [statusCode] 
     * @param {boolean} [includeDocumentFile] 
     * @param {string} [stDate] 
     * @param {string} [endDate] 
     * @param {string} [stExpDate] 
     * @param {string} [endExpDate] 
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailAnamnesisApi
     */
    public apiClientDetailAnamnesisGetFormRequestsGet(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: AxiosRequestConfig) {
        return ClientDetailAnamnesisApiFp(this.configuration).apiClientDetailAnamnesisGetFormRequestsGet(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientDetailGeneralApi - axios parameter creator
 * @export
 */
export const ClientDetailGeneralApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {string} [period] 
         * @param {number} [limit] 
         * @param {boolean} [validOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientAppointmentsGet: async (idClient?: string, period?: string, limit?: number, validOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetClientAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (validOnly !== undefined) {
                localVarQueryParameter['validOnly'] = validOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientEmailArchiveGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetClientEmailArchive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientInvoiceListGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetClientInvoiceList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientSMSArchiveGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetClientSMSArchive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientSMSIncomingGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetClientSMSIncoming`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetDoctorPassesGet: async (idMedicalReport?: string, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetDoctorPasses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetLaboratoryLabelListGet: async (idMedicalReport?: string, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetLaboratoryLabelList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetMedicalExaminationGridGet: async (idMedicalReport?: string, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetMedicalExaminationGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetMedicalReportExternGridGet: async (idMedicalReport?: string, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetMedicalReportExternGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {boolean} [includeExternGrid] 
         * @param {boolean} [includePrescriptionGrid] 
         * @param {boolean} [includeMedicalExaminationGrid] 
         * @param {boolean} [includeDoctorPasses] 
         * @param {boolean} [includeTransportOrders] 
         * @param {boolean} [includeLaboratoryLabels] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetMedicalReportGeneralDetailGet: async (idMedicalReport?: string, idClient?: string, includeExternGrid?: boolean, includePrescriptionGrid?: boolean, includeMedicalExaminationGrid?: boolean, includeDoctorPasses?: boolean, includeTransportOrders?: boolean, includeLaboratoryLabels?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetMedicalReportGeneralDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (includeExternGrid !== undefined) {
                localVarQueryParameter['includeExternGrid'] = includeExternGrid;
            }

            if (includePrescriptionGrid !== undefined) {
                localVarQueryParameter['includePrescriptionGrid'] = includePrescriptionGrid;
            }

            if (includeMedicalExaminationGrid !== undefined) {
                localVarQueryParameter['includeMedicalExaminationGrid'] = includeMedicalExaminationGrid;
            }

            if (includeDoctorPasses !== undefined) {
                localVarQueryParameter['includeDoctorPasses'] = includeDoctorPasses;
            }

            if (includeTransportOrders !== undefined) {
                localVarQueryParameter['includeTransportOrders'] = includeTransportOrders;
            }

            if (includeLaboratoryLabels !== undefined) {
                localVarQueryParameter['includeLaboratoryLabels'] = includeLaboratoryLabels;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetPrescriptionListGet: async (idMedicalReport?: string, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetPrescriptionList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetTransportOrdersGet: async (idMedicalReport?: string, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientDetailGeneral/GetTransportOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientDetailGeneralApi - functional programming interface
 * @export
 */
export const ClientDetailGeneralApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientDetailGeneralApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {string} [period] 
         * @param {number} [limit] 
         * @param {boolean} [validOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetClientAppointmentsGet(idClient?: string, period?: string, limit?: number, validOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetClientAppointmentsGet(idClient, period, limit, validOnly, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetClientAppointmentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetClientEmailArchiveGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOClientDetailGeneralReminderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetClientEmailArchiveGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetClientEmailArchiveGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetClientInvoiceListGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOClientDetailGeneralInvoiceClientInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetClientInvoiceListGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetClientInvoiceListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetClientSMSArchiveGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOClientDetailGeneralReminderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetClientSMSArchiveGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetClientSMSArchiveGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetClientSMSIncomingGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOClientDetailGeneralReminderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetClientSMSIncomingGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetClientSMSIncomingGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetDoctorPassesGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetDoctorPassesGet(idMedicalReport, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetDoctorPassesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetLaboratoryLabelListGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetLaboratoryLabelListGet(idMedicalReport, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetLaboratoryLabelListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetMedicalExaminationGridGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetMedicalExaminationGridGet(idMedicalReport, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetMedicalExaminationGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetMedicalReportExternGridGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetMedicalReportExternGridGet(idMedicalReport, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetMedicalReportExternGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {boolean} [includeExternGrid] 
         * @param {boolean} [includePrescriptionGrid] 
         * @param {boolean} [includeMedicalExaminationGrid] 
         * @param {boolean} [includeDoctorPasses] 
         * @param {boolean} [includeTransportOrders] 
         * @param {boolean} [includeLaboratoryLabels] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetMedicalReportGeneralDetailGet(idMedicalReport?: string, idClient?: string, includeExternGrid?: boolean, includePrescriptionGrid?: boolean, includeMedicalExaminationGrid?: boolean, includeDoctorPasses?: boolean, includeTransportOrders?: boolean, includeLaboratoryLabels?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetMedicalReportGeneralDetailGet(idMedicalReport, idClient, includeExternGrid, includePrescriptionGrid, includeMedicalExaminationGrid, includeDoctorPasses, includeTransportOrders, includeLaboratoryLabels, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetMedicalReportGeneralDetailGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetPrescriptionListGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOClientDetailGeneralPrescriptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetPrescriptionListGet(idMedicalReport, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetPrescriptionListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientDetailGeneralGetTransportOrdersGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientDetailGeneralGetTransportOrdersGet(idMedicalReport, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientDetailGeneralApi.apiClientDetailGeneralGetTransportOrdersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ClientDetailGeneralApi - factory interface
 * @export
 */
export const ClientDetailGeneralApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientDetailGeneralApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {string} [period] 
         * @param {number} [limit] 
         * @param {boolean} [validOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientAppointmentsGet(idClient?: string, period?: string, limit?: number, validOnly?: boolean, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedAPPOINTMENTGRIDResult>> {
            return localVarFp.apiClientDetailGeneralGetClientAppointmentsGet(idClient, period, limit, validOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientEmailArchiveGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOClientDetailGeneralReminderDto>> {
            return localVarFp.apiClientDetailGeneralGetClientEmailArchiveGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientInvoiceListGet(idClient?: string, options?: any): AxiosPromise<APIXdentDTOClientDetailGeneralInvoiceClientInfoDto> {
            return localVarFp.apiClientDetailGeneralGetClientInvoiceListGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientSMSArchiveGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOClientDetailGeneralReminderDto>> {
            return localVarFp.apiClientDetailGeneralGetClientSMSArchiveGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetClientSMSIncomingGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOClientDetailGeneralReminderDto>> {
            return localVarFp.apiClientDetailGeneralGetClientSMSIncomingGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetDoctorPassesGet(idMedicalReport?: string, idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCTORPASSCLIENTGRIDResult>> {
            return localVarFp.apiClientDetailGeneralGetDoctorPassesGet(idMedicalReport, idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetLaboratoryLabelListGet(idMedicalReport?: string, idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELCLIENTGRIDNEWResult>> {
            return localVarFp.apiClientDetailGeneralGetLaboratoryLabelListGet(idMedicalReport, idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetMedicalExaminationGridGet(idMedicalReport?: string, idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALEXAMINATIONGRIDResult>> {
            return localVarFp.apiClientDetailGeneralGetMedicalExaminationGridGet(idMedicalReport, idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetMedicalReportExternGridGet(idMedicalReport?: string, idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTEXTERNGRIDNEWResult>> {
            return localVarFp.apiClientDetailGeneralGetMedicalReportExternGridGet(idMedicalReport, idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {boolean} [includeExternGrid] 
         * @param {boolean} [includePrescriptionGrid] 
         * @param {boolean} [includeMedicalExaminationGrid] 
         * @param {boolean} [includeDoctorPasses] 
         * @param {boolean} [includeTransportOrders] 
         * @param {boolean} [includeLaboratoryLabels] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetMedicalReportGeneralDetailGet(idMedicalReport?: string, idClient?: string, includeExternGrid?: boolean, includePrescriptionGrid?: boolean, includeMedicalExaminationGrid?: boolean, includeDoctorPasses?: boolean, includeTransportOrders?: boolean, includeLaboratoryLabels?: boolean, options?: any): AxiosPromise<APIXdentDTOMedicalRecordMedicalReportGeneralDetailDto> {
            return localVarFp.apiClientDetailGeneralGetMedicalReportGeneralDetailGet(idMedicalReport, idClient, includeExternGrid, includePrescriptionGrid, includeMedicalExaminationGrid, includeDoctorPasses, includeTransportOrders, includeLaboratoryLabels, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetPrescriptionListGet(idMedicalReport?: string, idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOClientDetailGeneralPrescriptionDto>> {
            return localVarFp.apiClientDetailGeneralGetPrescriptionListGet(idMedicalReport, idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientDetailGeneralGetTransportOrdersGet(idMedicalReport?: string, idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTRANSPORTORDERCLIENTGRIDResult>> {
            return localVarFp.apiClientDetailGeneralGetTransportOrdersGet(idMedicalReport, idClient, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientDetailGeneralApi - object-oriented interface
 * @export
 * @class ClientDetailGeneralApi
 * @extends {BaseAPI}
 */
export class ClientDetailGeneralApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {string} [period] 
     * @param {number} [limit] 
     * @param {boolean} [validOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetClientAppointmentsGet(idClient?: string, period?: string, limit?: number, validOnly?: boolean, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetClientAppointmentsGet(idClient, period, limit, validOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetClientEmailArchiveGet(idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetClientEmailArchiveGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetClientInvoiceListGet(idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetClientInvoiceListGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetClientSMSArchiveGet(idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetClientSMSArchiveGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetClientSMSIncomingGet(idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetClientSMSIncomingGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetDoctorPassesGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetDoctorPassesGet(idMedicalReport, idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetLaboratoryLabelListGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetLaboratoryLabelListGet(idMedicalReport, idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetMedicalExaminationGridGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetMedicalExaminationGridGet(idMedicalReport, idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetMedicalReportExternGridGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetMedicalReportExternGridGet(idMedicalReport, idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {string} [idClient] 
     * @param {boolean} [includeExternGrid] 
     * @param {boolean} [includePrescriptionGrid] 
     * @param {boolean} [includeMedicalExaminationGrid] 
     * @param {boolean} [includeDoctorPasses] 
     * @param {boolean} [includeTransportOrders] 
     * @param {boolean} [includeLaboratoryLabels] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetMedicalReportGeneralDetailGet(idMedicalReport?: string, idClient?: string, includeExternGrid?: boolean, includePrescriptionGrid?: boolean, includeMedicalExaminationGrid?: boolean, includeDoctorPasses?: boolean, includeTransportOrders?: boolean, includeLaboratoryLabels?: boolean, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetMedicalReportGeneralDetailGet(idMedicalReport, idClient, includeExternGrid, includePrescriptionGrid, includeMedicalExaminationGrid, includeDoctorPasses, includeTransportOrders, includeLaboratoryLabels, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetPrescriptionListGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetPrescriptionListGet(idMedicalReport, idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDetailGeneralApi
     */
    public apiClientDetailGeneralGetTransportOrdersGet(idMedicalReport?: string, idClient?: string, options?: AxiosRequestConfig) {
        return ClientDetailGeneralApiFp(this.configuration).apiClientDetailGeneralGetTransportOrdersGet(idMedicalReport, idClient, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CodelistApi - axios parameter creator
 * @export
 */
export const CodelistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCodelistGetAllCodeListsGet: async (language?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Codelist/GetAllCodeLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets codelist code by id
         * @param {string} [idCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCodelistGetCodeByCodelistIdGet: async (idCodelist?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Codelist/GetCodeByCodelistId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idCodelist !== undefined) {
                localVarQueryParameter['idCodelist'] = idCodelist;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [language] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCodelistGetCodeListsByTypePost: async (language?: string, requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Codelist/GetCodeListsByType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodelistApi - functional programming interface
 * @export
 */
export const CodelistApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CodelistApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCodelistGetAllCodeListsGet(language?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<APISharedCodelistDto>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCodelistGetAllCodeListsGet(language, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CodelistApi.apiCodelistGetAllCodeListsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets codelist code by id
         * @param {string} [idCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCodelistGetCodeByCodelistIdGet(idCodelist?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCodelistGetCodeByCodelistIdGet(idCodelist, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CodelistApi.apiCodelistGetCodeByCodelistIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [language] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCodelistGetCodeListsByTypePost(language?: string, requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<APISharedCodelistDto>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCodelistGetCodeListsByTypePost(language, requestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CodelistApi.apiCodelistGetCodeListsByTypePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CodelistApi - factory interface
 * @export
 */
export const CodelistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CodelistApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCodelistGetAllCodeListsGet(language?: string, options?: any): AxiosPromise<{ [key: string]: Array<APISharedCodelistDto>; }> {
            return localVarFp.apiCodelistGetAllCodeListsGet(language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets codelist code by id
         * @param {string} [idCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCodelistGetCodeByCodelistIdGet(idCodelist?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiCodelistGetCodeByCodelistIdGet(idCodelist, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [language] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCodelistGetCodeListsByTypePost(language?: string, requestBody?: Array<string>, options?: any): AxiosPromise<{ [key: string]: Array<APISharedCodelistDto>; }> {
            return localVarFp.apiCodelistGetCodeListsByTypePost(language, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CodelistApi - object-oriented interface
 * @export
 * @class CodelistApi
 * @extends {BaseAPI}
 */
export class CodelistApi extends BaseAPI {
    /**
     * 
     * @summary Gets medical report by id
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodelistApi
     */
    public apiCodelistGetAllCodeListsGet(language?: string, options?: AxiosRequestConfig) {
        return CodelistApiFp(this.configuration).apiCodelistGetAllCodeListsGet(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets codelist code by id
     * @param {string} [idCodelist] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodelistApi
     */
    public apiCodelistGetCodeByCodelistIdGet(idCodelist?: string, options?: AxiosRequestConfig) {
        return CodelistApiFp(this.configuration).apiCodelistGetCodeByCodelistIdGet(idCodelist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets medical report by id
     * @param {string} [language] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodelistApi
     */
    public apiCodelistGetCodeListsByTypePost(language?: string, requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return CodelistApiFp(this.configuration).apiCodelistGetCodeListsByTypePost(language, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommunityApi - axios parameter creator
 * @export
 */
export const CommunityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticates user by credentials for community. based on xdent credentials
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityAuthAuthPost: async (apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CommunityAuth/Auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiSafesignaturesAuthPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityGalleryGetFileByIdGet: async (idFile?: string, imageAsType?: ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CommunityGallery/GetFileById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (imageAsType !== undefined) {
                localVarQueryParameter['imageAsType'] = imageAsType;
            }

            if (extendedBaseModel !== undefined) {
                localVarQueryParameter['extendedBaseModel'] = extendedBaseModel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets already set tags for specific file.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityGalleryGetFileTagsGet: async (idFile?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CommunityGallery/GetFileTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityGalleryGetThumbnailByIdGet: async (idFile?: string, size?: string, thumbnailAsType?: ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CommunityGallery/GetThumbnailById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (thumbnailAsType !== undefined) {
                localVarQueryParameter['thumbnailAsType'] = thumbnailAsType;
            }

            if (extendedBaseModel !== undefined) {
                localVarQueryParameter['extendedBaseModel'] = extendedBaseModel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityGetMetadataGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Community/GetMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunityApi - functional programming interface
 * @export
 */
export const CommunityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticates user by credentials for community. based on xdent credentials
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommunityAuthAuthPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommunityAuthAuthPost(apiSafesignaturesAuthPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunityApi.apiCommunityAuthAuthPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommunityGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedExtendedBaseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommunityGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunityApi.apiCommunityGalleryGetFileByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets already set tags for specific file.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommunityGalleryGetFileTagsGet(idFile?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommunityGalleryGetFileTagsGet(idFile, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunityApi.apiCommunityGalleryGetFileTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommunityGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedExtendedBaseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommunityGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunityApi.apiCommunityGalleryGetThumbnailByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommunityGetMetadataGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedCommunityCommunityPlatformMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommunityGetMetadataGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunityApi.apiCommunityGetMetadataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CommunityApi - factory interface
 * @export
 */
export const CommunityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunityApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticates user by credentials for community. based on xdent credentials
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityAuthAuthPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiCommunityAuthAuthPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: any): AxiosPromise<APISharedExtendedBaseModel> {
            return localVarFp.apiCommunityGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets already set tags for specific file.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityGalleryGetFileTagsGet(idFile?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult>> {
            return localVarFp.apiCommunityGalleryGetFileTagsGet(idFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: any): AxiosPromise<APISharedExtendedBaseModel> {
            return localVarFp.apiCommunityGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityGetMetadataGet(options?: any): AxiosPromise<APISharedCommunityCommunityPlatformMetadataDto> {
            return localVarFp.apiCommunityGetMetadataGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommunityApi - object-oriented interface
 * @export
 * @class CommunityApi
 * @extends {BaseAPI}
 */
export class CommunityApi extends BaseAPI {
    /**
     * 
     * @summary Authenticates user by credentials for community. based on xdent credentials
     * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiCommunityAuthAuthPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiCommunityAuthAuthPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return image from gallery by id as provided type
     * @param {string} [idFile] 
     * @param {ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {boolean} [extendedBaseModel] Return extended base64 model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiCommunityGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiCommunityGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets already set tags for specific file.
     * @param {string} [idFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiCommunityGalleryGetFileTagsGet(idFile?: string, options?: AxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiCommunityGalleryGetFileTagsGet(idFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return thumbnail from gallery by id as provided type
     * @param {string} [idFile] 
     * @param {string} [size] 
     * @param {ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {boolean} [extendedBaseModel] Returns extended base model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiCommunityGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiCommunityGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the metadata.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiCommunityGetMetadataGet(options?: AxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiCommunityGetMetadataGet(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum = typeof ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum[keyof typeof ApiCommunityGalleryGetFileByIdGetImageAsTypeEnum];
/**
 * @export
 */
export const ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum = typeof ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum[keyof typeof ApiCommunityGalleryGetThumbnailByIdGetThumbnailAsTypeEnum];


/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationServiceAvailabilityGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Configuration/ServiceAvailability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export const ConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConfigurationServiceAvailabilityGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedOptionsServiceAvailabilityOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConfigurationServiceAvailabilityGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConfigurationApi.apiConfigurationServiceAvailabilityGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ConfigurationApi - factory interface
 * @export
 */
export const ConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationServiceAvailabilityGet(options?: any): AxiosPromise<APISharedOptionsServiceAvailabilityOptions> {
            return localVarFp.apiConfigurationServiceAvailabilityGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigurationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public apiConfigurationServiceAvailabilityGet(options?: AxiosRequestConfig) {
        return ConfigurationApiFp(this.configuration).apiConfigurationServiceAvailabilityGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CronApi - axios parameter creator
 * @export
 */
export const CronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Moves sms core logs to archive table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronArchiveSmsCoreLogsPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ArchiveSmsCoreLogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronAutoConfirmFormRequestsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/AutoConfirmFormRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Runs cron to check NCZI requests statuses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronCheckNCZIRequestsStatusGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/CheckNCZIRequestsStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Processes Appointment Requests  For now it runs generation and ProcessFormSendRequests right after.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronCreateFormSendRequestsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/CreateFormSendRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns generalized DTO about our crons as dynamic json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronCronStatusGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/CronStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronEpodaniPollAcknowledgedEpodaniPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cron/epodani/PollAcknowledgedEpodani`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronEpodaniSendSignedEpodaniPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cron/epodani/SendSignedEpodani`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches local certificate from Windows Cert Store for SK XDENT Service app and saves it in DB.
         * @param {string} [subject] 
         * @param {ApiCronFetchLocalCertificateGetLocationEnum} [location] 1 - CurrentUser, 2 - LocalMachine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronFetchLocalCertificateGet: async (subject?: string, location?: ApiCronFetchLocalCertificateGetLocationEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/FetchLocalCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates Admin Global Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGenerateAdminGlobalStatsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/GenerateAdminGlobalStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGenerateAnalyticsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/GenerateAnalytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates all types of UserTodoActions for iKlient
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGenerateUserTodoActionsPost: async (days?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/GenerateUserTodoActions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGetAximaAnswersTestGet: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/GetAximaAnswersTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets data from Woocommerce API and saves it to our database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGetXdentShopDataGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/GetXdentShopData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert reminderAfter to ReminderEmail table and send today remindersAfter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronInsertAndSendReminderAfterGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/InsertAndSendReminderAfter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invalidates all refresh tokens for all expired companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronInvalidateRefreshTokenForExpiredCompaniesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/InvalidateRefreshTokenForExpiredCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log Timeouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronLogTimeoutsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/LogTimeouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notification cron table population,.. auth for security reasons here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronNotificationPopulateGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/NotificationPopulate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends all notifications..
         * @param {boolean} [returnAfterDbQuery] 
         * @param {boolean} [returnAfterQueryDeviceEval] 
         * @param {boolean} [returnAfterSent] 
         * @param {boolean} [returnBeforeConfirmed] 
         * @param {boolean} [returnAfterConfirmed] 
         * @param {boolean} [sendToFirebase] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPendingNotificationsSendGet: async (returnAfterDbQuery?: boolean, returnAfterQueryDeviceEval?: boolean, returnAfterSent?: boolean, returnBeforeConfirmed?: boolean, returnAfterConfirmed?: boolean, sendToFirebase?: boolean, idCompany?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/PendingNotificationsSend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (returnAfterDbQuery !== undefined) {
                localVarQueryParameter['returnAfterDbQuery'] = returnAfterDbQuery;
            }

            if (returnAfterQueryDeviceEval !== undefined) {
                localVarQueryParameter['returnAfterQueryDeviceEval'] = returnAfterQueryDeviceEval;
            }

            if (returnAfterSent !== undefined) {
                localVarQueryParameter['returnAfterSent'] = returnAfterSent;
            }

            if (returnBeforeConfirmed !== undefined) {
                localVarQueryParameter['returnBeforeConfirmed'] = returnBeforeConfirmed;
            }

            if (returnAfterConfirmed !== undefined) {
                localVarQueryParameter['returnAfterConfirmed'] = returnAfterConfirmed;
            }

            if (sendToFirebase !== undefined) {
                localVarQueryParameter['sendToFirebase'] = sendToFirebase;
            }

            if (idCompany !== undefined) {
                localVarQueryParameter['idCompany'] = idCompany;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Processes Appointment Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessAppointmentRequestsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessAppointmentRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by budget
         * @param {ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {number} [budget] Number of emails to process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessEmailStatesByBudgetGet: async (emailType?: ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum, budget?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessEmailStatesByBudget`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (emailType !== undefined) {
                localVarQueryParameter['emailType'] = emailType;
            }

            if (budget !== undefined) {
                localVarQueryParameter['budget'] = budget;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by date range (includes time)
         * @param {ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {Date} [dateFrom] Datetime from which emails should be processed
         * @param {Date} [dateTo] Datetime to which emails should be processed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessEmailStatesByDateRangeGet: async (emailType?: ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum, dateFrom?: Date, dateTo?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessEmailStatesByDateRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (emailType !== undefined) {
                localVarQueryParameter['emailType'] = emailType;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by days (and or) hours retroactively
         * @param {ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {number} [days] Number of days
         * @param {number} [hours] Number of hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessEmailStatesByDaysRetroactivelyGet: async (emailType?: ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum, days?: number, hours?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessEmailStatesByDaysRetroactively`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (emailType !== undefined) {
                localVarQueryParameter['emailType'] = emailType;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (hours !== undefined) {
                localVarQueryParameter['hours'] = hours;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when today (00:00:00 - 23:59:59)
         * @param {ApiCronProcessEmailStatesTodayGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessEmailStatesTodayGet: async (emailType?: ApiCronProcessEmailStatesTodayGetEmailTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessEmailStatesToday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (emailType !== undefined) {
                localVarQueryParameter['emailType'] = emailType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Runs payment gateway cron on awaiting (almost finished) payments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessFinishedGatewayPaymentsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessFinishedGatewayPayments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Processes and sends generated FormSendRequests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessFormSendRequestsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessFormSendRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Runs payment gateway cron on processing payment requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessGatewayPaymentsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessGatewayPayments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessLabRequestFormResultFilesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessLabRequestFormResultFiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Processes Laboratory validities - setne aktivní platnost laborkám, kterým v nový den vzešla platnost v platnost a přemapuje fráze a marka na nové kódy platnosti
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessLaboratoryValiditiesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessLaboratoryValidities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Selects all emails from SentEmails table that do not have postmark status or are pending, fetches their status and updates SentEmails.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessSentEmailStatesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/ProcessSentEmailStates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Propagates only WP XDT Banners to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPropagateShopBannersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/PropagateShopBanners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Propagates only WC XDT Orders to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPropagateShopOrdersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/PropagateShopOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Propagates only WP XDT Posts to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPropagateShopPostsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/PropagateShopPosts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checks the health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPuppeteerCloseFinishedTabsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cron/puppeteer/CloseFinishedTabs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checks the health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPuppeteerHealthCheckGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cron/puppeteer/HealthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [limit] 
         * @param {boolean} [dryRun] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSendRemindersAximaPost: async (limit?: number, dryRun?: boolean, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/SendRemindersAxima`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {APIXdentControllersCronCronControllerPhoneDto} [aPIXdentControllersCronCronControllerPhoneDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSendTestSmsToNonExistingNumberPost: async (idXdentUser?: string, aPIXdentControllersCronCronControllerPhoneDto?: APIXdentControllersCronCronControllerPhoneDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/SendTestSmsToNonExistingNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentControllersCronCronControllerPhoneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets the refresh token bearer identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSetRefreshTokenBearerIdPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/SetRefreshTokenBearerId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns generalized DTO about our crons as dynamic json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSmsAnswersTrackingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/SmsAnswersTracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Syncs labino laboratories to xdent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSyncLabinoLaboratoriesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/SyncLabinoLaboratories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Syncs labino lab requests to xdent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSyncLabinoLaboratoryRequestsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/SyncLabinoLaboratoryRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches table data from Labino and saves them to xdt DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSyncLabinoTablesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/SyncLabinoTables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlocks Labino for XDENT companies that are invoicePartners in Labino
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronUnlockLabinoCronGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Cron/UnlockLabinoCron`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CronApi - functional programming interface
 * @export
 */
export const CronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CronApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Moves sms core logs to archive table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronArchiveSmsCoreLogsPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronArchiveSmsCoreLogsPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronArchiveSmsCoreLogsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronAutoConfirmFormRequestsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronAutoConfirmFormRequestsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronAutoConfirmFormRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Runs cron to check NCZI requests statuses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronCheckNCZIRequestsStatusGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronCheckNCZIRequestsStatusGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronCheckNCZIRequestsStatusGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Processes Appointment Requests  For now it runs generation and ProcessFormSendRequests right after.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronCreateFormSendRequestsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronCreateFormSendRequestsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronCreateFormSendRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns generalized DTO about our crons as dynamic json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronCronStatusGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronCronStatusGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronCronStatusGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronEpodaniPollAcknowledgedEpodaniPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronEpodaniPollAcknowledgedEpodaniPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronEpodaniPollAcknowledgedEpodaniPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronEpodaniSendSignedEpodaniPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronEpodaniSendSignedEpodaniPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronEpodaniSendSignedEpodaniPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Fetches local certificate from Windows Cert Store for SK XDENT Service app and saves it in DB.
         * @param {string} [subject] 
         * @param {ApiCronFetchLocalCertificateGetLocationEnum} [location] 1 - CurrentUser, 2 - LocalMachine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronFetchLocalCertificateGet(subject?: string, location?: ApiCronFetchLocalCertificateGetLocationEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronFetchLocalCertificateGet(subject, location, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronFetchLocalCertificateGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generates Admin Global Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronGenerateAdminGlobalStatsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronGenerateAdminGlobalStatsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronGenerateAdminGlobalStatsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generates analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronGenerateAnalyticsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronGenerateAnalyticsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronGenerateAnalyticsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generates all types of UserTodoActions for iKlient
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronGenerateUserTodoActionsPost(days?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronGenerateUserTodoActionsPost(days, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronGenerateUserTodoActionsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronGetAximaAnswersTestGet(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronGetAximaAnswersTestGet(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronGetAximaAnswersTestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets data from Woocommerce API and saves it to our database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronGetXdentShopDataGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronGetXdentShopDataGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronGetXdentShopDataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Insert reminderAfter to ReminderEmail table and send today remindersAfter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronInsertAndSendReminderAfterGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronInsertAndSendReminderAfterGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronInsertAndSendReminderAfterGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Invalidates all refresh tokens for all expired companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronInvalidateRefreshTokenForExpiredCompaniesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronInvalidateRefreshTokenForExpiredCompaniesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronInvalidateRefreshTokenForExpiredCompaniesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Log Timeouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronLogTimeoutsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronLogTimeoutsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronLogTimeoutsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Notification cron table population,.. auth for security reasons here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronNotificationPopulateGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronNotificationPopulateGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronNotificationPopulateGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sends all notifications..
         * @param {boolean} [returnAfterDbQuery] 
         * @param {boolean} [returnAfterQueryDeviceEval] 
         * @param {boolean} [returnAfterSent] 
         * @param {boolean} [returnBeforeConfirmed] 
         * @param {boolean} [returnAfterConfirmed] 
         * @param {boolean} [sendToFirebase] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronPendingNotificationsSendGet(returnAfterDbQuery?: boolean, returnAfterQueryDeviceEval?: boolean, returnAfterSent?: boolean, returnBeforeConfirmed?: boolean, returnAfterConfirmed?: boolean, sendToFirebase?: boolean, idCompany?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronPendingNotificationsSendGet(returnAfterDbQuery, returnAfterQueryDeviceEval, returnAfterSent, returnBeforeConfirmed, returnAfterConfirmed, sendToFirebase, idCompany, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronPendingNotificationsSendGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Processes Appointment Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessAppointmentRequestsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessAppointmentRequestsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessAppointmentRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by budget
         * @param {ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {number} [budget] Number of emails to process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessEmailStatesByBudgetGet(emailType?: ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum, budget?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessEmailStatesByBudgetGet(emailType, budget, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessEmailStatesByBudgetGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by date range (includes time)
         * @param {ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {Date} [dateFrom] Datetime from which emails should be processed
         * @param {Date} [dateTo] Datetime to which emails should be processed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessEmailStatesByDateRangeGet(emailType?: ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessEmailStatesByDateRangeGet(emailType, dateFrom, dateTo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessEmailStatesByDateRangeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by days (and or) hours retroactively
         * @param {ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {number} [days] Number of days
         * @param {number} [hours] Number of hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessEmailStatesByDaysRetroactivelyGet(emailType?: ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum, days?: number, hours?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessEmailStatesByDaysRetroactivelyGet(emailType, days, hours, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessEmailStatesByDaysRetroactivelyGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when today (00:00:00 - 23:59:59)
         * @param {ApiCronProcessEmailStatesTodayGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessEmailStatesTodayGet(emailType?: ApiCronProcessEmailStatesTodayGetEmailTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessEmailStatesTodayGet(emailType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessEmailStatesTodayGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Runs payment gateway cron on awaiting (almost finished) payments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessFinishedGatewayPaymentsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessFinishedGatewayPaymentsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessFinishedGatewayPaymentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Processes and sends generated FormSendRequests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessFormSendRequestsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessFormSendRequestsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessFormSendRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Runs payment gateway cron on processing payment requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessGatewayPaymentsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessGatewayPaymentsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessGatewayPaymentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessLabRequestFormResultFilesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessLabRequestFormResultFilesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessLabRequestFormResultFilesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Processes Laboratory validities - setne aktivní platnost laborkám, kterým v nový den vzešla platnost v platnost a přemapuje fráze a marka na nové kódy platnosti
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessLaboratoryValiditiesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessLaboratoryValiditiesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessLaboratoryValiditiesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Selects all emails from SentEmails table that do not have postmark status or are pending, fetches their status and updates SentEmails.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronProcessSentEmailStatesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronProcessSentEmailStatesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronProcessSentEmailStatesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Propagates only WP XDT Banners to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronPropagateShopBannersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronPropagateShopBannersGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronPropagateShopBannersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Propagates only WC XDT Orders to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronPropagateShopOrdersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronPropagateShopOrdersGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronPropagateShopOrdersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Propagates only WP XDT Posts to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronPropagateShopPostsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronPropagateShopPostsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronPropagateShopPostsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Checks the health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronPuppeteerCloseFinishedTabsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronPuppeteerCloseFinishedTabsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronPuppeteerCloseFinishedTabsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Checks the health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronPuppeteerHealthCheckGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronPuppeteerHealthCheckGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronPuppeteerHealthCheckGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [limit] 
         * @param {boolean} [dryRun] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronSendRemindersAximaPost(limit?: number, dryRun?: boolean, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronSendRemindersAximaPost(limit, dryRun, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronSendRemindersAximaPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {APIXdentControllersCronCronControllerPhoneDto} [aPIXdentControllersCronCronControllerPhoneDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronSendTestSmsToNonExistingNumberPost(idXdentUser?: string, aPIXdentControllersCronCronControllerPhoneDto?: APIXdentControllersCronCronControllerPhoneDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronSendTestSmsToNonExistingNumberPost(idXdentUser, aPIXdentControllersCronCronControllerPhoneDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronSendTestSmsToNonExistingNumberPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sets the refresh token bearer identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronSetRefreshTokenBearerIdPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronSetRefreshTokenBearerIdPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronSetRefreshTokenBearerIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns generalized DTO about our crons as dynamic json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronSmsAnswersTrackingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronSmsAnswersTrackingGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronSmsAnswersTrackingGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Syncs labino laboratories to xdent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronSyncLabinoLaboratoriesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronSyncLabinoLaboratoriesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronSyncLabinoLaboratoriesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Syncs labino lab requests to xdent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronSyncLabinoLaboratoryRequestsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronSyncLabinoLaboratoryRequestsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronSyncLabinoLaboratoryRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Fetches table data from Labino and saves them to xdt DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronSyncLabinoTablesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronSyncLabinoTablesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronSyncLabinoTablesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Unlocks Labino for XDENT companies that are invoicePartners in Labino
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCronUnlockLabinoCronGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCronUnlockLabinoCronGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CronApi.apiCronUnlockLabinoCronGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CronApi - factory interface
 * @export
 */
export const CronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CronApiFp(configuration)
    return {
        /**
         * 
         * @summary Moves sms core logs to archive table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronArchiveSmsCoreLogsPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronArchiveSmsCoreLogsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronAutoConfirmFormRequestsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronAutoConfirmFormRequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Runs cron to check NCZI requests statuses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronCheckNCZIRequestsStatusGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronCheckNCZIRequestsStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Processes Appointment Requests  For now it runs generation and ProcessFormSendRequests right after.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronCreateFormSendRequestsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronCreateFormSendRequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns generalized DTO about our crons as dynamic json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronCronStatusGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronCronStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronEpodaniPollAcknowledgedEpodaniPost(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiCronEpodaniPollAcknowledgedEpodaniPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronEpodaniSendSignedEpodaniPost(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiCronEpodaniSendSignedEpodaniPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetches local certificate from Windows Cert Store for SK XDENT Service app and saves it in DB.
         * @param {string} [subject] 
         * @param {ApiCronFetchLocalCertificateGetLocationEnum} [location] 1 - CurrentUser, 2 - LocalMachine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronFetchLocalCertificateGet(subject?: string, location?: ApiCronFetchLocalCertificateGetLocationEnum, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronFetchLocalCertificateGet(subject, location, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates Admin Global Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGenerateAdminGlobalStatsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronGenerateAdminGlobalStatsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGenerateAnalyticsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronGenerateAnalyticsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates all types of UserTodoActions for iKlient
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGenerateUserTodoActionsPost(days?: number, options?: any): AxiosPromise<string> {
            return localVarFp.apiCronGenerateUserTodoActionsPost(days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGetAximaAnswersTestGet(idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronGetAximaAnswersTestGet(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets data from Woocommerce API and saves it to our database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronGetXdentShopDataGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronGetXdentShopDataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert reminderAfter to ReminderEmail table and send today remindersAfter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronInsertAndSendReminderAfterGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronInsertAndSendReminderAfterGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invalidates all refresh tokens for all expired companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronInvalidateRefreshTokenForExpiredCompaniesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronInvalidateRefreshTokenForExpiredCompaniesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log Timeouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronLogTimeoutsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronLogTimeoutsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notification cron table population,.. auth for security reasons here.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronNotificationPopulateGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronNotificationPopulateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends all notifications..
         * @param {boolean} [returnAfterDbQuery] 
         * @param {boolean} [returnAfterQueryDeviceEval] 
         * @param {boolean} [returnAfterSent] 
         * @param {boolean} [returnBeforeConfirmed] 
         * @param {boolean} [returnAfterConfirmed] 
         * @param {boolean} [sendToFirebase] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPendingNotificationsSendGet(returnAfterDbQuery?: boolean, returnAfterQueryDeviceEval?: boolean, returnAfterSent?: boolean, returnBeforeConfirmed?: boolean, returnAfterConfirmed?: boolean, sendToFirebase?: boolean, idCompany?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronPendingNotificationsSendGet(returnAfterDbQuery, returnAfterQueryDeviceEval, returnAfterSent, returnBeforeConfirmed, returnAfterConfirmed, sendToFirebase, idCompany, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Processes Appointment Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessAppointmentRequestsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessAppointmentRequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by budget
         * @param {ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {number} [budget] Number of emails to process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessEmailStatesByBudgetGet(emailType?: ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum, budget?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessEmailStatesByBudgetGet(emailType, budget, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by date range (includes time)
         * @param {ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {Date} [dateFrom] Datetime from which emails should be processed
         * @param {Date} [dateTo] Datetime to which emails should be processed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessEmailStatesByDateRangeGet(emailType?: ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum, dateFrom?: Date, dateTo?: Date, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessEmailStatesByDateRangeGet(emailType, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when by days (and or) hours retroactively
         * @param {ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {number} [days] Number of days
         * @param {number} [hours] Number of hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessEmailStatesByDaysRetroactivelyGet(emailType?: ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum, days?: number, hours?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessEmailStatesByDaysRetroactivelyGet(emailType, days, hours, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets if emails have been delivered and when today (00:00:00 - 23:59:59)
         * @param {ApiCronProcessEmailStatesTodayGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessEmailStatesTodayGet(emailType?: ApiCronProcessEmailStatesTodayGetEmailTypeEnum, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessEmailStatesTodayGet(emailType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Runs payment gateway cron on awaiting (almost finished) payments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessFinishedGatewayPaymentsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessFinishedGatewayPaymentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Processes and sends generated FormSendRequests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessFormSendRequestsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessFormSendRequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Runs payment gateway cron on processing payment requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessGatewayPaymentsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessGatewayPaymentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessLabRequestFormResultFilesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessLabRequestFormResultFilesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Processes Laboratory validities - setne aktivní platnost laborkám, kterým v nový den vzešla platnost v platnost a přemapuje fráze a marka na nové kódy platnosti
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessLaboratoryValiditiesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessLaboratoryValiditiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Selects all emails from SentEmails table that do not have postmark status or are pending, fetches their status and updates SentEmails.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronProcessSentEmailStatesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronProcessSentEmailStatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Propagates only WP XDT Banners to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPropagateShopBannersGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronPropagateShopBannersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Propagates only WC XDT Orders to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPropagateShopOrdersGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronPropagateShopOrdersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Propagates only WP XDT Posts to XDT DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPropagateShopPostsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronPropagateShopPostsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checks the health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPuppeteerCloseFinishedTabsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronPuppeteerCloseFinishedTabsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checks the health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronPuppeteerHealthCheckGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronPuppeteerHealthCheckGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} [limit] 
         * @param {boolean} [dryRun] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSendRemindersAximaPost(limit?: number, dryRun?: boolean, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronSendRemindersAximaPost(limit, dryRun, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {APIXdentControllersCronCronControllerPhoneDto} [aPIXdentControllersCronCronControllerPhoneDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSendTestSmsToNonExistingNumberPost(idXdentUser?: string, aPIXdentControllersCronCronControllerPhoneDto?: APIXdentControllersCronCronControllerPhoneDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiCronSendTestSmsToNonExistingNumberPost(idXdentUser, aPIXdentControllersCronCronControllerPhoneDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets the refresh token bearer identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSetRefreshTokenBearerIdPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronSetRefreshTokenBearerIdPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns generalized DTO about our crons as dynamic json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSmsAnswersTrackingGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronSmsAnswersTrackingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Syncs labino laboratories to xdent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSyncLabinoLaboratoriesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronSyncLabinoLaboratoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Syncs labino lab requests to xdent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSyncLabinoLaboratoryRequestsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronSyncLabinoLaboratoryRequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetches table data from Labino and saves them to xdt DB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronSyncLabinoTablesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronSyncLabinoTablesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlocks Labino for XDENT companies that are invoicePartners in Labino
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCronUnlockLabinoCronGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiCronUnlockLabinoCronGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CronApi - object-oriented interface
 * @export
 * @class CronApi
 * @extends {BaseAPI}
 */
export class CronApi extends BaseAPI {
    /**
     * 
     * @summary Moves sms core logs to archive table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronArchiveSmsCoreLogsPost(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronArchiveSmsCoreLogsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronAutoConfirmFormRequestsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronAutoConfirmFormRequestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Runs cron to check NCZI requests statuses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronCheckNCZIRequestsStatusGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronCheckNCZIRequestsStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Processes Appointment Requests  For now it runs generation and ProcessFormSendRequests right after.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronCreateFormSendRequestsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronCreateFormSendRequestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns generalized DTO about our crons as dynamic json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronCronStatusGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronCronStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronEpodaniPollAcknowledgedEpodaniPost(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronEpodaniPollAcknowledgedEpodaniPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronEpodaniSendSignedEpodaniPost(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronEpodaniSendSignedEpodaniPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetches local certificate from Windows Cert Store for SK XDENT Service app and saves it in DB.
     * @param {string} [subject] 
     * @param {ApiCronFetchLocalCertificateGetLocationEnum} [location] 1 - CurrentUser, 2 - LocalMachine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronFetchLocalCertificateGet(subject?: string, location?: ApiCronFetchLocalCertificateGetLocationEnum, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronFetchLocalCertificateGet(subject, location, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates Admin Global Stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronGenerateAdminGlobalStatsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronGenerateAdminGlobalStatsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates analytics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronGenerateAnalyticsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronGenerateAnalyticsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates all types of UserTodoActions for iKlient
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronGenerateUserTodoActionsPost(days?: number, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronGenerateUserTodoActionsPost(days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronGetAximaAnswersTestGet(idXdentUser?: string, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronGetAximaAnswersTestGet(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets data from Woocommerce API and saves it to our database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronGetXdentShopDataGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronGetXdentShopDataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert reminderAfter to ReminderEmail table and send today remindersAfter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronInsertAndSendReminderAfterGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronInsertAndSendReminderAfterGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invalidates all refresh tokens for all expired companies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronInvalidateRefreshTokenForExpiredCompaniesGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronInvalidateRefreshTokenForExpiredCompaniesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log Timeouts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronLogTimeoutsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronLogTimeoutsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notification cron table population,.. auth for security reasons here.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronNotificationPopulateGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronNotificationPopulateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends all notifications..
     * @param {boolean} [returnAfterDbQuery] 
     * @param {boolean} [returnAfterQueryDeviceEval] 
     * @param {boolean} [returnAfterSent] 
     * @param {boolean} [returnBeforeConfirmed] 
     * @param {boolean} [returnAfterConfirmed] 
     * @param {boolean} [sendToFirebase] 
     * @param {string} [idCompany] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronPendingNotificationsSendGet(returnAfterDbQuery?: boolean, returnAfterQueryDeviceEval?: boolean, returnAfterSent?: boolean, returnBeforeConfirmed?: boolean, returnAfterConfirmed?: boolean, sendToFirebase?: boolean, idCompany?: string, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronPendingNotificationsSendGet(returnAfterDbQuery, returnAfterQueryDeviceEval, returnAfterSent, returnBeforeConfirmed, returnAfterConfirmed, sendToFirebase, idCompany, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Processes Appointment Requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessAppointmentRequestsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessAppointmentRequestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets if emails have been delivered and when by budget
     * @param {ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
     * @param {number} [budget] Number of emails to process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessEmailStatesByBudgetGet(emailType?: ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum, budget?: number, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessEmailStatesByBudgetGet(emailType, budget, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets if emails have been delivered and when by date range (includes time)
     * @param {ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
     * @param {Date} [dateFrom] Datetime from which emails should be processed
     * @param {Date} [dateTo] Datetime to which emails should be processed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessEmailStatesByDateRangeGet(emailType?: ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum, dateFrom?: Date, dateTo?: Date, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessEmailStatesByDateRangeGet(emailType, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets if emails have been delivered and when by days (and or) hours retroactively
     * @param {ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
     * @param {number} [days] Number of days
     * @param {number} [hours] Number of hours
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessEmailStatesByDaysRetroactivelyGet(emailType?: ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum, days?: number, hours?: number, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessEmailStatesByDaysRetroactivelyGet(emailType, days, hours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets if emails have been delivered and when today (00:00:00 - 23:59:59)
     * @param {ApiCronProcessEmailStatesTodayGetEmailTypeEnum} [emailType] Type of email to process (or ALL)              0 - INVOICE,              1 - RECOMMENDATION,              2 - RECOMMENDATION_CONFIRM,              3 - RECOMMENDATION_NEW_CLIENT,              4 - FILE,              5 - APPOINTMENT_REMINDER,              6 - EQUIPMENT_REMINDER,              7 - OWNER_REGISTER,              8 - BUG_REPORT,              9 - ACTIVATION_REQUEST,              10 - LEASING,              11 - LEGAL,              12 - ACCOUNT_ACTIVATE,              13 - TEST,              14 - UNKNOWN,              15 - ALL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessEmailStatesTodayGet(emailType?: ApiCronProcessEmailStatesTodayGetEmailTypeEnum, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessEmailStatesTodayGet(emailType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Runs payment gateway cron on awaiting (almost finished) payments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessFinishedGatewayPaymentsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessFinishedGatewayPaymentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Processes and sends generated FormSendRequests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessFormSendRequestsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessFormSendRequestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Runs payment gateway cron on processing payment requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessGatewayPaymentsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessGatewayPaymentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessLabRequestFormResultFilesGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessLabRequestFormResultFilesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Processes Laboratory validities - setne aktivní platnost laborkám, kterým v nový den vzešla platnost v platnost a přemapuje fráze a marka na nové kódy platnosti
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessLaboratoryValiditiesGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessLaboratoryValiditiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Selects all emails from SentEmails table that do not have postmark status or are pending, fetches their status and updates SentEmails.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronProcessSentEmailStatesGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronProcessSentEmailStatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Propagates only WP XDT Banners to XDT DB
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronPropagateShopBannersGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronPropagateShopBannersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Propagates only WC XDT Orders to XDT DB
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronPropagateShopOrdersGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronPropagateShopOrdersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Propagates only WP XDT Posts to XDT DB
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronPropagateShopPostsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronPropagateShopPostsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checks the health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronPuppeteerCloseFinishedTabsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronPuppeteerCloseFinishedTabsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checks the health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronPuppeteerHealthCheckGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronPuppeteerHealthCheckGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {number} [limit] 
     * @param {boolean} [dryRun] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronSendRemindersAximaPost(limit?: number, dryRun?: boolean, idXdentUser?: string, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronSendRemindersAximaPost(limit, dryRun, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idXdentUser] 
     * @param {APIXdentControllersCronCronControllerPhoneDto} [aPIXdentControllersCronCronControllerPhoneDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronSendTestSmsToNonExistingNumberPost(idXdentUser?: string, aPIXdentControllersCronCronControllerPhoneDto?: APIXdentControllersCronCronControllerPhoneDto, options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronSendTestSmsToNonExistingNumberPost(idXdentUser, aPIXdentControllersCronCronControllerPhoneDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets the refresh token bearer identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronSetRefreshTokenBearerIdPost(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronSetRefreshTokenBearerIdPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns generalized DTO about our crons as dynamic json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronSmsAnswersTrackingGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronSmsAnswersTrackingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Syncs labino laboratories to xdent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronSyncLabinoLaboratoriesGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronSyncLabinoLaboratoriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Syncs labino lab requests to xdent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronSyncLabinoLaboratoryRequestsGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronSyncLabinoLaboratoryRequestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetches table data from Labino and saves them to xdt DB
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronSyncLabinoTablesGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronSyncLabinoTablesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlocks Labino for XDENT companies that are invoicePartners in Labino
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    public apiCronUnlockLabinoCronGet(options?: AxiosRequestConfig) {
        return CronApiFp(this.configuration).apiCronUnlockLabinoCronGet(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiCronFetchLocalCertificateGetLocationEnum = {
    CurrentUser: 'CurrentUser',
    LocalMachine: 'LocalMachine'
} as const;
export type ApiCronFetchLocalCertificateGetLocationEnum = typeof ApiCronFetchLocalCertificateGetLocationEnum[keyof typeof ApiCronFetchLocalCertificateGetLocationEnum];
/**
 * @export
 */
export const ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum = {
    Invoice: 'INVOICE',
    File: 'FILE',
    AppointmentReminder: 'APPOINTMENT_REMINDER',
    EquipmentReminder: 'EQUIPMENT_REMINDER',
    OwnerRegister: 'OWNER_REGISTER',
    ActivationRequest: 'ACTIVATION_REQUEST',
    AccountActivate: 'ACCOUNT_ACTIVATE',
    Test: 'TEST',
    BookingConfirmPayment: 'BOOKING_CONFIRM_PAYMENT',
    FormFillRequest: 'FORM_FILL_REQUEST',
    ClientAppointmentsUpcoming: 'CLIENT_APPOINTMENTS_UPCOMING',
    DhChart: 'DH_CHART',
    AppointmentReminderAfter: 'APPOINTMENT_REMINDER_AFTER',
    PasswordChange: 'PASSWORD_CHANGE',
    LabResults: 'LAB_RESULTS',
    Unknown: 'UNKNOWN',
    All: 'ALL'
} as const;
export type ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum = typeof ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum[keyof typeof ApiCronProcessEmailStatesByBudgetGetEmailTypeEnum];
/**
 * @export
 */
export const ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum = {
    Invoice: 'INVOICE',
    File: 'FILE',
    AppointmentReminder: 'APPOINTMENT_REMINDER',
    EquipmentReminder: 'EQUIPMENT_REMINDER',
    OwnerRegister: 'OWNER_REGISTER',
    ActivationRequest: 'ACTIVATION_REQUEST',
    AccountActivate: 'ACCOUNT_ACTIVATE',
    Test: 'TEST',
    BookingConfirmPayment: 'BOOKING_CONFIRM_PAYMENT',
    FormFillRequest: 'FORM_FILL_REQUEST',
    ClientAppointmentsUpcoming: 'CLIENT_APPOINTMENTS_UPCOMING',
    DhChart: 'DH_CHART',
    AppointmentReminderAfter: 'APPOINTMENT_REMINDER_AFTER',
    PasswordChange: 'PASSWORD_CHANGE',
    LabResults: 'LAB_RESULTS',
    Unknown: 'UNKNOWN',
    All: 'ALL'
} as const;
export type ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum = typeof ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum[keyof typeof ApiCronProcessEmailStatesByDateRangeGetEmailTypeEnum];
/**
 * @export
 */
export const ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum = {
    Invoice: 'INVOICE',
    File: 'FILE',
    AppointmentReminder: 'APPOINTMENT_REMINDER',
    EquipmentReminder: 'EQUIPMENT_REMINDER',
    OwnerRegister: 'OWNER_REGISTER',
    ActivationRequest: 'ACTIVATION_REQUEST',
    AccountActivate: 'ACCOUNT_ACTIVATE',
    Test: 'TEST',
    BookingConfirmPayment: 'BOOKING_CONFIRM_PAYMENT',
    FormFillRequest: 'FORM_FILL_REQUEST',
    ClientAppointmentsUpcoming: 'CLIENT_APPOINTMENTS_UPCOMING',
    DhChart: 'DH_CHART',
    AppointmentReminderAfter: 'APPOINTMENT_REMINDER_AFTER',
    PasswordChange: 'PASSWORD_CHANGE',
    LabResults: 'LAB_RESULTS',
    Unknown: 'UNKNOWN',
    All: 'ALL'
} as const;
export type ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum = typeof ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum[keyof typeof ApiCronProcessEmailStatesByDaysRetroactivelyGetEmailTypeEnum];
/**
 * @export
 */
export const ApiCronProcessEmailStatesTodayGetEmailTypeEnum = {
    Invoice: 'INVOICE',
    File: 'FILE',
    AppointmentReminder: 'APPOINTMENT_REMINDER',
    EquipmentReminder: 'EQUIPMENT_REMINDER',
    OwnerRegister: 'OWNER_REGISTER',
    ActivationRequest: 'ACTIVATION_REQUEST',
    AccountActivate: 'ACCOUNT_ACTIVATE',
    Test: 'TEST',
    BookingConfirmPayment: 'BOOKING_CONFIRM_PAYMENT',
    FormFillRequest: 'FORM_FILL_REQUEST',
    ClientAppointmentsUpcoming: 'CLIENT_APPOINTMENTS_UPCOMING',
    DhChart: 'DH_CHART',
    AppointmentReminderAfter: 'APPOINTMENT_REMINDER_AFTER',
    PasswordChange: 'PASSWORD_CHANGE',
    LabResults: 'LAB_RESULTS',
    Unknown: 'UNKNOWN',
    All: 'ALL'
} as const;
export type ApiCronProcessEmailStatesTodayGetEmailTypeEnum = typeof ApiCronProcessEmailStatesTodayGetEmailTypeEnum[keyof typeof ApiCronProcessEmailStatesTodayGetEmailTypeEnum];


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Uploads a certificate to database for later use.
         * @param {string} [code] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCertificateVaultUploadCertificatePost: async (code?: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CertificateVault/UploadCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes the answer confirmation.
         * @param {string} [answerId] The answer identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardChangeAnswerConfirmationPost: async (answerId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/ChangeAnswerConfirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (answerId !== undefined) {
                localVarQueryParameter['answerId'] = answerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirms all sms answers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardConfirmAllAnswersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/ConfirmAllAnswers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirms form request, in case of regFrom, creates new client, gallery etc..
         * @param {string} [idFormRequest] 
         * @param {boolean} [confirm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardConfirmOrRejectFormRequestGet: async (idFormRequest?: string, confirm?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/ConfirmOrRejectFormRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFormRequest !== undefined) {
                localVarQueryParameter['idFormRequest'] = idFormRequest;
            }

            if (confirm !== undefined) {
                localVarQueryParameter['confirm'] = confirm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return company summary stats. (Primarily pending notifications etc...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardGetCompanyStatsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/GetCompanyStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns xdent dashboard summary data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardGetDashboardGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/GetDashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets notification center data, (list of generalised notifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardGetNotificationCenterGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/GetNotificationCenter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates mock data for dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardRefreshMockDataPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/RefreshMockData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allows to delete dashboard note by id
         * @param {string} [idNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardNotesDeleteDelete: async (idNote?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/DashboardNotesDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idNote !== undefined) {
                localVarQueryParameter['idNote'] = idNote;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allow to create or update dashboard note.
         * @param {APISharedDashboardNotesInsertUpdateDTO} [aPISharedDashboardNotesInsertUpdateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardNotesInsertUpdatePost: async (aPISharedDashboardNotesInsertUpdateDTO?: APISharedDashboardNotesInsertUpdateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/DashboardNotesInsertUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedDashboardNotesInsertUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns data for dashboard notes widget
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {boolean} [isComplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardNotesListGet: async (offset?: number, limit?: number, isComplete?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/DashboardNotesList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (isComplete !== undefined) {
                localVarQueryParameter['isComplete'] = isComplete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary NOT TO BE USED ON MOBILE NOW - Returns data for widget layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardWidgetsLayoutGetGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/DashboardWidgetsLayoutGet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary NOT TO BE USED ON MOBILE NOW - Saves widget layout
         * @param {Array<APISharedWidgetDTO>} [aPISharedWidgetDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardWidgetsLayoutSavePost: async (aPISharedWidgetDTO?: Array<APISharedWidgetDTO>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/DashboardWidgetsLayoutSave`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedWidgetDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns data for Calls widget
         * @param {string} [callType] 
         * @param {string} [callDateStart] 
         * @param {string} [callDateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetCallOverviewGet: async (callType?: string, callDateStart?: string, callDateFinish?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetCallOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (callType !== undefined) {
                localVarQueryParameter['callType'] = callType;
            }

            if (callDateStart !== undefined) {
                localVarQueryParameter['callDateStart'] = callDateStart;
            }

            if (callDateFinish !== undefined) {
                localVarQueryParameter['callDateFinish'] = callDateFinish;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Web version of XDENT calls it with statusCode as \"PENDING\" and includeDocumentFile as false - every other parameter is passed as NULL.
         * @summary Returns data for Forms widget
         * @param {string} [idRequest] 
         * @param {string} [statusCode] 
         * @param {string} [formTypeCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetFormRequestsGet: async (idRequest?: string, statusCode?: string, formTypeCode?: string, includeDocumentFile?: boolean, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetFormRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idRequest !== undefined) {
                localVarQueryParameter['idRequest'] = idRequest;
            }

            if (statusCode !== undefined) {
                localVarQueryParameter['statusCode'] = statusCode;
            }

            if (formTypeCode !== undefined) {
                localVarQueryParameter['formTypeCode'] = formTypeCode;
            }

            if (includeDocumentFile !== undefined) {
                localVarQueryParameter['includeDocumentFile'] = includeDocumentFile;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns data for income per day widget
         * @param {Date} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetIncomePerDayGet: async (date?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetIncomePerDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns data for laboratory label widget
         * @param {Date} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetLaboratoryLabelListGet: async (date?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetLaboratoryLabelList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets notification center data, (list of individually strongly typed notifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetNotificationCenterGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/V2/GetNotificationCenter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns PDF file by request ID
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetPdfByRequestIdGet: async (idRequest?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetPdfByRequestId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idRequest !== undefined) {
                localVarQueryParameter['idRequest'] = idRequest;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns data for reservations widget
         * @param {Date} [date] 
         * @param {boolean} [online] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetReservationsPerDayGet: async (date?: Date, online?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetReservationsPerDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (online !== undefined) {
                localVarQueryParameter['online'] = online;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns data for SMS widget
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Date} [dateDashboard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetSmsListDashboardGet: async (offset?: number, limit?: number, dateDashboard?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetSmsListDashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (dateDashboard !== undefined) {
                localVarQueryParameter['dateDashboard'] = (dateDashboard as any instanceof Date) ?
                    (dateDashboard as any).toISOString() :
                    dateDashboard;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns data for store transactions widget
         * @param {Date} [date] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetStoreTransactionsPerDayGet: async (date?: Date, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetStoreTransactionsPerDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns data for Tasks widget
         * @param {boolean} [active] 
         * @param {number} [offset] 
         * @param {number} [rowsToFetch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetTasksGet: async (active?: boolean, offset?: number, rowsToFetch?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/v2/GetTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (rowsToFetch !== undefined) {
                localVarQueryParameter['rowsToFetch'] = rowsToFetch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Uploads a certificate to database for later use.
         * @param {string} [code] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCertificateVaultUploadCertificatePost(code?: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCertificateVaultUploadCertificatePost(code, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiCertificateVaultUploadCertificatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Changes the answer confirmation.
         * @param {string} [answerId] The answer identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardChangeAnswerConfirmationPost(answerId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardChangeAnswerConfirmationPost(answerId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardChangeAnswerConfirmationPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Confirms all sms answers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardConfirmAllAnswersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardConfirmAllAnswersGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardConfirmAllAnswersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Confirms form request, in case of regFrom, creates new client, gallery etc..
         * @param {string} [idFormRequest] 
         * @param {boolean} [confirm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardConfirmOrRejectFormRequestGet(idFormRequest?: string, confirm?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardConfirmOrRejectFormRequestGet(idFormRequest, confirm, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardConfirmOrRejectFormRequestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return company summary stats. (Primarily pending notifications etc...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardGetCompanyStatsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardGetCompanyStatsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardGetCompanyStatsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns xdent dashboard summary data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardGetDashboardGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDashobardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardGetDashboardGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardGetDashboardGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets notification center data, (list of generalised notifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardGetNotificationCenterGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedUnifiedNotification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardGetNotificationCenterGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardGetNotificationCenterGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates mock data for dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardRefreshMockDataPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardRefreshMockDataPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardRefreshMockDataPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Allows to delete dashboard note by id
         * @param {string} [idNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2DashboardNotesDeleteDelete(idNote?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2DashboardNotesDeleteDelete(idNote, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2DashboardNotesDeleteDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Allow to create or update dashboard note.
         * @param {APISharedDashboardNotesInsertUpdateDTO} [aPISharedDashboardNotesInsertUpdateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2DashboardNotesInsertUpdatePost(aPISharedDashboardNotesInsertUpdateDTO?: APISharedDashboardNotesInsertUpdateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2DashboardNotesInsertUpdatePost(aPISharedDashboardNotesInsertUpdateDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2DashboardNotesInsertUpdatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns data for dashboard notes widget
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {boolean} [isComplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2DashboardNotesListGet(offset?: number, limit?: number, isComplete?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedDashboardNotesListDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2DashboardNotesListGet(offset, limit, isComplete, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2DashboardNotesListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary NOT TO BE USED ON MOBILE NOW - Returns data for widget layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2DashboardWidgetsLayoutGetGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedWidgetLayoutMobileDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2DashboardWidgetsLayoutGetGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2DashboardWidgetsLayoutGetGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary NOT TO BE USED ON MOBILE NOW - Saves widget layout
         * @param {Array<APISharedWidgetDTO>} [aPISharedWidgetDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2DashboardWidgetsLayoutSavePost(aPISharedWidgetDTO?: Array<APISharedWidgetDTO>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2DashboardWidgetsLayoutSavePost(aPISharedWidgetDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2DashboardWidgetsLayoutSavePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns data for Calls widget
         * @param {string} [callType] 
         * @param {string} [callDateStart] 
         * @param {string} [callDateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetCallOverviewGet(callType?: string, callDateStart?: string, callDateFinish?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedCallEventDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetCallOverviewGet(callType, callDateStart, callDateFinish, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetCallOverviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Web version of XDENT calls it with statusCode as \"PENDING\" and includeDocumentFile as false - every other parameter is passed as NULL.
         * @summary Returns data for Forms widget
         * @param {string} [idRequest] 
         * @param {string} [statusCode] 
         * @param {string} [formTypeCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetFormRequestsGet(idRequest?: string, statusCode?: string, formTypeCode?: string, includeDocumentFile?: boolean, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetFormRequestsGet(idRequest, statusCode, formTypeCode, includeDocumentFile, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetFormRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns data for income per day widget
         * @param {Date} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetIncomePerDayGet(date?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetIncomePerDayGet(date, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetIncomePerDayGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns data for laboratory label widget
         * @param {Date} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetLaboratoryLabelListGet(date?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedGetLaboratoryLabelListDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetLaboratoryLabelListGet(date, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetLaboratoryLabelListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets notification center data, (list of individually strongly typed notifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetNotificationCenterGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTODashboardDashboardNotificationWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetNotificationCenterGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetNotificationCenterGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns PDF file by request ID
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetPdfByRequestIdGet(idRequest?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetPdfByRequestIdGet(idRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetPdfByRequestIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns data for reservations widget
         * @param {Date} [date] 
         * @param {boolean} [online] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetReservationsPerDayGet(date?: Date, online?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedGetReservationsPerDayDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetReservationsPerDayGet(date, online, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetReservationsPerDayGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns data for SMS widget
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Date} [dateDashboard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetSmsListDashboardGet(offset?: number, limit?: number, dateDashboard?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedSMSAnswersDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetSmsListDashboardGet(offset, limit, dateDashboard, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetSmsListDashboardGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns data for store transactions widget
         * @param {Date} [date] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetStoreTransactionsPerDayGet(date?: Date, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedGetStoreTransactionsPerDayDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetStoreTransactionsPerDayGet(date, lang, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetStoreTransactionsPerDayGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns data for Tasks widget
         * @param {boolean} [active] 
         * @param {number} [offset] 
         * @param {number} [rowsToFetch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardV2GetTasksGet(active?: boolean, offset?: number, rowsToFetch?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTODashboardV2TaskDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardV2GetTasksGet(active, offset, rowsToFetch, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.apiDashboardV2GetTasksGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Uploads a certificate to database for later use.
         * @param {string} [code] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCertificateVaultUploadCertificatePost(code?: string, file?: File, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiCertificateVaultUploadCertificatePost(code, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes the answer confirmation.
         * @param {string} [answerId] The answer identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardChangeAnswerConfirmationPost(answerId?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDashboardChangeAnswerConfirmationPost(answerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirms all sms answers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardConfirmAllAnswersGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDashboardConfirmAllAnswersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirms form request, in case of regFrom, creates new client, gallery etc..
         * @param {string} [idFormRequest] 
         * @param {boolean} [confirm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardConfirmOrRejectFormRequestGet(idFormRequest?: string, confirm?: boolean, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDashboardConfirmOrRejectFormRequestGet(idFormRequest, confirm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return company summary stats. (Primarily pending notifications etc...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardGetCompanyStatsGet(options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCOMPANYSTATSResult> {
            return localVarFp.apiDashboardGetCompanyStatsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns xdent dashboard summary data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardGetDashboardGet(options?: any): AxiosPromise<APISharedDashobardDto> {
            return localVarFp.apiDashboardGetDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets notification center data, (list of generalised notifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardGetNotificationCenterGet(options?: any): AxiosPromise<Array<APISharedUnifiedNotification>> {
            return localVarFp.apiDashboardGetNotificationCenterGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates mock data for dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardRefreshMockDataPost(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDashboardRefreshMockDataPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allows to delete dashboard note by id
         * @param {string} [idNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardNotesDeleteDelete(idNote?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDashboardV2DashboardNotesDeleteDelete(idNote, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allow to create or update dashboard note.
         * @param {APISharedDashboardNotesInsertUpdateDTO} [aPISharedDashboardNotesInsertUpdateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardNotesInsertUpdatePost(aPISharedDashboardNotesInsertUpdateDTO?: APISharedDashboardNotesInsertUpdateDTO, options?: any): AxiosPromise<string> {
            return localVarFp.apiDashboardV2DashboardNotesInsertUpdatePost(aPISharedDashboardNotesInsertUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns data for dashboard notes widget
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {boolean} [isComplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardNotesListGet(offset?: number, limit?: number, isComplete?: boolean, options?: any): AxiosPromise<Array<APISharedDashboardNotesListDTO>> {
            return localVarFp.apiDashboardV2DashboardNotesListGet(offset, limit, isComplete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary NOT TO BE USED ON MOBILE NOW - Returns data for widget layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardWidgetsLayoutGetGet(options?: any): AxiosPromise<Array<APISharedWidgetLayoutMobileDto>> {
            return localVarFp.apiDashboardV2DashboardWidgetsLayoutGetGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary NOT TO BE USED ON MOBILE NOW - Saves widget layout
         * @param {Array<APISharedWidgetDTO>} [aPISharedWidgetDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2DashboardWidgetsLayoutSavePost(aPISharedWidgetDTO?: Array<APISharedWidgetDTO>, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDashboardV2DashboardWidgetsLayoutSavePost(aPISharedWidgetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns data for Calls widget
         * @param {string} [callType] 
         * @param {string} [callDateStart] 
         * @param {string} [callDateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetCallOverviewGet(callType?: string, callDateStart?: string, callDateFinish?: string, options?: any): AxiosPromise<Array<APISharedCallEventDTO>> {
            return localVarFp.apiDashboardV2GetCallOverviewGet(callType, callDateStart, callDateFinish, options).then((request) => request(axios, basePath));
        },
        /**
         * Web version of XDENT calls it with statusCode as \"PENDING\" and includeDocumentFile as false - every other parameter is passed as NULL.
         * @summary Returns data for Forms widget
         * @param {string} [idRequest] 
         * @param {string} [statusCode] 
         * @param {string} [formTypeCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetFormRequestsGet(idRequest?: string, statusCode?: string, formTypeCode?: string, includeDocumentFile?: boolean, idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult>> {
            return localVarFp.apiDashboardV2GetFormRequestsGet(idRequest, statusCode, formTypeCode, includeDocumentFile, idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns data for income per day widget
         * @param {Date} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetIncomePerDayGet(date?: Date, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDASHBOARDINCOMEPERDAYGRIDResult>> {
            return localVarFp.apiDashboardV2GetIncomePerDayGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns data for laboratory label widget
         * @param {Date} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetLaboratoryLabelListGet(date?: Date, options?: any): AxiosPromise<Array<APISharedGetLaboratoryLabelListDTO>> {
            return localVarFp.apiDashboardV2GetLaboratoryLabelListGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets notification center data, (list of individually strongly typed notifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetNotificationCenterGet(options?: any): AxiosPromise<APIXdentDTODashboardDashboardNotificationWrapper> {
            return localVarFp.apiDashboardV2GetNotificationCenterGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns PDF file by request ID
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetPdfByRequestIdGet(idRequest?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiDashboardV2GetPdfByRequestIdGet(idRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns data for reservations widget
         * @param {Date} [date] 
         * @param {boolean} [online] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetReservationsPerDayGet(date?: Date, online?: boolean, options?: any): AxiosPromise<Array<APISharedGetReservationsPerDayDTO>> {
            return localVarFp.apiDashboardV2GetReservationsPerDayGet(date, online, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns data for SMS widget
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {Date} [dateDashboard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetSmsListDashboardGet(offset?: number, limit?: number, dateDashboard?: Date, options?: any): AxiosPromise<Array<APISharedSMSAnswersDTO>> {
            return localVarFp.apiDashboardV2GetSmsListDashboardGet(offset, limit, dateDashboard, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns data for store transactions widget
         * @param {Date} [date] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetStoreTransactionsPerDayGet(date?: Date, lang?: string, options?: any): AxiosPromise<Array<APISharedGetStoreTransactionsPerDayDTO>> {
            return localVarFp.apiDashboardV2GetStoreTransactionsPerDayGet(date, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns data for Tasks widget
         * @param {boolean} [active] 
         * @param {number} [offset] 
         * @param {number} [rowsToFetch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardV2GetTasksGet(active?: boolean, offset?: number, rowsToFetch?: number, options?: any): AxiosPromise<Array<APIXdentDTODashboardV2TaskDto>> {
            return localVarFp.apiDashboardV2GetTasksGet(active, offset, rowsToFetch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @summary Uploads a certificate to database for later use.
     * @param {string} [code] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiCertificateVaultUploadCertificatePost(code?: string, file?: File, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiCertificateVaultUploadCertificatePost(code, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes the answer confirmation.
     * @param {string} [answerId] The answer identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardChangeAnswerConfirmationPost(answerId?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardChangeAnswerConfirmationPost(answerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirms all sms answers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardConfirmAllAnswersGet(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardConfirmAllAnswersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirms form request, in case of regFrom, creates new client, gallery etc..
     * @param {string} [idFormRequest] 
     * @param {boolean} [confirm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardConfirmOrRejectFormRequestGet(idFormRequest?: string, confirm?: boolean, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardConfirmOrRejectFormRequestGet(idFormRequest, confirm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return company summary stats. (Primarily pending notifications etc...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardGetCompanyStatsGet(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardGetCompanyStatsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns xdent dashboard summary data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardGetDashboardGet(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardGetDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets notification center data, (list of generalised notifications)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardGetNotificationCenterGet(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardGetNotificationCenterGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates mock data for dashboard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardRefreshMockDataPost(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardRefreshMockDataPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allows to delete dashboard note by id
     * @param {string} [idNote] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2DashboardNotesDeleteDelete(idNote?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2DashboardNotesDeleteDelete(idNote, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allow to create or update dashboard note.
     * @param {APISharedDashboardNotesInsertUpdateDTO} [aPISharedDashboardNotesInsertUpdateDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2DashboardNotesInsertUpdatePost(aPISharedDashboardNotesInsertUpdateDTO?: APISharedDashboardNotesInsertUpdateDTO, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2DashboardNotesInsertUpdatePost(aPISharedDashboardNotesInsertUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns data for dashboard notes widget
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {boolean} [isComplete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2DashboardNotesListGet(offset?: number, limit?: number, isComplete?: boolean, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2DashboardNotesListGet(offset, limit, isComplete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary NOT TO BE USED ON MOBILE NOW - Returns data for widget layout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2DashboardWidgetsLayoutGetGet(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2DashboardWidgetsLayoutGetGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary NOT TO BE USED ON MOBILE NOW - Saves widget layout
     * @param {Array<APISharedWidgetDTO>} [aPISharedWidgetDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2DashboardWidgetsLayoutSavePost(aPISharedWidgetDTO?: Array<APISharedWidgetDTO>, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2DashboardWidgetsLayoutSavePost(aPISharedWidgetDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns data for Calls widget
     * @param {string} [callType] 
     * @param {string} [callDateStart] 
     * @param {string} [callDateFinish] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetCallOverviewGet(callType?: string, callDateStart?: string, callDateFinish?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetCallOverviewGet(callType, callDateStart, callDateFinish, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Web version of XDENT calls it with statusCode as \"PENDING\" and includeDocumentFile as false - every other parameter is passed as NULL.
     * @summary Returns data for Forms widget
     * @param {string} [idRequest] 
     * @param {string} [statusCode] 
     * @param {string} [formTypeCode] 
     * @param {boolean} [includeDocumentFile] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetFormRequestsGet(idRequest?: string, statusCode?: string, formTypeCode?: string, includeDocumentFile?: boolean, idClient?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetFormRequestsGet(idRequest, statusCode, formTypeCode, includeDocumentFile, idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns data for income per day widget
     * @param {Date} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetIncomePerDayGet(date?: Date, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetIncomePerDayGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns data for laboratory label widget
     * @param {Date} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetLaboratoryLabelListGet(date?: Date, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetLaboratoryLabelListGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets notification center data, (list of individually strongly typed notifications)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetNotificationCenterGet(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetNotificationCenterGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns PDF file by request ID
     * @param {string} [idRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetPdfByRequestIdGet(idRequest?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetPdfByRequestIdGet(idRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns data for reservations widget
     * @param {Date} [date] 
     * @param {boolean} [online] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetReservationsPerDayGet(date?: Date, online?: boolean, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetReservationsPerDayGet(date, online, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns data for SMS widget
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Date} [dateDashboard] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetSmsListDashboardGet(offset?: number, limit?: number, dateDashboard?: Date, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetSmsListDashboardGet(offset, limit, dateDashboard, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns data for store transactions widget
     * @param {Date} [date] 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetStoreTransactionsPerDayGet(date?: Date, lang?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetStoreTransactionsPerDayGet(date, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns data for Tasks widget
     * @param {boolean} [active] 
     * @param {number} [offset] 
     * @param {number} [rowsToFetch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiDashboardV2GetTasksGet(active?: boolean, offset?: number, rowsToFetch?: number, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiDashboardV2GetTasksGet(active, offset, rowsToFetch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DatabaseTableSyncApi - axios parameter creator
 * @export
 */
export const DatabaseTableSyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabaseTableSyncCompareGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DatabaseTableSync/Compare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatabaseTableSyncApi - functional programming interface
 * @export
 */
export const DatabaseTableSyncApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatabaseTableSyncApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabaseTableSyncCompareGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabaseTableSyncCompareGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DatabaseTableSyncApi.apiDatabaseTableSyncCompareGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DatabaseTableSyncApi - factory interface
 * @export
 */
export const DatabaseTableSyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatabaseTableSyncApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabaseTableSyncCompareGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabaseTableSyncCompareGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatabaseTableSyncApi - object-oriented interface
 * @export
 * @class DatabaseTableSyncApi
 * @extends {BaseAPI}
 */
export class DatabaseTableSyncApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseTableSyncApi
     */
    public apiDatabaseTableSyncCompareGet(options?: AxiosRequestConfig) {
        return DatabaseTableSyncApiFp(this.configuration).apiDatabaseTableSyncCompareGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiValuesIdDelete', 'id', id)
            const localVarPath = `/api/Values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiValuesIdGet', 'id', id)
            const localVarPath = `/api/Values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesIdPut: async (id: number, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiValuesIdPut', 'id', id)
            const localVarPath = `/api/Values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesPost: async (body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValuesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValuesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.apiValuesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValuesIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValuesIdDelete(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.apiValuesIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValuesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValuesIdGet(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.apiValuesIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValuesIdPut(id: number, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValuesIdPut(id, body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.apiValuesIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValuesPost(body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValuesPost(body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.apiValuesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiValuesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiValuesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesIdGet(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.apiValuesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {number} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesIdPut(id: number, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiValuesIdPut(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValuesPost(body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiValuesPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiValuesGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiValuesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiValuesIdDelete(id: number, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiValuesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiValuesIdGet(id: number, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiValuesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {number} id 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiValuesIdPut(id: number, body?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiValuesIdPut(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiValuesPost(body?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiValuesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DentalApi - axios parameter creator
 * @export
 */
export const DentalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets dental categories by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalCategoryGetDentalCategoriesByClientGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DentalCategory/GetDentalCategoriesByClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates dental categories by idClient for owner user.
         * @param {ApiDentalCategoryUpdateClientDentalCategoriesPutRequest} [apiDentalCategoryUpdateClientDentalCategoriesPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalCategoryUpdateClientDentalCategoriesPut: async (apiDentalCategoryUpdateClientDentalCategoriesPutRequest?: ApiDentalCategoryUpdateClientDentalCategoriesPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DentalCategory/UpdateClientDentalCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDentalCategoryUpdateClientDentalCategoriesPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} [idMedicalReport] 
         * @param {ApiDentalDentalChartImageGetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalDentalChartImageGet: async (idMedicalReport?: string, type?: ApiDentalDentalChartImageGetTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/DentalChartImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalDhChartIndexesPdfGet: async (idMedicalReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/DhChartIndexesPdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets client dental chart as PDF and saves it to MR gallery
         * @param {string} [idMedicalReport] 
         * @param {boolean} [printNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalExportDHChartGet: async (idMedicalReport?: string, printNote?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/ExportDHChart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (printNote !== undefined) {
                localVarQueryParameter['printNote'] = printNote;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets client recommendation based on dh data from medical report
         * @param {string} [idMedicalReport] 
         * @param {boolean} [printNote] 
         * @param {ApiDentalGenerateDentalChartPdfGetExportTypeEnum} [exportType] 0 &#x3D; HTML, 1 &#x3D; PDF BYTES, 2 &#x3D; PDF FILE, 3 &#x3D; EXPORT TO MR GALLERY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGenerateDentalChartPdfGet: async (idMedicalReport?: string, printNote?: boolean, exportType?: ApiDentalGenerateDentalChartPdfGetExportTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/GenerateDentalChartPdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (printNote !== undefined) {
                localVarQueryParameter['printNote'] = printNote;
            }

            if (exportType !== undefined) {
                localVarQueryParameter['exportType'] = exportType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets dental chart by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetDentalChartClientDataGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/GetDentalChartClientData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets dental categories by idClient for owner user.
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetDentalChartGet: async (idMedicalReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/GetDentalChart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets perio dental chart history by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetDhHistoryGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/GetDhHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the peridontal chart indices value.
         * @param {APIXdentDTODentalGetPeridontalChartIndicesValueDataDto} [aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto] The model.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetPeridontalChartIndicesValuePost: async (aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto?: APIXdentDTODentalGetPeridontalChartIndicesValueDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/GetPeridontalChartIndicesValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets perio dental chart data by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetPeriodontalChartClientDataGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/GetPeriodontalChartClientData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historie dh krize. (po najeti v xdentu na history node se zobrazi pdf v iframe)
         * @param {Array<string>} [idReports] You can compare multiple med reports with each other - multiple dh charts
         * @param {Array<string>} [indexes] PI,BOP,API,BI,PBI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalIndexComparisonGet: async (idReports?: Array<string>, indexes?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/IndexComparison`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idReports) {
                localVarQueryParameter['idReports'] = idReports;
            }

            if (indexes) {
                localVarQueryParameter['indexes'] = indexes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview jednotliveho indexu dh krize ve forme image (png)
         * @param {string} [idMedicalReport] 
         * @param {Array<string>} [indexes] PI,BOP,API,BI,PBI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalIndexPreviewGet: async (idMedicalReport?: string, indexes?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/IndexPreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (indexes) {
                localVarQueryParameter['indexes'] = indexes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets dental chart by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalV2GetDentalChartClientDataGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dental/v2/GetDentalChartClientData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DentalApi - functional programming interface
 * @export
 */
export const DentalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DentalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets dental categories by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalCategoryGetDentalCategoriesByClientGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerClientDentalCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalCategoryGetDentalCategoriesByClientGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalCategoryGetDentalCategoriesByClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Updates dental categories by idClient for owner user.
         * @param {ApiDentalCategoryUpdateClientDentalCategoriesPutRequest} [apiDentalCategoryUpdateClientDentalCategoriesPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalCategoryUpdateClientDentalCategoriesPut(apiDentalCategoryUpdateClientDentalCategoriesPutRequest?: ApiDentalCategoryUpdateClientDentalCategoriesPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalCategoryUpdateClientDentalCategoriesPut(apiDentalCategoryUpdateClientDentalCategoriesPutRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalCategoryUpdateClientDentalCategoriesPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} [idMedicalReport] 
         * @param {ApiDentalDentalChartImageGetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalDentalChartImageGet(idMedicalReport?: string, type?: ApiDentalDentalChartImageGetTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalDentalChartImageGet(idMedicalReport, type, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalDentalChartImageGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalDhChartIndexesPdfGet(idMedicalReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalDhChartIndexesPdfGet(idMedicalReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalDhChartIndexesPdfGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets client dental chart as PDF and saves it to MR gallery
         * @param {string} [idMedicalReport] 
         * @param {boolean} [printNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalExportDHChartGet(idMedicalReport?: string, printNote?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalExportDHChartGet(idMedicalReport, printNote, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalExportDHChartGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets client recommendation based on dh data from medical report
         * @param {string} [idMedicalReport] 
         * @param {boolean} [printNote] 
         * @param {ApiDentalGenerateDentalChartPdfGetExportTypeEnum} [exportType] 0 &#x3D; HTML, 1 &#x3D; PDF BYTES, 2 &#x3D; PDF FILE, 3 &#x3D; EXPORT TO MR GALLERY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalGenerateDentalChartPdfGet(idMedicalReport?: string, printNote?: boolean, exportType?: ApiDentalGenerateDentalChartPdfGetExportTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalGenerateDentalChartPdfGet(idMedicalReport, printNote, exportType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalGenerateDentalChartPdfGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets dental chart by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalGetDentalChartClientDataGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTODentalDentalChartItemData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalGetDentalChartClientDataGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalGetDentalChartClientDataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets dental categories by idClient for owner user.
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalGetDentalChartGet(idMedicalReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerClientDentalCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalGetDentalChartGet(idMedicalReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalGetDentalChartGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets perio dental chart history by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalGetDhHistoryGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTODentalDhHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalGetDhHistoryGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalGetDhHistoryGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the peridontal chart indices value.
         * @param {APIXdentDTODentalGetPeridontalChartIndicesValueDataDto} [aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto] The model.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalGetPeridontalChartIndicesValuePost(aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto?: APIXdentDTODentalGetPeridontalChartIndicesValueDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTODentalGetPeridontalChartIndicesValueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalGetPeridontalChartIndicesValuePost(aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalGetPeridontalChartIndicesValuePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets perio dental chart data by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalGetPeriodontalChartClientDataGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTODentalPeriodontalChartItemData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalGetPeriodontalChartClientDataGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalGetPeriodontalChartClientDataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Historie dh krize. (po najeti v xdentu na history node se zobrazi pdf v iframe)
         * @param {Array<string>} [idReports] You can compare multiple med reports with each other - multiple dh charts
         * @param {Array<string>} [indexes] PI,BOP,API,BI,PBI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalIndexComparisonGet(idReports?: Array<string>, indexes?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalIndexComparisonGet(idReports, indexes, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalIndexComparisonGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Preview jednotliveho indexu dh krize ve forme image (png)
         * @param {string} [idMedicalReport] 
         * @param {Array<string>} [indexes] PI,BOP,API,BI,PBI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalIndexPreviewGet(idMedicalReport?: string, indexes?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalIndexPreviewGet(idMedicalReport, indexes, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalIndexPreviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets dental chart by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDentalV2GetDentalChartClientDataGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTODentalDentalChartItemData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDentalV2GetDentalChartClientDataGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DentalApi.apiDentalV2GetDentalChartClientDataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DentalApi - factory interface
 * @export
 */
export const DentalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DentalApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets dental categories by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalCategoryGetDentalCategoriesByClientGet(idClient?: string, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerClientDentalCategory>> {
            return localVarFp.apiDentalCategoryGetDentalCategoriesByClientGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates dental categories by idClient for owner user.
         * @param {ApiDentalCategoryUpdateClientDentalCategoriesPutRequest} [apiDentalCategoryUpdateClientDentalCategoriesPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalCategoryUpdateClientDentalCategoriesPut(apiDentalCategoryUpdateClientDentalCategoriesPutRequest?: ApiDentalCategoryUpdateClientDentalCategoriesPutRequest, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDentalCategoryUpdateClientDentalCategoriesPut(apiDentalCategoryUpdateClientDentalCategoriesPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} [idMedicalReport] 
         * @param {ApiDentalDentalChartImageGetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalDentalChartImageGet(idMedicalReport?: string, type?: ApiDentalDentalChartImageGetTypeEnum, options?: any): AxiosPromise<void> {
            return localVarFp.apiDentalDentalChartImageGet(idMedicalReport, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalDhChartIndexesPdfGet(idMedicalReport?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDentalDhChartIndexesPdfGet(idMedicalReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets client dental chart as PDF and saves it to MR gallery
         * @param {string} [idMedicalReport] 
         * @param {boolean} [printNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalExportDHChartGet(idMedicalReport?: string, printNote?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiDentalExportDHChartGet(idMedicalReport, printNote, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets client recommendation based on dh data from medical report
         * @param {string} [idMedicalReport] 
         * @param {boolean} [printNote] 
         * @param {ApiDentalGenerateDentalChartPdfGetExportTypeEnum} [exportType] 0 &#x3D; HTML, 1 &#x3D; PDF BYTES, 2 &#x3D; PDF FILE, 3 &#x3D; EXPORT TO MR GALLERY
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGenerateDentalChartPdfGet(idMedicalReport?: string, printNote?: boolean, exportType?: ApiDentalGenerateDentalChartPdfGetExportTypeEnum, options?: any): AxiosPromise<object> {
            return localVarFp.apiDentalGenerateDentalChartPdfGet(idMedicalReport, printNote, exportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets dental chart by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetDentalChartClientDataGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTODentalDentalChartItemData>> {
            return localVarFp.apiDentalGetDentalChartClientDataGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets dental categories by idClient for owner user.
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetDentalChartGet(idMedicalReport?: string, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerClientDentalCategory>> {
            return localVarFp.apiDentalGetDentalChartGet(idMedicalReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets perio dental chart history by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetDhHistoryGet(idClient?: string, options?: any): AxiosPromise<APIXdentDTODentalDhHistory> {
            return localVarFp.apiDentalGetDhHistoryGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the peridontal chart indices value.
         * @param {APIXdentDTODentalGetPeridontalChartIndicesValueDataDto} [aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto] The model.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetPeridontalChartIndicesValuePost(aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto?: APIXdentDTODentalGetPeridontalChartIndicesValueDataDto, options?: any): AxiosPromise<APIXdentDTODentalGetPeridontalChartIndicesValueResponseDto> {
            return localVarFp.apiDentalGetPeridontalChartIndicesValuePost(aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets perio dental chart data by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalGetPeriodontalChartClientDataGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTODentalPeriodontalChartItemData>> {
            return localVarFp.apiDentalGetPeriodontalChartClientDataGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historie dh krize. (po najeti v xdentu na history node se zobrazi pdf v iframe)
         * @param {Array<string>} [idReports] You can compare multiple med reports with each other - multiple dh charts
         * @param {Array<string>} [indexes] PI,BOP,API,BI,PBI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalIndexComparisonGet(idReports?: Array<string>, indexes?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiDentalIndexComparisonGet(idReports, indexes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview jednotliveho indexu dh krize ve forme image (png)
         * @param {string} [idMedicalReport] 
         * @param {Array<string>} [indexes] PI,BOP,API,BI,PBI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalIndexPreviewGet(idMedicalReport?: string, indexes?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiDentalIndexPreviewGet(idMedicalReport, indexes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets dental chart by idClient for owner user.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDentalV2GetDentalChartClientDataGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTODentalDentalChartItemData>> {
            return localVarFp.apiDentalV2GetDentalChartClientDataGet(idClient, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DentalApi - object-oriented interface
 * @export
 * @class DentalApi
 * @extends {BaseAPI}
 */
export class DentalApi extends BaseAPI {
    /**
     * 
     * @summary Gets dental categories by idClient for owner user.
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalCategoryGetDentalCategoriesByClientGet(idClient?: string, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalCategoryGetDentalCategoriesByClientGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates dental categories by idClient for owner user.
     * @param {ApiDentalCategoryUpdateClientDentalCategoriesPutRequest} [apiDentalCategoryUpdateClientDentalCategoriesPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalCategoryUpdateClientDentalCategoriesPut(apiDentalCategoryUpdateClientDentalCategoriesPutRequest?: ApiDentalCategoryUpdateClientDentalCategoriesPutRequest, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalCategoryUpdateClientDentalCategoriesPut(apiDentalCategoryUpdateClientDentalCategoriesPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} [idMedicalReport] 
     * @param {ApiDentalDentalChartImageGetTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalDentalChartImageGet(idMedicalReport?: string, type?: ApiDentalDentalChartImageGetTypeEnum, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalDentalChartImageGet(idMedicalReport, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalDhChartIndexesPdfGet(idMedicalReport?: string, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalDhChartIndexesPdfGet(idMedicalReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets client dental chart as PDF and saves it to MR gallery
     * @param {string} [idMedicalReport] 
     * @param {boolean} [printNote] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalExportDHChartGet(idMedicalReport?: string, printNote?: boolean, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalExportDHChartGet(idMedicalReport, printNote, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets client recommendation based on dh data from medical report
     * @param {string} [idMedicalReport] 
     * @param {boolean} [printNote] 
     * @param {ApiDentalGenerateDentalChartPdfGetExportTypeEnum} [exportType] 0 &#x3D; HTML, 1 &#x3D; PDF BYTES, 2 &#x3D; PDF FILE, 3 &#x3D; EXPORT TO MR GALLERY
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalGenerateDentalChartPdfGet(idMedicalReport?: string, printNote?: boolean, exportType?: ApiDentalGenerateDentalChartPdfGetExportTypeEnum, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalGenerateDentalChartPdfGet(idMedicalReport, printNote, exportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets dental chart by idClient for owner user.
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalGetDentalChartClientDataGet(idClient?: string, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalGetDentalChartClientDataGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets dental categories by idClient for owner user.
     * @param {string} [idMedicalReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalGetDentalChartGet(idMedicalReport?: string, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalGetDentalChartGet(idMedicalReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets perio dental chart history by idClient for owner user.
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalGetDhHistoryGet(idClient?: string, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalGetDhHistoryGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the peridontal chart indices value.
     * @param {APIXdentDTODentalGetPeridontalChartIndicesValueDataDto} [aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto] The model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalGetPeridontalChartIndicesValuePost(aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto?: APIXdentDTODentalGetPeridontalChartIndicesValueDataDto, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalGetPeridontalChartIndicesValuePost(aPIXdentDTODentalGetPeridontalChartIndicesValueDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets perio dental chart data by idClient for owner user.
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalGetPeriodontalChartClientDataGet(idClient?: string, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalGetPeriodontalChartClientDataGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historie dh krize. (po najeti v xdentu na history node se zobrazi pdf v iframe)
     * @param {Array<string>} [idReports] You can compare multiple med reports with each other - multiple dh charts
     * @param {Array<string>} [indexes] PI,BOP,API,BI,PBI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalIndexComparisonGet(idReports?: Array<string>, indexes?: Array<string>, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalIndexComparisonGet(idReports, indexes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview jednotliveho indexu dh krize ve forme image (png)
     * @param {string} [idMedicalReport] 
     * @param {Array<string>} [indexes] PI,BOP,API,BI,PBI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalIndexPreviewGet(idMedicalReport?: string, indexes?: Array<string>, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalIndexPreviewGet(idMedicalReport, indexes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets dental chart by idClient for owner user.
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DentalApi
     */
    public apiDentalV2GetDentalChartClientDataGet(idClient?: string, options?: AxiosRequestConfig) {
        return DentalApiFp(this.configuration).apiDentalV2GetDentalChartClientDataGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiDentalDentalChartImageGetTypeEnum = {
    Standard: 'STANDARD',
    Periodontal: 'PERIODONTAL'
} as const;
export type ApiDentalDentalChartImageGetTypeEnum = typeof ApiDentalDentalChartImageGetTypeEnum[keyof typeof ApiDentalDentalChartImageGetTypeEnum];
/**
 * @export
 */
export const ApiDentalGenerateDentalChartPdfGetExportTypeEnum = {
    Html: 'HTML',
    PdfBytes: 'PDF_BYTES',
    PdfFile: 'PDF_FILE',
    MrGallery: 'MR_GALLERY'
} as const;
export type ApiDentalGenerateDentalChartPdfGetExportTypeEnum = typeof ApiDentalGenerateDentalChartPdfGetExportTypeEnum[keyof typeof ApiDentalGenerateDentalChartPdfGetExportTypeEnum];


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sets users associated with document.
         * @param {string} [idDocument] 
         * @param {string} [idDocumentTemplate] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentAssociateUsersToDocumentPost: async (idDocument?: string, idDocumentTemplate?: string, requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/AssociateUsersToDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocument !== undefined) {
                localVarQueryParameter['idDocument'] = idDocument;
            }

            if (idDocumentTemplate !== undefined) {
                localVarQueryParameter['idDocumentTemplate'] = idDocumentTemplate;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Converts uploaded word to pdf
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentConvertWordToPdfPost: async (body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/ConvertWordToPdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates document copy.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateDocumentCopyPost: async (idDocument?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/CreateDocumentCopy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocument !== undefined) {
                localVarQueryParameter['idDocument'] = idDocument;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a document from document template localization
         * @param {APIXdentDTODocumentCreateDocumentFromTemplateDTO} [aPIXdentDTODocumentCreateDocumentFromTemplateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateDocumentFromTemplatePost: async (aPIXdentDTODocumentCreateDocumentFromTemplateDTO?: APIXdentDTODocumentCreateDocumentFromTemplateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/CreateDocumentFromTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTODocumentCreateDocumentFromTemplateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a document.
         * @param {APIXdentDTODocumentCreateDocumentDTO} [aPIXdentDTODocumentCreateDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateDocumentPost: async (aPIXdentDTODocumentCreateDocumentDTO?: APIXdentDTODocumentCreateDocumentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/CreateDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTODocumentCreateDocumentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a copy of a document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateDocumentTemplateCopyPost: async (idDocumentTemplate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/CreateDocumentTemplateCopy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentTemplate !== undefined) {
                localVarQueryParameter['idDocumentTemplate'] = idDocumentTemplate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DocumentPrintFormSettings IU
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateOrUpdateDocumentPrintFormSettingsPost: async (aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO?: APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/CreateOrUpdateDocumentPrintFormSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds or updates document template localization.
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateOrUpdateDocumentTemplateLocalizationPost: async (aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO?: APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/CreateOrUpdateDocumentTemplateLocalization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates or updates a document template.
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateOrUpdateDocumentTemplatePost: async (aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO?: APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/CreateOrUpdateDocumentTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDeleteDocumentTemplateDelete: async (idDocumentTemplate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/DeleteDocumentTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentTemplate !== undefined) {
                localVarQueryParameter['idDocumentTemplate'] = idDocumentTemplate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a document template localization
         * @param {string} [idDocumentTemplateLocalization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDeleteDocumentTemplateLocalizationDelete: async (idDocumentTemplateLocalization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/DeleteDocumentTemplateLocalization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentTemplateLocalization !== undefined) {
                localVarQueryParameter['idDocumentTemplateLocalization'] = idDocumentTemplateLocalization;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads document in openXML form
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDownloadDocumentGet: async (idDocument?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/DownloadDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocument !== undefined) {
                localVarQueryParameter['idDocument'] = idDocument;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all available document fields.
         * @param {string} [langCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetAllDocumentFieldsGet: async (langCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetAllDocumentFields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (langCode !== undefined) {
                localVarQueryParameter['langCode'] = langCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets users associated with document.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetAssociatedUsersToDocumentGet: async (idDocument?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetAssociatedUsersToDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocument !== undefined) {
                localVarQueryParameter['idDocument'] = idDocument;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets default print form settings content (internal usage)
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDefaultPrintFormSettingContentPost: async (body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDefaultPrintFormSettingContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets document by id.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentGet: async (idDocument?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocument !== undefined) {
                localVarQueryParameter['idDocument'] = idDocument;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets preview of document
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPreviewGet: async (idDocument?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentPreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocument !== undefined) {
                localVarQueryParameter['idDocument'] = idDocument;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets DocumentPrintFormSettings By location id
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPrintFormSettingsByLocationGet: async (idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentPrintFormSettingsByLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns DocumentPrintFormSettings
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPrintFormSettingsGet: async (idDocumentPrintFormSettings?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentPrintFormSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentPrintFormSettings !== undefined) {
                localVarQueryParameter['idDocumentPrintFormSettings'] = idDocumentPrintFormSettings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns company\'s DocumentPrintFormSettings
         * @param {boolean} [returnContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPrintFormSettingsGridGet: async (returnContent?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentPrintFormSettingsGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (returnContent !== undefined) {
                localVarQueryParameter['returnContent'] = returnContent;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets document template from db
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPrintFormSettingsTemplateGet: async (idDocumentPrintFormSettings?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentPrintFormSettingsTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentPrintFormSettings !== undefined) {
                localVarQueryParameter['idDocumentPrintFormSettings'] = idDocumentPrintFormSettings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a single document template by its ID.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplateGet: async (idDocumentTemplate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentTemplate !== undefined) {
                localVarQueryParameter['idDocumentTemplate'] = idDocumentTemplate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list or specified document template localization
         * @param {string} idDocumentTemplateLocalization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet: async (idDocumentTemplateLocalization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocumentTemplateLocalization' is not null or undefined
            assertParamExists('apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet', 'idDocumentTemplateLocalization', idDocumentTemplateLocalization)
            const localVarPath = `/api/Document/GetDocumentTemplateLocalization/{idDocumentTemplateLocalization}`
                .replace(`{${"idDocumentTemplateLocalization"}}`, encodeURIComponent(String(idDocumentTemplateLocalization)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets preview of document localization
         * @param {string} [idDocumentTemplateLocalization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplateLocalizationPreviewGet: async (idDocumentTemplateLocalization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentTemplateLocalizationPreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentTemplateLocalization !== undefined) {
                localVarQueryParameter['idDocumentTemplateLocalization'] = idDocumentTemplateLocalization;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets preview of document localization by template and language
         * @param {string} [idDocumentTemplate] 
         * @param {string} [idLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplatePreviewGet: async (idDocumentTemplate?: string, idLanguage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentTemplatePreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentTemplate !== undefined) {
                localVarQueryParameter['idDocumentTemplate'] = idDocumentTemplate;
            }

            if (idLanguage !== undefined) {
                localVarQueryParameter['idLanguage'] = idLanguage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of document templates.
         * @param {boolean} [valid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplatesGet: async (valid?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentTemplates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (valid !== undefined) {
                localVarQueryParameter['valid'] = valid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets documents.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentsGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets placeholder map for document
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetPlaceholdersForDocumentGet: async (idDocument?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetPlaceholdersForDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocument !== undefined) {
                localVarQueryParameter['idDocument'] = idDocument;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Merges content from word file and applies headers/footers from template.
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentMergeTemplateAndContentPost: async (idDocumentPrintFormSettings?: string, document?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/MergeTemplateAndContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentPrintFormSettings !== undefined) {
                localVarQueryParameter['idDocumentPrintFormSettings'] = idDocumentPrintFormSettings;
            }


            if (document !== undefined) { 
                localVarFormParams.append('document', document as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replaces placeholders in template
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentReplacePlaceholdersInTemplatePost: async (idDocumentPrintFormSettings?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/ReplacePlaceholdersInTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentPrintFormSettings !== undefined) {
                localVarQueryParameter['idDocumentPrintFormSettings'] = idDocumentPrintFormSettings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restores a deleted document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRestoreDocumentTemplatePost: async (idDocumentTemplate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/RestoreDocumentTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocumentTemplate !== undefined) {
                localVarQueryParameter['idDocumentTemplate'] = idDocumentTemplate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a document to client\'s email
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentSendDocumentPost: async (idDocument?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/SendDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDocument !== undefined) {
                localVarQueryParameter['idDocument'] = idDocument;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a document.
         * @param {APIXdentDTODocumentUpdateDocumentDTO} [aPIXdentDTODocumentUpdateDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentUpdateDocumentPost: async (aPIXdentDTODocumentUpdateDocumentDTO?: APIXdentDTODocumentUpdateDocumentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/UpdateDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTODocumentUpdateDocumentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads Word Document Template
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentUploadWordTemplatePost: async (document?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/UploadWordTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (document !== undefined) { 
                localVarFormParams.append('document', document as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sets users associated with document.
         * @param {string} [idDocument] 
         * @param {string} [idDocumentTemplate] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentAssociateUsersToDocumentPost(idDocument?: string, idDocumentTemplate?: string, requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentAssociateUsersToDocumentPost(idDocument, idDocumentTemplate, requestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentAssociateUsersToDocumentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Converts uploaded word to pdf
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentConvertWordToPdfPost(body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentConvertWordToPdfPost(body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentConvertWordToPdfPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates document copy.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCreateDocumentCopyPost(idDocument?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCreateDocumentCopyPost(idDocument, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentCreateDocumentCopyPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a document from document template localization
         * @param {APIXdentDTODocumentCreateDocumentFromTemplateDTO} [aPIXdentDTODocumentCreateDocumentFromTemplateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCreateDocumentFromTemplatePost(aPIXdentDTODocumentCreateDocumentFromTemplateDTO?: APIXdentDTODocumentCreateDocumentFromTemplateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCreateDocumentFromTemplatePost(aPIXdentDTODocumentCreateDocumentFromTemplateDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentCreateDocumentFromTemplatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a document.
         * @param {APIXdentDTODocumentCreateDocumentDTO} [aPIXdentDTODocumentCreateDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCreateDocumentPost(aPIXdentDTODocumentCreateDocumentDTO?: APIXdentDTODocumentCreateDocumentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCreateDocumentPost(aPIXdentDTODocumentCreateDocumentDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentCreateDocumentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a copy of a document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCreateDocumentTemplateCopyPost(idDocumentTemplate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCreateDocumentTemplateCopyPost(idDocumentTemplate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentCreateDocumentTemplateCopyPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary DocumentPrintFormSettings IU
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCreateOrUpdateDocumentPrintFormSettingsPost(aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO?: APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCreateOrUpdateDocumentPrintFormSettingsPost(aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentCreateOrUpdateDocumentPrintFormSettingsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adds or updates document template localization.
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCreateOrUpdateDocumentTemplateLocalizationPost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO?: APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCreateOrUpdateDocumentTemplateLocalizationPost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentCreateOrUpdateDocumentTemplateLocalizationPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates or updates a document template.
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCreateOrUpdateDocumentTemplatePost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO?: APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTODocumentCreateOrUpdateDocumentTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCreateOrUpdateDocumentTemplatePost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentCreateOrUpdateDocumentTemplatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentDeleteDocumentTemplateDelete(idDocumentTemplate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentDeleteDocumentTemplateDelete(idDocumentTemplate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentDeleteDocumentTemplateDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a document template localization
         * @param {string} [idDocumentTemplateLocalization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentDeleteDocumentTemplateLocalizationDelete(idDocumentTemplateLocalization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentDeleteDocumentTemplateLocalizationDelete(idDocumentTemplateLocalization, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentDeleteDocumentTemplateLocalizationDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads document in openXML form
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentDownloadDocumentGet(idDocument?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentDownloadDocumentGet(idDocument, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentDownloadDocumentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all available document fields.
         * @param {string} [langCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetAllDocumentFieldsGet(langCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedDynamicFormsFieldsBaseIDynamicFormField>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetAllDocumentFieldsGet(langCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetAllDocumentFieldsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets users associated with document.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetAssociatedUsersToDocumentGet(idDocument?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTODocumentAssociatedUsersToDocumentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetAssociatedUsersToDocumentGet(idDocument, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetAssociatedUsersToDocumentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets default print form settings content (internal usage)
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDefaultPrintFormSettingContentPost(body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDefaultPrintFormSettingContentPost(body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDefaultPrintFormSettingContentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets document by id.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentGet(idDocument?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTODocumentDocumentDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentGet(idDocument, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets preview of document
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentPreviewGet(idDocument?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentPreviewGet(idDocument, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentPreviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets DocumentPrintFormSettings By location id
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentPrintFormSettingsByLocationGet(idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentPrintFormSettingsByLocationGet(idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentPrintFormSettingsByLocationGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns DocumentPrintFormSettings
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentPrintFormSettingsGet(idDocumentPrintFormSettings?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentPrintFormSettingsGet(idDocumentPrintFormSettings, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentPrintFormSettingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns company\'s DocumentPrintFormSettings
         * @param {boolean} [returnContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentPrintFormSettingsGridGet(returnContent?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentPrintFormSettingsGridGet(returnContent, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentPrintFormSettingsGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets document template from db
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentPrintFormSettingsTemplateGet(idDocumentPrintFormSettings?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentPrintFormSettingsTemplateGet(idDocumentPrintFormSettings, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentPrintFormSettingsTemplateGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a single document template by its ID.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentTemplateGet(idDocumentTemplate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTODocumentDocumentTemplateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentTemplateGet(idDocumentTemplate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentTemplateGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list or specified document template localization
         * @param {string} idDocumentTemplateLocalization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet(idDocumentTemplateLocalization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTODocumentDocumentTemplateLocalizationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet(idDocumentTemplateLocalization, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets preview of document localization
         * @param {string} [idDocumentTemplateLocalization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentTemplateLocalizationPreviewGet(idDocumentTemplateLocalization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentTemplateLocalizationPreviewGet(idDocumentTemplateLocalization, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentTemplateLocalizationPreviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets preview of document localization by template and language
         * @param {string} [idDocumentTemplate] 
         * @param {string} [idLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentTemplatePreviewGet(idDocumentTemplate?: string, idLanguage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentTemplatePreviewGet(idDocumentTemplate, idLanguage, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentTemplatePreviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of document templates.
         * @param {boolean} [valid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentTemplatesGet(valid?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTODocumentDocumentTemplateDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentTemplatesGet(valid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentTemplatesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets documents.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentsGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTODocumentDocumentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentsGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets placeholder map for document
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetPlaceholdersForDocumentGet(idDocument?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetPlaceholdersForDocumentGet(idDocument, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentGetPlaceholdersForDocumentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Merges content from word file and applies headers/footers from template.
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentMergeTemplateAndContentPost(idDocumentPrintFormSettings?: string, document?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentMergeTemplateAndContentPost(idDocumentPrintFormSettings, document, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentMergeTemplateAndContentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Replaces placeholders in template
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentReplacePlaceholdersInTemplatePost(idDocumentPrintFormSettings?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentReplacePlaceholdersInTemplatePost(idDocumentPrintFormSettings, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentReplacePlaceholdersInTemplatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Restores a deleted document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRestoreDocumentTemplatePost(idDocumentTemplate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRestoreDocumentTemplatePost(idDocumentTemplate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentRestoreDocumentTemplatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sends a document to client\'s email
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentSendDocumentPost(idDocument?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentSendDocumentPost(idDocument, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentSendDocumentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a document.
         * @param {APIXdentDTODocumentUpdateDocumentDTO} [aPIXdentDTODocumentUpdateDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentUpdateDocumentPost(aPIXdentDTODocumentUpdateDocumentDTO?: APIXdentDTODocumentUpdateDocumentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentUpdateDocumentPost(aPIXdentDTODocumentUpdateDocumentDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentUpdateDocumentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads Word Document Template
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentUploadWordTemplatePost(document?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentUploadWordTemplatePost(document, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DocumentApi.apiDocumentUploadWordTemplatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @summary Sets users associated with document.
         * @param {string} [idDocument] 
         * @param {string} [idDocumentTemplate] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentAssociateUsersToDocumentPost(idDocument?: string, idDocumentTemplate?: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentAssociateUsersToDocumentPost(idDocument, idDocumentTemplate, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Converts uploaded word to pdf
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentConvertWordToPdfPost(body?: string, options?: any): AxiosPromise<object> {
            return localVarFp.apiDocumentConvertWordToPdfPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates document copy.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateDocumentCopyPost(idDocument?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentCreateDocumentCopyPost(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a document from document template localization
         * @param {APIXdentDTODocumentCreateDocumentFromTemplateDTO} [aPIXdentDTODocumentCreateDocumentFromTemplateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateDocumentFromTemplatePost(aPIXdentDTODocumentCreateDocumentFromTemplateDTO?: APIXdentDTODocumentCreateDocumentFromTemplateDTO, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentCreateDocumentFromTemplatePost(aPIXdentDTODocumentCreateDocumentFromTemplateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a document.
         * @param {APIXdentDTODocumentCreateDocumentDTO} [aPIXdentDTODocumentCreateDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateDocumentPost(aPIXdentDTODocumentCreateDocumentDTO?: APIXdentDTODocumentCreateDocumentDTO, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentCreateDocumentPost(aPIXdentDTODocumentCreateDocumentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a copy of a document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateDocumentTemplateCopyPost(idDocumentTemplate?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentCreateDocumentTemplateCopyPost(idDocumentTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DocumentPrintFormSettings IU
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateOrUpdateDocumentPrintFormSettingsPost(aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO?: APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentCreateOrUpdateDocumentPrintFormSettingsPost(aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds or updates document template localization.
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateOrUpdateDocumentTemplateLocalizationPost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO?: APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentCreateOrUpdateDocumentTemplateLocalizationPost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates or updates a document template.
         * @param {APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCreateOrUpdateDocumentTemplatePost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO?: APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO, options?: any): AxiosPromise<APIXdentDTODocumentCreateOrUpdateDocumentTemplateResponseDTO> {
            return localVarFp.apiDocumentCreateOrUpdateDocumentTemplatePost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDeleteDocumentTemplateDelete(idDocumentTemplate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentDeleteDocumentTemplateDelete(idDocumentTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a document template localization
         * @param {string} [idDocumentTemplateLocalization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDeleteDocumentTemplateLocalizationDelete(idDocumentTemplateLocalization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentDeleteDocumentTemplateLocalizationDelete(idDocumentTemplateLocalization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads document in openXML form
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDownloadDocumentGet(idDocument?: string, options?: any): AxiosPromise<object> {
            return localVarFp.apiDocumentDownloadDocumentGet(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all available document fields.
         * @param {string} [langCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetAllDocumentFieldsGet(langCode?: string, options?: any): AxiosPromise<Array<APISharedDynamicFormsFieldsBaseIDynamicFormField>> {
            return localVarFp.apiDocumentGetAllDocumentFieldsGet(langCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets users associated with document.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetAssociatedUsersToDocumentGet(idDocument?: string, options?: any): AxiosPromise<Array<APIXdentDTODocumentAssociatedUsersToDocumentDTO>> {
            return localVarFp.apiDocumentGetAssociatedUsersToDocumentGet(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets default print form settings content (internal usage)
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDefaultPrintFormSettingContentPost(body?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentGetDefaultPrintFormSettingContentPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets document by id.
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentGet(idDocument?: string, options?: any): AxiosPromise<APIXdentDTODocumentDocumentDTO> {
            return localVarFp.apiDocumentGetDocumentGet(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets preview of document
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPreviewGet(idDocument?: string, options?: any): AxiosPromise<object> {
            return localVarFp.apiDocumentGetDocumentPreviewGet(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets DocumentPrintFormSettings By location id
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPrintFormSettingsByLocationGet(idLocation?: string, options?: any): AxiosPromise<APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings> {
            return localVarFp.apiDocumentGetDocumentPrintFormSettingsByLocationGet(idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns DocumentPrintFormSettings
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPrintFormSettingsGet(idDocumentPrintFormSettings?: string, options?: any): AxiosPromise<APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings> {
            return localVarFp.apiDocumentGetDocumentPrintFormSettingsGet(idDocumentPrintFormSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns company\'s DocumentPrintFormSettings
         * @param {boolean} [returnContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPrintFormSettingsGridGet(returnContent?: boolean, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerDocumentPrintFormSettings>> {
            return localVarFp.apiDocumentGetDocumentPrintFormSettingsGridGet(returnContent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets document template from db
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentPrintFormSettingsTemplateGet(idDocumentPrintFormSettings?: string, options?: any): AxiosPromise<object> {
            return localVarFp.apiDocumentGetDocumentPrintFormSettingsTemplateGet(idDocumentPrintFormSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a single document template by its ID.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplateGet(idDocumentTemplate?: string, options?: any): AxiosPromise<APIXdentDTODocumentDocumentTemplateDTO> {
            return localVarFp.apiDocumentGetDocumentTemplateGet(idDocumentTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list or specified document template localization
         * @param {string} idDocumentTemplateLocalization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet(idDocumentTemplateLocalization: string, options?: any): AxiosPromise<APIXdentDTODocumentDocumentTemplateLocalizationDTO> {
            return localVarFp.apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet(idDocumentTemplateLocalization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets preview of document localization
         * @param {string} [idDocumentTemplateLocalization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplateLocalizationPreviewGet(idDocumentTemplateLocalization?: string, options?: any): AxiosPromise<object> {
            return localVarFp.apiDocumentGetDocumentTemplateLocalizationPreviewGet(idDocumentTemplateLocalization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets preview of document localization by template and language
         * @param {string} [idDocumentTemplate] 
         * @param {string} [idLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplatePreviewGet(idDocumentTemplate?: string, idLanguage?: string, options?: any): AxiosPromise<object> {
            return localVarFp.apiDocumentGetDocumentTemplatePreviewGet(idDocumentTemplate, idLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of document templates.
         * @param {boolean} [valid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentTemplatesGet(valid?: boolean, options?: any): AxiosPromise<Array<APIXdentDTODocumentDocumentTemplateDTO>> {
            return localVarFp.apiDocumentGetDocumentTemplatesGet(valid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets documents.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentsGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTODocumentDocumentDTO>> {
            return localVarFp.apiDocumentGetDocumentsGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets placeholder map for document
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetPlaceholdersForDocumentGet(idDocument?: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiDocumentGetPlaceholdersForDocumentGet(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Merges content from word file and applies headers/footers from template.
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentMergeTemplateAndContentPost(idDocumentPrintFormSettings?: string, document?: File, options?: any): AxiosPromise<object> {
            return localVarFp.apiDocumentMergeTemplateAndContentPost(idDocumentPrintFormSettings, document, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replaces placeholders in template
         * @param {string} [idDocumentPrintFormSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentReplacePlaceholdersInTemplatePost(idDocumentPrintFormSettings?: string, options?: any): AxiosPromise<object> {
            return localVarFp.apiDocumentReplacePlaceholdersInTemplatePost(idDocumentPrintFormSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restores a deleted document template.
         * @param {string} [idDocumentTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRestoreDocumentTemplatePost(idDocumentTemplate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentRestoreDocumentTemplatePost(idDocumentTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a document to client\'s email
         * @param {string} [idDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentSendDocumentPost(idDocument?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDocumentSendDocumentPost(idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a document.
         * @param {APIXdentDTODocumentUpdateDocumentDTO} [aPIXdentDTODocumentUpdateDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentUpdateDocumentPost(aPIXdentDTODocumentUpdateDocumentDTO?: APIXdentDTODocumentUpdateDocumentDTO, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentUpdateDocumentPost(aPIXdentDTODocumentUpdateDocumentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads Word Document Template
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentUploadWordTemplatePost(document?: File, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentUploadWordTemplatePost(document, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @summary Sets users associated with document.
     * @param {string} [idDocument] 
     * @param {string} [idDocumentTemplate] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentAssociateUsersToDocumentPost(idDocument?: string, idDocumentTemplate?: string, requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentAssociateUsersToDocumentPost(idDocument, idDocumentTemplate, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Converts uploaded word to pdf
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentConvertWordToPdfPost(body?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentConvertWordToPdfPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates document copy.
     * @param {string} [idDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentCreateDocumentCopyPost(idDocument?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentCreateDocumentCopyPost(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a document from document template localization
     * @param {APIXdentDTODocumentCreateDocumentFromTemplateDTO} [aPIXdentDTODocumentCreateDocumentFromTemplateDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentCreateDocumentFromTemplatePost(aPIXdentDTODocumentCreateDocumentFromTemplateDTO?: APIXdentDTODocumentCreateDocumentFromTemplateDTO, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentCreateDocumentFromTemplatePost(aPIXdentDTODocumentCreateDocumentFromTemplateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a document.
     * @param {APIXdentDTODocumentCreateDocumentDTO} [aPIXdentDTODocumentCreateDocumentDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentCreateDocumentPost(aPIXdentDTODocumentCreateDocumentDTO?: APIXdentDTODocumentCreateDocumentDTO, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentCreateDocumentPost(aPIXdentDTODocumentCreateDocumentDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a copy of a document template.
     * @param {string} [idDocumentTemplate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentCreateDocumentTemplateCopyPost(idDocumentTemplate?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentCreateDocumentTemplateCopyPost(idDocumentTemplate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DocumentPrintFormSettings IU
     * @param {APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentCreateOrUpdateDocumentPrintFormSettingsPost(aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO?: APIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentCreateOrUpdateDocumentPrintFormSettingsPost(aPIXdentDTODocumentCreateOrUpdateDocumentPrintFormSettingsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds or updates document template localization.
     * @param {APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentCreateOrUpdateDocumentTemplateLocalizationPost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO?: APIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentCreateOrUpdateDocumentTemplateLocalizationPost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateLocalizationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates or updates a document template.
     * @param {APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO} [aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentCreateOrUpdateDocumentTemplatePost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO?: APIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentCreateOrUpdateDocumentTemplatePost(aPIXdentDTODocumentCreateOrUpdateDocumentTemplateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a document template.
     * @param {string} [idDocumentTemplate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentDeleteDocumentTemplateDelete(idDocumentTemplate?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentDeleteDocumentTemplateDelete(idDocumentTemplate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a document template localization
     * @param {string} [idDocumentTemplateLocalization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentDeleteDocumentTemplateLocalizationDelete(idDocumentTemplateLocalization?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentDeleteDocumentTemplateLocalizationDelete(idDocumentTemplateLocalization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads document in openXML form
     * @param {string} [idDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentDownloadDocumentGet(idDocument?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentDownloadDocumentGet(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all available document fields.
     * @param {string} [langCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetAllDocumentFieldsGet(langCode?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetAllDocumentFieldsGet(langCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets users associated with document.
     * @param {string} [idDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetAssociatedUsersToDocumentGet(idDocument?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetAssociatedUsersToDocumentGet(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets default print form settings content (internal usage)
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDefaultPrintFormSettingContentPost(body?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDefaultPrintFormSettingContentPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets document by id.
     * @param {string} [idDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentGet(idDocument?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentGet(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets preview of document
     * @param {string} [idDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentPreviewGet(idDocument?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentPreviewGet(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets DocumentPrintFormSettings By location id
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentPrintFormSettingsByLocationGet(idLocation?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentPrintFormSettingsByLocationGet(idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns DocumentPrintFormSettings
     * @param {string} [idDocumentPrintFormSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentPrintFormSettingsGet(idDocumentPrintFormSettings?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentPrintFormSettingsGet(idDocumentPrintFormSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns company\'s DocumentPrintFormSettings
     * @param {boolean} [returnContent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentPrintFormSettingsGridGet(returnContent?: boolean, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentPrintFormSettingsGridGet(returnContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets document template from db
     * @param {string} [idDocumentPrintFormSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentPrintFormSettingsTemplateGet(idDocumentPrintFormSettings?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentPrintFormSettingsTemplateGet(idDocumentPrintFormSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a single document template by its ID.
     * @param {string} [idDocumentTemplate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentTemplateGet(idDocumentTemplate?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentTemplateGet(idDocumentTemplate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list or specified document template localization
     * @param {string} idDocumentTemplateLocalization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet(idDocumentTemplateLocalization: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentTemplateLocalizationIdDocumentTemplateLocalizationGet(idDocumentTemplateLocalization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets preview of document localization
     * @param {string} [idDocumentTemplateLocalization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentTemplateLocalizationPreviewGet(idDocumentTemplateLocalization?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentTemplateLocalizationPreviewGet(idDocumentTemplateLocalization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets preview of document localization by template and language
     * @param {string} [idDocumentTemplate] 
     * @param {string} [idLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentTemplatePreviewGet(idDocumentTemplate?: string, idLanguage?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentTemplatePreviewGet(idDocumentTemplate, idLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of document templates.
     * @param {boolean} [valid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentTemplatesGet(valid?: boolean, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentTemplatesGet(valid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets documents.
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentsGet(idClient?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentsGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets placeholder map for document
     * @param {string} [idDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetPlaceholdersForDocumentGet(idDocument?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetPlaceholdersForDocumentGet(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Merges content from word file and applies headers/footers from template.
     * @param {string} [idDocumentPrintFormSettings] 
     * @param {File} [document] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentMergeTemplateAndContentPost(idDocumentPrintFormSettings?: string, document?: File, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentMergeTemplateAndContentPost(idDocumentPrintFormSettings, document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replaces placeholders in template
     * @param {string} [idDocumentPrintFormSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentReplacePlaceholdersInTemplatePost(idDocumentPrintFormSettings?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentReplacePlaceholdersInTemplatePost(idDocumentPrintFormSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restores a deleted document template.
     * @param {string} [idDocumentTemplate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentRestoreDocumentTemplatePost(idDocumentTemplate?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentRestoreDocumentTemplatePost(idDocumentTemplate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a document to client\'s email
     * @param {string} [idDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentSendDocumentPost(idDocument?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentSendDocumentPost(idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a document.
     * @param {APIXdentDTODocumentUpdateDocumentDTO} [aPIXdentDTODocumentUpdateDocumentDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentUpdateDocumentPost(aPIXdentDTODocumentUpdateDocumentDTO?: APIXdentDTODocumentUpdateDocumentDTO, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentUpdateDocumentPost(aPIXdentDTODocumentUpdateDocumentDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads Word Document Template
     * @param {File} [document] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentUploadWordTemplatePost(document?: File, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentUploadWordTemplatePost(document, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EReceptApi - axios parameter creator
 * @export
 */
export const EReceptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSendSignedElectronicPrescriptionDto} [aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptEreceptCertLoadTestPost: async (aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto?: APIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ERecept/EreceptCertLoadTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptFilterDiagnoseGet: async (query?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ERecept/FilterDiagnose`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalPrescription] 
         * @param {boolean} [duplicate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptGetPrescriptionForEditGet: async (idMedicalPrescription?: string, duplicate?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ERecept/GetPrescriptionForEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalPrescription !== undefined) {
                localVarQueryParameter['idMedicalPrescription'] = idMedicalPrescription;
            }

            if (duplicate !== undefined) {
                localVarQueryParameter['duplicate'] = duplicate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptSUKLErrorsPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ERecept/SUKLErrors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptMagistralisSaveDto} [aPIXdentDTOEreceptMagistralisSaveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptSaveMagistralisPost: async (aPIXdentDTOEreceptMagistralisSaveDto?: APIXdentDTOEreceptMagistralisSaveDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ERecept/SaveMagistralis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEreceptMagistralisSaveDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSavePrescriptionDto} [aPIXdentDTOEreceptSavePrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptSavePrescriptionPost: async (aPIXdentDTOEreceptSavePrescriptionDto?: APIXdentDTOEreceptSavePrescriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ERecept/SavePrescription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEreceptSavePrescriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSendSignedElectronicPrescriptionDto} [aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptSendSignedElectronicPrescriptionPost: async (aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto?: APIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ERecept/SendSignedElectronicPrescription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EReceptApi - functional programming interface
 * @export
 */
export const EReceptApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EReceptApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSendSignedElectronicPrescriptionDto} [aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEReceptEreceptCertLoadTestPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto?: APIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEReceptEreceptCertLoadTestPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EReceptApi.apiEReceptEreceptCertLoadTestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEReceptFilterDiagnoseGet(query?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSESEARCHGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEReceptFilterDiagnoseGet(query, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EReceptApi.apiEReceptFilterDiagnoseGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalPrescription] 
         * @param {boolean} [duplicate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEReceptGetPrescriptionForEditGet(idMedicalPrescription?: string, duplicate?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEreceptCopyPrescriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEReceptGetPrescriptionForEditGet(idMedicalPrescription, duplicate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EReceptApi.apiEReceptGetPrescriptionForEditGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEReceptSUKLErrorsPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEReceptSUKLErrorsPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EReceptApi.apiEReceptSUKLErrorsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptMagistralisSaveDto} [aPIXdentDTOEreceptMagistralisSaveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEReceptSaveMagistralisPost(aPIXdentDTOEreceptMagistralisSaveDto?: APIXdentDTOEreceptMagistralisSaveDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEreceptMagistralisSaveResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEReceptSaveMagistralisPost(aPIXdentDTOEreceptMagistralisSaveDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EReceptApi.apiEReceptSaveMagistralisPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSavePrescriptionDto} [aPIXdentDTOEreceptSavePrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEReceptSavePrescriptionPost(aPIXdentDTOEreceptSavePrescriptionDto?: APIXdentDTOEreceptSavePrescriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEreceptSavePrescriptionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEReceptSavePrescriptionPost(aPIXdentDTOEreceptSavePrescriptionDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EReceptApi.apiEReceptSavePrescriptionPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSendSignedElectronicPrescriptionDto} [aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEReceptSendSignedElectronicPrescriptionPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto?: APIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEReceptSendSignedElectronicPrescriptionPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EReceptApi.apiEReceptSendSignedElectronicPrescriptionPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EReceptApi - factory interface
 * @export
 */
export const EReceptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EReceptApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSendSignedElectronicPrescriptionDto} [aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptEreceptCertLoadTestPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto?: APIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options?: any): AxiosPromise<APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto> {
            return localVarFp.apiEReceptEreceptCertLoadTestPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptFilterDiagnoseGet(query?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDIAGNOSESEARCHGRIDResult>> {
            return localVarFp.apiEReceptFilterDiagnoseGet(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalPrescription] 
         * @param {boolean} [duplicate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptGetPrescriptionForEditGet(idMedicalPrescription?: string, duplicate?: boolean, options?: any): AxiosPromise<APIXdentDTOEreceptCopyPrescriptionDto> {
            return localVarFp.apiEReceptGetPrescriptionForEditGet(idMedicalPrescription, duplicate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptSUKLErrorsPost(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSUKLERRORSGRIDResult>> {
            return localVarFp.apiEReceptSUKLErrorsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptMagistralisSaveDto} [aPIXdentDTOEreceptMagistralisSaveDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptSaveMagistralisPost(aPIXdentDTOEreceptMagistralisSaveDto?: APIXdentDTOEreceptMagistralisSaveDto, options?: any): AxiosPromise<APIXdentDTOEreceptMagistralisSaveResponseDto> {
            return localVarFp.apiEReceptSaveMagistralisPost(aPIXdentDTOEreceptMagistralisSaveDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSavePrescriptionDto} [aPIXdentDTOEreceptSavePrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptSavePrescriptionPost(aPIXdentDTOEreceptSavePrescriptionDto?: APIXdentDTOEreceptSavePrescriptionDto, options?: any): AxiosPromise<APIXdentDTOEreceptSavePrescriptionResponseDto> {
            return localVarFp.apiEReceptSavePrescriptionPost(aPIXdentDTOEreceptSavePrescriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEreceptSendSignedElectronicPrescriptionDto} [aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEReceptSendSignedElectronicPrescriptionPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto?: APIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options?: any): AxiosPromise<APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto> {
            return localVarFp.apiEReceptSendSignedElectronicPrescriptionPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EReceptApi - object-oriented interface
 * @export
 * @class EReceptApi
 * @extends {BaseAPI}
 */
export class EReceptApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOEreceptSendSignedElectronicPrescriptionDto} [aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EReceptApi
     */
    public apiEReceptEreceptCertLoadTestPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto?: APIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options?: AxiosRequestConfig) {
        return EReceptApiFp(this.configuration).apiEReceptEreceptCertLoadTestPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EReceptApi
     */
    public apiEReceptFilterDiagnoseGet(query?: string, options?: AxiosRequestConfig) {
        return EReceptApiFp(this.configuration).apiEReceptFilterDiagnoseGet(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalPrescription] 
     * @param {boolean} [duplicate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EReceptApi
     */
    public apiEReceptGetPrescriptionForEditGet(idMedicalPrescription?: string, duplicate?: boolean, options?: AxiosRequestConfig) {
        return EReceptApiFp(this.configuration).apiEReceptGetPrescriptionForEditGet(idMedicalPrescription, duplicate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EReceptApi
     */
    public apiEReceptSUKLErrorsPost(options?: AxiosRequestConfig) {
        return EReceptApiFp(this.configuration).apiEReceptSUKLErrorsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOEreceptMagistralisSaveDto} [aPIXdentDTOEreceptMagistralisSaveDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EReceptApi
     */
    public apiEReceptSaveMagistralisPost(aPIXdentDTOEreceptMagistralisSaveDto?: APIXdentDTOEreceptMagistralisSaveDto, options?: AxiosRequestConfig) {
        return EReceptApiFp(this.configuration).apiEReceptSaveMagistralisPost(aPIXdentDTOEreceptMagistralisSaveDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOEreceptSavePrescriptionDto} [aPIXdentDTOEreceptSavePrescriptionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EReceptApi
     */
    public apiEReceptSavePrescriptionPost(aPIXdentDTOEreceptSavePrescriptionDto?: APIXdentDTOEreceptSavePrescriptionDto, options?: AxiosRequestConfig) {
        return EReceptApiFp(this.configuration).apiEReceptSavePrescriptionPost(aPIXdentDTOEreceptSavePrescriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOEreceptSendSignedElectronicPrescriptionDto} [aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EReceptApi
     */
    public apiEReceptSendSignedElectronicPrescriptionPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto?: APIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options?: AxiosRequestConfig) {
        return EReceptApiFp(this.configuration).apiEReceptSendSignedElectronicPrescriptionPost(aPIXdentDTOEreceptSendSignedElectronicPrescriptionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EZdravieApi - axios parameter creator
 * @export
 */
export const EZdravieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generates a unique id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGenerateExternyIdentifikatorRiadkuGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GenerateExternyIdentifikatorRiadku`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGenerateIdPost: async (aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GenerateId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieGenerateEZdravieIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets SK client by id
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetClientSkByIdGet: async (clientId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetClientSkById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns filtered diagnoses based on name
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetDiagnosesGet: async (search?: string, take?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetDiagnoses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets insurance settings for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetInsuranceSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetInsuranceSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns filtered medical aid tools based on name
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetMedicalAidToolsGet: async (search?: string, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetMedicalAidTools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns filtered medicaments based on name and ATC
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetMedicamentsGet: async (search?: string, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetMedicaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the oupzs by ICO.
         * @param {string} [ico] The ICO.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetOUPZSByIcoGet: async (ico?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetOUPZSByIco`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ico !== undefined) {
                localVarQueryParameter['ico'] = ico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the provider  by ICO.
         * @param {string} [ico] The ICO.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetProviderZSByIcoGet: async (ico?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetProviderZSByIco`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ico !== undefined) {
                localVarQueryParameter['ico'] = ico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get unprocessed requests that are in the queue alongside some already processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetRequestQueueInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetRequestQueueInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} [idOUPZS] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetSomeByIdOUPZSGet: async (idOUPZS?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetSomeByIdOUPZS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idOUPZS !== undefined) {
                localVarQueryParameter['idOUPZS'] = idOUPZS;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} [idZPr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetSomeByIdZPrGet: async (idZPr?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EZdravie/GetSomeByIdZPr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idZPr !== undefined) {
                localVarQueryParameter['idZPr'] = idZPr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EZdravieApi - functional programming interface
 * @export
 */
export const EZdravieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EZdravieApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generates a unique id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGenerateExternyIdentifikatorRiadkuGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGenerateExternyIdentifikatorRiadkuGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGenerateExternyIdentifikatorRiadkuGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGenerateIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets SK client by id
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetClientSkByIdGet(clientId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEZdravieClientSkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetClientSkByIdGet(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetClientSkByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns filtered diagnoses based on name
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetDiagnosesGet(search?: string, take?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOEZdravieDiagnosisDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetDiagnosesGet(search, take, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetDiagnosesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets insurance settings for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetInsuranceSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEZdravieInsuranceSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetInsuranceSettingsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetInsuranceSettingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns filtered medical aid tools based on name
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetMedicalAidToolsGet(search?: string, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOEZdravieMedicalAidToolDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetMedicalAidToolsGet(search, take, skip, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetMedicalAidToolsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns filtered medicaments based on name and ATC
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetMedicamentsGet(search?: string, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOEZdravieMedicamentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetMedicamentsGet(search, take, skip, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetMedicamentsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the oupzs by ICO.
         * @param {string} [ico] The ICO.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetOUPZSByIcoGet(ico?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetOUPZSByIcoGet(ico, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetOUPZSByIcoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the provider  by ICO.
         * @param {string} [ico] The ICO.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetProviderZSByIcoGet(ico?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetProviderZSByIcoGet(ico, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetProviderZSByIcoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get unprocessed requests that are in the queue alongside some already processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetRequestQueueInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetRequestQueueInfoGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetRequestQueueInfoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} [idOUPZS] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetSomeByIdOUPZSGet(idOUPZS?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOEZdravieGetDataByIdOUPZSDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetSomeByIdOUPZSGet(idOUPZS, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetSomeByIdOUPZSGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} [idZPr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieGetSomeByIdZPrGet(idZPr?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEZdravieGetDataByIdZPrDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieGetSomeByIdZPrGet(idZPr, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieApi.apiEZdravieGetSomeByIdZPrGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EZdravieApi - factory interface
 * @export
 */
export const EZdravieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EZdravieApiFp(configuration)
    return {
        /**
         * 
         * @summary Generates a unique id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGenerateExternyIdentifikatorRiadkuGet(options?: any): AxiosPromise<number> {
            return localVarFp.apiEZdravieGenerateExternyIdentifikatorRiadkuGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEZdravieGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets SK client by id
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetClientSkByIdGet(clientId?: string, options?: any): AxiosPromise<APIXdentDTOEZdravieClientSkDto> {
            return localVarFp.apiEZdravieGetClientSkByIdGet(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns filtered diagnoses based on name
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetDiagnosesGet(search?: string, take?: number, options?: any): AxiosPromise<Array<APIXdentDTOEZdravieDiagnosisDto>> {
            return localVarFp.apiEZdravieGetDiagnosesGet(search, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets insurance settings for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetInsuranceSettingsGet(options?: any): AxiosPromise<APIXdentDTOEZdravieInsuranceSettingsDto> {
            return localVarFp.apiEZdravieGetInsuranceSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns filtered medical aid tools based on name
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetMedicalAidToolsGet(search?: string, take?: number, skip?: number, options?: any): AxiosPromise<Array<APIXdentDTOEZdravieMedicalAidToolDto>> {
            return localVarFp.apiEZdravieGetMedicalAidToolsGet(search, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns filtered medicaments based on name and ATC
         * @param {string} [search] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetMedicamentsGet(search?: string, take?: number, skip?: number, options?: any): AxiosPromise<Array<APIXdentDTOEZdravieMedicamentDto>> {
            return localVarFp.apiEZdravieGetMedicamentsGet(search, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the oupzs by ICO.
         * @param {string} [ico] The ICO.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetOUPZSByIcoGet(ico?: string, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerEZdravieOUPZS>> {
            return localVarFp.apiEZdravieGetOUPZSByIcoGet(ico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the provider  by ICO.
         * @param {string} [ico] The ICO.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetProviderZSByIcoGet(ico?: string, options?: any): AxiosPromise<APIContextGeneratedXdentCoreEntityLayerEZdravieProviderZS> {
            return localVarFp.apiEZdravieGetProviderZSByIcoGet(ico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get unprocessed requests that are in the queue alongside some already processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetRequestQueueInfoGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEZDRAVIEREQUESTQUEUEINFOGRIDResult>> {
            return localVarFp.apiEZdravieGetRequestQueueInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} [idOUPZS] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetSomeByIdOUPZSGet(idOUPZS?: string, options?: any): AxiosPromise<Array<APIXdentDTOEZdravieGetDataByIdOUPZSDto>> {
            return localVarFp.apiEZdravieGetSomeByIdOUPZSGet(idOUPZS, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} [idZPr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieGetSomeByIdZPrGet(idZPr?: string, options?: any): AxiosPromise<APIXdentDTOEZdravieGetDataByIdZPrDto> {
            return localVarFp.apiEZdravieGetSomeByIdZPrGet(idZPr, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EZdravieApi - object-oriented interface
 * @export
 * @class EZdravieApi
 * @extends {BaseAPI}
 */
export class EZdravieApi extends BaseAPI {
    /**
     * 
     * @summary Generates a unique id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGenerateExternyIdentifikatorRiadkuGet(options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGenerateExternyIdentifikatorRiadkuGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates id for ezdravie medical report
     * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets SK client by id
     * @param {string} [clientId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetClientSkByIdGet(clientId?: string, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetClientSkByIdGet(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns filtered diagnoses based on name
     * @param {string} [search] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetDiagnosesGet(search?: string, take?: number, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetDiagnosesGet(search, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets insurance settings for logged user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetInsuranceSettingsGet(options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetInsuranceSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns filtered medical aid tools based on name
     * @param {string} [search] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetMedicalAidToolsGet(search?: string, take?: number, skip?: number, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetMedicalAidToolsGet(search, take, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns filtered medicaments based on name and ATC
     * @param {string} [search] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetMedicamentsGet(search?: string, take?: number, skip?: number, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetMedicamentsGet(search, take, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the oupzs by ICO.
     * @param {string} [ico] The ICO.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetOUPZSByIcoGet(ico?: string, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetOUPZSByIcoGet(ico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the provider  by ICO.
     * @param {string} [ico] The ICO.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetProviderZSByIcoGet(ico?: string, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetProviderZSByIcoGet(ico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get unprocessed requests that are in the queue alongside some already processed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetRequestQueueInfoGet(options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetRequestQueueInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth policies: SkExternal)
     * @param {string} [idOUPZS] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetSomeByIdOUPZSGet(idOUPZS?: string, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetSomeByIdOUPZSGet(idOUPZS, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth policies: SkExternal)
     * @param {string} [idZPr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieApi
     */
    public apiEZdravieGetSomeByIdZPrGet(idZPr?: string, options?: AxiosRequestConfig) {
        return EZdravieApiFp(this.configuration).apiEZdravieGetSomeByIdZPrGet(idZPr, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EZdravieBasicApi - axios parameter creator
 * @export
 */
export const EZdravieBasicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Enqueques request
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieExtEnquequeRequestQueueDto} [aPIXdentDTOEZdravieExtEnquequeRequestQueueDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthEnqueueEzdravieRequestPost: async (idXdentUser: string, aPIXdentDTOEZdravieExtEnquequeRequestQueueDto?: APIXdentDTOEZdravieExtEnquequeRequestQueueDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idXdentUser' is not null or undefined
            assertParamExists('apiEZdravieBasicAuthEnqueueEzdravieRequestPost', 'idXdentUser', idXdentUser)
            const localVarPath = `/api/EZdravieBasicAuth/EnqueueEzdravieRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieExtEnquequeRequestQueueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthGenerateIdPost: async (idXdentUser: string, aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idXdentUser' is not null or undefined
            assertParamExists('apiEZdravieBasicAuthGenerateIdPost', 'idXdentUser', idXdentUser)
            const localVarPath = `/api/EZdravieBasicAuth/GenerateId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieGenerateEZdravieIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs request
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieExtLogRequestDto} [aPIXdentDTOEZdravieExtLogRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthLogEzdravieRequestPost: async (idXdentUser: string, aPIXdentDTOEZdravieExtLogRequestDto?: APIXdentDTOEZdravieExtLogRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idXdentUser' is not null or undefined
            assertParamExists('apiEZdravieBasicAuthLogEzdravieRequestPost', 'idXdentUser', idXdentUser)
            const localVarPath = `/api/EZdravieBasicAuth/LogEzdravieRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieExtLogRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves PreskripcnyZaznam to xdent
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieUlozPreskripcnyZaznamDto} [aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthUlozPreskripcnyZaznamPost: async (idXdentUser: string, aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto?: APIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idXdentUser' is not null or undefined
            assertParamExists('apiEZdravieBasicAuthUlozPreskripcnyZaznamPost', 'idXdentUser', idXdentUser)
            const localVarPath = `/api/EZdravieBasicAuth/UlozPreskripcnyZaznam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} idXdentUser 
         * @param {File} [file] 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthUploadCertificatePost: async (idXdentUser: string, file?: File, code?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idXdentUser' is not null or undefined
            assertParamExists('apiEZdravieBasicAuthUploadCertificatePost', 'idXdentUser', idXdentUser)
            const localVarPath = `/api/EZdravieBasicAuth/UploadCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (code !== undefined) { 
                localVarFormParams.append('code', code as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EZdravieBasicApi - functional programming interface
 * @export
 */
export const EZdravieBasicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EZdravieBasicApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Enqueques request
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieExtEnquequeRequestQueueDto} [aPIXdentDTOEZdravieExtEnquequeRequestQueueDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieBasicAuthEnqueueEzdravieRequestPost(idXdentUser: string, aPIXdentDTOEZdravieExtEnquequeRequestQueueDto?: APIXdentDTOEZdravieExtEnquequeRequestQueueDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieBasicAuthEnqueueEzdravieRequestPost(idXdentUser, aPIXdentDTOEZdravieExtEnquequeRequestQueueDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieBasicApi.apiEZdravieBasicAuthEnqueueEzdravieRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieBasicAuthGenerateIdPost(idXdentUser: string, aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieBasicAuthGenerateIdPost(idXdentUser, aPIXdentDTOEZdravieGenerateEZdravieIdDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieBasicApi.apiEZdravieBasicAuthGenerateIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Logs request
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieExtLogRequestDto} [aPIXdentDTOEZdravieExtLogRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieBasicAuthLogEzdravieRequestPost(idXdentUser: string, aPIXdentDTOEZdravieExtLogRequestDto?: APIXdentDTOEZdravieExtLogRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieBasicAuthLogEzdravieRequestPost(idXdentUser, aPIXdentDTOEZdravieExtLogRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieBasicApi.apiEZdravieBasicAuthLogEzdravieRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Saves PreskripcnyZaznam to xdent
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieUlozPreskripcnyZaznamDto} [aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieBasicAuthUlozPreskripcnyZaznamPost(idXdentUser: string, aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto?: APIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieBasicAuthUlozPreskripcnyZaznamPost(idXdentUser, aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieBasicApi.apiEZdravieBasicAuthUlozPreskripcnyZaznamPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} idXdentUser 
         * @param {File} [file] 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEZdravieBasicAuthUploadCertificatePost(idXdentUser: string, file?: File, code?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEZdravieBasicAuthUploadCertificatePost(idXdentUser, file, code, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieBasicApi.apiEZdravieBasicAuthUploadCertificatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EZdravieBasicApi - factory interface
 * @export
 */
export const EZdravieBasicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EZdravieBasicApiFp(configuration)
    return {
        /**
         * 
         * @summary Enqueques request
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieExtEnquequeRequestQueueDto} [aPIXdentDTOEZdravieExtEnquequeRequestQueueDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthEnqueueEzdravieRequestPost(idXdentUser: string, aPIXdentDTOEZdravieExtEnquequeRequestQueueDto?: APIXdentDTOEZdravieExtEnquequeRequestQueueDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEZdravieBasicAuthEnqueueEzdravieRequestPost(idXdentUser, aPIXdentDTOEZdravieExtEnquequeRequestQueueDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthGenerateIdPost(idXdentUser: string, aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEZdravieBasicAuthGenerateIdPost(idXdentUser, aPIXdentDTOEZdravieGenerateEZdravieIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs request
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieExtLogRequestDto} [aPIXdentDTOEZdravieExtLogRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthLogEzdravieRequestPost(idXdentUser: string, aPIXdentDTOEZdravieExtLogRequestDto?: APIXdentDTOEZdravieExtLogRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEZdravieBasicAuthLogEzdravieRequestPost(idXdentUser, aPIXdentDTOEZdravieExtLogRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves PreskripcnyZaznam to xdent
         * @param {string} idXdentUser 
         * @param {APIXdentDTOEZdravieUlozPreskripcnyZaznamDto} [aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthUlozPreskripcnyZaznamPost(idXdentUser: string, aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto?: APIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEZdravieBasicAuthUlozPreskripcnyZaznamPost(idXdentUser, aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth policies: SkExternal)
         * @param {string} idXdentUser 
         * @param {File} [file] 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEZdravieBasicAuthUploadCertificatePost(idXdentUser: string, file?: File, code?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiEZdravieBasicAuthUploadCertificatePost(idXdentUser, file, code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EZdravieBasicApi - object-oriented interface
 * @export
 * @class EZdravieBasicApi
 * @extends {BaseAPI}
 */
export class EZdravieBasicApi extends BaseAPI {
    /**
     * 
     * @summary Enqueques request
     * @param {string} idXdentUser 
     * @param {APIXdentDTOEZdravieExtEnquequeRequestQueueDto} [aPIXdentDTOEZdravieExtEnquequeRequestQueueDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieBasicApi
     */
    public apiEZdravieBasicAuthEnqueueEzdravieRequestPost(idXdentUser: string, aPIXdentDTOEZdravieExtEnquequeRequestQueueDto?: APIXdentDTOEZdravieExtEnquequeRequestQueueDto, options?: AxiosRequestConfig) {
        return EZdravieBasicApiFp(this.configuration).apiEZdravieBasicAuthEnqueueEzdravieRequestPost(idXdentUser, aPIXdentDTOEZdravieExtEnquequeRequestQueueDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates id for ezdravie medical report
     * @param {string} idXdentUser 
     * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieBasicApi
     */
    public apiEZdravieBasicAuthGenerateIdPost(idXdentUser: string, aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: AxiosRequestConfig) {
        return EZdravieBasicApiFp(this.configuration).apiEZdravieBasicAuthGenerateIdPost(idXdentUser, aPIXdentDTOEZdravieGenerateEZdravieIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs request
     * @param {string} idXdentUser 
     * @param {APIXdentDTOEZdravieExtLogRequestDto} [aPIXdentDTOEZdravieExtLogRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieBasicApi
     */
    public apiEZdravieBasicAuthLogEzdravieRequestPost(idXdentUser: string, aPIXdentDTOEZdravieExtLogRequestDto?: APIXdentDTOEZdravieExtLogRequestDto, options?: AxiosRequestConfig) {
        return EZdravieBasicApiFp(this.configuration).apiEZdravieBasicAuthLogEzdravieRequestPost(idXdentUser, aPIXdentDTOEZdravieExtLogRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves PreskripcnyZaznam to xdent
     * @param {string} idXdentUser 
     * @param {APIXdentDTOEZdravieUlozPreskripcnyZaznamDto} [aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieBasicApi
     */
    public apiEZdravieBasicAuthUlozPreskripcnyZaznamPost(idXdentUser: string, aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto?: APIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options?: AxiosRequestConfig) {
        return EZdravieBasicApiFp(this.configuration).apiEZdravieBasicAuthUlozPreskripcnyZaznamPost(idXdentUser, aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth policies: SkExternal)
     * @param {string} idXdentUser 
     * @param {File} [file] 
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieBasicApi
     */
    public apiEZdravieBasicAuthUploadCertificatePost(idXdentUser: string, file?: File, code?: string, options?: AxiosRequestConfig) {
        return EZdravieBasicApiFp(this.configuration).apiEZdravieBasicAuthUploadCertificatePost(idXdentUser, file, code, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EZdravieEXTApi - axios parameter creator
 * @export
 */
export const EZdravieEXTApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {APIXdentDTOEZdravieExtLoginDto} [aPIXdentDTOEZdravieExtLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtAuthPost: async (aPIXdentDTOEZdravieExtLoginDto?: APIXdentDTOEZdravieExtLoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/Auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieExtLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enqueques request
         * @param {APIXdentDTOEZdravieExtEnquequeRequestQueueDto} [aPIXdentDTOEZdravieExtEnquequeRequestQueueDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtEnqueueEzdravieRequestPost: async (aPIXdentDTOEZdravieExtEnquequeRequestQueueDto?: APIXdentDTOEZdravieExtEnquequeRequestQueueDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/EnqueueEzdravieRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieExtEnquequeRequestQueueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGenerateIdPost: async (aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/GenerateId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieGenerateEZdravieIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get local https certificate file
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetCertificateGet: async (code?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/GetCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets SK client by id
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetClientSkByIdGet: async (clientId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/GetClientSkById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets insurance settings for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetInsuranceSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/GetInsuranceSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get next request from queue for current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetNextRequestGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/GetNextRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get request from the queue by idRequest.
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetRequestGet: async (idRequest?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/GetRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idRequest !== undefined) {
                localVarQueryParameter['idRequest'] = idRequest;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get if next request exists in queue for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtHasNextRequestGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/HasNextRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs request
         * @param {APIXdentDTOEZdravieExtLogRequestDto} [aPIXdentDTOEZdravieExtLogRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtLogEzdravieRequestPost: async (aPIXdentDTOEZdravieExtLogRequestDto?: APIXdentDTOEZdravieExtLogRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/LogEzdravieRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieExtLogRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Just a test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtTestGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/Test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves PreskripcnyZaznam to xdent
         * @param {APIXdentDTOEZdravieUlozPreskripcnyZaznamDto} [aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtUlozPreskripcnyZaznamPost: async (aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto?: APIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/UlozPreskripcnyZaznam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates request in DB, adds log.
         * @param {APIXdentDTOEZdravieExtRequestResultDto} [aPIXdentDTOEZdravieExtRequestResultDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtUpdateRequestPost: async (aPIXdentDTOEZdravieExtRequestResultDto?: APIXdentDTOEZdravieExtRequestResultDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ezdravie/ext/UpdateRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEZdravieExtRequestResultDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EZdravieEXTApi - functional programming interface
 * @export
 */
export const EZdravieEXTApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EZdravieEXTApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {APIXdentDTOEZdravieExtLoginDto} [aPIXdentDTOEZdravieExtLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtAuthPost(aPIXdentDTOEZdravieExtLoginDto?: APIXdentDTOEZdravieExtLoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtAuthPost(aPIXdentDTOEZdravieExtLoginDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtAuthPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Enqueques request
         * @param {APIXdentDTOEZdravieExtEnquequeRequestQueueDto} [aPIXdentDTOEZdravieExtEnquequeRequestQueueDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtEnqueueEzdravieRequestPost(aPIXdentDTOEZdravieExtEnquequeRequestQueueDto?: APIXdentDTOEZdravieExtEnquequeRequestQueueDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtEnqueueEzdravieRequestPost(aPIXdentDTOEZdravieExtEnquequeRequestQueueDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtEnqueueEzdravieRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtGenerateIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get local https certificate file
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtGetCertificateGet(code?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtGetCertificateGet(code, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtGetCertificateGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets SK client by id
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtGetClientSkByIdGet(clientId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEZdravieClientSkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtGetClientSkByIdGet(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtGetClientSkByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets insurance settings for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtGetInsuranceSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEZdravieInsuranceSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtGetInsuranceSettingsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtGetInsuranceSettingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get next request from queue for current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtGetNextRequestGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEZdravieExtRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtGetNextRequestGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtGetNextRequestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get request from the queue by idRequest.
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtGetRequestGet(idRequest?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEZdravieExtRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtGetRequestGet(idRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtGetRequestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get if next request exists in queue for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtHasNextRequestGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtHasNextRequestGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtHasNextRequestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Logs request
         * @param {APIXdentDTOEZdravieExtLogRequestDto} [aPIXdentDTOEZdravieExtLogRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtLogEzdravieRequestPost(aPIXdentDTOEZdravieExtLogRequestDto?: APIXdentDTOEZdravieExtLogRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtLogEzdravieRequestPost(aPIXdentDTOEZdravieExtLogRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtLogEzdravieRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Just a test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtTestGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtTestGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtTestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Saves PreskripcnyZaznam to xdent
         * @param {APIXdentDTOEZdravieUlozPreskripcnyZaznamDto} [aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtUlozPreskripcnyZaznamPost(aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto?: APIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtUlozPreskripcnyZaznamPost(aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtUlozPreskripcnyZaznamPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Updates request in DB, adds log.
         * @param {APIXdentDTOEZdravieExtRequestResultDto} [aPIXdentDTOEZdravieExtRequestResultDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEzdravieExtUpdateRequestPost(aPIXdentDTOEZdravieExtRequestResultDto?: APIXdentDTOEZdravieExtRequestResultDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEzdravieExtUpdateRequestPost(aPIXdentDTOEZdravieExtRequestResultDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EZdravieEXTApi.apiEzdravieExtUpdateRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EZdravieEXTApi - factory interface
 * @export
 */
export const EZdravieEXTApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EZdravieEXTApiFp(configuration)
    return {
        /**
         * 
         * @param {APIXdentDTOEZdravieExtLoginDto} [aPIXdentDTOEZdravieExtLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtAuthPost(aPIXdentDTOEZdravieExtLoginDto?: APIXdentDTOEZdravieExtLoginDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiEzdravieExtAuthPost(aPIXdentDTOEZdravieExtLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enqueques request
         * @param {APIXdentDTOEZdravieExtEnquequeRequestQueueDto} [aPIXdentDTOEZdravieExtEnquequeRequestQueueDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtEnqueueEzdravieRequestPost(aPIXdentDTOEZdravieExtEnquequeRequestQueueDto?: APIXdentDTOEZdravieExtEnquequeRequestQueueDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEzdravieExtEnqueueEzdravieRequestPost(aPIXdentDTOEZdravieExtEnquequeRequestQueueDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates id for ezdravie medical report
         * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEzdravieExtGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get local https certificate file
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetCertificateGet(code?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiEzdravieExtGetCertificateGet(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets SK client by id
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetClientSkByIdGet(clientId?: string, options?: any): AxiosPromise<APIXdentDTOEZdravieClientSkDto> {
            return localVarFp.apiEzdravieExtGetClientSkByIdGet(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets insurance settings for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetInsuranceSettingsGet(options?: any): AxiosPromise<APIXdentDTOEZdravieInsuranceSettingsDto> {
            return localVarFp.apiEzdravieExtGetInsuranceSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get next request from queue for current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetNextRequestGet(options?: any): AxiosPromise<APIXdentDTOEZdravieExtRequestDto> {
            return localVarFp.apiEzdravieExtGetNextRequestGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get request from the queue by idRequest.
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtGetRequestGet(idRequest?: string, options?: any): AxiosPromise<APIXdentDTOEZdravieExtRequestDto> {
            return localVarFp.apiEzdravieExtGetRequestGet(idRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get if next request exists in queue for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtHasNextRequestGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiEzdravieExtHasNextRequestGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs request
         * @param {APIXdentDTOEZdravieExtLogRequestDto} [aPIXdentDTOEZdravieExtLogRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtLogEzdravieRequestPost(aPIXdentDTOEZdravieExtLogRequestDto?: APIXdentDTOEZdravieExtLogRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEzdravieExtLogEzdravieRequestPost(aPIXdentDTOEZdravieExtLogRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Just a test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtTestGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiEzdravieExtTestGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves PreskripcnyZaznam to xdent
         * @param {APIXdentDTOEZdravieUlozPreskripcnyZaznamDto} [aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtUlozPreskripcnyZaznamPost(aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto?: APIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiEzdravieExtUlozPreskripcnyZaznamPost(aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates request in DB, adds log.
         * @param {APIXdentDTOEZdravieExtRequestResultDto} [aPIXdentDTOEZdravieExtRequestResultDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEzdravieExtUpdateRequestPost(aPIXdentDTOEZdravieExtRequestResultDto?: APIXdentDTOEZdravieExtRequestResultDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiEzdravieExtUpdateRequestPost(aPIXdentDTOEZdravieExtRequestResultDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EZdravieEXTApi - object-oriented interface
 * @export
 * @class EZdravieEXTApi
 * @extends {BaseAPI}
 */
export class EZdravieEXTApi extends BaseAPI {
    /**
     * 
     * @param {APIXdentDTOEZdravieExtLoginDto} [aPIXdentDTOEZdravieExtLoginDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtAuthPost(aPIXdentDTOEZdravieExtLoginDto?: APIXdentDTOEZdravieExtLoginDto, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtAuthPost(aPIXdentDTOEZdravieExtLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enqueques request
     * @param {APIXdentDTOEZdravieExtEnquequeRequestQueueDto} [aPIXdentDTOEZdravieExtEnquequeRequestQueueDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtEnqueueEzdravieRequestPost(aPIXdentDTOEZdravieExtEnquequeRequestQueueDto?: APIXdentDTOEZdravieExtEnquequeRequestQueueDto, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtEnqueueEzdravieRequestPost(aPIXdentDTOEZdravieExtEnquequeRequestQueueDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates id for ezdravie medical report
     * @param {APIXdentDTOEZdravieGenerateEZdravieIdDto} [aPIXdentDTOEZdravieGenerateEZdravieIdDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto?: APIXdentDTOEZdravieGenerateEZdravieIdDto, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtGenerateIdPost(aPIXdentDTOEZdravieGenerateEZdravieIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get local https certificate file
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtGetCertificateGet(code?: string, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtGetCertificateGet(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets SK client by id
     * @param {string} [clientId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtGetClientSkByIdGet(clientId?: string, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtGetClientSkByIdGet(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets insurance settings for logged user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtGetInsuranceSettingsGet(options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtGetInsuranceSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get next request from queue for current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtGetNextRequestGet(options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtGetNextRequestGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get request from the queue by idRequest.
     * @param {string} [idRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtGetRequestGet(idRequest?: string, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtGetRequestGet(idRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get if next request exists in queue for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtHasNextRequestGet(options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtHasNextRequestGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs request
     * @param {APIXdentDTOEZdravieExtLogRequestDto} [aPIXdentDTOEZdravieExtLogRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtLogEzdravieRequestPost(aPIXdentDTOEZdravieExtLogRequestDto?: APIXdentDTOEZdravieExtLogRequestDto, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtLogEzdravieRequestPost(aPIXdentDTOEZdravieExtLogRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Just a test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtTestGet(options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtTestGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves PreskripcnyZaznam to xdent
     * @param {APIXdentDTOEZdravieUlozPreskripcnyZaznamDto} [aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtUlozPreskripcnyZaznamPost(aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto?: APIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtUlozPreskripcnyZaznamPost(aPIXdentDTOEZdravieUlozPreskripcnyZaznamDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates request in DB, adds log.
     * @param {APIXdentDTOEZdravieExtRequestResultDto} [aPIXdentDTOEZdravieExtRequestResultDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZdravieEXTApi
     */
    public apiEzdravieExtUpdateRequestPost(aPIXdentDTOEZdravieExtRequestResultDto?: APIXdentDTOEZdravieExtRequestResultDto, options?: AxiosRequestConfig) {
        return EZdravieEXTApiFp(this.configuration).apiEzdravieExtUpdateRequestPost(aPIXdentDTOEZdravieExtRequestResultDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sends Email
         * @param {APIXdentDTOPostmarkMailPostmarkSendEmailDto} [aPIXdentDTOPostmarkMailPostmarkSendEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailSendEmailPost: async (aPIXdentDTOPostmarkMailPostmarkSendEmailDto?: APIXdentDTOPostmarkMailPostmarkSendEmailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Email/SendEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOPostmarkMailPostmarkSendEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOPostmarkMailEmailDataFromS3Dto} [aPIXdentDTOPostmarkMailEmailDataFromS3Dto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailSendEmailWithCustomFileFromS3Post: async (aPIXdentDTOPostmarkMailEmailDataFromS3Dto?: APIXdentDTOPostmarkMailEmailDataFromS3Dto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Email/SendEmailWithCustomFileFromS3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOPostmarkMailEmailDataFromS3Dto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sends Email
         * @param {APIXdentDTOPostmarkMailPostmarkSendEmailDto} [aPIXdentDTOPostmarkMailPostmarkSendEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailSendEmailPost(aPIXdentDTOPostmarkMailPostmarkSendEmailDto?: APIXdentDTOPostmarkMailPostmarkSendEmailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailSendEmailPost(aPIXdentDTOPostmarkMailPostmarkSendEmailDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EmailApi.apiEmailSendEmailPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOPostmarkMailEmailDataFromS3Dto} [aPIXdentDTOPostmarkMailEmailDataFromS3Dto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmailSendEmailWithCustomFileFromS3Post(aPIXdentDTOPostmarkMailEmailDataFromS3Dto?: APIXdentDTOPostmarkMailEmailDataFromS3Dto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmailSendEmailWithCustomFileFromS3Post(aPIXdentDTOPostmarkMailEmailDataFromS3Dto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EmailApi.apiEmailSendEmailWithCustomFileFromS3Post']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailApiFp(configuration)
    return {
        /**
         * 
         * @summary Sends Email
         * @param {APIXdentDTOPostmarkMailPostmarkSendEmailDto} [aPIXdentDTOPostmarkMailPostmarkSendEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailSendEmailPost(aPIXdentDTOPostmarkMailPostmarkSendEmailDto?: APIXdentDTOPostmarkMailPostmarkSendEmailDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiEmailSendEmailPost(aPIXdentDTOPostmarkMailPostmarkSendEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOPostmarkMailEmailDataFromS3Dto} [aPIXdentDTOPostmarkMailEmailDataFromS3Dto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmailSendEmailWithCustomFileFromS3Post(aPIXdentDTOPostmarkMailEmailDataFromS3Dto?: APIXdentDTOPostmarkMailEmailDataFromS3Dto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiEmailSendEmailWithCustomFileFromS3Post(aPIXdentDTOPostmarkMailEmailDataFromS3Dto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI {
    /**
     * 
     * @summary Sends Email
     * @param {APIXdentDTOPostmarkMailPostmarkSendEmailDto} [aPIXdentDTOPostmarkMailPostmarkSendEmailDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailSendEmailPost(aPIXdentDTOPostmarkMailPostmarkSendEmailDto?: APIXdentDTOPostmarkMailPostmarkSendEmailDto, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailSendEmailPost(aPIXdentDTOPostmarkMailPostmarkSendEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOPostmarkMailEmailDataFromS3Dto} [aPIXdentDTOPostmarkMailEmailDataFromS3Dto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiEmailSendEmailWithCustomFileFromS3Post(aPIXdentDTOPostmarkMailEmailDataFromS3Dto?: APIXdentDTOPostmarkMailEmailDataFromS3Dto, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiEmailSendEmailWithCustomFileFromS3Post(aPIXdentDTOPostmarkMailEmailDataFromS3Dto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeApi - axios parameter creator
 * @export
 */
export const EmployeeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all employees for user (company), compatible with StaffController.GetStaffByUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmployeeGetEmployeeTreeByUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Employee/GetEmployeeTreeByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all employees for user (company).  Staffs have calendars, employees don\'t have to.  Every staff is also employee but not every employee is staff.
         * @param {Array<string>} [roles] Optional roles filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmployeeGetEmployeesByUserGet: async (roles?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Employee/GetEmployeesByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (roles) {
                localVarQueryParameter['roles'] = roles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeApi - functional programming interface
 * @export
 */
export const EmployeeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all employees for user (company), compatible with StaffController.GetStaffByUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmployeeGetEmployeeTreeByUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmployeeGetEmployeeTreeByUserGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EmployeeApi.apiEmployeeGetEmployeeTreeByUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all employees for user (company).  Staffs have calendars, employees don\'t have to.  Every staff is also employee but not every employee is staff.
         * @param {Array<string>} [roles] Optional roles filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEmployeeGetEmployeesByUserGet(roles?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEmployeeGetEmployeesByUserGet(roles, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EmployeeApi.apiEmployeeGetEmployeesByUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EmployeeApi - factory interface
 * @export
 */
export const EmployeeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all employees for user (company), compatible with StaffController.GetStaffByUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmployeeGetEmployeeTreeByUserGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSEREMPLOYEETREEResult>> {
            return localVarFp.apiEmployeeGetEmployeeTreeByUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all employees for user (company).  Staffs have calendars, employees don\'t have to.  Every staff is also employee but not every employee is staff.
         * @param {Array<string>} [roles] Optional roles filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEmployeeGetEmployeesByUserGet(roles?: Array<string>, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult>> {
            return localVarFp.apiEmployeeGetEmployeesByUserGet(roles, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeApi - object-oriented interface
 * @export
 * @class EmployeeApi
 * @extends {BaseAPI}
 */
export class EmployeeApi extends BaseAPI {
    /**
     * 
     * @summary Gets all employees for user (company), compatible with StaffController.GetStaffByUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public apiEmployeeGetEmployeeTreeByUserGet(options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).apiEmployeeGetEmployeeTreeByUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all employees for user (company).  Staffs have calendars, employees don\'t have to.  Every staff is also employee but not every employee is staff.
     * @param {Array<string>} [roles] Optional roles filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeApi
     */
    public apiEmployeeGetEmployeesByUserGet(roles?: Array<string>, options?: AxiosRequestConfig) {
        return EmployeeApiFp(this.configuration).apiEmployeeGetEmployeesByUserGet(roles, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EneschopenkaApi - axios parameter creator
 * @export
 */
export const EneschopenkaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto} [aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaCreatePost: async (aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto?: APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Eneschopenka/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idEneschopenka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaDetailGet: async (idEneschopenka: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idEneschopenka' is not null or undefined
            assertParamExists('apiEneschopenkaDetailGet', 'idEneschopenka', idEneschopenka)
            const localVarPath = `/api/Eneschopenka/Detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idEneschopenka !== undefined) {
                localVarQueryParameter['idEneschopenka'] = idEneschopenka;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaGridGet: async (idClient: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idClient' is not null or undefined
            assertParamExists('apiEneschopenkaGridGet', 'idClient', idClient)
            const localVarPath = `/api/Eneschopenka/Grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retuns file stream of the PDF document for the given Eneschopenka ID.
         * @param {string} idEneschopenka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaPdfGet: async (idEneschopenka: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idEneschopenka' is not null or undefined
            assertParamExists('apiEneschopenkaPdfGet', 'idEneschopenka', idEneschopenka)
            const localVarPath = `/api/Eneschopenka/Pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idEneschopenka !== undefined) {
                localVarQueryParameter['idEneschopenka'] = idEneschopenka;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto} [aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaSendPost: async (aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto?: APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Eneschopenka/Send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EneschopenkaApi - functional programming interface
 * @export
 */
export const EneschopenkaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EneschopenkaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto} [aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEneschopenkaCreatePost(aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto?: APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEneschopenkaCreatePost(aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EneschopenkaApi.apiEneschopenkaCreatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idEneschopenka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEneschopenkaDetailGet(idEneschopenka: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEneschopenkaDetailGet(idEneschopenka, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EneschopenkaApi.apiEneschopenkaDetailGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEneschopenkaGridGet(idClient: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOEneschopenkaEpWrappersSubmissionGridDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEneschopenkaGridGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EneschopenkaApi.apiEneschopenkaGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Retuns file stream of the PDF document for the given Eneschopenka ID.
         * @param {string} idEneschopenka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEneschopenkaPdfGet(idEneschopenka: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEneschopenkaPdfGet(idEneschopenka, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EneschopenkaApi.apiEneschopenkaPdfGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto} [aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEneschopenkaSendPost(aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto?: APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEneschopenkaSendPost(aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EneschopenkaApi.apiEneschopenkaSendPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EneschopenkaApi - factory interface
 * @export
 */
export const EneschopenkaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EneschopenkaApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto} [aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaCreatePost(aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto?: APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto, options?: any): AxiosPromise<APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto> {
            return localVarFp.apiEneschopenkaCreatePost(aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idEneschopenka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaDetailGet(idEneschopenka: string, options?: any): AxiosPromise<APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto> {
            return localVarFp.apiEneschopenkaDetailGet(idEneschopenka, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaGridGet(idClient: string, options?: any): AxiosPromise<APISharedDTOEneschopenkaEpWrappersSubmissionGridDto> {
            return localVarFp.apiEneschopenkaGridGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retuns file stream of the PDF document for the given Eneschopenka ID.
         * @param {string} idEneschopenka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaPdfGet(idEneschopenka: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiEneschopenkaPdfGet(idEneschopenka, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto} [aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEneschopenkaSendPost(aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto?: APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto, options?: any): AxiosPromise<object> {
            return localVarFp.apiEneschopenkaSendPost(aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EneschopenkaApi - object-oriented interface
 * @export
 * @class EneschopenkaApi
 * @extends {BaseAPI}
 */
export class EneschopenkaApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto} [aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EneschopenkaApi
     */
    public apiEneschopenkaCreatePost(aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto?: APISharedDTOEneschopenkaEpWrappersSubmissionCreateDto, options?: AxiosRequestConfig) {
        return EneschopenkaApiFp(this.configuration).apiEneschopenkaCreatePost(aPISharedDTOEneschopenkaEpWrappersSubmissionCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idEneschopenka 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EneschopenkaApi
     */
    public apiEneschopenkaDetailGet(idEneschopenka: string, options?: AxiosRequestConfig) {
        return EneschopenkaApiFp(this.configuration).apiEneschopenkaDetailGet(idEneschopenka, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idClient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EneschopenkaApi
     */
    public apiEneschopenkaGridGet(idClient: string, options?: AxiosRequestConfig) {
        return EneschopenkaApiFp(this.configuration).apiEneschopenkaGridGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retuns file stream of the PDF document for the given Eneschopenka ID.
     * @param {string} idEneschopenka 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EneschopenkaApi
     */
    public apiEneschopenkaPdfGet(idEneschopenka: string, options?: AxiosRequestConfig) {
        return EneschopenkaApiFp(this.configuration).apiEneschopenkaPdfGet(idEneschopenka, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto} [aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EneschopenkaApi
     */
    public apiEneschopenkaSendPost(aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto?: APISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto, options?: AxiosRequestConfig) {
        return EneschopenkaApiFp(this.configuration).apiEneschopenkaSendPost(aPISharedDTOEneschopenkaEpWrappersSubmissionWrapperDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EpodaniApi - axios parameter creator
 * @export
 */
export const EpodaniApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniCreateCsszEpodaniRequestDto} [aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniCreateCsszEpodaniRequestPost: async (aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto?: APIXdentDTOEpodaniCreateCsszEpodaniRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/CreateCsszEpodaniRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniCreateEpodaniRequestDto} [aPIXdentDTOEpodaniCreateEpodaniRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniCreateEpodaniPost: async (aPIXdentDTOEpodaniCreateEpodaniRequestDto?: APIXdentDTOEpodaniCreateEpodaniRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/CreateEpodani`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEpodaniCreateEpodaniRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszBankCodesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetCsszBankCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszBankTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetCsszBankTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszCodelistsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetCsszCodelists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszCountryCodesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetCsszCountryCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszDruhCinnostiGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetCsszDruhCinnosti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszDuvodPrevzetiGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetCsszDuvodPrevzeti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszFamilyRelationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetCsszFamilyRelations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszPensionTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetCsszPensionTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetEpodaniByClientIdGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/GetEpodaniByClientId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniImportEnumsPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/ImportEnums`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEpodani] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniValidateByIdGet: async (idEpodani?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/ValidateById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idEpodani !== undefined) {
                localVarQueryParameter['idEpodani'] = idEpodani;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniValidateRequestDto} [aPIXdentDTOEpodaniValidateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniValidatePost: async (aPIXdentDTOEpodaniValidateRequestDto?: APIXdentDTOEpodaniValidateRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Epodani/Validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOEpodaniValidateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EpodaniApi - functional programming interface
 * @export
 */
export const EpodaniApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EpodaniApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniCreateCsszEpodaniRequestDto} [aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniCreateCsszEpodaniRequestPost(aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto?: APIXdentDTOEpodaniCreateCsszEpodaniRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEpodaniGetExternalSignDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniCreateCsszEpodaniRequestPost(aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniCreateCsszEpodaniRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniCreateEpodaniRequestDto} [aPIXdentDTOEpodaniCreateEpodaniRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniCreateEpodaniPost(aPIXdentDTOEpodaniCreateEpodaniRequestDto?: APIXdentDTOEpodaniCreateEpodaniRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniCreateEpodaniPost(aPIXdentDTOEpodaniCreateEpodaniRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniCreateEpodaniPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetCsszBankCodesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszBankCode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetCsszBankCodesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetCsszBankCodesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetCsszBankTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszBankType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetCsszBankTypesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetCsszBankTypesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetCsszCodelistsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerSuklCokr>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetCsszCodelistsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetCsszCodelistsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetCsszCountryCodesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszCountryCode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetCsszCountryCodesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetCsszCountryCodesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetCsszDruhCinnostiGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszCisDruhCin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetCsszDruhCinnostiGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetCsszDruhCinnostiGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetCsszDuvodPrevzetiGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszDuvodPrevzeti>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetCsszDuvodPrevzetiGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetCsszDuvodPrevzetiGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetCsszFamilyRelationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszFamilyRelations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetCsszFamilyRelationsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetCsszFamilyRelationsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetCsszPensionTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszPensionType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetCsszPensionTypesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetCsszPensionTypesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniGetEpodaniByClientIdGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniGetEpodaniByClientIdGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniGetEpodaniByClientIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniImportEnumsPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniImportEnumsPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniImportEnumsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEpodani] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniValidateByIdGet(idEpodani?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniValidateByIdGet(idEpodani, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniValidateByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniValidateRequestDto} [aPIXdentDTOEpodaniValidateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEpodaniValidatePost(aPIXdentDTOEpodaniValidateRequestDto?: APIXdentDTOEpodaniValidateRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEpodaniValidatePost(aPIXdentDTOEpodaniValidateRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EpodaniApi.apiEpodaniValidatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EpodaniApi - factory interface
 * @export
 */
export const EpodaniApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EpodaniApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniCreateCsszEpodaniRequestDto} [aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniCreateCsszEpodaniRequestPost(aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto?: APIXdentDTOEpodaniCreateCsszEpodaniRequestDto, options?: any): AxiosPromise<APIXdentDTOEpodaniGetExternalSignDataResponse> {
            return localVarFp.apiEpodaniCreateCsszEpodaniRequestPost(aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniCreateEpodaniRequestDto} [aPIXdentDTOEpodaniCreateEpodaniRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniCreateEpodaniPost(aPIXdentDTOEpodaniCreateEpodaniRequestDto?: APIXdentDTOEpodaniCreateEpodaniRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiEpodaniCreateEpodaniPost(aPIXdentDTOEpodaniCreateEpodaniRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszBankCodesGet(options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszBankCode>> {
            return localVarFp.apiEpodaniGetCsszBankCodesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszBankTypesGet(options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszBankType>> {
            return localVarFp.apiEpodaniGetCsszBankTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszCodelistsGet(options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerSuklCokr>> {
            return localVarFp.apiEpodaniGetCsszCodelistsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszCountryCodesGet(options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszCountryCode>> {
            return localVarFp.apiEpodaniGetCsszCountryCodesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszDruhCinnostiGet(options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszCisDruhCin>> {
            return localVarFp.apiEpodaniGetCsszDruhCinnostiGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszDuvodPrevzetiGet(options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszDuvodPrevzeti>> {
            return localVarFp.apiEpodaniGetCsszDuvodPrevzetiGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszFamilyRelationsGet(options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszFamilyRelations>> {
            return localVarFp.apiEpodaniGetCsszFamilyRelationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetCsszPensionTypesGet(options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCsszPensionType>> {
            return localVarFp.apiEpodaniGetCsszPensionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniGetEpodaniByClientIdGet(idClient?: string, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerCSSZEpodaniRequest>> {
            return localVarFp.apiEpodaniGetEpodaniByClientIdGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniImportEnumsPost(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiEpodaniImportEnumsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEpodani] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniValidateByIdGet(idEpodani?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiEpodaniValidateByIdGet(idEpodani, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOEpodaniValidateRequestDto} [aPIXdentDTOEpodaniValidateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEpodaniValidatePost(aPIXdentDTOEpodaniValidateRequestDto?: APIXdentDTOEpodaniValidateRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiEpodaniValidatePost(aPIXdentDTOEpodaniValidateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EpodaniApi - object-oriented interface
 * @export
 * @class EpodaniApi
 * @extends {BaseAPI}
 */
export class EpodaniApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOEpodaniCreateCsszEpodaniRequestDto} [aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniCreateCsszEpodaniRequestPost(aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto?: APIXdentDTOEpodaniCreateCsszEpodaniRequestDto, options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniCreateCsszEpodaniRequestPost(aPIXdentDTOEpodaniCreateCsszEpodaniRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOEpodaniCreateEpodaniRequestDto} [aPIXdentDTOEpodaniCreateEpodaniRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniCreateEpodaniPost(aPIXdentDTOEpodaniCreateEpodaniRequestDto?: APIXdentDTOEpodaniCreateEpodaniRequestDto, options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniCreateEpodaniPost(aPIXdentDTOEpodaniCreateEpodaniRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetCsszBankCodesGet(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetCsszBankCodesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetCsszBankTypesGet(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetCsszBankTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetCsszCodelistsGet(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetCsszCodelistsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetCsszCountryCodesGet(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetCsszCountryCodesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetCsszDruhCinnostiGet(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetCsszDruhCinnostiGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetCsszDuvodPrevzetiGet(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetCsszDuvodPrevzetiGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetCsszFamilyRelationsGet(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetCsszFamilyRelationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetCsszPensionTypesGet(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetCsszPensionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniGetEpodaniByClientIdGet(idClient?: string, options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniGetEpodaniByClientIdGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniImportEnumsPost(options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniImportEnumsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idEpodani] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniValidateByIdGet(idEpodani?: string, options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniValidateByIdGet(idEpodani, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOEpodaniValidateRequestDto} [aPIXdentDTOEpodaniValidateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpodaniApi
     */
    public apiEpodaniValidatePost(aPIXdentDTOEpodaniValidateRequestDto?: APIXdentDTOEpodaniValidateRequestDto, options?: AxiosRequestConfig) {
        return EpodaniApiFp(this.configuration).apiEpodaniValidatePost(aPIXdentDTOEpodaniValidateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FormApi - axios parameter creator
 * @export
 */
export const FormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient. idLocation is hard filter overriding any byz logic applied without filter.
         * @param {string} [idClient] 
         * @param {boolean} [isFavouriteOnly] 
         * @param {boolean} [published] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetDefaultFormsByClientGet: async (idClient?: string, isFavouriteOnly?: boolean, published?: boolean, idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form/GetDefaultFormsByClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (isFavouriteOnly !== undefined) {
                localVarQueryParameter['isFavouriteOnly'] = isFavouriteOnly;
            }

            if (published !== undefined) {
                localVarQueryParameter['published'] = published;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetPopulatedFormsByClientGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form/GetPopulatedFormsByClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets signed forms for client.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetSignedFormsGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form/GetSignedForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetTreatmentPlansByClientGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form/GetTreatmentPlansByClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle given forms autoConfirm bit true / false
         * @param {APISharedXdentFormsToggleAutoConfirmDto} [aPISharedXdentFormsToggleAutoConfirmDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormToggleFormsAutoConfirmPatch: async (aPISharedXdentFormsToggleAutoConfirmDto?: APISharedXdentFormsToggleAutoConfirmDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form/ToggleFormsAutoConfirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedXdentFormsToggleAutoConfirmDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormApi - functional programming interface
 * @export
 */
export const FormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient. idLocation is hard filter overriding any byz logic applied without filter.
         * @param {string} [idClient] 
         * @param {boolean} [isFavouriteOnly] 
         * @param {boolean} [published] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormGetDefaultFormsByClientGet(idClient?: string, isFavouriteOnly?: boolean, published?: boolean, idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedXdentFormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormGetDefaultFormsByClientGet(idClient, isFavouriteOnly, published, idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormApi.apiFormGetDefaultFormsByClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormGetPopulatedFormsByClientGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedXdentFormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormGetPopulatedFormsByClientGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormApi.apiFormGetPopulatedFormsByClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets signed forms for client.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormGetSignedFormsGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormGetSignedFormsGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormApi.apiFormGetSignedFormsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormGetTreatmentPlansByClientGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedTreatmentPlanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormGetTreatmentPlansByClientGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormApi.apiFormGetTreatmentPlansByClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle given forms autoConfirm bit true / false
         * @param {APISharedXdentFormsToggleAutoConfirmDto} [aPISharedXdentFormsToggleAutoConfirmDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormToggleFormsAutoConfirmPatch(aPISharedXdentFormsToggleAutoConfirmDto?: APISharedXdentFormsToggleAutoConfirmDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormToggleFormsAutoConfirmPatch(aPISharedXdentFormsToggleAutoConfirmDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormApi.apiFormToggleFormsAutoConfirmPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FormApi - factory interface
 * @export
 */
export const FormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient. idLocation is hard filter overriding any byz logic applied without filter.
         * @param {string} [idClient] 
         * @param {boolean} [isFavouriteOnly] 
         * @param {boolean} [published] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetDefaultFormsByClientGet(idClient?: string, isFavouriteOnly?: boolean, published?: boolean, idLocation?: string, options?: any): AxiosPromise<Array<APISharedXdentFormDto>> {
            return localVarFp.apiFormGetDefaultFormsByClientGet(idClient, isFavouriteOnly, published, idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetPopulatedFormsByClientGet(idClient?: string, options?: any): AxiosPromise<Array<APISharedXdentFormDto>> {
            return localVarFp.apiFormGetPopulatedFormsByClientGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets signed forms for client.
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetSignedFormsGet(idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDResult>> {
            return localVarFp.apiFormGetSignedFormsGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetTreatmentPlansByClientGet(idClient?: string, options?: any): AxiosPromise<Array<APISharedTreatmentPlanDto>> {
            return localVarFp.apiFormGetTreatmentPlansByClientGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle given forms autoConfirm bit true / false
         * @param {APISharedXdentFormsToggleAutoConfirmDto} [aPISharedXdentFormsToggleAutoConfirmDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormToggleFormsAutoConfirmPatch(aPISharedXdentFormsToggleAutoConfirmDto?: APISharedXdentFormsToggleAutoConfirmDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiFormToggleFormsAutoConfirmPatch(aPISharedXdentFormsToggleAutoConfirmDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormApi - object-oriented interface
 * @export
 * @class FormApi
 * @extends {BaseAPI}
 */
export class FormApi extends BaseAPI {
    /**
     * 
     * @summary Gets all available forms by location based od provided idClient. idLocation is hard filter overriding any byz logic applied without filter.
     * @param {string} [idClient] 
     * @param {boolean} [isFavouriteOnly] 
     * @param {boolean} [published] 
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormGetDefaultFormsByClientGet(idClient?: string, isFavouriteOnly?: boolean, published?: boolean, idLocation?: string, options?: AxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormGetDefaultFormsByClientGet(idClient, isFavouriteOnly, published, idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all available forms by location based od provided idClient
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormGetPopulatedFormsByClientGet(idClient?: string, options?: AxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormGetPopulatedFormsByClientGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets signed forms for client.
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormGetSignedFormsGet(idClient?: string, options?: AxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormGetSignedFormsGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all available forms by location based od provided idClient
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormGetTreatmentPlansByClientGet(idClient?: string, options?: AxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormGetTreatmentPlansByClientGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle given forms autoConfirm bit true / false
     * @param {APISharedXdentFormsToggleAutoConfirmDto} [aPISharedXdentFormsToggleAutoConfirmDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormToggleFormsAutoConfirmPatch(aPISharedXdentFormsToggleAutoConfirmDto?: APISharedXdentFormsToggleAutoConfirmDto, options?: AxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormToggleFormsAutoConfirmPatch(aPISharedXdentFormsToggleAutoConfirmDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FormRequestApi - axios parameter creator
 * @export
 */
export const FormRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accepts form request
         * @param {APIXdentControllersXdentFormRequestActionDto} [aPIXdentControllersXdentFormRequestActionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestAcceptPost: async (aPIXdentControllersXdentFormRequestActionDto?: APIXdentControllersXdentFormRequestActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormRequest/Accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentControllersXdentFormRequestActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get document requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestDocumentRequestsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormRequest/DocumentRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get form requests
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestFormRequestsGet: async (idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormRequest/FormRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idRequest !== undefined) {
                localVarQueryParameter['idRequest'] = idRequest;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (statusCode !== undefined) {
                localVarQueryParameter['statusCode'] = statusCode;
            }

            if (includeDocumentFile !== undefined) {
                localVarQueryParameter['includeDocumentFile'] = includeDocumentFile;
            }

            if (stDate !== undefined) {
                localVarQueryParameter['stDate'] = stDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (stExpDate !== undefined) {
                localVarQueryParameter['stExpDate'] = stExpDate;
            }

            if (endExpDate !== undefined) {
                localVarQueryParameter['endExpDate'] = endExpDate;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get form requests (bad webmethod, but it\'s what the client expects maybe)
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestGetFormRequestsGridPost: async (idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormRequest/GetFormRequestsGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idRequest !== undefined) {
                localVarQueryParameter['idRequest'] = idRequest;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (statusCode !== undefined) {
                localVarQueryParameter['statusCode'] = statusCode;
            }

            if (includeDocumentFile !== undefined) {
                localVarQueryParameter['includeDocumentFile'] = includeDocumentFile;
            }

            if (stDate !== undefined) {
                localVarQueryParameter['stDate'] = stDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (stExpDate !== undefined) {
                localVarQueryParameter['stExpDate'] = stExpDate;
            }

            if (endExpDate !== undefined) {
                localVarQueryParameter['endExpDate'] = endExpDate;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rejects form request
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestRejectDelete: async (idRequest?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormRequest/Reject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idRequest !== undefined) {
                localVarQueryParameter['idRequest'] = idRequest;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormRequestApi - functional programming interface
 * @export
 */
export const FormRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accepts form request
         * @param {APIXdentControllersXdentFormRequestActionDto} [aPIXdentControllersXdentFormRequestActionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormRequestAcceptPost(aPIXdentControllersXdentFormRequestActionDto?: APIXdentControllersXdentFormRequestActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormRequestAcceptPost(aPIXdentControllersXdentFormRequestActionDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormRequestApi.apiFormRequestAcceptPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get document requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormRequestDocumentRequestsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormRequestDocumentRequestsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormRequestApi.apiFormRequestDocumentRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get form requests
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormRequestFormRequestsGet(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormRequestFormRequestsGet(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormRequestApi.apiFormRequestFormRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get form requests (bad webmethod, but it\'s what the client expects maybe)
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormRequestGetFormRequestsGridPost(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormRequestGetFormRequestsGridPost(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormRequestApi.apiFormRequestGetFormRequestsGridPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rejects form request
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormRequestRejectDelete(idRequest?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormRequestRejectDelete(idRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormRequestApi.apiFormRequestRejectDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FormRequestApi - factory interface
 * @export
 */
export const FormRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormRequestApiFp(configuration)
    return {
        /**
         * 
         * @summary Accepts form request
         * @param {APIXdentControllersXdentFormRequestActionDto} [aPIXdentControllersXdentFormRequestActionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestAcceptPost(aPIXdentControllersXdentFormRequestActionDto?: APIXdentControllersXdentFormRequestActionDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiFormRequestAcceptPost(aPIXdentControllersXdentFormRequestActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get document requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestDocumentRequestsGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedDOCUMENTREQUESTGRIDResult>> {
            return localVarFp.apiFormRequestDocumentRequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get form requests
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestFormRequestsGet(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult>> {
            return localVarFp.apiFormRequestFormRequestsGet(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get form requests (bad webmethod, but it\'s what the client expects maybe)
         * @param {string} [idRequest] 
         * @param {string} [idStaff] 
         * @param {string} [statusCode] 
         * @param {boolean} [includeDocumentFile] 
         * @param {string} [stDate] 
         * @param {string} [endDate] 
         * @param {string} [stExpDate] 
         * @param {string} [endExpDate] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestGetFormRequestsGridPost(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedFORMREQUESTGRIDSTATISTICSResult>> {
            return localVarFp.apiFormRequestGetFormRequestsGridPost(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rejects form request
         * @param {string} [idRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormRequestRejectDelete(idRequest?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiFormRequestRejectDelete(idRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormRequestApi - object-oriented interface
 * @export
 * @class FormRequestApi
 * @extends {BaseAPI}
 */
export class FormRequestApi extends BaseAPI {
    /**
     * 
     * @summary Accepts form request
     * @param {APIXdentControllersXdentFormRequestActionDto} [aPIXdentControllersXdentFormRequestActionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormRequestApi
     */
    public apiFormRequestAcceptPost(aPIXdentControllersXdentFormRequestActionDto?: APIXdentControllersXdentFormRequestActionDto, options?: AxiosRequestConfig) {
        return FormRequestApiFp(this.configuration).apiFormRequestAcceptPost(aPIXdentControllersXdentFormRequestActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get document requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormRequestApi
     */
    public apiFormRequestDocumentRequestsGet(options?: AxiosRequestConfig) {
        return FormRequestApiFp(this.configuration).apiFormRequestDocumentRequestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get form requests
     * @param {string} [idRequest] 
     * @param {string} [idStaff] 
     * @param {string} [statusCode] 
     * @param {boolean} [includeDocumentFile] 
     * @param {string} [stDate] 
     * @param {string} [endDate] 
     * @param {string} [stExpDate] 
     * @param {string} [endExpDate] 
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormRequestApi
     */
    public apiFormRequestFormRequestsGet(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: AxiosRequestConfig) {
        return FormRequestApiFp(this.configuration).apiFormRequestFormRequestsGet(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get form requests (bad webmethod, but it\'s what the client expects maybe)
     * @param {string} [idRequest] 
     * @param {string} [idStaff] 
     * @param {string} [statusCode] 
     * @param {boolean} [includeDocumentFile] 
     * @param {string} [stDate] 
     * @param {string} [endDate] 
     * @param {string} [stExpDate] 
     * @param {string} [endExpDate] 
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormRequestApi
     */
    public apiFormRequestGetFormRequestsGridPost(idRequest?: string, idStaff?: string, statusCode?: string, includeDocumentFile?: boolean, stDate?: string, endDate?: string, stExpDate?: string, endExpDate?: string, idLocation?: string, options?: AxiosRequestConfig) {
        return FormRequestApiFp(this.configuration).apiFormRequestGetFormRequestsGridPost(idRequest, idStaff, statusCode, includeDocumentFile, stDate, endDate, stExpDate, endExpDate, idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rejects form request
     * @param {string} [idRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormRequestApi
     */
    public apiFormRequestRejectDelete(idRequest?: string, options?: AxiosRequestConfig) {
        return FormRequestApiFp(this.configuration).apiFormRequestRejectDelete(idRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GalleryApi - axios parameter creator
 * @export
 */
export const GalleryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes file by id for owner user.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryDeleteFileDelete: async (idFile?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/DeleteFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits file metadata
         * @param {APIXdentDTOGalleryEditGalleryFileMetadataDto} [aPIXdentDTOGalleryEditGalleryFileMetadataDto] IdExistingFile is for file replacement; IdMaster is IdGallery, only used for new file upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryEditFileMetadataPut: async (aPIXdentDTOGalleryEditGalleryFileMetadataDto?: APIXdentDTOGalleryEditGalleryFileMetadataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/EditFileMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOGalleryEditGalleryFileMetadataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits file in client gallery, limit per request is 50mb. (Will have to be shared again to iklient)
         * @param {string} [idExistingFile] 
         * @param {File} [file] 
         * @param {ApiGalleryEditFilePutGalleryTypeEnum} [galleryType] 0 - General, 1 - MedicalReport, 2 - SignedDocumentation, 3 - HealthPlan, -1 - MedicalReportDetail
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryEditFilePut: async (idExistingFile?: string, file?: File, galleryType?: ApiGalleryEditFilePutGalleryTypeEnum, idMaster?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/EditFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (idExistingFile !== undefined) { 
                localVarFormParams.append('idExistingFile', idExistingFile as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (galleryType !== undefined) { 
                localVarFormParams.append('galleryType', galleryType as any);
            }
    
            if (idMaster !== undefined) { 
                localVarFormParams.append('idMaster', idMaster as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all possible company tags for file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetAllFileTagsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetAllFileTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get client gallery based on galleryType
         * @param {string} [idMaster] Client that owns the gallery
         * @param {string} [idLastFile] Acts as start index in gallery
         * @param {number} [pageSize] Files count to fetch
         * @param {ApiGalleryGetClientGalleryGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Image,1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF, 6 &#x3D; None
         * @param {string} [thumbSize] Size of the thumbnail (if thumbnail type is NOT None)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetClientGalleryGet: async (idMaster?: string, idLastFile?: string, pageSize?: number, galleryType?: ApiGalleryGetClientGalleryGetGalleryTypeEnum, thumbnailAsType?: ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum, thumbSize?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetClientGallery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMaster !== undefined) {
                localVarQueryParameter['idMaster'] = idMaster;
            }

            if (idLastFile !== undefined) {
                localVarQueryParameter['idLastFile'] = idLastFile;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (galleryType !== undefined) {
                localVarQueryParameter['galleryType'] = galleryType;
            }

            if (thumbnailAsType !== undefined) {
                localVarQueryParameter['thumbnailAsType'] = thumbnailAsType;
            }

            if (thumbSize !== undefined) {
                localVarQueryParameter['thumbSize'] = thumbSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get client gallery based on galleryType
         * @param {string} [idMaster] Client that owns the gallery
         * @param {Array<string>} [idGalleries] Id of wanted galleries, for General it stays empty
         * @param {ApiGalleryGetClientGalleryTestGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetClientGalleryTestGet: async (idMaster?: string, idGalleries?: Array<string>, galleryType?: ApiGalleryGetClientGalleryTestGetGalleryTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetClientGalleryTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMaster !== undefined) {
                localVarQueryParameter['idMaster'] = idMaster;
            }

            if (idGalleries) {
                localVarQueryParameter['idGalleries'] = idGalleries;
            }

            if (galleryType !== undefined) {
                localVarQueryParameter['galleryType'] = galleryType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetFileByIdGet: async (idFile?: string, imageAsType?: ApiGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetFileById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (imageAsType !== undefined) {
                localVarQueryParameter['imageAsType'] = imageAsType;
            }

            if (extendedBaseModel !== undefined) {
                localVarQueryParameter['extendedBaseModel'] = extendedBaseModel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets file info by id
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetFileInfoByIdGet: async (idFile?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetFileInfoById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets already set tags for specific file.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetFileTagsGet: async (idFile?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetFileTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets files grid
         * @param {APIXdentDTOGalleryGetFilesGridDto} [aPIXdentDTOGalleryGetFilesGridDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetFilesGridPost: async (aPIXdentDTOGalleryGetFilesGridDto?: APIXdentDTOGalleryGetFilesGridDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetFilesGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOGalleryGetFilesGridDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns GalleryIds respective for each galleryType, General not included
         * @param {string} [idClient] 
         * @param {ApiGalleryGetGalleryIdsGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetGalleryIdsGet: async (idClient?: string, galleryType?: ApiGalleryGetGalleryIdsGetGalleryTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetGalleryIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (galleryType !== undefined) {
                localVarQueryParameter['galleryType'] = galleryType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetThumbnailByIdGet: async (idFile?: string, size?: string, thumbnailAsType?: ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/GetThumbnailById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (thumbnailAsType !== undefined) {
                localVarQueryParameter['thumbnailAsType'] = thumbnailAsType;
            }

            if (extendedBaseModel !== undefined) {
                localVarQueryParameter['extendedBaseModel'] = extendedBaseModel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shares file to iklient, on behalf of user company.
         * @param {string} [idFile] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryIklientShareGet: async (idFile?: string, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/IklientShare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves the profile photo.
         * @param {APIXdentDTOGallerySaveProfilePhotoRequestDto} [aPIXdentDTOGallerySaveProfilePhotoRequestDto] The request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGallerySaveProfilePhotoPost: async (aPIXdentDTOGallerySaveProfilePhotoRequestDto?: APIXdentDTOGallerySaveProfilePhotoRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/SaveProfilePhoto`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOGallerySaveProfilePhotoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the color of the client badge.
         * @param {APIXdentDTOGalleryUpdateClientBadgeColorRequestDto} [aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto] The request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryUpdateClientBadgeColorPost: async (aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto?: APIXdentDTOGalleryUpdateClientBadgeColorRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/UpdateClientBadgeColor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads file into client gallery, limit per request is 50mb.
         * @param {File} [file] 
         * @param {ApiGalleryUploadFilePostGalleryTypeEnum} [galleryType] 
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryUploadFilePost: async (file?: File, galleryType?: ApiGalleryUploadFilePostGalleryTypeEnum, idMaster?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/UploadFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (galleryType !== undefined) { 
                localVarFormParams.append('galleryType', galleryType as any);
            }
    
            if (idMaster !== undefined) { 
                localVarFormParams.append('idMaster', idMaster as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads file into client gallery, limit per request is 50mb.  Does not call upload service, only returns passed iFile, use this to setup your api call.  Only validates passed model, if returns Ok, gallery will accept this file.
         * @param {File} [file] 
         * @param {ApiGalleryUploadFileTestPostGalleryTypeEnum} [galleryType] 
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryUploadFileTestPost: async (file?: File, galleryType?: ApiGalleryUploadFileTestPostGalleryTypeEnum, idMaster?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Gallery/UploadFileTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (galleryType !== undefined) { 
                localVarFormParams.append('galleryType', galleryType as any);
            }
    
            if (idMaster !== undefined) { 
                localVarFormParams.append('idMaster', idMaster as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} deviceToken 
         * @param {string} [idFile] 
         * @param {ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesGalleryGetFileByIdGet: async (deviceToken: string, idFile?: string, imageAsType?: ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesGalleryGetFileByIdGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/gallery/GetFileById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (imageAsType !== undefined) {
                localVarQueryParameter['imageAsType'] = imageAsType;
            }

            if (extendedBaseModel !== undefined) {
                localVarQueryParameter['extendedBaseModel'] = extendedBaseModel;
            }

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} deviceToken 
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesGalleryGetThumbnailByIdGet: async (deviceToken: string, idFile?: string, size?: string, thumbnailAsType?: ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesGalleryGetThumbnailByIdGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/gallery/GetThumbnailById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (thumbnailAsType !== undefined) {
                localVarQueryParameter['thumbnailAsType'] = thumbnailAsType;
            }

            if (extendedBaseModel !== undefined) {
                localVarQueryParameter['extendedBaseModel'] = extendedBaseModel;
            }

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return pdf from gallery by id iklient form as stream. Signed by our safe signatures public cert.
         * @param {string} deviceToken 
         * @param {string} [idForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesGallerySafeSignaturesPdfGet: async (deviceToken: string, idForm?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesGallerySafeSignaturesPdfGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/gallery/SafeSignaturesPdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idForm !== undefined) {
                localVarQueryParameter['idForm'] = idForm;
            }

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GalleryApi - functional programming interface
 * @export
 */
export const GalleryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GalleryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes file by id for owner user.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryDeleteFileDelete(idFile?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryDeleteFileDelete(idFile, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryDeleteFileDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edits file metadata
         * @param {APIXdentDTOGalleryEditGalleryFileMetadataDto} [aPIXdentDTOGalleryEditGalleryFileMetadataDto] IdExistingFile is for file replacement; IdMaster is IdGallery, only used for new file upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryEditFileMetadataPut(aPIXdentDTOGalleryEditGalleryFileMetadataDto?: APIXdentDTOGalleryEditGalleryFileMetadataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryEditFileMetadataPut(aPIXdentDTOGalleryEditGalleryFileMetadataDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryEditFileMetadataPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edits file in client gallery, limit per request is 50mb. (Will have to be shared again to iklient)
         * @param {string} [idExistingFile] 
         * @param {File} [file] 
         * @param {ApiGalleryEditFilePutGalleryTypeEnum} [galleryType] 0 - General, 1 - MedicalReport, 2 - SignedDocumentation, 3 - HealthPlan, -1 - MedicalReportDetail
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryEditFilePut(idExistingFile?: string, file?: File, galleryType?: ApiGalleryEditFilePutGalleryTypeEnum, idMaster?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOGalleryGalleryFilesGrid2WithContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryEditFilePut(idExistingFile, file, galleryType, idMaster, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryEditFilePut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all possible company tags for file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetAllFileTagsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetAllFileTagsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetAllFileTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get client gallery based on galleryType
         * @param {string} [idMaster] Client that owns the gallery
         * @param {string} [idLastFile] Acts as start index in gallery
         * @param {number} [pageSize] Files count to fetch
         * @param {ApiGalleryGetClientGalleryGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Image,1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF, 6 &#x3D; None
         * @param {string} [thumbSize] Size of the thumbnail (if thumbnail type is NOT None)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetClientGalleryGet(idMaster?: string, idLastFile?: string, pageSize?: number, galleryType?: ApiGalleryGetClientGalleryGetGalleryTypeEnum, thumbnailAsType?: ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum, thumbSize?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOGalleryGroupedGalleryWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetClientGalleryGet(idMaster, idLastFile, pageSize, galleryType, thumbnailAsType, thumbSize, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetClientGalleryGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get client gallery based on galleryType
         * @param {string} [idMaster] Client that owns the gallery
         * @param {Array<string>} [idGalleries] Id of wanted galleries, for General it stays empty
         * @param {ApiGalleryGetClientGalleryTestGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetClientGalleryTestGet(idMaster?: string, idGalleries?: Array<string>, galleryType?: ApiGalleryGetClientGalleryTestGetGalleryTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOGalleryGroupedGalleryWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetClientGalleryTestGet(idMaster, idGalleries, galleryType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetClientGalleryTestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedExtendedBaseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetFileByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets file info by id
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetFileInfoByIdGet(idFile?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetFileInfoByIdGet(idFile, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetFileInfoByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets already set tags for specific file.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetFileTagsGet(idFile?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetFileTagsGet(idFile, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetFileTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets files grid
         * @param {APIXdentDTOGalleryGetFilesGridDto} [aPIXdentDTOGalleryGetFilesGridDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetFilesGridPost(aPIXdentDTOGalleryGetFilesGridDto?: APIXdentDTOGalleryGetFilesGridDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetFilesGridPost(aPIXdentDTOGalleryGetFilesGridDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetFilesGridPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns GalleryIds respective for each galleryType, General not included
         * @param {string} [idClient] 
         * @param {ApiGalleryGetGalleryIdsGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetGalleryIdsGet(idClient?: string, galleryType?: ApiGalleryGetGalleryIdsGetGalleryTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetGalleryIdsGet(idClient, galleryType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetGalleryIdsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedExtendedBaseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryGetThumbnailByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Shares file to iklient, on behalf of user company.
         * @param {string} [idFile] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryIklientShareGet(idFile?: string, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryIklientShareGet(idFile, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryIklientShareGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Saves the profile photo.
         * @param {APIXdentDTOGallerySaveProfilePhotoRequestDto} [aPIXdentDTOGallerySaveProfilePhotoRequestDto] The request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGallerySaveProfilePhotoPost(aPIXdentDTOGallerySaveProfilePhotoRequestDto?: APIXdentDTOGallerySaveProfilePhotoRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGallerySaveProfilePhotoPost(aPIXdentDTOGallerySaveProfilePhotoRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGallerySaveProfilePhotoPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the color of the client badge.
         * @param {APIXdentDTOGalleryUpdateClientBadgeColorRequestDto} [aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto] The request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryUpdateClientBadgeColorPost(aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto?: APIXdentDTOGalleryUpdateClientBadgeColorRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryUpdateClientBadgeColorPost(aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryUpdateClientBadgeColorPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads file into client gallery, limit per request is 50mb.
         * @param {File} [file] 
         * @param {ApiGalleryUploadFilePostGalleryTypeEnum} [galleryType] 
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryUploadFilePost(file?: File, galleryType?: ApiGalleryUploadFilePostGalleryTypeEnum, idMaster?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOGalleryGalleryFilesGrid2WithContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryUploadFilePost(file, galleryType, idMaster, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryUploadFilePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads file into client gallery, limit per request is 50mb.  Does not call upload service, only returns passed iFile, use this to setup your api call.  Only validates passed model, if returns Ok, gallery will accept this file.
         * @param {File} [file] 
         * @param {ApiGalleryUploadFileTestPostGalleryTypeEnum} [galleryType] 
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGalleryUploadFileTestPost(file?: File, galleryType?: ApiGalleryUploadFileTestPostGalleryTypeEnum, idMaster?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedUploadGalleryFileInternal>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGalleryUploadFileTestPost(file, galleryType, idMaster, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiGalleryUploadFileTestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} deviceToken 
         * @param {string} [idFile] 
         * @param {ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesGalleryGetFileByIdGet(deviceToken: string, idFile?: string, imageAsType?: ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedExtendedBaseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesGalleryGetFileByIdGet(deviceToken, idFile, imageAsType, extendedBaseModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiSafesignaturesGalleryGetFileByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} deviceToken 
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesGalleryGetThumbnailByIdGet(deviceToken: string, idFile?: string, size?: string, thumbnailAsType?: ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedExtendedBaseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesGalleryGetThumbnailByIdGet(deviceToken, idFile, size, thumbnailAsType, extendedBaseModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiSafesignaturesGalleryGetThumbnailByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return pdf from gallery by id iklient form as stream. Signed by our safe signatures public cert.
         * @param {string} deviceToken 
         * @param {string} [idForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesGallerySafeSignaturesPdfGet(deviceToken: string, idForm?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesGallerySafeSignaturesPdfGet(deviceToken, idForm, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GalleryApi.apiSafesignaturesGallerySafeSignaturesPdfGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GalleryApi - factory interface
 * @export
 */
export const GalleryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GalleryApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes file by id for owner user.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryDeleteFileDelete(idFile?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiGalleryDeleteFileDelete(idFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edits file metadata
         * @param {APIXdentDTOGalleryEditGalleryFileMetadataDto} [aPIXdentDTOGalleryEditGalleryFileMetadataDto] IdExistingFile is for file replacement; IdMaster is IdGallery, only used for new file upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryEditFileMetadataPut(aPIXdentDTOGalleryEditGalleryFileMetadataDto?: APIXdentDTOGalleryEditGalleryFileMetadataDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiGalleryEditFileMetadataPut(aPIXdentDTOGalleryEditGalleryFileMetadataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edits file in client gallery, limit per request is 50mb. (Will have to be shared again to iklient)
         * @param {string} [idExistingFile] 
         * @param {File} [file] 
         * @param {ApiGalleryEditFilePutGalleryTypeEnum} [galleryType] 0 - General, 1 - MedicalReport, 2 - SignedDocumentation, 3 - HealthPlan, -1 - MedicalReportDetail
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryEditFilePut(idExistingFile?: string, file?: File, galleryType?: ApiGalleryEditFilePutGalleryTypeEnum, idMaster?: string, options?: any): AxiosPromise<APISharedDTOGalleryGalleryFilesGrid2WithContentDto> {
            return localVarFp.apiGalleryEditFilePut(idExistingFile, file, galleryType, idMaster, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all possible company tags for file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetAllFileTagsGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGGRIDResult>> {
            return localVarFp.apiGalleryGetAllFileTagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get client gallery based on galleryType
         * @param {string} [idMaster] Client that owns the gallery
         * @param {string} [idLastFile] Acts as start index in gallery
         * @param {number} [pageSize] Files count to fetch
         * @param {ApiGalleryGetClientGalleryGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Image,1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF, 6 &#x3D; None
         * @param {string} [thumbSize] Size of the thumbnail (if thumbnail type is NOT None)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetClientGalleryGet(idMaster?: string, idLastFile?: string, pageSize?: number, galleryType?: ApiGalleryGetClientGalleryGetGalleryTypeEnum, thumbnailAsType?: ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum, thumbSize?: string, options?: any): AxiosPromise<APISharedDTOGalleryGroupedGalleryWrapperDto> {
            return localVarFp.apiGalleryGetClientGalleryGet(idMaster, idLastFile, pageSize, galleryType, thumbnailAsType, thumbSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get client gallery based on galleryType
         * @param {string} [idMaster] Client that owns the gallery
         * @param {Array<string>} [idGalleries] Id of wanted galleries, for General it stays empty
         * @param {ApiGalleryGetClientGalleryTestGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetClientGalleryTestGet(idMaster?: string, idGalleries?: Array<string>, galleryType?: ApiGalleryGetClientGalleryTestGetGalleryTypeEnum, options?: any): AxiosPromise<APISharedDTOGalleryGroupedGalleryWrapperDto> {
            return localVarFp.apiGalleryGetClientGalleryTestGet(idMaster, idGalleries, galleryType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: any): AxiosPromise<APISharedExtendedBaseModel> {
            return localVarFp.apiGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets file info by id
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetFileInfoByIdGet(idFile?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result> {
            return localVarFp.apiGalleryGetFileInfoByIdGet(idFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets already set tags for specific file.
         * @param {string} [idFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetFileTagsGet(idFile?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTAGENTITYGRIDResult>> {
            return localVarFp.apiGalleryGetFileTagsGet(idFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets files grid
         * @param {APIXdentDTOGalleryGetFilesGridDto} [aPIXdentDTOGalleryGetFilesGridDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetFilesGridPost(aPIXdentDTOGalleryGetFilesGridDto?: APIXdentDTOGalleryGetFilesGridDto, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedGALLERYFILESGRID2Result>> {
            return localVarFp.apiGalleryGetFilesGridPost(aPIXdentDTOGalleryGetFilesGridDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns GalleryIds respective for each galleryType, General not included
         * @param {string} [idClient] 
         * @param {ApiGalleryGetGalleryIdsGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetGalleryIdsGet(idClient?: string, galleryType?: ApiGalleryGetGalleryIdsGetGalleryTypeEnum, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiGalleryGetGalleryIdsGet(idClient, galleryType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: any): AxiosPromise<APISharedExtendedBaseModel> {
            return localVarFp.apiGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shares file to iklient, on behalf of user company.
         * @param {string} [idFile] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryIklientShareGet(idFile?: string, idClient?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiGalleryIklientShareGet(idFile, idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves the profile photo.
         * @param {APIXdentDTOGallerySaveProfilePhotoRequestDto} [aPIXdentDTOGallerySaveProfilePhotoRequestDto] The request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGallerySaveProfilePhotoPost(aPIXdentDTOGallerySaveProfilePhotoRequestDto?: APIXdentDTOGallerySaveProfilePhotoRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiGallerySaveProfilePhotoPost(aPIXdentDTOGallerySaveProfilePhotoRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the color of the client badge.
         * @param {APIXdentDTOGalleryUpdateClientBadgeColorRequestDto} [aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto] The request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryUpdateClientBadgeColorPost(aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto?: APIXdentDTOGalleryUpdateClientBadgeColorRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiGalleryUpdateClientBadgeColorPost(aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads file into client gallery, limit per request is 50mb.
         * @param {File} [file] 
         * @param {ApiGalleryUploadFilePostGalleryTypeEnum} [galleryType] 
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryUploadFilePost(file?: File, galleryType?: ApiGalleryUploadFilePostGalleryTypeEnum, idMaster?: string, options?: any): AxiosPromise<APISharedDTOGalleryGalleryFilesGrid2WithContentDto> {
            return localVarFp.apiGalleryUploadFilePost(file, galleryType, idMaster, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads file into client gallery, limit per request is 50mb.  Does not call upload service, only returns passed iFile, use this to setup your api call.  Only validates passed model, if returns Ok, gallery will accept this file.
         * @param {File} [file] 
         * @param {ApiGalleryUploadFileTestPostGalleryTypeEnum} [galleryType] 
         * @param {string} [idMaster] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGalleryUploadFileTestPost(file?: File, galleryType?: ApiGalleryUploadFileTestPostGalleryTypeEnum, idMaster?: string, options?: any): AxiosPromise<APISharedUploadGalleryFileInternal> {
            return localVarFp.apiGalleryUploadFileTestPost(file, galleryType, idMaster, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} deviceToken 
         * @param {string} [idFile] 
         * @param {ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesGalleryGetFileByIdGet(deviceToken: string, idFile?: string, imageAsType?: ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: any): AxiosPromise<APISharedExtendedBaseModel> {
            return localVarFp.apiSafesignaturesGalleryGetFileByIdGet(deviceToken, idFile, imageAsType, extendedBaseModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} deviceToken 
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesGalleryGetThumbnailByIdGet(deviceToken: string, idFile?: string, size?: string, thumbnailAsType?: ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: any): AxiosPromise<APISharedExtendedBaseModel> {
            return localVarFp.apiSafesignaturesGalleryGetThumbnailByIdGet(deviceToken, idFile, size, thumbnailAsType, extendedBaseModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return pdf from gallery by id iklient form as stream. Signed by our safe signatures public cert.
         * @param {string} deviceToken 
         * @param {string} [idForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesGallerySafeSignaturesPdfGet(deviceToken: string, idForm?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiSafesignaturesGallerySafeSignaturesPdfGet(deviceToken, idForm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GalleryApi - object-oriented interface
 * @export
 * @class GalleryApi
 * @extends {BaseAPI}
 */
export class GalleryApi extends BaseAPI {
    /**
     * 
     * @summary Deletes file by id for owner user.
     * @param {string} [idFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryDeleteFileDelete(idFile?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryDeleteFileDelete(idFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edits file metadata
     * @param {APIXdentDTOGalleryEditGalleryFileMetadataDto} [aPIXdentDTOGalleryEditGalleryFileMetadataDto] IdExistingFile is for file replacement; IdMaster is IdGallery, only used for new file upload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryEditFileMetadataPut(aPIXdentDTOGalleryEditGalleryFileMetadataDto?: APIXdentDTOGalleryEditGalleryFileMetadataDto, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryEditFileMetadataPut(aPIXdentDTOGalleryEditGalleryFileMetadataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edits file in client gallery, limit per request is 50mb. (Will have to be shared again to iklient)
     * @param {string} [idExistingFile] 
     * @param {File} [file] 
     * @param {ApiGalleryEditFilePutGalleryTypeEnum} [galleryType] 0 - General, 1 - MedicalReport, 2 - SignedDocumentation, 3 - HealthPlan, -1 - MedicalReportDetail
     * @param {string} [idMaster] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryEditFilePut(idExistingFile?: string, file?: File, galleryType?: ApiGalleryEditFilePutGalleryTypeEnum, idMaster?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryEditFilePut(idExistingFile, file, galleryType, idMaster, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all possible company tags for file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetAllFileTagsGet(options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetAllFileTagsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get client gallery based on galleryType
     * @param {string} [idMaster] Client that owns the gallery
     * @param {string} [idLastFile] Acts as start index in gallery
     * @param {number} [pageSize] Files count to fetch
     * @param {ApiGalleryGetClientGalleryGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
     * @param {ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Image,1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF, 6 &#x3D; None
     * @param {string} [thumbSize] Size of the thumbnail (if thumbnail type is NOT None)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetClientGalleryGet(idMaster?: string, idLastFile?: string, pageSize?: number, galleryType?: ApiGalleryGetClientGalleryGetGalleryTypeEnum, thumbnailAsType?: ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum, thumbSize?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetClientGalleryGet(idMaster, idLastFile, pageSize, galleryType, thumbnailAsType, thumbSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get client gallery based on galleryType
     * @param {string} [idMaster] Client that owns the gallery
     * @param {Array<string>} [idGalleries] Id of wanted galleries, for General it stays empty
     * @param {ApiGalleryGetClientGalleryTestGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetClientGalleryTestGet(idMaster?: string, idGalleries?: Array<string>, galleryType?: ApiGalleryGetClientGalleryTestGetGalleryTypeEnum, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetClientGalleryTestGet(idMaster, idGalleries, galleryType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return image from gallery by id as provided type
     * @param {string} [idFile] 
     * @param {ApiGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {boolean} [extendedBaseModel] Return extended base64 model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets file info by id
     * @param {string} [idFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetFileInfoByIdGet(idFile?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetFileInfoByIdGet(idFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets already set tags for specific file.
     * @param {string} [idFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetFileTagsGet(idFile?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetFileTagsGet(idFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets files grid
     * @param {APIXdentDTOGalleryGetFilesGridDto} [aPIXdentDTOGalleryGetFilesGridDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetFilesGridPost(aPIXdentDTOGalleryGetFilesGridDto?: APIXdentDTOGalleryGetFilesGridDto, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetFilesGridPost(aPIXdentDTOGalleryGetFilesGridDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns GalleryIds respective for each galleryType, General not included
     * @param {string} [idClient] 
     * @param {ApiGalleryGetGalleryIdsGetGalleryTypeEnum} [galleryType] 0 &#x3D; General,1 &#x3D; MedicalReport, 2 &#x3D; SignedDocs, 3 &#x3D; HealthPlan, (-1) Medical Report Detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetGalleryIdsGet(idClient?: string, galleryType?: ApiGalleryGetGalleryIdsGetGalleryTypeEnum, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetGalleryIdsGet(idClient, galleryType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return thumbnail from gallery by id as provided type
     * @param {string} [idFile] 
     * @param {string} [size] 
     * @param {ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {boolean} [extendedBaseModel] Returns extended base model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shares file to iklient, on behalf of user company.
     * @param {string} [idFile] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryIklientShareGet(idFile?: string, idClient?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryIklientShareGet(idFile, idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves the profile photo.
     * @param {APIXdentDTOGallerySaveProfilePhotoRequestDto} [aPIXdentDTOGallerySaveProfilePhotoRequestDto] The request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGallerySaveProfilePhotoPost(aPIXdentDTOGallerySaveProfilePhotoRequestDto?: APIXdentDTOGallerySaveProfilePhotoRequestDto, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGallerySaveProfilePhotoPost(aPIXdentDTOGallerySaveProfilePhotoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the color of the client badge.
     * @param {APIXdentDTOGalleryUpdateClientBadgeColorRequestDto} [aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto] The request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryUpdateClientBadgeColorPost(aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto?: APIXdentDTOGalleryUpdateClientBadgeColorRequestDto, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryUpdateClientBadgeColorPost(aPIXdentDTOGalleryUpdateClientBadgeColorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads file into client gallery, limit per request is 50mb.
     * @param {File} [file] 
     * @param {ApiGalleryUploadFilePostGalleryTypeEnum} [galleryType] 
     * @param {string} [idMaster] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryUploadFilePost(file?: File, galleryType?: ApiGalleryUploadFilePostGalleryTypeEnum, idMaster?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryUploadFilePost(file, galleryType, idMaster, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads file into client gallery, limit per request is 50mb.  Does not call upload service, only returns passed iFile, use this to setup your api call.  Only validates passed model, if returns Ok, gallery will accept this file.
     * @param {File} [file] 
     * @param {ApiGalleryUploadFileTestPostGalleryTypeEnum} [galleryType] 
     * @param {string} [idMaster] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiGalleryUploadFileTestPost(file?: File, galleryType?: ApiGalleryUploadFileTestPostGalleryTypeEnum, idMaster?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiGalleryUploadFileTestPost(file, galleryType, idMaster, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return image from gallery by id as provided type
     * @param {string} deviceToken 
     * @param {string} [idFile] 
     * @param {ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {boolean} [extendedBaseModel] Return extended base64 model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiSafesignaturesGalleryGetFileByIdGet(deviceToken: string, idFile?: string, imageAsType?: ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiSafesignaturesGalleryGetFileByIdGet(deviceToken, idFile, imageAsType, extendedBaseModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return thumbnail from gallery by id as provided type
     * @param {string} deviceToken 
     * @param {string} [idFile] 
     * @param {string} [size] 
     * @param {ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {boolean} [extendedBaseModel] Returns extended base model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiSafesignaturesGalleryGetThumbnailByIdGet(deviceToken: string, idFile?: string, size?: string, thumbnailAsType?: ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiSafesignaturesGalleryGetThumbnailByIdGet(deviceToken, idFile, size, thumbnailAsType, extendedBaseModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return pdf from gallery by id iklient form as stream. Signed by our safe signatures public cert.
     * @param {string} deviceToken 
     * @param {string} [idForm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GalleryApi
     */
    public apiSafesignaturesGallerySafeSignaturesPdfGet(deviceToken: string, idForm?: string, options?: AxiosRequestConfig) {
        return GalleryApiFp(this.configuration).apiSafesignaturesGallerySafeSignaturesPdfGet(deviceToken, idForm, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiGalleryEditFilePutGalleryTypeEnum = {
    General: 'General',
    MedicalReport: 'MedicalReport',
    SignedDocumentation: 'SignedDocumentation',
    HealthPlan: 'HealthPlan',
    MedicalReportDetail: 'MedicalReportDetail'
} as const;
export type ApiGalleryEditFilePutGalleryTypeEnum = typeof ApiGalleryEditFilePutGalleryTypeEnum[keyof typeof ApiGalleryEditFilePutGalleryTypeEnum];
/**
 * @export
 */
export const ApiGalleryGetClientGalleryGetGalleryTypeEnum = {
    General: 'General',
    MedicalReport: 'MedicalReport',
    SignedDocumentation: 'SignedDocumentation',
    HealthPlan: 'HealthPlan',
    MedicalReportDetail: 'MedicalReportDetail'
} as const;
export type ApiGalleryGetClientGalleryGetGalleryTypeEnum = typeof ApiGalleryGetClientGalleryGetGalleryTypeEnum[keyof typeof ApiGalleryGetClientGalleryGetGalleryTypeEnum];
/**
 * @export
 */
export const ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum = typeof ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum[keyof typeof ApiGalleryGetClientGalleryGetThumbnailAsTypeEnum];
/**
 * @export
 */
export const ApiGalleryGetClientGalleryTestGetGalleryTypeEnum = {
    General: 'General',
    MedicalReport: 'MedicalReport',
    SignedDocumentation: 'SignedDocumentation',
    HealthPlan: 'HealthPlan',
    MedicalReportDetail: 'MedicalReportDetail'
} as const;
export type ApiGalleryGetClientGalleryTestGetGalleryTypeEnum = typeof ApiGalleryGetClientGalleryTestGetGalleryTypeEnum[keyof typeof ApiGalleryGetClientGalleryTestGetGalleryTypeEnum];
/**
 * @export
 */
export const ApiGalleryGetFileByIdGetImageAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiGalleryGetFileByIdGetImageAsTypeEnum = typeof ApiGalleryGetFileByIdGetImageAsTypeEnum[keyof typeof ApiGalleryGetFileByIdGetImageAsTypeEnum];
/**
 * @export
 */
export const ApiGalleryGetGalleryIdsGetGalleryTypeEnum = {
    General: 'General',
    MedicalReport: 'MedicalReport',
    SignedDocumentation: 'SignedDocumentation',
    HealthPlan: 'HealthPlan',
    MedicalReportDetail: 'MedicalReportDetail'
} as const;
export type ApiGalleryGetGalleryIdsGetGalleryTypeEnum = typeof ApiGalleryGetGalleryIdsGetGalleryTypeEnum[keyof typeof ApiGalleryGetGalleryIdsGetGalleryTypeEnum];
/**
 * @export
 */
export const ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum = typeof ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum[keyof typeof ApiGalleryGetThumbnailByIdGetThumbnailAsTypeEnum];
/**
 * @export
 */
export const ApiGalleryUploadFilePostGalleryTypeEnum = {
    General: 'General',
    MedicalReport: 'MedicalReport',
    SignedDocumentation: 'SignedDocumentation',
    HealthPlan: 'HealthPlan',
    MedicalReportDetail: 'MedicalReportDetail'
} as const;
export type ApiGalleryUploadFilePostGalleryTypeEnum = typeof ApiGalleryUploadFilePostGalleryTypeEnum[keyof typeof ApiGalleryUploadFilePostGalleryTypeEnum];
/**
 * @export
 */
export const ApiGalleryUploadFileTestPostGalleryTypeEnum = {
    General: 'General',
    MedicalReport: 'MedicalReport',
    SignedDocumentation: 'SignedDocumentation',
    HealthPlan: 'HealthPlan',
    MedicalReportDetail: 'MedicalReportDetail'
} as const;
export type ApiGalleryUploadFileTestPostGalleryTypeEnum = typeof ApiGalleryUploadFileTestPostGalleryTypeEnum[keyof typeof ApiGalleryUploadFileTestPostGalleryTypeEnum];
/**
 * @export
 */
export const ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum = typeof ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum[keyof typeof ApiSafesignaturesGalleryGetFileByIdGetImageAsTypeEnum];
/**
 * @export
 */
export const ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum = typeof ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum[keyof typeof ApiSafesignaturesGalleryGetThumbnailByIdGetThumbnailAsTypeEnum];


/**
 * GlobalApi - axios parameter creator
 * @export
 */
export const GlobalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalDeleteEntityPost: async (idEntity?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Global/DeleteEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idEntity !== undefined) {
                localVarQueryParameter['idEntity'] = idEntity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalRestoreEntityPost: async (idEntity?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Global/RestoreEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idEntity !== undefined) {
                localVarQueryParameter['idEntity'] = idEntity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalApi - functional programming interface
 * @export
 */
export const GlobalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGlobalDeleteEntityPost(idEntity?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGlobalDeleteEntityPost(idEntity, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GlobalApi.apiGlobalDeleteEntityPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGlobalRestoreEntityPost(idEntity?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGlobalRestoreEntityPost(idEntity, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GlobalApi.apiGlobalRestoreEntityPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GlobalApi - factory interface
 * @export
 */
export const GlobalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalDeleteEntityPost(idEntity?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiGlobalDeleteEntityPost(idEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalRestoreEntityPost(idEntity?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiGlobalRestoreEntityPost(idEntity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalApi - object-oriented interface
 * @export
 * @class GlobalApi
 * @extends {BaseAPI}
 */
export class GlobalApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalApi
     */
    public apiGlobalDeleteEntityPost(idEntity?: string, options?: AxiosRequestConfig) {
        return GlobalApiFp(this.configuration).apiGlobalDeleteEntityPost(idEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalApi
     */
    public apiGlobalRestoreEntityPost(idEntity?: string, options?: AxiosRequestConfig) {
        return GlobalApiFp(this.configuration).apiGlobalRestoreEntityPost(idEntity, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GovEreceptApi - axios parameter creator
 * @export
 */
export const GovEreceptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMagistralis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentGovEreceptMagistralisGlobalGet: async (idMagistralis?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdent/gov/Erecept/MagistralisGlobal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMagistralis !== undefined) {
                localVarQueryParameter['idMagistralis'] = idMagistralis;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentGovEreceptStaffInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdent/gov/Erecept/StaffInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOGovEreceptZalozitPredpisRequestDto} [aPIXdentDTOGovEreceptZalozitPredpisRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentGovEreceptZalozitPredpisPost: async (aPIXdentDTOGovEreceptZalozitPredpisRequestDto?: APIXdentDTOGovEreceptZalozitPredpisRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdent/gov/Erecept/ZalozitPredpis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOGovEreceptZalozitPredpisRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GovEreceptApi - functional programming interface
 * @export
 */
export const GovEreceptApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GovEreceptApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMagistralis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentGovEreceptMagistralisGlobalGet(idMagistralis?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEreceptMagistralisData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentGovEreceptMagistralisGlobalGet(idMagistralis, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GovEreceptApi.apiXdentGovEreceptMagistralisGlobalGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentGovEreceptStaffInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentGovEreceptStaffInfoGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GovEreceptApi.apiXdentGovEreceptStaffInfoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOGovEreceptZalozitPredpisRequestDto} [aPIXdentDTOGovEreceptZalozitPredpisRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentGovEreceptZalozitPredpisPost(aPIXdentDTOGovEreceptZalozitPredpisRequestDto?: APIXdentDTOGovEreceptZalozitPredpisRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentGovEreceptZalozitPredpisPost(aPIXdentDTOGovEreceptZalozitPredpisRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GovEreceptApi.apiXdentGovEreceptZalozitPredpisPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GovEreceptApi - factory interface
 * @export
 */
export const GovEreceptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GovEreceptApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMagistralis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentGovEreceptMagistralisGlobalGet(idMagistralis?: string, options?: any): AxiosPromise<APIXdentDTOEreceptMagistralisData> {
            return localVarFp.apiXdentGovEreceptMagistralisGlobalGet(idMagistralis, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentGovEreceptStaffInfoGet(options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERPRIVILEGESFORMResult> {
            return localVarFp.apiXdentGovEreceptStaffInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOGovEreceptZalozitPredpisRequestDto} [aPIXdentDTOGovEreceptZalozitPredpisRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentGovEreceptZalozitPredpisPost(aPIXdentDTOGovEreceptZalozitPredpisRequestDto?: APIXdentDTOGovEreceptZalozitPredpisRequestDto, options?: any): AxiosPromise<APIXdentDTOEreceptSignedElectronicPrescriptionResponseDto> {
            return localVarFp.apiXdentGovEreceptZalozitPredpisPost(aPIXdentDTOGovEreceptZalozitPredpisRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GovEreceptApi - object-oriented interface
 * @export
 * @class GovEreceptApi
 * @extends {BaseAPI}
 */
export class GovEreceptApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMagistralis] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GovEreceptApi
     */
    public apiXdentGovEreceptMagistralisGlobalGet(idMagistralis?: string, options?: AxiosRequestConfig) {
        return GovEreceptApiFp(this.configuration).apiXdentGovEreceptMagistralisGlobalGet(idMagistralis, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GovEreceptApi
     */
    public apiXdentGovEreceptStaffInfoGet(options?: AxiosRequestConfig) {
        return GovEreceptApiFp(this.configuration).apiXdentGovEreceptStaffInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOGovEreceptZalozitPredpisRequestDto} [aPIXdentDTOGovEreceptZalozitPredpisRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GovEreceptApi
     */
    public apiXdentGovEreceptZalozitPredpisPost(aPIXdentDTOGovEreceptZalozitPredpisRequestDto?: APIXdentDTOGovEreceptZalozitPredpisRequestDto, options?: AxiosRequestConfig) {
        return GovEreceptApiFp(this.configuration).apiXdentGovEreceptZalozitPredpisPost(aPIXdentDTOGovEreceptZalozitPredpisRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GovVzpApi - axios parameter creator
 * @export
 */
export const GovVzpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOGovVzpRegistracePojistenceRequestDto} [aPIXdentDTOGovVzpRegistracePojistenceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentGovVzpRegistracePojistencePost: async (aPIXdentDTOGovVzpRegistracePojistenceRequestDto?: APIXdentDTOGovVzpRegistracePojistenceRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdent/gov/Vzp/RegistracePojistence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOGovVzpRegistracePojistenceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GovVzpApi - functional programming interface
 * @export
 */
export const GovVzpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GovVzpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOGovVzpRegistracePojistenceRequestDto} [aPIXdentDTOGovVzpRegistracePojistenceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentGovVzpRegistracePojistencePost(aPIXdentDTOGovVzpRegistracePojistenceRequestDto?: APIXdentDTOGovVzpRegistracePojistenceRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentGovVzpRegistracePojistencePost(aPIXdentDTOGovVzpRegistracePojistenceRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GovVzpApi.apiXdentGovVzpRegistracePojistencePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GovVzpApi - factory interface
 * @export
 */
export const GovVzpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GovVzpApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOGovVzpRegistracePojistenceRequestDto} [aPIXdentDTOGovVzpRegistracePojistenceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentGovVzpRegistracePojistencePost(aPIXdentDTOGovVzpRegistracePojistenceRequestDto?: APIXdentDTOGovVzpRegistracePojistenceRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiXdentGovVzpRegistracePojistencePost(aPIXdentDTOGovVzpRegistracePojistenceRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GovVzpApi - object-oriented interface
 * @export
 * @class GovVzpApi
 * @extends {BaseAPI}
 */
export class GovVzpApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOGovVzpRegistracePojistenceRequestDto} [aPIXdentDTOGovVzpRegistracePojistenceRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GovVzpApi
     */
    public apiXdentGovVzpRegistracePojistencePost(aPIXdentDTOGovVzpRegistracePojistenceRequestDto?: APIXdentDTOGovVzpRegistracePojistenceRequestDto, options?: AxiosRequestConfig) {
        return GovVzpApiFp(this.configuration).apiXdentGovVzpRegistracePojistencePost(aPIXdentDTOGovVzpRegistracePojistenceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImportApi - axios parameter creator
 * @export
 */
export const ImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {boolean} [hasHeader] 
         * @param {number} [indexesCode] index of code column in csv
         * @param {number} [indexesTitle] index of title column in csv
         * @param {number} [indexesText] index of text column in csv
         * @param {number} [indexesAnnotation] index of anotation column in csv
         * @param {string} [languageShortcode] 
         * @param {string} [codelistTypeCode] 
         * @param {string} [codelistTypeTitle] 
         * @param {boolean} [newCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportImportCodelistCsvPost: async (file?: File, hasHeader?: boolean, indexesCode?: number, indexesTitle?: number, indexesText?: number, indexesAnnotation?: number, languageShortcode?: string, codelistTypeCode?: string, codelistTypeTitle?: string, newCodelist?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Import/ImportCodelistCsv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (hasHeader !== undefined) { 
                localVarFormParams.append('hasHeader', hasHeader as any);
            }
    
            if (indexesCode !== undefined) { 
                localVarFormParams.append('indexes.code', indexesCode as any);
            }
    
            if (indexesTitle !== undefined) { 
                localVarFormParams.append('indexes.title', indexesTitle as any);
            }
    
            if (indexesText !== undefined) { 
                localVarFormParams.append('indexes.text', indexesText as any);
            }
    
            if (indexesAnnotation !== undefined) { 
                localVarFormParams.append('indexes.annotation', indexesAnnotation as any);
            }
    
            if (languageShortcode !== undefined) { 
                localVarFormParams.append('languageShortcode', languageShortcode as any);
            }
    
            if (codelistTypeCode !== undefined) { 
                localVarFormParams.append('codelistTypeCode', codelistTypeCode as any);
            }
    
            if (codelistTypeTitle !== undefined) { 
                localVarFormParams.append('codelistTypeTitle', codelistTypeTitle as any);
            }
    
            if (newCodelist !== undefined) { 
                localVarFormParams.append('newCodelist', newCodelist as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportApi - functional programming interface
 * @export
 */
export const ImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {boolean} [hasHeader] 
         * @param {number} [indexesCode] index of code column in csv
         * @param {number} [indexesTitle] index of title column in csv
         * @param {number} [indexesText] index of text column in csv
         * @param {number} [indexesAnnotation] index of anotation column in csv
         * @param {string} [languageShortcode] 
         * @param {string} [codelistTypeCode] 
         * @param {string} [codelistTypeTitle] 
         * @param {boolean} [newCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportImportCodelistCsvPost(file?: File, hasHeader?: boolean, indexesCode?: number, indexesTitle?: number, indexesText?: number, indexesAnnotation?: number, languageShortcode?: string, codelistTypeCode?: string, codelistTypeTitle?: string, newCodelist?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportImportCodelistCsvPost(file, hasHeader, indexesCode, indexesTitle, indexesText, indexesAnnotation, languageShortcode, codelistTypeCode, codelistTypeTitle, newCodelist, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImportApi.apiImportImportCodelistCsvPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ImportApi - factory interface
 * @export
 */
export const ImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {boolean} [hasHeader] 
         * @param {number} [indexesCode] index of code column in csv
         * @param {number} [indexesTitle] index of title column in csv
         * @param {number} [indexesText] index of text column in csv
         * @param {number} [indexesAnnotation] index of anotation column in csv
         * @param {string} [languageShortcode] 
         * @param {string} [codelistTypeCode] 
         * @param {string} [codelistTypeTitle] 
         * @param {boolean} [newCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportImportCodelistCsvPost(file?: File, hasHeader?: boolean, indexesCode?: number, indexesTitle?: number, indexesText?: number, indexesAnnotation?: number, languageShortcode?: string, codelistTypeCode?: string, codelistTypeTitle?: string, newCodelist?: boolean, options?: any): AxiosPromise<string> {
            return localVarFp.apiImportImportCodelistCsvPost(file, hasHeader, indexesCode, indexesTitle, indexesText, indexesAnnotation, languageShortcode, codelistTypeCode, codelistTypeTitle, newCodelist, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportApi - object-oriented interface
 * @export
 * @class ImportApi
 * @extends {BaseAPI}
 */
export class ImportApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {File} [file] 
     * @param {boolean} [hasHeader] 
     * @param {number} [indexesCode] index of code column in csv
     * @param {number} [indexesTitle] index of title column in csv
     * @param {number} [indexesText] index of text column in csv
     * @param {number} [indexesAnnotation] index of anotation column in csv
     * @param {string} [languageShortcode] 
     * @param {string} [codelistTypeCode] 
     * @param {string} [codelistTypeTitle] 
     * @param {boolean} [newCodelist] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    public apiImportImportCodelistCsvPost(file?: File, hasHeader?: boolean, indexesCode?: number, indexesTitle?: number, indexesText?: number, indexesAnnotation?: number, languageShortcode?: string, codelistTypeCode?: string, codelistTypeTitle?: string, newCodelist?: boolean, options?: AxiosRequestConfig) {
        return ImportApiFp(this.configuration).apiImportImportCodelistCsvPost(file, hasHeader, indexesCode, indexesTitle, indexesText, indexesAnnotation, languageShortcode, codelistTypeCode, codelistTypeTitle, newCodelist, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InsuranceApi - axios parameter creator
 * @export
 */
export const InsuranceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check insurance code add
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceRulesInsuranceCheckAddCode} [aPISharedInsuranceRulesInsuranceCheckAddCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceCheckAddCodePost: async (idXdentUser?: string, aPISharedInsuranceRulesInsuranceCheckAddCode?: APISharedInsuranceRulesInsuranceCheckAddCode, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/CheckAddCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedInsuranceRulesInsuranceCheckAddCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check insurance code advisor
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceRulesInsuranceCheckAdviseCode} [aPISharedInsuranceRulesInsuranceCheckAdviseCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceCheckAdviseCodePost: async (idXdentUser?: string, aPISharedInsuranceRulesInsuranceCheckAdviseCode?: APISharedInsuranceRulesInsuranceCheckAdviseCode, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/CheckAdviseCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedInsuranceRulesInsuranceCheckAdviseCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns medical reports for unlocking by given client
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceInvoiceGetLockedReportsModel} [aPISharedInsuranceInvoiceGetLockedReportsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceGetClientMedicalReportLockedPost: async (idXdentUser?: string, aPISharedInsuranceInvoiceGetLockedReportsModel?: APISharedInsuranceInvoiceGetLockedReportsModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/GetClientMedicalReportLocked`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedInsuranceInvoiceGetLockedReportsModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a custom insurance code
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceCustomCodeDelModel} [aPISharedInsuranceCustomCodeDelModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceInsuranceCustomCodeDeletePost: async (idXdentUser?: string, aPISharedInsuranceCustomCodeDelModel?: APISharedInsuranceCustomCodeDelModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/InsuranceCustomCodeDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedInsuranceCustomCodeDelModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get grid of custom insurance codes for a location
         * @param {string} [idLocation] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceInsuranceCustomCodeGridGet: async (idLocation?: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/InsuranceCustomCodeGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert or update a custom insurance code
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceCustomCodeIUModel} [aPISharedInsuranceCustomCodeIUModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceInsuranceCustomCodeIUPost: async (idXdentUser?: string, aPISharedInsuranceCustomCodeIUModel?: APISharedInsuranceCustomCodeIUModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/InsuranceCustomCodeIU`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedInsuranceCustomCodeIUModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate insurance invoice davky
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel} [aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceInsuranceInvoiceGeneratePost: async (idXdentUser?: string, aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel?: APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/InsuranceInvoiceGenerate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlocks medical report
         * @param {string} [idMedicalReport] 
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceUnlockMedicalReportPost: async (idMedicalReport?: string, idStaff?: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/UnlockMedicalReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlocks medical report - batch action
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceUnlockMedicalReportsBatchPost: async (idStaff?: string, idXdentUser?: string, requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Insurance/UnlockMedicalReportsBatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsuranceApi - functional programming interface
 * @export
 */
export const InsuranceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsuranceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check insurance code add
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceRulesInsuranceCheckAddCode} [aPISharedInsuranceRulesInsuranceCheckAddCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceCheckAddCodePost(idXdentUser?: string, aPISharedInsuranceRulesInsuranceCheckAddCode?: APISharedInsuranceRulesInsuranceCheckAddCode, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceCheckAddCodePost(idXdentUser, aPISharedInsuranceRulesInsuranceCheckAddCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceCheckAddCodePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Check insurance code advisor
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceRulesInsuranceCheckAdviseCode} [aPISharedInsuranceRulesInsuranceCheckAdviseCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceCheckAdviseCodePost(idXdentUser?: string, aPISharedInsuranceRulesInsuranceCheckAdviseCode?: APISharedInsuranceRulesInsuranceCheckAdviseCode, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceCheckAdviseCodePost(idXdentUser, aPISharedInsuranceRulesInsuranceCheckAdviseCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceCheckAdviseCodePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns medical reports for unlocking by given client
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceInvoiceGetLockedReportsModel} [aPISharedInsuranceInvoiceGetLockedReportsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceGetClientMedicalReportLockedPost(idXdentUser?: string, aPISharedInsuranceInvoiceGetLockedReportsModel?: APISharedInsuranceInvoiceGetLockedReportsModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceGetClientMedicalReportLockedPost(idXdentUser, aPISharedInsuranceInvoiceGetLockedReportsModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceGetClientMedicalReportLockedPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a custom insurance code
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceCustomCodeDelModel} [aPISharedInsuranceCustomCodeDelModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceInsuranceCustomCodeDeletePost(idXdentUser?: string, aPISharedInsuranceCustomCodeDelModel?: APISharedInsuranceCustomCodeDelModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceInsuranceCustomCodeDeletePost(idXdentUser, aPISharedInsuranceCustomCodeDelModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceInsuranceCustomCodeDeletePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get grid of custom insurance codes for a location
         * @param {string} [idLocation] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceInsuranceCustomCodeGridGet(idLocation?: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceInsuranceCustomCodeGridGet(idLocation, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceInsuranceCustomCodeGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Insert or update a custom insurance code
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceCustomCodeIUModel} [aPISharedInsuranceCustomCodeIUModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceInsuranceCustomCodeIUPost(idXdentUser?: string, aPISharedInsuranceCustomCodeIUModel?: APISharedInsuranceCustomCodeIUModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceInsuranceCustomCodeIUPost(idXdentUser, aPISharedInsuranceCustomCodeIUModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceInsuranceCustomCodeIUPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generate insurance invoice davky
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel} [aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceInsuranceInvoiceGeneratePost(idXdentUser?: string, aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel?: APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceInsuranceInvoiceGeneratePost(idXdentUser, aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceInsuranceInvoiceGeneratePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Unlocks medical report
         * @param {string} [idMedicalReport] 
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceUnlockMedicalReportPost(idMedicalReport?: string, idStaff?: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceUnlockMedicalReportPost(idMedicalReport, idStaff, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceUnlockMedicalReportPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Unlocks medical report - batch action
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceUnlockMedicalReportsBatchPost(idStaff?: string, idXdentUser?: string, requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceUnlockMedicalReportsBatchPost(idStaff, idXdentUser, requestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceApi.apiInsuranceUnlockMedicalReportsBatchPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * InsuranceApi - factory interface
 * @export
 */
export const InsuranceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsuranceApiFp(configuration)
    return {
        /**
         * 
         * @summary Check insurance code add
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceRulesInsuranceCheckAddCode} [aPISharedInsuranceRulesInsuranceCheckAddCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceCheckAddCodePost(idXdentUser?: string, aPISharedInsuranceRulesInsuranceCheckAddCode?: APISharedInsuranceRulesInsuranceCheckAddCode, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceCheckAddCodePost(idXdentUser, aPISharedInsuranceRulesInsuranceCheckAddCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check insurance code advisor
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceRulesInsuranceCheckAdviseCode} [aPISharedInsuranceRulesInsuranceCheckAdviseCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceCheckAdviseCodePost(idXdentUser?: string, aPISharedInsuranceRulesInsuranceCheckAdviseCode?: APISharedInsuranceRulesInsuranceCheckAdviseCode, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceCheckAdviseCodePost(idXdentUser, aPISharedInsuranceRulesInsuranceCheckAdviseCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns medical reports for unlocking by given client
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceInvoiceGetLockedReportsModel} [aPISharedInsuranceInvoiceGetLockedReportsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceGetClientMedicalReportLockedPost(idXdentUser?: string, aPISharedInsuranceInvoiceGetLockedReportsModel?: APISharedInsuranceInvoiceGetLockedReportsModel, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceGetClientMedicalReportLockedPost(idXdentUser, aPISharedInsuranceInvoiceGetLockedReportsModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a custom insurance code
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceCustomCodeDelModel} [aPISharedInsuranceCustomCodeDelModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceInsuranceCustomCodeDeletePost(idXdentUser?: string, aPISharedInsuranceCustomCodeDelModel?: APISharedInsuranceCustomCodeDelModel, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceInsuranceCustomCodeDeletePost(idXdentUser, aPISharedInsuranceCustomCodeDelModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get grid of custom insurance codes for a location
         * @param {string} [idLocation] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceInsuranceCustomCodeGridGet(idLocation?: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceInsuranceCustomCodeGridGet(idLocation, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert or update a custom insurance code
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceCustomCodeIUModel} [aPISharedInsuranceCustomCodeIUModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceInsuranceCustomCodeIUPost(idXdentUser?: string, aPISharedInsuranceCustomCodeIUModel?: APISharedInsuranceCustomCodeIUModel, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceInsuranceCustomCodeIUPost(idXdentUser, aPISharedInsuranceCustomCodeIUModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate insurance invoice davky
         * @param {string} [idXdentUser] 
         * @param {APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel} [aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceInsuranceInvoiceGeneratePost(idXdentUser?: string, aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel?: APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceInsuranceInvoiceGeneratePost(idXdentUser, aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlocks medical report
         * @param {string} [idMedicalReport] 
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceUnlockMedicalReportPost(idMedicalReport?: string, idStaff?: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceUnlockMedicalReportPost(idMedicalReport, idStaff, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlocks medical report - batch action
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceUnlockMedicalReportsBatchPost(idStaff?: string, idXdentUser?: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceUnlockMedicalReportsBatchPost(idStaff, idXdentUser, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsuranceApi - object-oriented interface
 * @export
 * @class InsuranceApi
 * @extends {BaseAPI}
 */
export class InsuranceApi extends BaseAPI {
    /**
     * 
     * @summary Check insurance code add
     * @param {string} [idXdentUser] 
     * @param {APISharedInsuranceRulesInsuranceCheckAddCode} [aPISharedInsuranceRulesInsuranceCheckAddCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceCheckAddCodePost(idXdentUser?: string, aPISharedInsuranceRulesInsuranceCheckAddCode?: APISharedInsuranceRulesInsuranceCheckAddCode, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceCheckAddCodePost(idXdentUser, aPISharedInsuranceRulesInsuranceCheckAddCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check insurance code advisor
     * @param {string} [idXdentUser] 
     * @param {APISharedInsuranceRulesInsuranceCheckAdviseCode} [aPISharedInsuranceRulesInsuranceCheckAdviseCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceCheckAdviseCodePost(idXdentUser?: string, aPISharedInsuranceRulesInsuranceCheckAdviseCode?: APISharedInsuranceRulesInsuranceCheckAdviseCode, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceCheckAdviseCodePost(idXdentUser, aPISharedInsuranceRulesInsuranceCheckAdviseCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns medical reports for unlocking by given client
     * @param {string} [idXdentUser] 
     * @param {APISharedInsuranceInvoiceGetLockedReportsModel} [aPISharedInsuranceInvoiceGetLockedReportsModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceGetClientMedicalReportLockedPost(idXdentUser?: string, aPISharedInsuranceInvoiceGetLockedReportsModel?: APISharedInsuranceInvoiceGetLockedReportsModel, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceGetClientMedicalReportLockedPost(idXdentUser, aPISharedInsuranceInvoiceGetLockedReportsModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a custom insurance code
     * @param {string} [idXdentUser] 
     * @param {APISharedInsuranceCustomCodeDelModel} [aPISharedInsuranceCustomCodeDelModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceInsuranceCustomCodeDeletePost(idXdentUser?: string, aPISharedInsuranceCustomCodeDelModel?: APISharedInsuranceCustomCodeDelModel, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceInsuranceCustomCodeDeletePost(idXdentUser, aPISharedInsuranceCustomCodeDelModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get grid of custom insurance codes for a location
     * @param {string} [idLocation] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceInsuranceCustomCodeGridGet(idLocation?: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceInsuranceCustomCodeGridGet(idLocation, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert or update a custom insurance code
     * @param {string} [idXdentUser] 
     * @param {APISharedInsuranceCustomCodeIUModel} [aPISharedInsuranceCustomCodeIUModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceInsuranceCustomCodeIUPost(idXdentUser?: string, aPISharedInsuranceCustomCodeIUModel?: APISharedInsuranceCustomCodeIUModel, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceInsuranceCustomCodeIUPost(idXdentUser, aPISharedInsuranceCustomCodeIUModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate insurance invoice davky
     * @param {string} [idXdentUser] 
     * @param {APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel} [aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceInsuranceInvoiceGeneratePost(idXdentUser?: string, aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel?: APISharedInsuranceInvoiceInsuranceInvoiceGenerateModel, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceInsuranceInvoiceGeneratePost(idXdentUser, aPISharedInsuranceInvoiceInsuranceInvoiceGenerateModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlocks medical report
     * @param {string} [idMedicalReport] 
     * @param {string} [idStaff] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceUnlockMedicalReportPost(idMedicalReport?: string, idStaff?: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceUnlockMedicalReportPost(idMedicalReport, idStaff, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlocks medical report - batch action
     * @param {string} [idStaff] 
     * @param {string} [idXdentUser] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceApi
     */
    public apiInsuranceUnlockMedicalReportsBatchPost(idStaff?: string, idXdentUser?: string, requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return InsuranceApiFp(this.configuration).apiInsuranceUnlockMedicalReportsBatchPost(idStaff, idXdentUser, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InsuranceItemApi - axios parameter creator
 * @export
 */
export const InsuranceItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {number} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {number} [clientAge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceItemGetInsuranceServiceCodesGet: async (query?: string, pageLimit?: number, idStaff?: string, clientAge?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InsuranceItem/GetInsuranceServiceCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['pageLimit'] = pageLimit;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (clientAge !== undefined) {
                localVarQueryParameter['clientAge'] = clientAge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceItemImportInsuranceItemsAsyncPost: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InsuranceItem/ImportInsuranceItemsAsync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsuranceItemApi - functional programming interface
 * @export
 */
export const InsuranceItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsuranceItemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {number} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {number} [clientAge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceItemGetInsuranceServiceCodesGet(query?: string, pageLimit?: number, idStaff?: string, clientAge?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceItemGetInsuranceServiceCodesGet(query, pageLimit, idStaff, clientAge, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceItemApi.apiInsuranceItemGetInsuranceServiceCodesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInsuranceItemImportInsuranceItemsAsyncPost(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInsuranceItemImportInsuranceItemsAsyncPost(file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InsuranceItemApi.apiInsuranceItemImportInsuranceItemsAsyncPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * InsuranceItemApi - factory interface
 * @export
 */
export const InsuranceItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsuranceItemApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {number} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {number} [clientAge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceItemGetInsuranceServiceCodesGet(query?: string, pageLimit?: number, idStaff?: string, clientAge?: number, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCELABORATORYITEMSSEARCHGRIDNEWResult>> {
            return localVarFp.apiInsuranceItemGetInsuranceServiceCodesGet(query, pageLimit, idStaff, clientAge, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInsuranceItemImportInsuranceItemsAsyncPost(file?: File, options?: any): AxiosPromise<void> {
            return localVarFp.apiInsuranceItemImportInsuranceItemsAsyncPost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsuranceItemApi - object-oriented interface
 * @export
 * @class InsuranceItemApi
 * @extends {BaseAPI}
 */
export class InsuranceItemApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [query] 
     * @param {number} [pageLimit] 
     * @param {string} [idStaff] 
     * @param {number} [clientAge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceItemApi
     */
    public apiInsuranceItemGetInsuranceServiceCodesGet(query?: string, pageLimit?: number, idStaff?: string, clientAge?: number, options?: AxiosRequestConfig) {
        return InsuranceItemApiFp(this.configuration).apiInsuranceItemGetInsuranceServiceCodesGet(query, pageLimit, idStaff, clientAge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsuranceItemApi
     */
    public apiInsuranceItemImportInsuranceItemsAsyncPost(file?: File, options?: AxiosRequestConfig) {
        return InsuranceItemApiFp(this.configuration).apiInsuranceItemImportInsuranceItemsAsyncPost(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoiceApi - axios parameter creator
 * @export
 */
export const InvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idInvoice 
         * @param {string} [kioskId] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalPay4uInvoicePayIdInvoiceCardPost: async (idInvoice: string, kioskId?: string, language?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idInvoice' is not null or undefined
            assertParamExists('apiExternalPay4uInvoicePayIdInvoiceCardPost', 'idInvoice', idInvoice)
            const localVarPath = `/api/external/pay4u/invoice/pay/{idInvoice}/card`
                .replace(`{${"idInvoice"}}`, encodeURIComponent(String(idInvoice)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (kioskId != null) {
                localVarHeaderParameter['kioskId'] = String(kioskId);
            }

            if (language != null) {
                localVarHeaderParameter['language'] = String(language);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} searchType 
         * @param {string} searchId 
         * @param {string} [kioskId] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet: async (searchType: string, searchId: string, kioskId?: string, language?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchType' is not null or undefined
            assertParamExists('apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet', 'searchType', searchType)
            // verify required parameter 'searchId' is not null or undefined
            assertParamExists('apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet', 'searchId', searchId)
            const localVarPath = `/api/external/pay4u/invoice/search/{searchType}/{searchId}`
                .replace(`{${"searchType"}}`, encodeURIComponent(String(searchType)))
                .replace(`{${"searchId"}}`, encodeURIComponent(String(searchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (kioskId != null) {
                localVarHeaderParameter['kioskId'] = String(kioskId);
            }

            if (language != null) {
                localVarHeaderParameter['language'] = String(language);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes the invoice.
         * @param {string} [id] 
         * @param {string} [type] 
         * @param {boolean} [delTransaction] 
         * @param {boolean} [storeUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceDeleteInvoiceDelete: async (id?: string, type?: string, delTransaction?: boolean, storeUpdate?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/DeleteInvoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (delTransaction !== undefined) {
                localVarQueryParameter['delTransaction'] = delTransaction;
            }

            if (storeUpdate !== undefined) {
                localVarQueryParameter['storeUpdate'] = storeUpdate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceInvoiceExportConfigDto} [aPIXdentDTOInvoiceInvoiceExportConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceExportInvoicePost: async (aPIXdentDTOInvoiceInvoiceExportConfigDto?: APIXdentDTOInvoiceInvoiceExportConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/ExportInvoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOInvoiceInvoiceExportConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceInvoiceExportRangeConfigDto} [aPIXdentDTOInvoiceInvoiceExportRangeConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceExportInvoiceRangePost: async (aPIXdentDTOInvoiceInvoiceExportRangeConfigDto?: APIXdentDTOInvoiceInvoiceExportRangeConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/ExportInvoiceRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOInvoiceInvoiceExportRangeConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceFilterClientsPartnersGet: async (data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/FilterClientsPartners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {number} [itemLimit] 
         * @param {boolean} [showMacro] 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceFilterInvoiceItemsGet: async (query?: string, itemLimit?: number, showMacro?: boolean, activeOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/FilterInvoiceItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (itemLimit !== undefined) {
                localVarQueryParameter['itemLimit'] = itemLimit;
            }

            if (showMacro !== undefined) {
                localVarQueryParameter['showMacro'] = showMacro;
            }

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the currency rates.
         * @param {string} [idLocation] Can be null. Used for fixed currency location settings. Overrides the actual rate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetCurrencyRatesGet: async (idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/GetCurrencyRates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the invoice data.
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceDataGet: async (id: string, language: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInvoiceGetInvoiceDataGet', 'id', id)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiInvoiceGetInvoiceDataGet', 'language', language)
            const localVarPath = `/api/Invoice/GetInvoiceData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idIssuer] 
         * @param {string} [idStaff] 
         * @param {string} [idInvoiceType] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceListAfterDueGet: async (idLocation?: string, idIssuer?: string, idStaff?: string, idInvoiceType?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/GetInvoiceListAfterDue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (idIssuer !== undefined) {
                localVarQueryParameter['idIssuer'] = idIssuer;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (idInvoiceType !== undefined) {
                localVarQueryParameter['idInvoiceType'] = idInvoiceType;
            }

            if (idBillingType !== undefined) {
                localVarQueryParameter['idBillingType'] = idBillingType;
            }

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateFinish !== undefined) {
                localVarQueryParameter['dateFinish'] = dateFinish;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idIssuer] 
         * @param {string} [idStaff] 
         * @param {string} [idInvoiceType] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceListGet: async (idLocation?: string, idIssuer?: string, idStaff?: string, idInvoiceType?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/GetInvoiceList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (idIssuer !== undefined) {
                localVarQueryParameter['idIssuer'] = idIssuer;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (idInvoiceType !== undefined) {
                localVarQueryParameter['idInvoiceType'] = idInvoiceType;
            }

            if (idBillingType !== undefined) {
                localVarQueryParameter['idBillingType'] = idBillingType;
            }

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateFinish !== undefined) {
                localVarQueryParameter['dateFinish'] = dateFinish;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets company invoice settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/GetInvoiceSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idStaff] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceTransactionListGet: async (idLocation?: string, idStaff?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/GetInvoiceTransactionList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (idBillingType !== undefined) {
                localVarQueryParameter['idBillingType'] = idBillingType;
            }

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateFinish !== undefined) {
                localVarQueryParameter['dateFinish'] = dateFinish;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceTrashListGet: async (idLocation?: string, dateStart?: string, dateFinish?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/GetInvoiceTrashList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateFinish !== undefined) {
                localVarQueryParameter['dateFinish'] = dateFinish;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetUserCreditDebtGet: async (idUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/GetUserCreditDebt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idUser !== undefined) {
                localVarQueryParameter['idUser'] = idUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [id] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceLoadMacroItemsGet: async (id?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/LoadMacroItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceSaveInvoiceDto} [aPIXdentDTOInvoiceSaveInvoiceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceSaveInvoicePost: async (aPIXdentDTOInvoiceSaveInvoiceDto?: APIXdentDTOInvoiceSaveInvoiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/SaveInvoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOInvoiceSaveInvoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [location] 
         * @param {Date} [from] 
         * @param {Date} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceSummaryInvoiceGridGet: async (location?: string, from?: Date, to?: Date, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invoice/SummaryInvoiceGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceApi - functional programming interface
 * @export
 */
export const InvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idInvoice 
         * @param {string} [kioskId] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalPay4uInvoicePayIdInvoiceCardPost(idInvoice: string, kioskId?: string, language?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOPayment4UPayInvoiceApiResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalPay4uInvoicePayIdInvoiceCardPost(idInvoice, kioskId, language, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiExternalPay4uInvoicePayIdInvoiceCardPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} searchType 
         * @param {string} searchId 
         * @param {string} [kioskId] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet(searchType: string, searchId: string, kioskId?: string, language?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet(searchType, searchId, kioskId, language, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes the invoice.
         * @param {string} [id] 
         * @param {string} [type] 
         * @param {boolean} [delTransaction] 
         * @param {boolean} [storeUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceDeleteInvoiceDelete(id?: string, type?: string, delTransaction?: boolean, storeUpdate?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOInvoiceInvoiceDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceDeleteInvoiceDelete(id, type, delTransaction, storeUpdate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceDeleteInvoiceDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceInvoiceExportConfigDto} [aPIXdentDTOInvoiceInvoiceExportConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceExportInvoicePost(aPIXdentDTOInvoiceInvoiceExportConfigDto?: APIXdentDTOInvoiceInvoiceExportConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceExportInvoicePost(aPIXdentDTOInvoiceInvoiceExportConfigDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceExportInvoicePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceInvoiceExportRangeConfigDto} [aPIXdentDTOInvoiceInvoiceExportRangeConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceExportInvoiceRangePost(aPIXdentDTOInvoiceInvoiceExportRangeConfigDto?: APIXdentDTOInvoiceInvoiceExportRangeConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceExportInvoiceRangePost(aPIXdentDTOInvoiceInvoiceExportRangeConfigDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceExportInvoiceRangePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceFilterClientsPartnersGet(data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceClientPartnerFilterHelpDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceFilterClientsPartnersGet(data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceFilterClientsPartnersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {number} [itemLimit] 
         * @param {boolean} [showMacro] 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceFilterInvoiceItemsGet(query?: string, itemLimit?: number, showMacro?: boolean, activeOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceInvoiceCodesItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceFilterInvoiceItemsGet(query, itemLimit, showMacro, activeOnly, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceFilterInvoiceItemsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the currency rates.
         * @param {string} [idLocation] Can be null. Used for fixed currency location settings. Overrides the actual rate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceGetCurrencyRatesGet(idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedServicesCurrencyRate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGetCurrencyRatesGet(idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceGetCurrencyRatesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the invoice data.
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceGetInvoiceDataGet(id: string, language: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOInvoiceInvoiceDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGetInvoiceDataGet(id, language, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceGetInvoiceDataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idIssuer] 
         * @param {string} [idStaff] 
         * @param {string} [idInvoiceType] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceGetInvoiceListAfterDueGet(idLocation?: string, idIssuer?: string, idStaff?: string, idInvoiceType?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceInvoiceGridInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGetInvoiceListAfterDueGet(idLocation, idIssuer, idStaff, idInvoiceType, idBillingType, dateStart, dateFinish, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceGetInvoiceListAfterDueGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idIssuer] 
         * @param {string} [idStaff] 
         * @param {string} [idInvoiceType] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceGetInvoiceListGet(idLocation?: string, idIssuer?: string, idStaff?: string, idInvoiceType?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceInvoiceGridInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGetInvoiceListGet(idLocation, idIssuer, idStaff, idInvoiceType, idBillingType, dateStart, dateFinish, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceGetInvoiceListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets company invoice settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceGetInvoiceSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOInvoiceInvoiceSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGetInvoiceSettingsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceGetInvoiceSettingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idStaff] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceGetInvoiceTransactionListGet(idLocation?: string, idStaff?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceInvoiceTransactionInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGetInvoiceTransactionListGet(idLocation, idStaff, idBillingType, dateStart, dateFinish, lang, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceGetInvoiceTransactionListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceGetInvoiceTrashListGet(idLocation?: string, dateStart?: string, dateFinish?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceInvoiceGridInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGetInvoiceTrashListGet(idLocation, dateStart, dateFinish, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceGetInvoiceTrashListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceGetUserCreditDebtGet(idUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTATSUSERINVOICEResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGetUserCreditDebtGet(idUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceGetUserCreditDebtGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [id] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceLoadMacroItemsGet(id?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceInvoiceCodesItemHelpDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceLoadMacroItemsGet(id, lang, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceLoadMacroItemsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceSaveInvoiceDto} [aPIXdentDTOInvoiceSaveInvoiceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceSaveInvoicePost(aPIXdentDTOInvoiceSaveInvoiceDto?: APIXdentDTOInvoiceSaveInvoiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOInvoiceInvoiceReturnInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceSaveInvoicePost(aPIXdentDTOInvoiceSaveInvoiceDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceSaveInvoicePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [location] 
         * @param {Date} [from] 
         * @param {Date} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceSummaryInvoiceGridGet(location?: string, from?: Date, to?: Date, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceSummaryInvoiceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceSummaryInvoiceGridGet(location, from, to, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceApi.apiInvoiceSummaryInvoiceGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * InvoiceApi - factory interface
 * @export
 */
export const InvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idInvoice 
         * @param {string} [kioskId] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalPay4uInvoicePayIdInvoiceCardPost(idInvoice: string, kioskId?: string, language?: string, options?: any): AxiosPromise<APIXdentDTOPayment4UPayInvoiceApiResponseDto> {
            return localVarFp.apiExternalPay4uInvoicePayIdInvoiceCardPost(idInvoice, kioskId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} searchType 
         * @param {string} searchId 
         * @param {string} [kioskId] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet(searchType: string, searchId: string, kioskId?: string, language?: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet(searchType, searchId, kioskId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes the invoice.
         * @param {string} [id] 
         * @param {string} [type] 
         * @param {boolean} [delTransaction] 
         * @param {boolean} [storeUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceDeleteInvoiceDelete(id?: string, type?: string, delTransaction?: boolean, storeUpdate?: boolean, options?: any): AxiosPromise<APIXdentDTOInvoiceInvoiceDataDto> {
            return localVarFp.apiInvoiceDeleteInvoiceDelete(id, type, delTransaction, storeUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceInvoiceExportConfigDto} [aPIXdentDTOInvoiceInvoiceExportConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceExportInvoicePost(aPIXdentDTOInvoiceInvoiceExportConfigDto?: APIXdentDTOInvoiceInvoiceExportConfigDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiInvoiceExportInvoicePost(aPIXdentDTOInvoiceInvoiceExportConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceInvoiceExportRangeConfigDto} [aPIXdentDTOInvoiceInvoiceExportRangeConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceExportInvoiceRangePost(aPIXdentDTOInvoiceInvoiceExportRangeConfigDto?: APIXdentDTOInvoiceInvoiceExportRangeConfigDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiInvoiceExportInvoiceRangePost(aPIXdentDTOInvoiceInvoiceExportRangeConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceFilterClientsPartnersGet(data?: string, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceClientPartnerFilterHelpDto>> {
            return localVarFp.apiInvoiceFilterClientsPartnersGet(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [query] 
         * @param {number} [itemLimit] 
         * @param {boolean} [showMacro] 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceFilterInvoiceItemsGet(query?: string, itemLimit?: number, showMacro?: boolean, activeOnly?: boolean, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceInvoiceCodesItemDto>> {
            return localVarFp.apiInvoiceFilterInvoiceItemsGet(query, itemLimit, showMacro, activeOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the currency rates.
         * @param {string} [idLocation] Can be null. Used for fixed currency location settings. Overrides the actual rate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetCurrencyRatesGet(idLocation?: string, options?: any): AxiosPromise<Array<APISharedServicesCurrencyRate>> {
            return localVarFp.apiInvoiceGetCurrencyRatesGet(idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the invoice data.
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceDataGet(id: string, language: string, options?: any): AxiosPromise<APIXdentDTOInvoiceInvoiceDataDto> {
            return localVarFp.apiInvoiceGetInvoiceDataGet(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idIssuer] 
         * @param {string} [idStaff] 
         * @param {string} [idInvoiceType] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceListAfterDueGet(idLocation?: string, idIssuer?: string, idStaff?: string, idInvoiceType?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceInvoiceGridInfoDto>> {
            return localVarFp.apiInvoiceGetInvoiceListAfterDueGet(idLocation, idIssuer, idStaff, idInvoiceType, idBillingType, dateStart, dateFinish, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idIssuer] 
         * @param {string} [idStaff] 
         * @param {string} [idInvoiceType] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceListGet(idLocation?: string, idIssuer?: string, idStaff?: string, idInvoiceType?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceInvoiceGridInfoDto>> {
            return localVarFp.apiInvoiceGetInvoiceListGet(idLocation, idIssuer, idStaff, idInvoiceType, idBillingType, dateStart, dateFinish, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets company invoice settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceSettingsGet(options?: any): AxiosPromise<APIXdentDTOInvoiceInvoiceSettingsDto> {
            return localVarFp.apiInvoiceGetInvoiceSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idStaff] 
         * @param {string} [idBillingType] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceTransactionListGet(idLocation?: string, idStaff?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, lang?: string, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceInvoiceTransactionInfoDto>> {
            return localVarFp.apiInvoiceGetInvoiceTransactionListGet(idLocation, idStaff, idBillingType, dateStart, dateFinish, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [dateStart] 
         * @param {string} [dateFinish] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetInvoiceTrashListGet(idLocation?: string, dateStart?: string, dateFinish?: string, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceInvoiceGridInfoDto>> {
            return localVarFp.apiInvoiceGetInvoiceTrashListGet(idLocation, dateStart, dateFinish, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceGetUserCreditDebtGet(idUser?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTATSUSERINVOICEResult> {
            return localVarFp.apiInvoiceGetUserCreditDebtGet(idUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [id] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceLoadMacroItemsGet(id?: string, lang?: string, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceInvoiceCodesItemHelpDto>> {
            return localVarFp.apiInvoiceLoadMacroItemsGet(id, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceSaveInvoiceDto} [aPIXdentDTOInvoiceSaveInvoiceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceSaveInvoicePost(aPIXdentDTOInvoiceSaveInvoiceDto?: APIXdentDTOInvoiceSaveInvoiceDto, options?: any): AxiosPromise<APIXdentDTOInvoiceInvoiceReturnInfoDto> {
            return localVarFp.apiInvoiceSaveInvoicePost(aPIXdentDTOInvoiceSaveInvoiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [location] 
         * @param {Date} [from] 
         * @param {Date} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceSummaryInvoiceGridGet(location?: string, from?: Date, to?: Date, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceSummaryInvoiceDto>> {
            return localVarFp.apiInvoiceSummaryInvoiceGridGet(location, from, to, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceApi - object-oriented interface
 * @export
 * @class InvoiceApi
 * @extends {BaseAPI}
 */
export class InvoiceApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} idInvoice 
     * @param {string} [kioskId] 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiExternalPay4uInvoicePayIdInvoiceCardPost(idInvoice: string, kioskId?: string, language?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiExternalPay4uInvoicePayIdInvoiceCardPost(idInvoice, kioskId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} searchType 
     * @param {string} searchId 
     * @param {string} [kioskId] 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet(searchType: string, searchId: string, kioskId?: string, language?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiExternalPay4uInvoiceSearchSearchTypeSearchIdGet(searchType, searchId, kioskId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes the invoice.
     * @param {string} [id] 
     * @param {string} [type] 
     * @param {boolean} [delTransaction] 
     * @param {boolean} [storeUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceDeleteInvoiceDelete(id?: string, type?: string, delTransaction?: boolean, storeUpdate?: boolean, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceDeleteInvoiceDelete(id, type, delTransaction, storeUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOInvoiceInvoiceExportConfigDto} [aPIXdentDTOInvoiceInvoiceExportConfigDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceExportInvoicePost(aPIXdentDTOInvoiceInvoiceExportConfigDto?: APIXdentDTOInvoiceInvoiceExportConfigDto, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceExportInvoicePost(aPIXdentDTOInvoiceInvoiceExportConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOInvoiceInvoiceExportRangeConfigDto} [aPIXdentDTOInvoiceInvoiceExportRangeConfigDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceExportInvoiceRangePost(aPIXdentDTOInvoiceInvoiceExportRangeConfigDto?: APIXdentDTOInvoiceInvoiceExportRangeConfigDto, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceExportInvoiceRangePost(aPIXdentDTOInvoiceInvoiceExportRangeConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceFilterClientsPartnersGet(data?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceFilterClientsPartnersGet(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [query] 
     * @param {number} [itemLimit] 
     * @param {boolean} [showMacro] 
     * @param {boolean} [activeOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceFilterInvoiceItemsGet(query?: string, itemLimit?: number, showMacro?: boolean, activeOnly?: boolean, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceFilterInvoiceItemsGet(query, itemLimit, showMacro, activeOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the currency rates.
     * @param {string} [idLocation] Can be null. Used for fixed currency location settings. Overrides the actual rate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceGetCurrencyRatesGet(idLocation?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceGetCurrencyRatesGet(idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the invoice data.
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceGetInvoiceDataGet(id: string, language: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceGetInvoiceDataGet(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLocation] 
     * @param {string} [idIssuer] 
     * @param {string} [idStaff] 
     * @param {string} [idInvoiceType] 
     * @param {string} [idBillingType] 
     * @param {string} [dateStart] 
     * @param {string} [dateFinish] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceGetInvoiceListAfterDueGet(idLocation?: string, idIssuer?: string, idStaff?: string, idInvoiceType?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceGetInvoiceListAfterDueGet(idLocation, idIssuer, idStaff, idInvoiceType, idBillingType, dateStart, dateFinish, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLocation] 
     * @param {string} [idIssuer] 
     * @param {string} [idStaff] 
     * @param {string} [idInvoiceType] 
     * @param {string} [idBillingType] 
     * @param {string} [dateStart] 
     * @param {string} [dateFinish] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceGetInvoiceListGet(idLocation?: string, idIssuer?: string, idStaff?: string, idInvoiceType?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceGetInvoiceListGet(idLocation, idIssuer, idStaff, idInvoiceType, idBillingType, dateStart, dateFinish, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets company invoice settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceGetInvoiceSettingsGet(options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceGetInvoiceSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLocation] 
     * @param {string} [idStaff] 
     * @param {string} [idBillingType] 
     * @param {string} [dateStart] 
     * @param {string} [dateFinish] 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceGetInvoiceTransactionListGet(idLocation?: string, idStaff?: string, idBillingType?: string, dateStart?: string, dateFinish?: string, lang?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceGetInvoiceTransactionListGet(idLocation, idStaff, idBillingType, dateStart, dateFinish, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLocation] 
     * @param {string} [dateStart] 
     * @param {string} [dateFinish] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceGetInvoiceTrashListGet(idLocation?: string, dateStart?: string, dateFinish?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceGetInvoiceTrashListGet(idLocation, dateStart, dateFinish, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceGetUserCreditDebtGet(idUser?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceGetUserCreditDebtGet(idUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [id] 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceLoadMacroItemsGet(id?: string, lang?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceLoadMacroItemsGet(id, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOInvoiceSaveInvoiceDto} [aPIXdentDTOInvoiceSaveInvoiceDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceSaveInvoicePost(aPIXdentDTOInvoiceSaveInvoiceDto?: APIXdentDTOInvoiceSaveInvoiceDto, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceSaveInvoicePost(aPIXdentDTOInvoiceSaveInvoiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [location] 
     * @param {Date} [from] 
     * @param {Date} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiInvoiceSummaryInvoiceGridGet(location?: string, from?: Date, to?: Date, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceSummaryInvoiceGridGet(location, from, to, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoiceNoteApi - axios parameter creator
 * @export
 */
export const InvoiceNoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceNoteDeleteDataNotePost: async (data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InvoiceNote/DeleteDataNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceNoteLoadDataNoteGet: async (data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InvoiceNote/LoadDataNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceNoteLoadDataNoteListGet: async (data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InvoiceNote/LoadDataNoteList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceNoteInvoiceNoteDto} [aPIXdentDTOInvoiceNoteInvoiceNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceNoteSaveDataNotePost: async (aPIXdentDTOInvoiceNoteInvoiceNoteDto?: APIXdentDTOInvoiceNoteInvoiceNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InvoiceNote/SaveDataNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOInvoiceNoteInvoiceNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceNoteApi - functional programming interface
 * @export
 */
export const InvoiceNoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceNoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceNoteDeleteDataNotePost(data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceNoteDeleteDataNotePost(data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceNoteApi.apiInvoiceNoteDeleteDataNotePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceNoteLoadDataNoteGet(data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOInvoiceNoteInvoiceNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceNoteLoadDataNoteGet(data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceNoteApi.apiInvoiceNoteLoadDataNoteGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceNoteLoadDataNoteListGet(data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOInvoiceNoteInvoiceNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceNoteLoadDataNoteListGet(data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceNoteApi.apiInvoiceNoteLoadDataNoteListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceNoteInvoiceNoteDto} [aPIXdentDTOInvoiceNoteInvoiceNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceNoteSaveDataNotePost(aPIXdentDTOInvoiceNoteInvoiceNoteDto?: APIXdentDTOInvoiceNoteInvoiceNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceNoteSaveDataNotePost(aPIXdentDTOInvoiceNoteInvoiceNoteDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InvoiceNoteApi.apiInvoiceNoteSaveDataNotePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * InvoiceNoteApi - factory interface
 * @export
 */
export const InvoiceNoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceNoteApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceNoteDeleteDataNotePost(data?: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiInvoiceNoteDeleteDataNotePost(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceNoteLoadDataNoteGet(data?: string, options?: any): AxiosPromise<APIXdentDTOInvoiceNoteInvoiceNoteDto> {
            return localVarFp.apiInvoiceNoteLoadDataNoteGet(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceNoteLoadDataNoteListGet(data?: string, options?: any): AxiosPromise<Array<APIXdentDTOInvoiceNoteInvoiceNoteDto>> {
            return localVarFp.apiInvoiceNoteLoadDataNoteListGet(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOInvoiceNoteInvoiceNoteDto} [aPIXdentDTOInvoiceNoteInvoiceNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceNoteSaveDataNotePost(aPIXdentDTOInvoiceNoteInvoiceNoteDto?: APIXdentDTOInvoiceNoteInvoiceNoteDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiInvoiceNoteSaveDataNotePost(aPIXdentDTOInvoiceNoteInvoiceNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceNoteApi - object-oriented interface
 * @export
 * @class InvoiceNoteApi
 * @extends {BaseAPI}
 */
export class InvoiceNoteApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceNoteApi
     */
    public apiInvoiceNoteDeleteDataNotePost(data?: string, options?: AxiosRequestConfig) {
        return InvoiceNoteApiFp(this.configuration).apiInvoiceNoteDeleteDataNotePost(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceNoteApi
     */
    public apiInvoiceNoteLoadDataNoteGet(data?: string, options?: AxiosRequestConfig) {
        return InvoiceNoteApiFp(this.configuration).apiInvoiceNoteLoadDataNoteGet(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceNoteApi
     */
    public apiInvoiceNoteLoadDataNoteListGet(data?: string, options?: AxiosRequestConfig) {
        return InvoiceNoteApiFp(this.configuration).apiInvoiceNoteLoadDataNoteListGet(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOInvoiceNoteInvoiceNoteDto} [aPIXdentDTOInvoiceNoteInvoiceNoteDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceNoteApi
     */
    public apiInvoiceNoteSaveDataNotePost(aPIXdentDTOInvoiceNoteInvoiceNoteDto?: APIXdentDTOInvoiceNoteInvoiceNoteDto, options?: AxiosRequestConfig) {
        return InvoiceNoteApiFp(this.configuration).apiInvoiceNoteSaveDataNotePost(aPIXdentDTOInvoiceNoteInvoiceNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JsAuthApi - axios parameter creator
 * @export
 */
export const JsAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticates user by provided id from xdent BE. (Audience for community)
         * @param {string} idXdentUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJsAuthAuthByIdCommunityPost: async (idXdentUser: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idXdentUser' is not null or undefined
            assertParamExists('apiJsAuthAuthByIdCommunityPost', 'idXdentUser', idXdentUser)
            const localVarPath = `/api/JsAuth/AuthByIdCommunity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticates user by provided id from xdent BE.
         * @param {string} idXdentUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJsAuthAuthByIdPost: async (idXdentUser: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idXdentUser' is not null or undefined
            assertParamExists('apiJsAuthAuthByIdPost', 'idXdentUser', idXdentUser)
            const localVarPath = `/api/JsAuth/AuthById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JsAuthApi - functional programming interface
 * @export
 */
export const JsAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JsAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticates user by provided id from xdent BE. (Audience for community)
         * @param {string} idXdentUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiJsAuthAuthByIdCommunityPost(idXdentUser: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiJsAuthAuthByIdCommunityPost(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['JsAuthApi.apiJsAuthAuthByIdCommunityPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticates user by provided id from xdent BE.
         * @param {string} idXdentUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiJsAuthAuthByIdPost(idXdentUser: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiJsAuthAuthByIdPost(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['JsAuthApi.apiJsAuthAuthByIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * JsAuthApi - factory interface
 * @export
 */
export const JsAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JsAuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticates user by provided id from xdent BE. (Audience for community)
         * @param {string} idXdentUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJsAuthAuthByIdCommunityPost(idXdentUser: string, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiJsAuthAuthByIdCommunityPost(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticates user by provided id from xdent BE.
         * @param {string} idXdentUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJsAuthAuthByIdPost(idXdentUser: string, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiJsAuthAuthByIdPost(idXdentUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JsAuthApi - object-oriented interface
 * @export
 * @class JsAuthApi
 * @extends {BaseAPI}
 */
export class JsAuthApi extends BaseAPI {
    /**
     * 
     * @summary Authenticates user by provided id from xdent BE. (Audience for community)
     * @param {string} idXdentUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsAuthApi
     */
    public apiJsAuthAuthByIdCommunityPost(idXdentUser: string, options?: AxiosRequestConfig) {
        return JsAuthApiFp(this.configuration).apiJsAuthAuthByIdCommunityPost(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticates user by provided id from xdent BE.
     * @param {string} idXdentUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JsAuthApi
     */
    public apiJsAuthAuthByIdPost(idXdentUser: string, options?: AxiosRequestConfig) {
        return JsAuthApiFp(this.configuration).apiJsAuthAuthByIdPost(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LabinoApi - axios parameter creator
 * @export
 */
export const LabinoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all the laboratory pair requests for xdent company.
         * @param {string} [idXdentCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoCheckLaboratoryRequestsGet: async (idXdentCompany?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/CheckLaboratoryRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentCompany !== undefined) {
                localVarQueryParameter['idXdentCompany'] = idXdentCompany;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabPairHelp} [labinoDtoLabPairHelp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoCreateLaboratoryPost: async (labinoDtoLabPairHelp?: LabinoDtoLabPairHelp, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/CreateLaboratory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoLabPairHelp, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all available laboratories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoGetAllLaboratoriesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/GetAllLaboratories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all available laboratories with geocache.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoGetAllLaboratoriesWithGeocacheGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/GetAllLaboratoriesWithGeocache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets labTicketHistory
         * @param {string} [idLaboratory] 
         * @param {string} [ticketNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoGetLabLabelHistoryGridGet: async (idLaboratory?: string, ticketNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/GetLabLabelHistoryGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLaboratory !== undefined) {
                localVarQueryParameter['idLaboratory'] = idLaboratory;
            }

            if (ticketNumber !== undefined) {
                localVarQueryParameter['ticketNumber'] = ticketNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all the laboratory pair requests for xdent company.
         * @param {boolean} [unreadOnly] 
         * @param {number} [start] 
         * @param {number} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoGetLabRequestsNotificationsGet: async (unreadOnly?: boolean, start?: number, end?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/GetLabRequestsNotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unreadOnly'] = unreadOnly;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoInvalidateLaboratoryRequest} [labinoDtoInvalidateLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoInvalidateLaboratoryRequestPost: async (labinoDtoInvalidateLaboratoryRequest?: LabinoDtoInvalidateLaboratoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/InvalidateLaboratoryRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoInvalidateLaboratoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabPairHelp} [labinoDtoLabPairHelp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoInvalidateXdentLaboratoryPost: async (labinoDtoLabPairHelp?: LabinoDtoLabPairHelp, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/InvalidateXdentLaboratory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoLabPairHelp, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes status of LabLaboratoryRequest to read. (1/true)
         * @param {APIXdentDTOLabinoReadLabRequestsNotificationDto} [aPIXdentDTOLabinoReadLabRequestsNotificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoReadLabRequestsNotificationPost: async (aPIXdentDTOLabinoReadLabRequestsNotificationDto?: APIXdentDTOLabinoReadLabRequestsNotificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/ReadLabRequestsNotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOLabinoReadLabRequestsNotificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idChatMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoReadLabinoMessagesGet: async (idChatMessage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Labino/ReadLabinoMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idChatMessage !== undefined) {
                localVarQueryParameter['idChatMessage'] = idChatMessage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idOwner 
         * @param {string} idLaboratory 
         * @param {string} idLabLocation 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoSendLaboratoryRequestGet: async (idOwner: string, idLaboratory: string, idLabLocation: string, idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idOwner' is not null or undefined
            assertParamExists('apiLabinoSendLaboratoryRequestGet', 'idOwner', idOwner)
            // verify required parameter 'idLaboratory' is not null or undefined
            assertParamExists('apiLabinoSendLaboratoryRequestGet', 'idLaboratory', idLaboratory)
            // verify required parameter 'idLabLocation' is not null or undefined
            assertParamExists('apiLabinoSendLaboratoryRequestGet', 'idLabLocation', idLabLocation)
            const localVarPath = `/api/Labino/SendLaboratoryRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idOwner !== undefined) {
                localVarQueryParameter['idOwner'] = idOwner;
            }

            if (idLaboratory !== undefined) {
                localVarQueryParameter['idLaboratory'] = idLaboratory;
            }

            if (idLabLocation !== undefined) {
                localVarQueryParameter['idLabLocation'] = idLabLocation;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shares message to labino. If message already exists and idFile is provided, file is shared to that message.
         * @param {LabinoDtoShareTicketChatMessage} [labinoDtoShareTicketChatMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentShareSendExternalTicketChatMessagePost: async (labinoDtoShareTicketChatMessage?: LabinoDtoShareTicketChatMessage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentShare/SendExternalTicketChatMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoShareTicketChatMessage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOXdentShareShareLabTicketFileDto} [aPIXdentDTOXdentShareShareLabTicketFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentShareShareLabTicketFileToLabinoAsChatMessagePost: async (aPIXdentDTOXdentShareShareLabTicketFileDto?: APIXdentDTOXdentShareShareLabTicketFileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentShare/ShareLabTicketFileToLabinoAsChatMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOXdentShareShareLabTicketFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LabinoApi - functional programming interface
 * @export
 */
export const LabinoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LabinoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all the laboratory pair requests for xdent company.
         * @param {string} [idXdentCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoCheckLaboratoryRequestsGet(idXdentCompany?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoCheckLaboratoryRequestsGet(idXdentCompany, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoCheckLaboratoryRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabPairHelp} [labinoDtoLabPairHelp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoCreateLaboratoryPost(labinoDtoLabPairHelp?: LabinoDtoLabPairHelp, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoCreateLaboratoryPost(labinoDtoLabPairHelp, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoCreateLaboratoryPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all available laboratories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoGetAllLaboratoriesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoGetAllLaboratoriesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoGetAllLaboratoriesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all available laboratories with geocache.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoGetAllLaboratoriesWithGeocacheGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LabinoDtoLaboratoryGridMarketplaceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoGetAllLaboratoriesWithGeocacheGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoGetAllLaboratoriesWithGeocacheGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets labTicketHistory
         * @param {string} [idLaboratory] 
         * @param {string} [ticketNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoGetLabLabelHistoryGridGet(idLaboratory?: string, ticketNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORYLABELHISTORYGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoGetLabLabelHistoryGridGet(idLaboratory, ticketNumber, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoGetLabLabelHistoryGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all the laboratory pair requests for xdent company.
         * @param {boolean} [unreadOnly] 
         * @param {number} [start] 
         * @param {number} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoGetLabRequestsNotificationsGet(unreadOnly?: boolean, start?: number, end?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoGetLabRequestsNotificationsGet(unreadOnly, start, end, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoGetLabRequestsNotificationsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoInvalidateLaboratoryRequest} [labinoDtoInvalidateLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoInvalidateLaboratoryRequestPost(labinoDtoInvalidateLaboratoryRequest?: LabinoDtoInvalidateLaboratoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoInvalidateLaboratoryRequestPost(labinoDtoInvalidateLaboratoryRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoInvalidateLaboratoryRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabPairHelp} [labinoDtoLabPairHelp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoInvalidateXdentLaboratoryPost(labinoDtoLabPairHelp?: LabinoDtoLabPairHelp, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoInvalidateXdentLaboratoryPost(labinoDtoLabPairHelp, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoInvalidateXdentLaboratoryPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Changes status of LabLaboratoryRequest to read. (1/true)
         * @param {APIXdentDTOLabinoReadLabRequestsNotificationDto} [aPIXdentDTOLabinoReadLabRequestsNotificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoReadLabRequestsNotificationPost(aPIXdentDTOLabinoReadLabRequestsNotificationDto?: APIXdentDTOLabinoReadLabRequestsNotificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoReadLabRequestsNotificationPost(aPIXdentDTOLabinoReadLabRequestsNotificationDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoReadLabRequestsNotificationPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idChatMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoReadLabinoMessagesGet(idChatMessage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoReadLabinoMessagesGet(idChatMessage, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoReadLabinoMessagesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idOwner 
         * @param {string} idLaboratory 
         * @param {string} idLabLocation 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoSendLaboratoryRequestGet(idOwner: string, idLaboratory: string, idLabLocation: string, idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoSendLaboratoryRequestGet(idOwner, idLaboratory, idLabLocation, idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiLabinoSendLaboratoryRequestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Shares message to labino. If message already exists and idFile is provided, file is shared to that message.
         * @param {LabinoDtoShareTicketChatMessage} [labinoDtoShareTicketChatMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentShareSendExternalTicketChatMessagePost(labinoDtoShareTicketChatMessage?: LabinoDtoShareTicketChatMessage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentShareSendExternalTicketChatMessagePost(labinoDtoShareTicketChatMessage, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiXdentShareSendExternalTicketChatMessagePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOXdentShareShareLabTicketFileDto} [aPIXdentDTOXdentShareShareLabTicketFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentShareShareLabTicketFileToLabinoAsChatMessagePost(aPIXdentDTOXdentShareShareLabTicketFileDto?: APIXdentDTOXdentShareShareLabTicketFileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentShareShareLabTicketFileToLabinoAsChatMessagePost(aPIXdentDTOXdentShareShareLabTicketFileDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LabinoApi.apiXdentShareShareLabTicketFileToLabinoAsChatMessagePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LabinoApi - factory interface
 * @export
 */
export const LabinoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LabinoApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all the laboratory pair requests for xdent company.
         * @param {string} [idXdentCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoCheckLaboratoryRequestsGet(idXdentCompany?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPICHECKREQUESTSResult>> {
            return localVarFp.apiLabinoCheckLaboratoryRequestsGet(idXdentCompany, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabPairHelp} [labinoDtoLabPairHelp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoCreateLaboratoryPost(labinoDtoLabPairHelp?: LabinoDtoLabPairHelp, options?: any): AxiosPromise<string> {
            return localVarFp.apiLabinoCreateLaboratoryPost(labinoDtoLabPairHelp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all available laboratories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoGetAllLaboratoriesGet(options?: any): AxiosPromise<Array<APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORIESGRIDResult>> {
            return localVarFp.apiLabinoGetAllLaboratoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all available laboratories with geocache.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoGetAllLaboratoriesWithGeocacheGet(options?: any): AxiosPromise<Array<LabinoDtoLaboratoryGridMarketplaceDto>> {
            return localVarFp.apiLabinoGetAllLaboratoriesWithGeocacheGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets labTicketHistory
         * @param {string} [idLaboratory] 
         * @param {string} [ticketNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoGetLabLabelHistoryGridGet(idLaboratory?: string, ticketNumber?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsLabinoLabinoDbProceduresContextGeneratedLABAPILABORATORYLABELHISTORYGRIDResult>> {
            return localVarFp.apiLabinoGetLabLabelHistoryGridGet(idLaboratory, ticketNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all the laboratory pair requests for xdent company.
         * @param {boolean} [unreadOnly] 
         * @param {number} [start] 
         * @param {number} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoGetLabRequestsNotificationsGet(unreadOnly?: boolean, start?: number, end?: number, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerLabLaboratoryRequest>> {
            return localVarFp.apiLabinoGetLabRequestsNotificationsGet(unreadOnly, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoInvalidateLaboratoryRequest} [labinoDtoInvalidateLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoInvalidateLaboratoryRequestPost(labinoDtoInvalidateLaboratoryRequest?: LabinoDtoInvalidateLaboratoryRequest, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoInvalidateLaboratoryRequestPost(labinoDtoInvalidateLaboratoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabPairHelp} [labinoDtoLabPairHelp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoInvalidateXdentLaboratoryPost(labinoDtoLabPairHelp?: LabinoDtoLabPairHelp, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoInvalidateXdentLaboratoryPost(labinoDtoLabPairHelp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes status of LabLaboratoryRequest to read. (1/true)
         * @param {APIXdentDTOLabinoReadLabRequestsNotificationDto} [aPIXdentDTOLabinoReadLabRequestsNotificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoReadLabRequestsNotificationPost(aPIXdentDTOLabinoReadLabRequestsNotificationDto?: APIXdentDTOLabinoReadLabRequestsNotificationDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoReadLabRequestsNotificationPost(aPIXdentDTOLabinoReadLabRequestsNotificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idChatMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoReadLabinoMessagesGet(idChatMessage?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoReadLabinoMessagesGet(idChatMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idOwner 
         * @param {string} idLaboratory 
         * @param {string} idLabLocation 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoSendLaboratoryRequestGet(idOwner: string, idLaboratory: string, idLabLocation: string, idLocation?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiLabinoSendLaboratoryRequestGet(idOwner, idLaboratory, idLabLocation, idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shares message to labino. If message already exists and idFile is provided, file is shared to that message.
         * @param {LabinoDtoShareTicketChatMessage} [labinoDtoShareTicketChatMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentShareSendExternalTicketChatMessagePost(labinoDtoShareTicketChatMessage?: LabinoDtoShareTicketChatMessage, options?: any): AxiosPromise<string> {
            return localVarFp.apiXdentShareSendExternalTicketChatMessagePost(labinoDtoShareTicketChatMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOXdentShareShareLabTicketFileDto} [aPIXdentDTOXdentShareShareLabTicketFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentShareShareLabTicketFileToLabinoAsChatMessagePost(aPIXdentDTOXdentShareShareLabTicketFileDto?: APIXdentDTOXdentShareShareLabTicketFileDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiXdentShareShareLabTicketFileToLabinoAsChatMessagePost(aPIXdentDTOXdentShareShareLabTicketFileDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LabinoApi - object-oriented interface
 * @export
 * @class LabinoApi
 * @extends {BaseAPI}
 */
export class LabinoApi extends BaseAPI {
    /**
     * 
     * @summary Gets all the laboratory pair requests for xdent company.
     * @param {string} [idXdentCompany] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoCheckLaboratoryRequestsGet(idXdentCompany?: string, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoCheckLaboratoryRequestsGet(idXdentCompany, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {LabinoDtoLabPairHelp} [labinoDtoLabPairHelp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoCreateLaboratoryPost(labinoDtoLabPairHelp?: LabinoDtoLabPairHelp, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoCreateLaboratoryPost(labinoDtoLabPairHelp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all available laboratories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoGetAllLaboratoriesGet(options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoGetAllLaboratoriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all available laboratories with geocache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoGetAllLaboratoriesWithGeocacheGet(options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoGetAllLaboratoriesWithGeocacheGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets labTicketHistory
     * @param {string} [idLaboratory] 
     * @param {string} [ticketNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoGetLabLabelHistoryGridGet(idLaboratory?: string, ticketNumber?: string, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoGetLabLabelHistoryGridGet(idLaboratory, ticketNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all the laboratory pair requests for xdent company.
     * @param {boolean} [unreadOnly] 
     * @param {number} [start] 
     * @param {number} [end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoGetLabRequestsNotificationsGet(unreadOnly?: boolean, start?: number, end?: number, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoGetLabRequestsNotificationsGet(unreadOnly, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {LabinoDtoInvalidateLaboratoryRequest} [labinoDtoInvalidateLaboratoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoInvalidateLaboratoryRequestPost(labinoDtoInvalidateLaboratoryRequest?: LabinoDtoInvalidateLaboratoryRequest, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoInvalidateLaboratoryRequestPost(labinoDtoInvalidateLaboratoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {LabinoDtoLabPairHelp} [labinoDtoLabPairHelp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoInvalidateXdentLaboratoryPost(labinoDtoLabPairHelp?: LabinoDtoLabPairHelp, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoInvalidateXdentLaboratoryPost(labinoDtoLabPairHelp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes status of LabLaboratoryRequest to read. (1/true)
     * @param {APIXdentDTOLabinoReadLabRequestsNotificationDto} [aPIXdentDTOLabinoReadLabRequestsNotificationDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoReadLabRequestsNotificationPost(aPIXdentDTOLabinoReadLabRequestsNotificationDto?: APIXdentDTOLabinoReadLabRequestsNotificationDto, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoReadLabRequestsNotificationPost(aPIXdentDTOLabinoReadLabRequestsNotificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idChatMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoReadLabinoMessagesGet(idChatMessage?: string, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoReadLabinoMessagesGet(idChatMessage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idOwner 
     * @param {string} idLaboratory 
     * @param {string} idLabLocation 
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiLabinoSendLaboratoryRequestGet(idOwner: string, idLaboratory: string, idLabLocation: string, idLocation?: string, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiLabinoSendLaboratoryRequestGet(idOwner, idLaboratory, idLabLocation, idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shares message to labino. If message already exists and idFile is provided, file is shared to that message.
     * @param {LabinoDtoShareTicketChatMessage} [labinoDtoShareTicketChatMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiXdentShareSendExternalTicketChatMessagePost(labinoDtoShareTicketChatMessage?: LabinoDtoShareTicketChatMessage, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiXdentShareSendExternalTicketChatMessagePost(labinoDtoShareTicketChatMessage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOXdentShareShareLabTicketFileDto} [aPIXdentDTOXdentShareShareLabTicketFileDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabinoApi
     */
    public apiXdentShareShareLabTicketFileToLabinoAsChatMessagePost(aPIXdentDTOXdentShareShareLabTicketFileDto?: APIXdentDTOXdentShareShareLabTicketFileDto, options?: AxiosRequestConfig) {
        return LabinoApiFp(this.configuration).apiXdentShareShareLabTicketFileToLabinoAsChatMessagePost(aPIXdentDTOXdentShareShareLabTicketFileDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns Catalog of tests in JSON format.
         * @param {number} [version] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformCatalogGet: async (version?: number, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns label printform for a request form
         * @param {string} [idClient] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformClientlabelGet: async (idClient?: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/clientlabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns filtered diagnosis in JSON format.
         * @param {string} [filter] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformDiagnosisGet: async (filter?: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/diagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of laboratory requests with errors
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformErrorsRequestsGet: async (pageNumber?: number, pageSize?: number, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/errors/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all request forms for {idClient}
         * @param {string} [idClient] 
         * @param {Date} [after] 
         * @param {boolean} [hideCancelled] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformGet: async (idClient?: string, after?: Date, hideCancelled?: boolean, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = (after as any instanceof Date) ?
                    (after as any).toISOString() :
                    after;
            }

            if (hideCancelled !== undefined) {
                localVarQueryParameter['hideCancelled'] = hideCancelled;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the last sent DASTA file. XML content only, not the file itself
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdDastaGet: async (id: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLabRequestformIdDastaGet', 'id', id)
            const localVarPath = `/api/lab/requestform/{id}/dasta`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft deletes a lab request form by setting deletedAt and status.
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabRequestFormDelete: async (idLabRequestForm: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestForm' is not null or undefined
            assertParamExists('apiLabRequestformIdLabRequestFormDelete', 'idLabRequestForm', idLabRequestForm)
            const localVarPath = `/api/lab/requestform/{idLabRequestForm}`
                .replace(`{${"idLabRequestForm"}}`, encodeURIComponent(String(idLabRequestForm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a request form
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabRequestFormGet: async (idLabRequestForm: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestForm' is not null or undefined
            assertParamExists('apiLabRequestformIdLabRequestFormGet', 'idLabRequestForm', idLabRequestForm)
            const localVarPath = `/api/lab/requestform/{idLabRequestForm}`
                .replace(`{${"idLabRequestForm"}}`, encodeURIComponent(String(idLabRequestForm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns result PDF for a request form. Merged from multiple headers, if multiple headers has attachment
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabRequestFormResultpdfmergedGet: async (idLabRequestForm: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestForm' is not null or undefined
            assertParamExists('apiLabRequestformIdLabRequestFormResultpdfmergedGet', 'idLabRequestForm', idLabRequestForm)
            const localVarPath = `/api/lab/requestform/{idLabRequestForm}/resultpdfmerged`
                .replace(`{${"idLabRequestForm"}}`, encodeURIComponent(String(idLabRequestForm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the sampleCollected flag for a lab request form.
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {boolean} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabRequestFormSamplecollectedPost: async (idLabRequestForm: string, idXdentUser?: string, body?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestForm' is not null or undefined
            assertParamExists('apiLabRequestformIdLabRequestFormSamplecollectedPost', 'idLabRequestForm', idLabRequestForm)
            const localVarPath = `/api/lab/requestform/{idLabRequestForm}/samplecollected`
                .replace(`{${"idLabRequestForm"}}`, encodeURIComponent(String(idLabRequestForm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns label printform for a request form
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabelGet: async (id: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLabRequestformIdLabelGet', 'id', id)
            const localVarPath = `/api/lab/requestform/{id}/label`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns printform for a request form
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdPrintformGet: async (id: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLabRequestformIdPrintformGet', 'id', id)
            const localVarPath = `/api/lab/requestform/{id}/printform`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns results for a request form.
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdResultGet: async (id: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLabRequestformIdResultGet', 'id', id)
            const localVarPath = `/api/lab/requestform/{id}/result`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The event type is either \"Status\" for changes in form status or \"Result\" for attached result entries.
         * @summary Returns a chronological log of status updates and result entries for a specific lab request form.
         * @param {string} [idLabRequestForm] Optional. If provided, returns events only for the specified lab request form.   If null, returns events for all request forms accessible to the current user.
         * @param {number} [pageNumber] The page number for server-side pagination. Default is 1.
         * @param {number} [pageSize] The number of records per page. Default is 20.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformLogGet: async (idLabRequestForm?: string, pageNumber?: number, pageSize?: number, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLabRequestForm !== undefined) {
                localVarQueryParameter['idLabRequestForm'] = idLabRequestForm;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upserts a request form
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabRequestFormDto} [aPISharedLabRequestFormsDTOLabRequestFormDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformPost: async (idXdentUser?: string, aPISharedLabRequestFormsDTOLabRequestFormDto?: APISharedLabRequestFormsDTOLabRequestFormDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedLabRequestFormsDTOLabRequestFormDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabRequestForm] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformStatuslogGet: async (idLabRequestForm?: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/statuslog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLabRequestForm !== undefined) {
                localVarQueryParameter['idLabRequestForm'] = idLabRequestForm;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns Catalog of tests in JSON format.
         * @param {number} [version] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformCatalogGet(version?: number, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformCatalogGet(version, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformCatalogGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns label printform for a request form
         * @param {string} [idClient] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformClientlabelGet(idClient?: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformClientlabelGet(idClient, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformClientlabelGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns filtered diagnosis in JSON format.
         * @param {string} [filter] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformDiagnosisGet(filter?: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformDiagnosisGet(filter, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformDiagnosisGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of laboratory requests with errors
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformErrorsRequestsGet(pageNumber?: number, pageSize?: number, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormErrorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformErrorsRequestsGet(pageNumber, pageSize, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformErrorsRequestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all request forms for {idClient}
         * @param {string} [idClient] 
         * @param {Date} [after] 
         * @param {boolean} [hideCancelled] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformGet(idClient?: string, after?: Date, hideCancelled?: boolean, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormGridDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformGet(idClient, after, hideCancelled, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the last sent DASTA file. XML content only, not the file itself
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformIdDastaGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformIdDastaGet(id, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformIdDastaGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Soft deletes a lab request form by setting deletedAt and status.
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformIdLabRequestFormDelete(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformIdLabRequestFormDelete(idLabRequestForm, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformIdLabRequestFormDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a request form
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformIdLabRequestFormGet(idLabRequestForm, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformIdLabRequestFormGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns result PDF for a request form. Merged from multiple headers, if multiple headers has attachment
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformIdLabRequestFormResultpdfmergedGet(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformIdLabRequestFormResultpdfmergedGet(idLabRequestForm, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformIdLabRequestFormResultpdfmergedGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the sampleCollected flag for a lab request form.
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {boolean} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformIdLabRequestFormSamplecollectedPost(idLabRequestForm: string, idXdentUser?: string, body?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformIdLabRequestFormSamplecollectedPost(idLabRequestForm, idXdentUser, body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformIdLabRequestFormSamplecollectedPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns label printform for a request form
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformIdLabelGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformIdLabelGet(id, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformIdLabelGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns printform for a request form
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformIdPrintformGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformIdPrintformGet(id, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformIdPrintformGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns results for a request form.
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformIdResultGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformIdResultGet(id, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformIdResultGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * The event type is either \"Status\" for changes in form status or \"Result\" for attached result entries.
         * @summary Returns a chronological log of status updates and result entries for a specific lab request form.
         * @param {string} [idLabRequestForm] Optional. If provided, returns events only for the specified lab request form.   If null, returns events for all request forms accessible to the current user.
         * @param {number} [pageNumber] The page number for server-side pagination. Default is 1.
         * @param {number} [pageSize] The number of records per page. Default is 20.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformLogGet(idLabRequestForm?: string, pageNumber?: number, pageSize?: number, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormLogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformLogGet(idLabRequestForm, pageNumber, pageSize, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformLogGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Upserts a request form
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabRequestFormDto} [aPISharedLabRequestFormsDTOLabRequestFormDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformPost(idXdentUser?: string, aPISharedLabRequestFormsDTOLabRequestFormDto?: APISharedLabRequestFormsDTOLabRequestFormDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformPost(idXdentUser, aPISharedLabRequestFormsDTOLabRequestFormDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabRequestForm] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformStatuslogGet(idLabRequestForm?: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormStatusLogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformStatuslogGet(idLabRequestForm, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormApi.apiLabRequestformStatuslogGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormApi - factory interface
 * @export
 */
export const LaboratoryRequestFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns Catalog of tests in JSON format.
         * @param {number} [version] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformCatalogGet(version?: number, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabCatalog> {
            return localVarFp.apiLabRequestformCatalogGet(version, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns label printform for a request form
         * @param {string} [idClient] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformClientlabelGet(idClient?: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformClientlabelGet(idClient, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns filtered diagnosis in JSON format.
         * @param {string} [filter] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformDiagnosisGet(filter?: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabCatalog> {
            return localVarFp.apiLabRequestformDiagnosisGet(filter, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of laboratory requests with errors
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformErrorsRequestsGet(pageNumber?: number, pageSize?: number, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormErrorDto>> {
            return localVarFp.apiLabRequestformErrorsRequestsGet(pageNumber, pageSize, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all request forms for {idClient}
         * @param {string} [idClient] 
         * @param {Date} [after] 
         * @param {boolean} [hideCancelled] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformGet(idClient?: string, after?: Date, hideCancelled?: boolean, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormGridDto>> {
            return localVarFp.apiLabRequestformGet(idClient, after, hideCancelled, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the last sent DASTA file. XML content only, not the file itself
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdDastaGet(id: string, idXdentUser?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiLabRequestformIdDastaGet(id, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft deletes a lab request form by setting deletedAt and status.
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabRequestFormDelete(idLabRequestForm: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformIdLabRequestFormDelete(idLabRequestForm, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a request form
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormDto> {
            return localVarFp.apiLabRequestformIdLabRequestFormGet(idLabRequestForm, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns result PDF for a request form. Merged from multiple headers, if multiple headers has attachment
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabRequestFormResultpdfmergedGet(idLabRequestForm: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformIdLabRequestFormResultpdfmergedGet(idLabRequestForm, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the sampleCollected flag for a lab request form.
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {boolean} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabRequestFormSamplecollectedPost(idLabRequestForm: string, idXdentUser?: string, body?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformIdLabRequestFormSamplecollectedPost(idLabRequestForm, idXdentUser, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns label printform for a request form
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdLabelGet(id: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformIdLabelGet(id, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns printform for a request form
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdPrintformGet(id: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformIdPrintformGet(id, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns results for a request form.
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformIdResultGet(id: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormResultDto> {
            return localVarFp.apiLabRequestformIdResultGet(id, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * The event type is either \"Status\" for changes in form status or \"Result\" for attached result entries.
         * @summary Returns a chronological log of status updates and result entries for a specific lab request form.
         * @param {string} [idLabRequestForm] Optional. If provided, returns events only for the specified lab request form.   If null, returns events for all request forms accessible to the current user.
         * @param {number} [pageNumber] The page number for server-side pagination. Default is 1.
         * @param {number} [pageSize] The number of records per page. Default is 20.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformLogGet(idLabRequestForm?: string, pageNumber?: number, pageSize?: number, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormLogDto>> {
            return localVarFp.apiLabRequestformLogGet(idLabRequestForm, pageNumber, pageSize, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upserts a request form
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabRequestFormDto} [aPISharedLabRequestFormsDTOLabRequestFormDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformPost(idXdentUser?: string, aPISharedLabRequestFormsDTOLabRequestFormDto?: APISharedLabRequestFormsDTOLabRequestFormDto, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormDto>> {
            return localVarFp.apiLabRequestformPost(idXdentUser, aPISharedLabRequestFormsDTOLabRequestFormDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabRequestForm] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformStatuslogGet(idLabRequestForm?: string, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormStatusLogDto>> {
            return localVarFp.apiLabRequestformStatuslogGet(idLabRequestForm, idXdentUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormApi extends BaseAPI {
    /**
     * 
     * @summary Returns Catalog of tests in JSON format.
     * @param {number} [version] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformCatalogGet(version?: number, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformCatalogGet(version, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns label printform for a request form
     * @param {string} [idClient] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformClientlabelGet(idClient?: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformClientlabelGet(idClient, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns filtered diagnosis in JSON format.
     * @param {string} [filter] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformDiagnosisGet(filter?: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformDiagnosisGet(filter, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of laboratory requests with errors
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformErrorsRequestsGet(pageNumber?: number, pageSize?: number, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformErrorsRequestsGet(pageNumber, pageSize, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all request forms for {idClient}
     * @param {string} [idClient] 
     * @param {Date} [after] 
     * @param {boolean} [hideCancelled] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformGet(idClient?: string, after?: Date, hideCancelled?: boolean, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformGet(idClient, after, hideCancelled, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the last sent DASTA file. XML content only, not the file itself
     * @param {string} id 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformIdDastaGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformIdDastaGet(id, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft deletes a lab request form by setting deletedAt and status.
     * @param {string} idLabRequestForm 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformIdLabRequestFormDelete(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformIdLabRequestFormDelete(idLabRequestForm, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a request form
     * @param {string} idLabRequestForm 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformIdLabRequestFormGet(idLabRequestForm, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns result PDF for a request form. Merged from multiple headers, if multiple headers has attachment
     * @param {string} idLabRequestForm 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformIdLabRequestFormResultpdfmergedGet(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformIdLabRequestFormResultpdfmergedGet(idLabRequestForm, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the sampleCollected flag for a lab request form.
     * @param {string} idLabRequestForm 
     * @param {string} [idXdentUser] 
     * @param {boolean} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformIdLabRequestFormSamplecollectedPost(idLabRequestForm: string, idXdentUser?: string, body?: boolean, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformIdLabRequestFormSamplecollectedPost(idLabRequestForm, idXdentUser, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns label printform for a request form
     * @param {string} id 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformIdLabelGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformIdLabelGet(id, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns printform for a request form
     * @param {string} id 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformIdPrintformGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformIdPrintformGet(id, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns results for a request form.
     * @param {string} id 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformIdResultGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformIdResultGet(id, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The event type is either \"Status\" for changes in form status or \"Result\" for attached result entries.
     * @summary Returns a chronological log of status updates and result entries for a specific lab request form.
     * @param {string} [idLabRequestForm] Optional. If provided, returns events only for the specified lab request form.   If null, returns events for all request forms accessible to the current user.
     * @param {number} [pageNumber] The page number for server-side pagination. Default is 1.
     * @param {number} [pageSize] The number of records per page. Default is 20.
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformLogGet(idLabRequestForm?: string, pageNumber?: number, pageSize?: number, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformLogGet(idLabRequestForm, pageNumber, pageSize, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upserts a request form
     * @param {string} [idXdentUser] 
     * @param {APISharedLabRequestFormsDTOLabRequestFormDto} [aPISharedLabRequestFormsDTOLabRequestFormDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformPost(idXdentUser?: string, aPISharedLabRequestFormsDTOLabRequestFormDto?: APISharedLabRequestFormsDTOLabRequestFormDto, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformPost(idXdentUser, aPISharedLabRequestFormsDTOLabRequestFormDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLabRequestForm] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormApi
     */
    public apiLabRequestformStatuslogGet(idLabRequestForm?: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormApiFp(this.configuration).apiLabRequestformStatuslogGet(idLabRequestForm, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormAssignmentApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormAssignmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentMyGet: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/assignment/My`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List assignees for resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet: async (idLabRequestFormResultHeader: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            const localVarPath = `/api/lab/requestform/assignment/ResultHeaders/{idLabRequestFormResultHeader}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove staff from resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete: async (idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            // verify required parameter 'idStaff' is not null or undefined
            assertParamExists('apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete', 'idStaff', idStaff)
            const localVarPath = `/api/lab/requestform/assignment/ResultHeaders/{idLabRequestFormResultHeader}/staff/{idStaff}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)))
                .replace(`{${"idStaff"}}`, encodeURIComponent(String(idStaff)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign staff to resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost: async (idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            // verify required parameter 'idStaff' is not null or undefined
            assertParamExists('apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost', 'idStaff', idStaff)
            const localVarPath = `/api/lab/requestform/assignment/ResultHeaders/{idLabRequestFormResultHeader}/staff/{idStaff}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)))
                .replace(`{${"idStaff"}}`, encodeURIComponent(String(idStaff)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign staff to resultHeader and remove all existing. Also assign to all other result with the same group
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost: async (idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            // verify required parameter 'idStaff' is not null or undefined
            assertParamExists('apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost', 'idStaff', idStaff)
            const localVarPath = `/api/lab/requestform/assignment/ResultHeaders/{idLabRequestFormResultHeader}/staff/{idStaff}/replace`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)))
                .replace(`{${"idStaff"}}`, encodeURIComponent(String(idStaff)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormAssignmentApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormAssignmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormAssignmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformAssignmentMyGet(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormAssigmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformAssignmentMyGet(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormAssignmentApi.apiLabRequestformAssignmentMyGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List assignees for resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormAssigmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormAssignmentApi.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Remove staff from resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete(idLabRequestFormResultHeader, idStaff, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormAssignmentApi.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Assign staff to resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormAssignmentApi.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Assign staff to resultHeader and remove all existing. Also assign to all other result with the same group
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormAssignmentApi.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormAssignmentApi - factory interface
 * @export
 */
export const LaboratoryRequestFormAssignmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormAssignmentApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentMyGet(idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormAssigmentDto>> {
            return localVarFp.apiLabRequestformAssignmentMyGet(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List assignees for resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormAssigmentDto>> {
            return localVarFp.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove staff from resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete(idLabRequestFormResultHeader, idStaff, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign staff to resultHeader
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign staff to resultHeader and remove all existing. Also assign to all other result with the same group
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormAssignmentApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormAssignmentApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormAssignmentApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormAssignmentApi
     */
    public apiLabRequestformAssignmentMyGet(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormAssignmentApiFp(this.configuration).apiLabRequestformAssignmentMyGet(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List assignees for resultHeader
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormAssignmentApi
     */
    public apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormAssignmentApiFp(this.configuration).apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove staff from resultHeader
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} idStaff 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormAssignmentApi
     */
    public apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormAssignmentApiFp(this.configuration).apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffDelete(idLabRequestFormResultHeader, idStaff, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign staff to resultHeader
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} idStaff 
     * @param {string} [idXdentUser] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormAssignmentApi
     */
    public apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormAssignmentApiFp(this.configuration).apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign staff to resultHeader and remove all existing. Also assign to all other result with the same group
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} idStaff 
     * @param {string} [idXdentUser] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormAssignmentApi
     */
    public apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormAssignmentApiFp(this.configuration).apiLabRequestformAssignmentResultHeadersIdLabRequestFormResultHeaderStaffIdStaffReplacePost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormHintsApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormHintsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformHintsClientIdClientGet: async (idClient: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idClient' is not null or undefined
            assertParamExists('apiLabRequestformHintsClientIdClientGet', 'idClient', idClient)
            const localVarPath = `/api/lab/requestform/hints/client/{idClient}`
                .replace(`{${"idClient"}}`, encodeURIComponent(String(idClient)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost: async (idClient: string, idLabRequestFormResultHeader: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idClient' is not null or undefined
            assertParamExists('apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost', 'idClient', idClient)
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            const localVarPath = `/api/lab/requestform/hints/client/{idClient}/result/{idLabRequestFormResultHeader}`
                .replace(`{${"idClient"}}`, encodeURIComponent(String(idClient)))
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformHintsFormIdLabRequestFormGet: async (idLabRequestForm: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestForm' is not null or undefined
            assertParamExists('apiLabRequestformHintsFormIdLabRequestFormGet', 'idLabRequestForm', idLabRequestForm)
            const localVarPath = `/api/lab/requestform/hints/form/{idLabRequestForm}`
                .replace(`{${"idLabRequestForm"}}`, encodeURIComponent(String(idLabRequestForm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormPairHint 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformHintsIdLabRequestFormPairHintDelete: async (idLabRequestFormPairHint: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormPairHint' is not null or undefined
            assertParamExists('apiLabRequestformHintsIdLabRequestFormPairHintDelete', 'idLabRequestFormPairHint', idLabRequestFormPairHint)
            const localVarPath = `/api/lab/requestform/hints/{idLabRequestFormPairHint}`
                .replace(`{${"idLabRequestFormPairHint"}}`, encodeURIComponent(String(idLabRequestFormPairHint)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormHintsApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormHintsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormHintsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformHintsClientIdClientGet(idClient: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormPairHintDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformHintsClientIdClientGet(idClient, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormHintsApi.apiLabRequestformHintsClientIdClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost(idClient: string, idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost(idClient, idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormHintsApi.apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformHintsFormIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormPairHintDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformHintsFormIdLabRequestFormGet(idLabRequestForm, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormHintsApi.apiLabRequestformHintsFormIdLabRequestFormGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormPairHint 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformHintsIdLabRequestFormPairHintDelete(idLabRequestFormPairHint: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformHintsIdLabRequestFormPairHintDelete(idLabRequestFormPairHint, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormHintsApi.apiLabRequestformHintsIdLabRequestFormPairHintDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormHintsApi - factory interface
 * @export
 */
export const LaboratoryRequestFormHintsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormHintsApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformHintsClientIdClientGet(idClient: string, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormPairHintDto>> {
            return localVarFp.apiLabRequestformHintsClientIdClientGet(idClient, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost(idClient: string, idLabRequestFormResultHeader: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost(idClient, idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformHintsFormIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormPairHintDto>> {
            return localVarFp.apiLabRequestformHintsFormIdLabRequestFormGet(idLabRequestForm, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormPairHint 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformHintsIdLabRequestFormPairHintDelete(idLabRequestFormPairHint: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformHintsIdLabRequestFormPairHintDelete(idLabRequestFormPairHint, idXdentUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormHintsApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormHintsApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormHintsApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} idClient 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormHintsApi
     */
    public apiLabRequestformHintsClientIdClientGet(idClient: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormHintsApiFp(this.configuration).apiLabRequestformHintsClientIdClientGet(idClient, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idClient 
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormHintsApi
     */
    public apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost(idClient: string, idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormHintsApiFp(this.configuration).apiLabRequestformHintsClientIdClientResultIdLabRequestFormResultHeaderPost(idClient, idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idLabRequestForm 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormHintsApi
     */
    public apiLabRequestformHintsFormIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormHintsApiFp(this.configuration).apiLabRequestformHintsFormIdLabRequestFormGet(idLabRequestForm, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idLabRequestFormPairHint 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormHintsApi
     */
    public apiLabRequestformHintsIdLabRequestFormPairHintDelete(idLabRequestFormPairHint: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormHintsApiFp(this.configuration).apiLabRequestformHintsIdLabRequestFormPairHintDelete(idLabRequestFormPairHint, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormNotificationApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormNotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabResultNotificationDto} [aPISharedLabRequestFormsDTOLabResultNotificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformNotifyPost: async (idXdentUser?: string, aPISharedLabRequestFormsDTOLabResultNotificationDto?: APISharedLabRequestFormsDTOLabResultNotificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/notify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedLabRequestFormsDTOLabResultNotificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet: async (idLabRequestForm: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestForm' is not null or undefined
            assertParamExists('apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet', 'idLabRequestForm', idLabRequestForm)
            const localVarPath = `/api/lab/requestform/notify/preview/byrequest/{idLabRequestForm}`
                .replace(`{${"idLabRequestForm"}}`, encodeURIComponent(String(idLabRequestForm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet: async (idLabRequestFormResultHeader: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            const localVarPath = `/api/lab/requestform/notify/preview/byresult/{idLabRequestFormResultHeader}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabRequestForm] 
         * @param {string} [idLabRequestFormResultHeader] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformNotifyPreviewGet: async (idLabRequestForm?: string, idLabRequestFormResultHeader?: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/notify/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLabRequestForm !== undefined) {
                localVarQueryParameter['idLabRequestForm'] = idLabRequestForm;
            }

            if (idLabRequestFormResultHeader !== undefined) {
                localVarQueryParameter['idLabRequestFormResultHeader'] = idLabRequestFormResultHeader;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormNotificationApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormNotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormNotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabResultNotificationDto} [aPISharedLabRequestFormsDTOLabResultNotificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformNotifyPost(idXdentUser?: string, aPISharedLabRequestFormsDTOLabResultNotificationDto?: APISharedLabRequestFormsDTOLabResultNotificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedEmailsSendResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformNotifyPost(idXdentUser, aPISharedLabRequestFormsDTOLabResultNotificationDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormNotificationApi.apiLabRequestformNotifyPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOResultEmailPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet(idLabRequestForm, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormNotificationApi.apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOResultEmailPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormNotificationApi.apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabRequestForm] 
         * @param {string} [idLabRequestFormResultHeader] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformNotifyPreviewGet(idLabRequestForm?: string, idLabRequestFormResultHeader?: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOResultEmailPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformNotifyPreviewGet(idLabRequestForm, idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormNotificationApi.apiLabRequestformNotifyPreviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormNotificationApi - factory interface
 * @export
 */
export const LaboratoryRequestFormNotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormNotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabResultNotificationDto} [aPISharedLabRequestFormsDTOLabResultNotificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformNotifyPost(idXdentUser?: string, aPISharedLabRequestFormsDTOLabResultNotificationDto?: APISharedLabRequestFormsDTOLabResultNotificationDto, options?: any): AxiosPromise<APISharedEmailsSendResultDto> {
            return localVarFp.apiLabRequestformNotifyPost(idXdentUser, aPISharedLabRequestFormsDTOLabResultNotificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOResultEmailPreviewDTO> {
            return localVarFp.apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet(idLabRequestForm, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOResultEmailPreviewDTO> {
            return localVarFp.apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabRequestForm] 
         * @param {string} [idLabRequestFormResultHeader] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformNotifyPreviewGet(idLabRequestForm?: string, idLabRequestFormResultHeader?: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOResultEmailPreviewDTO> {
            return localVarFp.apiLabRequestformNotifyPreviewGet(idLabRequestForm, idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormNotificationApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormNotificationApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormNotificationApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idXdentUser] 
     * @param {APISharedLabRequestFormsDTOLabResultNotificationDto} [aPISharedLabRequestFormsDTOLabResultNotificationDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormNotificationApi
     */
    public apiLabRequestformNotifyPost(idXdentUser?: string, aPISharedLabRequestFormsDTOLabResultNotificationDto?: APISharedLabRequestFormsDTOLabResultNotificationDto, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormNotificationApiFp(this.configuration).apiLabRequestformNotifyPost(idXdentUser, aPISharedLabRequestFormsDTOLabResultNotificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idLabRequestForm 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormNotificationApi
     */
    public apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet(idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormNotificationApiFp(this.configuration).apiLabRequestformNotifyPreviewByrequestIdLabRequestFormGet(idLabRequestForm, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormNotificationApi
     */
    public apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormNotificationApiFp(this.configuration).apiLabRequestformNotifyPreviewByresultIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLabRequestForm] 
     * @param {string} [idLabRequestFormResultHeader] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormNotificationApi
     */
    public apiLabRequestformNotifyPreviewGet(idLabRequestForm?: string, idLabRequestFormResultHeader?: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormNotificationApiFp(this.configuration).apiLabRequestformNotifyPreviewGet(idLabRequestForm, idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormResultsApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormResultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ignores the result.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost: async (idLabRequestFormResult: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResult' is not null or undefined
            assertParamExists('apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost', 'idLabRequestFormResult', idLabRequestFormResult)
            const localVarPath = `/api/lab/requestform/results/errors/ignore/{idLabRequestFormResult}`
                .replace(`{${"idLabRequestFormResult"}}`, encodeURIComponent(String(idLabRequestFormResult)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets the flag for result reprocessing.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost: async (idLabRequestFormResult: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResult' is not null or undefined
            assertParamExists('apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost', 'idLabRequestFormResult', idLabRequestFormResult)
            const localVarPath = `/api/lab/requestform/results/errors/redo/{idLabRequestFormResult}`
                .replace(`{${"idLabRequestFormResult"}}`, encodeURIComponent(String(idLabRequestFormResult)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of results with errors.
         * @param {boolean} [includeRemoved] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsErrorsResultsGet: async (includeRemoved?: boolean, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/results/errors/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (includeRemoved !== undefined) {
                localVarQueryParameter['includeRemoved'] = includeRemoved;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the entire XML file of the result.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet: async (idLabRequestFormResult: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResult' is not null or undefined
            assertParamExists('apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet', 'idLabRequestFormResult', idLabRequestFormResult)
            const localVarPath = `/api/lab/requestform/results/file/{idLabRequestFormResult}/download`
                .replace(`{${"idLabRequestFormResult"}}`, encodeURIComponent(String(idLabRequestFormResult)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the XML file content of the result file.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsFileIdLabRequestFormResultXmlGet: async (idLabRequestFormResult: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResult' is not null or undefined
            assertParamExists('apiLabRequestformResultsFileIdLabRequestFormResultXmlGet', 'idLabRequestFormResult', idLabRequestFormResult)
            const localVarPath = `/api/lab/requestform/results/file/{idLabRequestFormResult}/xml`
                .replace(`{${"idLabRequestFormResult"}}`, encodeURIComponent(String(idLabRequestFormResult)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign staff to result and set status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost: async (idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            // verify required parameter 'idStaff' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost', 'idStaff', idStaff)
            const localVarPath = `/api/lab/requestform/results/header/{idLabRequestFormResultHeader}/assignProcessingStaff/{idStaff}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)))
                .replace(`{${"idStaff"}}`, encodeURIComponent(String(idStaff)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns results by request form header
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet: async (idLabRequestFormResultHeader: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            const localVarPath = `/api/lab/requestform/results/header/{idLabRequestFormResultHeader}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign staff to result and set status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost: async (idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            // verify required parameter 'idStaff' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost', 'idStaff', idStaff)
            const localVarPath = `/api/lab/requestform/results/header/{idLabRequestFormResultHeader}/replaceProcessingStaff/{idStaff}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)))
                .replace(`{${"idStaff"}}`, encodeURIComponent(String(idStaff)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set result status to resolved
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost: async (idLabRequestFormResultHeader: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            const localVarPath = `/api/lab/requestform/results/header/{idLabRequestFormResultHeader}/resolved`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set result status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} statusCode 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost: async (idLabRequestFormResultHeader: string, statusCode: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            // verify required parameter 'statusCode' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost', 'statusCode', statusCode)
            const localVarPath = `/api/lab/requestform/results/header/{idLabRequestFormResultHeader}/status/{statusCode}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)))
                .replace(`{${"statusCode"}}`, encodeURIComponent(String(statusCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the XML content in which the result was received.
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet: async (idLabRequestFormResultHeader: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            const localVarPath = `/api/lab/requestform/results/header/{idLabRequestFormResultHeader}/xml`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns result PDF for a request form header
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet: async (idLabRequestFormResultHeader: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            const localVarPath = `/api/lab/requestform/results/{idLabRequestFormResultHeader}/resultpdf`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {boolean} [showResolved] 
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsOverviewGet: async (showResolved?: boolean, idStaff?: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/results/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (showResolved !== undefined) {
                localVarQueryParameter['showResolved'] = showResolved;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {boolean} [showResolved] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsOverviewMyGet: async (showResolved?: boolean, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/results/overview/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (showResolved !== undefined) {
                localVarQueryParameter['showResolved'] = showResolved;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reprocesses the specific result header.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsProcessIdLabRequestFormResultPost: async (idLabRequestFormResult: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResult' is not null or undefined
            assertParamExists('apiLabRequestformResultsProcessIdLabRequestFormResultPost', 'idLabRequestFormResult', idLabRequestFormResult)
            const localVarPath = `/api/lab/requestform/results/process/{idLabRequestFormResult}`
                .replace(`{${"idLabRequestFormResult"}}`, encodeURIComponent(String(idLabRequestFormResult)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Triggers processing of all results in the queue.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsProcessPost: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/results/process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsStatsGet: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/results/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of unlinked results.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsUnpairedGet: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/results/unpaired`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormResultsApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormResultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormResultsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ignores the result.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sets the flag for result reprocessing.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of results with errors.
         * @param {boolean} [includeRemoved] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsErrorsResultsGet(includeRemoved?: boolean, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsErrorsResultsGet(includeRemoved, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsErrorsResultsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the entire XML file of the result.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet(idLabRequestFormResult, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the XML file content of the result file.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsFileIdLabRequestFormResultXmlGet(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsFileIdLabRequestFormResultXmlGet(idLabRequestFormResult, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsFileIdLabRequestFormResultXmlGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Assign staff to result and set status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns results by request form header
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Assign staff to result and set status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Set result status to resolved
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost(idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Set result status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} statusCode 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost(idLabRequestFormResultHeader: string, statusCode: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost(idLabRequestFormResultHeader, statusCode, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the XML content in which the result was received.
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet(idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns result PDF for a request form header
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet(idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {boolean} [showResolved] 
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsOverviewGet(showResolved?: boolean, idStaff?: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsOverviewGet(showResolved, idStaff, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsOverviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {boolean} [showResolved] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsOverviewMyGet(showResolved?: boolean, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsOverviewMyGet(showResolved, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsOverviewMyGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Reprocesses the specific result header.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsProcessIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsProcessIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsProcessIdLabRequestFormResultPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Triggers processing of all results in the queue.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsProcessPost(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsLabRequestResultParseLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsProcessPost(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsProcessPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsStatsGet(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabRequestResultOverviewStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsStatsGet(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsStatsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of unlinked results.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsUnpairedGet(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsUnpairedGet(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsApi.apiLabRequestformResultsUnpairedGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormResultsApi - factory interface
 * @export
 */
export const LaboratoryRequestFormResultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormResultsApiFp(configuration)
    return {
        /**
         * 
         * @summary Ignores the result.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets the flag for result reprocessing.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of results with errors.
         * @param {boolean} [includeRemoved] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsErrorsResultsGet(includeRemoved?: boolean, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormResultsErroredDto>> {
            return localVarFp.apiLabRequestformResultsErrorsResultsGet(includeRemoved, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the entire XML file of the result.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet(idLabRequestFormResult: string, idXdentUser?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet(idLabRequestFormResult, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the XML file content of the result file.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsFileIdLabRequestFormResultXmlGet(idLabRequestFormResult: string, idXdentUser?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiLabRequestformResultsFileIdLabRequestFormResultXmlGet(idLabRequestFormResult, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign staff to result and set status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns results by request form header
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormResultDto> {
            return localVarFp.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign staff to result and set status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idStaff 
         * @param {string} [idXdentUser] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set result status to resolved
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set result status
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} statusCode 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost(idLabRequestFormResultHeader: string, statusCode: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost(idLabRequestFormResultHeader, statusCode, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the XML content in which the result was received.
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns result PDF for a request form header
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {boolean} [showResolved] 
         * @param {string} [idStaff] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsOverviewGet(showResolved?: boolean, idStaff?: string, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto>> {
            return localVarFp.apiLabRequestformResultsOverviewGet(showResolved, idStaff, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {boolean} [showResolved] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsOverviewMyGet(showResolved?: boolean, idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormResultOverviewDto>> {
            return localVarFp.apiLabRequestformResultsOverviewMyGet(showResolved, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reprocesses the specific result header.
         * @param {string} idLabRequestFormResult 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsProcessIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsProcessIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Triggers processing of all results in the queue.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsProcessPost(idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsLabRequestResultParseLog>> {
            return localVarFp.apiLabRequestformResultsProcessPost(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns overview of lab request form result headers with assignees or latest in group.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsStatsGet(idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabRequestResultOverviewStats> {
            return localVarFp.apiLabRequestformResultsStatsGet(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of unlinked results.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsUnpairedGet(idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormResultHeaderDto>> {
            return localVarFp.apiLabRequestformResultsUnpairedGet(idXdentUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormResultsApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormResultsApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormResultsApi extends BaseAPI {
    /**
     * 
     * @summary Ignores the result.
     * @param {string} idLabRequestFormResult 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsErrorsIgnoreIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets the flag for result reprocessing.
     * @param {string} idLabRequestFormResult 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsErrorsRedoIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of results with errors.
     * @param {boolean} [includeRemoved] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsErrorsResultsGet(includeRemoved?: boolean, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsErrorsResultsGet(includeRemoved, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the entire XML file of the result.
     * @param {string} idLabRequestFormResult 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsFileIdLabRequestFormResultDownloadGet(idLabRequestFormResult, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the XML file content of the result file.
     * @param {string} idLabRequestFormResult 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsFileIdLabRequestFormResultXmlGet(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsFileIdLabRequestFormResultXmlGet(idLabRequestFormResult, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign staff to result and set status
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} idStaff 
     * @param {string} [idXdentUser] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderAssignProcessingStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns results by request form header
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign staff to result and set status
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} idStaff 
     * @param {string} [idXdentUser] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost(idLabRequestFormResultHeader: string, idStaff: string, idXdentUser?: string, body?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderReplaceProcessingStaffIdStaffPost(idLabRequestFormResultHeader, idStaff, idXdentUser, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set result status to resolved
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderResolvedPost(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set result status
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} statusCode 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost(idLabRequestFormResultHeader: string, statusCode: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderStatusStatusCodePost(idLabRequestFormResultHeader, statusCode, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the XML content in which the result was received.
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsHeaderIdLabRequestFormResultHeaderXmlGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns result PDF for a request form header
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsIdLabRequestFormResultHeaderResultpdfGet(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns overview of lab request form result headers with assignees or latest in group.
     * @param {boolean} [showResolved] 
     * @param {string} [idStaff] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsOverviewGet(showResolved?: boolean, idStaff?: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsOverviewGet(showResolved, idStaff, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns overview of lab request form result headers with assignees or latest in group.
     * @param {boolean} [showResolved] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsOverviewMyGet(showResolved?: boolean, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsOverviewMyGet(showResolved, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reprocesses the specific result header.
     * @param {string} idLabRequestFormResult 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsProcessIdLabRequestFormResultPost(idLabRequestFormResult: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsProcessIdLabRequestFormResultPost(idLabRequestFormResult, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Triggers processing of all results in the queue.
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsProcessPost(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsProcessPost(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns overview of lab request form result headers with assignees or latest in group.
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsStatsGet(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsStatsGet(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of unlinked results.
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsApi
     */
    public apiLabRequestformResultsUnpairedGet(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsApiFp(this.configuration).apiLabRequestformResultsUnpairedGet(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormResultsLinkingApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormResultsLinkingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idClient 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost: async (idLabRequestFormResultHeader: string, idClient: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            // verify required parameter 'idClient' is not null or undefined
            assertParamExists('apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost', 'idClient', idClient)
            const localVarPath = `/api/lab/requestform/results/link/{idLabRequestFormResultHeader}/client/{idClient}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)))
                .replace(`{${"idClient"}}`, encodeURIComponent(String(idClient)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost: async (idLabRequestFormResultHeader: string, idLabRequestForm: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            // verify required parameter 'idLabRequestForm' is not null or undefined
            assertParamExists('apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost', 'idLabRequestForm', idLabRequestForm)
            const localVarPath = `/api/lab/requestform/results/link/{idLabRequestFormResultHeader}/form/{idLabRequestForm}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)))
                .replace(`{${"idLabRequestForm"}}`, encodeURIComponent(String(idLabRequestForm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost: async (idLabRequestFormResultHeader: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormResultHeader' is not null or undefined
            assertParamExists('apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost', 'idLabRequestFormResultHeader', idLabRequestFormResultHeader)
            const localVarPath = `/api/lab/requestform/results/link/unlink/{idLabRequestFormResultHeader}`
                .replace(`{${"idLabRequestFormResultHeader"}}`, encodeURIComponent(String(idLabRequestFormResultHeader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormResultsLinkingApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormResultsLinkingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormResultsLinkingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idClient 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost(idLabRequestFormResultHeader: string, idClient: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOPairResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost(idLabRequestFormResultHeader, idClient, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsLinkingApi.apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost(idLabRequestFormResultHeader: string, idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOPairResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost(idLabRequestFormResultHeader, idLabRequestForm, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsLinkingApi.apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost(idLabRequestFormResultHeader, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormResultsLinkingApi.apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormResultsLinkingApi - factory interface
 * @export
 */
export const LaboratoryRequestFormResultsLinkingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormResultsLinkingApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idClient 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost(idLabRequestFormResultHeader: string, idClient: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOPairResultDto> {
            return localVarFp.apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost(idLabRequestFormResultHeader, idClient, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} idLabRequestForm 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost(idLabRequestFormResultHeader: string, idLabRequestForm: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOPairResultDto> {
            return localVarFp.apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost(idLabRequestFormResultHeader, idLabRequestForm, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idLabRequestFormResultHeader 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormResultsLinkingApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormResultsLinkingApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormResultsLinkingApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} idClient 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsLinkingApi
     */
    public apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost(idLabRequestFormResultHeader: string, idClient: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsLinkingApiFp(this.configuration).apiLabRequestformResultsLinkIdLabRequestFormResultHeaderClientIdClientPost(idLabRequestFormResultHeader, idClient, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} idLabRequestForm 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsLinkingApi
     */
    public apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost(idLabRequestFormResultHeader: string, idLabRequestForm: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsLinkingApiFp(this.configuration).apiLabRequestformResultsLinkIdLabRequestFormResultHeaderFormIdLabRequestFormPost(idLabRequestFormResultHeader, idLabRequestForm, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idLabRequestFormResultHeader 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormResultsLinkingApi
     */
    public apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost(idLabRequestFormResultHeader: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormResultsLinkingApiFp(this.configuration).apiLabRequestformResultsLinkUnlinkIdLabRequestFormResultHeaderPost(idLabRequestFormResultHeader, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormServiceApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ensures existence of SQID for all laboratory requests
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformServiceComputeresulthashPost: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/service/computeresulthash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reprocesses the specific result header
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformServiceProcessresultIdGet: async (id: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLabRequestformServiceProcessresultIdGet', 'id', id)
            const localVarPath = `/api/lab/requestform/service/processresult/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Triggers processing of all results in the queue
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformServiceProcessresultallGet: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/service/processresultall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Regenerates all PDF printforms of all laboratory requests
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformServiceRefreshprintformPost: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/service/refreshprintform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormServiceApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ensures existence of SQID for all laboratory requests
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformServiceComputeresulthashPost(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformServiceComputeresulthashPost(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormServiceApi.apiLabRequestformServiceComputeresulthashPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Reprocesses the specific result header
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformServiceProcessresultIdGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformServiceProcessresultIdGet(id, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormServiceApi.apiLabRequestformServiceProcessresultIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Triggers processing of all results in the queue
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformServiceProcessresultallGet(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsLabRequestResultParseLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformServiceProcessresultallGet(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormServiceApi.apiLabRequestformServiceProcessresultallGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Regenerates all PDF printforms of all laboratory requests
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformServiceRefreshprintformPost(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformServiceRefreshprintformPost(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormServiceApi.apiLabRequestformServiceRefreshprintformPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormServiceApi - factory interface
 * @export
 */
export const LaboratoryRequestFormServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Ensures existence of SQID for all laboratory requests
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformServiceComputeresulthashPost(idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformServiceComputeresulthashPost(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reprocesses the specific result header
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformServiceProcessresultIdGet(id: string, idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformServiceProcessresultIdGet(id, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Triggers processing of all results in the queue
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformServiceProcessresultallGet(idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsLabRequestResultParseLog>> {
            return localVarFp.apiLabRequestformServiceProcessresultallGet(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Regenerates all PDF printforms of all laboratory requests
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformServiceRefreshprintformPost(idXdentUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabRequestformServiceRefreshprintformPost(idXdentUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormServiceApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormServiceApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormServiceApi extends BaseAPI {
    /**
     * 
     * @summary Ensures existence of SQID for all laboratory requests
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormServiceApi
     */
    public apiLabRequestformServiceComputeresulthashPost(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormServiceApiFp(this.configuration).apiLabRequestformServiceComputeresulthashPost(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reprocesses the specific result header
     * @param {string} id 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormServiceApi
     */
    public apiLabRequestformServiceProcessresultIdGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormServiceApiFp(this.configuration).apiLabRequestformServiceProcessresultIdGet(id, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Triggers processing of all results in the queue
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormServiceApi
     */
    public apiLabRequestformServiceProcessresultallGet(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormServiceApiFp(this.configuration).apiLabRequestformServiceProcessresultallGet(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Regenerates all PDF printforms of all laboratory requests
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormServiceApi
     */
    public apiLabRequestformServiceRefreshprintformPost(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormServiceApiFp(this.configuration).apiLabRequestformServiceRefreshprintformPost(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormTagsApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormTagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all active tags for the company.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsCompanyGet: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/tags/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsCreatePost: async (idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/tags/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedLabRequestFormTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a tag to an element.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [tableName] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost: async (idLabRequestFormTag: string, idGlobal: string, tableName?: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormTag' is not null or undefined
            assertParamExists('apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost', 'idLabRequestFormTag', idLabRequestFormTag)
            // verify required parameter 'idGlobal' is not null or undefined
            assertParamExists('apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost', 'idGlobal', idGlobal)
            const localVarPath = `/api/lab/requestform/tags/element/{idGlobal}/add/{idLabRequestFormTag}`
                .replace(`{${"idLabRequestFormTag"}}`, encodeURIComponent(String(idLabRequestFormTag)))
                .replace(`{${"idGlobal"}}`, encodeURIComponent(String(idGlobal)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (tableName !== undefined) {
                localVarQueryParameter['tableName'] = tableName;
            }

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all tags assigned to an element.
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsElementIdGlobalGet: async (idGlobal: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idGlobal' is not null or undefined
            assertParamExists('apiLabRequestformTagsElementIdGlobalGet', 'idGlobal', idGlobal)
            const localVarPath = `/api/lab/requestform/tags/element/{idGlobal}`
                .replace(`{${"idGlobal"}}`, encodeURIComponent(String(idGlobal)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if an element has a tag.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet: async (idLabRequestFormTag: string, idGlobal: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormTag' is not null or undefined
            assertParamExists('apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet', 'idLabRequestFormTag', idLabRequestFormTag)
            // verify required parameter 'idGlobal' is not null or undefined
            assertParamExists('apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet', 'idGlobal', idGlobal)
            const localVarPath = `/api/lab/requestform/tags/element/{idGlobal}/has/{idLabRequestFormTag}`
                .replace(`{${"idLabRequestFormTag"}}`, encodeURIComponent(String(idLabRequestFormTag)))
                .replace(`{${"idGlobal"}}`, encodeURIComponent(String(idGlobal)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a tag from an element.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete: async (idLabRequestFormTag: string, idGlobal: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormTag' is not null or undefined
            assertParamExists('apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete', 'idLabRequestFormTag', idLabRequestFormTag)
            // verify required parameter 'idGlobal' is not null or undefined
            assertParamExists('apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete', 'idGlobal', idGlobal)
            const localVarPath = `/api/lab/requestform/tags/element/{idGlobal}/remove/{idLabRequestFormTag}`
                .replace(`{${"idLabRequestFormTag"}}`, encodeURIComponent(String(idLabRequestFormTag)))
                .replace(`{${"idGlobal"}}`, encodeURIComponent(String(idGlobal)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a tag and its connections.
         * @param {string} idLabRequestFormTag 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsIdLabRequestFormTagDelete: async (idLabRequestFormTag: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idLabRequestFormTag' is not null or undefined
            assertParamExists('apiLabRequestformTagsIdLabRequestFormTagDelete', 'idLabRequestFormTag', idLabRequestFormTag)
            const localVarPath = `/api/lab/requestform/tags/{idLabRequestFormTag}`
                .replace(`{${"idLabRequestFormTag"}}`, encodeURIComponent(String(idLabRequestFormTag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update a tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsPost: async (idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedLabRequestFormTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all active tags for a table.
         * @param {string} tableName 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsTableTableNameGet: async (tableName: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableName' is not null or undefined
            assertParamExists('apiLabRequestformTagsTableTableNameGet', 'tableName', tableName)
            const localVarPath = `/api/lab/requestform/tags/table/{tableName}`
                .replace(`{${"tableName"}}`, encodeURIComponent(String(tableName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsUpdatePut: async (idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/tags/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentServicesXdentScopedLabRequestFormTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormTagsApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormTagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormTagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all active tags for the company.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsCompanyGet(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsCompanyGet(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsCompanyGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsCreatePost(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsCreatePost(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsCreatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Add a tag to an element.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [tableName] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost(idLabRequestFormTag: string, idGlobal: string, tableName?: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost(idLabRequestFormTag, idGlobal, tableName, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List all tags assigned to an element.
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsElementIdGlobalGet(idGlobal: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsElementIdGlobalGet(idGlobal, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsElementIdGlobalGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Check if an element has a tag.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet(idLabRequestFormTag: string, idGlobal: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet(idLabRequestFormTag, idGlobal, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a tag from an element.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete(idLabRequestFormTag: string, idGlobal: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete(idLabRequestFormTag, idGlobal, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Soft-delete a tag and its connections.
         * @param {string} idLabRequestFormTag 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsIdLabRequestFormTagDelete(idLabRequestFormTag: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsIdLabRequestFormTagDelete(idLabRequestFormTag, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsIdLabRequestFormTagDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create or update a tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsPost(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsPost(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List all active tags for a table.
         * @param {string} tableName 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsTableTableNameGet(tableName: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsTableTableNameGet(tableName, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsTableTableNameGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTagsUpdatePut(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTagsUpdatePut(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTagsApi.apiLabRequestformTagsUpdatePut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormTagsApi - factory interface
 * @export
 */
export const LaboratoryRequestFormTagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormTagsApiFp(configuration)
    return {
        /**
         * 
         * @summary List all active tags for the company.
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsCompanyGet(idXdentUser?: string, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>> {
            return localVarFp.apiLabRequestformTagsCompanyGet(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsCreatePost(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: any): AxiosPromise<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags> {
            return localVarFp.apiLabRequestformTagsCreatePost(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a tag to an element.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [tableName] 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost(idLabRequestFormTag: string, idGlobal: string, tableName?: string, idXdentUser?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost(idLabRequestFormTag, idGlobal, tableName, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all tags assigned to an element.
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsElementIdGlobalGet(idGlobal: string, idXdentUser?: string, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>> {
            return localVarFp.apiLabRequestformTagsElementIdGlobalGet(idGlobal, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if an element has a tag.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet(idLabRequestFormTag: string, idGlobal: string, idXdentUser?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet(idLabRequestFormTag, idGlobal, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a tag from an element.
         * @param {string} idLabRequestFormTag 
         * @param {string} idGlobal 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete(idLabRequestFormTag: string, idGlobal: string, idXdentUser?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete(idLabRequestFormTag, idGlobal, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a tag and its connections.
         * @param {string} idLabRequestFormTag 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsIdLabRequestFormTagDelete(idLabRequestFormTag: string, idXdentUser?: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiLabRequestformTagsIdLabRequestFormTagDelete(idLabRequestFormTag, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update a tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsPost(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: any): AxiosPromise<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags> {
            return localVarFp.apiLabRequestformTagsPost(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all active tags for a table.
         * @param {string} tableName 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsTableTableNameGet(tableName: string, idXdentUser?: string, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags>> {
            return localVarFp.apiLabRequestformTagsTableTableNameGet(tableName, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing tag.
         * @param {string} [idXdentUser] 
         * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTagsUpdatePut(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: any): AxiosPromise<APIContextGeneratedXdentCoreEntityLayerLabRequestFormTags> {
            return localVarFp.apiLabRequestformTagsUpdatePut(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormTagsApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormTagsApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormTagsApi extends BaseAPI {
    /**
     * 
     * @summary List all active tags for the company.
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsCompanyGet(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsCompanyGet(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new tag.
     * @param {string} [idXdentUser] 
     * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsCreatePost(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsCreatePost(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a tag to an element.
     * @param {string} idLabRequestFormTag 
     * @param {string} idGlobal 
     * @param {string} [tableName] 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost(idLabRequestFormTag: string, idGlobal: string, tableName?: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsElementIdGlobalAddIdLabRequestFormTagPost(idLabRequestFormTag, idGlobal, tableName, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all tags assigned to an element.
     * @param {string} idGlobal 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsElementIdGlobalGet(idGlobal: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsElementIdGlobalGet(idGlobal, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if an element has a tag.
     * @param {string} idLabRequestFormTag 
     * @param {string} idGlobal 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet(idLabRequestFormTag: string, idGlobal: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsElementIdGlobalHasIdLabRequestFormTagGet(idLabRequestFormTag, idGlobal, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a tag from an element.
     * @param {string} idLabRequestFormTag 
     * @param {string} idGlobal 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete(idLabRequestFormTag: string, idGlobal: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsElementIdGlobalRemoveIdLabRequestFormTagDelete(idLabRequestFormTag, idGlobal, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a tag and its connections.
     * @param {string} idLabRequestFormTag 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsIdLabRequestFormTagDelete(idLabRequestFormTag: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsIdLabRequestFormTagDelete(idLabRequestFormTag, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update a tag.
     * @param {string} [idXdentUser] 
     * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsPost(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsPost(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all active tags for a table.
     * @param {string} tableName 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsTableTableNameGet(tableName: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsTableTableNameGet(tableName, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing tag.
     * @param {string} [idXdentUser] 
     * @param {APIXdentServicesXdentScopedLabRequestFormTagDto} [aPIXdentServicesXdentScopedLabRequestFormTagDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTagsApi
     */
    public apiLabRequestformTagsUpdatePut(idXdentUser?: string, aPIXdentServicesXdentScopedLabRequestFormTagDto?: APIXdentServicesXdentScopedLabRequestFormTagDto, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTagsApiFp(this.configuration).apiLabRequestformTagsUpdatePut(idXdentUser, aPIXdentServicesXdentScopedLabRequestFormTagDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LaboratoryRequestFormTemplatesApi - axios parameter creator
 * @export
 */
export const LaboratoryRequestFormTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a list of laboratory requests templates
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTemplateGet: async (idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes the template
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTemplateIdDelete: async (id: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLabRequestformTemplateIdDelete', 'id', id)
            const localVarPath = `/api/lab/requestform/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Laboratory request template detail
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTemplateIdGet: async (id: string, idXdentUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLabRequestformTemplateIdGet', 'id', id)
            const localVarPath = `/api/lab/requestform/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates or updates a laboratory request template
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto} [aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTemplatePut: async (idXdentUser?: string, aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto?: APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lab/requestform/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaboratoryRequestFormTemplatesApi - functional programming interface
 * @export
 */
export const LaboratoryRequestFormTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaboratoryRequestFormTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns a list of laboratory requests templates
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTemplateGet(idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTemplateGet(idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTemplatesApi.apiLabRequestformTemplateGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes the template
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTemplateIdDelete(id: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTemplateIdDelete(id, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTemplatesApi.apiLabRequestformTemplateIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Laboratory request template detail
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTemplateIdGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTemplateIdGet(id, idXdentUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTemplatesApi.apiLabRequestformTemplateIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates or updates a laboratory request template
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto} [aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabRequestformTemplatePut(idXdentUser?: string, aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto?: APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabRequestformTemplatePut(idXdentUser, aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LaboratoryRequestFormTemplatesApi.apiLabRequestformTemplatePut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LaboratoryRequestFormTemplatesApi - factory interface
 * @export
 */
export const LaboratoryRequestFormTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaboratoryRequestFormTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns a list of laboratory requests templates
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTemplateGet(idXdentUser?: string, options?: any): AxiosPromise<Array<APISharedLabRequestFormsDTOLabRequestFormTemplateGridDto>> {
            return localVarFp.apiLabRequestformTemplateGet(idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes the template
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTemplateIdDelete(id: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto> {
            return localVarFp.apiLabRequestformTemplateIdDelete(id, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Laboratory request template detail
         * @param {string} id 
         * @param {string} [idXdentUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTemplateIdGet(id: string, idXdentUser?: string, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormTemplateDetailDto> {
            return localVarFp.apiLabRequestformTemplateIdGet(id, idXdentUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates or updates a laboratory request template
         * @param {string} [idXdentUser] 
         * @param {APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto} [aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabRequestformTemplatePut(idXdentUser?: string, aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto?: APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto, options?: any): AxiosPromise<APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto> {
            return localVarFp.apiLabRequestformTemplatePut(idXdentUser, aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LaboratoryRequestFormTemplatesApi - object-oriented interface
 * @export
 * @class LaboratoryRequestFormTemplatesApi
 * @extends {BaseAPI}
 */
export class LaboratoryRequestFormTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Returns a list of laboratory requests templates
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTemplatesApi
     */
    public apiLabRequestformTemplateGet(idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTemplatesApiFp(this.configuration).apiLabRequestformTemplateGet(idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes the template
     * @param {string} id 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTemplatesApi
     */
    public apiLabRequestformTemplateIdDelete(id: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTemplatesApiFp(this.configuration).apiLabRequestformTemplateIdDelete(id, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Laboratory request template detail
     * @param {string} id 
     * @param {string} [idXdentUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTemplatesApi
     */
    public apiLabRequestformTemplateIdGet(id: string, idXdentUser?: string, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTemplatesApiFp(this.configuration).apiLabRequestformTemplateIdGet(id, idXdentUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates or updates a laboratory request template
     * @param {string} [idXdentUser] 
     * @param {APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto} [aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaboratoryRequestFormTemplatesApi
     */
    public apiLabRequestformTemplatePut(idXdentUser?: string, aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto?: APISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto, options?: AxiosRequestConfig) {
        return LaboratoryRequestFormTemplatesApiFp(this.configuration).apiLabRequestformTemplatePut(idXdentUser, aPISharedLabRequestFormsDTOLabRequestFormTemplateCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LanguagesApi - axios parameter creator
 * @export
 */
export const LanguagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLanguagesGetLanguagesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Languages/GetLanguages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns localizations for mobile app
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLanguagesMobileLocalizationGet: async (languageCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Languages/MobileLocalization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageCode !== undefined) {
                localVarQueryParameter['languageCode'] = languageCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LanguagesApi - functional programming interface
 * @export
 */
export const LanguagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LanguagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns all available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLanguagesGetLanguagesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentServicesXdentScopedLanguagesServiceLanguageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLanguagesGetLanguagesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LanguagesApi.apiLanguagesGetLanguagesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns localizations for mobile app
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLanguagesMobileLocalizationGet(languageCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLanguagesMobileLocalizationGet(languageCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LanguagesApi.apiLanguagesMobileLocalizationGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LanguagesApi - factory interface
 * @export
 */
export const LanguagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LanguagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns all available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLanguagesGetLanguagesGet(options?: any): AxiosPromise<Array<APIXdentServicesXdentScopedLanguagesServiceLanguageDTO>> {
            return localVarFp.apiLanguagesGetLanguagesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns localizations for mobile app
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLanguagesMobileLocalizationGet(languageCode?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiLanguagesMobileLocalizationGet(languageCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LanguagesApi - object-oriented interface
 * @export
 * @class LanguagesApi
 * @extends {BaseAPI}
 */
export class LanguagesApi extends BaseAPI {
    /**
     * 
     * @summary Returns all available languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LanguagesApi
     */
    public apiLanguagesGetLanguagesGet(options?: AxiosRequestConfig) {
        return LanguagesApiFp(this.configuration).apiLanguagesGetLanguagesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns localizations for mobile app
     * @param {string} [languageCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LanguagesApi
     */
    public apiLanguagesMobileLocalizationGet(languageCode?: string, options?: AxiosRequestConfig) {
        return LanguagesApiFp(this.configuration).apiLanguagesMobileLocalizationGet(languageCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegacyApi - axios parameter creator
 * @export
 */
export const LegacyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates occurence from appointment pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyCreateOccurenceGet: async (idResource?: string, data?: string, intervalOriginal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/CreateOccurence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idResource !== undefined) {
                localVarQueryParameter['idResource'] = idResource;
            }

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }

            if (intervalOriginal !== undefined) {
                localVarQueryParameter['intervalOriginal'] = intervalOriginal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyDeleteAppointmentGet: async (idResource?: string, data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/DeleteAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idResource !== undefined) {
                localVarQueryParameter['idResource'] = idResource;
            }

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes changed occurence (pattern element).
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyDeleteChangedOccurenceGet: async (idResource?: string, data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/DeleteChangedOccurence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idResource !== undefined) {
                localVarQueryParameter['idResource'] = idResource;
            }

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes occurence from appointment pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyDeleteOccurenceGet: async (idResource?: string, data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/DeleteOccurence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idResource !== undefined) {
                localVarQueryParameter['idResource'] = idResource;
            }

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Inserts appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyInsertAppointmentGet: async (idResource?: string, data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/InsertAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idResource !== undefined) {
                localVarQueryParameter['idResource'] = idResource;
            }

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyPatternGet: async (idResource?: string, data?: string, intervalOriginal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/Pattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idResource !== undefined) {
                localVarQueryParameter['idResource'] = idResource;
            }

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }

            if (intervalOriginal !== undefined) {
                localVarQueryParameter['intervalOriginal'] = intervalOriginal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restores occurence to default pattern values.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyRestoreOccurencesGet: async (idResource?: string, data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/RestoreOccurences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idResource !== undefined) {
                localVarQueryParameter['idResource'] = idResource;
            }

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for available times by multiples of minutes offset.
         * @param {Date} [startTime] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {number} [minutesOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacySearchAvailableTimeGet: async (startTime?: Date, idService?: string, idStaff?: string, minutesOffset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/SearchAvailableTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (idService !== undefined) {
                localVarQueryParameter['idService'] = idService;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (minutesOffset !== undefined) {
                localVarQueryParameter['minutesOffset'] = minutesOffset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyUpdateAppointmentGet: async (idResource?: string, data?: string, intervalOriginal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Legacy/UpdateAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idResource !== undefined) {
                localVarQueryParameter['idResource'] = idResource;
            }

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }

            if (intervalOriginal !== undefined) {
                localVarQueryParameter['intervalOriginal'] = intervalOriginal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegacyApi - functional programming interface
 * @export
 */
export const LegacyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegacyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates occurence from appointment pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacyCreateOccurenceGet(idResource?: string, data?: string, intervalOriginal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacyCreateOccurenceGet(idResource, data, intervalOriginal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacyCreateOccurenceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacyDeleteAppointmentGet(idResource?: string, data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacyDeleteAppointmentGet(idResource, data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacyDeleteAppointmentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes changed occurence (pattern element).
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacyDeleteChangedOccurenceGet(idResource?: string, data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacyDeleteChangedOccurenceGet(idResource, data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacyDeleteChangedOccurenceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes occurence from appointment pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacyDeleteOccurenceGet(idResource?: string, data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacyDeleteOccurenceGet(idResource, data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacyDeleteOccurenceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Inserts appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacyInsertAppointmentGet(idResource?: string, data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacyInsertAppointmentGet(idResource, data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacyInsertAppointmentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacyPatternGet(idResource?: string, data?: string, intervalOriginal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacyPatternGet(idResource, data, intervalOriginal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacyPatternGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Restores occurence to default pattern values.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacyRestoreOccurencesGet(idResource?: string, data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacyRestoreOccurencesGet(idResource, data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacyRestoreOccurencesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for available times by multiples of minutes offset.
         * @param {Date} [startTime] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {number} [minutesOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacySearchAvailableTimeGet(startTime?: Date, idService?: string, idStaff?: string, minutesOffset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOLegacySearchAvailableTimeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacySearchAvailableTimeGet(startTime, idService, idStaff, minutesOffset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacySearchAvailableTimeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Updates appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegacyUpdateAppointmentGet(idResource?: string, data?: string, intervalOriginal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegacyUpdateAppointmentGet(idResource, data, intervalOriginal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LegacyApi.apiLegacyUpdateAppointmentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LegacyApi - factory interface
 * @export
 */
export const LegacyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegacyApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates occurence from appointment pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyCreateOccurenceGet(idResource?: string, data?: string, intervalOriginal?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLegacyCreateOccurenceGet(idResource, data, intervalOriginal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyDeleteAppointmentGet(idResource?: string, data?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLegacyDeleteAppointmentGet(idResource, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes changed occurence (pattern element).
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyDeleteChangedOccurenceGet(idResource?: string, data?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLegacyDeleteChangedOccurenceGet(idResource, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes occurence from appointment pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyDeleteOccurenceGet(idResource?: string, data?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLegacyDeleteOccurenceGet(idResource, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Inserts appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyInsertAppointmentGet(idResource?: string, data?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLegacyInsertAppointmentGet(idResource, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates pattern.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyPatternGet(idResource?: string, data?: string, intervalOriginal?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLegacyPatternGet(idResource, data, intervalOriginal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restores occurence to default pattern values.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyRestoreOccurencesGet(idResource?: string, data?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLegacyRestoreOccurencesGet(idResource, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for available times by multiples of minutes offset.
         * @param {Date} [startTime] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {number} [minutesOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacySearchAvailableTimeGet(startTime?: Date, idService?: string, idStaff?: string, minutesOffset?: number, options?: any): AxiosPromise<Array<APIXdentDTOLegacySearchAvailableTimeDto>> {
            return localVarFp.apiLegacySearchAvailableTimeGet(startTime, idService, idStaff, minutesOffset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates appointment via provided data.
         * @param {string} [idResource] 
         * @param {string} [data] 
         * @param {string} [intervalOriginal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegacyUpdateAppointmentGet(idResource?: string, data?: string, intervalOriginal?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLegacyUpdateAppointmentGet(idResource, data, intervalOriginal, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegacyApi - object-oriented interface
 * @export
 * @class LegacyApi
 * @extends {BaseAPI}
 */
export class LegacyApi extends BaseAPI {
    /**
     * 
     * @summary Creates occurence from appointment pattern.
     * @param {string} [idResource] 
     * @param {string} [data] 
     * @param {string} [intervalOriginal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacyCreateOccurenceGet(idResource?: string, data?: string, intervalOriginal?: string, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacyCreateOccurenceGet(idResource, data, intervalOriginal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes appointment via provided data.
     * @param {string} [idResource] 
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacyDeleteAppointmentGet(idResource?: string, data?: string, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacyDeleteAppointmentGet(idResource, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes changed occurence (pattern element).
     * @param {string} [idResource] 
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacyDeleteChangedOccurenceGet(idResource?: string, data?: string, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacyDeleteChangedOccurenceGet(idResource, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes occurence from appointment pattern.
     * @param {string} [idResource] 
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacyDeleteOccurenceGet(idResource?: string, data?: string, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacyDeleteOccurenceGet(idResource, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Inserts appointment via provided data.
     * @param {string} [idResource] 
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacyInsertAppointmentGet(idResource?: string, data?: string, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacyInsertAppointmentGet(idResource, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates pattern.
     * @param {string} [idResource] 
     * @param {string} [data] 
     * @param {string} [intervalOriginal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacyPatternGet(idResource?: string, data?: string, intervalOriginal?: string, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacyPatternGet(idResource, data, intervalOriginal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restores occurence to default pattern values.
     * @param {string} [idResource] 
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacyRestoreOccurencesGet(idResource?: string, data?: string, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacyRestoreOccurencesGet(idResource, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for available times by multiples of minutes offset.
     * @param {Date} [startTime] 
     * @param {string} [idService] 
     * @param {string} [idStaff] 
     * @param {number} [minutesOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacySearchAvailableTimeGet(startTime?: Date, idService?: string, idStaff?: string, minutesOffset?: number, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacySearchAvailableTimeGet(startTime, idService, idStaff, minutesOffset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates appointment via provided data.
     * @param {string} [idResource] 
     * @param {string} [data] 
     * @param {string} [intervalOriginal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public apiLegacyUpdateAppointmentGet(idResource?: string, data?: string, intervalOriginal?: string, options?: AxiosRequestConfig) {
        return LegacyApiFp(this.configuration).apiLegacyUpdateAppointmentGet(idResource, data, intervalOriginal, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return location custom settings by location id
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsGetLocationCustomSettingsGet: async (idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Locations/GetLocationCustomSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return locations for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsGetLocationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Locations/GetLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return location custom settings by location id
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsGetLocationCustomSettingsGet(idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOLocationLocationCustomSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLocationsGetLocationCustomSettingsGet(idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LocationsApi.apiLocationsGetLocationCustomSettingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return locations for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsGetLocationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOLocationLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLocationsGetLocationsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LocationsApi.apiLocationsGetLocationsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Return location custom settings by location id
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsGetLocationCustomSettingsGet(idLocation?: string, options?: any): AxiosPromise<APISharedDTOLocationLocationCustomSettingsDto> {
            return localVarFp.apiLocationsGetLocationCustomSettingsGet(idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return locations for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsGetLocationsGet(options?: any): AxiosPromise<Array<APIXdentDTOLocationLocationDto>> {
            return localVarFp.apiLocationsGetLocationsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @summary Return location custom settings by location id
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiLocationsGetLocationCustomSettingsGet(idLocation?: string, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiLocationsGetLocationCustomSettingsGet(idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return locations for logged user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiLocationsGetLocationsGet(options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiLocationsGetLocationsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogsApi - axios parameter creator
 * @export
 */
export const LogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {APIXdentDTOUserLogUserLogDto} [aPIXdentDTOUserLogUserLogDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogCreatePost: async (aPIXdentDTOUserLogUserLogDto?: APIXdentDTOUserLogUserLogDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mobile/log/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOUserLogUserLogDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestAuthLoggingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mobile/log/TestAuthLogging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestExceptionLoggingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mobile/log/TestExceptionLogging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestInnerExceptionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mobile/log/TestInnerExceptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestLoggingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mobile/log/TestLogging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {APIXdentDTOUserLogTestLogPostDto} [aPIXdentDTOUserLogTestLogPostDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestLoggingPost: async (aPIXdentDTOUserLogTestLogPostDto?: APIXdentDTOUserLogTestLogPostDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mobile/log/TestLogging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOUserLogTestLogPostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets logs for logged user. Admin role can get logs from users in the same company.
         * @param {Date} [dateStart] FILTER
         * @param {Date} [dateEnd] FILTER
         * @param {string} [idUser] FILTER (company restrictions apply)
         * @param {string} [idLog] FILTER
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogUserLogsGet: async (dateStart?: Date, dateEnd?: Date, idUser?: string, idLog?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mobile/log/UserLogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = (dateStart as any instanceof Date) ?
                    (dateStart as any).toISOString() :
                    dateStart;
            }

            if (dateEnd !== undefined) {
                localVarQueryParameter['dateEnd'] = (dateEnd as any instanceof Date) ?
                    (dateEnd as any).toISOString() :
                    dateEnd;
            }

            if (idUser !== undefined) {
                localVarQueryParameter['idUser'] = idUser;
            }

            if (idLog !== undefined) {
                localVarQueryParameter['idLog'] = idLog;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogsApi - functional programming interface
 * @export
 */
export const LogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {APIXdentDTOUserLogUserLogDto} [aPIXdentDTOUserLogUserLogDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMobileLogCreatePost(aPIXdentDTOUserLogUserLogDto?: APIXdentDTOUserLogUserLogDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMobileLogCreatePost(aPIXdentDTOUserLogUserLogDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogsApi.apiMobileLogCreatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMobileLogTestAuthLoggingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMobileLogTestAuthLoggingGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogsApi.apiMobileLogTestAuthLoggingGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMobileLogTestExceptionLoggingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMobileLogTestExceptionLoggingGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogsApi.apiMobileLogTestExceptionLoggingGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMobileLogTestInnerExceptionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMobileLogTestInnerExceptionsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogsApi.apiMobileLogTestInnerExceptionsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMobileLogTestLoggingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMobileLogTestLoggingGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogsApi.apiMobileLogTestLoggingGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {APIXdentDTOUserLogTestLogPostDto} [aPIXdentDTOUserLogTestLogPostDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMobileLogTestLoggingPost(aPIXdentDTOUserLogTestLogPostDto?: APIXdentDTOUserLogTestLogPostDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMobileLogTestLoggingPost(aPIXdentDTOUserLogTestLogPostDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogsApi.apiMobileLogTestLoggingPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets logs for logged user. Admin role can get logs from users in the same company.
         * @param {Date} [dateStart] FILTER
         * @param {Date} [dateEnd] FILTER
         * @param {string} [idUser] FILTER (company restrictions apply)
         * @param {string} [idLog] FILTER
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMobileLogUserLogsGet(dateStart?: Date, dateEnd?: Date, idUser?: string, idLog?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerUserLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMobileLogUserLogsGet(dateStart, dateEnd, idUser, idLog, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogsApi.apiMobileLogUserLogsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LogsApi - factory interface
 * @export
 */
export const LogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogsApiFp(configuration)
    return {
        /**
         * 
         * @param {APIXdentDTOUserLogUserLogDto} [aPIXdentDTOUserLogUserLogDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogCreatePost(aPIXdentDTOUserLogUserLogDto?: APIXdentDTOUserLogUserLogDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiMobileLogCreatePost(aPIXdentDTOUserLogUserLogDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestAuthLoggingGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiMobileLogTestAuthLoggingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestExceptionLoggingGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiMobileLogTestExceptionLoggingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestInnerExceptionsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiMobileLogTestInnerExceptionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestLoggingGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiMobileLogTestLoggingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {APIXdentDTOUserLogTestLogPostDto} [aPIXdentDTOUserLogTestLogPostDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogTestLoggingPost(aPIXdentDTOUserLogTestLogPostDto?: APIXdentDTOUserLogTestLogPostDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiMobileLogTestLoggingPost(aPIXdentDTOUserLogTestLogPostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets logs for logged user. Admin role can get logs from users in the same company.
         * @param {Date} [dateStart] FILTER
         * @param {Date} [dateEnd] FILTER
         * @param {string} [idUser] FILTER (company restrictions apply)
         * @param {string} [idLog] FILTER
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMobileLogUserLogsGet(dateStart?: Date, dateEnd?: Date, idUser?: string, idLog?: string, options?: any): AxiosPromise<Array<APIContextGeneratedXdentCoreEntityLayerUserLog>> {
            return localVarFp.apiMobileLogUserLogsGet(dateStart, dateEnd, idUser, idLog, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogsApi - object-oriented interface
 * @export
 * @class LogsApi
 * @extends {BaseAPI}
 */
export class LogsApi extends BaseAPI {
    /**
     * 
     * @param {APIXdentDTOUserLogUserLogDto} [aPIXdentDTOUserLogUserLogDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiMobileLogCreatePost(aPIXdentDTOUserLogUserLogDto?: APIXdentDTOUserLogUserLogDto, options?: AxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiMobileLogCreatePost(aPIXdentDTOUserLogUserLogDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiMobileLogTestAuthLoggingGet(options?: AxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiMobileLogTestAuthLoggingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiMobileLogTestExceptionLoggingGet(options?: AxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiMobileLogTestExceptionLoggingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiMobileLogTestInnerExceptionsGet(options?: AxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiMobileLogTestInnerExceptionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiMobileLogTestLoggingGet(options?: AxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiMobileLogTestLoggingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {APIXdentDTOUserLogTestLogPostDto} [aPIXdentDTOUserLogTestLogPostDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiMobileLogTestLoggingPost(aPIXdentDTOUserLogTestLogPostDto?: APIXdentDTOUserLogTestLogPostDto, options?: AxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiMobileLogTestLoggingPost(aPIXdentDTOUserLogTestLogPostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets logs for logged user. Admin role can get logs from users in the same company.
     * @param {Date} [dateStart] FILTER
     * @param {Date} [dateEnd] FILTER
     * @param {string} [idUser] FILTER (company restrictions apply)
     * @param {string} [idLog] FILTER
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiMobileLogUserLogsGet(dateStart?: Date, dateEnd?: Date, idUser?: string, idLog?: string, options?: AxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiMobileLogUserLogsGet(dateStart, dateEnd, idUser, idLog, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MedicalReportApi - axios parameter creator
 * @export
 */
export const MedicalReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create/update exam in MedicalReport
         * @param {APIXdentDTOMedicalRecordMedicalReportExamDto} [aPIXdentDTOMedicalRecordMedicalReportExamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportCreateUpdateExamPost: async (aPIXdentDTOMedicalRecordMedicalReportExamDto?: APIXdentDTOMedicalRecordMedicalReportExamDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/CreateUpdateExam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOMedicalRecordMedicalReportExamDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ExamList exam in MedicalReport
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamListGet: async (idMedicalReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/ExamList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates text from dental chart to insert into medical report
         * @param {string} [medicalReportId] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGenerateMedicalReportTextFromChartGet: async (medicalReportId?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GenerateMedicalReportTextFromChart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (medicalReportId !== undefined) {
                localVarQueryParameter['medicalReportId'] = medicalReportId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets diagnosis by medical report id
         * @param {string} [idReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetDiagnosisGet: async (idReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetDiagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idReport !== undefined) {
                localVarQueryParameter['idReport'] = idReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets medical report insurance history list
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetInsuranceClientHistoryListGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetInsuranceClientHistoryList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets invoice client history list
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetInvoiceClientHistoryListGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetInvoiceClientHistoryList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportDetailByIdGet: async (idMedicalReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetMedicalReportDetailById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [idReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportGet: async (idReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetMedicalReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idReport !== undefined) {
                localVarQueryParameter['idReport'] = idReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets medical report insurance grid
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportInsuranceGridGet: async (data?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetMedicalReportInsuranceGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets medical report lab labels
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportLabLabelsGet: async (idMedicalReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetMedicalReportLabLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets medical reports by client
         * @param {string} [clientId] 
         * @param {boolean} [showInfoReports] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportsByClientGet: async (clientId?: string, showInfoReports?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetMedicalReportsByClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (showInfoReports !== undefined) {
                localVarQueryParameter['showInfoReports'] = showInfoReports;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets supervisors for medical report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetSupervisorListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/GetSupervisorList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves new/existing medical report
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportMedicalReportInsuranceLockTogglePost: async (idMedicalReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/MedicalReportInsuranceLockToggle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves new/existing medical report
         * @param {APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto} [aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportSavePost: async (aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto?: APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReport/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicalReportApi - functional programming interface
 * @export
 */
export const MedicalReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicalReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create/update exam in MedicalReport
         * @param {APIXdentDTOMedicalRecordMedicalReportExamDto} [aPIXdentDTOMedicalRecordMedicalReportExamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportCreateUpdateExamPost(aPIXdentDTOMedicalRecordMedicalReportExamDto?: APIXdentDTOMedicalRecordMedicalReportExamDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportCreateUpdateExamPost(aPIXdentDTOMedicalRecordMedicalReportExamDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportCreateUpdateExamPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary ExamList exam in MedicalReport
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportExamListGet(idMedicalReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportExamDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportExamListGet(idMedicalReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportExamListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generates text from dental chart to insert into medical report
         * @param {string} [medicalReportId] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGenerateMedicalReportTextFromChartGet(medicalReportId?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGenerateMedicalReportTextFromChartGet(medicalReportId, lang, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGenerateMedicalReportTextFromChartGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets diagnosis by medical report id
         * @param {string} [idReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetDiagnosisGet(idReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetDiagnosisGet(idReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetDiagnosisGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets medical report insurance history list
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetInsuranceClientHistoryListGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetInsuranceClientHistoryListGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetInsuranceClientHistoryListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets invoice client history list
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetInvoiceClientHistoryListGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordInsuranceClientHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetInvoiceClientHistoryListGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetInvoiceClientHistoryListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetMedicalReportDetailByIdGet(idMedicalReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedMedicalReportDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetMedicalReportDetailByIdGet(idMedicalReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetMedicalReportDetailByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [idReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetMedicalReportGet(idReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetMedicalReportGet(idReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetMedicalReportGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets medical report insurance grid
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetMedicalReportInsuranceGridGet(data?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportInsuranceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetMedicalReportInsuranceGridGet(data, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetMedicalReportInsuranceGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets medical report lab labels
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetMedicalReportLabLabelsGet(idMedicalReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetMedicalReportLabLabelsGet(idMedicalReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetMedicalReportLabLabelsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets medical reports by client
         * @param {string} [clientId] 
         * @param {boolean} [showInfoReports] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetMedicalReportsByClientGet(clientId?: string, showInfoReports?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetMedicalReportsByClientGet(clientId, showInfoReports, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetMedicalReportsByClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets supervisors for medical report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportGetSupervisorListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportGetSupervisorListGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportGetSupervisorListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Saves new/existing medical report
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportMedicalReportInsuranceLockTogglePost(idMedicalReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportMedicalReportInsuranceLockTogglePost(idMedicalReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportMedicalReportInsuranceLockTogglePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Saves new/existing medical report
         * @param {APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto} [aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportSavePost(aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto?: APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportSavePost(aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportApi.apiMedicalReportSavePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MedicalReportApi - factory interface
 * @export
 */
export const MedicalReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicalReportApiFp(configuration)
    return {
        /**
         * 
         * @summary Create/update exam in MedicalReport
         * @param {APIXdentDTOMedicalRecordMedicalReportExamDto} [aPIXdentDTOMedicalRecordMedicalReportExamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportCreateUpdateExamPost(aPIXdentDTOMedicalRecordMedicalReportExamDto?: APIXdentDTOMedicalRecordMedicalReportExamDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiMedicalReportCreateUpdateExamPost(aPIXdentDTOMedicalRecordMedicalReportExamDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ExamList exam in MedicalReport
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamListGet(idMedicalReport?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportExamDto>> {
            return localVarFp.apiMedicalReportExamListGet(idMedicalReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates text from dental chart to insert into medical report
         * @param {string} [medicalReportId] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGenerateMedicalReportTextFromChartGet(medicalReportId?: string, lang?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiMedicalReportGenerateMedicalReportTextFromChartGet(medicalReportId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets diagnosis by medical report id
         * @param {string} [idReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetDiagnosisGet(idReport?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTDIAGNOSEGRIDResult>> {
            return localVarFp.apiMedicalReportGetDiagnosisGet(idReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets medical report insurance history list
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetInsuranceClientHistoryListGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordInsuranceClientHistoryExtendedDto>> {
            return localVarFp.apiMedicalReportGetInsuranceClientHistoryListGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets invoice client history list
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetInvoiceClientHistoryListGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordInsuranceClientHistoryDto>> {
            return localVarFp.apiMedicalReportGetInvoiceClientHistoryListGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportDetailByIdGet(idMedicalReport?: string, options?: any): AxiosPromise<APISharedMedicalReportDetailDto> {
            return localVarFp.apiMedicalReportGetMedicalReportDetailByIdGet(idMedicalReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets medical report by id
         * @param {string} [idReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportGet(idReport?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTFORMResult> {
            return localVarFp.apiMedicalReportGetMedicalReportGet(idReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets medical report insurance grid
         * @param {string} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportInsuranceGridGet(data?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportInsuranceDto>> {
            return localVarFp.apiMedicalReportGetMedicalReportInsuranceGridGet(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets medical report lab labels
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportLabLabelsGet(idMedicalReport?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedLABORATORYLABELGRIDResult>> {
            return localVarFp.apiMedicalReportGetMedicalReportLabLabelsGet(idMedicalReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets medical reports by client
         * @param {string} [clientId] 
         * @param {boolean} [showInfoReports] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetMedicalReportsByClientGet(clientId?: string, showInfoReports?: boolean, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTGRIDResult>> {
            return localVarFp.apiMedicalReportGetMedicalReportsByClientGet(clientId, showInfoReports, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets supervisors for medical report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportGetSupervisorListGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINVOICESUPERVISORGRIDResult>> {
            return localVarFp.apiMedicalReportGetSupervisorListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves new/existing medical report
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportMedicalReportInsuranceLockTogglePost(idMedicalReport?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiMedicalReportMedicalReportInsuranceLockTogglePost(idMedicalReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves new/existing medical report
         * @param {APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto} [aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportSavePost(aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto?: APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiMedicalReportSavePost(aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicalReportApi - object-oriented interface
 * @export
 * @class MedicalReportApi
 * @extends {BaseAPI}
 */
export class MedicalReportApi extends BaseAPI {
    /**
     * 
     * @summary Create/update exam in MedicalReport
     * @param {APIXdentDTOMedicalRecordMedicalReportExamDto} [aPIXdentDTOMedicalRecordMedicalReportExamDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportCreateUpdateExamPost(aPIXdentDTOMedicalRecordMedicalReportExamDto?: APIXdentDTOMedicalRecordMedicalReportExamDto, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportCreateUpdateExamPost(aPIXdentDTOMedicalRecordMedicalReportExamDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ExamList exam in MedicalReport
     * @param {string} [idMedicalReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportExamListGet(idMedicalReport?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportExamListGet(idMedicalReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates text from dental chart to insert into medical report
     * @param {string} [medicalReportId] 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGenerateMedicalReportTextFromChartGet(medicalReportId?: string, lang?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGenerateMedicalReportTextFromChartGet(medicalReportId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets diagnosis by medical report id
     * @param {string} [idReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetDiagnosisGet(idReport?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetDiagnosisGet(idReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets medical report insurance history list
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetInsuranceClientHistoryListGet(idClient?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetInsuranceClientHistoryListGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets invoice client history list
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetInvoiceClientHistoryListGet(idClient?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetInvoiceClientHistoryListGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets medical report by id
     * @param {string} [idMedicalReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetMedicalReportDetailByIdGet(idMedicalReport?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetMedicalReportDetailByIdGet(idMedicalReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets medical report by id
     * @param {string} [idReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetMedicalReportGet(idReport?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetMedicalReportGet(idReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets medical report insurance grid
     * @param {string} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetMedicalReportInsuranceGridGet(data?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetMedicalReportInsuranceGridGet(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets medical report lab labels
     * @param {string} [idMedicalReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetMedicalReportLabLabelsGet(idMedicalReport?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetMedicalReportLabLabelsGet(idMedicalReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets medical reports by client
     * @param {string} [clientId] 
     * @param {boolean} [showInfoReports] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetMedicalReportsByClientGet(clientId?: string, showInfoReports?: boolean, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetMedicalReportsByClientGet(clientId, showInfoReports, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets supervisors for medical report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportGetSupervisorListGet(options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportGetSupervisorListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves new/existing medical report
     * @param {string} [idMedicalReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportMedicalReportInsuranceLockTogglePost(idMedicalReport?: string, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportMedicalReportInsuranceLockTogglePost(idMedicalReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves new/existing medical report
     * @param {APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto} [aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportApi
     */
    public apiMedicalReportSavePost(aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto?: APIXdentDTOMedicalRecordMedicalReportSaveWrapperDto, options?: AxiosRequestConfig) {
        return MedicalReportApiFp(this.configuration).apiMedicalReportSavePost(aPIXdentDTOMedicalRecordMedicalReportSaveWrapperDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MedicalReportExamSettingsApi - axios parameter creator
 * @export
 */
export const MedicalReportExamSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto} [aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamResultSettingsCreateUpdatePost: async (aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto?: APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportExamSettings/ExamResultSettingsCreateUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamResultSettingsListGet: async (idMedicalReportExamSettings?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportExamSettings/ExamResultSettingsList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReportExamSettings !== undefined) {
                localVarQueryParameter['idMedicalReportExamSettings'] = idMedicalReportExamSettings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportExamSettingsDto} [aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamSettingsCreateUpdatePost: async (aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto?: APIXdentDTOMedicalRecordMedicalReportExamSettingsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportExamSettings/ExamSettingsCreateUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamSettingsDeleteDelete: async (idMedicalReportExamSettings?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportExamSettings/ExamSettingsDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReportExamSettings !== undefined) {
                localVarQueryParameter['idMedicalReportExamSettings'] = idMedicalReportExamSettings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {number} [resultsMaxLength] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamSettingsListGet: async (idLocation?: string, resultsMaxLength?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportExamSettings/ExamSettingsList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (resultsMaxLength !== undefined) {
                localVarQueryParameter['resultsMaxLength'] = resultsMaxLength;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamOptionSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamSettingsResultDeleteDelete: async (idMedicalReportExamOptionSettings?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportExamSettings/ExamSettingsResultDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReportExamOptionSettings !== undefined) {
                localVarQueryParameter['idMedicalReportExamOptionSettings'] = idMedicalReportExamOptionSettings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicalReportExamSettingsApi - functional programming interface
 * @export
 */
export const MedicalReportExamSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicalReportExamSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto} [aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportExamSettingsExamResultSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto?: APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportExamSettingsExamResultSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportExamSettingsApi.apiMedicalReportExamSettingsExamResultSettingsCreateUpdatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportExamSettingsExamResultSettingsListGet(idMedicalReportExamSettings?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportExamSettingsExamResultSettingsListGet(idMedicalReportExamSettings, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportExamSettingsApi.apiMedicalReportExamSettingsExamResultSettingsListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportExamSettingsDto} [aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportExamSettingsExamSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto?: APIXdentDTOMedicalRecordMedicalReportExamSettingsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportExamSettingsExamSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportExamSettingsApi.apiMedicalReportExamSettingsExamSettingsCreateUpdatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportExamSettingsExamSettingsDeleteDelete(idMedicalReportExamSettings?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportExamSettingsExamSettingsDeleteDelete(idMedicalReportExamSettings, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportExamSettingsApi.apiMedicalReportExamSettingsExamSettingsDeleteDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {number} [resultsMaxLength] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportExamSettingsExamSettingsListGet(idLocation?: string, resultsMaxLength?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportExamSettingsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportExamSettingsExamSettingsListGet(idLocation, resultsMaxLength, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportExamSettingsApi.apiMedicalReportExamSettingsExamSettingsListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamOptionSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportExamSettingsExamSettingsResultDeleteDelete(idMedicalReportExamOptionSettings?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportExamSettingsExamSettingsResultDeleteDelete(idMedicalReportExamOptionSettings, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportExamSettingsApi.apiMedicalReportExamSettingsExamSettingsResultDeleteDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MedicalReportExamSettingsApi - factory interface
 * @export
 */
export const MedicalReportExamSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicalReportExamSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto} [aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamResultSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto?: APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiMedicalReportExamSettingsExamResultSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamResultSettingsListGet(idMedicalReportExamSettings?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto>> {
            return localVarFp.apiMedicalReportExamSettingsExamResultSettingsListGet(idMedicalReportExamSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportExamSettingsDto} [aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto?: APIXdentDTOMedicalRecordMedicalReportExamSettingsDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiMedicalReportExamSettingsExamSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamSettingsDeleteDelete(idMedicalReportExamSettings?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMedicalReportExamSettingsExamSettingsDeleteDelete(idMedicalReportExamSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {number} [resultsMaxLength] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamSettingsListGet(idLocation?: string, resultsMaxLength?: number, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportExamSettingsDto>> {
            return localVarFp.apiMedicalReportExamSettingsExamSettingsListGet(idLocation, resultsMaxLength, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportExamOptionSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportExamSettingsExamSettingsResultDeleteDelete(idMedicalReportExamOptionSettings?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMedicalReportExamSettingsExamSettingsResultDeleteDelete(idMedicalReportExamOptionSettings, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicalReportExamSettingsApi - object-oriented interface
 * @export
 * @class MedicalReportExamSettingsApi
 * @extends {BaseAPI}
 */
export class MedicalReportExamSettingsApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto} [aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportExamSettingsApi
     */
    public apiMedicalReportExamSettingsExamResultSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto?: APIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto, options?: AxiosRequestConfig) {
        return MedicalReportExamSettingsApiFp(this.configuration).apiMedicalReportExamSettingsExamResultSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamResultSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReportExamSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportExamSettingsApi
     */
    public apiMedicalReportExamSettingsExamResultSettingsListGet(idMedicalReportExamSettings?: string, options?: AxiosRequestConfig) {
        return MedicalReportExamSettingsApiFp(this.configuration).apiMedicalReportExamSettingsExamResultSettingsListGet(idMedicalReportExamSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOMedicalRecordMedicalReportExamSettingsDto} [aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportExamSettingsApi
     */
    public apiMedicalReportExamSettingsExamSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto?: APIXdentDTOMedicalRecordMedicalReportExamSettingsDto, options?: AxiosRequestConfig) {
        return MedicalReportExamSettingsApiFp(this.configuration).apiMedicalReportExamSettingsExamSettingsCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportExamSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReportExamSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportExamSettingsApi
     */
    public apiMedicalReportExamSettingsExamSettingsDeleteDelete(idMedicalReportExamSettings?: string, options?: AxiosRequestConfig) {
        return MedicalReportExamSettingsApiFp(this.configuration).apiMedicalReportExamSettingsExamSettingsDeleteDelete(idMedicalReportExamSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLocation] 
     * @param {number} [resultsMaxLength] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportExamSettingsApi
     */
    public apiMedicalReportExamSettingsExamSettingsListGet(idLocation?: string, resultsMaxLength?: number, options?: AxiosRequestConfig) {
        return MedicalReportExamSettingsApiFp(this.configuration).apiMedicalReportExamSettingsExamSettingsListGet(idLocation, resultsMaxLength, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReportExamOptionSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportExamSettingsApi
     */
    public apiMedicalReportExamSettingsExamSettingsResultDeleteDelete(idMedicalReportExamOptionSettings?: string, options?: AxiosRequestConfig) {
        return MedicalReportExamSettingsApiFp(this.configuration).apiMedicalReportExamSettingsExamSettingsResultDeleteDelete(idMedicalReportExamOptionSettings, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MedicalReportPregnancyApi - axios parameter creator
 * @export
 */
export const MedicalReportPregnancyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportPregnancyDto} [aPIXdentDTOMedicalRecordMedicalReportPregnancyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyCreateUpdatePost: async (aPIXdentDTOMedicalRecordMedicalReportPregnancyDto?: APIXdentDTOMedicalRecordMedicalReportPregnancyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportPregnancy/PregnancyCreateUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOMedicalRecordMedicalReportPregnancyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto} [aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyExamCreateUpdatePost: async (aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto?: APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportPregnancy/PregnancyExamCreateUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyExamGridByClientGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportPregnancy/PregnancyExamGridByClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyExamGridByReportGet: async (idMedicalReport?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportPregnancy/PregnancyExamGridByReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReport !== undefined) {
                localVarQueryParameter['idMedicalReport'] = idMedicalReport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportPregnancy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyExamGridGet: async (idMedicalReportPregnancy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportPregnancy/PregnancyExamGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idMedicalReportPregnancy !== undefined) {
                localVarQueryParameter['idMedicalReportPregnancy'] = idMedicalReportPregnancy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyGridGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MedicalReportPregnancy/PregnancyGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicalReportPregnancyApi - functional programming interface
 * @export
 */
export const MedicalReportPregnancyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicalReportPregnancyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportPregnancyDto} [aPIXdentDTOMedicalRecordMedicalReportPregnancyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportPregnancyPregnancyCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyDto?: APIXdentDTOMedicalRecordMedicalReportPregnancyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportPregnancyPregnancyCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportPregnancyApi.apiMedicalReportPregnancyPregnancyCreateUpdatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto} [aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportPregnancyPregnancyExamCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto?: APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportPregnancyPregnancyExamCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportPregnancyApi.apiMedicalReportPregnancyPregnancyExamCreateUpdatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportPregnancyPregnancyExamGridByClientGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportPregnancyPregnancyExamGridByClientGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportPregnancyApi.apiMedicalReportPregnancyPregnancyExamGridByClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportPregnancyPregnancyExamGridByReportGet(idMedicalReport?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportPregnancyPregnancyExamGridByReportGet(idMedicalReport, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportPregnancyApi.apiMedicalReportPregnancyPregnancyExamGridByReportGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportPregnancy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportPregnancyPregnancyExamGridGet(idMedicalReportPregnancy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportPregnancyPregnancyExamGridGet(idMedicalReportPregnancy, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportPregnancyApi.apiMedicalReportPregnancyPregnancyExamGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMedicalReportPregnancyPregnancyGridGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportPregnancyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMedicalReportPregnancyPregnancyGridGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MedicalReportPregnancyApi.apiMedicalReportPregnancyPregnancyGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MedicalReportPregnancyApi - factory interface
 * @export
 */
export const MedicalReportPregnancyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicalReportPregnancyApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportPregnancyDto} [aPIXdentDTOMedicalRecordMedicalReportPregnancyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyDto?: APIXdentDTOMedicalRecordMedicalReportPregnancyDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiMedicalReportPregnancyPregnancyCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto} [aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyExamCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto?: APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiMedicalReportPregnancyPregnancyExamCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyExamGridByClientGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto>> {
            return localVarFp.apiMedicalReportPregnancyPregnancyExamGridByClientGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyExamGridByReportGet(idMedicalReport?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto>> {
            return localVarFp.apiMedicalReportPregnancyPregnancyExamGridByReportGet(idMedicalReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idMedicalReportPregnancy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyExamGridGet(idMedicalReportPregnancy?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto>> {
            return localVarFp.apiMedicalReportPregnancyPregnancyExamGridGet(idMedicalReportPregnancy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMedicalReportPregnancyPregnancyGridGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOMedicalRecordMedicalReportPregnancyDto>> {
            return localVarFp.apiMedicalReportPregnancyPregnancyGridGet(idClient, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicalReportPregnancyApi - object-oriented interface
 * @export
 * @class MedicalReportPregnancyApi
 * @extends {BaseAPI}
 */
export class MedicalReportPregnancyApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOMedicalRecordMedicalReportPregnancyDto} [aPIXdentDTOMedicalRecordMedicalReportPregnancyDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportPregnancyApi
     */
    public apiMedicalReportPregnancyPregnancyCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyDto?: APIXdentDTOMedicalRecordMedicalReportPregnancyDto, options?: AxiosRequestConfig) {
        return MedicalReportPregnancyApiFp(this.configuration).apiMedicalReportPregnancyPregnancyCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto} [aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportPregnancyApi
     */
    public apiMedicalReportPregnancyPregnancyExamCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto?: APIXdentDTOMedicalRecordMedicalReportPregnancyExamDto, options?: AxiosRequestConfig) {
        return MedicalReportPregnancyApiFp(this.configuration).apiMedicalReportPregnancyPregnancyExamCreateUpdatePost(aPIXdentDTOMedicalRecordMedicalReportPregnancyExamDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportPregnancyApi
     */
    public apiMedicalReportPregnancyPregnancyExamGridByClientGet(idClient?: string, options?: AxiosRequestConfig) {
        return MedicalReportPregnancyApiFp(this.configuration).apiMedicalReportPregnancyPregnancyExamGridByClientGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportPregnancyApi
     */
    public apiMedicalReportPregnancyPregnancyExamGridByReportGet(idMedicalReport?: string, options?: AxiosRequestConfig) {
        return MedicalReportPregnancyApiFp(this.configuration).apiMedicalReportPregnancyPregnancyExamGridByReportGet(idMedicalReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idMedicalReportPregnancy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportPregnancyApi
     */
    public apiMedicalReportPregnancyPregnancyExamGridGet(idMedicalReportPregnancy?: string, options?: AxiosRequestConfig) {
        return MedicalReportPregnancyApiFp(this.configuration).apiMedicalReportPregnancyPregnancyExamGridGet(idMedicalReportPregnancy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalReportPregnancyApi
     */
    public apiMedicalReportPregnancyPregnancyGridGet(idClient?: string, options?: AxiosRequestConfig) {
        return MedicalReportPregnancyApiFp(this.configuration).apiMedicalReportPregnancyPregnancyGridGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MigrationApi - axios parameter creator
 * @export
 */
export const MigrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set appointment confirmation status from onlineBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationGenerateIdCompanyToUserRefreshTokensGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Migration/GenerateIdCompanyToUserRefreshTokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesMigrationPost: async (body?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safesignatures/migration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MigrationApi - functional programming interface
 * @export
 */
export const MigrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MigrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Set appointment confirmation status from onlineBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationGenerateIdCompanyToUserRefreshTokensGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationGenerateIdCompanyToUserRefreshTokensGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MigrationApi.apiMigrationGenerateIdCompanyToUserRefreshTokensGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesMigrationPost(body?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesMigrationPost(body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MigrationApi.apiSafesignaturesMigrationPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MigrationApi - factory interface
 * @export
 */
export const MigrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MigrationApiFp(configuration)
    return {
        /**
         * 
         * @summary Set appointment confirmation status from onlineBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationGenerateIdCompanyToUserRefreshTokensGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiMigrationGenerateIdCompanyToUserRefreshTokensGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesMigrationPost(body?: any, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiSafesignaturesMigrationPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MigrationApi - object-oriented interface
 * @export
 * @class MigrationApi
 * @extends {BaseAPI}
 */
export class MigrationApi extends BaseAPI {
    /**
     * 
     * @summary Set appointment confirmation status from onlineBooking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    public apiMigrationGenerateIdCompanyToUserRefreshTokensGet(options?: AxiosRequestConfig) {
        return MigrationApiFp(this.configuration).apiMigrationGenerateIdCompanyToUserRefreshTokensGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    public apiSafesignaturesMigrationPost(body?: any, options?: AxiosRequestConfig) {
        return MigrationApiFp(this.configuration).apiSafesignaturesMigrationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NCZIApi - axios parameter creator
 * @export
 */
export const NCZIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sends report to NCZI
         * @param {APIXdentDTONCZIReportSendReportApiDto} [aPIXdentDTONCZIReportSendReportApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNCZIReportSendReportPost: async (aPIXdentDTONCZIReportSendReportApiDto?: APIXdentDTONCZIReportSendReportApiDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/NCZIReport/SendReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTONCZIReportSendReportApiDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NCZIApi - functional programming interface
 * @export
 */
export const NCZIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NCZIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sends report to NCZI
         * @param {APIXdentDTONCZIReportSendReportApiDto} [aPIXdentDTONCZIReportSendReportApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNCZIReportSendReportPost(aPIXdentDTONCZIReportSendReportApiDto?: APIXdentDTONCZIReportSendReportApiDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTONCZIReportSendReportApiResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNCZIReportSendReportPost(aPIXdentDTONCZIReportSendReportApiDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['NCZIApi.apiNCZIReportSendReportPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * NCZIApi - factory interface
 * @export
 */
export const NCZIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NCZIApiFp(configuration)
    return {
        /**
         * 
         * @summary Sends report to NCZI
         * @param {APIXdentDTONCZIReportSendReportApiDto} [aPIXdentDTONCZIReportSendReportApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNCZIReportSendReportPost(aPIXdentDTONCZIReportSendReportApiDto?: APIXdentDTONCZIReportSendReportApiDto, options?: any): AxiosPromise<APIXdentDTONCZIReportSendReportApiResponseDto> {
            return localVarFp.apiNCZIReportSendReportPost(aPIXdentDTONCZIReportSendReportApiDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NCZIApi - object-oriented interface
 * @export
 * @class NCZIApi
 * @extends {BaseAPI}
 */
export class NCZIApi extends BaseAPI {
    /**
     * 
     * @summary Sends report to NCZI
     * @param {APIXdentDTONCZIReportSendReportApiDto} [aPIXdentDTONCZIReportSendReportApiDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NCZIApi
     */
    public apiNCZIReportSendReportPost(aPIXdentDTONCZIReportSendReportApiDto?: APIXdentDTONCZIReportSendReportApiDto, options?: AxiosRequestConfig) {
        return NCZIApiFp(this.configuration).apiNCZIReportSendReportPost(aPIXdentDTONCZIReportSendReportApiDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnlineBookingApi - axios parameter creator
 * @export
 */
export const OnlineBookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticate by credentials
         * @param {ApiOnlineBookingAuthOnlineBookingIklientPostRequest} [apiOnlineBookingAuthOnlineBookingIklientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingAuthOnlineBookingIklientPost: async (apiOnlineBookingAuthOnlineBookingIklientPostRequest?: ApiOnlineBookingAuthOnlineBookingIklientPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/AuthOnlineBookingIklient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiOnlineBookingAuthOnlineBookingIklientPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {APISharedCancelOnlineBookingAppointmentDto} [aPISharedCancelOnlineBookingAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingCancelAppointmentPost: async (aPISharedCancelOnlineBookingAppointmentDto?: APISharedCancelOnlineBookingAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/CancelAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedCancelOnlineBookingAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create iklient link partnership request for iKlient form filling.
         * @param {APIXdentDTOOnlineBookingBookingPartnershipRequestDto} [aPIXdentDTOOnlineBookingBookingPartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingCreatePartnershipRequestPost: async (aPIXdentDTOOnlineBookingBookingPartnershipRequestDto?: APIXdentDTOOnlineBookingBookingPartnershipRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/CreatePartnershipRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOOnlineBookingBookingPartnershipRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticate by credentials
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingExtendBearerTokenIklientPost: async (aPISharedExtendBearerDto?: APISharedExtendBearerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/ExtendBearerTokenIklient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedExtendBearerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [idService] 
         * @param {Array<string>} [idStaffs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetAvailableTimesAllGet: async (idService?: string, idStaffs?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/GetAvailableTimesAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idService !== undefined) {
                localVarQueryParameter['idService'] = idService;
            }

            if (idStaffs) {
                localVarQueryParameter['idStaffs'] = idStaffs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetAvailableTimesGet: async (idService?: string, idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/GetAvailableTimes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idService !== undefined) {
                localVarQueryParameter['idService'] = idService;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [idLocation] 
         * @param {Date} [date] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetAvailableTimesInMonthGet: async (idLocation?: string, date?: Date, idService?: string, idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/GetAvailableTimesInMonth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (idService !== undefined) {
                localVarQueryParameter['idService'] = idService;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return thumbnail or full sized image from gallery by id as desired type
         * @param {string} [idFile] IdFile of desired thumbnail
         * @param {string} [size] Pixel dimensions of desired thumb. If this is null or empty, returns full sized image.
         * @param {ApiOnlineBookingGetFileGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64
         * @param {boolean} [isIklientGallery] Select whether to call iklient or xdent gallery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetFileGet: async (idFile?: string, size?: string, imageAsType?: ApiOnlineBookingGetFileGetImageAsTypeEnum, isIklientGallery?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/GetFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (imageAsType !== undefined) {
                localVarQueryParameter['imageAsType'] = imageAsType;
            }

            if (isIklientGallery !== undefined) {
                localVarQueryParameter['isIklientGallery'] = isIklientGallery;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetOnlineBookingIklientInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/GetOnlineBookingIklientInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} [dateTime] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingIsAvailableTimeGet: async (dateTime?: Date, idService?: string, idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/IsAvailableTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dateTime !== undefined) {
                localVarQueryParameter['dateTime'] = (dateTime as any instanceof Date) ?
                    (dateTime as any).toISOString() :
                    dateTime;
            }

            if (idService !== undefined) {
                localVarQueryParameter['idService'] = idService;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [idLocation] 
         * @param {Date} [date] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingIsAvailableTimeInMonthGet: async (idLocation?: string, date?: Date, idService?: string, idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/IsAvailableTimeInMonth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (idService !== undefined) {
                localVarQueryParameter['idService'] = idService;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets online booking metadata for online booking by host url prefix associated with idCompany
         * @param {string} [idAppointment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingMetadataByAppointmentGet: async (idAppointment?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/MetadataByAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idAppointment !== undefined) {
                localVarQueryParameter['idAppointment'] = idAppointment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets online booking metadata for online booking by host url prefix associated with idCompany
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingMetadataByMiniWebsiteGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/MetadataByMiniWebsite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingMetadataByUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/MetadataByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [idCompany] 
         * @param {boolean} [newBooking] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingMetadataGet: async (idCompany?: string, newBooking?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/Metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idCompany !== undefined) {
                localVarQueryParameter['idCompany'] = idCompany;
            }

            if (newBooking !== undefined) {
                localVarQueryParameter['newBooking'] = newBooking;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiOnlineBookingSendUnknownClientPostRequest} [apiOnlineBookingSendUnknownClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingSendUnknownClientPost: async (apiOnlineBookingSendUnknownClientPostRequest?: ApiOnlineBookingSendUnknownClientPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/SendUnknownClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiOnlineBookingSendUnknownClientPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiOnlineBookingSendUnknownClientPostRequest} [apiOnlineBookingSendUnknownClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingSendUnknownClientV2Post: async (apiOnlineBookingSendUnknownClientPostRequest?: ApiOnlineBookingSendUnknownClientPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/SendUnknownClientV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiOnlineBookingSendUnknownClientPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {APISharedOnlineBookingSendByMiniWebsiteV3Dto} [aPISharedOnlineBookingSendByMiniWebsiteV3Dto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingSendUnknownClientV3Post: async (aPISharedOnlineBookingSendByMiniWebsiteV3Dto?: APISharedOnlineBookingSendByMiniWebsiteV3Dto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OnlineBooking/SendUnknownClientV3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedOnlineBookingSendByMiniWebsiteV3Dto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnlineBookingApi - functional programming interface
 * @export
 */
export const OnlineBookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnlineBookingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticate by credentials
         * @param {ApiOnlineBookingAuthOnlineBookingIklientPostRequest} [apiOnlineBookingAuthOnlineBookingIklientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingAuthOnlineBookingIklientPost(apiOnlineBookingAuthOnlineBookingIklientPostRequest?: ApiOnlineBookingAuthOnlineBookingIklientPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingAuthOnlineBookingIklientPost(apiOnlineBookingAuthOnlineBookingIklientPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingAuthOnlineBookingIklientPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {APISharedCancelOnlineBookingAppointmentDto} [aPISharedCancelOnlineBookingAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingCancelAppointmentPost(aPISharedCancelOnlineBookingAppointmentDto?: APISharedCancelOnlineBookingAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingCancelAppointmentPost(aPISharedCancelOnlineBookingAppointmentDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingCancelAppointmentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create iklient link partnership request for iKlient form filling.
         * @param {APIXdentDTOOnlineBookingBookingPartnershipRequestDto} [aPIXdentDTOOnlineBookingBookingPartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingCreatePartnershipRequestPost(aPIXdentDTOOnlineBookingBookingPartnershipRequestDto?: APIXdentDTOOnlineBookingBookingPartnershipRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingCreatePartnershipRequestPost(aPIXdentDTOOnlineBookingBookingPartnershipRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingCreatePartnershipRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticate by credentials
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingExtendBearerTokenIklientPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingExtendBearerTokenIklientPost(aPISharedExtendBearerDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingExtendBearerTokenIklientPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} [idService] 
         * @param {Array<string>} [idStaffs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingGetAvailableTimesAllGet(idService?: string, idStaffs?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingGetAvailableTimesAllGet(idService, idStaffs, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingGetAvailableTimesAllGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingGetAvailableTimesGet(idService?: string, idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingGetAvailableTimesGet(idService, idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingGetAvailableTimesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} [idLocation] 
         * @param {Date} [date] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingGetAvailableTimesInMonthGet(idLocation?: string, date?: Date, idService?: string, idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingGetAvailableTimesInMonthGet(idLocation, date, idService, idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingGetAvailableTimesInMonthGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return thumbnail or full sized image from gallery by id as desired type
         * @param {string} [idFile] IdFile of desired thumbnail
         * @param {string} [size] Pixel dimensions of desired thumb. If this is null or empty, returns full sized image.
         * @param {ApiOnlineBookingGetFileGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64
         * @param {boolean} [isIklientGallery] Select whether to call iklient or xdent gallery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingGetFileGet(idFile?: string, size?: string, imageAsType?: ApiOnlineBookingGetFileGetImageAsTypeEnum, isIklientGallery?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingGetFileGet(idFile, size, imageAsType, isIklientGallery, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingGetFileGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingGetOnlineBookingIklientInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingGetOnlineBookingIklientInfoGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingGetOnlineBookingIklientInfoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {Date} [dateTime] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingIsAvailableTimeGet(dateTime?: Date, idService?: string, idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingIsAvailableTimeGet(dateTime, idService, idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingIsAvailableTimeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} [idLocation] 
         * @param {Date} [date] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingIsAvailableTimeInMonthGet(idLocation?: string, date?: Date, idService?: string, idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingIsAvailableTimeInMonthGet(idLocation, date, idService, idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingIsAvailableTimeInMonthGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets online booking metadata for online booking by host url prefix associated with idCompany
         * @param {string} [idAppointment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingMetadataByAppointmentGet(idAppointment?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOOnlineBookingOnlineBookingMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingMetadataByAppointmentGet(idAppointment, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingMetadataByAppointmentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets online booking metadata for online booking by host url prefix associated with idCompany
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingMetadataByMiniWebsiteGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOOnlineBookingOnlineBookingMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingMetadataByMiniWebsiteGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingMetadataByMiniWebsiteGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingMetadataByUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOOnlineBookingOnlineBookingMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingMetadataByUserGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingMetadataByUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} [idCompany] 
         * @param {boolean} [newBooking] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingMetadataGet(idCompany?: string, newBooking?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOOnlineBookingOnlineBookingMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingMetadataGet(idCompany, newBooking, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingMetadataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {ApiOnlineBookingSendUnknownClientPostRequest} [apiOnlineBookingSendUnknownClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingSendUnknownClientPost(apiOnlineBookingSendUnknownClientPostRequest?: ApiOnlineBookingSendUnknownClientPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingSendUnknownClientPost(apiOnlineBookingSendUnknownClientPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingSendUnknownClientPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {ApiOnlineBookingSendUnknownClientPostRequest} [apiOnlineBookingSendUnknownClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingSendUnknownClientV2Post(apiOnlineBookingSendUnknownClientPostRequest?: ApiOnlineBookingSendUnknownClientPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedOnlineBookingResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingSendUnknownClientV2Post(apiOnlineBookingSendUnknownClientPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingSendUnknownClientV2Post']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {APISharedOnlineBookingSendByMiniWebsiteV3Dto} [aPISharedOnlineBookingSendByMiniWebsiteV3Dto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnlineBookingSendUnknownClientV3Post(aPISharedOnlineBookingSendByMiniWebsiteV3Dto?: APISharedOnlineBookingSendByMiniWebsiteV3Dto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedOnlineBookingResultV3Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnlineBookingSendUnknownClientV3Post(aPISharedOnlineBookingSendByMiniWebsiteV3Dto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OnlineBookingApi.apiOnlineBookingSendUnknownClientV3Post']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * OnlineBookingApi - factory interface
 * @export
 */
export const OnlineBookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnlineBookingApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticate by credentials
         * @param {ApiOnlineBookingAuthOnlineBookingIklientPostRequest} [apiOnlineBookingAuthOnlineBookingIklientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingAuthOnlineBookingIklientPost(apiOnlineBookingAuthOnlineBookingIklientPostRequest?: ApiOnlineBookingAuthOnlineBookingIklientPostRequest, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiOnlineBookingAuthOnlineBookingIklientPost(apiOnlineBookingAuthOnlineBookingIklientPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {APISharedCancelOnlineBookingAppointmentDto} [aPISharedCancelOnlineBookingAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingCancelAppointmentPost(aPISharedCancelOnlineBookingAppointmentDto?: APISharedCancelOnlineBookingAppointmentDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiOnlineBookingCancelAppointmentPost(aPISharedCancelOnlineBookingAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create iklient link partnership request for iKlient form filling.
         * @param {APIXdentDTOOnlineBookingBookingPartnershipRequestDto} [aPIXdentDTOOnlineBookingBookingPartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingCreatePartnershipRequestPost(aPIXdentDTOOnlineBookingBookingPartnershipRequestDto?: APIXdentDTOOnlineBookingBookingPartnershipRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiOnlineBookingCreatePartnershipRequestPost(aPIXdentDTOOnlineBookingBookingPartnershipRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticate by credentials
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingExtendBearerTokenIklientPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiOnlineBookingExtendBearerTokenIklientPost(aPISharedExtendBearerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [idService] 
         * @param {Array<string>} [idStaffs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetAvailableTimesAllGet(idService?: string, idStaffs?: Array<string>, options?: any): AxiosPromise<Array<APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem>> {
            return localVarFp.apiOnlineBookingGetAvailableTimesAllGet(idService, idStaffs, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetAvailableTimesGet(idService?: string, idStaff?: string, options?: any): AxiosPromise<Array<APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem>> {
            return localVarFp.apiOnlineBookingGetAvailableTimesGet(idService, idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [idLocation] 
         * @param {Date} [date] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetAvailableTimesInMonthGet(idLocation?: string, date?: Date, idService?: string, idStaff?: string, options?: any): AxiosPromise<Array<APISharedModelsOnlineBookingOnlineBookingDtoOpenDayItem>> {
            return localVarFp.apiOnlineBookingGetAvailableTimesInMonthGet(idLocation, date, idService, idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return thumbnail or full sized image from gallery by id as desired type
         * @param {string} [idFile] IdFile of desired thumbnail
         * @param {string} [size] Pixel dimensions of desired thumb. If this is null or empty, returns full sized image.
         * @param {ApiOnlineBookingGetFileGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64
         * @param {boolean} [isIklientGallery] Select whether to call iklient or xdent gallery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetFileGet(idFile?: string, size?: string, imageAsType?: ApiOnlineBookingGetFileGetImageAsTypeEnum, isIklientGallery?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiOnlineBookingGetFileGet(idFile, size, imageAsType, isIklientGallery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingGetOnlineBookingIklientInfoGet(options?: any): AxiosPromise<APIXdentDTOOnlineBookingOnlineBookingIklientInfoDto> {
            return localVarFp.apiOnlineBookingGetOnlineBookingIklientInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} [dateTime] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingIsAvailableTimeGet(dateTime?: Date, idService?: string, idStaff?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiOnlineBookingIsAvailableTimeGet(dateTime, idService, idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [idLocation] 
         * @param {Date} [date] 
         * @param {string} [idService] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingIsAvailableTimeInMonthGet(idLocation?: string, date?: Date, idService?: string, idStaff?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiOnlineBookingIsAvailableTimeInMonthGet(idLocation, date, idService, idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets online booking metadata for online booking by host url prefix associated with idCompany
         * @param {string} [idAppointment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingMetadataByAppointmentGet(idAppointment?: string, options?: any): AxiosPromise<APISharedDTOOnlineBookingOnlineBookingMetadataDto> {
            return localVarFp.apiOnlineBookingMetadataByAppointmentGet(idAppointment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets online booking metadata for online booking by host url prefix associated with idCompany
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingMetadataByMiniWebsiteGet(options?: any): AxiosPromise<APISharedDTOOnlineBookingOnlineBookingMetadataDto> {
            return localVarFp.apiOnlineBookingMetadataByMiniWebsiteGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingMetadataByUserGet(options?: any): AxiosPromise<APISharedDTOOnlineBookingOnlineBookingMetadataDto> {
            return localVarFp.apiOnlineBookingMetadataByUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [idCompany] 
         * @param {boolean} [newBooking] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingMetadataGet(idCompany?: string, newBooking?: boolean, options?: any): AxiosPromise<APISharedDTOOnlineBookingOnlineBookingMetadataDto> {
            return localVarFp.apiOnlineBookingMetadataGet(idCompany, newBooking, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiOnlineBookingSendUnknownClientPostRequest} [apiOnlineBookingSendUnknownClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingSendUnknownClientPost(apiOnlineBookingSendUnknownClientPostRequest?: ApiOnlineBookingSendUnknownClientPostRequest, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiOnlineBookingSendUnknownClientPost(apiOnlineBookingSendUnknownClientPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiOnlineBookingSendUnknownClientPostRequest} [apiOnlineBookingSendUnknownClientPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingSendUnknownClientV2Post(apiOnlineBookingSendUnknownClientPostRequest?: ApiOnlineBookingSendUnknownClientPostRequest, options?: any): AxiosPromise<APISharedOnlineBookingResultDto> {
            return localVarFp.apiOnlineBookingSendUnknownClientV2Post(apiOnlineBookingSendUnknownClientPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {APISharedOnlineBookingSendByMiniWebsiteV3Dto} [aPISharedOnlineBookingSendByMiniWebsiteV3Dto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnlineBookingSendUnknownClientV3Post(aPISharedOnlineBookingSendByMiniWebsiteV3Dto?: APISharedOnlineBookingSendByMiniWebsiteV3Dto, options?: any): AxiosPromise<APISharedOnlineBookingResultV3Dto> {
            return localVarFp.apiOnlineBookingSendUnknownClientV3Post(aPISharedOnlineBookingSendByMiniWebsiteV3Dto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnlineBookingApi - object-oriented interface
 * @export
 * @class OnlineBookingApi
 * @extends {BaseAPI}
 */
export class OnlineBookingApi extends BaseAPI {
    /**
     * 
     * @summary Authenticate by credentials
     * @param {ApiOnlineBookingAuthOnlineBookingIklientPostRequest} [apiOnlineBookingAuthOnlineBookingIklientPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingAuthOnlineBookingIklientPost(apiOnlineBookingAuthOnlineBookingIklientPostRequest?: ApiOnlineBookingAuthOnlineBookingIklientPostRequest, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingAuthOnlineBookingIklientPost(apiOnlineBookingAuthOnlineBookingIklientPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {APISharedCancelOnlineBookingAppointmentDto} [aPISharedCancelOnlineBookingAppointmentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingCancelAppointmentPost(aPISharedCancelOnlineBookingAppointmentDto?: APISharedCancelOnlineBookingAppointmentDto, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingCancelAppointmentPost(aPISharedCancelOnlineBookingAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create iklient link partnership request for iKlient form filling.
     * @param {APIXdentDTOOnlineBookingBookingPartnershipRequestDto} [aPIXdentDTOOnlineBookingBookingPartnershipRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingCreatePartnershipRequestPost(aPIXdentDTOOnlineBookingBookingPartnershipRequestDto?: APIXdentDTOOnlineBookingBookingPartnershipRequestDto, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingCreatePartnershipRequestPost(aPIXdentDTOOnlineBookingBookingPartnershipRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticate by credentials
     * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingExtendBearerTokenIklientPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingExtendBearerTokenIklientPost(aPISharedExtendBearerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [idService] 
     * @param {Array<string>} [idStaffs] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingGetAvailableTimesAllGet(idService?: string, idStaffs?: Array<string>, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingGetAvailableTimesAllGet(idService, idStaffs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [idService] 
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingGetAvailableTimesGet(idService?: string, idStaff?: string, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingGetAvailableTimesGet(idService, idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [idLocation] 
     * @param {Date} [date] 
     * @param {string} [idService] 
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingGetAvailableTimesInMonthGet(idLocation?: string, date?: Date, idService?: string, idStaff?: string, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingGetAvailableTimesInMonthGet(idLocation, date, idService, idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return thumbnail or full sized image from gallery by id as desired type
     * @param {string} [idFile] IdFile of desired thumbnail
     * @param {string} [size] Pixel dimensions of desired thumb. If this is null or empty, returns full sized image.
     * @param {ApiOnlineBookingGetFileGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64
     * @param {boolean} [isIklientGallery] Select whether to call iklient or xdent gallery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingGetFileGet(idFile?: string, size?: string, imageAsType?: ApiOnlineBookingGetFileGetImageAsTypeEnum, isIklientGallery?: boolean, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingGetFileGet(idFile, size, imageAsType, isIklientGallery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingGetOnlineBookingIklientInfoGet(options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingGetOnlineBookingIklientInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Date} [dateTime] 
     * @param {string} [idService] 
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingIsAvailableTimeGet(dateTime?: Date, idService?: string, idStaff?: string, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingIsAvailableTimeGet(dateTime, idService, idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [idLocation] 
     * @param {Date} [date] 
     * @param {string} [idService] 
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingIsAvailableTimeInMonthGet(idLocation?: string, date?: Date, idService?: string, idStaff?: string, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingIsAvailableTimeInMonthGet(idLocation, date, idService, idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets online booking metadata for online booking by host url prefix associated with idCompany
     * @param {string} [idAppointment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingMetadataByAppointmentGet(idAppointment?: string, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingMetadataByAppointmentGet(idAppointment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets online booking metadata for online booking by host url prefix associated with idCompany
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingMetadataByMiniWebsiteGet(options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingMetadataByMiniWebsiteGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingMetadataByUserGet(options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingMetadataByUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [idCompany] 
     * @param {boolean} [newBooking] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingMetadataGet(idCompany?: string, newBooking?: boolean, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingMetadataGet(idCompany, newBooking, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiOnlineBookingSendUnknownClientPostRequest} [apiOnlineBookingSendUnknownClientPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingSendUnknownClientPost(apiOnlineBookingSendUnknownClientPostRequest?: ApiOnlineBookingSendUnknownClientPostRequest, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingSendUnknownClientPost(apiOnlineBookingSendUnknownClientPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiOnlineBookingSendUnknownClientPostRequest} [apiOnlineBookingSendUnknownClientPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingSendUnknownClientV2Post(apiOnlineBookingSendUnknownClientPostRequest?: ApiOnlineBookingSendUnknownClientPostRequest, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingSendUnknownClientV2Post(apiOnlineBookingSendUnknownClientPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {APISharedOnlineBookingSendByMiniWebsiteV3Dto} [aPISharedOnlineBookingSendByMiniWebsiteV3Dto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineBookingApi
     */
    public apiOnlineBookingSendUnknownClientV3Post(aPISharedOnlineBookingSendByMiniWebsiteV3Dto?: APISharedOnlineBookingSendByMiniWebsiteV3Dto, options?: AxiosRequestConfig) {
        return OnlineBookingApiFp(this.configuration).apiOnlineBookingSendUnknownClientV3Post(aPISharedOnlineBookingSendByMiniWebsiteV3Dto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiOnlineBookingGetFileGetImageAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiOnlineBookingGetFileGetImageAsTypeEnum = typeof ApiOnlineBookingGetFileGetImageAsTypeEnum[keyof typeof ApiOnlineBookingGetFileGetImageAsTypeEnum];


/**
 * PartnershipRequestApi - axios parameter creator
 * @export
 */
export const PartnershipRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create partnership request
         * @param {APISharedCreatePartnershipRequestDto} [aPISharedCreatePartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPartnershipRequestCreatePartnershipRequestPost: async (aPISharedCreatePartnershipRequestDto?: APISharedCreatePartnershipRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PartnershipRequest/CreatePartnershipRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedCreatePartnershipRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create partnership password reset request
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPartnershipRequestCreatePasswordResetRequestGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PartnershipRequest/CreatePasswordResetRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create partnership request
         * @param {APISharedCreatePartnershipRequestDto} [aPISharedCreatePartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentPartnershipRequestCreatePartnershipRequestPost: async (aPISharedCreatePartnershipRequestDto?: APISharedCreatePartnershipRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentPartnershipRequest/CreatePartnershipRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedCreatePartnershipRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create partnership password reset request
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentPartnershipRequestCreatePasswordResetRequestGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentPartnershipRequest/CreatePasswordResetRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates registration request to iklient for xdent client
         * @param {APISharedSendClientRegistrationRequestDto} [aPISharedSendClientRegistrationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentPartnershipRequestSendClientRegistrationRequestPost: async (aPISharedSendClientRegistrationRequestDto?: APISharedSendClientRegistrationRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentPartnershipRequest/SendClientRegistrationRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedSendClientRegistrationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnershipRequestApi - functional programming interface
 * @export
 */
export const PartnershipRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnershipRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create partnership request
         * @param {APISharedCreatePartnershipRequestDto} [aPISharedCreatePartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto?: APISharedCreatePartnershipRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedPartnershipRequestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PartnershipRequestApi.apiPartnershipRequestCreatePartnershipRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create partnership password reset request
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPartnershipRequestCreatePasswordResetRequestGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPartnershipRequestCreatePasswordResetRequestGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PartnershipRequestApi.apiPartnershipRequestCreatePasswordResetRequestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create partnership request
         * @param {APISharedCreatePartnershipRequestDto} [aPISharedCreatePartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto?: APISharedCreatePartnershipRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedPartnershipRequestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PartnershipRequestApi.apiXdentPartnershipRequestCreatePartnershipRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create partnership password reset request
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentPartnershipRequestCreatePasswordResetRequestGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentPartnershipRequestCreatePasswordResetRequestGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PartnershipRequestApi.apiXdentPartnershipRequestCreatePasswordResetRequestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates registration request to iklient for xdent client
         * @param {APISharedSendClientRegistrationRequestDto} [aPISharedSendClientRegistrationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentPartnershipRequestSendClientRegistrationRequestPost(aPISharedSendClientRegistrationRequestDto?: APISharedSendClientRegistrationRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedRegistrationRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentPartnershipRequestSendClientRegistrationRequestPost(aPISharedSendClientRegistrationRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PartnershipRequestApi.apiXdentPartnershipRequestSendClientRegistrationRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PartnershipRequestApi - factory interface
 * @export
 */
export const PartnershipRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnershipRequestApiFp(configuration)
    return {
        /**
         * 
         * @summary Create partnership request
         * @param {APISharedCreatePartnershipRequestDto} [aPISharedCreatePartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto?: APISharedCreatePartnershipRequestDto, options?: any): AxiosPromise<APISharedPartnershipRequestResult> {
            return localVarFp.apiPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create partnership password reset request
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPartnershipRequestCreatePasswordResetRequestGet(idClient?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiPartnershipRequestCreatePasswordResetRequestGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create partnership request
         * @param {APISharedCreatePartnershipRequestDto} [aPISharedCreatePartnershipRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto?: APISharedCreatePartnershipRequestDto, options?: any): AxiosPromise<APISharedPartnershipRequestResult> {
            return localVarFp.apiXdentPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create partnership password reset request
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentPartnershipRequestCreatePasswordResetRequestGet(idClient?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiXdentPartnershipRequestCreatePasswordResetRequestGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates registration request to iklient for xdent client
         * @param {APISharedSendClientRegistrationRequestDto} [aPISharedSendClientRegistrationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentPartnershipRequestSendClientRegistrationRequestPost(aPISharedSendClientRegistrationRequestDto?: APISharedSendClientRegistrationRequestDto, options?: any): AxiosPromise<APISharedRegistrationRequestResponseDto> {
            return localVarFp.apiXdentPartnershipRequestSendClientRegistrationRequestPost(aPISharedSendClientRegistrationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnershipRequestApi - object-oriented interface
 * @export
 * @class PartnershipRequestApi
 * @extends {BaseAPI}
 */
export class PartnershipRequestApi extends BaseAPI {
    /**
     * 
     * @summary Create partnership request
     * @param {APISharedCreatePartnershipRequestDto} [aPISharedCreatePartnershipRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnershipRequestApi
     */
    public apiPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto?: APISharedCreatePartnershipRequestDto, options?: AxiosRequestConfig) {
        return PartnershipRequestApiFp(this.configuration).apiPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create partnership password reset request
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnershipRequestApi
     */
    public apiPartnershipRequestCreatePasswordResetRequestGet(idClient?: string, options?: AxiosRequestConfig) {
        return PartnershipRequestApiFp(this.configuration).apiPartnershipRequestCreatePasswordResetRequestGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create partnership request
     * @param {APISharedCreatePartnershipRequestDto} [aPISharedCreatePartnershipRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnershipRequestApi
     */
    public apiXdentPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto?: APISharedCreatePartnershipRequestDto, options?: AxiosRequestConfig) {
        return PartnershipRequestApiFp(this.configuration).apiXdentPartnershipRequestCreatePartnershipRequestPost(aPISharedCreatePartnershipRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create partnership password reset request
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnershipRequestApi
     */
    public apiXdentPartnershipRequestCreatePasswordResetRequestGet(idClient?: string, options?: AxiosRequestConfig) {
        return PartnershipRequestApiFp(this.configuration).apiXdentPartnershipRequestCreatePasswordResetRequestGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates registration request to iklient for xdent client
     * @param {APISharedSendClientRegistrationRequestDto} [aPISharedSendClientRegistrationRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnershipRequestApi
     */
    public apiXdentPartnershipRequestSendClientRegistrationRequestPost(aPISharedSendClientRegistrationRequestDto?: APISharedSendClientRegistrationRequestDto, options?: AxiosRequestConfig) {
        return PartnershipRequestApiFp(this.configuration).apiXdentPartnershipRequestSendClientRegistrationRequestPost(aPISharedSendClientRegistrationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentGatewayApi - axios parameter creator
 * @export
 */
export const PaymentGatewayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary For testing if communication is OKAY.
         * @param {string} [idCompany] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayEchoGet: async (idCompany?: string, idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PaymentGateway/Echo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idCompany !== undefined) {
                localVarQueryParameter['idCompany'] = idCompany;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary For testing if communication is OKAY.
         * @param {APIXdentDTOPaymentGatewayEchoApiDto} [aPIXdentDTOPaymentGatewayEchoApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayEchoPost: async (aPIXdentDTOPaymentGatewayEchoApiDto?: APIXdentDTOPaymentGatewayEchoApiDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PaymentGateway/Echo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOPaymentGatewayEchoApiDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Main endpoint -> returns URL to redirect FE to.
         * @param {APIXdentDTOPaymentGatewayPaymentInitApiDto} [aPIXdentDTOPaymentGatewayPaymentInitApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayPaymentInitPost: async (aPIXdentDTOPaymentGatewayPaymentInitApiDto?: APIXdentDTOPaymentGatewayPaymentInitApiDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PaymentGateway/PaymentInit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOPaymentGatewayPaymentInitApiDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the status of the payment.
         * @param {string} [idAppointment] 
         * @param {string} [payId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayPaymentStatusGet: async (idAppointment?: string, payId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PaymentGateway/PaymentStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idAppointment !== undefined) {
                localVarQueryParameter['idAppointment'] = idAppointment;
            }

            if (payId !== undefined) {
                localVarQueryParameter['payId'] = payId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary For sending emails again using list of \"idPaymentGatewayRequest\"
         * @param {APIXdentDTOPaymentGatewaySendConfirmationEmailDto} [aPIXdentDTOPaymentGatewaySendConfirmationEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewaySendConfirmationEmailPost: async (aPIXdentDTOPaymentGatewaySendConfirmationEmailDto?: APIXdentDTOPaymentGatewaySendConfirmationEmailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PaymentGateway/SendConfirmationEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOPaymentGatewaySendConfirmationEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Just for my internal testing. Throws error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayTestGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PaymentGateway/Test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentGatewayApi - functional programming interface
 * @export
 */
export const PaymentGatewayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentGatewayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary For testing if communication is OKAY.
         * @param {string} [idCompany] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentGatewayEchoGet(idCompany?: string, idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOPaymentGatewayEchoApiResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentGatewayEchoGet(idCompany, idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentGatewayApi.apiPaymentGatewayEchoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary For testing if communication is OKAY.
         * @param {APIXdentDTOPaymentGatewayEchoApiDto} [aPIXdentDTOPaymentGatewayEchoApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentGatewayEchoPost(aPIXdentDTOPaymentGatewayEchoApiDto?: APIXdentDTOPaymentGatewayEchoApiDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOPaymentGatewayEchoApiResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentGatewayEchoPost(aPIXdentDTOPaymentGatewayEchoApiDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentGatewayApi.apiPaymentGatewayEchoPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Main endpoint -> returns URL to redirect FE to.
         * @param {APIXdentDTOPaymentGatewayPaymentInitApiDto} [aPIXdentDTOPaymentGatewayPaymentInitApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentGatewayPaymentInitPost(aPIXdentDTOPaymentGatewayPaymentInitApiDto?: APIXdentDTOPaymentGatewayPaymentInitApiDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOPaymentGatewayPaymentInitApiResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentGatewayPaymentInitPost(aPIXdentDTOPaymentGatewayPaymentInitApiDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentGatewayApi.apiPaymentGatewayPaymentInitPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the status of the payment.
         * @param {string} [idAppointment] 
         * @param {string} [payId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentGatewayPaymentStatusGet(idAppointment?: string, payId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentGatewayPaymentStatusGet(idAppointment, payId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentGatewayApi.apiPaymentGatewayPaymentStatusGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary For sending emails again using list of \"idPaymentGatewayRequest\"
         * @param {APIXdentDTOPaymentGatewaySendConfirmationEmailDto} [aPIXdentDTOPaymentGatewaySendConfirmationEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentGatewaySendConfirmationEmailPost(aPIXdentDTOPaymentGatewaySendConfirmationEmailDto?: APIXdentDTOPaymentGatewaySendConfirmationEmailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentGatewaySendConfirmationEmailPost(aPIXdentDTOPaymentGatewaySendConfirmationEmailDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentGatewayApi.apiPaymentGatewaySendConfirmationEmailPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Just for my internal testing. Throws error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentGatewayTestGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentGatewayTestGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentGatewayApi.apiPaymentGatewayTestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PaymentGatewayApi - factory interface
 * @export
 */
export const PaymentGatewayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentGatewayApiFp(configuration)
    return {
        /**
         * 
         * @summary For testing if communication is OKAY.
         * @param {string} [idCompany] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayEchoGet(idCompany?: string, idLocation?: string, options?: any): AxiosPromise<APIXdentDTOPaymentGatewayEchoApiResponseDto> {
            return localVarFp.apiPaymentGatewayEchoGet(idCompany, idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary For testing if communication is OKAY.
         * @param {APIXdentDTOPaymentGatewayEchoApiDto} [aPIXdentDTOPaymentGatewayEchoApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayEchoPost(aPIXdentDTOPaymentGatewayEchoApiDto?: APIXdentDTOPaymentGatewayEchoApiDto, options?: any): AxiosPromise<APIXdentDTOPaymentGatewayEchoApiResponseDto> {
            return localVarFp.apiPaymentGatewayEchoPost(aPIXdentDTOPaymentGatewayEchoApiDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Main endpoint -> returns URL to redirect FE to.
         * @param {APIXdentDTOPaymentGatewayPaymentInitApiDto} [aPIXdentDTOPaymentGatewayPaymentInitApiDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayPaymentInitPost(aPIXdentDTOPaymentGatewayPaymentInitApiDto?: APIXdentDTOPaymentGatewayPaymentInitApiDto, options?: any): AxiosPromise<APIXdentDTOPaymentGatewayPaymentInitApiResponseDto> {
            return localVarFp.apiPaymentGatewayPaymentInitPost(aPIXdentDTOPaymentGatewayPaymentInitApiDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the status of the payment.
         * @param {string} [idAppointment] 
         * @param {string} [payId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayPaymentStatusGet(idAppointment?: string, payId?: string, options?: any): AxiosPromise<APIXdentDTOPaymentGatewayPaymentStatusApiResponseDto> {
            return localVarFp.apiPaymentGatewayPaymentStatusGet(idAppointment, payId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary For sending emails again using list of \"idPaymentGatewayRequest\"
         * @param {APIXdentDTOPaymentGatewaySendConfirmationEmailDto} [aPIXdentDTOPaymentGatewaySendConfirmationEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewaySendConfirmationEmailPost(aPIXdentDTOPaymentGatewaySendConfirmationEmailDto?: APIXdentDTOPaymentGatewaySendConfirmationEmailDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiPaymentGatewaySendConfirmationEmailPost(aPIXdentDTOPaymentGatewaySendConfirmationEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Just for my internal testing. Throws error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentGatewayTestGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiPaymentGatewayTestGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentGatewayApi - object-oriented interface
 * @export
 * @class PaymentGatewayApi
 * @extends {BaseAPI}
 */
export class PaymentGatewayApi extends BaseAPI {
    /**
     * 
     * @summary For testing if communication is OKAY.
     * @param {string} [idCompany] 
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentGatewayApi
     */
    public apiPaymentGatewayEchoGet(idCompany?: string, idLocation?: string, options?: AxiosRequestConfig) {
        return PaymentGatewayApiFp(this.configuration).apiPaymentGatewayEchoGet(idCompany, idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary For testing if communication is OKAY.
     * @param {APIXdentDTOPaymentGatewayEchoApiDto} [aPIXdentDTOPaymentGatewayEchoApiDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentGatewayApi
     */
    public apiPaymentGatewayEchoPost(aPIXdentDTOPaymentGatewayEchoApiDto?: APIXdentDTOPaymentGatewayEchoApiDto, options?: AxiosRequestConfig) {
        return PaymentGatewayApiFp(this.configuration).apiPaymentGatewayEchoPost(aPIXdentDTOPaymentGatewayEchoApiDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Main endpoint -> returns URL to redirect FE to.
     * @param {APIXdentDTOPaymentGatewayPaymentInitApiDto} [aPIXdentDTOPaymentGatewayPaymentInitApiDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentGatewayApi
     */
    public apiPaymentGatewayPaymentInitPost(aPIXdentDTOPaymentGatewayPaymentInitApiDto?: APIXdentDTOPaymentGatewayPaymentInitApiDto, options?: AxiosRequestConfig) {
        return PaymentGatewayApiFp(this.configuration).apiPaymentGatewayPaymentInitPost(aPIXdentDTOPaymentGatewayPaymentInitApiDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the status of the payment.
     * @param {string} [idAppointment] 
     * @param {string} [payId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentGatewayApi
     */
    public apiPaymentGatewayPaymentStatusGet(idAppointment?: string, payId?: string, options?: AxiosRequestConfig) {
        return PaymentGatewayApiFp(this.configuration).apiPaymentGatewayPaymentStatusGet(idAppointment, payId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary For sending emails again using list of \"idPaymentGatewayRequest\"
     * @param {APIXdentDTOPaymentGatewaySendConfirmationEmailDto} [aPIXdentDTOPaymentGatewaySendConfirmationEmailDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentGatewayApi
     */
    public apiPaymentGatewaySendConfirmationEmailPost(aPIXdentDTOPaymentGatewaySendConfirmationEmailDto?: APIXdentDTOPaymentGatewaySendConfirmationEmailDto, options?: AxiosRequestConfig) {
        return PaymentGatewayApiFp(this.configuration).apiPaymentGatewaySendConfirmationEmailPost(aPIXdentDTOPaymentGatewaySendConfirmationEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Just for my internal testing. Throws error.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentGatewayApi
     */
    public apiPaymentGatewayTestGet(options?: AxiosRequestConfig) {
        return PaymentGatewayApiFp(this.configuration).apiPaymentGatewayTestGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentImportApi - axios parameter creator
 * @export
 */
export const PaymentImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {string} [importType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentImportPost: async (file?: File, importType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/payment/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (importType !== undefined) { 
                localVarFormParams.append('importType', importType as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Array<APIXdentDTOPaymentImportPaymentImportRow>} [aPIXdentDTOPaymentImportPaymentImportRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentImportSavePost: async (aPIXdentDTOPaymentImportPaymentImportRow?: Array<APIXdentDTOPaymentImportPaymentImportRow>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/payment/import/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOPaymentImportPaymentImportRow, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentImportApi - functional programming interface
 * @export
 */
export const PaymentImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentImportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {string} [importType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentImportPost(file?: File, importType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentImportPost(file, importType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentImportApi.apiPaymentImportPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Array<APIXdentDTOPaymentImportPaymentImportRow>} [aPIXdentDTOPaymentImportPaymentImportRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentImportSavePost(aPIXdentDTOPaymentImportPaymentImportRow?: Array<APIXdentDTOPaymentImportPaymentImportRow>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentImportSavePost(aPIXdentDTOPaymentImportPaymentImportRow, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentImportApi.apiPaymentImportSavePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PaymentImportApi - factory interface
 * @export
 */
export const PaymentImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentImportApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {string} [importType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentImportPost(file?: File, importType?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiPaymentImportPost(file, importType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Array<APIXdentDTOPaymentImportPaymentImportRow>} [aPIXdentDTOPaymentImportPaymentImportRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentImportSavePost(aPIXdentDTOPaymentImportPaymentImportRow?: Array<APIXdentDTOPaymentImportPaymentImportRow>, options?: any): AxiosPromise<void> {
            return localVarFp.apiPaymentImportSavePost(aPIXdentDTOPaymentImportPaymentImportRow, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentImportApi - object-oriented interface
 * @export
 * @class PaymentImportApi
 * @extends {BaseAPI}
 */
export class PaymentImportApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {File} [file] 
     * @param {string} [importType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentImportApi
     */
    public apiPaymentImportPost(file?: File, importType?: string, options?: AxiosRequestConfig) {
        return PaymentImportApiFp(this.configuration).apiPaymentImportPost(file, importType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {Array<APIXdentDTOPaymentImportPaymentImportRow>} [aPIXdentDTOPaymentImportPaymentImportRow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentImportApi
     */
    public apiPaymentImportSavePost(aPIXdentDTOPaymentImportPaymentImportRow?: Array<APIXdentDTOPaymentImportPaymentImportRow>, options?: AxiosRequestConfig) {
        return PaymentImportApiFp(this.configuration).apiPaymentImportSavePost(aPIXdentDTOPaymentImportPaymentImportRow, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PersonalNumberApi - axios parameter creator
 * @export
 */
export const PersonalNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Analyzes personal number for dateOfBirth, gender and other properties.
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalNumberAnalyzeGet: async (personalNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PersonalNumber/Analyze`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (personalNumber !== undefined) {
                localVarQueryParameter['personalNumber'] = personalNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checks if the personal number is valid. (rodne cislo)
         * @param {string} deviceToken 
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesPersonalNumberValidateGet: async (deviceToken: string, personalNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesPersonalNumberValidateGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/personalNumber/Validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (personalNumber !== undefined) {
                localVarQueryParameter['personalNumber'] = personalNumber;
            }

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonalNumberApi - functional programming interface
 * @export
 */
export const PersonalNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonalNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Analyzes personal number for dateOfBirth, gender and other properties.
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalNumberAnalyzeGet(personalNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOValidationPersonalNumberAnalyzeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalNumberAnalyzeGet(personalNumber, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PersonalNumberApi.apiPersonalNumberAnalyzeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Checks if the personal number is valid. (rodne cislo)
         * @param {string} deviceToken 
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesPersonalNumberValidateGet(deviceToken: string, personalNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOValidationPersonalNumberAnalyzeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesPersonalNumberValidateGet(deviceToken, personalNumber, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PersonalNumberApi.apiSafesignaturesPersonalNumberValidateGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PersonalNumberApi - factory interface
 * @export
 */
export const PersonalNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonalNumberApiFp(configuration)
    return {
        /**
         * 
         * @summary Analyzes personal number for dateOfBirth, gender and other properties.
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalNumberAnalyzeGet(personalNumber?: string, options?: any): AxiosPromise<APISharedDTOValidationPersonalNumberAnalyzeDto> {
            return localVarFp.apiPersonalNumberAnalyzeGet(personalNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checks if the personal number is valid. (rodne cislo)
         * @param {string} deviceToken 
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesPersonalNumberValidateGet(deviceToken: string, personalNumber?: string, options?: any): AxiosPromise<APISharedDTOValidationPersonalNumberAnalyzeDto> {
            return localVarFp.apiSafesignaturesPersonalNumberValidateGet(deviceToken, personalNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonalNumberApi - object-oriented interface
 * @export
 * @class PersonalNumberApi
 * @extends {BaseAPI}
 */
export class PersonalNumberApi extends BaseAPI {
    /**
     * 
     * @summary Analyzes personal number for dateOfBirth, gender and other properties.
     * @param {string} [personalNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalNumberApi
     */
    public apiPersonalNumberAnalyzeGet(personalNumber?: string, options?: AxiosRequestConfig) {
        return PersonalNumberApiFp(this.configuration).apiPersonalNumberAnalyzeGet(personalNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checks if the personal number is valid. (rodne cislo)
     * @param {string} deviceToken 
     * @param {string} [personalNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalNumberApi
     */
    public apiSafesignaturesPersonalNumberValidateGet(deviceToken: string, personalNumber?: string, options?: AxiosRequestConfig) {
        return PersonalNumberApiFp(this.configuration).apiSafesignaturesPersonalNumberValidateGet(deviceToken, personalNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PhrasesApi - axios parameter creator
 * @export
 */
export const PhrasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all roles for logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhrasesGetUserPhrasesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Phrases/GetUserPhrases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhrasesApi - functional programming interface
 * @export
 */
export const PhrasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhrasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all roles for logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhrasesGetUserPhrasesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhrasesGetUserPhrasesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PhrasesApi.apiPhrasesGetUserPhrasesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PhrasesApi - factory interface
 * @export
 */
export const PhrasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhrasesApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all roles for logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhrasesGetUserPhrasesGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedMEDICALREPORTPHRASEGRIDNEWResult>> {
            return localVarFp.apiPhrasesGetUserPhrasesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhrasesApi - object-oriented interface
 * @export
 * @class PhrasesApi
 * @extends {BaseAPI}
 */
export class PhrasesApi extends BaseAPI {
    /**
     * 
     * @summary Gets all roles for logged user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhrasesApi
     */
    public apiPhrasesGetUserPhrasesGet(options?: AxiosRequestConfig) {
        return PhrasesApiFp(this.configuration).apiPhrasesGetUserPhrasesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PremiumApi - axios parameter creator
 * @export
 */
export const PremiumApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets premium services for logged user by company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPremiumGetCompanyPremiumServicesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Premium/GetCompanyPremiumServices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PremiumApi - functional programming interface
 * @export
 */
export const PremiumApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PremiumApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets premium services for logged user by company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPremiumGetCompanyPremiumServicesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOPremiumPremiumServicesSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPremiumGetCompanyPremiumServicesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PremiumApi.apiPremiumGetCompanyPremiumServicesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PremiumApi - factory interface
 * @export
 */
export const PremiumApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PremiumApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets premium services for logged user by company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPremiumGetCompanyPremiumServicesGet(options?: any): AxiosPromise<APIXdentDTOPremiumPremiumServicesSettings> {
            return localVarFp.apiPremiumGetCompanyPremiumServicesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PremiumApi - object-oriented interface
 * @export
 * @class PremiumApi
 * @extends {BaseAPI}
 */
export class PremiumApi extends BaseAPI {
    /**
     * 
     * @summary Gets premium services for logged user by company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PremiumApi
     */
    public apiPremiumGetCompanyPremiumServicesGet(options?: AxiosRequestConfig) {
        return PremiumApiFp(this.configuration).apiPremiumGetCompanyPremiumServicesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrintFormApi - axios parameter creator
 * @export
 */
export const PrintFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate form PDF
         * @param {string} [idXdentUser] 
         * @param {APISharedFormRequest} [aPISharedFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrintFormFormPost: async (idXdentUser?: string, aPISharedFormRequest?: APISharedFormRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PrintForm/Form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentUser != null) {
                localVarHeaderParameter['idXdentUser'] = String(idXdentUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedFormRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the print form overview.
         * @param {string} [clientId] The client identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrintFormGetPrintFormOverviewGet: async (clientId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PrintForm/GetPrintFormOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate PDF. General printform controller (tiskopisy). Accept whatever entity type is possible to print. Forms/Invoice/LaboratoryLabel..
         * @param {string} [idEntity] Entity id tied to printed document.
         * @param {ApiPrintFormPdfGetPrintFormTypeEnum} [printFormType] Possible values &#x3D; [0 - OldRecipe, 1 - Invoice, 2 - LaboratoryLabel, 3 - DoctorPass, 4 - TransportOrder, 5 - MedicalExamination, 6 - MedicalReport, 7 - MedicalReportExternal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrintFormPdfGet: async (idEntity?: string, printFormType?: ApiPrintFormPdfGetPrintFormTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PrintForm/Pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idEntity !== undefined) {
                localVarQueryParameter['idEntity'] = idEntity;
            }

            if (printFormType !== undefined) {
                localVarQueryParameter['printFormType'] = printFormType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrintFormApi - functional programming interface
 * @export
 */
export const PrintFormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrintFormApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate form PDF
         * @param {string} [idXdentUser] 
         * @param {APISharedFormRequest} [aPISharedFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrintFormFormPost(idXdentUser?: string, aPISharedFormRequest?: APISharedFormRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrintFormFormPost(idXdentUser, aPISharedFormRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintFormApi.apiPrintFormFormPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the print form overview.
         * @param {string} [clientId] The client identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrintFormGetPrintFormOverviewGet(clientId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOPrintformsPrintFormOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrintFormGetPrintFormOverviewGet(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintFormApi.apiPrintFormGetPrintFormOverviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generate PDF. General printform controller (tiskopisy). Accept whatever entity type is possible to print. Forms/Invoice/LaboratoryLabel..
         * @param {string} [idEntity] Entity id tied to printed document.
         * @param {ApiPrintFormPdfGetPrintFormTypeEnum} [printFormType] Possible values &#x3D; [0 - OldRecipe, 1 - Invoice, 2 - LaboratoryLabel, 3 - DoctorPass, 4 - TransportOrder, 5 - MedicalExamination, 6 - MedicalReport, 7 - MedicalReportExternal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPrintFormPdfGet(idEntity?: string, printFormType?: ApiPrintFormPdfGetPrintFormTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPrintFormPdfGet(idEntity, printFormType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintFormApi.apiPrintFormPdfGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PrintFormApi - factory interface
 * @export
 */
export const PrintFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrintFormApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate form PDF
         * @param {string} [idXdentUser] 
         * @param {APISharedFormRequest} [aPISharedFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrintFormFormPost(idXdentUser?: string, aPISharedFormRequest?: APISharedFormRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiPrintFormFormPost(idXdentUser, aPISharedFormRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the print form overview.
         * @param {string} [clientId] The client identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrintFormGetPrintFormOverviewGet(clientId?: string, options?: any): AxiosPromise<APIXdentDTOPrintformsPrintFormOverviewDto> {
            return localVarFp.apiPrintFormGetPrintFormOverviewGet(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate PDF. General printform controller (tiskopisy). Accept whatever entity type is possible to print. Forms/Invoice/LaboratoryLabel..
         * @param {string} [idEntity] Entity id tied to printed document.
         * @param {ApiPrintFormPdfGetPrintFormTypeEnum} [printFormType] Possible values &#x3D; [0 - OldRecipe, 1 - Invoice, 2 - LaboratoryLabel, 3 - DoctorPass, 4 - TransportOrder, 5 - MedicalExamination, 6 - MedicalReport, 7 - MedicalReportExternal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPrintFormPdfGet(idEntity?: string, printFormType?: ApiPrintFormPdfGetPrintFormTypeEnum, options?: any): AxiosPromise<void> {
            return localVarFp.apiPrintFormPdfGet(idEntity, printFormType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrintFormApi - object-oriented interface
 * @export
 * @class PrintFormApi
 * @extends {BaseAPI}
 */
export class PrintFormApi extends BaseAPI {
    /**
     * 
     * @summary Generate form PDF
     * @param {string} [idXdentUser] 
     * @param {APISharedFormRequest} [aPISharedFormRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintFormApi
     */
    public apiPrintFormFormPost(idXdentUser?: string, aPISharedFormRequest?: APISharedFormRequest, options?: AxiosRequestConfig) {
        return PrintFormApiFp(this.configuration).apiPrintFormFormPost(idXdentUser, aPISharedFormRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the print form overview.
     * @param {string} [clientId] The client identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintFormApi
     */
    public apiPrintFormGetPrintFormOverviewGet(clientId?: string, options?: AxiosRequestConfig) {
        return PrintFormApiFp(this.configuration).apiPrintFormGetPrintFormOverviewGet(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate PDF. General printform controller (tiskopisy). Accept whatever entity type is possible to print. Forms/Invoice/LaboratoryLabel..
     * @param {string} [idEntity] Entity id tied to printed document.
     * @param {ApiPrintFormPdfGetPrintFormTypeEnum} [printFormType] Possible values &#x3D; [0 - OldRecipe, 1 - Invoice, 2 - LaboratoryLabel, 3 - DoctorPass, 4 - TransportOrder, 5 - MedicalExamination, 6 - MedicalReport, 7 - MedicalReportExternal]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintFormApi
     */
    public apiPrintFormPdfGet(idEntity?: string, printFormType?: ApiPrintFormPdfGetPrintFormTypeEnum, options?: AxiosRequestConfig) {
        return PrintFormApiFp(this.configuration).apiPrintFormPdfGet(idEntity, printFormType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiPrintFormPdfGetPrintFormTypeEnum = {
    OldRecipe: 'OldRecipe',
    Invoice: 'Invoice',
    LaboratoryLabel: 'LaboratoryLabel',
    DoctorPass: 'DoctorPass',
    TransportOrder: 'TransportOrder',
    MedicalExamination: 'MedicalExamination',
    MedicalReport: 'MedicalReport',
    MedicalReportExternal: 'MedicalReportExternal',
    ClientAppointmentsUpcoming: 'Client_Appointments_Upcoming',
    LabRequestResultHeader: 'LabRequestResultHeader',
    Unknown: 'UNKNOWN'
} as const;
export type ApiPrintFormPdfGetPrintFormTypeEnum = typeof ApiPrintFormPdfGetPrintFormTypeEnum[keyof typeof ApiPrintFormPdfGetPrintFormTypeEnum];


/**
 * PublicResourcesApi - axios parameter creator
 * @export
 */
export const PublicResourcesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns xdent favicon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicResourceGetXdentFaviconGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PublicResource/GetXdentFavicon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicResourcesApi - functional programming interface
 * @export
 */
export const PublicResourcesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicResourcesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns xdent favicon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicResourceGetXdentFaviconGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicResourceGetXdentFaviconGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PublicResourcesApi.apiPublicResourceGetXdentFaviconGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PublicResourcesApi - factory interface
 * @export
 */
export const PublicResourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicResourcesApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns xdent favicon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicResourceGetXdentFaviconGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiPublicResourceGetXdentFaviconGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicResourcesApi - object-oriented interface
 * @export
 * @class PublicResourcesApi
 * @extends {BaseAPI}
 */
export class PublicResourcesApi extends BaseAPI {
    /**
     * 
     * @summary Returns xdent favicon
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicResourcesApi
     */
    public apiPublicResourceGetXdentFaviconGet(options?: AxiosRequestConfig) {
        return PublicResourcesApiFp(this.configuration).apiPublicResourceGetXdentFaviconGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RatingApi - axios parameter creator
 * @export
 */
export const RatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the rating configuration for mobile app.  Maximum for apple is 3 and for google is 12 per year. (as of mid 2024)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRatingConfigurationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Rating/Configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RatingApi - functional programming interface
 * @export
 */
export const RatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RatingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the rating configuration for mobile app.  Maximum for apple is 3 and for google is 12 per year. (as of mid 2024)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRatingConfigurationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTORatingRatingConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRatingConfigurationGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RatingApi.apiRatingConfigurationGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RatingApi - factory interface
 * @export
 */
export const RatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RatingApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the rating configuration for mobile app.  Maximum for apple is 3 and for google is 12 per year. (as of mid 2024)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRatingConfigurationGet(options?: any): AxiosPromise<APISharedDTORatingRatingConfigurationDto> {
            return localVarFp.apiRatingConfigurationGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RatingApi - object-oriented interface
 * @export
 * @class RatingApi
 * @extends {BaseAPI}
 */
export class RatingApi extends BaseAPI {
    /**
     * 
     * @summary Gets the rating configuration for mobile app.  Maximum for apple is 3 and for google is 12 per year. (as of mid 2024)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    public apiRatingConfigurationGet(options?: AxiosRequestConfig) {
        return RatingApiFp(this.configuration).apiRatingConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RequestSafeSignaturesApi - axios parameter creator
 * @export
 */
export const RequestSafeSignaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates SSRequest based on client and xdent treatment plan.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto} [aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesCreatePlanSSRequestForClientPost: async (deviceToken: string, aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto?: APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiRequestSafesignaturesCreatePlanSSRequestForClientPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/request/safesignatures/CreatePlanSSRequestForClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates SSRequest.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSSRequestCreateDto} [aPIXdentDTOSafeSignaturesSSRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesCreateRequestPost: async (deviceToken: string, aPIXdentDTOSafeSignaturesSSRequestCreateDto?: APIXdentDTOSafeSignaturesSSRequestCreateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiRequestSafesignaturesCreateRequestPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/request/safesignatures/CreateRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesSSRequestCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates SSRequest based on client and xdent form.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreateSSRequestForClientDto} [aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesCreateSSRequestForClientPost: async (deviceToken: string, aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto?: APIXdentDTOSafeSignaturesCreateSSRequestForClientDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiRequestSafesignaturesCreateSSRequestForClientPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/request/safesignatures/CreateSSRequestForClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates SSRequest based on idIklientForm of filled form.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto} [aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost: async (deviceToken: string, aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto?: APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/request/safesignatures/CreateSSRequestFromPopulatedForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns true or false whether the BETA version of SafeSignatures is still supported
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesIsBetaSupportedGet: async (deviceToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiRequestSafesignaturesIsBetaSupportedGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/request/safesignatures/IsBetaSupported`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestSafeSignaturesApi - functional programming interface
 * @export
 */
export const RequestSafeSignaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestSafeSignaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates SSRequest based on client and xdent treatment plan.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto} [aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequestSafesignaturesCreatePlanSSRequestForClientPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto?: APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRequestSafesignaturesCreatePlanSSRequestForClientPost(deviceToken, aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestSafeSignaturesApi.apiRequestSafesignaturesCreatePlanSSRequestForClientPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates SSRequest.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSSRequestCreateDto} [aPIXdentDTOSafeSignaturesSSRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequestSafesignaturesCreateRequestPost(deviceToken: string, aPIXdentDTOSafeSignaturesSSRequestCreateDto?: APIXdentDTOSafeSignaturesSSRequestCreateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRequestSafesignaturesCreateRequestPost(deviceToken, aPIXdentDTOSafeSignaturesSSRequestCreateDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestSafeSignaturesApi.apiRequestSafesignaturesCreateRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates SSRequest based on client and xdent form.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreateSSRequestForClientDto} [aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequestSafesignaturesCreateSSRequestForClientPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto?: APIXdentDTOSafeSignaturesCreateSSRequestForClientDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRequestSafesignaturesCreateSSRequestForClientPost(deviceToken, aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestSafeSignaturesApi.apiRequestSafesignaturesCreateSSRequestForClientPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates SSRequest based on idIklientForm of filled form.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto} [aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto?: APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost(deviceToken, aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestSafeSignaturesApi.apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns true or false whether the BETA version of SafeSignatures is still supported
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRequestSafesignaturesIsBetaSupportedGet(deviceToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRequestSafesignaturesIsBetaSupportedGet(deviceToken, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestSafeSignaturesApi.apiRequestSafesignaturesIsBetaSupportedGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RequestSafeSignaturesApi - factory interface
 * @export
 */
export const RequestSafeSignaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestSafeSignaturesApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates SSRequest based on client and xdent treatment plan.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto} [aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesCreatePlanSSRequestForClientPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto?: APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiRequestSafesignaturesCreatePlanSSRequestForClientPost(deviceToken, aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates SSRequest.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSSRequestCreateDto} [aPIXdentDTOSafeSignaturesSSRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesCreateRequestPost(deviceToken: string, aPIXdentDTOSafeSignaturesSSRequestCreateDto?: APIXdentDTOSafeSignaturesSSRequestCreateDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiRequestSafesignaturesCreateRequestPost(deviceToken, aPIXdentDTOSafeSignaturesSSRequestCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates SSRequest based on client and xdent form.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreateSSRequestForClientDto} [aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesCreateSSRequestForClientPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto?: APIXdentDTOSafeSignaturesCreateSSRequestForClientDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiRequestSafesignaturesCreateSSRequestForClientPost(deviceToken, aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates SSRequest based on idIklientForm of filled form.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto} [aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto?: APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost(deviceToken, aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns true or false whether the BETA version of SafeSignatures is still supported
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRequestSafesignaturesIsBetaSupportedGet(deviceToken: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiRequestSafesignaturesIsBetaSupportedGet(deviceToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestSafeSignaturesApi - object-oriented interface
 * @export
 * @class RequestSafeSignaturesApi
 * @extends {BaseAPI}
 */
export class RequestSafeSignaturesApi extends BaseAPI {
    /**
     * 
     * @summary Creates SSRequest based on client and xdent treatment plan.
     * @param {string} deviceToken 
     * @param {APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto} [aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestSafeSignaturesApi
     */
    public apiRequestSafesignaturesCreatePlanSSRequestForClientPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto?: APIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto, options?: AxiosRequestConfig) {
        return RequestSafeSignaturesApiFp(this.configuration).apiRequestSafesignaturesCreatePlanSSRequestForClientPost(deviceToken, aPIXdentDTOSafeSignaturesCreatePlanSSRequestForClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates SSRequest.
     * @param {string} deviceToken 
     * @param {APIXdentDTOSafeSignaturesSSRequestCreateDto} [aPIXdentDTOSafeSignaturesSSRequestCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestSafeSignaturesApi
     */
    public apiRequestSafesignaturesCreateRequestPost(deviceToken: string, aPIXdentDTOSafeSignaturesSSRequestCreateDto?: APIXdentDTOSafeSignaturesSSRequestCreateDto, options?: AxiosRequestConfig) {
        return RequestSafeSignaturesApiFp(this.configuration).apiRequestSafesignaturesCreateRequestPost(deviceToken, aPIXdentDTOSafeSignaturesSSRequestCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates SSRequest based on client and xdent form.
     * @param {string} deviceToken 
     * @param {APIXdentDTOSafeSignaturesCreateSSRequestForClientDto} [aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestSafeSignaturesApi
     */
    public apiRequestSafesignaturesCreateSSRequestForClientPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto?: APIXdentDTOSafeSignaturesCreateSSRequestForClientDto, options?: AxiosRequestConfig) {
        return RequestSafeSignaturesApiFp(this.configuration).apiRequestSafesignaturesCreateSSRequestForClientPost(deviceToken, aPIXdentDTOSafeSignaturesCreateSSRequestForClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates SSRequest based on idIklientForm of filled form.
     * @param {string} deviceToken 
     * @param {APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto} [aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestSafeSignaturesApi
     */
    public apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost(deviceToken: string, aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto?: APIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto, options?: AxiosRequestConfig) {
        return RequestSafeSignaturesApiFp(this.configuration).apiRequestSafesignaturesCreateSSRequestFromPopulatedFormPost(deviceToken, aPIXdentDTOSafeSignaturesCreateSSRequestForClientPopulatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns true or false whether the BETA version of SafeSignatures is still supported
     * @param {string} deviceToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestSafeSignaturesApi
     */
    public apiRequestSafesignaturesIsBetaSupportedGet(deviceToken: string, options?: AxiosRequestConfig) {
        return RequestSafeSignaturesApiFp(this.configuration).apiRequestSafesignaturesIsBetaSupportedGet(deviceToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all roles for logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleGetUserRolesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Role/GetUserRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Tests if provided roles belog to logged user
         * @param {Array<string>} [roles] Query array of roles
         * @param {boolean} [strict] If multiple roles are provided, selects whether logic AND or logic OR will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleIsUserInRolesGet: async (roles?: Array<string>, strict?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Role/IsUserInRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (roles) {
                localVarQueryParameter['roles'] = roles;
            }

            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all roles for logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleGetUserRolesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleGetUserRolesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoleApi.apiRoleGetUserRolesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Tests if provided roles belog to logged user
         * @param {Array<string>} [roles] Query array of roles
         * @param {boolean} [strict] If multiple roles are provided, selects whether logic AND or logic OR will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleIsUserInRolesGet(roles?: Array<string>, strict?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleIsUserInRolesGet(roles, strict, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RoleApi.apiRoleIsUserInRolesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all roles for logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleGetUserRolesGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiRoleGetUserRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tests if provided roles belog to logged user
         * @param {Array<string>} [roles] Query array of roles
         * @param {boolean} [strict] If multiple roles are provided, selects whether logic AND or logic OR will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleIsUserInRolesGet(roles?: Array<string>, strict?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiRoleIsUserInRolesGet(roles, strict, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     * 
     * @summary Gets all roles for logged user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiRoleGetUserRolesGet(options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiRoleGetUserRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Tests if provided roles belog to logged user
     * @param {Array<string>} [roles] Query array of roles
     * @param {boolean} [strict] If multiple roles are provided, selects whether logic AND or logic OR will be used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiRoleIsUserInRolesGet(roles?: Array<string>, strict?: boolean, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiRoleIsUserInRolesGet(roles, strict, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RvgApi - axios parameter creator
 * @export
 */
export const RvgApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRvgSegmentationPost: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Rvg/Segmentation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [imageType] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRvgSegmentationWithAdditionalDataPost: async (imageType?: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Rvg/SegmentationWithAdditionalData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (imageType != null) {
                localVarHeaderParameter['ImageType'] = String(imageType);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RvgApi - functional programming interface
 * @export
 */
export const RvgApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RvgApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRvgSegmentationPost(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTORvgSegmentationResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRvgSegmentationPost(file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RvgApi.apiRvgSegmentationPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [imageType] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRvgSegmentationWithAdditionalDataPost(imageType?: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTORvgSegmentationResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRvgSegmentationWithAdditionalDataPost(imageType, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RvgApi.apiRvgSegmentationWithAdditionalDataPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RvgApi - factory interface
 * @export
 */
export const RvgApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RvgApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRvgSegmentationPost(file?: File, options?: any): AxiosPromise<Array<APIXdentDTORvgSegmentationResponseDto>> {
            return localVarFp.apiRvgSegmentationPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [imageType] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRvgSegmentationWithAdditionalDataPost(imageType?: string, file?: File, options?: any): AxiosPromise<Array<APIXdentDTORvgSegmentationResponseDto>> {
            return localVarFp.apiRvgSegmentationWithAdditionalDataPost(imageType, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RvgApi - object-oriented interface
 * @export
 * @class RvgApi
 * @extends {BaseAPI}
 */
export class RvgApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RvgApi
     */
    public apiRvgSegmentationPost(file?: File, options?: AxiosRequestConfig) {
        return RvgApiFp(this.configuration).apiRvgSegmentationPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [imageType] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RvgApi
     */
    public apiRvgSegmentationWithAdditionalDataPost(imageType?: string, file?: File, options?: AxiosRequestConfig) {
        return RvgApiFp(this.configuration).apiRvgSegmentationWithAdditionalDataPost(imageType, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * S3Api - axios parameter creator
 * @export
 */
export const S3ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {string} [personalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiS3ListByClientFlatGet: async (idClient?: string, personalId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/S3/listByClientFlat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (personalId !== undefined) {
                localVarQueryParameter['personalId'] = personalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [prefix] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiS3ListGet: async (prefix?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/S3/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiS3ObjectGet: async (key?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/S3/object`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiS3PresignedUrlGet: async (key?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/S3/presigned-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * S3Api - functional programming interface
 * @export
 */
export const S3ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = S3ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {string} [personalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiS3ListByClientFlatGet(idClient?: string, personalId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentServicesXdentScopedS3FileItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiS3ListByClientFlatGet(idClient, personalId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['S3Api.apiS3ListByClientFlatGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [prefix] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiS3ListGet(prefix?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentServicesXdentScopedS3FileItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiS3ListGet(prefix, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['S3Api.apiS3ListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiS3ObjectGet(key?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiS3ObjectGet(key, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['S3Api.apiS3ObjectGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiS3PresignedUrlGet(key?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedGetPresignedUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiS3PresignedUrlGet(key, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['S3Api.apiS3PresignedUrlGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * S3Api - factory interface
 * @export
 */
export const S3ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = S3ApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {string} [personalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiS3ListByClientFlatGet(idClient?: string, personalId?: string, options?: any): AxiosPromise<Array<APIXdentServicesXdentScopedS3FileItem>> {
            return localVarFp.apiS3ListByClientFlatGet(idClient, personalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [prefix] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiS3ListGet(prefix?: string, options?: any): AxiosPromise<Array<APIXdentServicesXdentScopedS3FileItem>> {
            return localVarFp.apiS3ListGet(prefix, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiS3ObjectGet(key?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiS3ObjectGet(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiS3PresignedUrlGet(key?: string, options?: any): AxiosPromise<APIXdentServicesXdentScopedGetPresignedUrl> {
            return localVarFp.apiS3PresignedUrlGet(key, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * S3Api - object-oriented interface
 * @export
 * @class S3Api
 * @extends {BaseAPI}
 */
export class S3Api extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {string} [personalId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public apiS3ListByClientFlatGet(idClient?: string, personalId?: string, options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).apiS3ListByClientFlatGet(idClient, personalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [prefix] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public apiS3ListGet(prefix?: string, options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).apiS3ListGet(prefix, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [key] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public apiS3ObjectGet(key?: string, options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).apiS3ObjectGet(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [key] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public apiS3PresignedUrlGet(key?: string, options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).apiS3PresignedUrlGet(key, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceApi - axios parameter creator
 * @export
 */
export const ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceGetServiceGridGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Service/GetServiceGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns array of Guids (idService) that belong to idStaff
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceGetServiceIdsByStaffGet: async (idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Service/GetServiceIdsByStaff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Array<string>} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceGetServicesByStaffGet: async (idStaff?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Service/GetServicesByStaff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idStaff) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceGetServicesByUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Service/GetServicesByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idServiceLocationSetting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceLocationSettingsDelete: async (idServiceLocationSetting?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Service/LocationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idServiceLocationSetting !== undefined) {
                localVarQueryParameter['idServiceLocationSetting'] = idServiceLocationSetting;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idService] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceLocationSettingsGet: async (idService?: string, idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Service/LocationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idService !== undefined) {
                localVarQueryParameter['idService'] = idService;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOServiceServiceLocationSettingDTO} [aPIXdentDTOServiceServiceLocationSettingDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceLocationSettingsPost: async (aPIXdentDTOServiceServiceLocationSettingDTO?: APIXdentDTOServiceServiceLocationSettingDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Service/LocationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOServiceServiceLocationSettingDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApi - functional programming interface
 * @export
 */
export const ServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceGetServiceGridGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceGetServiceGridGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ServiceApi.apiServiceGetServiceGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns array of Guids (idService) that belong to idStaff
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceGetServiceIdsByStaffGet(idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceGetServiceIdsByStaffGet(idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ServiceApi.apiServiceGetServiceIdsByStaffGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Array<string>} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceGetServicesByStaffGet(idStaff?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceGetServicesByStaffGet(idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ServiceApi.apiServiceGetServicesByStaffGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceGetServicesByUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceGetServicesByUserGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ServiceApi.apiServiceGetServicesByUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idServiceLocationSetting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceLocationSettingsDelete(idServiceLocationSetting?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceLocationSettingsDelete(idServiceLocationSetting, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ServiceApi.apiServiceLocationSettingsDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idService] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceLocationSettingsGet(idService?: string, idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceLocationSettingsGet(idService, idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ServiceApi.apiServiceLocationSettingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOServiceServiceLocationSettingDTO} [aPIXdentDTOServiceServiceLocationSettingDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceLocationSettingsPost(aPIXdentDTOServiceServiceLocationSettingDTO?: APIXdentDTOServiceServiceLocationSettingDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceLocationSettingsPost(aPIXdentDTOServiceServiceLocationSettingDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ServiceApi.apiServiceLocationSettingsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ServiceApi - factory interface
 * @export
 */
export const ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceGetServiceGridGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiServiceGetServiceGridGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns array of Guids (idService) that belong to idStaff
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceGetServiceIdsByStaffGet(idStaff?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiServiceGetServiceIdsByStaffGet(idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {Array<string>} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceGetServicesByStaffGet(idStaff?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiServiceGetServicesByStaffGet(idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceGetServicesByUserGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiServiceGetServicesByUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idServiceLocationSetting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceLocationSettingsDelete(idServiceLocationSetting?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiServiceLocationSettingsDelete(idServiceLocationSetting, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idService] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceLocationSettingsGet(idService?: string, idLocation?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiServiceLocationSettingsGet(idService, idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOServiceServiceLocationSettingDTO} [aPIXdentDTOServiceServiceLocationSettingDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceLocationSettingsPost(aPIXdentDTOServiceServiceLocationSettingDTO?: APIXdentDTOServiceServiceLocationSettingDTO, options?: any): AxiosPromise<void> {
            return localVarFp.apiServiceLocationSettingsPost(aPIXdentDTOServiceServiceLocationSettingDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
export class ServiceApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiServiceGetServiceGridGet(options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).apiServiceGetServiceGridGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns array of Guids (idService) that belong to idStaff
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiServiceGetServiceIdsByStaffGet(idStaff?: string, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).apiServiceGetServiceIdsByStaffGet(idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {Array<string>} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiServiceGetServicesByStaffGet(idStaff?: Array<string>, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).apiServiceGetServicesByStaffGet(idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiServiceGetServicesByUserGet(options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).apiServiceGetServicesByUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idServiceLocationSetting] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiServiceLocationSettingsDelete(idServiceLocationSetting?: string, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).apiServiceLocationSettingsDelete(idServiceLocationSetting, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idService] 
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiServiceLocationSettingsGet(idService?: string, idLocation?: string, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).apiServiceLocationSettingsGet(idService, idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOServiceServiceLocationSettingDTO} [aPIXdentDTOServiceServiceLocationSettingDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public apiServiceLocationSettingsPost(aPIXdentDTOServiceServiceLocationSettingDTO?: APIXdentDTOServiceServiceLocationSettingDTO, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).apiServiceLocationSettingsPost(aPIXdentDTOServiceServiceLocationSettingDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {number} [noi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsAccountGetPriceListGet: async (noi?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Settings/Account/GetPriceList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (noi !== undefined) {
                localVarQueryParameter['noi'] = noi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {number} [noi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsAccountGetPriceListGet(noi?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOPriceListPriceListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsAccountGetPriceListGet(noi, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.apiSettingsAccountGetPriceListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {number} [noi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsAccountGetPriceListGet(noi?: number, options?: any): AxiosPromise<APIXdentDTOPriceListPriceListDto> {
            return localVarFp.apiSettingsAccountGetPriceListGet(noi, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {number} [noi] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public apiSettingsAccountGetPriceListGet(noi?: number, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).apiSettingsAccountGetPriceListGet(noi, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShopApi - axios parameter creator
 * @export
 */
export const ShopApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Purges WooCommerce entities
         * @param {boolean} [dryRun] True shows which URL is configured to be purged. False does the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopCleanWooCommerceGet: async (dryRun?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Shop/CleanWooCommerce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Purges WordPress entities - WordPress REST API Authentication plugin must be disabled for this to work
         * @param {boolean} [dryRun] True shows which URL is configured to be purged. False does the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopCleanWordPressGet: async (dryRun?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Shop/CleanWordPress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves order to WooCommerce
         * @param {APISharedCreateOrderDTO} [aPISharedCreateOrderDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopCreateShopOrderPost: async (aPISharedCreateOrderDTO?: APISharedCreateOrderDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Shop/CreateShopOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedCreateOrderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns filtered shop products using singleton
         * @param {APISharedProductFiltersDTO} [aPISharedProductFiltersDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopGetProductsFilteredPost: async (aPISharedProductFiltersDTO?: APISharedProductFiltersDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Shop/GetProductsFiltered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedProductFiltersDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refreshes SHOP manager - ONLY FOR DEVELOPERS (pouze pro ty kdo znaji kouzelne slovicko)
         * @param {string} [kouzelneSluvko] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopReloadShopManagerInstancePost: async (kouzelneSluvko?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Shop/ReloadShopManagerInstance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (kouzelneSluvko !== undefined) {
                localVarQueryParameter['kouzelneSluvko'] = kouzelneSluvko;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends user message to WooCommerce order
         * @param {APISharedSendMessageDTO} [aPISharedSendMessageDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopSendShopMessagePost: async (aPISharedSendMessageDTO?: APISharedSendMessageDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Shop/SendShopMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedSendMessageDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Imports data from GLS to WooCommerce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopXdentShopImportGLSGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Shop/XdentShopImportGLS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Imports data from KunkelaDentalpoint to WooCommerce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopXdentShopImportKunkelaDentalpointGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Shop/XdentShopImportKunkelaDentalpoint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopApi - functional programming interface
 * @export
 */
export const ShopApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Purges WooCommerce entities
         * @param {boolean} [dryRun] True shows which URL is configured to be purged. False does the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopCleanWooCommerceGet(dryRun?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopCleanWooCommerceGet(dryRun, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ShopApi.apiShopCleanWooCommerceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Purges WordPress entities - WordPress REST API Authentication plugin must be disabled for this to work
         * @param {boolean} [dryRun] True shows which URL is configured to be purged. False does the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopCleanWordPressGet(dryRun?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopCleanWordPressGet(dryRun, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ShopApi.apiShopCleanWordPressGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Saves order to WooCommerce
         * @param {APISharedCreateOrderDTO} [aPISharedCreateOrderDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopCreateShopOrderPost(aPISharedCreateOrderDTO?: APISharedCreateOrderDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopCreateShopOrderPost(aPISharedCreateOrderDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ShopApi.apiShopCreateShopOrderPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns filtered shop products using singleton
         * @param {APISharedProductFiltersDTO} [aPISharedProductFiltersDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopGetProductsFilteredPost(aPISharedProductFiltersDTO?: APISharedProductFiltersDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopGetProductsFilteredPost(aPISharedProductFiltersDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ShopApi.apiShopGetProductsFilteredPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Refreshes SHOP manager - ONLY FOR DEVELOPERS (pouze pro ty kdo znaji kouzelne slovicko)
         * @param {string} [kouzelneSluvko] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopReloadShopManagerInstancePost(kouzelneSluvko?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopReloadShopManagerInstancePost(kouzelneSluvko, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ShopApi.apiShopReloadShopManagerInstancePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sends user message to WooCommerce order
         * @param {APISharedSendMessageDTO} [aPISharedSendMessageDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopSendShopMessagePost(aPISharedSendMessageDTO?: APISharedSendMessageDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopSendShopMessagePost(aPISharedSendMessageDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ShopApi.apiShopSendShopMessagePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Imports data from GLS to WooCommerce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopXdentShopImportGLSGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopXdentShopImportGLSGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ShopApi.apiShopXdentShopImportGLSGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Imports data from KunkelaDentalpoint to WooCommerce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopXdentShopImportKunkelaDentalpointGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopXdentShopImportKunkelaDentalpointGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ShopApi.apiShopXdentShopImportKunkelaDentalpointGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ShopApi - factory interface
 * @export
 */
export const ShopApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopApiFp(configuration)
    return {
        /**
         * 
         * @summary Purges WooCommerce entities
         * @param {boolean} [dryRun] True shows which URL is configured to be purged. False does the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopCleanWooCommerceGet(dryRun?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopCleanWooCommerceGet(dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Purges WordPress entities - WordPress REST API Authentication plugin must be disabled for this to work
         * @param {boolean} [dryRun] True shows which URL is configured to be purged. False does the job.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopCleanWordPressGet(dryRun?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopCleanWordPressGet(dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves order to WooCommerce
         * @param {APISharedCreateOrderDTO} [aPISharedCreateOrderDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopCreateShopOrderPost(aPISharedCreateOrderDTO?: APISharedCreateOrderDTO, options?: any): AxiosPromise<number> {
            return localVarFp.apiShopCreateShopOrderPost(aPISharedCreateOrderDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns filtered shop products using singleton
         * @param {APISharedProductFiltersDTO} [aPISharedProductFiltersDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopGetProductsFilteredPost(aPISharedProductFiltersDTO?: APISharedProductFiltersDTO, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopGetProductsFilteredPost(aPISharedProductFiltersDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refreshes SHOP manager - ONLY FOR DEVELOPERS (pouze pro ty kdo znaji kouzelne slovicko)
         * @param {string} [kouzelneSluvko] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopReloadShopManagerInstancePost(kouzelneSluvko?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopReloadShopManagerInstancePost(kouzelneSluvko, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends user message to WooCommerce order
         * @param {APISharedSendMessageDTO} [aPISharedSendMessageDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopSendShopMessagePost(aPISharedSendMessageDTO?: APISharedSendMessageDTO, options?: any): AxiosPromise<number> {
            return localVarFp.apiShopSendShopMessagePost(aPISharedSendMessageDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Imports data from GLS to WooCommerce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopXdentShopImportGLSGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiShopXdentShopImportGLSGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Imports data from KunkelaDentalpoint to WooCommerce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopXdentShopImportKunkelaDentalpointGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiShopXdentShopImportKunkelaDentalpointGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopApi - object-oriented interface
 * @export
 * @class ShopApi
 * @extends {BaseAPI}
 */
export class ShopApi extends BaseAPI {
    /**
     * 
     * @summary Purges WooCommerce entities
     * @param {boolean} [dryRun] True shows which URL is configured to be purged. False does the job.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopApi
     */
    public apiShopCleanWooCommerceGet(dryRun?: boolean, options?: AxiosRequestConfig) {
        return ShopApiFp(this.configuration).apiShopCleanWooCommerceGet(dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Purges WordPress entities - WordPress REST API Authentication plugin must be disabled for this to work
     * @param {boolean} [dryRun] True shows which URL is configured to be purged. False does the job.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopApi
     */
    public apiShopCleanWordPressGet(dryRun?: boolean, options?: AxiosRequestConfig) {
        return ShopApiFp(this.configuration).apiShopCleanWordPressGet(dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves order to WooCommerce
     * @param {APISharedCreateOrderDTO} [aPISharedCreateOrderDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopApi
     */
    public apiShopCreateShopOrderPost(aPISharedCreateOrderDTO?: APISharedCreateOrderDTO, options?: AxiosRequestConfig) {
        return ShopApiFp(this.configuration).apiShopCreateShopOrderPost(aPISharedCreateOrderDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns filtered shop products using singleton
     * @param {APISharedProductFiltersDTO} [aPISharedProductFiltersDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopApi
     */
    public apiShopGetProductsFilteredPost(aPISharedProductFiltersDTO?: APISharedProductFiltersDTO, options?: AxiosRequestConfig) {
        return ShopApiFp(this.configuration).apiShopGetProductsFilteredPost(aPISharedProductFiltersDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refreshes SHOP manager - ONLY FOR DEVELOPERS (pouze pro ty kdo znaji kouzelne slovicko)
     * @param {string} [kouzelneSluvko] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopApi
     */
    public apiShopReloadShopManagerInstancePost(kouzelneSluvko?: string, options?: AxiosRequestConfig) {
        return ShopApiFp(this.configuration).apiShopReloadShopManagerInstancePost(kouzelneSluvko, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends user message to WooCommerce order
     * @param {APISharedSendMessageDTO} [aPISharedSendMessageDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopApi
     */
    public apiShopSendShopMessagePost(aPISharedSendMessageDTO?: APISharedSendMessageDTO, options?: AxiosRequestConfig) {
        return ShopApiFp(this.configuration).apiShopSendShopMessagePost(aPISharedSendMessageDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Imports data from GLS to WooCommerce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopApi
     */
    public apiShopXdentShopImportGLSGet(options?: AxiosRequestConfig) {
        return ShopApiFp(this.configuration).apiShopXdentShopImportGLSGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Imports data from KunkelaDentalpoint to WooCommerce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopApi
     */
    public apiShopXdentShopImportKunkelaDentalpointGet(options?: AxiosRequestConfig) {
        return ShopApiFp(this.configuration).apiShopXdentShopImportKunkelaDentalpointGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SideBarApi - axios parameter creator
 * @export
 */
export const SideBarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [table] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarAllCustomTagsGet: async (table?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/AllCustomTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (table !== undefined) {
                localVarQueryParameter['table'] = table;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarClientCreditTransactionsIdClientGet: async (idClient: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idClient' is not null or undefined
            assertParamExists('apiSideBarClientCreditTransactionsIdClientGet', 'idClient', idClient)
            const localVarPath = `/api/SideBar/ClientCreditTransactions/{idClient}`
                .replace(`{${"idClient"}}`, encodeURIComponent(String(idClient)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarClientDentalCategoryGet: async (idUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/ClientDentalCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idUser !== undefined) {
                localVarQueryParameter['idUser'] = idUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarClientInfoIdClientGet: async (idClient: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idClient' is not null or undefined
            assertParamExists('apiSideBarClientInfoIdClientGet', 'idClient', idClient)
            const localVarPath = `/api/SideBar/ClientInfo/{idClient}`
                .replace(`{${"idClient"}}`, encodeURIComponent(String(idClient)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarGetCustomTagsRequestDto} [aPIXdentDTOSideBarGetCustomTagsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarCustomTagsPost: async (aPIXdentDTOSideBarGetCustomTagsRequestDto?: APIXdentDTOSideBarGetCustomTagsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/CustomTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSideBarGetCustomTagsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarDeleteRelationCustomTagRequestDto} [aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarDeleteRelationCustomTagPost: async (aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto?: APIXdentDTOSideBarDeleteRelationCustomTagRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/DeleteRelationCustomTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarDispensarizationPlansGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/DispensarizationPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {boolean} [valid] 
         * @param {boolean} [deleted] 
         * @param {Array<string>} [roles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarEmployeeGridSimpleGet: async (valid?: boolean, deleted?: boolean, roles?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/EmployeeGridSimple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (valid !== undefined) {
                localVarQueryParameter['valid'] = valid;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (roles) {
                localVarQueryParameter['roles'] = roles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarFilterClientsGet: async (filter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/FilterClients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarInsuranceDoctorGridGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/InsuranceDoctorGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarSetCustomTagMethodRequestDto} [aPIXdentDTOSideBarSetCustomTagMethodRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarSetCustomTagPost: async (aPIXdentDTOSideBarSetCustomTagMethodRequestDto?: APIXdentDTOSideBarSetCustomTagMethodRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/SetCustomTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSideBarSetCustomTagMethodRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarUpdateAppointmentStatusRequestDto} [aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarUpdateAppointmentStatusPut: async (aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto?: APIXdentDTOSideBarUpdateAppointmentStatusRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/UpdateAppointmentStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarWaitingClientsDeleteAllAppointmentPost: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/WaitingClientsDeleteAllAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto} [aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarWaitingClientsUpdateNotePost: async (aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto?: APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/WaitingClientsUpdateNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarWaitingListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/WaitingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarWaitingRoomClientsGet: async (idLocation?: string, idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SideBar/WaitingRoomClients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SideBarApi - functional programming interface
 * @export
 */
export const SideBarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SideBarApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [table] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarAllCustomTagsGet(table?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOSideBarCustomTagDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarAllCustomTagsGet(table, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarAllCustomTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarClientCreditTransactionsIdClientGet(idClient: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarClientCreditTransactionsIdClientGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarClientCreditTransactionsIdClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarClientDentalCategoryGet(idUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarClientDentalCategoryGet(idUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarClientDentalCategoryGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarClientInfoIdClientGet(idClient: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOSideBarClientInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarClientInfoIdClientGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarClientInfoIdClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarGetCustomTagsRequestDto} [aPIXdentDTOSideBarGetCustomTagsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarCustomTagsPost(aPIXdentDTOSideBarGetCustomTagsRequestDto?: APIXdentDTOSideBarGetCustomTagsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOSideBarCustomTagDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarCustomTagsPost(aPIXdentDTOSideBarGetCustomTagsRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarCustomTagsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarDeleteRelationCustomTagRequestDto} [aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarDeleteRelationCustomTagPost(aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto?: APIXdentDTOSideBarDeleteRelationCustomTagRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarDeleteRelationCustomTagPost(aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarDeleteRelationCustomTagPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarDispensarizationPlansGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOSideBarDispensarizationPlanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarDispensarizationPlansGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarDispensarizationPlansGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {boolean} [valid] 
         * @param {boolean} [deleted] 
         * @param {Array<string>} [roles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarEmployeeGridSimpleGet(valid?: boolean, deleted?: boolean, roles?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarEmployeeGridSimpleGet(valid, deleted, roles, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarEmployeeGridSimpleGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarFilterClientsGet(filter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOSideBarSideBarClientFilterDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarFilterClientsGet(filter, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarFilterClientsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarInsuranceDoctorGridGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarInsuranceDoctorGridGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarInsuranceDoctorGridGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarSetCustomTagMethodRequestDto} [aPIXdentDTOSideBarSetCustomTagMethodRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarSetCustomTagPost(aPIXdentDTOSideBarSetCustomTagMethodRequestDto?: APIXdentDTOSideBarSetCustomTagMethodRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOSideBarCustomTagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarSetCustomTagPost(aPIXdentDTOSideBarSetCustomTagMethodRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarSetCustomTagPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarUpdateAppointmentStatusRequestDto} [aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarUpdateAppointmentStatusPut(aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto?: APIXdentDTOSideBarUpdateAppointmentStatusRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarUpdateAppointmentStatusPut(aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarUpdateAppointmentStatusPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarWaitingClientsDeleteAllAppointmentPost(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarWaitingClientsDeleteAllAppointmentPost(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarWaitingClientsDeleteAllAppointmentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto} [aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarWaitingClientsUpdateNotePost(aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto?: APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarWaitingClientsUpdateNotePost(aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarWaitingClientsUpdateNotePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarWaitingListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOSideBarGetWaitingListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarWaitingListGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarWaitingListGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSideBarWaitingRoomClientsGet(idLocation?: string, idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOSideBarClientWaitingRoomDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSideBarWaitingRoomClientsGet(idLocation, idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SideBarApi.apiSideBarWaitingRoomClientsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SideBarApi - factory interface
 * @export
 */
export const SideBarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SideBarApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [table] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarAllCustomTagsGet(table?: string, options?: any): AxiosPromise<Array<APIXdentDTOSideBarCustomTagDto>> {
            return localVarFp.apiSideBarAllCustomTagsGet(table, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarClientCreditTransactionsIdClientGet(idClient: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTCREDITGRIDResult>> {
            return localVarFp.apiSideBarClientCreditTransactionsIdClientGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarClientDentalCategoryGet(idUser?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCLIENTDENTALCATEGORYFORMResult> {
            return localVarFp.apiSideBarClientDentalCategoryGet(idUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} idClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarClientInfoIdClientGet(idClient: string, options?: any): AxiosPromise<APIXdentDTOSideBarClientInfoDto> {
            return localVarFp.apiSideBarClientInfoIdClientGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarGetCustomTagsRequestDto} [aPIXdentDTOSideBarGetCustomTagsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarCustomTagsPost(aPIXdentDTOSideBarGetCustomTagsRequestDto?: APIXdentDTOSideBarGetCustomTagsRequestDto, options?: any): AxiosPromise<Array<APIXdentDTOSideBarCustomTagDto>> {
            return localVarFp.apiSideBarCustomTagsPost(aPIXdentDTOSideBarGetCustomTagsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarDeleteRelationCustomTagRequestDto} [aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarDeleteRelationCustomTagPost(aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto?: APIXdentDTOSideBarDeleteRelationCustomTagRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiSideBarDeleteRelationCustomTagPost(aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarDispensarizationPlansGet(idClient?: string, options?: any): AxiosPromise<Array<APIXdentDTOSideBarDispensarizationPlanDto>> {
            return localVarFp.apiSideBarDispensarizationPlansGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {boolean} [valid] 
         * @param {boolean} [deleted] 
         * @param {Array<string>} [roles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarEmployeeGridSimpleGet(valid?: boolean, deleted?: boolean, roles?: Array<string>, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedEMPLOYEEGRIDSIMPLEResult>> {
            return localVarFp.apiSideBarEmployeeGridSimpleGet(valid, deleted, roles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarFilterClientsGet(filter?: string, options?: any): AxiosPromise<Array<APIXdentDTOSideBarSideBarClientFilterDto>> {
            return localVarFp.apiSideBarFilterClientsGet(filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarInsuranceDoctorGridGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedINSURANCEDOCTORGRIDResult>> {
            return localVarFp.apiSideBarInsuranceDoctorGridGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarSetCustomTagMethodRequestDto} [aPIXdentDTOSideBarSetCustomTagMethodRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarSetCustomTagPost(aPIXdentDTOSideBarSetCustomTagMethodRequestDto?: APIXdentDTOSideBarSetCustomTagMethodRequestDto, options?: any): AxiosPromise<APIXdentDTOSideBarCustomTagDto> {
            return localVarFp.apiSideBarSetCustomTagPost(aPIXdentDTOSideBarSetCustomTagMethodRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarUpdateAppointmentStatusRequestDto} [aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarUpdateAppointmentStatusPut(aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto?: APIXdentDTOSideBarUpdateAppointmentStatusRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiSideBarUpdateAppointmentStatusPut(aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarWaitingClientsDeleteAllAppointmentPost(idClient?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiSideBarWaitingClientsDeleteAllAppointmentPost(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto} [aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarWaitingClientsUpdateNotePost(aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto?: APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiSideBarWaitingClientsUpdateNotePost(aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarWaitingListGet(options?: any): AxiosPromise<APIXdentDTOSideBarGetWaitingListResponseDto> {
            return localVarFp.apiSideBarWaitingListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLocation] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSideBarWaitingRoomClientsGet(idLocation?: string, idStaff?: string, options?: any): AxiosPromise<Array<APIXdentDTOSideBarClientWaitingRoomDto>> {
            return localVarFp.apiSideBarWaitingRoomClientsGet(idLocation, idStaff, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SideBarApi - object-oriented interface
 * @export
 * @class SideBarApi
 * @extends {BaseAPI}
 */
export class SideBarApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [table] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarAllCustomTagsGet(table?: string, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarAllCustomTagsGet(table, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idClient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarClientCreditTransactionsIdClientGet(idClient: string, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarClientCreditTransactionsIdClientGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarClientDentalCategoryGet(idUser?: string, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarClientDentalCategoryGet(idUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} idClient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarClientInfoIdClientGet(idClient: string, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarClientInfoIdClientGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOSideBarGetCustomTagsRequestDto} [aPIXdentDTOSideBarGetCustomTagsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarCustomTagsPost(aPIXdentDTOSideBarGetCustomTagsRequestDto?: APIXdentDTOSideBarGetCustomTagsRequestDto, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarCustomTagsPost(aPIXdentDTOSideBarGetCustomTagsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOSideBarDeleteRelationCustomTagRequestDto} [aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarDeleteRelationCustomTagPost(aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto?: APIXdentDTOSideBarDeleteRelationCustomTagRequestDto, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarDeleteRelationCustomTagPost(aPIXdentDTOSideBarDeleteRelationCustomTagRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarDispensarizationPlansGet(idClient?: string, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarDispensarizationPlansGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {boolean} [valid] 
     * @param {boolean} [deleted] 
     * @param {Array<string>} [roles] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarEmployeeGridSimpleGet(valid?: boolean, deleted?: boolean, roles?: Array<string>, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarEmployeeGridSimpleGet(valid, deleted, roles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarFilterClientsGet(filter?: string, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarFilterClientsGet(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarInsuranceDoctorGridGet(options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarInsuranceDoctorGridGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOSideBarSetCustomTagMethodRequestDto} [aPIXdentDTOSideBarSetCustomTagMethodRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarSetCustomTagPost(aPIXdentDTOSideBarSetCustomTagMethodRequestDto?: APIXdentDTOSideBarSetCustomTagMethodRequestDto, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarSetCustomTagPost(aPIXdentDTOSideBarSetCustomTagMethodRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOSideBarUpdateAppointmentStatusRequestDto} [aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarUpdateAppointmentStatusPut(aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto?: APIXdentDTOSideBarUpdateAppointmentStatusRequestDto, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarUpdateAppointmentStatusPut(aPIXdentDTOSideBarUpdateAppointmentStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarWaitingClientsDeleteAllAppointmentPost(idClient?: string, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarWaitingClientsDeleteAllAppointmentPost(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto} [aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarWaitingClientsUpdateNotePost(aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto?: APIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarWaitingClientsUpdateNotePost(aPIXdentDTOSideBarWaitingClientsUpdateNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarWaitingListGet(options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarWaitingListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLocation] 
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SideBarApi
     */
    public apiSideBarWaitingRoomClientsGet(idLocation?: string, idStaff?: string, options?: AxiosRequestConfig) {
        return SideBarApiFp(this.configuration).apiSideBarWaitingRoomClientsGet(idLocation, idStaff, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SignApi - axios parameter creator
 * @export
 */
export const SignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets sign metadata for sign request
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignGetSealedPdfTestGet: async (deviceToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesSignGetSealedPdfTestGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/sign/GetSealedPdfTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accepts Definition and Model of filled form and returns regenerated pdf file.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto} [aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSaveAndRegenerateFormPost: async (deviceToken: string, aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto?: APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesSignSaveAndRegenerateFormPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/sign/SaveAndRegenerateForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finally seals document with signature and returns it as a file for debugging.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSignSafeSigSealSignedDocumentDto} [aPIXdentDTOSignSafeSigSealSignedDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSealSignedDocumentGet: async (deviceToken: string, aPIXdentDTOSignSafeSigSealSignedDocumentDto?: APIXdentDTOSignSafeSigSealSignedDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesSignSealSignedDocumentGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/sign/SealSignedDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSignSafeSigSealSignedDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finally seals document with signature and returns true if succeeded.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSignSafeSigSealSignedDocumentDto} [aPIXdentDTOSignSafeSigSealSignedDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSealSignedDocumentMockGet: async (deviceToken: string, aPIXdentDTOSignSafeSigSealSignedDocumentDto?: APIXdentDTOSignSafeSigSealSignedDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesSignSealSignedDocumentMockGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/sign/SealSignedDocumentMock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSignSafeSigSealSignedDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turns in signed form to be sealed and to create a form request
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSendSignedMetadataDto} [aPIXdentDTOSafeSignaturesSendSignedMetadataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSendSignedMetadataPost: async (deviceToken: string, aPIXdentDTOSafeSignaturesSendSignedMetadataDto?: APIXdentDTOSafeSignaturesSendSignedMetadataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesSignSendSignedMetadataPost', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/sign/SendSignedMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSafeSignaturesSendSignedMetadataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets sign metadata for sign request
         * @param {string} deviceToken 
         * @param {string} [idBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSignMetadataGet: async (deviceToken: string, idBatch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesSignSignMetadataGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/sign/SignMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idBatch !== undefined) {
                localVarQueryParameter['idBatch'] = idBatch;
            }

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignApi - functional programming interface
 * @export
 */
export const SignApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets sign metadata for sign request
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesSignGetSealedPdfTestGet(deviceToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOSafeSignaturesSignMetadataDtoOld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesSignGetSealedPdfTestGet(deviceToken, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SignApi.apiSafesignaturesSignGetSealedPdfTestGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Accepts Definition and Model of filled form and returns regenerated pdf file.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto} [aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesSignSaveAndRegenerateFormPost(deviceToken: string, aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto?: APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOSafeSignaturesSaveAndRegenerateFormResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesSignSaveAndRegenerateFormPost(deviceToken, aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SignApi.apiSafesignaturesSignSaveAndRegenerateFormPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Finally seals document with signature and returns it as a file for debugging.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSignSafeSigSealSignedDocumentDto} [aPIXdentDTOSignSafeSigSealSignedDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesSignSealSignedDocumentGet(deviceToken: string, aPIXdentDTOSignSafeSigSealSignedDocumentDto?: APIXdentDTOSignSafeSigSealSignedDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesSignSealSignedDocumentGet(deviceToken, aPIXdentDTOSignSafeSigSealSignedDocumentDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SignApi.apiSafesignaturesSignSealSignedDocumentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Finally seals document with signature and returns true if succeeded.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSignSafeSigSealSignedDocumentDto} [aPIXdentDTOSignSafeSigSealSignedDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesSignSealSignedDocumentMockGet(deviceToken: string, aPIXdentDTOSignSafeSigSealSignedDocumentDto?: APIXdentDTOSignSafeSigSealSignedDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesSignSealSignedDocumentMockGet(deviceToken, aPIXdentDTOSignSafeSigSealSignedDocumentDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SignApi.apiSafesignaturesSignSealSignedDocumentMockGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Turns in signed form to be sealed and to create a form request
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSendSignedMetadataDto} [aPIXdentDTOSafeSignaturesSendSignedMetadataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesSignSendSignedMetadataPost(deviceToken: string, aPIXdentDTOSafeSignaturesSendSignedMetadataDto?: APIXdentDTOSafeSignaturesSendSignedMetadataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesSignSendSignedMetadataPost(deviceToken, aPIXdentDTOSafeSignaturesSendSignedMetadataDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SignApi.apiSafesignaturesSignSendSignedMetadataPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets sign metadata for sign request
         * @param {string} deviceToken 
         * @param {string} [idBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesSignSignMetadataGet(deviceToken: string, idBatch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOSafeSignaturesSignMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesSignSignMetadataGet(deviceToken, idBatch, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SignApi.apiSafesignaturesSignSignMetadataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SignApi - factory interface
 * @export
 */
export const SignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets sign metadata for sign request
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignGetSealedPdfTestGet(deviceToken: string, options?: any): AxiosPromise<APIXdentDTOSafeSignaturesSignMetadataDtoOld> {
            return localVarFp.apiSafesignaturesSignGetSealedPdfTestGet(deviceToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accepts Definition and Model of filled form and returns regenerated pdf file.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto} [aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSaveAndRegenerateFormPost(deviceToken: string, aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto?: APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto, options?: any): AxiosPromise<APIXdentDTOSafeSignaturesSaveAndRegenerateFormResponseDto> {
            return localVarFp.apiSafesignaturesSignSaveAndRegenerateFormPost(deviceToken, aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finally seals document with signature and returns it as a file for debugging.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSignSafeSigSealSignedDocumentDto} [aPIXdentDTOSignSafeSigSealSignedDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSealSignedDocumentGet(deviceToken: string, aPIXdentDTOSignSafeSigSealSignedDocumentDto?: APIXdentDTOSignSafeSigSealSignedDocumentDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiSafesignaturesSignSealSignedDocumentGet(deviceToken, aPIXdentDTOSignSafeSigSealSignedDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finally seals document with signature and returns true if succeeded.
         * @param {string} deviceToken 
         * @param {APIXdentDTOSignSafeSigSealSignedDocumentDto} [aPIXdentDTOSignSafeSigSealSignedDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSealSignedDocumentMockGet(deviceToken: string, aPIXdentDTOSignSafeSigSealSignedDocumentDto?: APIXdentDTOSignSafeSigSealSignedDocumentDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiSafesignaturesSignSealSignedDocumentMockGet(deviceToken, aPIXdentDTOSignSafeSigSealSignedDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turns in signed form to be sealed and to create a form request
         * @param {string} deviceToken 
         * @param {APIXdentDTOSafeSignaturesSendSignedMetadataDto} [aPIXdentDTOSafeSignaturesSendSignedMetadataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSendSignedMetadataPost(deviceToken: string, aPIXdentDTOSafeSignaturesSendSignedMetadataDto?: APIXdentDTOSafeSignaturesSendSignedMetadataDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiSafesignaturesSignSendSignedMetadataPost(deviceToken, aPIXdentDTOSafeSignaturesSendSignedMetadataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets sign metadata for sign request
         * @param {string} deviceToken 
         * @param {string} [idBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSignSignMetadataGet(deviceToken: string, idBatch?: string, options?: any): AxiosPromise<APIXdentDTOSafeSignaturesSignMetadataDto> {
            return localVarFp.apiSafesignaturesSignSignMetadataGet(deviceToken, idBatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignApi - object-oriented interface
 * @export
 * @class SignApi
 * @extends {BaseAPI}
 */
export class SignApi extends BaseAPI {
    /**
     * 
     * @summary Gets sign metadata for sign request
     * @param {string} deviceToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignApi
     */
    public apiSafesignaturesSignGetSealedPdfTestGet(deviceToken: string, options?: AxiosRequestConfig) {
        return SignApiFp(this.configuration).apiSafesignaturesSignGetSealedPdfTestGet(deviceToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accepts Definition and Model of filled form and returns regenerated pdf file.
     * @param {string} deviceToken 
     * @param {APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto} [aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignApi
     */
    public apiSafesignaturesSignSaveAndRegenerateFormPost(deviceToken: string, aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto?: APIXdentDTOSafeSignaturesSaveAndRegenerateFormDto, options?: AxiosRequestConfig) {
        return SignApiFp(this.configuration).apiSafesignaturesSignSaveAndRegenerateFormPost(deviceToken, aPIXdentDTOSafeSignaturesSaveAndRegenerateFormDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finally seals document with signature and returns it as a file for debugging.
     * @param {string} deviceToken 
     * @param {APIXdentDTOSignSafeSigSealSignedDocumentDto} [aPIXdentDTOSignSafeSigSealSignedDocumentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignApi
     */
    public apiSafesignaturesSignSealSignedDocumentGet(deviceToken: string, aPIXdentDTOSignSafeSigSealSignedDocumentDto?: APIXdentDTOSignSafeSigSealSignedDocumentDto, options?: AxiosRequestConfig) {
        return SignApiFp(this.configuration).apiSafesignaturesSignSealSignedDocumentGet(deviceToken, aPIXdentDTOSignSafeSigSealSignedDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finally seals document with signature and returns true if succeeded.
     * @param {string} deviceToken 
     * @param {APIXdentDTOSignSafeSigSealSignedDocumentDto} [aPIXdentDTOSignSafeSigSealSignedDocumentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignApi
     */
    public apiSafesignaturesSignSealSignedDocumentMockGet(deviceToken: string, aPIXdentDTOSignSafeSigSealSignedDocumentDto?: APIXdentDTOSignSafeSigSealSignedDocumentDto, options?: AxiosRequestConfig) {
        return SignApiFp(this.configuration).apiSafesignaturesSignSealSignedDocumentMockGet(deviceToken, aPIXdentDTOSignSafeSigSealSignedDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turns in signed form to be sealed and to create a form request
     * @param {string} deviceToken 
     * @param {APIXdentDTOSafeSignaturesSendSignedMetadataDto} [aPIXdentDTOSafeSignaturesSendSignedMetadataDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignApi
     */
    public apiSafesignaturesSignSendSignedMetadataPost(deviceToken: string, aPIXdentDTOSafeSignaturesSendSignedMetadataDto?: APIXdentDTOSafeSignaturesSendSignedMetadataDto, options?: AxiosRequestConfig) {
        return SignApiFp(this.configuration).apiSafesignaturesSignSendSignedMetadataPost(deviceToken, aPIXdentDTOSafeSignaturesSendSignedMetadataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets sign metadata for sign request
     * @param {string} deviceToken 
     * @param {string} [idBatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignApi
     */
    public apiSafesignaturesSignSignMetadataGet(deviceToken: string, idBatch?: string, options?: AxiosRequestConfig) {
        return SignApiFp(this.configuration).apiSafesignaturesSignSignMetadataGet(deviceToken, idBatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SmartformApi - axios parameter creator
 * @export
 */
export const SmartformApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Suggests the address.  Docs for impl version v10: https://docs.smartform.cz/smartform-api/oracleAddress/oracleAddress-v10.html#operation/oracle  Docs for all versions https://www.smartform.cz/dokumentace/smartform-api/naseptavani-adres/dokumentace-api/#
         * @param {APIXdentDTOSmartformAddressSuggestionDto} [aPIXdentDTOSmartformAddressSuggestionDto] The data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSmartformSuggestAddressPost: async (aPIXdentDTOSmartformAddressSuggestionDto?: APIXdentDTOSmartformAddressSuggestionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Smartform/SuggestAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOSmartformAddressSuggestionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmartformApi - functional programming interface
 * @export
 */
export const SmartformApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SmartformApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Suggests the address.  Docs for impl version v10: https://docs.smartform.cz/smartform-api/oracleAddress/oracleAddress-v10.html#operation/oracle  Docs for all versions https://www.smartform.cz/dokumentace/smartform-api/naseptavani-adres/dokumentace-api/#
         * @param {APIXdentDTOSmartformAddressSuggestionDto} [aPIXdentDTOSmartformAddressSuggestionDto] The data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSmartformSuggestAddressPost(aPIXdentDTOSmartformAddressSuggestionDto?: APIXdentDTOSmartformAddressSuggestionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOSmartformAddressSuggestionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSmartformSuggestAddressPost(aPIXdentDTOSmartformAddressSuggestionDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SmartformApi.apiSmartformSuggestAddressPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SmartformApi - factory interface
 * @export
 */
export const SmartformApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SmartformApiFp(configuration)
    return {
        /**
         * 
         * @summary Suggests the address.  Docs for impl version v10: https://docs.smartform.cz/smartform-api/oracleAddress/oracleAddress-v10.html#operation/oracle  Docs for all versions https://www.smartform.cz/dokumentace/smartform-api/naseptavani-adres/dokumentace-api/#
         * @param {APIXdentDTOSmartformAddressSuggestionDto} [aPIXdentDTOSmartformAddressSuggestionDto] The data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSmartformSuggestAddressPost(aPIXdentDTOSmartformAddressSuggestionDto?: APIXdentDTOSmartformAddressSuggestionDto, options?: any): AxiosPromise<APIXdentDTOSmartformAddressSuggestionResponseDto> {
            return localVarFp.apiSmartformSuggestAddressPost(aPIXdentDTOSmartformAddressSuggestionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SmartformApi - object-oriented interface
 * @export
 * @class SmartformApi
 * @extends {BaseAPI}
 */
export class SmartformApi extends BaseAPI {
    /**
     * 
     * @summary Suggests the address.  Docs for impl version v10: https://docs.smartform.cz/smartform-api/oracleAddress/oracleAddress-v10.html#operation/oracle  Docs for all versions https://www.smartform.cz/dokumentace/smartform-api/naseptavani-adres/dokumentace-api/#
     * @param {APIXdentDTOSmartformAddressSuggestionDto} [aPIXdentDTOSmartformAddressSuggestionDto] The data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartformApi
     */
    public apiSmartformSuggestAddressPost(aPIXdentDTOSmartformAddressSuggestionDto?: APIXdentDTOSmartformAddressSuggestionDto, options?: AxiosRequestConfig) {
        return SmartformApiFp(this.configuration).apiSmartformSuggestAddressPost(aPIXdentDTOSmartformAddressSuggestionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SmsApi - axios parameter creator
 * @export
 */
export const SmsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sends the SMS.
         * @param {APISharedDTOQuickSmsSendQuickSmsDto} [aPISharedDTOQuickSmsSendQuickSmsDto] The dto.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSmsSendSmsQuickPost: async (aPISharedDTOQuickSmsSendQuickSmsDto?: APISharedDTOQuickSmsSendQuickSmsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Sms/SendSmsQuick`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedDTOQuickSmsSendQuickSmsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmsApi - functional programming interface
 * @export
 */
export const SmsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SmsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sends the SMS.
         * @param {APISharedDTOQuickSmsSendQuickSmsDto} [aPISharedDTOQuickSmsSendQuickSmsDto] The dto.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSmsSendSmsQuickPost(aPISharedDTOQuickSmsSendQuickSmsDto?: APISharedDTOQuickSmsSendQuickSmsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSmsSendSmsQuickPost(aPISharedDTOQuickSmsSendQuickSmsDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SmsApi.apiSmsSendSmsQuickPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SmsApi - factory interface
 * @export
 */
export const SmsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SmsApiFp(configuration)
    return {
        /**
         * 
         * @summary Sends the SMS.
         * @param {APISharedDTOQuickSmsSendQuickSmsDto} [aPISharedDTOQuickSmsSendQuickSmsDto] The dto.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSmsSendSmsQuickPost(aPISharedDTOQuickSmsSendQuickSmsDto?: APISharedDTOQuickSmsSendQuickSmsDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiSmsSendSmsQuickPost(aPISharedDTOQuickSmsSendQuickSmsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SmsApi - object-oriented interface
 * @export
 * @class SmsApi
 * @extends {BaseAPI}
 */
export class SmsApi extends BaseAPI {
    /**
     * 
     * @summary Sends the SMS.
     * @param {APISharedDTOQuickSmsSendQuickSmsDto} [aPISharedDTOQuickSmsSendQuickSmsDto] The dto.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsApi
     */
    public apiSmsSendSmsQuickPost(aPISharedDTOQuickSmsSendQuickSmsDto?: APISharedDTOQuickSmsSendQuickSmsDto, options?: AxiosRequestConfig) {
        return SmsApiFp(this.configuration).apiSmsSendSmsQuickPost(aPISharedDTOQuickSmsSendQuickSmsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StaffApi - axios parameter creator
 * @export
 */
export const StaffApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all staff by id.
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStaffGetStaffByIdGet: async (idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Staff/GetStaffById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all staffs for location
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStaffGetStaffByLocationGet: async (idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Staff/GetStaffByLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all staffs for user (company)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStaffGetStaffByUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Staff/GetStaffByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StaffApi - functional programming interface
 * @export
 */
export const StaffApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StaffApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all staff by id.
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStaffGetStaffByIdGet(idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStaffGetStaffByIdGet(idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StaffApi.apiStaffGetStaffByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all staffs for location
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStaffGetStaffByLocationGet(idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStaffGetStaffByLocationGet(idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StaffApi.apiStaffGetStaffByLocationGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all staffs for user (company)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStaffGetStaffByUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStaffGetStaffByUserGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StaffApi.apiStaffGetStaffByUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * StaffApi - factory interface
 * @export
 */
export const StaffApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StaffApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all staff by id.
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStaffGetStaffByIdGet(idStaff?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult> {
            return localVarFp.apiStaffGetStaffByIdGet(idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all staffs for location
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStaffGetStaffByLocationGet(idLocation?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult>> {
            return localVarFp.apiStaffGetStaffByLocationGet(idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all staffs for user (company)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStaffGetStaffByUserGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERSTAFFTREEResult>> {
            return localVarFp.apiStaffGetStaffByUserGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StaffApi - object-oriented interface
 * @export
 * @class StaffApi
 * @extends {BaseAPI}
 */
export class StaffApi extends BaseAPI {
    /**
     * 
     * @summary Gets all staff by id.
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public apiStaffGetStaffByIdGet(idStaff?: string, options?: AxiosRequestConfig) {
        return StaffApiFp(this.configuration).apiStaffGetStaffByIdGet(idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all staffs for location
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public apiStaffGetStaffByLocationGet(idLocation?: string, options?: AxiosRequestConfig) {
        return StaffApiFp(this.configuration).apiStaffGetStaffByLocationGet(idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all staffs for user (company)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public apiStaffGetStaffByUserGet(options?: AxiosRequestConfig) {
        return StaffApiFp(this.configuration).apiStaffGetStaffByUserGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoreQuantityApi - axios parameter creator
 * @export
 */
export const StoreQuantityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoiceCode] 
         * @param {string} [idStoreLocation] 
         * @param {string} [filter] 
         * @param {boolean} [includePostExpiry] 
         * @param {boolean} [includeSubStores] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreQuantitySearchStoreItemLotExpGet: async (idInvoiceCode?: string, idStoreLocation?: string, filter?: string, includePostExpiry?: boolean, includeSubStores?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreQuantity/SearchStoreItemLotExp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idInvoiceCode !== undefined) {
                localVarQueryParameter['idInvoiceCode'] = idInvoiceCode;
            }

            if (idStoreLocation !== undefined) {
                localVarQueryParameter['idStoreLocation'] = idStoreLocation;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (includePostExpiry !== undefined) {
                localVarQueryParameter['includePostExpiry'] = includePostExpiry;
            }

            if (includeSubStores !== undefined) {
                localVarQueryParameter['includeSubStores'] = includeSubStores;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreQuantityApi - functional programming interface
 * @export
 */
export const StoreQuantityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreQuantityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoiceCode] 
         * @param {string} [idStoreLocation] 
         * @param {string} [filter] 
         * @param {boolean} [includePostExpiry] 
         * @param {boolean} [includeSubStores] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreQuantitySearchStoreItemLotExpGet(idInvoiceCode?: string, idStoreLocation?: string, filter?: string, includePostExpiry?: boolean, includeSubStores?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTOREITEMLOTEXPSEARCHResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStoreQuantitySearchStoreItemLotExpGet(idInvoiceCode, idStoreLocation, filter, includePostExpiry, includeSubStores, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StoreQuantityApi.apiStoreQuantitySearchStoreItemLotExpGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * StoreQuantityApi - factory interface
 * @export
 */
export const StoreQuantityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreQuantityApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoiceCode] 
         * @param {string} [idStoreLocation] 
         * @param {string} [filter] 
         * @param {boolean} [includePostExpiry] 
         * @param {boolean} [includeSubStores] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreQuantitySearchStoreItemLotExpGet(idInvoiceCode?: string, idStoreLocation?: string, filter?: string, includePostExpiry?: boolean, includeSubStores?: boolean, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedSTOREITEMLOTEXPSEARCHResult>> {
            return localVarFp.apiStoreQuantitySearchStoreItemLotExpGet(idInvoiceCode, idStoreLocation, filter, includePostExpiry, includeSubStores, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreQuantityApi - object-oriented interface
 * @export
 * @class StoreQuantityApi
 * @extends {BaseAPI}
 */
export class StoreQuantityApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idInvoiceCode] 
     * @param {string} [idStoreLocation] 
     * @param {string} [filter] 
     * @param {boolean} [includePostExpiry] 
     * @param {boolean} [includeSubStores] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreQuantityApi
     */
    public apiStoreQuantitySearchStoreItemLotExpGet(idInvoiceCode?: string, idStoreLocation?: string, filter?: string, includePostExpiry?: boolean, includeSubStores?: boolean, options?: AxiosRequestConfig) {
        return StoreQuantityApiFp(this.configuration).apiStoreQuantitySearchStoreItemLotExpGet(idInvoiceCode, idStoreLocation, filter, includePostExpiry, includeSubStores, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SuklApi - axios parameter creator
 * @export
 */
export const SuklApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get MedicamentsAndSubstances
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSuklGetMedicamentsAndSubstancesGet: async (deviceToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesSuklGetMedicamentsAndSubstancesGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/sukl/GetMedicamentsAndSubstances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get MedicamentsAndSubstances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuklGetMedicamentsAndSubstancesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Sukl/GetMedicamentsAndSubstances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuklApi - functional programming interface
 * @export
 */
export const SuklApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuklApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get MedicamentsAndSubstances
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesSuklGetMedicamentsAndSubstancesGet(deviceToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedSuklMedicamentsAndSubstancesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesSuklGetMedicamentsAndSubstancesGet(deviceToken, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SuklApi.apiSafesignaturesSuklGetMedicamentsAndSubstancesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get MedicamentsAndSubstances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuklGetMedicamentsAndSubstancesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuklGetMedicamentsAndSubstancesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SuklApi.apiSuklGetMedicamentsAndSubstancesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SuklApi - factory interface
 * @export
 */
export const SuklApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuklApiFp(configuration)
    return {
        /**
         * 
         * @summary Get MedicamentsAndSubstances
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesSuklGetMedicamentsAndSubstancesGet(deviceToken: string, options?: any): AxiosPromise<APISharedSuklMedicamentsAndSubstancesDto> {
            return localVarFp.apiSafesignaturesSuklGetMedicamentsAndSubstancesGet(deviceToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get MedicamentsAndSubstances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuklGetMedicamentsAndSubstancesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiSuklGetMedicamentsAndSubstancesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuklApi - object-oriented interface
 * @export
 * @class SuklApi
 * @extends {BaseAPI}
 */
export class SuklApi extends BaseAPI {
    /**
     * 
     * @summary Get MedicamentsAndSubstances
     * @param {string} deviceToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuklApi
     */
    public apiSafesignaturesSuklGetMedicamentsAndSubstancesGet(deviceToken: string, options?: AxiosRequestConfig) {
        return SuklApiFp(this.configuration).apiSafesignaturesSuklGetMedicamentsAndSubstancesGet(deviceToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get MedicamentsAndSubstances
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuklApi
     */
    public apiSuklGetMedicamentsAndSubstancesGet(options?: AxiosRequestConfig) {
        return SuklApiFp(this.configuration).apiSuklGetMedicamentsAndSubstancesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TagApi - axios parameter creator
 * @export
 */
export const TagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds new tag (company), and sets it to client.
         * @param {APISharedAddClientRelationCustomTagDto} [aPISharedAddClientRelationCustomTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagAddClientCustomTagPost: async (aPISharedAddClientRelationCustomTagDto?: APISharedAddClientRelationCustomTagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Tag/AddClientCustomTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedAddClientRelationCustomTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds tag to user (company)
         * @param {ApiTagAddCustomTagPostRequest} [apiTagAddCustomTagPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagAddCustomTagPost: async (apiTagAddCustomTagPostRequest?: ApiTagAddCustomTagPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Tag/AddCustomTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTagAddCustomTagPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes tag from client by it\'s global(relation) id.
         * @param {string} [idClient] 
         * @param {string} [idCustomTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagDeleteClientTagDelete: async (idClient?: string, idCustomTag?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Tag/DeleteClientTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (idCustomTag !== undefined) {
                localVarQueryParameter['idCustomTag'] = idCustomTag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes tag from logged user company by it\'s id.
         * @param {string} [idCustomTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagDeleteUserTagDelete: async (idCustomTag?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Tag/DeleteUserTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idCustomTag !== undefined) {
                localVarQueryParameter['idCustomTag'] = idCustomTag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all active tags for client
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagGetTagsByClientGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Tag/GetTagsByClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all valid tags for user (company)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagGetTagsByUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Tag/GetTagsByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagApi - functional programming interface
 * @export
 */
export const TagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Adds new tag (company), and sets it to client.
         * @param {APISharedAddClientRelationCustomTagDto} [aPISharedAddClientRelationCustomTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagAddClientCustomTagPost(aPISharedAddClientRelationCustomTagDto?: APISharedAddClientRelationCustomTagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTagAddClientCustomTagPost(aPISharedAddClientRelationCustomTagDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagApi.apiTagAddClientCustomTagPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adds tag to user (company)
         * @param {ApiTagAddCustomTagPostRequest} [apiTagAddCustomTagPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagAddCustomTagPost(apiTagAddCustomTagPostRequest?: ApiTagAddCustomTagPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTagAddCustomTagPost(apiTagAddCustomTagPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagApi.apiTagAddCustomTagPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes tag from client by it\'s global(relation) id.
         * @param {string} [idClient] 
         * @param {string} [idCustomTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagDeleteClientTagDelete(idClient?: string, idCustomTag?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTagDeleteClientTagDelete(idClient, idCustomTag, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagApi.apiTagDeleteClientTagDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes tag from logged user company by it\'s id.
         * @param {string} [idCustomTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagDeleteUserTagDelete(idCustomTag?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTagDeleteUserTagDelete(idCustomTag, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagApi.apiTagDeleteUserTagDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all active tags for client
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagGetTagsByClientGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTagGetTagsByClientGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagApi.apiTagGetTagsByClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all valid tags for user (company)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagGetTagsByUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTagGetTagsByUserGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagApi.apiTagGetTagsByUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TagApi - factory interface
 * @export
 */
export const TagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagApiFp(configuration)
    return {
        /**
         * 
         * @summary Adds new tag (company), and sets it to client.
         * @param {APISharedAddClientRelationCustomTagDto} [aPISharedAddClientRelationCustomTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagAddClientCustomTagPost(aPISharedAddClientRelationCustomTagDto?: APISharedAddClientRelationCustomTagDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiTagAddClientCustomTagPost(aPISharedAddClientRelationCustomTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds tag to user (company)
         * @param {ApiTagAddCustomTagPostRequest} [apiTagAddCustomTagPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagAddCustomTagPost(apiTagAddCustomTagPostRequest?: ApiTagAddCustomTagPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiTagAddCustomTagPost(apiTagAddCustomTagPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes tag from client by it\'s global(relation) id.
         * @param {string} [idClient] 
         * @param {string} [idCustomTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagDeleteClientTagDelete(idClient?: string, idCustomTag?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiTagDeleteClientTagDelete(idClient, idCustomTag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes tag from logged user company by it\'s id.
         * @param {string} [idCustomTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagDeleteUserTagDelete(idCustomTag?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiTagDeleteUserTagDelete(idCustomTag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all active tags for client
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagGetTagsByClientGet(idClient?: string, options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedCUSTOMTAGFORMResult>> {
            return localVarFp.apiTagGetTagsByClientGet(idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all valid tags for user (company)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagGetTagsByUserGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiTagGetTagsByUserGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TagApi - object-oriented interface
 * @export
 * @class TagApi
 * @extends {BaseAPI}
 */
export class TagApi extends BaseAPI {
    /**
     * 
     * @summary Adds new tag (company), and sets it to client.
     * @param {APISharedAddClientRelationCustomTagDto} [aPISharedAddClientRelationCustomTagDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public apiTagAddClientCustomTagPost(aPISharedAddClientRelationCustomTagDto?: APISharedAddClientRelationCustomTagDto, options?: AxiosRequestConfig) {
        return TagApiFp(this.configuration).apiTagAddClientCustomTagPost(aPISharedAddClientRelationCustomTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds tag to user (company)
     * @param {ApiTagAddCustomTagPostRequest} [apiTagAddCustomTagPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public apiTagAddCustomTagPost(apiTagAddCustomTagPostRequest?: ApiTagAddCustomTagPostRequest, options?: AxiosRequestConfig) {
        return TagApiFp(this.configuration).apiTagAddCustomTagPost(apiTagAddCustomTagPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes tag from client by it\'s global(relation) id.
     * @param {string} [idClient] 
     * @param {string} [idCustomTag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public apiTagDeleteClientTagDelete(idClient?: string, idCustomTag?: string, options?: AxiosRequestConfig) {
        return TagApiFp(this.configuration).apiTagDeleteClientTagDelete(idClient, idCustomTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes tag from logged user company by it\'s id.
     * @param {string} [idCustomTag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public apiTagDeleteUserTagDelete(idCustomTag?: string, options?: AxiosRequestConfig) {
        return TagApiFp(this.configuration).apiTagDeleteUserTagDelete(idCustomTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all active tags for client
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public apiTagGetTagsByClientGet(idClient?: string, options?: AxiosRequestConfig) {
        return TagApiFp(this.configuration).apiTagGetTagsByClientGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all valid tags for user (company)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public apiTagGetTagsByUserGet(options?: AxiosRequestConfig) {
        return TagApiFp(this.configuration).apiTagGetTagsByUserGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaskApi - axios parameter creator
 * @export
 */
export const TaskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sets xdent task status
         * @param {APIXdentDTOTaskChangeStatusDto} [aPIXdentDTOTaskChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskChangeStatusPut: async (aPIXdentDTOTaskChangeStatusDto?: APIXdentDTOTaskChangeStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Task/ChangeStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOTaskChangeStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates comment message associated with xdent task
         * @param {APIXdentDTOTaskCommentDto} [aPIXdentDTOTaskCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskCommentMessagePost: async (aPIXdentDTOTaskCommentDto?: APIXdentDTOTaskCommentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Task/CommentMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOTaskCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new xdent task
         * @param {APIXdentDTOTaskCreateTaskDto} [aPIXdentDTOTaskCreateTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskCreatePost: async (aPIXdentDTOTaskCreateTaskDto?: APIXdentDTOTaskCreateTaskDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Task/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOTaskCreateTaskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes xdent task
         * @param {string} [idTask] 
         * @param {string} [idBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskDeleteDelete: async (idTask?: string, idBatch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Task/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idTask !== undefined) {
                localVarQueryParameter['idTask'] = idTask;
            }

            if (idBatch !== undefined) {
                localVarQueryParameter['idBatch'] = idBatch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits xdent task
         * @param {APIXdentDTOTaskEditTaskDto} [aPIXdentDTOTaskEditTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskEditPut: async (aPIXdentDTOTaskEditTaskDto?: APIXdentDTOTaskEditTaskDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Task/Edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOTaskEditTaskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets comments/messages for specified task
         * @param {string} [idTaskBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskTaskMessagesGet: async (idTaskBatch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Task/TaskMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idTaskBatch !== undefined) {
                localVarQueryParameter['idTaskBatch'] = idTaskBatch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskApi - functional programming interface
 * @export
 */
export const TaskApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sets xdent task status
         * @param {APIXdentDTOTaskChangeStatusDto} [aPIXdentDTOTaskChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskChangeStatusPut(aPIXdentDTOTaskChangeStatusDto?: APIXdentDTOTaskChangeStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskChangeStatusPut(aPIXdentDTOTaskChangeStatusDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TaskApi.apiTaskChangeStatusPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates comment message associated with xdent task
         * @param {APIXdentDTOTaskCommentDto} [aPIXdentDTOTaskCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskCommentMessagePost(aPIXdentDTOTaskCommentDto?: APIXdentDTOTaskCommentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskCommentMessagePost(aPIXdentDTOTaskCommentDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TaskApi.apiTaskCommentMessagePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Creates new xdent task
         * @param {APIXdentDTOTaskCreateTaskDto} [aPIXdentDTOTaskCreateTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskCreatePost(aPIXdentDTOTaskCreateTaskDto?: APIXdentDTOTaskCreateTaskDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskCreatePost(aPIXdentDTOTaskCreateTaskDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TaskApi.apiTaskCreatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes xdent task
         * @param {string} [idTask] 
         * @param {string} [idBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskDeleteDelete(idTask?: string, idBatch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskDeleteDelete(idTask, idBatch, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TaskApi.apiTaskDeleteDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edits xdent task
         * @param {APIXdentDTOTaskEditTaskDto} [aPIXdentDTOTaskEditTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskEditPut(aPIXdentDTOTaskEditTaskDto?: APIXdentDTOTaskEditTaskDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskEditPut(aPIXdentDTOTaskEditTaskDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TaskApi.apiTaskEditPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets comments/messages for specified task
         * @param {string} [idTaskBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskTaskMessagesGet(idTaskBatch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskTaskMessagesGet(idTaskBatch, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TaskApi.apiTaskTaskMessagesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TaskApi - factory interface
 * @export
 */
export const TaskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskApiFp(configuration)
    return {
        /**
         * 
         * @summary Sets xdent task status
         * @param {APIXdentDTOTaskChangeStatusDto} [aPIXdentDTOTaskChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskChangeStatusPut(aPIXdentDTOTaskChangeStatusDto?: APIXdentDTOTaskChangeStatusDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiTaskChangeStatusPut(aPIXdentDTOTaskChangeStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates comment message associated with xdent task
         * @param {APIXdentDTOTaskCommentDto} [aPIXdentDTOTaskCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskCommentMessagePost(aPIXdentDTOTaskCommentDto?: APIXdentDTOTaskCommentDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiTaskCommentMessagePost(aPIXdentDTOTaskCommentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new xdent task
         * @param {APIXdentDTOTaskCreateTaskDto} [aPIXdentDTOTaskCreateTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskCreatePost(aPIXdentDTOTaskCreateTaskDto?: APIXdentDTOTaskCreateTaskDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiTaskCreatePost(aPIXdentDTOTaskCreateTaskDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes xdent task
         * @param {string} [idTask] 
         * @param {string} [idBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskDeleteDelete(idTask?: string, idBatch?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiTaskDeleteDelete(idTask, idBatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edits xdent task
         * @param {APIXdentDTOTaskEditTaskDto} [aPIXdentDTOTaskEditTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskEditPut(aPIXdentDTOTaskEditTaskDto?: APIXdentDTOTaskEditTaskDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiTaskEditPut(aPIXdentDTOTaskEditTaskDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets comments/messages for specified task
         * @param {string} [idTaskBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskTaskMessagesGet(idTaskBatch?: string, options?: any): AxiosPromise<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedTASKMESSAGEGRIDResult> {
            return localVarFp.apiTaskTaskMessagesGet(idTaskBatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskApi - object-oriented interface
 * @export
 * @class TaskApi
 * @extends {BaseAPI}
 */
export class TaskApi extends BaseAPI {
    /**
     * 
     * @summary Sets xdent task status
     * @param {APIXdentDTOTaskChangeStatusDto} [aPIXdentDTOTaskChangeStatusDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    public apiTaskChangeStatusPut(aPIXdentDTOTaskChangeStatusDto?: APIXdentDTOTaskChangeStatusDto, options?: AxiosRequestConfig) {
        return TaskApiFp(this.configuration).apiTaskChangeStatusPut(aPIXdentDTOTaskChangeStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates comment message associated with xdent task
     * @param {APIXdentDTOTaskCommentDto} [aPIXdentDTOTaskCommentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    public apiTaskCommentMessagePost(aPIXdentDTOTaskCommentDto?: APIXdentDTOTaskCommentDto, options?: AxiosRequestConfig) {
        return TaskApiFp(this.configuration).apiTaskCommentMessagePost(aPIXdentDTOTaskCommentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new xdent task
     * @param {APIXdentDTOTaskCreateTaskDto} [aPIXdentDTOTaskCreateTaskDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    public apiTaskCreatePost(aPIXdentDTOTaskCreateTaskDto?: APIXdentDTOTaskCreateTaskDto, options?: AxiosRequestConfig) {
        return TaskApiFp(this.configuration).apiTaskCreatePost(aPIXdentDTOTaskCreateTaskDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes xdent task
     * @param {string} [idTask] 
     * @param {string} [idBatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    public apiTaskDeleteDelete(idTask?: string, idBatch?: string, options?: AxiosRequestConfig) {
        return TaskApiFp(this.configuration).apiTaskDeleteDelete(idTask, idBatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edits xdent task
     * @param {APIXdentDTOTaskEditTaskDto} [aPIXdentDTOTaskEditTaskDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    public apiTaskEditPut(aPIXdentDTOTaskEditTaskDto?: APIXdentDTOTaskEditTaskDto, options?: AxiosRequestConfig) {
        return TaskApiFp(this.configuration).apiTaskEditPut(aPIXdentDTOTaskEditTaskDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets comments/messages for specified task
     * @param {string} [idTaskBatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    public apiTaskTaskMessagesGet(idTaskBatch?: string, options?: AxiosRequestConfig) {
        return TaskApiFp(this.configuration).apiTaskTaskMessagesGet(idTaskBatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestApi - axios parameter creator
 * @export
 */
export const TestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Test if device is paired. Should return 500 if not paired with global ErrorDto
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesTestTestPairedDeviceGet: async (deviceToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesTestTestPairedDeviceGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/test/TestPairedDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestAnalyzeB2BSetupCertificatesValidityPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/AnalyzeB2BSetupCertificatesValidity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestAnalyzeB2BVzpResponsesPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/AnalyzeB2BVzpResponses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestGetEnumTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/GetEnumTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTemplatesWithUnicodePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TemplatesWithUnicode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test certificate validity
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestCertificateValidityGet: async (idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestCertificateValidity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestDnsUrlParserGet: async (url?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestDnsUrlParser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestIpGetGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestIpGet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestKeylessTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestKeylessTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestMultipleFlurlHeadersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestMultipleFlurlHeaders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [compressImages] 
         * @param {number} [imageQuality] 
         * @param {boolean} [optimizeFont] 
         * @param {boolean} [removeMetadata] 
         * @param {boolean} [optimizePageContents] 
         * @param {File} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestPdfCompressionPost: async (compressImages?: boolean, imageQuality?: number, optimizeFont?: boolean, removeMetadata?: boolean, optimizePageContents?: boolean, model?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestPdfCompression`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (compressImages != null) {
                localVarHeaderParameter['compressImages'] = typeof compressImages === 'string'
                    ? compressImages
                    : JSON.stringify(compressImages);
            }

            if (imageQuality != null) {
                localVarHeaderParameter['imageQuality'] = typeof imageQuality === 'string'
                    ? imageQuality
                    : JSON.stringify(imageQuality);
            }

            if (optimizeFont != null) {
                localVarHeaderParameter['optimizeFont'] = typeof optimizeFont === 'string'
                    ? optimizeFont
                    : JSON.stringify(optimizeFont);
            }

            if (removeMetadata != null) {
                localVarHeaderParameter['removeMetadata'] = typeof removeMetadata === 'string'
                    ? removeMetadata
                    : JSON.stringify(removeMetadata);
            }

            if (optimizePageContents != null) {
                localVarHeaderParameter['optimizePageContents'] = typeof optimizePageContents === 'string'
                    ? optimizePageContents
                    : JSON.stringify(optimizePageContents);
            }


            if (model !== undefined) { 
                localVarFormParams.append('model', model as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestSMSGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestSMS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestSmsSendTempPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestSmsSendTemp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [timeoutSec] 
         * @param {number} [actionTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestTaskTimeoutGet: async (timeoutSec?: number, actionTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Test/TestTaskTimeout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timeoutSec !== undefined) {
                localVarQueryParameter['timeoutSec'] = timeoutSec;
            }

            if (actionTime !== undefined) {
                localVarQueryParameter['actionTime'] = actionTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestApi - functional programming interface
 * @export
 */
export const TestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Test if device is paired. Should return 500 if not paired with global ErrorDto
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesTestTestPairedDeviceGet(deviceToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesTestTestPairedDeviceGet(deviceToken, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiSafesignaturesTestTestPairedDeviceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestAnalyzeB2BSetupCertificatesValidityPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestAnalyzeB2BSetupCertificatesValidityPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestAnalyzeB2BSetupCertificatesValidityPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestAnalyzeB2BVzpResponsesPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestAnalyzeB2BVzpResponsesPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestAnalyzeB2BVzpResponsesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestGetEnumTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestGetEnumTypesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestGetEnumTypesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTemplatesWithUnicodePost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTemplatesWithUnicodePost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTemplatesWithUnicodePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Test certificate validity
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestCertificateValidityGet(idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestCertificateValidityGet(idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestCertificateValidityGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestDnsUrlParserGet(url?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestDnsUrlParserGet(url, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestDnsUrlParserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestIpGetGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestIpGetGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestIpGetGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestKeylessTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestKeylessTypesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestKeylessTypesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestMultipleFlurlHeadersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestMultipleFlurlHeadersGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestMultipleFlurlHeadersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [compressImages] 
         * @param {number} [imageQuality] 
         * @param {boolean} [optimizeFont] 
         * @param {boolean} [removeMetadata] 
         * @param {boolean} [optimizePageContents] 
         * @param {File} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestPdfCompressionPost(compressImages?: boolean, imageQuality?: number, optimizeFont?: boolean, removeMetadata?: boolean, optimizePageContents?: boolean, model?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestPdfCompressionPost(compressImages, imageQuality, optimizeFont, removeMetadata, optimizePageContents, model, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestPdfCompressionPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestSMSGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestSMSGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestSMSGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestSmsSendTempPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestSmsSendTempPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestSmsSendTempPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {number} [timeoutSec] 
         * @param {number} [actionTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestTestTaskTimeoutGet(timeoutSec?: number, actionTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestTestTaskTimeoutGet(timeoutSec, actionTime, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestApi.apiTestTestTaskTimeoutGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TestApi - factory interface
 * @export
 */
export const TestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestApiFp(configuration)
    return {
        /**
         * 
         * @summary Test if device is paired. Should return 500 if not paired with global ErrorDto
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesTestTestPairedDeviceGet(deviceToken: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiSafesignaturesTestTestPairedDeviceGet(deviceToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestAnalyzeB2BSetupCertificatesValidityPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestAnalyzeB2BSetupCertificatesValidityPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestAnalyzeB2BVzpResponsesPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestAnalyzeB2BVzpResponsesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestGetEnumTypesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestGetEnumTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTemplatesWithUnicodePost(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTemplatesWithUnicodePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test certificate validity
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestCertificateValidityGet(idLocation?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestCertificateValidityGet(idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestDnsUrlParserGet(url?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestDnsUrlParserGet(url, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestIpGetGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestIpGetGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestKeylessTypesGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestKeylessTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestMultipleFlurlHeadersGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestMultipleFlurlHeadersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [compressImages] 
         * @param {number} [imageQuality] 
         * @param {boolean} [optimizeFont] 
         * @param {boolean} [removeMetadata] 
         * @param {boolean} [optimizePageContents] 
         * @param {File} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestPdfCompressionPost(compressImages?: boolean, imageQuality?: number, optimizeFont?: boolean, removeMetadata?: boolean, optimizePageContents?: boolean, model?: File, options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestPdfCompressionPost(compressImages, imageQuality, optimizeFont, removeMetadata, optimizePageContents, model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestSMSGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestSMSGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestSmsSendTempPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestSmsSendTempPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [timeoutSec] 
         * @param {number} [actionTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestTestTaskTimeoutGet(timeoutSec?: number, actionTime?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiTestTestTaskTimeoutGet(timeoutSec, actionTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestApi - object-oriented interface
 * @export
 * @class TestApi
 * @extends {BaseAPI}
 */
export class TestApi extends BaseAPI {
    /**
     * 
     * @summary Test if device is paired. Should return 500 if not paired with global ErrorDto
     * @param {string} deviceToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiSafesignaturesTestTestPairedDeviceGet(deviceToken: string, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiSafesignaturesTestTestPairedDeviceGet(deviceToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestAnalyzeB2BSetupCertificatesValidityPost(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestAnalyzeB2BSetupCertificatesValidityPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestAnalyzeB2BVzpResponsesPost(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestAnalyzeB2BVzpResponsesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestGetEnumTypesGet(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestGetEnumTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTemplatesWithUnicodePost(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTemplatesWithUnicodePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test certificate validity
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestCertificateValidityGet(idLocation?: string, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestCertificateValidityGet(idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [url] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestDnsUrlParserGet(url?: string, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestDnsUrlParserGet(url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestIpGetGet(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestIpGetGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestKeylessTypesGet(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestKeylessTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestMultipleFlurlHeadersGet(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestMultipleFlurlHeadersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [compressImages] 
     * @param {number} [imageQuality] 
     * @param {boolean} [optimizeFont] 
     * @param {boolean} [removeMetadata] 
     * @param {boolean} [optimizePageContents] 
     * @param {File} [model] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestPdfCompressionPost(compressImages?: boolean, imageQuality?: number, optimizeFont?: boolean, removeMetadata?: boolean, optimizePageContents?: boolean, model?: File, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestPdfCompressionPost(compressImages, imageQuality, optimizeFont, removeMetadata, optimizePageContents, model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestSMSGet(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestSMSGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestSmsSendTempPost(options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestSmsSendTempPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [timeoutSec] 
     * @param {number} [actionTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public apiTestTestTaskTimeoutGet(timeoutSec?: number, actionTime?: number, options?: AxiosRequestConfig) {
        return TestApiFp(this.configuration).apiTestTestTaskTimeoutGet(timeoutSec, actionTime, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestGeneratedContextApi - axios parameter creator
 * @export
 */
export const TestGeneratedContextApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestGeneratedContextTestPrimaryKeysPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/TestGeneratedContext/TestPrimaryKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestGeneratedContextApi - functional programming interface
 * @export
 */
export const TestGeneratedContextApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestGeneratedContextApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestGeneratedContextTestPrimaryKeysPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestGeneratedContextTestPrimaryKeysPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TestGeneratedContextApi.apiTestGeneratedContextTestPrimaryKeysPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TestGeneratedContextApi - factory interface
 * @export
 */
export const TestGeneratedContextApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestGeneratedContextApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestGeneratedContextTestPrimaryKeysPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiTestGeneratedContextTestPrimaryKeysPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestGeneratedContextApi - object-oriented interface
 * @export
 * @class TestGeneratedContextApi
 * @extends {BaseAPI}
 */
export class TestGeneratedContextApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestGeneratedContextApi
     */
    public apiTestGeneratedContextTestPrimaryKeysPost(options?: AxiosRequestConfig) {
        return TestGeneratedContextApiFp(this.configuration).apiTestGeneratedContextTestPrimaryKeysPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user info
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesUserUserInfoGet: async (deviceToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesignaturesUserUserInfoGet', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesignatures/user/UserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAuthByCredentialsPost: async (apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/AuthByCredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiSafesignaturesAuthPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model, for 30 sec.
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAuthByCredentialsTestPost: async (apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/AuthByCredentialsTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiSafesignaturesAuthPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserExtendBearerTokenPost: async (aPISharedExtendBearerDto?: APISharedExtendBearerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/ExtendBearerToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedExtendBearerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGetUserInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/GetUserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user info
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGetUserInfoX3Get: async (controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/GetUserInfoX3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (controller !== undefined) {
                localVarQueryParameter['controller'] = controller;
            }

            if (cacheContext !== undefined) {
                localVarQueryParameter['cacheContext'] = cacheContext;
            }

            if (invoker !== undefined) {
                localVarQueryParameter['invoker'] = invoker;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }

            if (idGlobal !== undefined) {
                localVarQueryParameter['idGlobal'] = idGlobal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all user-groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UserGroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logouts this instance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserLogoutPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserNotTestAuthExceptionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/NotTestAuthExceptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Tests auth exceptions
         * @param {ApiUserTestAuthExceptionsGetTestTypeEnum} [testType] 0 &#x3D; MembershipNotFound, 1 &#x3D; WrongCredentials, 2 &#x3D; SubscriptionExpired, 3 &#x3D; InvalidRefreshToken, 4 &#x3D; EmptyCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserTestAuthExceptionsGet: async (testType?: ApiUserTestAuthExceptionsGetTestTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/TestAuthExceptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (testType !== undefined) {
                localVarQueryParameter['testType'] = testType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user info
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesUserUserInfoGet(deviceToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOUserGlobalXdentConfigurationWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesUserUserInfoGet(deviceToken, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiSafesignaturesUserUserInfoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAuthByCredentialsPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAuthByCredentialsPost(apiSafesignaturesAuthPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserAuthByCredentialsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model, for 30 sec.
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAuthByCredentialsTestPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAuthByCredentialsTestPost(apiSafesignaturesAuthPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserAuthByCredentialsTestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserExtendBearerTokenPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserExtendBearerTokenPost(aPISharedExtendBearerDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserExtendBearerTokenPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGetUserInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedGlobalXdentConfigurationWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGetUserInfoGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserGetUserInfoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get user info
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGetUserInfoX3Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedGlobalXdentConfigurationWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGetUserInfoX3Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserGetUserInfoX3Get']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get all user-groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGroupGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERGROUPGRIDResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGroupGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserGroupGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Logouts this instance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserLogoutPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserLogoutPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserLogoutPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserNotTestAuthExceptionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserNotTestAuthExceptionsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserNotTestAuthExceptionsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Tests auth exceptions
         * @param {ApiUserTestAuthExceptionsGetTestTypeEnum} [testType] 0 &#x3D; MembershipNotFound, 1 &#x3D; WrongCredentials, 2 &#x3D; SubscriptionExpired, 3 &#x3D; InvalidRefreshToken, 4 &#x3D; EmptyCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserTestAuthExceptionsGet(testType?: ApiUserTestAuthExceptionsGetTestTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserTestAuthExceptionsGet(testType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.apiUserTestAuthExceptionsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user info
         * @param {string} deviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesUserUserInfoGet(deviceToken: string, options?: any): AxiosPromise<APIXdentDTOUserGlobalXdentConfigurationWrapperDto> {
            return localVarFp.apiSafesignaturesUserUserInfoGet(deviceToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAuthByCredentialsPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiUserAuthByCredentialsPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticates user by login credentials via post model, for 30 sec.
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAuthByCredentialsTestPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiUserAuthByCredentialsTestPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserExtendBearerTokenPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiUserExtendBearerTokenPost(aPISharedExtendBearerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGetUserInfoGet(options?: any): AxiosPromise<APISharedGlobalXdentConfigurationWrapperDto> {
            return localVarFp.apiUserGetUserInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user info
         * @param {string} [controller] 
         * @param {string} [cacheContext] 
         * @param {string} [invoker] 
         * @param {string} [key] 
         * @param {string} [transactionId] 
         * @param {number} [expiration] 
         * @param {string} [idGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGetUserInfoX3Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: any): AxiosPromise<APISharedGlobalXdentConfigurationWrapperDto> {
            return localVarFp.apiUserGetUserInfoX3Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all user-groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupGet(options?: any): AxiosPromise<Array<APIGeneratedContextsXdentXdentDbProceduresContextGeneratedUSERGROUPGRIDResult>> {
            return localVarFp.apiUserGroupGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logouts this instance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserLogoutPost(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiUserLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserNotTestAuthExceptionsGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiUserNotTestAuthExceptionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tests auth exceptions
         * @param {ApiUserTestAuthExceptionsGetTestTypeEnum} [testType] 0 &#x3D; MembershipNotFound, 1 &#x3D; WrongCredentials, 2 &#x3D; SubscriptionExpired, 3 &#x3D; InvalidRefreshToken, 4 &#x3D; EmptyCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserTestAuthExceptionsGet(testType?: ApiUserTestAuthExceptionsGetTestTypeEnum, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiUserTestAuthExceptionsGet(testType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Get user info
     * @param {string} deviceToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiSafesignaturesUserUserInfoGet(deviceToken: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiSafesignaturesUserUserInfoGet(deviceToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticates user by login credentials via post model
     * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserAuthByCredentialsPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserAuthByCredentialsPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticates user by login credentials via post model, for 30 sec.
     * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserAuthByCredentialsTestPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserAuthByCredentialsTestPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extends bearer token with provided refresh and old bearer
     * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserExtendBearerTokenPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserExtendBearerTokenPost(aPISharedExtendBearerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserGetUserInfoGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserGetUserInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user info
     * @param {string} [controller] 
     * @param {string} [cacheContext] 
     * @param {string} [invoker] 
     * @param {string} [key] 
     * @param {string} [transactionId] 
     * @param {number} [expiration] 
     * @param {string} [idGlobal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserGetUserInfoX3Get(controller?: string, cacheContext?: string, invoker?: string, key?: string, transactionId?: string, expiration?: number, idGlobal?: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserGetUserInfoX3Get(controller, cacheContext, invoker, key, transactionId, expiration, idGlobal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all user-groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserGroupGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserGroupGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logouts this instance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserLogoutPost(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserNotTestAuthExceptionsGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserNotTestAuthExceptionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Tests auth exceptions
     * @param {ApiUserTestAuthExceptionsGetTestTypeEnum} [testType] 0 &#x3D; MembershipNotFound, 1 &#x3D; WrongCredentials, 2 &#x3D; SubscriptionExpired, 3 &#x3D; InvalidRefreshToken, 4 &#x3D; EmptyCredentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserTestAuthExceptionsGet(testType?: ApiUserTestAuthExceptionsGetTestTypeEnum, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserTestAuthExceptionsGet(testType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiUserTestAuthExceptionsGetTestTypeEnum = {
    MembershipNotFound: 'MembershipNotFound',
    WrongCredentials: 'WrongCredentials',
    SubscriptionExpired: 'SubscriptionExpired',
    InvalidRefreshToken: 'InvalidRefreshToken',
    EmptyCredentials: 'EmptyCredentials'
} as const;
export type ApiUserTestAuthExceptionsGetTestTypeEnum = typeof ApiUserTestAuthExceptionsGetTestTypeEnum[keyof typeof ApiUserTestAuthExceptionsGetTestTypeEnum];


/**
 * ValidationApi - axios parameter creator
 * @export
 */
export const ValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Checks if the phone number is valid. Prefix has to be included. + is optional.
         * @param {string} phoneNumberWithPrefix Phone number with prefix.
         * @param {boolean} [strictFormat] If true, the phone number must match the strict format. {+/optional}{phoneNumberWithPrefix}, allowed chars: +0123456789 and space \&quot; \&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesValidationParseAndValidatePhoneGet: async (phoneNumberWithPrefix: string, strictFormat?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberWithPrefix' is not null or undefined
            assertParamExists('apiSafesignaturesValidationParseAndValidatePhoneGet', 'phoneNumberWithPrefix', phoneNumberWithPrefix)
            const localVarPath = `/api/safesignatures/validation/ParseAndValidatePhone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (phoneNumberWithPrefix !== undefined) {
                localVarQueryParameter['phoneNumberWithPrefix'] = phoneNumberWithPrefix;
            }

            if (strictFormat !== undefined) {
                localVarQueryParameter['strictFormat'] = strictFormat;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checks if the personal number is valid. (rodne cislo)
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesValidationValidatePersonalNumberGet: async (personalNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safesignatures/validation/ValidatePersonalNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (personalNumber !== undefined) {
                localVarQueryParameter['personalNumber'] = personalNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Compares the provided ZipCode against Czech and Slovak ZipCodes
         * @param {string} [zipCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesValidationValidateZipCodeGet: async (zipCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safesignatures/validation/ValidateZipCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (zipCode !== undefined) {
                localVarQueryParameter['zipCode'] = zipCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidationApi - functional programming interface
 * @export
 */
export const ValidationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Checks if the phone number is valid. Prefix has to be included. + is optional.
         * @param {string} phoneNumberWithPrefix Phone number with prefix.
         * @param {boolean} [strictFormat] If true, the phone number must match the strict format. {+/optional}{phoneNumberWithPrefix}, allowed chars: +0123456789 and space \&quot; \&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesValidationParseAndValidatePhoneGet(phoneNumberWithPrefix: string, strictFormat?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOValidationPhoneValidationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesValidationParseAndValidatePhoneGet(phoneNumberWithPrefix, strictFormat, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ValidationApi.apiSafesignaturesValidationParseAndValidatePhoneGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Checks if the personal number is valid. (rodne cislo)
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesValidationValidatePersonalNumberGet(personalNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOValidationPersonalNumberAnalyzeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesValidationValidatePersonalNumberGet(personalNumber, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ValidationApi.apiSafesignaturesValidationValidatePersonalNumberGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Compares the provided ZipCode against Czech and Slovak ZipCodes
         * @param {string} [zipCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesignaturesValidationValidateZipCodeGet(zipCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOValidationZipCodeValidationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesignaturesValidationValidateZipCodeGet(zipCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ValidationApi.apiSafesignaturesValidationValidateZipCodeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ValidationApi - factory interface
 * @export
 */
export const ValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidationApiFp(configuration)
    return {
        /**
         * 
         * @summary Checks if the phone number is valid. Prefix has to be included. + is optional.
         * @param {string} phoneNumberWithPrefix Phone number with prefix.
         * @param {boolean} [strictFormat] If true, the phone number must match the strict format. {+/optional}{phoneNumberWithPrefix}, allowed chars: +0123456789 and space \&quot; \&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesValidationParseAndValidatePhoneGet(phoneNumberWithPrefix: string, strictFormat?: boolean, options?: any): AxiosPromise<APISharedDTOValidationPhoneValidationResultDto> {
            return localVarFp.apiSafesignaturesValidationParseAndValidatePhoneGet(phoneNumberWithPrefix, strictFormat, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checks if the personal number is valid. (rodne cislo)
         * @param {string} [personalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesValidationValidatePersonalNumberGet(personalNumber?: string, options?: any): AxiosPromise<APISharedDTOValidationPersonalNumberAnalyzeDto> {
            return localVarFp.apiSafesignaturesValidationValidatePersonalNumberGet(personalNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Compares the provided ZipCode against Czech and Slovak ZipCodes
         * @param {string} [zipCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesignaturesValidationValidateZipCodeGet(zipCode?: string, options?: any): AxiosPromise<APISharedDTOValidationZipCodeValidationResultDto> {
            return localVarFp.apiSafesignaturesValidationValidateZipCodeGet(zipCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidationApi - object-oriented interface
 * @export
 * @class ValidationApi
 * @extends {BaseAPI}
 */
export class ValidationApi extends BaseAPI {
    /**
     * 
     * @summary Checks if the phone number is valid. Prefix has to be included. + is optional.
     * @param {string} phoneNumberWithPrefix Phone number with prefix.
     * @param {boolean} [strictFormat] If true, the phone number must match the strict format. {+/optional}{phoneNumberWithPrefix}, allowed chars: +0123456789 and space \&quot; \&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiSafesignaturesValidationParseAndValidatePhoneGet(phoneNumberWithPrefix: string, strictFormat?: boolean, options?: AxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiSafesignaturesValidationParseAndValidatePhoneGet(phoneNumberWithPrefix, strictFormat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checks if the personal number is valid. (rodne cislo)
     * @param {string} [personalNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiSafesignaturesValidationValidatePersonalNumberGet(personalNumber?: string, options?: AxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiSafesignaturesValidationValidatePersonalNumberGet(personalNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Compares the provided ZipCode against Czech and Slovak ZipCodes
     * @param {string} [zipCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiSafesignaturesValidationValidateZipCodeGet(zipCode?: string, options?: AxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiSafesignaturesValidationValidateZipCodeGet(zipCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VirtualWebCronApi - axios parameter creator
 * @export
 */
export const VirtualWebCronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancels all running tests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerCancelAllTestsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VirtualWebCronCotroller/CancelAllTests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns active test running time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerGetRunningTimeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VirtualWebCronCotroller/GetRunningTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancels all running tests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerReturnTestResultsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VirtualWebCronCotroller/ReturnTestResults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turns on/off vwbcs for permanent notifications.
         * @param {number} [delay] 
         * @param {boolean} [killActive] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerSimulateCronNotificationsPermanentGet: async (delay?: number, killActive?: boolean, idCompany?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VirtualWebCronCotroller/SimulateCronNotificationsPermanent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (delay !== undefined) {
                localVarQueryParameter['delay'] = delay;
            }

            if (killActive !== undefined) {
                localVarQueryParameter['killActive'] = killActive;
            }

            if (idCompany !== undefined) {
                localVarQueryParameter['idCompany'] = idCompany;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turns on/off vwbcs for trainsient notifications. (deletes all of them after send, so they can be sent again.)
         * @param {number} [delay] 
         * @param {boolean} [killActive] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerSimulateCronNotificationsTransientGet: async (delay?: number, killActive?: boolean, idCompany?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VirtualWebCronCotroller/SimulateCronNotificationsTransient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (delay !== undefined) {
                localVarQueryParameter['delay'] = delay;
            }

            if (killActive !== undefined) {
                localVarQueryParameter['killActive'] = killActive;
            }

            if (idCompany !== undefined) {
                localVarQueryParameter['idCompany'] = idCompany;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VirtualWebCronApi - functional programming interface
 * @export
 */
export const VirtualWebCronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VirtualWebCronApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancels all running tests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVirtualWebCronCotrollerCancelAllTestsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVirtualWebCronCotrollerCancelAllTestsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VirtualWebCronApi.apiVirtualWebCronCotrollerCancelAllTestsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns active test running time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVirtualWebCronCotrollerGetRunningTimeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVirtualWebCronCotrollerGetRunningTimeGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VirtualWebCronApi.apiVirtualWebCronCotrollerGetRunningTimeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancels all running tests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVirtualWebCronCotrollerReturnTestResultsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVirtualWebCronCotrollerReturnTestResultsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VirtualWebCronApi.apiVirtualWebCronCotrollerReturnTestResultsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Turns on/off vwbcs for permanent notifications.
         * @param {number} [delay] 
         * @param {boolean} [killActive] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVirtualWebCronCotrollerSimulateCronNotificationsPermanentGet(delay?: number, killActive?: boolean, idCompany?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVirtualWebCronCotrollerSimulateCronNotificationsPermanentGet(delay, killActive, idCompany, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VirtualWebCronApi.apiVirtualWebCronCotrollerSimulateCronNotificationsPermanentGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Turns on/off vwbcs for trainsient notifications. (deletes all of them after send, so they can be sent again.)
         * @param {number} [delay] 
         * @param {boolean} [killActive] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVirtualWebCronCotrollerSimulateCronNotificationsTransientGet(delay?: number, killActive?: boolean, idCompany?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVirtualWebCronCotrollerSimulateCronNotificationsTransientGet(delay, killActive, idCompany, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VirtualWebCronApi.apiVirtualWebCronCotrollerSimulateCronNotificationsTransientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * VirtualWebCronApi - factory interface
 * @export
 */
export const VirtualWebCronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VirtualWebCronApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancels all running tests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerCancelAllTestsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiVirtualWebCronCotrollerCancelAllTestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns active test running time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerGetRunningTimeGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiVirtualWebCronCotrollerGetRunningTimeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancels all running tests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerReturnTestResultsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiVirtualWebCronCotrollerReturnTestResultsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turns on/off vwbcs for permanent notifications.
         * @param {number} [delay] 
         * @param {boolean} [killActive] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerSimulateCronNotificationsPermanentGet(delay?: number, killActive?: boolean, idCompany?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiVirtualWebCronCotrollerSimulateCronNotificationsPermanentGet(delay, killActive, idCompany, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turns on/off vwbcs for trainsient notifications. (deletes all of them after send, so they can be sent again.)
         * @param {number} [delay] 
         * @param {boolean} [killActive] 
         * @param {string} [idCompany] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVirtualWebCronCotrollerSimulateCronNotificationsTransientGet(delay?: number, killActive?: boolean, idCompany?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiVirtualWebCronCotrollerSimulateCronNotificationsTransientGet(delay, killActive, idCompany, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VirtualWebCronApi - object-oriented interface
 * @export
 * @class VirtualWebCronApi
 * @extends {BaseAPI}
 */
export class VirtualWebCronApi extends BaseAPI {
    /**
     * 
     * @summary Cancels all running tests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualWebCronApi
     */
    public apiVirtualWebCronCotrollerCancelAllTestsGet(options?: AxiosRequestConfig) {
        return VirtualWebCronApiFp(this.configuration).apiVirtualWebCronCotrollerCancelAllTestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns active test running time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualWebCronApi
     */
    public apiVirtualWebCronCotrollerGetRunningTimeGet(options?: AxiosRequestConfig) {
        return VirtualWebCronApiFp(this.configuration).apiVirtualWebCronCotrollerGetRunningTimeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancels all running tests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualWebCronApi
     */
    public apiVirtualWebCronCotrollerReturnTestResultsGet(options?: AxiosRequestConfig) {
        return VirtualWebCronApiFp(this.configuration).apiVirtualWebCronCotrollerReturnTestResultsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turns on/off vwbcs for permanent notifications.
     * @param {number} [delay] 
     * @param {boolean} [killActive] 
     * @param {string} [idCompany] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualWebCronApi
     */
    public apiVirtualWebCronCotrollerSimulateCronNotificationsPermanentGet(delay?: number, killActive?: boolean, idCompany?: string, options?: AxiosRequestConfig) {
        return VirtualWebCronApiFp(this.configuration).apiVirtualWebCronCotrollerSimulateCronNotificationsPermanentGet(delay, killActive, idCompany, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turns on/off vwbcs for trainsient notifications. (deletes all of them after send, so they can be sent again.)
     * @param {number} [delay] 
     * @param {boolean} [killActive] 
     * @param {string} [idCompany] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualWebCronApi
     */
    public apiVirtualWebCronCotrollerSimulateCronNotificationsTransientGet(delay?: number, killActive?: boolean, idCompany?: string, options?: AxiosRequestConfig) {
        return VirtualWebCronApiFp(this.configuration).apiVirtualWebCronCotrollerSimulateCronNotificationsTransientGet(delay, killActive, idCompany, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VzpApi - axios parameter creator
 * @export
 */
export const VzpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idVzpAsyncResponse] id of file
         * @param {ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum} [returnFileAsType] 0 &#x3D; Image,1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF, 6 &#x3D; None
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVzpInsuranceVzpAsyncResponseFileGet: async (idVzpAsyncResponse?: string, returnFileAsType?: ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Vzp/InsuranceVzpAsyncResponseFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idVzpAsyncResponse !== undefined) {
                localVarQueryParameter['idVzpAsyncResponse'] = idVzpAsyncResponse;
            }

            if (returnFileAsType !== undefined) {
                localVarQueryParameter['returnFileAsType'] = returnFileAsType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOVzpAsyncResponsesGridDto} [aPIXdentDTOVzpAsyncResponsesGridDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVzpInsuranceVzpAsyncResponseGridPost: async (aPIXdentDTOVzpAsyncResponsesGridDto?: APIXdentDTOVzpAsyncResponsesGridDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Vzp/InsuranceVzpAsyncResponseGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOVzpAsyncResponsesGridDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [q] 
         * @param {string} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVzpSearchInsuranceDiagnoseItemsGet: async (q?: string, pageLimit?: string, idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Vzp/SearchInsuranceDiagnoseItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page_limit'] = pageLimit;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [q] 
         * @param {string} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {number} [clientAge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVzpSearchInsuranceItemsGet: async (q?: string, pageLimit?: string, idStaff?: string, clientAge?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Vzp/SearchInsuranceItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page_limit'] = pageLimit;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (clientAge !== undefined) {
                localVarQueryParameter['clientAge'] = clientAge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VzpApi - functional programming interface
 * @export
 */
export const VzpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VzpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idVzpAsyncResponse] id of file
         * @param {ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum} [returnFileAsType] 0 &#x3D; Image,1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF, 6 &#x3D; None
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVzpInsuranceVzpAsyncResponseFileGet(idVzpAsyncResponse?: string, returnFileAsType?: ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVzpInsuranceVzpAsyncResponseFileGet(idVzpAsyncResponse, returnFileAsType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VzpApi.apiVzpInsuranceVzpAsyncResponseFileGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOVzpAsyncResponsesGridDto} [aPIXdentDTOVzpAsyncResponsesGridDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVzpInsuranceVzpAsyncResponseGridPost(aPIXdentDTOVzpAsyncResponsesGridDto?: APIXdentDTOVzpAsyncResponsesGridDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOVzpAsyncResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVzpInsuranceVzpAsyncResponseGridPost(aPIXdentDTOVzpAsyncResponsesGridDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VzpApi.apiVzpInsuranceVzpAsyncResponseGridPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [q] 
         * @param {string} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVzpSearchInsuranceDiagnoseItemsGet(q?: string, pageLimit?: string, idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOVzpInsuranceSearchDiagnoseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVzpSearchInsuranceDiagnoseItemsGet(q, pageLimit, idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VzpApi.apiVzpSearchInsuranceDiagnoseItemsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [q] 
         * @param {string} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {number} [clientAge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVzpSearchInsuranceItemsGet(q?: string, pageLimit?: string, idStaff?: string, clientAge?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOVzpInsuranceItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVzpSearchInsuranceItemsGet(q, pageLimit, idStaff, clientAge, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VzpApi.apiVzpSearchInsuranceItemsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * VzpApi - factory interface
 * @export
 */
export const VzpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VzpApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idVzpAsyncResponse] id of file
         * @param {ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum} [returnFileAsType] 0 &#x3D; Image,1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF, 6 &#x3D; None
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVzpInsuranceVzpAsyncResponseFileGet(idVzpAsyncResponse?: string, returnFileAsType?: ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum, options?: any): AxiosPromise<void> {
            return localVarFp.apiVzpInsuranceVzpAsyncResponseFileGet(idVzpAsyncResponse, returnFileAsType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APIXdentDTOVzpAsyncResponsesGridDto} [aPIXdentDTOVzpAsyncResponsesGridDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVzpInsuranceVzpAsyncResponseGridPost(aPIXdentDTOVzpAsyncResponsesGridDto?: APIXdentDTOVzpAsyncResponsesGridDto, options?: any): AxiosPromise<Array<APIXdentDTOVzpAsyncResponseDto>> {
            return localVarFp.apiVzpInsuranceVzpAsyncResponseGridPost(aPIXdentDTOVzpAsyncResponsesGridDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [q] 
         * @param {string} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVzpSearchInsuranceDiagnoseItemsGet(q?: string, pageLimit?: string, idStaff?: string, options?: any): AxiosPromise<Array<APIXdentDTOVzpInsuranceSearchDiagnoseDto>> {
            return localVarFp.apiVzpSearchInsuranceDiagnoseItemsGet(q, pageLimit, idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [q] 
         * @param {string} [pageLimit] 
         * @param {string} [idStaff] 
         * @param {number} [clientAge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVzpSearchInsuranceItemsGet(q?: string, pageLimit?: string, idStaff?: string, clientAge?: number, options?: any): AxiosPromise<Array<APIXdentDTOVzpInsuranceItemDto>> {
            return localVarFp.apiVzpSearchInsuranceItemsGet(q, pageLimit, idStaff, clientAge, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VzpApi - object-oriented interface
 * @export
 * @class VzpApi
 * @extends {BaseAPI}
 */
export class VzpApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idVzpAsyncResponse] id of file
     * @param {ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum} [returnFileAsType] 0 &#x3D; Image,1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF, 6 &#x3D; None
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VzpApi
     */
    public apiVzpInsuranceVzpAsyncResponseFileGet(idVzpAsyncResponse?: string, returnFileAsType?: ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum, options?: AxiosRequestConfig) {
        return VzpApiFp(this.configuration).apiVzpInsuranceVzpAsyncResponseFileGet(idVzpAsyncResponse, returnFileAsType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APIXdentDTOVzpAsyncResponsesGridDto} [aPIXdentDTOVzpAsyncResponsesGridDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VzpApi
     */
    public apiVzpInsuranceVzpAsyncResponseGridPost(aPIXdentDTOVzpAsyncResponsesGridDto?: APIXdentDTOVzpAsyncResponsesGridDto, options?: AxiosRequestConfig) {
        return VzpApiFp(this.configuration).apiVzpInsuranceVzpAsyncResponseGridPost(aPIXdentDTOVzpAsyncResponsesGridDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [q] 
     * @param {string} [pageLimit] 
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VzpApi
     */
    public apiVzpSearchInsuranceDiagnoseItemsGet(q?: string, pageLimit?: string, idStaff?: string, options?: AxiosRequestConfig) {
        return VzpApiFp(this.configuration).apiVzpSearchInsuranceDiagnoseItemsGet(q, pageLimit, idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [q] 
     * @param {string} [pageLimit] 
     * @param {string} [idStaff] 
     * @param {number} [clientAge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VzpApi
     */
    public apiVzpSearchInsuranceItemsGet(q?: string, pageLimit?: string, idStaff?: string, clientAge?: number, options?: AxiosRequestConfig) {
        return VzpApiFp(this.configuration).apiVzpSearchInsuranceItemsGet(q, pageLimit, idStaff, clientAge, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum = typeof ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum[keyof typeof ApiVzpInsuranceVzpAsyncResponseFileGetReturnFileAsTypeEnum];


/**
 * XdentApi - axios parameter creator
 * @export
 */
export const XdentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Migration EP - registers device by ios device token via logged user
         * @param {string} deviceToken 
         * @param {APIXdentControllersSafeSignaturesInitDevice} [aPIXdentControllersSafeSignaturesInitDevice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesigmigrationXdentInitDevicePost: async (deviceToken: string, aPIXdentControllersSafeSignaturesInitDevice?: APIXdentControllersSafeSignaturesInitDevice, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceToken' is not null or undefined
            assertParamExists('apiSafesigmigrationXdentInitDevicePost', 'deviceToken', deviceToken)
            const localVarPath = `/api/safesigmigration/xdent/InitDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceToken != null) {
                localVarHeaderParameter['deviceToken'] = String(deviceToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentControllersSafeSignaturesInitDevice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentApi - functional programming interface
 * @export
 */
export const XdentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Migration EP - registers device by ios device token via logged user
         * @param {string} deviceToken 
         * @param {APIXdentControllersSafeSignaturesInitDevice} [aPIXdentControllersSafeSignaturesInitDevice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafesigmigrationXdentInitDevicePost(deviceToken: string, aPIXdentControllersSafeSignaturesInitDevice?: APIXdentControllersSafeSignaturesInitDevice, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSafesigmigrationXdentInitDevicePost(deviceToken, aPIXdentControllersSafeSignaturesInitDevice, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentApi.apiSafesigmigrationXdentInitDevicePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentApi - factory interface
 * @export
 */
export const XdentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentApiFp(configuration)
    return {
        /**
         * 
         * @summary Migration EP - registers device by ios device token via logged user
         * @param {string} deviceToken 
         * @param {APIXdentControllersSafeSignaturesInitDevice} [aPIXdentControllersSafeSignaturesInitDevice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafesigmigrationXdentInitDevicePost(deviceToken: string, aPIXdentControllersSafeSignaturesInitDevice?: APIXdentControllersSafeSignaturesInitDevice, options?: any): AxiosPromise<void> {
            return localVarFp.apiSafesigmigrationXdentInitDevicePost(deviceToken, aPIXdentControllersSafeSignaturesInitDevice, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentApi - object-oriented interface
 * @export
 * @class XdentApi
 * @extends {BaseAPI}
 */
export class XdentApi extends BaseAPI {
    /**
     * 
     * @summary Migration EP - registers device by ios device token via logged user
     * @param {string} deviceToken 
     * @param {APIXdentControllersSafeSignaturesInitDevice} [aPIXdentControllersSafeSignaturesInitDevice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentApi
     */
    public apiSafesigmigrationXdentInitDevicePost(deviceToken: string, aPIXdentControllersSafeSignaturesInitDevice?: APIXdentControllersSafeSignaturesInitDevice, options?: AxiosRequestConfig) {
        return XdentApiFp(this.configuration).apiSafesigmigrationXdentInitDevicePost(deviceToken, aPIXdentControllersSafeSignaturesInitDevice, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentAdminApi - axios parameter creator
 * @export
 */
export const XdentAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintGenericInvoiceGet: async (idInvoice?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentAdminInvoice/PrintGenericInvoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idInvoice !== undefined) {
                localVarQueryParameter['idInvoice'] = idInvoice;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintGenericInvoicePreviewGet: async (idInvoice?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentAdminInvoice/PrintGenericInvoicePreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idInvoice !== undefined) {
                localVarQueryParameter['idInvoice'] = idInvoice;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {string} [idInvoiceTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintNextGetInvoiceGet: async (idInvoice?: string, idInvoiceTypeCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentAdminInvoice/PrintNextGetInvoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idInvoice !== undefined) {
                localVarQueryParameter['idInvoice'] = idInvoice;
            }

            if (idInvoiceTypeCode !== undefined) {
                localVarQueryParameter['idInvoiceTypeCode'] = idInvoiceTypeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintSubscriptionInvoiceGet: async (idInvoice?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentAdminInvoice/PrintSubscriptionInvoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idInvoice !== undefined) {
                localVarQueryParameter['idInvoice'] = idInvoice;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintSubscriptionInvoicePreviewGet: async (idInvoice?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentAdminInvoice/PrintSubscriptionInvoicePreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idInvoice !== undefined) {
                localVarQueryParameter['idInvoice'] = idInvoice;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentAdminApi - functional programming interface
 * @export
 */
export const XdentAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentAdminInvoicePrintGenericInvoiceGet(idInvoice?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentAdminInvoicePrintGenericInvoiceGet(idInvoice, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentAdminApi.apiXdentAdminInvoicePrintGenericInvoiceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentAdminInvoicePrintGenericInvoicePreviewGet(idInvoice?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentAdminInvoicePrintGenericInvoicePreviewGet(idInvoice, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentAdminApi.apiXdentAdminInvoicePrintGenericInvoicePreviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {string} [idInvoiceTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentAdminInvoicePrintNextGetInvoiceGet(idInvoice?: string, idInvoiceTypeCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentAdminInvoicePrintNextGetInvoiceGet(idInvoice, idInvoiceTypeCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentAdminApi.apiXdentAdminInvoicePrintNextGetInvoiceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentAdminInvoicePrintSubscriptionInvoiceGet(idInvoice?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentAdminInvoicePrintSubscriptionInvoiceGet(idInvoice, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentAdminApi.apiXdentAdminInvoicePrintSubscriptionInvoiceGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentAdminInvoicePrintSubscriptionInvoicePreviewGet(idInvoice?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentAdminInvoicePrintSubscriptionInvoicePreviewGet(idInvoice, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentAdminApi.apiXdentAdminInvoicePrintSubscriptionInvoicePreviewGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentAdminApi - factory interface
 * @export
 */
export const XdentAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintGenericInvoiceGet(idInvoice?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentAdminInvoicePrintGenericInvoiceGet(idInvoice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintGenericInvoicePreviewGet(idInvoice?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentAdminInvoicePrintGenericInvoicePreviewGet(idInvoice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {string} [idInvoiceTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintNextGetInvoiceGet(idInvoice?: string, idInvoiceTypeCode?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentAdminInvoicePrintNextGetInvoiceGet(idInvoice, idInvoiceTypeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintSubscriptionInvoiceGet(idInvoice?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentAdminInvoicePrintSubscriptionInvoiceGet(idInvoice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentAdminInvoicePrintSubscriptionInvoicePreviewGet(idInvoice?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentAdminInvoicePrintSubscriptionInvoicePreviewGet(idInvoice, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentAdminApi - object-oriented interface
 * @export
 * @class XdentAdminApi
 * @extends {BaseAPI}
 */
export class XdentAdminApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idInvoice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentAdminApi
     */
    public apiXdentAdminInvoicePrintGenericInvoiceGet(idInvoice?: string, options?: AxiosRequestConfig) {
        return XdentAdminApiFp(this.configuration).apiXdentAdminInvoicePrintGenericInvoiceGet(idInvoice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idInvoice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentAdminApi
     */
    public apiXdentAdminInvoicePrintGenericInvoicePreviewGet(idInvoice?: string, options?: AxiosRequestConfig) {
        return XdentAdminApiFp(this.configuration).apiXdentAdminInvoicePrintGenericInvoicePreviewGet(idInvoice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idInvoice] 
     * @param {string} [idInvoiceTypeCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentAdminApi
     */
    public apiXdentAdminInvoicePrintNextGetInvoiceGet(idInvoice?: string, idInvoiceTypeCode?: string, options?: AxiosRequestConfig) {
        return XdentAdminApiFp(this.configuration).apiXdentAdminInvoicePrintNextGetInvoiceGet(idInvoice, idInvoiceTypeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idInvoice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentAdminApi
     */
    public apiXdentAdminInvoicePrintSubscriptionInvoiceGet(idInvoice?: string, options?: AxiosRequestConfig) {
        return XdentAdminApiFp(this.configuration).apiXdentAdminInvoicePrintSubscriptionInvoiceGet(idInvoice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idInvoice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentAdminApi
     */
    public apiXdentAdminInvoicePrintSubscriptionInvoicePreviewGet(idInvoice?: string, options?: AxiosRequestConfig) {
        return XdentAdminApiFp(this.configuration).apiXdentAdminInvoicePrintSubscriptionInvoicePreviewGet(idInvoice, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentFormApi - axios parameter creator
 * @export
 */
export const XdentFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentFormGetPopulatedFormsByClientGet: async (idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentForm/GetPopulatedFormsByClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentFormApi - functional programming interface
 * @export
 */
export const XdentFormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentFormApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentFormGetPopulatedFormsByClientGet(idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedXdentFormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentFormGetPopulatedFormsByClientGet(idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentFormApi.apiXdentFormGetPopulatedFormsByClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentFormApi - factory interface
 * @export
 */
export const XdentFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentFormApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all available forms by location based od provided idClient
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentFormGetPopulatedFormsByClientGet(idClient?: string, options?: any): AxiosPromise<Array<APISharedXdentFormDto>> {
            return localVarFp.apiXdentFormGetPopulatedFormsByClientGet(idClient, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentFormApi - object-oriented interface
 * @export
 * @class XdentFormApi
 * @extends {BaseAPI}
 */
export class XdentFormApi extends BaseAPI {
    /**
     * 
     * @summary Gets all available forms by location based od provided idClient
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentFormApi
     */
    public apiXdentFormGetPopulatedFormsByClientGet(idClient?: string, options?: AxiosRequestConfig) {
        return XdentFormApiFp(this.configuration).apiXdentFormGetPopulatedFormsByClientGet(idClient, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentPointApi - axios parameter creator
 * @export
 */
export const XdentPointApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get POINT navigation settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/xdentpoint/navsettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get POINT navigation setting by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInternalXdentpointNavsettingsIdDelete', 'id', id)
            const localVarPath = `/api/internal/xdentpoint/navsettings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get POINT navigation setting by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInternalXdentpointNavsettingsIdGet', 'id', id)
            const localVarPath = `/api/internal/xdentpoint/navsettings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert point navigation setting desc mutation, update is handled by parent id and language id
         * @param {APIXdentDTOXdentPointPointNavSettingImageUpdateDto} [aPIXdentDTOXdentPointPointNavSettingImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsImagePost: async (aPIXdentDTOXdentPointPointNavSettingImageUpdateDto?: APIXdentDTOXdentPointPointNavSettingImageUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/xdentpoint/navsettings/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOXdentPointPointNavSettingImageUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert point navigation setting desc mutation, update is handled by parent id and language id
         * @param {APIXdentDTOXdentPointPointNavSettingMutationUpdateDto} [aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsMutationPost: async (aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto?: APIXdentDTOXdentPointPointNavSettingMutationUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/xdentpoint/navsettings/mutation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert point navigation setting (can include all mutations), update is handled by having id in body.
         * @param {APIXdentDTOXdentPointPointNavigationSettingUpdateDto} [aPIXdentDTOXdentPointPointNavigationSettingUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsPost: async (aPIXdentDTOXdentPointPointNavigationSettingUpdateDto?: APIXdentDTOXdentPointPointNavigationSettingUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/xdentpoint/navsettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIXdentDTOXdentPointPointNavigationSettingUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointApi - functional programming interface
 * @export
 */
export const XdentPointApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get POINT navigation settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInternalXdentpointNavsettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APIXdentDTOXdentPointPointNavigationSettingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInternalXdentpointNavsettingsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointApi.apiInternalXdentpointNavsettingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get POINT navigation setting by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInternalXdentpointNavsettingsIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInternalXdentpointNavsettingsIdDelete(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointApi.apiInternalXdentpointNavsettingsIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get POINT navigation setting by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInternalXdentpointNavsettingsIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentDTOXdentPointPointNavigationSettingFullDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInternalXdentpointNavsettingsIdGet(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointApi.apiInternalXdentpointNavsettingsIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Upsert point navigation setting desc mutation, update is handled by parent id and language id
         * @param {APIXdentDTOXdentPointPointNavSettingImageUpdateDto} [aPIXdentDTOXdentPointPointNavSettingImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInternalXdentpointNavsettingsImagePost(aPIXdentDTOXdentPointPointNavSettingImageUpdateDto?: APIXdentDTOXdentPointPointNavSettingImageUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInternalXdentpointNavsettingsImagePost(aPIXdentDTOXdentPointPointNavSettingImageUpdateDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointApi.apiInternalXdentpointNavsettingsImagePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Upsert point navigation setting desc mutation, update is handled by parent id and language id
         * @param {APIXdentDTOXdentPointPointNavSettingMutationUpdateDto} [aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInternalXdentpointNavsettingsMutationPost(aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto?: APIXdentDTOXdentPointPointNavSettingMutationUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInternalXdentpointNavsettingsMutationPost(aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointApi.apiInternalXdentpointNavsettingsMutationPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Upsert point navigation setting (can include all mutations), update is handled by having id in body.
         * @param {APIXdentDTOXdentPointPointNavigationSettingUpdateDto} [aPIXdentDTOXdentPointPointNavigationSettingUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInternalXdentpointNavsettingsPost(aPIXdentDTOXdentPointPointNavigationSettingUpdateDto?: APIXdentDTOXdentPointPointNavigationSettingUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInternalXdentpointNavsettingsPost(aPIXdentDTOXdentPointPointNavigationSettingUpdateDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointApi.apiInternalXdentpointNavsettingsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointApi - factory interface
 * @export
 */
export const XdentPointApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointApiFp(configuration)
    return {
        /**
         * 
         * @summary Get POINT navigation settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsGet(options?: any): AxiosPromise<Array<APIXdentDTOXdentPointPointNavigationSettingDto>> {
            return localVarFp.apiInternalXdentpointNavsettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get POINT navigation setting by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsIdDelete(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiInternalXdentpointNavsettingsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get POINT navigation setting by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsIdGet(id: string, options?: any): AxiosPromise<APIXdentDTOXdentPointPointNavigationSettingFullDto> {
            return localVarFp.apiInternalXdentpointNavsettingsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert point navigation setting desc mutation, update is handled by parent id and language id
         * @param {APIXdentDTOXdentPointPointNavSettingImageUpdateDto} [aPIXdentDTOXdentPointPointNavSettingImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsImagePost(aPIXdentDTOXdentPointPointNavSettingImageUpdateDto?: APIXdentDTOXdentPointPointNavSettingImageUpdateDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiInternalXdentpointNavsettingsImagePost(aPIXdentDTOXdentPointPointNavSettingImageUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert point navigation setting desc mutation, update is handled by parent id and language id
         * @param {APIXdentDTOXdentPointPointNavSettingMutationUpdateDto} [aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsMutationPost(aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto?: APIXdentDTOXdentPointPointNavSettingMutationUpdateDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiInternalXdentpointNavsettingsMutationPost(aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert point navigation setting (can include all mutations), update is handled by having id in body.
         * @param {APIXdentDTOXdentPointPointNavigationSettingUpdateDto} [aPIXdentDTOXdentPointPointNavigationSettingUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInternalXdentpointNavsettingsPost(aPIXdentDTOXdentPointPointNavigationSettingUpdateDto?: APIXdentDTOXdentPointPointNavigationSettingUpdateDto, options?: any): AxiosPromise<string> {
            return localVarFp.apiInternalXdentpointNavsettingsPost(aPIXdentDTOXdentPointPointNavigationSettingUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointApi - object-oriented interface
 * @export
 * @class XdentPointApi
 * @extends {BaseAPI}
 */
export class XdentPointApi extends BaseAPI {
    /**
     * 
     * @summary Get POINT navigation settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointApi
     */
    public apiInternalXdentpointNavsettingsGet(options?: AxiosRequestConfig) {
        return XdentPointApiFp(this.configuration).apiInternalXdentpointNavsettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get POINT navigation setting by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointApi
     */
    public apiInternalXdentpointNavsettingsIdDelete(id: string, options?: AxiosRequestConfig) {
        return XdentPointApiFp(this.configuration).apiInternalXdentpointNavsettingsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get POINT navigation setting by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointApi
     */
    public apiInternalXdentpointNavsettingsIdGet(id: string, options?: AxiosRequestConfig) {
        return XdentPointApiFp(this.configuration).apiInternalXdentpointNavsettingsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert point navigation setting desc mutation, update is handled by parent id and language id
     * @param {APIXdentDTOXdentPointPointNavSettingImageUpdateDto} [aPIXdentDTOXdentPointPointNavSettingImageUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointApi
     */
    public apiInternalXdentpointNavsettingsImagePost(aPIXdentDTOXdentPointPointNavSettingImageUpdateDto?: APIXdentDTOXdentPointPointNavSettingImageUpdateDto, options?: AxiosRequestConfig) {
        return XdentPointApiFp(this.configuration).apiInternalXdentpointNavsettingsImagePost(aPIXdentDTOXdentPointPointNavSettingImageUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert point navigation setting desc mutation, update is handled by parent id and language id
     * @param {APIXdentDTOXdentPointPointNavSettingMutationUpdateDto} [aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointApi
     */
    public apiInternalXdentpointNavsettingsMutationPost(aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto?: APIXdentDTOXdentPointPointNavSettingMutationUpdateDto, options?: AxiosRequestConfig) {
        return XdentPointApiFp(this.configuration).apiInternalXdentpointNavsettingsMutationPost(aPIXdentDTOXdentPointPointNavSettingMutationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert point navigation setting (can include all mutations), update is handled by having id in body.
     * @param {APIXdentDTOXdentPointPointNavigationSettingUpdateDto} [aPIXdentDTOXdentPointPointNavigationSettingUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointApi
     */
    public apiInternalXdentpointNavsettingsPost(aPIXdentDTOXdentPointPointNavigationSettingUpdateDto?: APIXdentDTOXdentPointPointNavigationSettingUpdateDto, options?: AxiosRequestConfig) {
        return XdentPointApiFp(this.configuration).apiInternalXdentpointNavsettingsPost(aPIXdentDTOXdentPointPointNavigationSettingUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentPointAppointmentApi - axios parameter creator
 * @export
 */
export const XdentPointAppointmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Confirms appointment by id. Only for AS_ORDERED and AS_CONFIRMED states.
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointAppointmentConfirmAppointmentPatch: async (appointmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('apiXdentpointAppointmentConfirmAppointmentPatch', 'appointmentId', appointmentId)
            const localVarPath = `/api/xdentpoint/appointment/ConfirmAppointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {string} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointAppointmentGetAppointmentByIdGet: async (appointmentId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/appointment/GetAppointmentById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointAppointmentApi - functional programming interface
 * @export
 */
export const XdentPointAppointmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointAppointmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Confirms appointment by id. Only for AS_ORDERED and AS_CONFIRMED states.
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointAppointmentConfirmAppointmentPatch(appointmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointAppointmentConfirmAppointmentPatch(appointmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointAppointmentApi.apiXdentpointAppointmentConfirmAppointmentPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {string} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointAppointmentGetAppointmentByIdGet(appointmentId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointAppointmentGetAppointmentByIdGet(appointmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointAppointmentApi.apiXdentpointAppointmentGetAppointmentByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointAppointmentApi - factory interface
 * @export
 */
export const XdentPointAppointmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointAppointmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Confirms appointment by id. Only for AS_ORDERED and AS_CONFIRMED states.
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointAppointmentConfirmAppointmentPatch(appointmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentpointAppointmentConfirmAppointmentPatch(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets appointment by id for owner user.
         * @param {string} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointAppointmentGetAppointmentByIdGet(appointmentId?: string, options?: any): AxiosPromise<APISharedAppointmentDto> {
            return localVarFp.apiXdentpointAppointmentGetAppointmentByIdGet(appointmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointAppointmentApi - object-oriented interface
 * @export
 * @class XdentPointAppointmentApi
 * @extends {BaseAPI}
 */
export class XdentPointAppointmentApi extends BaseAPI {
    /**
     * 
     * @summary Confirms appointment by id. Only for AS_ORDERED and AS_CONFIRMED states.
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointAppointmentApi
     */
    public apiXdentpointAppointmentConfirmAppointmentPatch(appointmentId: string, options?: AxiosRequestConfig) {
        return XdentPointAppointmentApiFp(this.configuration).apiXdentpointAppointmentConfirmAppointmentPatch(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets appointment by id for owner user.
     * @param {string} [appointmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointAppointmentApi
     */
    public apiXdentpointAppointmentGetAppointmentByIdGet(appointmentId?: string, options?: AxiosRequestConfig) {
        return XdentPointAppointmentApiFp(this.configuration).apiXdentpointAppointmentGetAppointmentByIdGet(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentPointClientApi - axios parameter creator
 * @export
 */
export const XdentPointClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get additional data for appointment - including client navigation info
         * @param {string} [idAppointment] 
         * @param {string} [idClient] 
         * @param {string} [idStaff] 
         * @param {string} [idService] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointClientAdditionalAppointmentDataGet: async (idAppointment?: string, idClient?: string, idStaff?: string, idService?: string, idLocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/client/AdditionalAppointmentData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idAppointment !== undefined) {
                localVarQueryParameter['idAppointment'] = idAppointment;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }

            if (idService !== undefined) {
                localVarQueryParameter['idService'] = idService;
            }

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get upcoming clients for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointClientUpcomingClientsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/client/UpcomingClients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get upcoming clients for logged user V2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointClientUpcomingClientsV2Get: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/client/UpcomingClientsV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointClientApi - functional programming interface
 * @export
 */
export const XdentPointClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get additional data for appointment - including client navigation info
         * @param {string} [idAppointment] 
         * @param {string} [idClient] 
         * @param {string} [idStaff] 
         * @param {string} [idService] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointClientAdditionalAppointmentDataGet(idAppointment?: string, idClient?: string, idStaff?: string, idService?: string, idLocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedClientServiceXdentPointAppointmentAddInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointClientAdditionalAppointmentDataGet(idAppointment, idClient, idStaff, idService, idLocation, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointClientApi.apiXdentpointClientAdditionalAppointmentDataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get upcoming clients for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointClientUpcomingClientsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointClientUpcomingClientsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointClientApi.apiXdentpointClientUpcomingClientsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get upcoming clients for logged user V2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointClientUpcomingClientsV2Get(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointClientUpcomingClientsV2Get(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointClientApi.apiXdentpointClientUpcomingClientsV2Get']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointClientApi - factory interface
 * @export
 */
export const XdentPointClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointClientApiFp(configuration)
    return {
        /**
         * 
         * @summary Get additional data for appointment - including client navigation info
         * @param {string} [idAppointment] 
         * @param {string} [idClient] 
         * @param {string} [idStaff] 
         * @param {string} [idService] 
         * @param {string} [idLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointClientAdditionalAppointmentDataGet(idAppointment?: string, idClient?: string, idStaff?: string, idService?: string, idLocation?: string, options?: any): AxiosPromise<APIXdentServicesXdentScopedClientServiceXdentPointAppointmentAddInfoDto> {
            return localVarFp.apiXdentpointClientAdditionalAppointmentDataGet(idAppointment, idClient, idStaff, idService, idLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get upcoming clients for logged user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointClientUpcomingClientsGet(options?: any): AxiosPromise<APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperDto> {
            return localVarFp.apiXdentpointClientUpcomingClientsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get upcoming clients for logged user V2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointClientUpcomingClientsV2Get(options?: any): AxiosPromise<APIXdentServicesXdentScopedClientServiceXdentPointGridAppointmentWrapperV2Dto> {
            return localVarFp.apiXdentpointClientUpcomingClientsV2Get(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointClientApi - object-oriented interface
 * @export
 * @class XdentPointClientApi
 * @extends {BaseAPI}
 */
export class XdentPointClientApi extends BaseAPI {
    /**
     * 
     * @summary Get additional data for appointment - including client navigation info
     * @param {string} [idAppointment] 
     * @param {string} [idClient] 
     * @param {string} [idStaff] 
     * @param {string} [idService] 
     * @param {string} [idLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointClientApi
     */
    public apiXdentpointClientAdditionalAppointmentDataGet(idAppointment?: string, idClient?: string, idStaff?: string, idService?: string, idLocation?: string, options?: AxiosRequestConfig) {
        return XdentPointClientApiFp(this.configuration).apiXdentpointClientAdditionalAppointmentDataGet(idAppointment, idClient, idStaff, idService, idLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get upcoming clients for logged user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointClientApi
     */
    public apiXdentpointClientUpcomingClientsGet(options?: AxiosRequestConfig) {
        return XdentPointClientApiFp(this.configuration).apiXdentpointClientUpcomingClientsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get upcoming clients for logged user V2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointClientApi
     */
    public apiXdentpointClientUpcomingClientsV2Get(options?: AxiosRequestConfig) {
        return XdentPointClientApiFp(this.configuration).apiXdentpointClientUpcomingClientsV2Get(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentPointConfigurationApi - axios parameter creator
 * @export
 */
export const XdentPointConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get app configuration. For model example, call the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointConfigGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/Config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointConfigurationApi - functional programming interface
 * @export
 */
export const XdentPointConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get app configuration. For model example, call the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointConfigGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointConfigGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointConfigurationApi.apiXdentpointConfigGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointConfigurationApi - factory interface
 * @export
 */
export const XdentPointConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get app configuration. For model example, call the endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointConfigGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentpointConfigGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointConfigurationApi - object-oriented interface
 * @export
 * @class XdentPointConfigurationApi
 * @extends {BaseAPI}
 */
export class XdentPointConfigurationApi extends BaseAPI {
    /**
     * 
     * @summary Get app configuration. For model example, call the endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointConfigurationApi
     */
    public apiXdentpointConfigGet(options?: AxiosRequestConfig) {
        return XdentPointConfigurationApiFp(this.configuration).apiXdentpointConfigGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentPointDeviceApi - axios parameter creator
 * @export
 */
export const XdentPointDeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sends anonymous pair request.
         * @param {string} idDevice Device token. Has to be bound to device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointPairGet: async (idDevice: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDevice' is not null or undefined
            assertParamExists('apiXdentpointPairGet', 'idDevice', idDevice)
            const localVarPath = `/api/xdentpoint/Pair`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idDevice !== undefined) {
                localVarQueryParameter['idDevice'] = idDevice;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointDeviceApi - functional programming interface
 * @export
 */
export const XdentPointDeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointDeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sends anonymous pair request.
         * @param {string} idDevice Device token. Has to be bound to device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointPairGet(idDevice: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointPairGet(idDevice, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointDeviceApi.apiXdentpointPairGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointDeviceApi - factory interface
 * @export
 */
export const XdentPointDeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointDeviceApiFp(configuration)
    return {
        /**
         * 
         * @summary Sends anonymous pair request.
         * @param {string} idDevice Device token. Has to be bound to device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointPairGet(idDevice: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentpointPairGet(idDevice, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointDeviceApi - object-oriented interface
 * @export
 * @class XdentPointDeviceApi
 * @extends {BaseAPI}
 */
export class XdentPointDeviceApi extends BaseAPI {
    /**
     * 
     * @summary Sends anonymous pair request.
     * @param {string} idDevice Device token. Has to be bound to device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointDeviceApi
     */
    public apiXdentpointPairGet(idDevice: string, options?: AxiosRequestConfig) {
        return XdentPointDeviceApiFp(this.configuration).apiXdentpointPairGet(idDevice, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentPointGalleryApi - axios parameter creator
 * @export
 */
export const XdentPointGalleryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointGalleryGetFileByIdGet: async (idFile?: string, imageAsType?: ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/gallery/GetFileById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (imageAsType !== undefined) {
                localVarQueryParameter['imageAsType'] = imageAsType;
            }

            if (extendedBaseModel !== undefined) {
                localVarQueryParameter['extendedBaseModel'] = extendedBaseModel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointGalleryGetThumbnailByIdGet: async (idFile?: string, size?: string, thumbnailAsType?: ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/gallery/GetThumbnailById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idFile !== undefined) {
                localVarQueryParameter['idFile'] = idFile;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (thumbnailAsType !== undefined) {
                localVarQueryParameter['thumbnailAsType'] = thumbnailAsType;
            }

            if (extendedBaseModel !== undefined) {
                localVarQueryParameter['extendedBaseModel'] = extendedBaseModel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointGalleryApi - functional programming interface
 * @export
 */
export const XdentPointGalleryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointGalleryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedExtendedBaseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointGalleryApi.apiXdentpointGalleryGetFileByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedExtendedBaseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointGalleryApi.apiXdentpointGalleryGetThumbnailByIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointGalleryApi - factory interface
 * @export
 */
export const XdentPointGalleryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointGalleryApiFp(configuration)
    return {
        /**
         * 
         * @summary Return image from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Return extended base64 model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: any): AxiosPromise<APISharedExtendedBaseModel> {
            return localVarFp.apiXdentpointGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return thumbnail from gallery by id as provided type
         * @param {string} [idFile] 
         * @param {string} [size] 
         * @param {ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {boolean} [extendedBaseModel] Returns extended base model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: any): AxiosPromise<APISharedExtendedBaseModel> {
            return localVarFp.apiXdentpointGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointGalleryApi - object-oriented interface
 * @export
 * @class XdentPointGalleryApi
 * @extends {BaseAPI}
 */
export class XdentPointGalleryApi extends BaseAPI {
    /**
     * 
     * @summary Return image from gallery by id as provided type
     * @param {string} [idFile] 
     * @param {ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {boolean} [extendedBaseModel] Return extended base64 model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointGalleryApi
     */
    public apiXdentpointGalleryGetFileByIdGet(idFile?: string, imageAsType?: ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig) {
        return XdentPointGalleryApiFp(this.configuration).apiXdentpointGalleryGetFileByIdGet(idFile, imageAsType, extendedBaseModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return thumbnail from gallery by id as provided type
     * @param {string} [idFile] 
     * @param {string} [size] 
     * @param {ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum} [thumbnailAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {boolean} [extendedBaseModel] Returns extended base model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointGalleryApi
     */
    public apiXdentpointGalleryGetThumbnailByIdGet(idFile?: string, size?: string, thumbnailAsType?: ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum, extendedBaseModel?: boolean, options?: AxiosRequestConfig) {
        return XdentPointGalleryApiFp(this.configuration).apiXdentpointGalleryGetThumbnailByIdGet(idFile, size, thumbnailAsType, extendedBaseModel, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum = typeof ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum[keyof typeof ApiXdentpointGalleryGetFileByIdGetImageAsTypeEnum];
/**
 * @export
 */
export const ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum = typeof ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum[keyof typeof ApiXdentpointGalleryGetThumbnailByIdGetThumbnailAsTypeEnum];


/**
 * XdentPointLocationApi - axios parameter creator
 * @export
 */
export const XdentPointLocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointLocationAvailableLocationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/location/AvailableLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return location logo from gallery by locationId as desired type
         * @param {string} [idLocation] 
         * @param {ApiXdentpointLocationLogoGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointLocationLogoGet: async (idLocation?: string, imageAsType?: ApiXdentpointLocationLogoGetImageAsTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/location/Logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLocation !== undefined) {
                localVarQueryParameter['idLocation'] = idLocation;
            }

            if (imageAsType !== undefined) {
                localVarQueryParameter['imageAsType'] = imageAsType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointLocationApi - functional programming interface
 * @export
 */
export const XdentPointLocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointLocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointLocationAvailableLocationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APISharedLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointLocationAvailableLocationsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointLocationApi.apiXdentpointLocationAvailableLocationsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Return location logo from gallery by locationId as desired type
         * @param {string} [idLocation] 
         * @param {ApiXdentpointLocationLogoGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointLocationLogoGet(idLocation?: string, imageAsType?: ApiXdentpointLocationLogoGetImageAsTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointLocationLogoGet(idLocation, imageAsType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointLocationApi.apiXdentpointLocationLogoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointLocationApi - factory interface
 * @export
 */
export const XdentPointLocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointLocationApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointLocationAvailableLocationsGet(options?: any): AxiosPromise<Array<APISharedLocationDto>> {
            return localVarFp.apiXdentpointLocationAvailableLocationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return location logo from gallery by locationId as desired type
         * @param {string} [idLocation] 
         * @param {ApiXdentpointLocationLogoGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointLocationLogoGet(idLocation?: string, imageAsType?: ApiXdentpointLocationLogoGetImageAsTypeEnum, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentpointLocationLogoGet(idLocation, imageAsType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointLocationApi - object-oriented interface
 * @export
 * @class XdentPointLocationApi
 * @extends {BaseAPI}
 */
export class XdentPointLocationApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointLocationApi
     */
    public apiXdentpointLocationAvailableLocationsGet(options?: AxiosRequestConfig) {
        return XdentPointLocationApiFp(this.configuration).apiXdentpointLocationAvailableLocationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return location logo from gallery by locationId as desired type
     * @param {string} [idLocation] 
     * @param {ApiXdentpointLocationLogoGetImageAsTypeEnum} [imageAsType] 0 &#x3D; Raw, 1 &#x3D; ByteStream, 2 &#x3D; Base64, 3 &#x3D; CompressedImageStream, 4 &#x3D; BSON, 5 &#x3D; PDF
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointLocationApi
     */
    public apiXdentpointLocationLogoGet(idLocation?: string, imageAsType?: ApiXdentpointLocationLogoGetImageAsTypeEnum, options?: AxiosRequestConfig) {
        return XdentPointLocationApiFp(this.configuration).apiXdentpointLocationLogoGet(idLocation, imageAsType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiXdentpointLocationLogoGetImageAsTypeEnum = {
    Raw: 'Raw',
    ByteStream: 'ByteStream',
    Base64: 'Base64',
    CompressedImageStream: 'CompressedImageStream',
    Bson: 'Bson',
    Pdf: 'Pdf',
    Auto: 'Auto',
    None: 'None'
} as const;
export type ApiXdentpointLocationLogoGetImageAsTypeEnum = typeof ApiXdentpointLocationLogoGetImageAsTypeEnum[keyof typeof ApiXdentpointLocationLogoGetImageAsTypeEnum];


/**
 * XdentPointTestApi - axios parameter creator
 * @export
 */
export const XdentPointTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Test possible pair responses for subsequent api calls,
         * @param {string} idXdentPointDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointTestPairHeaderGet: async (idXdentPointDevice: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idXdentPointDevice' is not null or undefined
            assertParamExists('apiXdentpointTestPairHeaderGet', 'idXdentPointDevice', idXdentPointDevice)
            const localVarPath = `/api/xdentpoint/TestPairHeader`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentPointDevice != null) {
                localVarHeaderParameter['idXdentPointDevice'] = String(idXdentPointDevice);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test possible pair responses.
         * @param {string} [desiredResponse] Response to be given to client. (MOCK), Possible values: DEVICE_PAIRED, NO_DEVICE_ID_PROVIDED, DEVICE_NOT_PAIRED, DEVICE_PAIR_EXPIRED. Returns random for null.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointTestPairResponsesGet: async (desiredResponse?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/TestPairResponses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (desiredResponse !== undefined) {
                localVarQueryParameter['desiredResponse'] = desiredResponse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointTestApi - functional programming interface
 * @export
 */
export const XdentPointTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Test possible pair responses for subsequent api calls,
         * @param {string} idXdentPointDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointTestPairHeaderGet(idXdentPointDevice: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointTestPairHeaderGet(idXdentPointDevice, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointTestApi.apiXdentpointTestPairHeaderGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Test possible pair responses.
         * @param {string} [desiredResponse] Response to be given to client. (MOCK), Possible values: DEVICE_PAIRED, NO_DEVICE_ID_PROVIDED, DEVICE_NOT_PAIRED, DEVICE_PAIR_EXPIRED. Returns random for null.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointTestPairResponsesGet(desiredResponse?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointTestPairResponsesGet(desiredResponse, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointTestApi.apiXdentpointTestPairResponsesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointTestApi - factory interface
 * @export
 */
export const XdentPointTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointTestApiFp(configuration)
    return {
        /**
         * 
         * @summary Test possible pair responses for subsequent api calls,
         * @param {string} idXdentPointDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointTestPairHeaderGet(idXdentPointDevice: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentpointTestPairHeaderGet(idXdentPointDevice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test possible pair responses.
         * @param {string} [desiredResponse] Response to be given to client. (MOCK), Possible values: DEVICE_PAIRED, NO_DEVICE_ID_PROVIDED, DEVICE_NOT_PAIRED, DEVICE_PAIR_EXPIRED. Returns random for null.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointTestPairResponsesGet(desiredResponse?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiXdentpointTestPairResponsesGet(desiredResponse, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointTestApi - object-oriented interface
 * @export
 * @class XdentPointTestApi
 * @extends {BaseAPI}
 */
export class XdentPointTestApi extends BaseAPI {
    /**
     * 
     * @summary Test possible pair responses for subsequent api calls,
     * @param {string} idXdentPointDevice 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointTestApi
     */
    public apiXdentpointTestPairHeaderGet(idXdentPointDevice: string, options?: AxiosRequestConfig) {
        return XdentPointTestApiFp(this.configuration).apiXdentpointTestPairHeaderGet(idXdentPointDevice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test possible pair responses.
     * @param {string} [desiredResponse] Response to be given to client. (MOCK), Possible values: DEVICE_PAIRED, NO_DEVICE_ID_PROVIDED, DEVICE_NOT_PAIRED, DEVICE_PAIR_EXPIRED. Returns random for null.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointTestApi
     */
    public apiXdentpointTestPairResponsesGet(desiredResponse?: string, options?: AxiosRequestConfig) {
        return XdentPointTestApiFp(this.configuration).apiXdentpointTestPairResponsesGet(desiredResponse, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentPointUserApi - axios parameter creator
 * @export
 */
export const XdentPointUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointAuthByCredentialsPost: async (apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/AuthByCredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiSafesignaturesAuthPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointExtendBearerTokenPost: async (aPISharedExtendBearerDto?: APISharedExtendBearerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/ExtendBearerToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedExtendBearerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointGetUserInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/xdentpoint/GetUserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentPointUserApi - functional programming interface
 * @export
 */
export const XdentPointUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentPointUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointAuthByCredentialsPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointAuthByCredentialsPost(apiSafesignaturesAuthPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointUserApi.apiXdentpointAuthByCredentialsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointExtendBearerTokenPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedJsonWebToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointExtendBearerTokenPost(aPISharedExtendBearerDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointUserApi.apiXdentpointExtendBearerTokenPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentpointGetUserInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedGlobalXdentConfigurationWrapperDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentpointGetUserInfoGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentPointUserApi.apiXdentpointGetUserInfoGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentPointUserApi - factory interface
 * @export
 */
export const XdentPointUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentPointUserApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticates user by login credentials via post model
         * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointAuthByCredentialsPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiXdentpointAuthByCredentialsPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extends bearer token with provided refresh and old bearer
         * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointExtendBearerTokenPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: any): AxiosPromise<APISharedJsonWebToken> {
            return localVarFp.apiXdentpointExtendBearerTokenPost(aPISharedExtendBearerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentpointGetUserInfoGet(options?: any): AxiosPromise<APISharedGlobalXdentConfigurationWrapperDto> {
            return localVarFp.apiXdentpointGetUserInfoGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentPointUserApi - object-oriented interface
 * @export
 * @class XdentPointUserApi
 * @extends {BaseAPI}
 */
export class XdentPointUserApi extends BaseAPI {
    /**
     * 
     * @summary Authenticates user by login credentials via post model
     * @param {ApiSafesignaturesAuthPostRequest} [apiSafesignaturesAuthPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointUserApi
     */
    public apiXdentpointAuthByCredentialsPost(apiSafesignaturesAuthPostRequest?: ApiSafesignaturesAuthPostRequest, options?: AxiosRequestConfig) {
        return XdentPointUserApiFp(this.configuration).apiXdentpointAuthByCredentialsPost(apiSafesignaturesAuthPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extends bearer token with provided refresh and old bearer
     * @param {APISharedExtendBearerDto} [aPISharedExtendBearerDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointUserApi
     */
    public apiXdentpointExtendBearerTokenPost(aPISharedExtendBearerDto?: APISharedExtendBearerDto, options?: AxiosRequestConfig) {
        return XdentPointUserApiFp(this.configuration).apiXdentpointExtendBearerTokenPost(aPISharedExtendBearerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentPointUserApi
     */
    public apiXdentpointGetUserInfoGet(options?: AxiosRequestConfig) {
        return XdentPointUserApiFp(this.configuration).apiXdentpointGetUserInfoGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentShareApi - axios parameter creator
 * @export
 */
export const XdentShareApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabTicket] 
         * @param {string} [idApplication] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareFetchExternalChatMetadataGet: async (idLabTicket?: string, idApplication?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/FetchExternalChatMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLabTicket !== undefined) {
                localVarQueryParameter['idLabTicket'] = idLabTicket;
            }

            if (idApplication !== undefined) {
                localVarQueryParameter['idApplication'] = idApplication;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentLaboratory] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketClientGet: async (idXdentLaboratory?: string, idClient?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/GetLabTicketClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idXdentLaboratory !== undefined) {
                localVarQueryParameter['idXdentLaboratory'] = idXdentLaboratory;
            }

            if (idClient !== undefined) {
                localVarQueryParameter['idClient'] = idClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketStaffEmailGet: async (idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/GetLabTicketStaffEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketStaffGet: async (idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/GetLabTicketStaff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketStaffPhonePrefixCodeGet: async (idCodelist?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/GetLabTicketStaffPhonePrefixCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idCodelist !== undefined) {
                localVarQueryParameter['idCodelist'] = idCodelist;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketStaffUserGet: async (idStaff?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/GetLabTicketStaffUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idStaff !== undefined) {
                localVarQueryParameter['idStaff'] = idStaff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetTicketXdentShareStatusGet: async (idLabTicket?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/GetTicketXdentShareStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLabTicket !== undefined) {
                localVarQueryParameter['idLabTicket'] = idLabTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets info about xdent location
         * @param {string} [idLabCompany] 
         * @param {string} [idLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetXdentLocationBillingInfoAsyncGet: async (idLabCompany?: string, idLabLaboratoryRequest?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/GetXdentLocationBillingInfoAsync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idLabCompany !== undefined) {
                localVarQueryParameter['idLabCompany'] = idLabCompany;
            }

            if (idLabLaboratoryRequest !== undefined) {
                localVarQueryParameter['idLabLaboratoryRequest'] = idLabLaboratoryRequest;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets notifications about new pricelist from labino
         * @param {LabinoDtoSharePricelistValidityInternalDto} [labinoDtoSharePricelistValidityInternalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentSharePublishNewPricelistValidityPost: async (labinoDtoSharePricelistValidityInternalDto?: LabinoDtoSharePricelistValidityInternalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/PublishNewPricelistValidity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoSharePricelistValidityInternalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedReadMessagesDto} [aPISharedReadMessagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareReadXdentMessagesFromLabinoPost: async (aPISharedReadMessagesDto?: APISharedReadMessagesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/ReadXdentMessagesFromLabino`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPISharedReadMessagesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets notification about labino partner invitation
         * @param {LabinoDtoInvoicePartnerInvitationDTO} [labinoDtoInvoicePartnerInvitationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareSendInvoicePartnerInvitationPost: async (labinoDtoInvoicePartnerInvitationDTO?: LabinoDtoInvoicePartnerInvitationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/SendInvoicePartnerInvitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoInvoicePartnerInvitationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shares pair request to xdent.
         * @param {LabinoDtoShareLabLaboratoryRequest} [labinoDtoShareLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareShareLabRequestConfirmPost: async (labinoDtoShareLabLaboratoryRequest?: LabinoDtoShareLabLaboratoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/ShareLabRequestConfirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoShareLabLaboratoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest} [apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPost: async (apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest?: ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/ShareTicketChatMessageLabinoToXdent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest} [apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareShareTicketFilePost: async (apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest?: ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/ShareTicketFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabTicketHistoryDto} [labinoDtoLabTicketHistoryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareShareTicketHistoryLabinoToXdentPost: async (labinoDtoLabTicketHistoryDto?: LabinoDtoLabTicketHistoryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/ShareTicketHistoryLabinoToXdent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoLabTicketHistoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends unpair notification to xdent / sets laboratory request as unpaired
         * @param {LabinoDtoShareLabLaboratoryRequest} [labinoDtoShareLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareUnpairXdentRequestPost: async (labinoDtoShareLabLaboratoryRequest?: LabinoDtoShareLabLaboratoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/labino/XdentShare/UnpairXdentRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labinoDtoShareLabLaboratoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentShareApi - functional programming interface
 * @export
 */
export const XdentShareApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentShareApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabTicket] 
         * @param {string} [idApplication] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareFetchExternalChatMetadataGet(idLabTicket?: string, idApplication?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareFetchExternalChatMetadataGet(idLabTicket, idApplication, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareFetchExternalChatMetadataGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentLaboratory] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareGetLabTicketClientGet(idXdentLaboratory?: string, idClient?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareGetLabTicketClientGet(idXdentLaboratory, idClient, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareGetLabTicketClientGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareGetLabTicketStaffEmailGet(idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareGetLabTicketStaffEmailGet(idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareGetLabTicketStaffEmailGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareGetLabTicketStaffGet(idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareGetLabTicketStaffGet(idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareGetLabTicketStaffGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareGetLabTicketStaffPhonePrefixCodeGet(idCodelist?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareGetLabTicketStaffPhonePrefixCodeGet(idCodelist, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareGetLabTicketStaffPhonePrefixCodeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareGetLabTicketStaffUserGet(idStaff?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareGetLabTicketStaffUserGet(idStaff, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareGetLabTicketStaffUserGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareGetTicketXdentShareStatusGet(idLabTicket?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareGetTicketXdentShareStatusGet(idLabTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareGetTicketXdentShareStatusGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Gets info about xdent location
         * @param {string} [idLabCompany] 
         * @param {string} [idLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareGetXdentLocationBillingInfoAsyncGet(idLabCompany?: string, idLabLaboratoryRequest?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabinoDtoXdentLocationBillingInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareGetXdentLocationBillingInfoAsyncGet(idLabCompany, idLabLaboratoryRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareGetXdentLocationBillingInfoAsyncGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sets notifications about new pricelist from labino
         * @param {LabinoDtoSharePricelistValidityInternalDto} [labinoDtoSharePricelistValidityInternalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentSharePublishNewPricelistValidityPost(labinoDtoSharePricelistValidityInternalDto?: LabinoDtoSharePricelistValidityInternalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentSharePublishNewPricelistValidityPost(labinoDtoSharePricelistValidityInternalDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentSharePublishNewPricelistValidityPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedReadMessagesDto} [aPISharedReadMessagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareReadXdentMessagesFromLabinoPost(aPISharedReadMessagesDto?: APISharedReadMessagesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareReadXdentMessagesFromLabinoPost(aPISharedReadMessagesDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareReadXdentMessagesFromLabinoPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sets notification about labino partner invitation
         * @param {LabinoDtoInvoicePartnerInvitationDTO} [labinoDtoInvoicePartnerInvitationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareSendInvoicePartnerInvitationPost(labinoDtoInvoicePartnerInvitationDTO?: LabinoDtoInvoicePartnerInvitationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareSendInvoicePartnerInvitationPost(labinoDtoInvoicePartnerInvitationDTO, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareSendInvoicePartnerInvitationPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Shares pair request to xdent.
         * @param {LabinoDtoShareLabLaboratoryRequest} [labinoDtoShareLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareShareLabRequestConfirmPost(labinoDtoShareLabLaboratoryRequest?: LabinoDtoShareLabLaboratoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareShareLabRequestConfirmPost(labinoDtoShareLabLaboratoryRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareShareLabRequestConfirmPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest} [apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest?: ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest} [apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareShareTicketFilePost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest?: ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareShareTicketFilePost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareShareTicketFilePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabTicketHistoryDto} [labinoDtoLabTicketHistoryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareShareTicketHistoryLabinoToXdentPost(labinoDtoLabTicketHistoryDto?: LabinoDtoLabTicketHistoryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareShareTicketHistoryLabinoToXdentPost(labinoDtoLabTicketHistoryDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareShareTicketHistoryLabinoToXdentPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sends unpair notification to xdent / sets laboratory request as unpaired
         * @param {LabinoDtoShareLabLaboratoryRequest} [labinoDtoShareLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLabinoXdentShareUnpairXdentRequestPost(labinoDtoShareLabLaboratoryRequest?: LabinoDtoShareLabLaboratoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLabinoXdentShareUnpairXdentRequestPost(labinoDtoShareLabLaboratoryRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentShareApi.apiLabinoXdentShareUnpairXdentRequestPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentShareApi - factory interface
 * @export
 */
export const XdentShareApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentShareApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabTicket] 
         * @param {string} [idApplication] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareFetchExternalChatMetadataGet(idLabTicket?: string, idApplication?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareFetchExternalChatMetadataGet(idLabTicket, idApplication, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idXdentLaboratory] 
         * @param {string} [idClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketClientGet(idXdentLaboratory?: string, idClient?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareGetLabTicketClientGet(idXdentLaboratory, idClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketStaffEmailGet(idStaff?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareGetLabTicketStaffEmailGet(idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketStaffGet(idStaff?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareGetLabTicketStaffGet(idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idCodelist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketStaffPhonePrefixCodeGet(idCodelist?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareGetLabTicketStaffPhonePrefixCodeGet(idCodelist, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idStaff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetLabTicketStaffUserGet(idStaff?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareGetLabTicketStaffUserGet(idStaff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idLabTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetTicketXdentShareStatusGet(idLabTicket?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareGetTicketXdentShareStatusGet(idLabTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets info about xdent location
         * @param {string} [idLabCompany] 
         * @param {string} [idLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareGetXdentLocationBillingInfoAsyncGet(idLabCompany?: string, idLabLaboratoryRequest?: string, options?: any): AxiosPromise<LabinoDtoXdentLocationBillingInfoDto> {
            return localVarFp.apiLabinoXdentShareGetXdentLocationBillingInfoAsyncGet(idLabCompany, idLabLaboratoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets notifications about new pricelist from labino
         * @param {LabinoDtoSharePricelistValidityInternalDto} [labinoDtoSharePricelistValidityInternalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentSharePublishNewPricelistValidityPost(labinoDtoSharePricelistValidityInternalDto?: LabinoDtoSharePricelistValidityInternalDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoXdentSharePublishNewPricelistValidityPost(labinoDtoSharePricelistValidityInternalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {APISharedReadMessagesDto} [aPISharedReadMessagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareReadXdentMessagesFromLabinoPost(aPISharedReadMessagesDto?: APISharedReadMessagesDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoXdentShareReadXdentMessagesFromLabinoPost(aPISharedReadMessagesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets notification about labino partner invitation
         * @param {LabinoDtoInvoicePartnerInvitationDTO} [labinoDtoInvoicePartnerInvitationDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareSendInvoicePartnerInvitationPost(labinoDtoInvoicePartnerInvitationDTO?: LabinoDtoInvoicePartnerInvitationDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoXdentShareSendInvoicePartnerInvitationPost(labinoDtoInvoicePartnerInvitationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shares pair request to xdent.
         * @param {LabinoDtoShareLabLaboratoryRequest} [labinoDtoShareLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareShareLabRequestConfirmPost(labinoDtoShareLabLaboratoryRequest?: LabinoDtoShareLabLaboratoryRequest, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoXdentShareShareLabRequestConfirmPost(labinoDtoShareLabLaboratoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest} [apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest?: ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest} [apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareShareTicketFilePost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest?: ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareShareTicketFilePost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {LabinoDtoLabTicketHistoryDto} [labinoDtoLabTicketHistoryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareShareTicketHistoryLabinoToXdentPost(labinoDtoLabTicketHistoryDto?: LabinoDtoLabTicketHistoryDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiLabinoXdentShareShareTicketHistoryLabinoToXdentPost(labinoDtoLabTicketHistoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends unpair notification to xdent / sets laboratory request as unpaired
         * @param {LabinoDtoShareLabLaboratoryRequest} [labinoDtoShareLabLaboratoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLabinoXdentShareUnpairXdentRequestPost(labinoDtoShareLabLaboratoryRequest?: LabinoDtoShareLabLaboratoryRequest, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiLabinoXdentShareUnpairXdentRequestPost(labinoDtoShareLabLaboratoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentShareApi - object-oriented interface
 * @export
 * @class XdentShareApi
 * @extends {BaseAPI}
 */
export class XdentShareApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLabTicket] 
     * @param {string} [idApplication] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareFetchExternalChatMetadataGet(idLabTicket?: string, idApplication?: string, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareFetchExternalChatMetadataGet(idLabTicket, idApplication, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idXdentLaboratory] 
     * @param {string} [idClient] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareGetLabTicketClientGet(idXdentLaboratory?: string, idClient?: string, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareGetLabTicketClientGet(idXdentLaboratory, idClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareGetLabTicketStaffEmailGet(idStaff?: string, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareGetLabTicketStaffEmailGet(idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareGetLabTicketStaffGet(idStaff?: string, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareGetLabTicketStaffGet(idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idCodelist] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareGetLabTicketStaffPhonePrefixCodeGet(idCodelist?: string, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareGetLabTicketStaffPhonePrefixCodeGet(idCodelist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idStaff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareGetLabTicketStaffUserGet(idStaff?: string, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareGetLabTicketStaffUserGet(idStaff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {string} [idLabTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareGetTicketXdentShareStatusGet(idLabTicket?: string, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareGetTicketXdentShareStatusGet(idLabTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets info about xdent location
     * @param {string} [idLabCompany] 
     * @param {string} [idLabLaboratoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareGetXdentLocationBillingInfoAsyncGet(idLabCompany?: string, idLabLaboratoryRequest?: string, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareGetXdentLocationBillingInfoAsyncGet(idLabCompany, idLabLaboratoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets notifications about new pricelist from labino
     * @param {LabinoDtoSharePricelistValidityInternalDto} [labinoDtoSharePricelistValidityInternalDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentSharePublishNewPricelistValidityPost(labinoDtoSharePricelistValidityInternalDto?: LabinoDtoSharePricelistValidityInternalDto, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentSharePublishNewPricelistValidityPost(labinoDtoSharePricelistValidityInternalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {APISharedReadMessagesDto} [aPISharedReadMessagesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareReadXdentMessagesFromLabinoPost(aPISharedReadMessagesDto?: APISharedReadMessagesDto, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareReadXdentMessagesFromLabinoPost(aPISharedReadMessagesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets notification about labino partner invitation
     * @param {LabinoDtoInvoicePartnerInvitationDTO} [labinoDtoInvoicePartnerInvitationDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareSendInvoicePartnerInvitationPost(labinoDtoInvoicePartnerInvitationDTO?: LabinoDtoInvoicePartnerInvitationDTO, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareSendInvoicePartnerInvitationPost(labinoDtoInvoicePartnerInvitationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shares pair request to xdent.
     * @param {LabinoDtoShareLabLaboratoryRequest} [labinoDtoShareLabLaboratoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareShareLabRequestConfirmPost(labinoDtoShareLabLaboratoryRequest?: LabinoDtoShareLabLaboratoryRequest, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareShareLabRequestConfirmPost(labinoDtoShareLabLaboratoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest} [apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest?: ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest} [apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareShareTicketFilePost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest?: ApiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareShareTicketFilePost(apiLabinoXdentShareShareTicketChatMessageLabinoToXdentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {LabinoDtoLabTicketHistoryDto} [labinoDtoLabTicketHistoryDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareShareTicketHistoryLabinoToXdentPost(labinoDtoLabTicketHistoryDto?: LabinoDtoLabTicketHistoryDto, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareShareTicketHistoryLabinoToXdentPost(labinoDtoLabTicketHistoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends unpair notification to xdent / sets laboratory request as unpaired
     * @param {LabinoDtoShareLabLaboratoryRequest} [labinoDtoShareLabLaboratoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentShareApi
     */
    public apiLabinoXdentShareUnpairXdentRequestPost(labinoDtoShareLabLaboratoryRequest?: LabinoDtoShareLabLaboratoryRequest, options?: AxiosRequestConfig) {
        return XdentShareApiFp(this.configuration).apiLabinoXdentShareUnpairXdentRequestPost(labinoDtoShareLabLaboratoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XdentTowerApi - axios parameter creator
 * @export
 */
export const XdentTowerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentTowerGetUserCompanyIdGet: async (idUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/XdentTower/GetUserCompanyId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idUser !== undefined) {
                localVarQueryParameter['idUser'] = idUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XdentTowerApi - functional programming interface
 * @export
 */
export const XdentTowerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XdentTowerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiXdentTowerGetUserCompanyIdGet(idUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIXdentServicesXdentScopedInterfacesGetCompanyIdByUserIdDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiXdentTowerGetUserCompanyIdGet(idUser, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['XdentTowerApi.apiXdentTowerGetUserCompanyIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * XdentTowerApi - factory interface
 * @export
 */
export const XdentTowerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XdentTowerApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {string} [idUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiXdentTowerGetUserCompanyIdGet(idUser?: string, options?: any): AxiosPromise<APIXdentServicesXdentScopedInterfacesGetCompanyIdByUserIdDTO> {
            return localVarFp.apiXdentTowerGetUserCompanyIdGet(idUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XdentTowerApi - object-oriented interface
 * @export
 * @class XdentTowerApi
 * @extends {BaseAPI}
 */
export class XdentTowerApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {string} [idUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XdentTowerApi
     */
    public apiXdentTowerGetUserCompanyIdGet(idUser?: string, options?: AxiosRequestConfig) {
        return XdentTowerApiFp(this.configuration).apiXdentTowerGetUserCompanyIdGet(idUser, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ZabbixApi - axios parameter creator
 * @export
 */
export const ZabbixApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiZabbixReminderStatsTodayGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Zabbix/ReminderStatsToday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiZabbixSmsLimitsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Zabbix/SmsLimits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZabbixApi - functional programming interface
 * @export
 */
export const ZabbixApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZabbixApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiZabbixReminderStatsTodayGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOZabbixZabbixSmsLimitsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiZabbixReminderStatsTodayGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ZabbixApi.apiZabbixReminderStatsTodayGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiZabbixSmsLimitsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISharedDTOZabbixZabbixSmsLimitsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiZabbixSmsLimitsGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ZabbixApi.apiZabbixSmsLimitsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ZabbixApi - factory interface
 * @export
 */
export const ZabbixApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZabbixApiFp(configuration)
    return {
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiZabbixReminderStatsTodayGet(options?: any): AxiosPromise<APISharedDTOZabbixZabbixSmsLimitsDto> {
            return localVarFp.apiZabbixReminderStatsTodayGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiZabbixSmsLimitsGet(options?: any): AxiosPromise<APISharedDTOZabbixZabbixSmsLimitsDto> {
            return localVarFp.apiZabbixSmsLimitsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZabbixApi - object-oriented interface
 * @export
 * @class ZabbixApi
 * @extends {BaseAPI}
 */
export class ZabbixApi extends BaseAPI {
    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZabbixApi
     */
    public apiZabbixReminderStatsTodayGet(options?: AxiosRequestConfig) {
        return ZabbixApiFp(this.configuration).apiZabbixReminderStatsTodayGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZabbixApi
     */
    public apiZabbixSmsLimitsGet(options?: AxiosRequestConfig) {
        return ZabbixApiFp(this.configuration).apiZabbixSmsLimitsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



